
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefe78"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefe78"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Qwp0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2129928c0bdc1efe$export$ffb0004e005737fa; }, function (v) { return $2129928c0bdc1efe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2129928c0bdc1efe$export$34b9dba7ce09269b; }, function (v) { return $2129928c0bdc1efe$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2129928c0bdc1efe$export$25062201e9e25d76; }, function (v) { return $2129928c0bdc1efe$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2129928c0bdc1efe$export$ffb0004e005737fa;
var $2129928c0bdc1efe$export$34b9dba7ce09269b;
var $2129928c0bdc1efe$export$25062201e9e25d76;
'use strict';
parcelRequire("2WFPq");

var $gIfym = parcelRequire("gIfym");
var $2129928c0bdc1efe$var$g = 60103;
$2129928c0bdc1efe$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $2129928c0bdc1efe$var$h = Symbol.for;
    $2129928c0bdc1efe$var$g = $2129928c0bdc1efe$var$h("react.element");
    $2129928c0bdc1efe$export$ffb0004e005737fa = $2129928c0bdc1efe$var$h("react.fragment");
}
var $2129928c0bdc1efe$var$m = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2129928c0bdc1efe$var$n = Object.prototype.hasOwnProperty, $2129928c0bdc1efe$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2129928c0bdc1efe$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$2129928c0bdc1efe$var$n.call(a, b) && !$2129928c0bdc1efe$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2129928c0bdc1efe$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $2129928c0bdc1efe$var$m.current
    };
}
$2129928c0bdc1efe$export$34b9dba7ce09269b = $2129928c0bdc1efe$var$q;
$2129928c0bdc1efe$export$25062201e9e25d76 = $2129928c0bdc1efe$var$q;

});
parcelRegister("2WFPq", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $225171d2ce221288$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $225171d2ce221288$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $225171d2ce221288$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $225171d2ce221288$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $225171d2ce221288$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $225171d2ce221288$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $225171d2ce221288$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($225171d2ce221288$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($225171d2ce221288$var$getOwnPropertySymbols) {
            symbols = $225171d2ce221288$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($225171d2ce221288$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("gIfym", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ga9lV"));

});
parcelRegister("ga9lV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bc44d5c582efa5c9$export$ffb0004e005737fa; }, function (v) { return $bc44d5c582efa5c9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc44d5c582efa5c9$export$5f8d39834fd61797; }, function (v) { return $bc44d5c582efa5c9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc44d5c582efa5c9$export$e2c29f18771995cb; }, function (v) { return $bc44d5c582efa5c9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5; }, function (v) { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $bc44d5c582efa5c9$export$dca3b0875bd9a954; }, function (v) { return $bc44d5c582efa5c9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bc44d5c582efa5c9$export$16fa2f45be04daa8; }, function (v) { return $bc44d5c582efa5c9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd; }, function (v) { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc44d5c582efa5c9$export$ae55be85d98224ed; }, function (v) { return $bc44d5c582efa5c9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bc44d5c582efa5c9$export$e530037191fcd5d7; }, function (v) { return $bc44d5c582efa5c9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109; }, function (v) { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d; }, function (v) { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9; }, function (v) { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43; }, function (v) { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bc44d5c582efa5c9$export$257a8862b851cb5b; }, function (v) { return $bc44d5c582efa5c9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bc44d5c582efa5c9$export$a8257692ac88316c; }, function (v) { return $bc44d5c582efa5c9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bc44d5c582efa5c9$export$488013bae63b21da; }, function (v) { return $bc44d5c582efa5c9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bc44d5c582efa5c9$export$7c73462e0d25e514; }, function (v) { return $bc44d5c582efa5c9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bc44d5c582efa5c9$export$35808ee640e87ca7; }, function (v) { return $bc44d5c582efa5c9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bc44d5c582efa5c9$export$fae74005e78b1a27; }, function (v) { return $bc44d5c582efa5c9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e; }, function (v) { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $bc44d5c582efa5c9$export$6d9c69b0de29b591; }, function (v) { return $bc44d5c582efa5c9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bc44d5c582efa5c9$export$d5a552a76deda3c2; }, function (v) { return $bc44d5c582efa5c9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c; }, function (v) { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bc44d5c582efa5c9$export$1538c33de8887b59; }, function (v) { return $bc44d5c582efa5c9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bc44d5c582efa5c9$export$13e3392192263954; }, function (v) { return $bc44d5c582efa5c9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca; }, function (v) { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bc44d5c582efa5c9$export$60241385465d0a34; }, function (v) { return $bc44d5c582efa5c9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $bc44d5c582efa5c9$export$83d89fbfd8236492; }, function (v) { return $bc44d5c582efa5c9$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc44d5c582efa5c9$export$ffb0004e005737fa;
var $bc44d5c582efa5c9$export$5f8d39834fd61797;
var $bc44d5c582efa5c9$export$e2c29f18771995cb;
var $bc44d5c582efa5c9$export$74bf444e3cd11ea5;
var $bc44d5c582efa5c9$export$dca3b0875bd9a954;
var $bc44d5c582efa5c9$export$16fa2f45be04daa8;
var $bc44d5c582efa5c9$export$221d75b3f55bb0bd;
var $bc44d5c582efa5c9$export$ae55be85d98224ed;
var $bc44d5c582efa5c9$export$e530037191fcd5d7;
var $bc44d5c582efa5c9$export$fd42f52fd3ae1109;
var $bc44d5c582efa5c9$export$c8a8987d4410bf2d;
var $bc44d5c582efa5c9$export$d38cd72104c1f0e9;
var $bc44d5c582efa5c9$export$7d1e3a5e95ceca43;
var $bc44d5c582efa5c9$export$257a8862b851cb5b;
var $bc44d5c582efa5c9$export$a8257692ac88316c;
var $bc44d5c582efa5c9$export$488013bae63b21da;
var $bc44d5c582efa5c9$export$7c73462e0d25e514;
var $bc44d5c582efa5c9$export$35808ee640e87ca7;
var $bc44d5c582efa5c9$export$fae74005e78b1a27;
var $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e;
var $bc44d5c582efa5c9$export$6d9c69b0de29b591;
var $bc44d5c582efa5c9$export$d5a552a76deda3c2;
var $bc44d5c582efa5c9$export$e5c5a5f917a5871c;
var $bc44d5c582efa5c9$export$1538c33de8887b59;
var $bc44d5c582efa5c9$export$13e3392192263954;
var $bc44d5c582efa5c9$export$b8f5890fc79d6aca;
var $bc44d5c582efa5c9$export$60241385465d0a34;
var $bc44d5c582efa5c9$export$83d89fbfd8236492;
'use strict';

var $2WFPq = parcelRequire("2WFPq");
var $bc44d5c582efa5c9$var$n = 60103, $bc44d5c582efa5c9$var$p = 60106;
$bc44d5c582efa5c9$export$ffb0004e005737fa = 60107;
$bc44d5c582efa5c9$export$5f8d39834fd61797 = 60108;
$bc44d5c582efa5c9$export$e2c29f18771995cb = 60114;
var $bc44d5c582efa5c9$var$q = 60109, $bc44d5c582efa5c9$var$r = 60110, $bc44d5c582efa5c9$var$t = 60112;
$bc44d5c582efa5c9$export$74bf444e3cd11ea5 = 60113;
var $bc44d5c582efa5c9$var$u = 60115, $bc44d5c582efa5c9$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $bc44d5c582efa5c9$var$w = Symbol.for;
    $bc44d5c582efa5c9$var$n = $bc44d5c582efa5c9$var$w("react.element");
    $bc44d5c582efa5c9$var$p = $bc44d5c582efa5c9$var$w("react.portal");
    $bc44d5c582efa5c9$export$ffb0004e005737fa = $bc44d5c582efa5c9$var$w("react.fragment");
    $bc44d5c582efa5c9$export$5f8d39834fd61797 = $bc44d5c582efa5c9$var$w("react.strict_mode");
    $bc44d5c582efa5c9$export$e2c29f18771995cb = $bc44d5c582efa5c9$var$w("react.profiler");
    $bc44d5c582efa5c9$var$q = $bc44d5c582efa5c9$var$w("react.provider");
    $bc44d5c582efa5c9$var$r = $bc44d5c582efa5c9$var$w("react.context");
    $bc44d5c582efa5c9$var$t = $bc44d5c582efa5c9$var$w("react.forward_ref");
    $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = $bc44d5c582efa5c9$var$w("react.suspense");
    $bc44d5c582efa5c9$var$u = $bc44d5c582efa5c9$var$w("react.memo");
    $bc44d5c582efa5c9$var$v = $bc44d5c582efa5c9$var$w("react.lazy");
}
var $bc44d5c582efa5c9$var$x = "function" === typeof Symbol && Symbol.iterator;
function $bc44d5c582efa5c9$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc44d5c582efa5c9$var$x && a[$bc44d5c582efa5c9$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $bc44d5c582efa5c9$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bc44d5c582efa5c9$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bc44d5c582efa5c9$var$B = {};
function $bc44d5c582efa5c9$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$B;
    this.updater = c || $bc44d5c582efa5c9$var$A;
}
$bc44d5c582efa5c9$var$C.prototype.isReactComponent = {};
$bc44d5c582efa5c9$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($bc44d5c582efa5c9$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bc44d5c582efa5c9$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bc44d5c582efa5c9$var$D() {}
$bc44d5c582efa5c9$var$D.prototype = $bc44d5c582efa5c9$var$C.prototype;
function $bc44d5c582efa5c9$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$B;
    this.updater = c || $bc44d5c582efa5c9$var$A;
}
var $bc44d5c582efa5c9$var$F = $bc44d5c582efa5c9$var$E.prototype = new $bc44d5c582efa5c9$var$D;
$bc44d5c582efa5c9$var$F.constructor = $bc44d5c582efa5c9$var$E;
$2WFPq($bc44d5c582efa5c9$var$F, $bc44d5c582efa5c9$var$C.prototype);
$bc44d5c582efa5c9$var$F.isPureReactComponent = !0;
var $bc44d5c582efa5c9$var$G = {
    current: null
}, $bc44d5c582efa5c9$var$H = Object.prototype.hasOwnProperty, $bc44d5c582efa5c9$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bc44d5c582efa5c9$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bc44d5c582efa5c9$var$H.call(b, e) && !$bc44d5c582efa5c9$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $bc44d5c582efa5c9$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $bc44d5c582efa5c9$var$G.current
    };
}
function $bc44d5c582efa5c9$var$K(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bc44d5c582efa5c9$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc44d5c582efa5c9$var$n;
}
function $bc44d5c582efa5c9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bc44d5c582efa5c9$var$M = /\/+/g;
function $bc44d5c582efa5c9$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bc44d5c582efa5c9$var$escape("" + a.key) : b.toString(36);
}
function $bc44d5c582efa5c9$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bc44d5c582efa5c9$var$n:
                case $bc44d5c582efa5c9$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $bc44d5c582efa5c9$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($bc44d5c582efa5c9$var$M, "$&/") + "/"), $bc44d5c582efa5c9$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($bc44d5c582efa5c9$var$L(d) && (d = $bc44d5c582efa5c9$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($bc44d5c582efa5c9$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $bc44d5c582efa5c9$var$N(k, g);
        h += $bc44d5c582efa5c9$var$O(k, b, c, f, d);
    }
    else if (f = $bc44d5c582efa5c9$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $bc44d5c582efa5c9$var$N(k, g++), h += $bc44d5c582efa5c9$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($bc44d5c582efa5c9$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $bc44d5c582efa5c9$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $bc44d5c582efa5c9$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $bc44d5c582efa5c9$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $bc44d5c582efa5c9$var$R = {
    current: null
};
function $bc44d5c582efa5c9$var$S() {
    var a = $bc44d5c582efa5c9$var$R.current;
    if (null === a) throw Error($bc44d5c582efa5c9$var$z(321));
    return a;
}
var $bc44d5c582efa5c9$var$T = {
    ReactCurrentDispatcher: $bc44d5c582efa5c9$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $bc44d5c582efa5c9$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $2WFPq
};
$bc44d5c582efa5c9$export$dca3b0875bd9a954 = {
    map: $bc44d5c582efa5c9$var$P,
    forEach: function(a, b, c) {
        $bc44d5c582efa5c9$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $bc44d5c582efa5c9$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bc44d5c582efa5c9$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bc44d5c582efa5c9$var$L(a)) throw Error($bc44d5c582efa5c9$var$z(143));
        return a;
    }
};
$bc44d5c582efa5c9$export$16fa2f45be04daa8 = $bc44d5c582efa5c9$var$C;
$bc44d5c582efa5c9$export$221d75b3f55bb0bd = $bc44d5c582efa5c9$var$E;
$bc44d5c582efa5c9$export$ae55be85d98224ed = $bc44d5c582efa5c9$var$T;
$bc44d5c582efa5c9$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($bc44d5c582efa5c9$var$z(267, a));
    var e = $2WFPq({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bc44d5c582efa5c9$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bc44d5c582efa5c9$var$H.call(b, f) && !$bc44d5c582efa5c9$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $bc44d5c582efa5c9$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$bc44d5c582efa5c9$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $bc44d5c582efa5c9$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $bc44d5c582efa5c9$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$bc44d5c582efa5c9$export$c8a8987d4410bf2d = $bc44d5c582efa5c9$var$J;
$bc44d5c582efa5c9$export$d38cd72104c1f0e9 = function(a) {
    var b = $bc44d5c582efa5c9$var$J.bind(null, a);
    b.type = a;
    return b;
};
$bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bc44d5c582efa5c9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$t,
        render: a
    };
};
$bc44d5c582efa5c9$export$a8257692ac88316c = $bc44d5c582efa5c9$var$L;
$bc44d5c582efa5c9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bc44d5c582efa5c9$var$Q
    };
};
$bc44d5c582efa5c9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bc44d5c582efa5c9$export$35808ee640e87ca7 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useCallback(a, b);
};
$bc44d5c582efa5c9$export$fae74005e78b1a27 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useContext(a, b);
};
$bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = function() {};
$bc44d5c582efa5c9$export$6d9c69b0de29b591 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useEffect(a, b);
};
$bc44d5c582efa5c9$export$d5a552a76deda3c2 = function(a, b, c) {
    return $bc44d5c582efa5c9$var$S().useImperativeHandle(a, b, c);
};
$bc44d5c582efa5c9$export$e5c5a5f917a5871c = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useLayoutEffect(a, b);
};
$bc44d5c582efa5c9$export$1538c33de8887b59 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useMemo(a, b);
};
$bc44d5c582efa5c9$export$13e3392192263954 = function(a, b, c) {
    return $bc44d5c582efa5c9$var$S().useReducer(a, b, c);
};
$bc44d5c582efa5c9$export$b8f5890fc79d6aca = function(a) {
    return $bc44d5c582efa5c9$var$S().useRef(a);
};
$bc44d5c582efa5c9$export$60241385465d0a34 = function(a) {
    return $bc44d5c582efa5c9$var$S().useState(a);
};
$bc44d5c582efa5c9$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("bFpVl", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", function () { return addExtensionMethods; });

var $aGB1Z = parcelRequire("aGB1Z");
var $9FJRw = parcelRequire("9FJRw");

var $gB5MK = parcelRequire("gB5MK");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $9FJRw.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $gB5MK.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $gB5MK.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $gB5MK.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $gB5MK.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $gB5MK.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $aGB1Z.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $gB5MK.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("aGB1Z", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $7c7a8d35bee522e7$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $7c7a8d35bee522e7$export$653d0ef2bad9cdf9; });

var $5Tp4j = parcelRequire("5Tp4j");

var $cLZZ4 = parcelRequire("cLZZ4");

var $9FJRw = parcelRequire("9FJRw");

var $9lgN8 = parcelRequire("9lgN8");

var $5LfF9 = parcelRequire("5LfF9");

var $dveIv = parcelRequire("dveIv");

var $8swS4 = parcelRequire("8swS4");

var $iglHX = parcelRequire("iglHX");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $7c7a8d35bee522e7$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $9lgN8.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $7c7a8d35bee522e7$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $iglHX.Transaction)(transactionContext, this);
    transaction = (0, $8swS4.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $7c7a8d35bee522e7$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $dveIv.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $8swS4.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $7c7a8d35bee522e7$export$653d0ef2bad9cdf9() {
    const carrier = (0, $9FJRw.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $7c7a8d35bee522e7$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $7c7a8d35bee522e7$var$traceHeaders;
    (0, $5LfF9.registerErrorInstrumentation)();
}

});
parcelRegister("5Tp4j", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $44a588e16ef39759$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $44a588e16ef39759$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $44a588e16ef39759$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $44a588e16ef39759$export$af88d00dbe7f521; });

var $4m2mz = parcelRequire("4m2mz");

var $iyFKK = parcelRequire("iyFKK");
/** Prefix for logging strings */ const $44a588e16ef39759$var$PREFIX = 'Sentry Logger ';
const $44a588e16ef39759$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $44a588e16ef39759$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $44a588e16ef39759$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $iyFKK.GLOBAL_OBJ))) return callback();
    const console = (0, $iyFKK.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($44a588e16ef39759$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $44a588e16ef39759$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $44a588e16ef39759$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $4m2mz.DEBUG_BUILD) $44a588e16ef39759$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $44a588e16ef39759$export$cda52e2a8927a2ca(()=>{
                (0, $iyFKK.GLOBAL_OBJ).console[name](`${$44a588e16ef39759$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $44a588e16ef39759$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $44a588e16ef39759$export$af88d00dbe7f521 = $44a588e16ef39759$var$makeLogger();

});
parcelRegister("4m2mz", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $32bb0cc524978960$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $32bb0cc524978960$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("iyFKK", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $d82bca41a70b60ce$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $d82bca41a70b60ce$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $d82bca41a70b60ce$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $d82bca41a70b60ce$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $d82bca41a70b60ce$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $d82bca41a70b60ce$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $d82bca41a70b60ce$var$isGlobalObj(window) || typeof self == 'object' && $d82bca41a70b60ce$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $d82bca41a70b60ce$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $d82bca41a70b60ce$export$256479dc0cea61c4() {
    return $d82bca41a70b60ce$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $d82bca41a70b60ce$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $d82bca41a70b60ce$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("cLZZ4", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $02665aa788e567af$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $02665aa788e567af$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("9FJRw", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $70ab84b23cd6127c$export$19eade501500c6c1; });
$parcel$export(module.exports, "getCurrentHub", function () { return $70ab84b23cd6127c$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $70ab84b23cd6127c$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $70ab84b23cd6127c$export$70d775fb1f267027; });

var $5Tp4j = parcelRequire("5Tp4j");
var $7X4Jf = parcelRequire("7X4Jf");
var $iyFKK = parcelRequire("iyFKK");
var $aYpzJ = parcelRequire("aYpzJ");
var $fV6gF = parcelRequire("fV6gF");

var $194VC = parcelRequire("194VC");

var $cLZZ4 = parcelRequire("cLZZ4");

var $e7Dxw = parcelRequire("e7Dxw");

var $5cxyv = parcelRequire("5cxyv");

var $e9C8i = parcelRequire("e9C8i");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $70ab84b23cd6127c$export$24a86ef7798177e4 = parseFloat((0, $e9C8i.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $70ab84b23cd6127c$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $70ab84b23cd6127c$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $70ab84b23cd6127c$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $e7Dxw.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $e7Dxw.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $aYpzJ.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $fV6gF.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $fV6gF.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fV6gF.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $70ab84b23cd6127c$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $7X4Jf.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $5Tp4j.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $70ab84b23cd6127c$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $70ab84b23cd6127c$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $cLZZ4.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $5Tp4j.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $5Tp4j.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $5cxyv.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $194VC.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $iyFKK.GLOBAL_OBJ).navigator || {};
        const session = (0, $5cxyv.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $5cxyv.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $70ab84b23cd6127c$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $70ab84b23cd6127c$export$19eade501500c6c1() {
    (0, $iyFKK.GLOBAL_OBJ).__SENTRY__ = (0, $iyFKK.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $iyFKK.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $70ab84b23cd6127c$export$4188a14ad302d1bc(hub) {
    const registry = $70ab84b23cd6127c$export$19eade501500c6c1();
    const oldHub = $70ab84b23cd6127c$export$bfa8a924a84a76b7(registry);
    $70ab84b23cd6127c$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $70ab84b23cd6127c$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $70ab84b23cd6127c$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $70ab84b23cd6127c$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $70ab84b23cd6127c$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $70ab84b23cd6127c$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $70ab84b23cd6127c$var$getGlobalHub(registry = $70ab84b23cd6127c$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$70ab84b23cd6127c$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $70ab84b23cd6127c$export$bfa8a924a84a76b7(registry).isOlderThan($70ab84b23cd6127c$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $70ab84b23cd6127c$export$849f05434e95d2f2(registry, new $70ab84b23cd6127c$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $70ab84b23cd6127c$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $70ab84b23cd6127c$export$236689a79f5aa020(carrier, parent = $70ab84b23cd6127c$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$70ab84b23cd6127c$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $70ab84b23cd6127c$export$bfa8a924a84a76b7(carrier).isOlderThan($70ab84b23cd6127c$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $70ab84b23cd6127c$export$849f05434e95d2f2(carrier, new $70ab84b23cd6127c$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $70ab84b23cd6127c$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $70ab84b23cd6127c$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $70ab84b23cd6127c$export$70d775fb1f267027(callback, options = {}) {
    const registry = $70ab84b23cd6127c$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $70ab84b23cd6127c$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $70ab84b23cd6127c$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $iyFKK.getGlobalSingleton)('hub', ()=>new $70ab84b23cd6127c$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $70ab84b23cd6127c$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("7X4Jf", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $5ca1b61c9f6a22e2$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $5ca1b61c9f6a22e2$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $5ca1b61c9f6a22e2$export$baf075a948ffc0bf; });

var $iyFKK = parcelRequire("iyFKK");
const $5ca1b61c9f6a22e2$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $5ca1b61c9f6a22e2$export$7740643b9eeaf0c4() {
    return Date.now() / $5ca1b61c9f6a22e2$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $5ca1b61c9f6a22e2$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $iyFKK.GLOBAL_OBJ);
    if (!performance || !performance.now) return $5ca1b61c9f6a22e2$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $5ca1b61c9f6a22e2$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $5ca1b61c9f6a22e2$export$ee52dced521e3e18 = $5ca1b61c9f6a22e2$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $5ca1b61c9f6a22e2$export$c5907b5a8838db13 = $5ca1b61c9f6a22e2$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $5ca1b61c9f6a22e2$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $5ca1b61c9f6a22e2$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $iyFKK.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $5ca1b61c9f6a22e2$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $5ca1b61c9f6a22e2$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $5ca1b61c9f6a22e2$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $5ca1b61c9f6a22e2$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("aYpzJ", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $7fd358ade65e2de4$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $7fd358ade65e2de4$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $7fd358ade65e2de4$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $7fd358ade65e2de4$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $7fd358ade65e2de4$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $7fd358ade65e2de4$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $7fd358ade65e2de4$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $7fd358ade65e2de4$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $7fd358ade65e2de4$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $7fd358ade65e2de4$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $7fd358ade65e2de4$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $7fd358ade65e2de4$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $7fd358ade65e2de4$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $7fd358ade65e2de4$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $7fd358ade65e2de4$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $7fd358ade65e2de4$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $7fd358ade65e2de4$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$e6127cc7fe7395c3(wat) {
    switch($7fd358ade65e2de4$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $7fd358ade65e2de4$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$var$isBuiltin(wat, className) {
    return $7fd358ade65e2de4$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$9f9636d330b71954(wat) {
    return $7fd358ade65e2de4$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$ef9e2056653f0c8e(wat) {
    return $7fd358ade65e2de4$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$12e869b2a583f783(wat) {
    return $7fd358ade65e2de4$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$844ec244b1367d54(wat) {
    return $7fd358ade65e2de4$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$c3825b437cbdea5c(wat) {
    return wat === null || $7fd358ade65e2de4$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$53b83ca8eaab0383(wat) {
    return $7fd358ade65e2de4$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $7fd358ade65e2de4$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $7fd358ade65e2de4$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$49841c62b9eff15(wat) {
    return $7fd358ade65e2de4$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $7fd358ade65e2de4$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$bc2894c7158efbac(wat) {
    return $7fd358ade65e2de4$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7fd358ade65e2de4$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("fV6gF", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $b9710a8755aeb992$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $b9710a8755aeb992$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $b9710a8755aeb992$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $b9710a8755aeb992$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $b9710a8755aeb992$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $b9710a8755aeb992$export$3131421a7d01b4fb; });

var $9oYhG = parcelRequire("9oYhG");

var $7NyaU = parcelRequire("7NyaU");

var $iyFKK = parcelRequire("iyFKK");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $b9710a8755aeb992$export$19f53698e68b2496() {
    const gbl = (0, $iyFKK.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $b9710a8755aeb992$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $b9710a8755aeb992$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $b9710a8755aeb992$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $b9710a8755aeb992$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $b9710a8755aeb992$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $b9710a8755aeb992$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $b9710a8755aeb992$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $b9710a8755aeb992$export$d364f2020ab30578(input) {
    const match = input.match($b9710a8755aeb992$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $b9710a8755aeb992$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $7NyaU.snipLine)(line, 0));
    frame.context_line = (0, $7NyaU.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $7NyaU.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $b9710a8755aeb992$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9oYhG.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $b9710a8755aeb992$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("9oYhG", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $6d851e1d625abe20$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $6d851e1d625abe20$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $6d851e1d625abe20$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $6d851e1d625abe20$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $6d851e1d625abe20$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $6d851e1d625abe20$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $6d851e1d625abe20$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $6d851e1d625abe20$export$d25f2688db1bb433; });

var $c9A3H = parcelRequire("c9A3H");

var $4m2mz = parcelRequire("4m2mz");

var $aYpzJ = parcelRequire("aYpzJ");

var $5Tp4j = parcelRequire("5Tp4j");

var $7NyaU = parcelRequire("7NyaU");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $6d851e1d625abe20$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $6d851e1d625abe20$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $6d851e1d625abe20$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $4m2mz.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $6d851e1d625abe20$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $6d851e1d625abe20$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $6d851e1d625abe20$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $6d851e1d625abe20$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $6d851e1d625abe20$export$62ff257738bf57f5(value) {
    if ((0, $aYpzJ.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$6d851e1d625abe20$var$getOwnProperties(value)
    };
    else if ((0, $aYpzJ.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $6d851e1d625abe20$var$serializeEventTarget(value.target),
            currentTarget: $6d851e1d625abe20$var$serializeEventTarget(value.currentTarget),
            ...$6d851e1d625abe20$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $aYpzJ.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $6d851e1d625abe20$var$serializeEventTarget(target) {
    try {
        return (0, $aYpzJ.isElement)(target) ? (0, $c9A3H.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $6d851e1d625abe20$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $6d851e1d625abe20$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($6d851e1d625abe20$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $7NyaU.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $7NyaU.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $6d851e1d625abe20$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $6d851e1d625abe20$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $6d851e1d625abe20$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($6d851e1d625abe20$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $6d851e1d625abe20$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($6d851e1d625abe20$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $6d851e1d625abe20$var$isPojo(input) {
    if (!(0, $aYpzJ.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $6d851e1d625abe20$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $aYpzJ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("c9A3H", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $8d924bc737d277a8$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $8d924bc737d277a8$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $8d924bc737d277a8$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $8d924bc737d277a8$export$26727cfcc4d7e0fc; });

var $aYpzJ = parcelRequire("aYpzJ");

var $iyFKK = parcelRequire("iyFKK");
// eslint-disable-next-line deprecation/deprecation
const $8d924bc737d277a8$var$WINDOW = (0, $iyFKK.getGlobalObject)();
const $8d924bc737d277a8$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8d924bc737d277a8$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8d924bc737d277a8$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8d924bc737d277a8$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8d924bc737d277a8$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($8d924bc737d277a8$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $aYpzJ.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $8d924bc737d277a8$export$1cfafeee2987818b() {
    try {
        return $8d924bc737d277a8$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8d924bc737d277a8$export$c660c1f3ab49225c(selector) {
    if ($8d924bc737d277a8$var$WINDOW.document && $8d924bc737d277a8$var$WINDOW.document.querySelector) return $8d924bc737d277a8$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8d924bc737d277a8$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8d924bc737d277a8$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("7NyaU", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $5ad79e774d0f71c2$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $5ad79e774d0f71c2$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $5ad79e774d0f71c2$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $5ad79e774d0f71c2$export$a7a5ec66062ea5d; });

var $aYpzJ = parcelRequire("aYpzJ");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $5ad79e774d0f71c2$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $5ad79e774d0f71c2$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5ad79e774d0f71c2$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $aYpzJ.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $5ad79e774d0f71c2$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $aYpzJ.isString)(value)) return false;
    if ((0, $aYpzJ.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $aYpzJ.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $5ad79e774d0f71c2$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$5ad79e774d0f71c2$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("194VC", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $0d5a74655b483fa3$export$849dbeeeda01ae98; });
const $0d5a74655b483fa3$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("e7Dxw", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $a48063e8acc19b2c$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $a48063e8acc19b2c$export$aa55d5ab8e05984f; });

var $7X4Jf = parcelRequire("7X4Jf");
var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");
var $fV6gF = parcelRequire("fV6gF");

var $37IZD = parcelRequire("37IZD");

var $5cxyv = parcelRequire("5cxyv");

var $2Gpf8 = parcelRequire("2Gpf8");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $a48063e8acc19b2c$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $a48063e8acc19b2c$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $a48063e8acc19b2c$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $a48063e8acc19b2c$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $a48063e8acc19b2c$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $a48063e8acc19b2c$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $5cxyv.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $a48063e8acc19b2c$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $aYpzJ.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $a48063e8acc19b2c$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $a48063e8acc19b2c$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $7X4Jf.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $2Gpf8.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $37IZD.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $37IZD.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fV6gF.uuid4)();
        if (!this._client) {
            (0, $5Tp4j.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fV6gF.uuid4)();
        if (!this._client) {
            (0, $5Tp4j.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fV6gF.uuid4)();
        if (!this._client) {
            (0, $5Tp4j.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $a48063e8acc19b2c$export$aa55d5ab8e05984f() {
    if (!$a48063e8acc19b2c$var$globalScope) $a48063e8acc19b2c$var$globalScope = new $a48063e8acc19b2c$export$775b6bb06e53a214();
    return $a48063e8acc19b2c$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $a48063e8acc19b2c$export$c83048efd17527d6(scope) {
    $a48063e8acc19b2c$var$globalScope = scope;
}
function $a48063e8acc19b2c$var$generatePropagationContext() {
    return {
        traceId: (0, $fV6gF.uuid4)(),
        spanId: (0, $fV6gF.uuid4)().substring(16)
    };
}

});
parcelRegister("37IZD", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $2464ed3a16e83843$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $2464ed3a16e83843$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $2464ed3a16e83843$export$bf2a096c3e883e79; });

var $iyFKK = parcelRequire("iyFKK");
var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");
var $kT15L = parcelRequire("kT15L");

var $cLZZ4 = parcelRequire("cLZZ4");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $2464ed3a16e83843$export$3c4238858b85e8ac() {
    return (0, $iyFKK.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $2464ed3a16e83843$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $2464ed3a16e83843$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $2464ed3a16e83843$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $kT15L.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $cLZZ4.DEBUG_BUILD) && processor.id && result === null && (0, $5Tp4j.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $aYpzJ.isThenable)(result)) result.then((final)=>$2464ed3a16e83843$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $2464ed3a16e83843$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("kT15L", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $f349ca8cfec41480$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $f349ca8cfec41480$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $f349ca8cfec41480$export$78e43115b553f358; });

var $aYpzJ = parcelRequire("aYpzJ");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $f349ca8cfec41480$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($f349ca8cfec41480$var$States || ($f349ca8cfec41480$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $f349ca8cfec41480$export$1fda8aa4d135f8aa(value) {
    return new $f349ca8cfec41480$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $f349ca8cfec41480$export$78e43115b553f358(reason) {
    return new $f349ca8cfec41480$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $f349ca8cfec41480$export$6f292d4960313241 {
    constructor(executor){
        $f349ca8cfec41480$export$6f292d4960313241.prototype.__init.call(this);
        $f349ca8cfec41480$export$6f292d4960313241.prototype.__init2.call(this);
        $f349ca8cfec41480$export$6f292d4960313241.prototype.__init3.call(this);
        $f349ca8cfec41480$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $f349ca8cfec41480$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $f349ca8cfec41480$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $f349ca8cfec41480$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($f349ca8cfec41480$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($f349ca8cfec41480$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $f349ca8cfec41480$var$States.PENDING) return;
            if ((0, $aYpzJ.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $f349ca8cfec41480$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $f349ca8cfec41480$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $f349ca8cfec41480$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("5cxyv", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $3c981a28d72fc98e$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $3c981a28d72fc98e$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $3c981a28d72fc98e$export$56521d9ba90f62ee; });

var $9oYhG = parcelRequire("9oYhG");
var $7X4Jf = parcelRequire("7X4Jf");
var $fV6gF = parcelRequire("fV6gF");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $3c981a28d72fc98e$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $7X4Jf.timestampInSeconds)();
    const session = {
        sid: (0, $fV6gF.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$3c981a28d72fc98e$var$sessionToJSON(session)
    };
    if (context) $3c981a28d72fc98e$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $3c981a28d72fc98e$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $7X4Jf.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $fV6gF.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $3c981a28d72fc98e$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $3c981a28d72fc98e$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $3c981a28d72fc98e$var$sessionToJSON(session) {
    return (0, $9oYhG.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("2Gpf8", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $1f4315c65d1fe7a8$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $1f4315c65d1fe7a8$export$25ac7e259a513db4; });

var $fV6gF = parcelRequire("fV6gF");
var $9oYhG = parcelRequire("9oYhG");

var $3Uyl3 = parcelRequire("3Uyl3");

var $6V598 = parcelRequire("6V598");

var $9lgN8 = parcelRequire("9lgN8");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $1f4315c65d1fe7a8$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $1f4315c65d1fe7a8$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $1f4315c65d1fe7a8$var$applySpanToEvent(event, span);
    $1f4315c65d1fe7a8$var$applyFingerprintToEvent(event, fingerprint);
    $1f4315c65d1fe7a8$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $1f4315c65d1fe7a8$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $1f4315c65d1fe7a8$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $1f4315c65d1fe7a8$export$b1a120a2871faa46(data, 'extra', extra);
    $1f4315c65d1fe7a8$export$b1a120a2871faa46(data, 'tags', tags);
    $1f4315c65d1fe7a8$export$b1a120a2871faa46(data, 'user', user);
    $1f4315c65d1fe7a8$export$b1a120a2871faa46(data, 'contexts', contexts);
    $1f4315c65d1fe7a8$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $1f4315c65d1fe7a8$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $1f4315c65d1fe7a8$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $9oYhG.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $9oYhG.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $9oYhG.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $9oYhG.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $1f4315c65d1fe7a8$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $1f4315c65d1fe7a8$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $1f4315c65d1fe7a8$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $9lgN8.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $6V598.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $3Uyl3.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $9lgN8.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $1f4315c65d1fe7a8$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $fV6gF.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("3Uyl3", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $2d913cf973c6177e$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $2d913cf973c6177e$export$a117f995597e25df; });

var $9oYhG = parcelRequire("9oYhG");

var $194VC = parcelRequire("194VC");

var $6VKBH = parcelRequire("6VKBH");

var $6V598 = parcelRequire("6V598");

var $9lgN8 = parcelRequire("9lgN8");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $2d913cf973c6177e$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $9oYhG.dropUndefinedKeys)({
        environment: options.environment || (0, $194VC.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $2d913cf973c6177e$export$a117f995597e25df(span) {
    const client = (0, $6VKBH.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $2d913cf973c6177e$export$366bad00d6815eed((0, $9lgN8.spanToJSON)(span).trace_id || '', client, (0, $6VKBH.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $6V598.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $9lgN8.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $9lgN8.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("6VKBH", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $50bc381dc96efe54$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureEvent", function () { return $50bc381dc96efe54$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $50bc381dc96efe54$export$efda9a273d7a036d; });
$parcel$export(module.exports, "withScope", function () { return $50bc381dc96efe54$export$ec58d9285c204497; });
$parcel$export(module.exports, "getCurrentScope", function () { return $50bc381dc96efe54$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $50bc381dc96efe54$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "startSession", function () { return $50bc381dc96efe54$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $50bc381dc96efe54$export$667e7b4d445d566b; });

var $iyFKK = parcelRequire("iyFKK");
var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");
var $7X4Jf = parcelRequire("7X4Jf");
var $fV6gF = parcelRequire("fV6gF");

var $194VC = parcelRequire("194VC");

var $cLZZ4 = parcelRequire("cLZZ4");

var $9FJRw = parcelRequire("9FJRw");

var $5cxyv = parcelRequire("5cxyv");

var $hW2rK = parcelRequire("hW2rK");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $50bc381dc96efe54$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().captureException(exception, (0, $hW2rK.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $50bc381dc96efe54$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $50bc381dc96efe54$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $50bc381dc96efe54$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $50bc381dc96efe54$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9FJRw.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $50bc381dc96efe54$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9FJRw.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $50bc381dc96efe54$export$9a4fed82c350c2bd(callback) {
    return (0, $9FJRw.runWithAsyncContext)(()=>{
        return callback((0, $9FJRw.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $50bc381dc96efe54$export$e57ac09b143d92a2(span, callback) {
    return $50bc381dc96efe54$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $50bc381dc96efe54$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $50bc381dc96efe54$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $50bc381dc96efe54$export$c7be4b0125a10cba();
    const client = $50bc381dc96efe54$export$6bb76d6eba7e258c();
    if (!client) (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $fV6gF.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $50bc381dc96efe54$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $50bc381dc96efe54$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $7X4Jf.timestampInSeconds)();
    function finishCheckIn(status) {
        $50bc381dc96efe54$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $7X4Jf.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $aYpzJ.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $50bc381dc96efe54$export$4909b86c8034bf73(timeout) {
    const client = $50bc381dc96efe54$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $50bc381dc96efe54$export$8360e631d277ea4d(timeout) {
    const client = $50bc381dc96efe54$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $50bc381dc96efe54$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $50bc381dc96efe54$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $50bc381dc96efe54$export$3f95c6f800b78024() {
    return !!$50bc381dc96efe54$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $50bc381dc96efe54$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9FJRw.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $50bc381dc96efe54$export$c0d84948cecf78d8(context) {
    const client = $50bc381dc96efe54$export$6bb76d6eba7e258c();
    const isolationScope = (0, $9FJRw.getIsolationScope)();
    const currentScope = $50bc381dc96efe54$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $194VC.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $iyFKK.GLOBAL_OBJ).navigator || {};
    const session = (0, $5cxyv.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $5cxyv.updateSession)(currentSession, {
        status: 'exited'
    });
    $50bc381dc96efe54$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $50bc381dc96efe54$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9FJRw.getIsolationScope)();
    const currentScope = $50bc381dc96efe54$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $5cxyv.closeSession)(session);
    $50bc381dc96efe54$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $50bc381dc96efe54$var$_sendSessionUpdate() {
    const isolationScope = (0, $9FJRw.getIsolationScope)();
    const currentScope = $50bc381dc96efe54$export$c7be4b0125a10cba();
    const client = $50bc381dc96efe54$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $50bc381dc96efe54$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $50bc381dc96efe54$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $50bc381dc96efe54$var$_sendSessionUpdate();
}

});
parcelRegister("hW2rK", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $d0e9c045561be941$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $d0e9c045561be941$export$76b5f966996d1653; });

var $fV6gF = parcelRequire("fV6gF");
var $7X4Jf = parcelRequire("7X4Jf");
var $iyFKK = parcelRequire("iyFKK");
var $gAfIh = parcelRequire("gAfIh");
var $7NyaU = parcelRequire("7NyaU");

var $194VC = parcelRequire("194VC");

var $37IZD = parcelRequire("37IZD");

var $e7Dxw = parcelRequire("e7Dxw");

var $2Gpf8 = parcelRequire("2Gpf8");

var $9lgN8 = parcelRequire("9lgN8");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $d0e9c045561be941$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $fV6gF.uuid4)(),
        timestamp: event.timestamp || (0, $7X4Jf.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $d0e9c045561be941$var$applyClientOptions(prepared, options);
    $d0e9c045561be941$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $d0e9c045561be941$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $d0e9c045561be941$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $fV6gF.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $e7Dxw.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $2Gpf8.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $2Gpf8.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $2Gpf8.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $37IZD.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $37IZD.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $d0e9c045561be941$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $d0e9c045561be941$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $d0e9c045561be941$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $194VC.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $7NyaU.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $7NyaU.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $7NyaU.truncate)(request.url, maxValueLength);
}
const $d0e9c045561be941$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $d0e9c045561be941$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $iyFKK.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $d0e9c045561be941$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $d0e9c045561be941$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $d0e9c045561be941$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $d0e9c045561be941$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $d0e9c045561be941$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $gAfIh.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $gAfIh.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $gAfIh.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $gAfIh.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $gAfIh.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $9lgN8.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $gAfIh.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $d0e9c045561be941$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $e7Dxw.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $d0e9c045561be941$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($d0e9c045561be941$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($d0e9c045561be941$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $d0e9c045561be941$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $e7Dxw.Scope) || typeof hint === 'function';
}
const $d0e9c045561be941$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $d0e9c045561be941$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$d0e9c045561be941$var$captureContextKeys.includes(key));
}

});
parcelRegister("gAfIh", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $c12c3271e65f83ab$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $c12c3271e65f83ab$export$23fbbb20bed71033; });

var $aYpzJ = parcelRequire("aYpzJ");

var $evETt = parcelRequire("evETt");

var $9oYhG = parcelRequire("9oYhG");

var $iLMLM = parcelRequire("iLMLM");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c12c3271e65f83ab$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $c12c3271e65f83ab$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $c12c3271e65f83ab$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $c12c3271e65f83ab$export$a3295358bff77e(object, depth);
    if ($c12c3271e65f83ab$var$jsonSize(normalized) > maxSize) return $c12c3271e65f83ab$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $c12c3271e65f83ab$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $evETt.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $aYpzJ.isNaN)(value)) return value;
    const stringified = $c12c3271e65f83ab$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $c12c3271e65f83ab$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $9oYhG.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $c12c3271e65f83ab$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $c12c3271e65f83ab$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $aYpzJ.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $aYpzJ.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $iLMLM.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $c12c3271e65f83ab$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $c12c3271e65f83ab$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $c12c3271e65f83ab$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c12c3271e65f83ab$var$jsonSize(value) {
    return $c12c3271e65f83ab$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $c12c3271e65f83ab$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("evETt", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $a903ae959eed3acb$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $a903ae959eed3acb$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("iLMLM", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $daa27267ddcb361d$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $daa27267ddcb361d$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $daa27267ddcb361d$export$aad197c7121a6651; });

var $aVYGb = parcelRequire("aVYGb");
const $daa27267ddcb361d$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $daa27267ddcb361d$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $daa27267ddcb361d$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $daa27267ddcb361d$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $daa27267ddcb361d$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($daa27267ddcb361d$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $daa27267ddcb361d$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $daa27267ddcb361d$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $daa27267ddcb361d$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $daa27267ddcb361d$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $daa27267ddcb361d$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($daa27267ddcb361d$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($daa27267ddcb361d$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $daa27267ddcb361d$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $daa27267ddcb361d$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $daa27267ddcb361d$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $daa27267ddcb361d$var$defaultFunctionName;
        return fn.name || $daa27267ddcb361d$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $daa27267ddcb361d$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $daa27267ddcb361d$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $aVYGb.node)(getModule)
    ];
}

});
parcelRegister("aVYGb", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $7f5e4bea457d5e42$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $7f5e4bea457d5e42$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $7f5e4bea457d5e42$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $7f5e4bea457d5e42$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});



parcelRegister("9lgN8", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $6cd319a9003a7e67$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $6cd319a9003a7e67$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $6cd319a9003a7e67$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $6cd319a9003a7e67$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $6cd319a9003a7e67$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $6cd319a9003a7e67$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $6cd319a9003a7e67$export$3f7581298f56c6d7; });

var $9oYhG = parcelRequire("9oYhG");
var $UpCJO = parcelRequire("UpCJO");
var $7X4Jf = parcelRequire("7X4Jf");
// These are aligned with OpenTelemetry trace flags
const $6cd319a9003a7e67$export$208d5b368507fb8b = 0x0;
const $6cd319a9003a7e67$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $6cd319a9003a7e67$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $6cd319a9003a7e67$export$92d8c23565496537(span);
    return (0, $9oYhG.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $6cd319a9003a7e67$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $6cd319a9003a7e67$export$5caecac1caaf3a71(span);
    return (0, $UpCJO.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $6cd319a9003a7e67$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $6cd319a9003a7e67$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $6cd319a9003a7e67$var$ensureTimestampInSeconds(input.getTime());
    return (0, $7X4Jf.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $6cd319a9003a7e67$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $6cd319a9003a7e67$export$92d8c23565496537(span) {
    if ($6cd319a9003a7e67$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $6cd319a9003a7e67$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $6cd319a9003a7e67$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $6cd319a9003a7e67$export$eb571cd9b5d98de8);
}

});
parcelRegister("UpCJO", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $0a991b6e7a123396$export$394a210812ba3012; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $0a991b6e7a123396$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $0a991b6e7a123396$export$ca5c066532785b6e; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $0a991b6e7a123396$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $0a991b6e7a123396$export$f35d907436da45cf; });

var $hqP9w = parcelRequire("hqP9w");

var $fV6gF = parcelRequire("fV6gF");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $0a991b6e7a123396$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $0a991b6e7a123396$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($0a991b6e7a123396$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $0a991b6e7a123396$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $0a991b6e7a123396$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $hqP9w.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $fV6gF.uuid4)(),
            spanId: (0, $fV6gF.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $fV6gF.uuid4)(),
            parentSpanId: parentSpanId || (0, $fV6gF.uuid4)().substring(16),
            spanId: (0, $fV6gF.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $0a991b6e7a123396$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $0a991b6e7a123396$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $hqP9w.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $fV6gF.uuid4)(),
        spanId: (0, $fV6gF.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $fV6gF.uuid4)(),
        parentSpanId: parentSpanId || (0, $fV6gF.uuid4)().substring(16),
        spanId: (0, $fV6gF.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $0a991b6e7a123396$export$f35d907436da45cf(traceId = (0, $fV6gF.uuid4)(), spanId = (0, $fV6gF.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("hqP9w", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $cb0c8b30ec190e09$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $cb0c8b30ec190e09$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $cb0c8b30ec190e09$export$56766feef403f365; });

var $4m2mz = parcelRequire("4m2mz");

var $aYpzJ = parcelRequire("aYpzJ");

var $5Tp4j = parcelRequire("5Tp4j");
const $cb0c8b30ec190e09$export$9ca9946bd449ac06 = 'baggage';
const $cb0c8b30ec190e09$export$6e69537d67fa20f = 'sentry-';
const $cb0c8b30ec190e09$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $cb0c8b30ec190e09$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $cb0c8b30ec190e09$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $aYpzJ.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $cb0c8b30ec190e09$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $cb0c8b30ec190e09$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($cb0c8b30ec190e09$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($cb0c8b30ec190e09$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $cb0c8b30ec190e09$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$cb0c8b30ec190e09$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $cb0c8b30ec190e09$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $cb0c8b30ec190e09$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $cb0c8b30ec190e09$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $cb0c8b30ec190e09$export$bdd844ddb2def819) {
            (0, $4m2mz.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});





parcelRegister("6V598", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $509c0ee79b6fa3a2$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $509c0ee79b6fa3a2$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});




parcelRegister("e9C8i", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $a4df7c52e4206ec8$export$31499a9cd224b78c; });
const $a4df7c52e4206ec8$export$31499a9cd224b78c = '7.120.4';

});


parcelRegister("5LfF9", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $431d7dd82c1e7664$export$637857c1d87b640c; });

var $8BjtY = parcelRequire("8BjtY");
var $6fjdr = parcelRequire("6fjdr");
var $5Tp4j = parcelRequire("5Tp4j");

var $cLZZ4 = parcelRequire("cLZZ4");

var $j527G = parcelRequire("j527G");
let $431d7dd82c1e7664$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $431d7dd82c1e7664$export$637857c1d87b640c() {
    if ($431d7dd82c1e7664$var$errorsInstrumented) return;
    $431d7dd82c1e7664$var$errorsInstrumented = true;
    (0, $8BjtY.addGlobalErrorInstrumentationHandler)($431d7dd82c1e7664$var$errorCallback);
    (0, $6fjdr.addGlobalUnhandledRejectionInstrumentationHandler)($431d7dd82c1e7664$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $431d7dd82c1e7664$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $j527G.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$431d7dd82c1e7664$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("8BjtY", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $6430e437b3723692$export$55b5c3ba2194f0c6; });

var $iyFKK = parcelRequire("iyFKK");

var $2dyEB = parcelRequire("2dyEB");
let $6430e437b3723692$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6430e437b3723692$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $6430e437b3723692$var$instrumentError);
}
function $6430e437b3723692$var$instrumentError() {
    $6430e437b3723692$var$_oldOnErrorHandler = (0, $iyFKK.GLOBAL_OBJ).onerror;
    (0, $iyFKK.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $2dyEB.triggerHandlers)('error', handlerData);
        if ($6430e437b3723692$var$_oldOnErrorHandler && !$6430e437b3723692$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $6430e437b3723692$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $iyFKK.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("2dyEB", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $19d7ad35f913f9b5$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $19d7ad35f913f9b5$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $19d7ad35f913f9b5$export$b18c893e424d3127; });

var $4m2mz = parcelRequire("4m2mz");

var $5Tp4j = parcelRequire("5Tp4j");

var $iLMLM = parcelRequire("iLMLM");
// We keep the handlers globally
const $19d7ad35f913f9b5$var$handlers = {};
const $19d7ad35f913f9b5$var$instrumented = {};
/** Add a handler function. */ function $19d7ad35f913f9b5$export$a4e09611e30da72e(type, handler) {
    $19d7ad35f913f9b5$var$handlers[type] = $19d7ad35f913f9b5$var$handlers[type] || [];
    $19d7ad35f913f9b5$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $19d7ad35f913f9b5$export$b17eab759a1cb5fe() {
    Object.keys($19d7ad35f913f9b5$var$handlers).forEach((key)=>{
        $19d7ad35f913f9b5$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $19d7ad35f913f9b5$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$19d7ad35f913f9b5$var$instrumented[type]) {
        instrumentFn();
        $19d7ad35f913f9b5$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $19d7ad35f913f9b5$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $19d7ad35f913f9b5$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4m2mz.DEBUG_BUILD) && (0, $5Tp4j.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $iLMLM.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("6fjdr", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $48c30ca0e95013f8$export$8bf4fc6858821a4e; });

var $iyFKK = parcelRequire("iyFKK");

var $2dyEB = parcelRequire("2dyEB");
let $48c30ca0e95013f8$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $48c30ca0e95013f8$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $48c30ca0e95013f8$var$instrumentUnhandledRejection);
}
function $48c30ca0e95013f8$var$instrumentUnhandledRejection() {
    $48c30ca0e95013f8$var$_oldOnUnhandledRejectionHandler = (0, $iyFKK.GLOBAL_OBJ).onunhandledrejection;
    (0, $iyFKK.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $2dyEB.triggerHandlers)('unhandledrejection', handlerData);
        if ($48c30ca0e95013f8$var$_oldOnUnhandledRejectionHandler && !$48c30ca0e95013f8$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $48c30ca0e95013f8$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $iyFKK.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("j527G", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $de4021819d557384$export$a7feb32fdd923295; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $de4021819d557384$export$8e9a29865c0a1226; });

var $UpCJO = parcelRequire("UpCJO");

var $9FJRw = parcelRequire("9FJRw");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $de4021819d557384$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $9FJRw.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $de4021819d557384$export$8e9a29865c0a1226 = (0, $UpCJO.extractTraceparentData);

});


parcelRegister("dveIv", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $9d499612243a4a91$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $9d499612243a4a91$export$b279e6bd7040371f; });

var $5Tp4j = parcelRequire("5Tp4j");
var $7X4Jf = parcelRequire("7X4Jf");

var $cLZZ4 = parcelRequire("cLZZ4");

var $9lgN8 = parcelRequire("9lgN8");

var $rqtTb = parcelRequire("rqtTb");

var $iglHX = parcelRequire("iglHX");
const $9d499612243a4a91$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $9d499612243a4a91$var$FINISH_REASON_TAG = 'finishReason';
const $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $9d499612243a4a91$export$370d6113c18ba86c extends (0, $rqtTb.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $9lgN8.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $9d499612243a4a91$export$b279e6bd7040371f extends (0, $iglHX.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $9d499612243a4a91$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $9d499612243a4a91$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $9d499612243a4a91$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $9lgN8.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($9d499612243a4a91$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $cLZZ4.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $5Tp4j.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $9lgN8.spanToJSON)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $9lgN8.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $cLZZ4.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $5Tp4j.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $5Tp4j.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $9d499612243a4a91$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $7X4Jf.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $9d499612243a4a91$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("rqtTb", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $0527105293201aa3$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $0527105293201aa3$export$5f1714a13ed34c01; });

var $9oYhG = parcelRequire("9oYhG");
var $5Tp4j = parcelRequire("5Tp4j");
var $7X4Jf = parcelRequire("7X4Jf");
var $fV6gF = parcelRequire("fV6gF");

var $cLZZ4 = parcelRequire("cLZZ4");

var $kBKS6 = parcelRequire("kBKS6");

var $eas0Q = parcelRequire("eas0Q");

var $6V598 = parcelRequire("6V598");

var $9lgN8 = parcelRequire("9lgN8");

var $iI0FQ = parcelRequire("iI0FQ");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $0527105293201aa3$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $0527105293201aa3$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $fV6gF.uuid4)();
        this._spanId = spanContext.spanId || (0, $fV6gF.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $7X4Jf.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || 'manual',
            [(0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $9lgN8.TRACE_FLAG_SAMPLED) : (0, $9lgN8.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $0527105293201aa3$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $6V598.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $cLZZ4.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $9lgN8.spanToJSON)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $5Tp4j.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $iI0FQ.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $6V598.getRootSpan)(this);
        if ((0, $cLZZ4.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $5Tp4j.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $9lgN8.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $9lgN8.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $9oYhG.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $9lgN8.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $9oYhG.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $kBKS6.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("kBKS6", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $f00b9f0f196434cd$export$2e7205e45c58797d; });

var $9oYhG = parcelRequire("9oYhG");




var $aWXXn = parcelRequire("aWXXn");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $f00b9f0f196434cd$var$SPAN_METRIC_SUMMARY;
function $f00b9f0f196434cd$var$getMetricStorageForSpan(span) {
    return $f00b9f0f196434cd$var$SPAN_METRIC_SUMMARY ? $f00b9f0f196434cd$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $f00b9f0f196434cd$export$2e7205e45c58797d(span) {
    const storage = $f00b9f0f196434cd$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $9oYhG.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $f00b9f0f196434cd$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $aWXXn.getActiveSpan)();
    if (span) {
        const storage = $f00b9f0f196434cd$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$f00b9f0f196434cd$var$SPAN_METRIC_SUMMARY) $f00b9f0f196434cd$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $f00b9f0f196434cd$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("aWXXn", function(module, exports) {

$parcel$export(module.exports, "startSpan", function () { return $7f8dd450b84f7346$export$a1bd95187356f372; });
$parcel$export(module.exports, "startInactiveSpan", function () { return $7f8dd450b84f7346$export$63dbba021a6b4047; });
$parcel$export(module.exports, "getActiveSpan", function () { return $7f8dd450b84f7346$export$1be426a8e585c83e; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $7f8dd450b84f7346$export$c08fbc656a245d03; });

var $9oYhG = parcelRequire("9oYhG");
var $5Tp4j = parcelRequire("5Tp4j");
var $UpCJO = parcelRequire("UpCJO");

var $cLZZ4 = parcelRequire("cLZZ4");

var $9FJRw = parcelRequire("9FJRw");

var $9lgN8 = parcelRequire("9lgN8");



var $3Uyl3 = parcelRequire("3Uyl3");

var $6VKBH = parcelRequire("6VKBH");

var $kOOOk = parcelRequire("kOOOk");

var $bFyHv = parcelRequire("bFyHv");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $7f8dd450b84f7346$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9FJRw.getCurrentHub)();
    const scope = (0, $6VKBH.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $7f8dd450b84f7346$var$normalizeContext(context);
    const activeSpan = $7f8dd450b84f7346$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $kOOOk.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7f8dd450b84f7346$export$a1bd95187356f372(context, callback) {
    const spanContext = $7f8dd450b84f7346$var$normalizeContext(context);
    return (0, $9FJRw.runWithAsyncContext)(()=>{
        return (0, $6VKBH.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $9FJRw.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $7f8dd450b84f7346$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $kOOOk.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $9lgN8.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $7f8dd450b84f7346$export$cb9e396e6b90b703 = $7f8dd450b84f7346$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7f8dd450b84f7346$export$c10292ad04b92aea(context, callback) {
    const spanContext = $7f8dd450b84f7346$var$normalizeContext(context);
    return (0, $9FJRw.runWithAsyncContext)(()=>{
        return (0, $6VKBH.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $9FJRw.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $7f8dd450b84f7346$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $kOOOk.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $9lgN8.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7f8dd450b84f7346$export$63dbba021a6b4047(context) {
    if (!(0, $bFyHv.hasTracingEnabled)()) return undefined;
    const spanContext = $7f8dd450b84f7346$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9FJRw.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $7f8dd450b84f7346$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $6VKBH.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $7f8dd450b84f7346$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $7f8dd450b84f7346$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6VKBH.getCurrentScope)().getSpan();
}
const $7f8dd450b84f7346$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $6VKBH.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $UpCJO.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $cLZZ4.DEBUG_BUILD) && traceparentData) (0, $5Tp4j.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $9oYhG.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $9FJRw.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $7f8dd450b84f7346$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $bFyHv.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $9FJRw.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $3Uyl3.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $9lgN8.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $7f8dd450b84f7346$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $7f8dd450b84f7346$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $9lgN8.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $7f8dd450b84f7346$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $7f8dd450b84f7346$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $7f8dd450b84f7346$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $9oYhG.addNonEnumerableProperty)(span, $7f8dd450b84f7346$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $9oYhG.addNonEnumerableProperty)(span, $7f8dd450b84f7346$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $7f8dd450b84f7346$export$c08fbc656a245d03(span) {
    return {
        scope: span[$7f8dd450b84f7346$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$7f8dd450b84f7346$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("kOOOk", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $f27fe41eb09ac12c$export$18ce21a8b7efd7e9; });

var $aYpzJ = parcelRequire("aYpzJ");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $f27fe41eb09ac12c$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $f27fe41eb09ac12c$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $f27fe41eb09ac12c$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $aYpzJ.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("bFyHv", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $87ee70e81aa45d0f$export$5008da00b1b6dee6; });

var $6VKBH = parcelRequire("6VKBH");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $87ee70e81aa45d0f$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $6VKBH.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("eas0Q", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $a507ba9465660d75$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $a507ba9465660d75$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $a507ba9465660d75$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $a507ba9465660d75$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $a507ba9465660d75$export$1efec95406bbe327; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $a507ba9465660d75$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $a507ba9465660d75$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $a507ba9465660d75$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $a507ba9465660d75$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $a507ba9465660d75$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("iI0FQ", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", function () { return $d9ecdbdeeb7b0816$export$beb8e6a823e89c5d; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $d9ecdbdeeb7b0816$export$ac65c70d78fcdb55; });
$parcel$export(module.exports, "setHttpStatus", function () { return $d9ecdbdeeb7b0816$export$2ad6630ec8164254; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $d9ecdbdeeb7b0816$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($d9ecdbdeeb7b0816$export$beb8e6a823e89c5d || ($d9ecdbdeeb7b0816$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $d9ecdbdeeb7b0816$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $d9ecdbdeeb7b0816$export$ac65c70d78fcdb55 = $d9ecdbdeeb7b0816$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $d9ecdbdeeb7b0816$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $d9ecdbdeeb7b0816$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("iglHX", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $d4ba8f64b8edb465$export$febc5573c75cefb0; });

var $9oYhG = parcelRequire("9oYhG");
var $5Tp4j = parcelRequire("5Tp4j");

var $cLZZ4 = parcelRequire("cLZZ4");

var $9FJRw = parcelRequire("9FJRw");

var $kBKS6 = parcelRequire("kBKS6");

var $eas0Q = parcelRequire("eas0Q");

var $9lgN8 = parcelRequire("9lgN8");

var $3Uyl3 = parcelRequire("3Uyl3");

var $rqtTb = parcelRequire("rqtTb");

var $aWXXn = parcelRequire("aWXXn");
/** JSDoc */ class $d4ba8f64b8edb465$export$febc5573c75cefb0 extends (0, $rqtTb.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $9FJRw.getCurrentHub)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $rqtTb.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $9lgN8.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $9oYhG.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $3Uyl3.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $9lgN8.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $9lgN8.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $aWXXn.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $9lgN8.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $9oYhG.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $3Uyl3.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $kBKS6.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("8swS4", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $628a6fc5c6f89f68$export$b3258c3993bc9b71; });
$parcel$export(module.exports, "isValidSampleRate", function () { return $628a6fc5c6f89f68$export$2603c8d332a51c42; });

var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");

var $cLZZ4 = parcelRequire("cLZZ4");

var $eas0Q = parcelRequire("eas0Q");

var $bFyHv = parcelRequire("bFyHv");

var $9lgN8 = parcelRequire("9lgN8");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $628a6fc5c6f89f68$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $bFyHv.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$628a6fc5c6f89f68$export$2603c8d332a51c42(sampleRate)) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $cLZZ4.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $5Tp4j.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $9lgN8.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $628a6fc5c6f89f68$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $aYpzJ.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("gB5MK", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });
$parcel$export(module.exports, "loadModule", function () { return loadModule; });

var $hTyas = parcelRequire("hTyas");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $hTyas.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("hTyas", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $d07213b84877d036$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $d07213b84877d036$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $d07213b84877d036$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $d07213b84877d036$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});



parcelRegister("eN6q3", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $gIfym = parcelRequire("gIfym");

var $2WFPq = parcelRequire("2WFPq");

var $Qw0kg = parcelRequire("Qw0kg");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$gIfym) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $2WFPq({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $gIfym.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $2WFPq({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $2WFPq({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $2WFPq({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $Qw0kg.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $Qw0kg.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $Qw0kg.unstable_UserBlockingPriority, ed = $Qw0kg.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $2WFPq(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $2WFPq({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $2WFPq({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $2WFPq({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $2WFPq({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $2WFPq({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $2WFPq({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $2WFPq({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $2WFPq({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $2WFPq({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $2WFPq({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $2WFPq({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $2WFPq({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $2WFPq({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $Qw0kg.unstable_runWithPriority, Of = $Qw0kg.unstable_scheduleCallback, Pf = $Qw0kg.unstable_cancelCallback, Qf = $Qw0kg.unstable_shouldYield, Rf = $Qw0kg.unstable_requestPaint, Sf = $Qw0kg.unstable_now, Tf = $Qw0kg.unstable_getCurrentPriorityLevel, Uf = $Qw0kg.unstable_ImmediatePriority, Vf = $Qw0kg.unstable_UserBlockingPriority, Wf = $Qw0kg.unstable_NormalPriority, Xf = $Qw0kg.unstable_LowPriority, Yf = $Qw0kg.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $2WFPq({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $2WFPq({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $gIfym.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2WFPq({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $2WFPq({}, e, {
                    value: void 0
                });
                d = $2WFPq({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $2WFPq({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("Qw0kg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("29Llp"));

});
parcelRegister("29Llp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $192125a6b5623347$export$c4744153514ff05d; }, function (v) { return $192125a6b5623347$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $192125a6b5623347$export$b5836b71941fa3ed; }, function (v) { return $192125a6b5623347$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $192125a6b5623347$export$d66a1c1c77bd778b; }, function (v) { return $192125a6b5623347$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $192125a6b5623347$export$3e506c1ccc9cc1a7; }, function (v) { return $192125a6b5623347$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $192125a6b5623347$export$e26fe2ed2fa76875; }, function (v) { return $192125a6b5623347$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $192125a6b5623347$export$502329bbf4b505b1; }, function (v) { return $192125a6b5623347$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $192125a6b5623347$export$6e3807111c4874c4; }, function (v) { return $192125a6b5623347$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $192125a6b5623347$export$c27134553091fb3a; }, function (v) { return $192125a6b5623347$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $192125a6b5623347$export$33ee1acdc04fd2a2; }, function (v) { return $192125a6b5623347$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $192125a6b5623347$export$b00a404bbd5edef2; }, function (v) { return $192125a6b5623347$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $192125a6b5623347$export$8352ce38b91d0c62; }, function (v) { return $192125a6b5623347$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $192125a6b5623347$export$d3dfb8e4810cb555; }, function (v) { return $192125a6b5623347$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $192125a6b5623347$export$839f9183b0465a69; }, function (v) { return $192125a6b5623347$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $192125a6b5623347$export$72fdf0e06517287b; }, function (v) { return $192125a6b5623347$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $192125a6b5623347$export$4b844e58a3e414b4; }, function (v) { return $192125a6b5623347$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $192125a6b5623347$export$816d2913ae6b83b1; }, function (v) { return $192125a6b5623347$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $192125a6b5623347$export$61bcfe829111a1d0; }, function (v) { return $192125a6b5623347$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $192125a6b5623347$export$7ee8c9beb337bc3f; }, function (v) { return $192125a6b5623347$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $192125a6b5623347$export$cf845f2c119da08a; }, function (v) { return $192125a6b5623347$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $192125a6b5623347$export$c4744153514ff05d;
var $192125a6b5623347$export$b5836b71941fa3ed;
var $192125a6b5623347$export$d66a1c1c77bd778b;
var $192125a6b5623347$export$3e506c1ccc9cc1a7;
var $192125a6b5623347$export$e26fe2ed2fa76875;
var $192125a6b5623347$export$502329bbf4b505b1;
var $192125a6b5623347$export$6e3807111c4874c4;
var $192125a6b5623347$export$c27134553091fb3a;
var $192125a6b5623347$export$33ee1acdc04fd2a2;
var $192125a6b5623347$export$b00a404bbd5edef2;
var $192125a6b5623347$export$8352ce38b91d0c62;
var $192125a6b5623347$export$d3dfb8e4810cb555;
var $192125a6b5623347$export$839f9183b0465a69;
var $192125a6b5623347$export$72fdf0e06517287b;
var $192125a6b5623347$export$4b844e58a3e414b4;
var $192125a6b5623347$export$816d2913ae6b83b1;
var $192125a6b5623347$export$61bcfe829111a1d0;
var $192125a6b5623347$export$7ee8c9beb337bc3f;
var $192125a6b5623347$export$cf845f2c119da08a;
'use strict';
var $192125a6b5623347$var$f, $192125a6b5623347$var$g, $192125a6b5623347$var$h, $192125a6b5623347$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $192125a6b5623347$var$l = performance;
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$l.now();
    };
} else {
    var $192125a6b5623347$var$p = Date, $192125a6b5623347$var$q = $192125a6b5623347$var$p.now();
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$p.now() - $192125a6b5623347$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $192125a6b5623347$var$t = null, $192125a6b5623347$var$u = null, $192125a6b5623347$var$w = function() {
        if (null !== $192125a6b5623347$var$t) try {
            var a = $192125a6b5623347$export$c4744153514ff05d();
            $192125a6b5623347$var$t(!0, a);
            $192125a6b5623347$var$t = null;
        } catch (b) {
            throw setTimeout($192125a6b5623347$var$w, 0), b;
        }
    };
    $192125a6b5623347$var$f = function(a) {
        null !== $192125a6b5623347$var$t ? setTimeout($192125a6b5623347$var$f, 0, a) : ($192125a6b5623347$var$t = a, setTimeout($192125a6b5623347$var$w, 0));
    };
    $192125a6b5623347$var$g = function(a, b) {
        $192125a6b5623347$var$u = setTimeout(a, b);
    };
    $192125a6b5623347$var$h = function() {
        clearTimeout($192125a6b5623347$var$u);
    };
    $192125a6b5623347$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $192125a6b5623347$var$k = $192125a6b5623347$export$d66a1c1c77bd778b = function() {};
} else {
    var $192125a6b5623347$var$x = window.setTimeout, $192125a6b5623347$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $192125a6b5623347$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $192125a6b5623347$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $192125a6b5623347$var$A = !1, $192125a6b5623347$var$B = null, $192125a6b5623347$var$C = -1, $192125a6b5623347$var$D = 5, $192125a6b5623347$var$E = 0;
    $192125a6b5623347$export$b5836b71941fa3ed = function() {
        return $192125a6b5623347$export$c4744153514ff05d() >= $192125a6b5623347$var$E;
    };
    $192125a6b5623347$var$k = function() {};
    $192125a6b5623347$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $192125a6b5623347$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $192125a6b5623347$var$F = new MessageChannel, $192125a6b5623347$var$G = $192125a6b5623347$var$F.port2;
    $192125a6b5623347$var$F.port1.onmessage = function() {
        if (null !== $192125a6b5623347$var$B) {
            var a = $192125a6b5623347$export$c4744153514ff05d();
            $192125a6b5623347$var$E = a + $192125a6b5623347$var$D;
            try {
                $192125a6b5623347$var$B(!0, a) ? $192125a6b5623347$var$G.postMessage(null) : ($192125a6b5623347$var$A = !1, $192125a6b5623347$var$B = null);
            } catch (b) {
                throw $192125a6b5623347$var$G.postMessage(null), b;
            }
        } else $192125a6b5623347$var$A = !1;
    };
    $192125a6b5623347$var$f = function(a) {
        $192125a6b5623347$var$B = a;
        $192125a6b5623347$var$A || ($192125a6b5623347$var$A = !0, $192125a6b5623347$var$G.postMessage(null));
    };
    $192125a6b5623347$var$g = function(a, b) {
        $192125a6b5623347$var$C = $192125a6b5623347$var$x(function() {
            a($192125a6b5623347$export$c4744153514ff05d());
        }, b);
    };
    $192125a6b5623347$var$h = function() {
        $192125a6b5623347$var$y($192125a6b5623347$var$C);
        $192125a6b5623347$var$C = -1;
    };
}
function $192125a6b5623347$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $192125a6b5623347$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $192125a6b5623347$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $192125a6b5623347$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $192125a6b5623347$var$I(n, c)) void 0 !== r && 0 > $192125a6b5623347$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $192125a6b5623347$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $192125a6b5623347$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $192125a6b5623347$var$L = [], $192125a6b5623347$var$M = [], $192125a6b5623347$var$N = 1, $192125a6b5623347$var$O = null, $192125a6b5623347$var$P = 3, $192125a6b5623347$var$Q = !1, $192125a6b5623347$var$R = !1, $192125a6b5623347$var$S = !1;
function $192125a6b5623347$var$T(a) {
    for(var b = $192125a6b5623347$var$J($192125a6b5623347$var$M); null !== b;){
        if (null === b.callback) $192125a6b5623347$var$K($192125a6b5623347$var$M);
        else if (b.startTime <= a) $192125a6b5623347$var$K($192125a6b5623347$var$M), b.sortIndex = b.expirationTime, $192125a6b5623347$var$H($192125a6b5623347$var$L, b);
        else break;
        b = $192125a6b5623347$var$J($192125a6b5623347$var$M);
    }
}
function $192125a6b5623347$var$U(a) {
    $192125a6b5623347$var$S = !1;
    $192125a6b5623347$var$T(a);
    if (!$192125a6b5623347$var$R) {
        if (null !== $192125a6b5623347$var$J($192125a6b5623347$var$L)) $192125a6b5623347$var$R = !0, $192125a6b5623347$var$f($192125a6b5623347$var$V);
        else {
            var b = $192125a6b5623347$var$J($192125a6b5623347$var$M);
            null !== b && $192125a6b5623347$var$g($192125a6b5623347$var$U, b.startTime - a);
        }
    }
}
function $192125a6b5623347$var$V(a, b) {
    $192125a6b5623347$var$R = !1;
    $192125a6b5623347$var$S && ($192125a6b5623347$var$S = !1, $192125a6b5623347$var$h());
    $192125a6b5623347$var$Q = !0;
    var c = $192125a6b5623347$var$P;
    try {
        $192125a6b5623347$var$T(b);
        for($192125a6b5623347$var$O = $192125a6b5623347$var$J($192125a6b5623347$var$L); null !== $192125a6b5623347$var$O && (!($192125a6b5623347$var$O.expirationTime > b) || a && !$192125a6b5623347$export$b5836b71941fa3ed());){
            var d = $192125a6b5623347$var$O.callback;
            if ("function" === typeof d) {
                $192125a6b5623347$var$O.callback = null;
                $192125a6b5623347$var$P = $192125a6b5623347$var$O.priorityLevel;
                var e = d($192125a6b5623347$var$O.expirationTime <= b);
                b = $192125a6b5623347$export$c4744153514ff05d();
                "function" === typeof e ? $192125a6b5623347$var$O.callback = e : $192125a6b5623347$var$O === $192125a6b5623347$var$J($192125a6b5623347$var$L) && $192125a6b5623347$var$K($192125a6b5623347$var$L);
                $192125a6b5623347$var$T(b);
            } else $192125a6b5623347$var$K($192125a6b5623347$var$L);
            $192125a6b5623347$var$O = $192125a6b5623347$var$J($192125a6b5623347$var$L);
        }
        if (null !== $192125a6b5623347$var$O) var m = !0;
        else {
            var n = $192125a6b5623347$var$J($192125a6b5623347$var$M);
            null !== n && $192125a6b5623347$var$g($192125a6b5623347$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $192125a6b5623347$var$O = null, $192125a6b5623347$var$P = c, $192125a6b5623347$var$Q = !1;
    }
}
var $192125a6b5623347$var$W = $192125a6b5623347$var$k;
$192125a6b5623347$export$3e506c1ccc9cc1a7 = 5;
$192125a6b5623347$export$e26fe2ed2fa76875 = 1;
$192125a6b5623347$export$502329bbf4b505b1 = 4;
$192125a6b5623347$export$6e3807111c4874c4 = 3;
$192125a6b5623347$export$c27134553091fb3a = null;
$192125a6b5623347$export$33ee1acdc04fd2a2 = 2;
$192125a6b5623347$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$192125a6b5623347$export$8352ce38b91d0c62 = function() {
    $192125a6b5623347$var$R || $192125a6b5623347$var$Q || ($192125a6b5623347$var$R = !0, $192125a6b5623347$var$f($192125a6b5623347$var$V));
};
$192125a6b5623347$export$d3dfb8e4810cb555 = function() {
    return $192125a6b5623347$var$P;
};
$192125a6b5623347$export$839f9183b0465a69 = function() {
    return $192125a6b5623347$var$J($192125a6b5623347$var$L);
};
$192125a6b5623347$export$72fdf0e06517287b = function(a) {
    switch($192125a6b5623347$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $192125a6b5623347$var$P;
    }
    var c = $192125a6b5623347$var$P;
    $192125a6b5623347$var$P = b;
    try {
        return a();
    } finally{
        $192125a6b5623347$var$P = c;
    }
};
$192125a6b5623347$export$4b844e58a3e414b4 = function() {};
$192125a6b5623347$export$816d2913ae6b83b1 = $192125a6b5623347$var$W;
$192125a6b5623347$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $192125a6b5623347$var$P;
    $192125a6b5623347$var$P = a;
    try {
        return b();
    } finally{
        $192125a6b5623347$var$P = c;
    }
};
$192125a6b5623347$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $192125a6b5623347$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $192125a6b5623347$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $192125a6b5623347$var$H($192125a6b5623347$var$M, a), null === $192125a6b5623347$var$J($192125a6b5623347$var$L) && a === $192125a6b5623347$var$J($192125a6b5623347$var$M) && ($192125a6b5623347$var$S ? $192125a6b5623347$var$h() : $192125a6b5623347$var$S = !0, $192125a6b5623347$var$g($192125a6b5623347$var$U, c - d))) : (a.sortIndex = e, $192125a6b5623347$var$H($192125a6b5623347$var$L, a), $192125a6b5623347$var$R || $192125a6b5623347$var$Q || ($192125a6b5623347$var$R = !0, $192125a6b5623347$var$f($192125a6b5623347$var$V)));
    return a;
};
$192125a6b5623347$export$cf845f2c119da08a = function(a) {
    var b = $192125a6b5623347$var$P;
    return function() {
        var c = $192125a6b5623347$var$P;
        $192125a6b5623347$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $192125a6b5623347$var$P = c;
        }
    };
};

});



parcelRegister("jBLdM", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (format || !formatUpper) return format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format
        };
        return format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(locale, +this, output);
        return locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("euka9", function(module, exports) {

var $9xBij = parcelRequire("9xBij");
var $02b8d4ad2c123c0f$var$Global = $9xBij.Global;
module.exports = {
    name: 'localStorage',
    read: $02b8d4ad2c123c0f$var$read,
    write: $02b8d4ad2c123c0f$var$write,
    each: $02b8d4ad2c123c0f$var$each,
    remove: $02b8d4ad2c123c0f$var$remove,
    clearAll: $02b8d4ad2c123c0f$var$clearAll
};
function $02b8d4ad2c123c0f$var$localStorage() {
    return $02b8d4ad2c123c0f$var$Global.localStorage;
}
function $02b8d4ad2c123c0f$var$read(key) {
    return $02b8d4ad2c123c0f$var$localStorage().getItem(key);
}
function $02b8d4ad2c123c0f$var$write(key, data) {
    return $02b8d4ad2c123c0f$var$localStorage().setItem(key, data);
}
function $02b8d4ad2c123c0f$var$each(fn) {
    for(var i = $02b8d4ad2c123c0f$var$localStorage().length - 1; i >= 0; i--){
        var key = $02b8d4ad2c123c0f$var$localStorage().key(i);
        fn($02b8d4ad2c123c0f$var$read(key), key);
    }
}
function $02b8d4ad2c123c0f$var$remove(key) {
    return $02b8d4ad2c123c0f$var$localStorage().removeItem(key);
}
function $02b8d4ad2c123c0f$var$clearAll() {
    return $02b8d4ad2c123c0f$var$localStorage().clear();
}

});
parcelRegister("9xBij", function(module, exports) {
var $6f242007b64e0b5d$var$assign = $6f242007b64e0b5d$var$make_assign();
var $6f242007b64e0b5d$var$create = $6f242007b64e0b5d$var$make_create();
var $6f242007b64e0b5d$var$trim = $6f242007b64e0b5d$var$make_trim();
var $6f242007b64e0b5d$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $6f242007b64e0b5d$var$assign,
    create: $6f242007b64e0b5d$var$create,
    trim: $6f242007b64e0b5d$var$trim,
    bind: $6f242007b64e0b5d$var$bind,
    slice: $6f242007b64e0b5d$var$slice,
    each: $6f242007b64e0b5d$var$each,
    map: $6f242007b64e0b5d$var$map,
    pluck: $6f242007b64e0b5d$var$pluck,
    isList: $6f242007b64e0b5d$var$isList,
    isFunction: $6f242007b64e0b5d$var$isFunction,
    isObject: $6f242007b64e0b5d$var$isObject,
    Global: $6f242007b64e0b5d$var$Global
};
function $6f242007b64e0b5d$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$6f242007b64e0b5d$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $6f242007b64e0b5d$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $6f242007b64e0b5d$var$slice(arguments, 1);
        return $6f242007b64e0b5d$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $6f242007b64e0b5d$var$slice(arguments, 1);
            F.prototype = obj;
            return $6f242007b64e0b5d$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $6f242007b64e0b5d$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $6f242007b64e0b5d$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $6f242007b64e0b5d$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $6f242007b64e0b5d$var$each(obj, fn) {
    $6f242007b64e0b5d$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $6f242007b64e0b5d$var$map(obj, fn) {
    var res = $6f242007b64e0b5d$var$isList(obj) ? [] : {};
    $6f242007b64e0b5d$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $6f242007b64e0b5d$var$pluck(obj, fn) {
    if ($6f242007b64e0b5d$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $6f242007b64e0b5d$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $6f242007b64e0b5d$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $6f242007b64e0b5d$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("lRbAa", function(module, exports) {
// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var $9xBij = parcelRequire("9xBij");
var $fe97883c11374039$var$Global = $9xBij.Global;
module.exports = {
    name: 'oldFF-globalStorage',
    read: $fe97883c11374039$var$read,
    write: $fe97883c11374039$var$write,
    each: $fe97883c11374039$var$each,
    remove: $fe97883c11374039$var$remove,
    clearAll: $fe97883c11374039$var$clearAll
};
var $fe97883c11374039$var$globalStorage = $fe97883c11374039$var$Global.globalStorage;
function $fe97883c11374039$var$read(key) {
    return $fe97883c11374039$var$globalStorage[key];
}
function $fe97883c11374039$var$write(key, data) {
    $fe97883c11374039$var$globalStorage[key] = data;
}
function $fe97883c11374039$var$each(fn) {
    for(var i = $fe97883c11374039$var$globalStorage.length - 1; i >= 0; i--){
        var key = $fe97883c11374039$var$globalStorage.key(i);
        fn($fe97883c11374039$var$globalStorage[key], key);
    }
}
function $fe97883c11374039$var$remove(key) {
    return $fe97883c11374039$var$globalStorage.removeItem(key);
}
function $fe97883c11374039$var$clearAll() {
    $fe97883c11374039$var$each(function(key, _) {
        delete $fe97883c11374039$var$globalStorage[key];
    });
}

});

parcelRegister("kZLhS", function(module, exports) {
// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var $9xBij = parcelRequire("9xBij");
var $f48e2f6a45e5f38f$var$Global = $9xBij.Global;
module.exports = {
    name: 'oldIE-userDataStorage',
    write: $f48e2f6a45e5f38f$var$write,
    read: $f48e2f6a45e5f38f$var$read,
    each: $f48e2f6a45e5f38f$var$each,
    remove: $f48e2f6a45e5f38f$var$remove,
    clearAll: $f48e2f6a45e5f38f$var$clearAll
};
var $f48e2f6a45e5f38f$var$storageName = 'storejs';
var $f48e2f6a45e5f38f$var$doc = $f48e2f6a45e5f38f$var$Global.document;
var $f48e2f6a45e5f38f$var$_withStorageEl = $f48e2f6a45e5f38f$var$_makeIEStorageElFunction();
var $f48e2f6a45e5f38f$var$disable = ($f48e2f6a45e5f38f$var$Global.navigator ? $f48e2f6a45e5f38f$var$Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
;
function $f48e2f6a45e5f38f$var$write(unfixedKey, data) {
    if ($f48e2f6a45e5f38f$var$disable) return;
    var fixedKey = $f48e2f6a45e5f38f$var$fixKey(unfixedKey);
    $f48e2f6a45e5f38f$var$_withStorageEl(function(storageEl) {
        storageEl.setAttribute(fixedKey, data);
        storageEl.save($f48e2f6a45e5f38f$var$storageName);
    });
}
function $f48e2f6a45e5f38f$var$read(unfixedKey) {
    if ($f48e2f6a45e5f38f$var$disable) return;
    var fixedKey = $f48e2f6a45e5f38f$var$fixKey(unfixedKey);
    var res = null;
    $f48e2f6a45e5f38f$var$_withStorageEl(function(storageEl) {
        res = storageEl.getAttribute(fixedKey);
    });
    return res;
}
function $f48e2f6a45e5f38f$var$each(callback) {
    $f48e2f6a45e5f38f$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        for(var i = attributes.length - 1; i >= 0; i--){
            var attr = attributes[i];
            callback(storageEl.getAttribute(attr.name), attr.name);
        }
    });
}
function $f48e2f6a45e5f38f$var$remove(unfixedKey) {
    var fixedKey = $f48e2f6a45e5f38f$var$fixKey(unfixedKey);
    $f48e2f6a45e5f38f$var$_withStorageEl(function(storageEl) {
        storageEl.removeAttribute(fixedKey);
        storageEl.save($f48e2f6a45e5f38f$var$storageName);
    });
}
function $f48e2f6a45e5f38f$var$clearAll() {
    $f48e2f6a45e5f38f$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        storageEl.load($f48e2f6a45e5f38f$var$storageName);
        for(var i = attributes.length - 1; i >= 0; i--)storageEl.removeAttribute(attributes[i].name);
        storageEl.save($f48e2f6a45e5f38f$var$storageName);
    });
}
// Helpers
//////////
// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var $f48e2f6a45e5f38f$var$forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
function $f48e2f6a45e5f38f$var$fixKey(key) {
    return key.replace(/^\d/, '___$&').replace($f48e2f6a45e5f38f$var$forbiddenCharsRegex, '___');
}
function $f48e2f6a45e5f38f$var$_makeIEStorageElFunction() {
    if (!$f48e2f6a45e5f38f$var$doc || !$f48e2f6a45e5f38f$var$doc.documentElement || !$f48e2f6a45e5f38f$var$doc.documentElement.addBehavior) return null;
    var scriptTag = 'script', storageOwner, storageContainer, storageEl;
    // Since #userData storage applies only to specific paths, we need to
    // somehow link our data to a specific path.  We choose /favicon.ico
    // as a pretty safe option, since all browsers already make a request to
    // this URL anyway and being a 404 will not hurt us here.  We wrap an
    // iframe pointing to the favicon in an ActiveXObject(htmlfile) object
    // (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
    // since the iframe access rules appear to allow direct access and
    // manipulation of the document element, even for a 404 page.  This
    // document can be used instead of the current document (which would
    // have been limited to the current path) to perform #userData storage.
    try {
        /* global ActiveXObject */ storageContainer = new ActiveXObject('htmlfile');
        storageContainer.open();
        storageContainer.write('<' + scriptTag + '>document.w=window</' + scriptTag + '><iframe src="/favicon.ico"></iframe>');
        storageContainer.close();
        storageOwner = storageContainer.w.frames[0].document;
        storageEl = storageOwner.createElement('div');
    } catch (e) {
        // somehow ActiveXObject instantiation failed (perhaps some special
        // security settings or otherwse), fall back to per-path storage
        storageEl = $f48e2f6a45e5f38f$var$doc.createElement('div');
        storageOwner = $f48e2f6a45e5f38f$var$doc.body;
    }
    return function(storeFunction) {
        var args = [].slice.call(arguments, 0);
        args.unshift(storageEl);
        // See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
        // and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
        storageOwner.appendChild(storageEl);
        storageEl.addBehavior('#default#userData');
        storageEl.load($f48e2f6a45e5f38f$var$storageName);
        storeFunction.apply(this, args);
        storageOwner.removeChild(storageEl);
        return;
    };
}

});

parcelRegister("e4Z05", function(module, exports) {
// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var $9xBij = parcelRequire("9xBij");
var $a400c1cf249b5a05$var$Global = $9xBij.Global;
var $a400c1cf249b5a05$var$trim = $9xBij.trim;
module.exports = {
    name: 'cookieStorage',
    read: $a400c1cf249b5a05$var$read,
    write: $a400c1cf249b5a05$var$write,
    each: $a400c1cf249b5a05$var$each,
    remove: $a400c1cf249b5a05$var$remove,
    clearAll: $a400c1cf249b5a05$var$clearAll
};
var $a400c1cf249b5a05$var$doc = $a400c1cf249b5a05$var$Global.document;
function $a400c1cf249b5a05$var$read(key) {
    if (!key || !$a400c1cf249b5a05$var$_has(key)) return null;
    var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
    return unescape($a400c1cf249b5a05$var$doc.cookie.replace(new RegExp(regexpStr), "$1"));
}
function $a400c1cf249b5a05$var$each(callback) {
    var cookies = $a400c1cf249b5a05$var$doc.cookie.split(/; ?/g);
    for(var i = cookies.length - 1; i >= 0; i--){
        if (!$a400c1cf249b5a05$var$trim(cookies[i])) continue;
        var kvp = cookies[i].split('=');
        var key = unescape(kvp[0]);
        var val = unescape(kvp[1]);
        callback(val, key);
    }
}
function $a400c1cf249b5a05$var$write(key, data) {
    if (!key) return;
    $a400c1cf249b5a05$var$doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
}
function $a400c1cf249b5a05$var$remove(key) {
    if (!key || !$a400c1cf249b5a05$var$_has(key)) return;
    $a400c1cf249b5a05$var$doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
function $a400c1cf249b5a05$var$clearAll() {
    $a400c1cf249b5a05$var$each(function(_, key) {
        $a400c1cf249b5a05$var$remove(key);
    });
}
function $a400c1cf249b5a05$var$_has(key) {
    return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test($a400c1cf249b5a05$var$doc.cookie);
}

});

parcelRegister("52S69", function(module, exports) {

var $9xBij = parcelRequire("9xBij");
var $3ac71a6f55e675af$var$Global = $9xBij.Global;
module.exports = {
    name: 'sessionStorage',
    read: $3ac71a6f55e675af$var$read,
    write: $3ac71a6f55e675af$var$write,
    each: $3ac71a6f55e675af$var$each,
    remove: $3ac71a6f55e675af$var$remove,
    clearAll: $3ac71a6f55e675af$var$clearAll
};
function $3ac71a6f55e675af$var$sessionStorage() {
    return $3ac71a6f55e675af$var$Global.sessionStorage;
}
function $3ac71a6f55e675af$var$read(key) {
    return $3ac71a6f55e675af$var$sessionStorage().getItem(key);
}
function $3ac71a6f55e675af$var$write(key, data) {
    return $3ac71a6f55e675af$var$sessionStorage().setItem(key, data);
}
function $3ac71a6f55e675af$var$each(fn) {
    for(var i = $3ac71a6f55e675af$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $3ac71a6f55e675af$var$sessionStorage().key(i);
        fn($3ac71a6f55e675af$var$read(key), key);
    }
}
function $3ac71a6f55e675af$var$remove(key) {
    return $3ac71a6f55e675af$var$sessionStorage().removeItem(key);
}
function $3ac71a6f55e675af$var$clearAll() {
    return $3ac71a6f55e675af$var$sessionStorage().clear();
}

});

parcelRegister("evnLY", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $a8f666b991a242a0$var$read,
    write: $a8f666b991a242a0$var$write,
    each: $a8f666b991a242a0$var$each,
    remove: $a8f666b991a242a0$var$remove,
    clearAll: $a8f666b991a242a0$var$clearAll
};
var $a8f666b991a242a0$var$memoryStorage = {};
function $a8f666b991a242a0$var$read(key) {
    return $a8f666b991a242a0$var$memoryStorage[key];
}
function $a8f666b991a242a0$var$write(key, data) {
    $a8f666b991a242a0$var$memoryStorage[key] = data;
}
function $a8f666b991a242a0$var$each(callback) {
    for(var key in $a8f666b991a242a0$var$memoryStorage)if ($a8f666b991a242a0$var$memoryStorage.hasOwnProperty(key)) callback($a8f666b991a242a0$var$memoryStorage[key], key);
}
function $a8f666b991a242a0$var$remove(key) {
    delete $a8f666b991a242a0$var$memoryStorage[key];
}
function $a8f666b991a242a0$var$clearAll(key) {
    $a8f666b991a242a0$var$memoryStorage = {};
}

});

parcelRegister("6s9tW", function(module, exports) {
module.exports = $4b2cb67f5ed4c102$var$json2Plugin;

function $4b2cb67f5ed4c102$var$json2Plugin() {
    (parcelRequire("70jIm"));
    return {};
}

});
parcelRegister("70jIm", function(module, exports) {
/* eslint-disable */ //  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html
//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.
//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.
//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.
//          For example, this would serialize Dates as ISO strings.
//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };
//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.
//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.
//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.
//          JSON.stringify(undefined) returns undefined.
//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.
//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.
//          Example:
//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'
//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'
//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.
//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.
//          Example:
//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.
//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });
//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });
//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.
/*jslint
    eval, for, this
*/ /*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
if (typeof JSON !== "object") JSON = {};
(function() {
    "use strict";
    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    }
    function this_value() {
        return this.valueOf();
    }
    if (typeof Date.prototype.toJSON !== "function") {
        Date.prototype.toJSON = function() {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
        };
        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }
    var gap;
    var indent;
    var meta;
    var rep;
    function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string) ? "\"" + string.replace(rx_escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + "\"" : "\"" + string + "\"";
    }
    function str(key, holder) {
        // Produce a string from holder[key].
        var i; // The loop counter.
        var k; // The member key.
        var v; // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value){
            case "string":
                return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce "null". The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is "object", we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is "object",
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else {
                    // Otherwise, iterate through all of the keys in the object.
                    for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                }
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof JSON.stringify !== "function") {
        meta = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function(value, replacer, space) {
            // The stringify method takes a value and an optional replacer, and an optional
            // space parameter, and returns a JSON text. The replacer can be a function
            // that can replace values, or an array of strings that will select the keys.
            // A default replacer method can be provided. Use of the space parameter can
            // produce text that is more easily readable.
            var i;
            gap = "";
            indent = "";
            // If the space parameter is a number, make an indent string containing that
            // many spaces.
            if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
            else if (typeof space === "string") indent = space;
            // If there is a replacer, it must be a function or an array.
            // Otherwise, throw an error.
            rep = replacer;
            if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
            // Make a fake root object containing our value under the key of "".
            // Return the result of stringifying the value.
            return str("", {
                "": value
            });
        };
    }
    // If the JSON object does not yet have a parse method, give it one.
    if (typeof JSON.parse !== "function") JSON.parse = function(text, reviver) {
        // The parse method takes a text and an optional reviver function, and returns
        // a JavaScript value if the text is a valid JSON text.
        var j;
        function walk(holder, key) {
            // The walk method is used to recursively walk the resulting structure so
            // that modifications can be made.
            var k;
            var v;
            var value = holder[key];
            if (value && typeof value === "object") {
                for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                    v = walk(value, k);
                    if (v !== undefined) value[k] = v;
                    else delete value[k];
                }
            }
            return reviver.call(holder, key, value);
        }
        // Parsing happens in four stages. In the first stage, we replace certain
        // Unicode characters with escape sequences. JavaScript handles many characters
        // incorrectly, either silently deleting them, or treating them as line endings.
        text = String(text);
        rx_dangerous.lastIndex = 0;
        if (rx_dangerous.test(text)) text = text.replace(rx_dangerous, function(a) {
            return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        });
        // In the second stage, we run the text against regular expressions that look
        // for non-JSON patterns. We are especially concerned with "()" and "new"
        // because they can cause invocation, and "=" because it can cause mutation.
        // But just to be safe, we want to reject all unexpected forms.
        // We split the second stage into 4 regexp operations in order to work around
        // crippling inefficiencies in IE's and Safari's regexp engines. First we
        // replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
        // replace all simple value tokens with "]" characters. Third, we delete all
        // open brackets that follow a colon or comma or that begin the text. Finally,
        // we look to see that the remaining characters are only whitespace or "]" or
        // "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
        if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
            // In the third stage we use the eval function to compile the text into a
            // JavaScript structure. The "{" operator is subject to a syntactic ambiguity
            // in JavaScript: it can begin a block or an object literal. We wrap the text
            // in parens to eliminate the ambiguity.
            j = eval("(" + text + ")");
            // In the optional fourth stage, we recursively walk the new structure, passing
            // each name/value pair to a reviver function for possible transformation.
            return typeof reviver === "function" ? walk({
                "": j
            }, "") : j;
        }
        // If the text is not JSON parseable, then a SyntaxError is thrown.
        throw new SyntaxError("JSON.parse");
    };
})();

});


parcelRegister("7lXH1", function(module, exports) {

var $98IaM = parcelRequire("98IaM");
var $55a8cc56a2378350$require$Buffer = $98IaM.Buffer;

var $17tgv = parcelRequire("17tgv");







/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(this, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.LinkTarget = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.addLinkAttributes = addLinkAttributes;
                exports.deprecated = deprecated;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _base_factory = __w_pdfjs_require__(135);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
                var SVG_NS = "http://www.w3.org/2000/svg";
                var PixelsPerInch = {
                    CSS: 96.0,
                    PDF: 72.0,
                    get PDF_TO_CSS_UNITS () {
                        return (0, _util.shadow)(this, "PDF_TO_CSS_UNITS", this.CSS / this.PDF);
                    }
                };
                exports.PixelsPerInch = PixelsPerInch;
                var DOMCanvasFactory = /*#__PURE__*/ function(_BaseCanvasFactory) {
                    _inherits(DOMCanvasFactory, _BaseCanvasFactory);
                    var _super = _createSuper(DOMCanvasFactory);
                    function DOMCanvasFactory() {
                        var _this;
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$ownerDocument = _ref.ownerDocument, ownerDocument = _ref$ownerDocument === void 0 ? globalThis.document : _ref$ownerDocument;
                        _classCallCheck(this, DOMCanvasFactory);
                        _this = _super.call(this);
                        _this._document = ownerDocument;
                        return _this;
                    }
                    _createClass(DOMCanvasFactory, [
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                var canvas = this._document.createElement("canvas");
                                canvas.width = width;
                                canvas.height = height;
                                return canvas;
                            }
                        }
                    ]);
                    return DOMCanvasFactory;
                }(_base_factory.BaseCanvasFactory);
                exports.DOMCanvasFactory = DOMCanvasFactory;
                function fetchData(_x) {
                    return _fetchData.apply(this, arguments);
                }
                function _fetchData() {
                    _fetchData = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(url) {
                        var asTypedArray, response, _args = arguments;
                        return _regenerator["default"].wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    asTypedArray = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                                    if (!isValidFetchUrl(url, document.baseURI)) {
                                        _context.next = 21;
                                        break;
                                    }
                                    _context.next = 4;
                                    return fetch(url);
                                case 4:
                                    response = _context.sent;
                                    if (response.ok) {
                                        _context.next = 7;
                                        break;
                                    }
                                    throw new Error(response.statusText);
                                case 7:
                                    if (!asTypedArray) {
                                        _context.next = 15;
                                        break;
                                    }
                                    _context.t1 = Uint8Array;
                                    _context.next = 11;
                                    return response.arrayBuffer();
                                case 11:
                                    _context.t2 = _context.sent;
                                    _context.t0 = new _context.t1(_context.t2);
                                    _context.next = 20;
                                    break;
                                case 15:
                                    _context.t3 = _util.stringToBytes;
                                    _context.next = 18;
                                    return response.text();
                                case 18:
                                    _context.t4 = _context.sent;
                                    _context.t0 = (0, _context.t3)(_context.t4);
                                case 20:
                                    return _context.abrupt("return", _context.t0);
                                case 21:
                                    return _context.abrupt("return", new Promise(function(resolve, reject) {
                                        var request = new XMLHttpRequest();
                                        request.open("GET", url, true);
                                        if (asTypedArray) request.responseType = "arraybuffer";
                                        request.onreadystatechange = function() {
                                            if (request.readyState !== XMLHttpRequest.DONE) return;
                                            if (request.status === 200 || request.status === 0) {
                                                var data;
                                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                                if (data) {
                                                    resolve(data);
                                                    return;
                                                }
                                            }
                                            reject(new Error(request.statusText));
                                        };
                                        request.send(null);
                                    }));
                                case 22:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return _fetchData.apply(this, arguments);
                }
                var DOMCMapReaderFactory = /*#__PURE__*/ function(_BaseCMapReaderFactor) {
                    _inherits(DOMCMapReaderFactory, _BaseCMapReaderFactor);
                    var _super2 = _createSuper(DOMCMapReaderFactory);
                    function DOMCMapReaderFactory() {
                        _classCallCheck(this, DOMCMapReaderFactory);
                        return _super2.apply(this, arguments);
                    }
                    _createClass(DOMCMapReaderFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                return fetchData(url, this.isCompressed).then(function(data) {
                                    return {
                                        cMapData: data,
                                        compressionType: compressionType
                                    };
                                });
                            }
                        }
                    ]);
                    return DOMCMapReaderFactory;
                }(_base_factory.BaseCMapReaderFactory);
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                var DOMStandardFontDataFactory = /*#__PURE__*/ function(_BaseStandardFontData) {
                    _inherits(DOMStandardFontDataFactory, _BaseStandardFontData);
                    var _super3 = _createSuper(DOMStandardFontDataFactory);
                    function DOMStandardFontDataFactory() {
                        _classCallCheck(this, DOMStandardFontDataFactory);
                        return _super3.apply(this, arguments);
                    }
                    _createClass(DOMStandardFontDataFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                return fetchData(url, true);
                            }
                        }
                    ]);
                    return DOMStandardFontDataFactory;
                }(_base_factory.BaseStandardFontDataFactory);
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                var DOMSVGFactory = /*#__PURE__*/ function(_BaseSVGFactory) {
                    _inherits(DOMSVGFactory, _BaseSVGFactory);
                    var _super4 = _createSuper(DOMSVGFactory);
                    function DOMSVGFactory() {
                        _classCallCheck(this, DOMSVGFactory);
                        return _super4.apply(this, arguments);
                    }
                    _createClass(DOMSVGFactory, [
                        {
                            key: "_createSVG",
                            value: function _createSVG(type) {
                                return document.createElementNS(SVG_NS, type);
                            }
                        }
                    ]);
                    return DOMSVGFactory;
                }(_base_factory.BaseSVGFactory);
                exports.DOMSVGFactory = DOMSVGFactory;
                var PageViewport = /*#__PURE__*/ function() {
                    function PageViewport(_ref2) {
                        var viewBox = _ref2.viewBox, scale = _ref2.scale, rotation = _ref2.rotation, _ref2$offsetX = _ref2.offsetX, offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX, _ref2$offsetY = _ref2.offsetY, offsetY = _ref2$offsetY === void 0 ? 0 : _ref2$offsetY, _ref2$dontFlip = _ref2.dontFlip, dontFlip = _ref2$dontFlip === void 0 ? false : _ref2$dontFlip;
                        _classCallCheck(this, PageViewport);
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        var centerX = (viewBox[2] + viewBox[0]) / 2;
                        var centerY = (viewBox[3] + viewBox[1]) / 2;
                        var rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        var offsetCanvasX, offsetCanvasY;
                        var width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = Math.abs(viewBox[3] - viewBox[1]) * scale;
                            height = Math.abs(viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = Math.abs(viewBox[2] - viewBox[0]) * scale;
                            height = Math.abs(viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    _createClass(PageViewport, [
                        {
                            key: "clone",
                            value: function clone() {
                                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$scale = _ref3.scale, scale = _ref3$scale === void 0 ? this.scale : _ref3$scale, _ref3$rotation = _ref3.rotation, rotation = _ref3$rotation === void 0 ? this.rotation : _ref3$rotation, _ref3$offsetX = _ref3.offsetX, offsetX = _ref3$offsetX === void 0 ? this.offsetX : _ref3$offsetX, _ref3$offsetY = _ref3.offsetY, offsetY = _ref3$offsetY === void 0 ? this.offsetY : _ref3$offsetY, _ref3$dontFlip = _ref3.dontFlip, dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
                                return new PageViewport({
                                    viewBox: this.viewBox.slice(),
                                    scale: scale,
                                    rotation: rotation,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    dontFlip: dontFlip
                                });
                            }
                        },
                        {
                            key: "convertToViewportPoint",
                            value: function convertToViewportPoint(x, y) {
                                return _util.Util.applyTransform([
                                    x,
                                    y
                                ], this.transform);
                            }
                        },
                        {
                            key: "convertToViewportRectangle",
                            value: function convertToViewportRectangle(rect) {
                                var topLeft = _util.Util.applyTransform([
                                    rect[0],
                                    rect[1]
                                ], this.transform);
                                var bottomRight = _util.Util.applyTransform([
                                    rect[2],
                                    rect[3]
                                ], this.transform);
                                return [
                                    topLeft[0],
                                    topLeft[1],
                                    bottomRight[0],
                                    bottomRight[1]
                                ];
                            }
                        },
                        {
                            key: "convertToPdfPoint",
                            value: function convertToPdfPoint(x, y) {
                                return _util.Util.applyInverseTransform([
                                    x,
                                    y
                                ], this.transform);
                            }
                        }
                    ]);
                    return PageViewport;
                }();
                exports.PageViewport = PageViewport;
                var RenderingCancelledException = /*#__PURE__*/ function(_BaseException) {
                    _inherits(RenderingCancelledException, _BaseException);
                    var _super5 = _createSuper(RenderingCancelledException);
                    function RenderingCancelledException(msg, type) {
                        var _this2;
                        _classCallCheck(this, RenderingCancelledException);
                        _this2 = _super5.call(this, msg, "RenderingCancelledException");
                        _this2.type = type;
                        return _this2;
                    }
                    return RenderingCancelledException;
                }(_util.BaseException);
                exports.RenderingCancelledException = RenderingCancelledException;
                var LinkTarget = {
                    NONE: 0,
                    SELF: 1,
                    BLANK: 2,
                    PARENT: 3,
                    TOP: 4
                };
                exports.LinkTarget = LinkTarget;
                function addLinkAttributes(link) {
                    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, url = _ref4.url, target = _ref4.target, rel = _ref4.rel, _ref4$enabled = _ref4.enabled, enabled = _ref4$enabled === void 0 ? true : _ref4$enabled;
                    (0, _util.assert)(url && typeof url === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
                    var urlNullRemoved = (0, _util.removeNullCharacters)(url);
                    if (enabled) link.href = link.title = urlNullRemoved;
                    else {
                        link.href = "";
                        link.title = "Disabled: ".concat(urlNullRemoved);
                        link.onclick = function() {
                            return false;
                        };
                    }
                    var targetStr = "";
                    switch(target){
                        case LinkTarget.NONE:
                            break;
                        case LinkTarget.SELF:
                            targetStr = "_self";
                            break;
                        case LinkTarget.BLANK:
                            targetStr = "_blank";
                            break;
                        case LinkTarget.PARENT:
                            targetStr = "_parent";
                            break;
                        case LinkTarget.TOP:
                            targetStr = "_top";
                            break;
                    }
                    link.target = targetStr;
                    link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
                }
                function isDataScheme(url) {
                    var ii = url.length;
                    var i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url) {
                    var anchor = url.indexOf("#");
                    var query = url.indexOf("?");
                    var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
                    return url.substring(url.lastIndexOf("/", end) + 1, end);
                }
                function getPdfFilenameFromUrl(url) {
                    var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "document.pdf";
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    var splitURI = reURI.exec(url);
                    var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch (ex) {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                var StatTimer = /*#__PURE__*/ function() {
                    function StatTimer() {
                        _classCallCheck(this, StatTimer);
                        this.started = Object.create(null);
                        this.times = [];
                    }
                    _createClass(StatTimer, [
                        {
                            key: "time",
                            value: function time(name) {
                                if (name in this.started) (0, _util.warn)("Timer is already running for ".concat(name));
                                this.started[name] = Date.now();
                            }
                        },
                        {
                            key: "timeEnd",
                            value: function timeEnd(name) {
                                if (!(name in this.started)) (0, _util.warn)("Timer has not been started for ".concat(name));
                                this.times.push({
                                    name: name,
                                    start: this.started[name],
                                    end: Date.now()
                                });
                                delete this.started[name];
                            }
                        },
                        {
                            key: "toString",
                            value: function toString() {
                                var outBuf = [];
                                var longest = 0;
                                var _iterator = _createForOfIteratorHelper(this.times), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var time = _step.value;
                                        var name = time.name;
                                        if (name.length > longest) longest = name.length;
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                var _iterator2 = _createForOfIteratorHelper(this.times), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var _time = _step2.value;
                                        var duration = _time.end - _time.start;
                                        outBuf.push("".concat(_time.name.padEnd(longest), " ").concat(duration, "ms\n"));
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                return outBuf.join("");
                            }
                        }
                    ]);
                    return StatTimer;
                }();
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        var _ref5 = baseUrl ? new URL(url, baseUrl) : new URL(url), protocol = _ref5.protocol;
                        return protocol === "http:" || protocol === "https:";
                    } catch (ex) {
                        return false;
                    }
                }
                function loadScript(src) {
                    var removeScriptElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    return new Promise(function(resolve, reject) {
                        var script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error("Cannot load script at: ".concat(script.src)));
                        };
                        (document.head || document.documentElement).appendChild(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                var pdfDateStringRegex;
                var PDFDateString = /*#__PURE__*/ function() {
                    function PDFDateString() {
                        _classCallCheck(this, PDFDateString);
                    }
                    _createClass(PDFDateString, null, [
                        {
                            key: "toDateObject",
                            value: function toDateObject(input) {
                                if (!input || !(0, _util.isString)(input)) return null;
                                if (!pdfDateStringRegex) pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                                var matches = pdfDateStringRegex.exec(input);
                                if (!matches) return null;
                                var year = parseInt(matches[1], 10);
                                var month = parseInt(matches[2], 10);
                                month = month >= 1 && month <= 12 ? month - 1 : 0;
                                var day = parseInt(matches[3], 10);
                                day = day >= 1 && day <= 31 ? day : 1;
                                var hour = parseInt(matches[4], 10);
                                hour = hour >= 0 && hour <= 23 ? hour : 0;
                                var minute = parseInt(matches[5], 10);
                                minute = minute >= 0 && minute <= 59 ? minute : 0;
                                var second = parseInt(matches[6], 10);
                                second = second >= 0 && second <= 59 ? second : 0;
                                var universalTimeRelation = matches[7] || "Z";
                                var offsetHour = parseInt(matches[8], 10);
                                offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                                var offsetMinute = parseInt(matches[9], 10) || 0;
                                offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                                if (universalTimeRelation === "-") {
                                    hour += offsetHour;
                                    minute += offsetMinute;
                                } else if (universalTimeRelation === "+") {
                                    hour -= offsetHour;
                                    minute -= offsetMinute;
                                }
                                return new Date(Date.UTC(year, month, day, hour, minute, second));
                            }
                        }
                    ]);
                    return PDFDateString;
                }();
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, _ref6) {
                    var _ref6$scale = _ref6.scale, scale = _ref6$scale === void 0 ? 1 : _ref6$scale, _ref6$rotation = _ref6.rotation, rotation = _ref6$rotation === void 0 ? 0 : _ref6$rotation;
                    var _xfaPage$attributes$s = xfaPage.attributes.style, width = _xfaPage$attributes$s.width, height = _xfaPage$attributes$s.height;
                    var viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
            /***/ },
            /* 2 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                module1.exports = __w_pdfjs_require__(3);
            /***/ },
            /* 3 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                /* module decorator */ module1 = __w_pdfjs_require__.nmd(module1);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var runtime = function(exports) {
                    "use strict";
                    var Op = Object.prototype;
                    var hasOwn = Op.hasOwnProperty;
                    var undefined1;
                    var $Symbol = typeof Symbol === "function" ? Symbol : {};
                    var iteratorSymbol = $Symbol.iterator || "@@iterator";
                    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
                    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
                    function define(obj, key, value) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true
                        });
                        return obj[key];
                    }
                    try {
                        define({}, "");
                    } catch (err) {
                        define = function define(obj, key, value) {
                            return obj[key] = value;
                        };
                    }
                    function wrap(innerFn, outerFn, self1, tryLocsList) {
                        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                        var generator = Object.create(protoGenerator.prototype);
                        var context = new Context(tryLocsList || []);
                        generator._invoke = makeInvokeMethod(innerFn, self1, context);
                        return generator;
                    }
                    exports.wrap = wrap;
                    function tryCatch(fn, obj, arg) {
                        try {
                            return {
                                type: "normal",
                                arg: fn.call(obj, arg)
                            };
                        } catch (err) {
                            return {
                                type: "throw",
                                arg: err
                            };
                        }
                    }
                    var GenStateSuspendedStart = "suspendedStart";
                    var GenStateSuspendedYield = "suspendedYield";
                    var GenStateExecuting = "executing";
                    var GenStateCompleted = "completed";
                    var ContinueSentinel = {};
                    function Generator() {}
                    function GeneratorFunction() {}
                    function GeneratorFunctionPrototype() {}
                    var IteratorPrototype = {};
                    define(IteratorPrototype, iteratorSymbol, function() {
                        return this;
                    });
                    var getProto = Object.getPrototypeOf;
                    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) IteratorPrototype = NativeIteratorPrototype;
                    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
                    GeneratorFunction.prototype = GeneratorFunctionPrototype;
                    define(Gp, "constructor", GeneratorFunctionPrototype);
                    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
                    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
                    function defineIteratorMethods(prototype) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(method) {
                            define(prototype, method, function(arg) {
                                return this._invoke(method, arg);
                            });
                        });
                    }
                    exports.isGeneratorFunction = function(genFun) {
                        var ctor = typeof genFun === "function" && genFun.constructor;
                        return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
                    };
                    exports.mark = function(genFun) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                        else {
                            genFun.__proto__ = GeneratorFunctionPrototype;
                            define(genFun, toStringTagSymbol, "GeneratorFunction");
                        }
                        genFun.prototype = Object.create(Gp);
                        return genFun;
                    };
                    exports.awrap = function(arg) {
                        return {
                            __await: arg
                        };
                    };
                    function AsyncIterator(generator, PromiseImpl) {
                        function invoke(method, arg, resolve, reject) {
                            var record = tryCatch(generator[method], generator, arg);
                            if (record.type === "throw") reject(record.arg);
                            else {
                                var result = record.arg;
                                var value = result.value;
                                if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                                    invoke("next", value, resolve, reject);
                                }, function(err) {
                                    invoke("throw", err, resolve, reject);
                                });
                                return PromiseImpl.resolve(value).then(function(unwrapped) {
                                    result.value = unwrapped;
                                    resolve(result);
                                }, function(error) {
                                    return invoke("throw", error, resolve, reject);
                                });
                            }
                        }
                        var previousPromise;
                        function enqueue(method, arg) {
                            function callInvokeWithMethodAndArg() {
                                return new PromiseImpl(function(resolve, reject) {
                                    invoke(method, arg, resolve, reject);
                                });
                            }
                            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                        }
                        this._invoke = enqueue;
                    }
                    defineIteratorMethods(AsyncIterator.prototype);
                    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
                        return this;
                    });
                    exports.AsyncIterator = AsyncIterator;
                    exports.async = function(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
                        if (PromiseImpl === void 0) PromiseImpl = Promise;
                        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
                        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
                            return result.done ? result.value : iter.next();
                        });
                    };
                    function makeInvokeMethod(innerFn, self1, context) {
                        var state = GenStateSuspendedStart;
                        return function invoke(method, arg) {
                            if (state === GenStateExecuting) throw new Error("Generator is already running");
                            if (state === GenStateCompleted) {
                                if (method === "throw") throw arg;
                                return doneResult();
                            }
                            context.method = method;
                            context.arg = arg;
                            while(true){
                                var delegate = context.delegate;
                                if (delegate) {
                                    var delegateResult = maybeInvokeDelegate(delegate, context);
                                    if (delegateResult) {
                                        if (delegateResult === ContinueSentinel) continue;
                                        return delegateResult;
                                    }
                                }
                                if (context.method === "next") context.sent = context._sent = context.arg;
                                else if (context.method === "throw") {
                                    if (state === GenStateSuspendedStart) {
                                        state = GenStateCompleted;
                                        throw context.arg;
                                    }
                                    context.dispatchException(context.arg);
                                } else if (context.method === "return") context.abrupt("return", context.arg);
                                state = GenStateExecuting;
                                var record = tryCatch(innerFn, self1, context);
                                if (record.type === "normal") {
                                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                                    if (record.arg === ContinueSentinel) continue;
                                    return {
                                        value: record.arg,
                                        done: context.done
                                    };
                                } else if (record.type === "throw") {
                                    state = GenStateCompleted;
                                    context.method = "throw";
                                    context.arg = record.arg;
                                }
                            }
                        };
                    }
                    function maybeInvokeDelegate(delegate, context) {
                        var method = delegate.iterator[context.method];
                        if (method === undefined1) {
                            context.delegate = null;
                            if (context.method === "throw") {
                                if (delegate.iterator["return"]) {
                                    context.method = "return";
                                    context.arg = undefined1;
                                    maybeInvokeDelegate(delegate, context);
                                    if (context.method === "throw") return ContinueSentinel;
                                }
                                context.method = "throw";
                                context.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return ContinueSentinel;
                        }
                        var record = tryCatch(method, delegate.iterator, context.arg);
                        if (record.type === "throw") {
                            context.method = "throw";
                            context.arg = record.arg;
                            context.delegate = null;
                            return ContinueSentinel;
                        }
                        var info = record.arg;
                        if (!info) {
                            context.method = "throw";
                            context.arg = new TypeError("iterator result is not an object");
                            context.delegate = null;
                            return ContinueSentinel;
                        }
                        if (info.done) {
                            context[delegate.resultName] = info.value;
                            context.next = delegate.nextLoc;
                            if (context.method !== "return") {
                                context.method = "next";
                                context.arg = undefined1;
                            }
                        } else return info;
                        context.delegate = null;
                        return ContinueSentinel;
                    }
                    defineIteratorMethods(Gp);
                    define(Gp, toStringTagSymbol, "Generator");
                    define(Gp, iteratorSymbol, function() {
                        return this;
                    });
                    define(Gp, "toString", function() {
                        return "[object Generator]";
                    });
                    function pushTryEntry(locs) {
                        var entry = {
                            tryLoc: locs[0]
                        };
                        if (1 in locs) entry.catchLoc = locs[1];
                        if (2 in locs) {
                            entry.finallyLoc = locs[2];
                            entry.afterLoc = locs[3];
                        }
                        this.tryEntries.push(entry);
                    }
                    function resetTryEntry(entry) {
                        var record = entry.completion || {};
                        record.type = "normal";
                        delete record.arg;
                        entry.completion = record;
                    }
                    function Context(tryLocsList) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ];
                        tryLocsList.forEach(pushTryEntry, this);
                        this.reset(true);
                    }
                    exports.keys = function(object) {
                        var keys = [];
                        for(var key in object)keys.push(key);
                        keys.reverse();
                        return function next() {
                            while(keys.length){
                                var key = keys.pop();
                                if (key in object) {
                                    next.value = key;
                                    next.done = false;
                                    return next;
                                }
                            }
                            next.done = true;
                            return next;
                        };
                    };
                    function values(iterable) {
                        if (iterable) {
                            var iteratorMethod = iterable[iteratorSymbol];
                            if (iteratorMethod) return iteratorMethod.call(iterable);
                            if (typeof iterable.next === "function") return iterable;
                            if (!isNaN(iterable.length)) {
                                var i = -1, next = function next() {
                                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                                        next.value = iterable[i];
                                        next.done = false;
                                        return next;
                                    }
                                    next.value = undefined1;
                                    next.done = true;
                                    return next;
                                };
                                return next.next = next;
                            }
                        }
                        return {
                            next: doneResult
                        };
                    }
                    exports.values = values;
                    function doneResult() {
                        return {
                            value: undefined1,
                            done: true
                        };
                    }
                    Context.prototype = {
                        constructor: Context,
                        reset: function reset(skipTempReset) {
                            this.prev = 0;
                            this.next = 0;
                            this.sent = this._sent = undefined1;
                            this.done = false;
                            this.delegate = null;
                            this.method = "next";
                            this.arg = undefined1;
                            this.tryEntries.forEach(resetTryEntry);
                            if (!skipTempReset) {
                                for(var name in this)if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined1;
                            }
                        },
                        stop: function stop() {
                            this.done = true;
                            var rootEntry = this.tryEntries[0];
                            var rootRecord = rootEntry.completion;
                            if (rootRecord.type === "throw") throw rootRecord.arg;
                            return this.rval;
                        },
                        dispatchException: function dispatchException(exception) {
                            if (this.done) throw exception;
                            var context = this;
                            function handle(loc, caught) {
                                record.type = "throw";
                                record.arg = exception;
                                context.next = loc;
                                if (caught) {
                                    context.method = "next";
                                    context.arg = undefined1;
                                }
                                return !!caught;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                var record = entry.completion;
                                if (entry.tryLoc === "root") return handle("end");
                                if (entry.tryLoc <= this.prev) {
                                    var hasCatch = hasOwn.call(entry, "catchLoc");
                                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                                    if (hasCatch && hasFinally) {
                                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                    } else if (hasCatch) {
                                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                                    } else if (hasFinally) {
                                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                    } else throw new Error("try statement without catch or finally");
                                }
                            }
                        },
                        abrupt: function abrupt(type, arg) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                                    var finallyEntry = entry;
                                    break;
                                }
                            }
                            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) finallyEntry = null;
                            var record = finallyEntry ? finallyEntry.completion : {};
                            record.type = type;
                            record.arg = arg;
                            if (finallyEntry) {
                                this.method = "next";
                                this.next = finallyEntry.finallyLoc;
                                return ContinueSentinel;
                            }
                            return this.complete(record);
                        },
                        complete: function complete(record, afterLoc) {
                            if (record.type === "throw") throw record.arg;
                            if (record.type === "break" || record.type === "continue") this.next = record.arg;
                            else if (record.type === "return") {
                                this.rval = this.arg = record.arg;
                                this.method = "return";
                                this.next = "end";
                            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
                            return ContinueSentinel;
                        },
                        finish: function finish(finallyLoc) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.finallyLoc === finallyLoc) {
                                    this.complete(entry.completion, entry.afterLoc);
                                    resetTryEntry(entry);
                                    return ContinueSentinel;
                                }
                            }
                        },
                        "catch": function _catch(tryLoc) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.tryLoc === tryLoc) {
                                    var record = entry.completion;
                                    if (record.type === "throw") {
                                        var thrown = record.arg;
                                        resetTryEntry(entry);
                                    }
                                    return thrown;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                            this.delegate = {
                                iterator: values(iterable),
                                resultName: resultName,
                                nextLoc: nextLoc
                            };
                            if (this.method === "next") this.arg = undefined1;
                            return ContinueSentinel;
                        }
                    };
                    return exports;
                }(_typeof(module1) === "object" ? module1.exports : {});
                try {
                    regeneratorRuntime = runtime;
                } catch (accidentalStrictMode) {
                    if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") globalThis.regeneratorRuntime = runtime;
                    else Function("r", "regeneratorRuntime = r")(runtime);
                }
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.UNSUPPORTED_FEATURES = exports.TextRenderingMode = exports.StreamType = exports.RenderingIntentFlag = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.IsLittleEndianCached = exports.IsEvalSupportedCached = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FontType = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.AnnotationType = exports.AnnotationStateModelType = exports.AnnotationReviewState = exports.AnnotationReplyType = exports.AnnotationMode = exports.AnnotationMarkedState = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.arrayByteLength = arrayByteLength;
                exports.arraysToBytes = arraysToBytes;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createObjectURL = createObjectURL;
                exports.createPromiseCapability = createPromiseCapability;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.escapeString = escapeString;
                exports.getModificationDate = getModificationDate;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isAscii = isAscii;
                exports.isBool = isBool;
                exports.isNum = isNum;
                exports.isSameOrigin = isSameOrigin;
                exports.isString = isString;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.removeNullCharacters = removeNullCharacters;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF16BEString = stringToUTF16BEString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                __w_pdfjs_require__(5);
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                var FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                var RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                var AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                var PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                var TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                var ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                var AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                var AnnotationStateModelType = {
                    MARKED: "Marked",
                    REVIEW: "Review"
                };
                exports.AnnotationStateModelType = AnnotationStateModelType;
                var AnnotationMarkedState = {
                    MARKED: "Marked",
                    UNMARKED: "Unmarked"
                };
                exports.AnnotationMarkedState = AnnotationMarkedState;
                var AnnotationReviewState = {
                    ACCEPTED: "Accepted",
                    REJECTED: "Rejected",
                    CANCELLED: "Cancelled",
                    COMPLETED: "Completed",
                    NONE: "None"
                };
                exports.AnnotationReviewState = AnnotationReviewState;
                var AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                var AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                var AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                var AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                var AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                var DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                var PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                var StreamType = {
                    UNKNOWN: "UNKNOWN",
                    FLATE: "FLATE",
                    LZW: "LZW",
                    DCT: "DCT",
                    JPX: "JPX",
                    JBIG: "JBIG",
                    A85: "A85",
                    AHX: "AHX",
                    CCF: "CCF",
                    RLX: "RLX"
                };
                exports.StreamType = StreamType;
                var FontType = {
                    UNKNOWN: "UNKNOWN",
                    TYPE1: "TYPE1",
                    TYPE1STANDARD: "TYPE1STANDARD",
                    TYPE1C: "TYPE1C",
                    CIDFONTTYPE0: "CIDFONTTYPE0",
                    CIDFONTTYPE0C: "CIDFONTTYPE0C",
                    TRUETYPE: "TRUETYPE",
                    CIDFONTTYPE2: "CIDFONTTYPE2",
                    TYPE3: "TYPE3",
                    OPENTYPE: "OPENTYPE",
                    TYPE0: "TYPE0",
                    MMTYPE1: "MMTYPE1"
                };
                exports.FontType = FontType;
                var VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                var CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1,
                    STREAM: 2
                };
                exports.CMapCompressionType = CMapCompressionType;
                var OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotations: 78,
                    endAnnotations: 79,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintJpegXObject: 82,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                var UNSUPPORTED_FEATURES = {
                    unknown: "unknown",
                    forms: "forms",
                    javaScript: "javaScript",
                    signatures: "signatures",
                    smask: "smask",
                    shadingPattern: "shadingPattern",
                    font: "font",
                    errorTilingPattern: "errorTilingPattern",
                    errorExtGState: "errorExtGState",
                    errorXObject: "errorXObject",
                    errorFontLoadType3: "errorFontLoadType3",
                    errorFontState: "errorFontState",
                    errorFontMissing: "errorFontMissing",
                    errorFontTranslate: "errorFontTranslate",
                    errorColorSpace: "errorColorSpace",
                    errorOperatorList: "errorOperatorList",
                    errorFontToUnicode: "errorFontToUnicode",
                    errorFontLoadNative: "errorFontLoadNative",
                    errorFontBuildPath: "errorFontBuildPath",
                    errorFontGetPath: "errorFontGetPath",
                    errorMarkedContent: "errorMarkedContent",
                    errorContentSubStream: "errorContentSubStream"
                };
                exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
                var PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                var verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log("Info: ".concat(msg));
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log("Warning: ".concat(msg));
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function isSameOrigin(baseUrl, otherUrl) {
                    var base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch (e) {
                        return false;
                    }
                    var other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                }
                function _isValidProtocol(url) {
                    if (!url) return false;
                    switch(url.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url) {
                    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                var dots = url.match(/\./g);
                                if (dots && dots.length >= 2) url = "http://".concat(url);
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch (ex) {}
                        }
                        var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch (ex) {}
                    return null;
                }
                function shadow(obj, prop, value) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                var BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                var PasswordException = /*#__PURE__*/ function(_BaseException) {
                    _inherits(PasswordException, _BaseException);
                    var _super = _createSuper(PasswordException);
                    function PasswordException(msg, code) {
                        var _this;
                        _classCallCheck(this, PasswordException);
                        _this = _super.call(this, msg, "PasswordException");
                        _this.code = code;
                        return _this;
                    }
                    return PasswordException;
                }(BaseException);
                exports.PasswordException = PasswordException;
                var UnknownErrorException = /*#__PURE__*/ function(_BaseException2) {
                    _inherits(UnknownErrorException, _BaseException2);
                    var _super2 = _createSuper(UnknownErrorException);
                    function UnknownErrorException(msg, details) {
                        var _this2;
                        _classCallCheck(this, UnknownErrorException);
                        _this2 = _super2.call(this, msg, "UnknownErrorException");
                        _this2.details = details;
                        return _this2;
                    }
                    return UnknownErrorException;
                }(BaseException);
                exports.UnknownErrorException = UnknownErrorException;
                var InvalidPDFException = /*#__PURE__*/ function(_BaseException3) {
                    _inherits(InvalidPDFException, _BaseException3);
                    var _super3 = _createSuper(InvalidPDFException);
                    function InvalidPDFException(msg) {
                        _classCallCheck(this, InvalidPDFException);
                        return _super3.call(this, msg, "InvalidPDFException");
                    }
                    return InvalidPDFException;
                }(BaseException);
                exports.InvalidPDFException = InvalidPDFException;
                var MissingPDFException = /*#__PURE__*/ function(_BaseException4) {
                    _inherits(MissingPDFException, _BaseException4);
                    var _super4 = _createSuper(MissingPDFException);
                    function MissingPDFException(msg) {
                        _classCallCheck(this, MissingPDFException);
                        return _super4.call(this, msg, "MissingPDFException");
                    }
                    return MissingPDFException;
                }(BaseException);
                exports.MissingPDFException = MissingPDFException;
                var UnexpectedResponseException = /*#__PURE__*/ function(_BaseException5) {
                    _inherits(UnexpectedResponseException, _BaseException5);
                    var _super5 = _createSuper(UnexpectedResponseException);
                    function UnexpectedResponseException(msg, status) {
                        var _this3;
                        _classCallCheck(this, UnexpectedResponseException);
                        _this3 = _super5.call(this, msg, "UnexpectedResponseException");
                        _this3.status = status;
                        return _this3;
                    }
                    return UnexpectedResponseException;
                }(BaseException);
                exports.UnexpectedResponseException = UnexpectedResponseException;
                var FormatError = /*#__PURE__*/ function(_BaseException6) {
                    _inherits(FormatError, _BaseException6);
                    var _super6 = _createSuper(FormatError);
                    function FormatError(msg) {
                        _classCallCheck(this, FormatError);
                        return _super6.call(this, msg, "FormatError");
                    }
                    return FormatError;
                }(BaseException);
                exports.FormatError = FormatError;
                var AbortException = /*#__PURE__*/ function(_BaseException7) {
                    _inherits(AbortException, _BaseException7);
                    var _super7 = _createSuper(AbortException);
                    function AbortException(msg) {
                        _classCallCheck(this, AbortException);
                        return _super7.call(this, msg, "AbortException");
                    }
                    return AbortException;
                }(BaseException);
                exports.AbortException = AbortException;
                var NullCharactersRegExp = /\x00+/g;
                var InvisibleCharactersRegExp = /[\x01-\x1F]/g;
                function removeNullCharacters(str) {
                    var replaceInvisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    if (typeof str !== "string") {
                        warn("The argument for removeNullCharacters must be a string.");
                        return str;
                    }
                    if (replaceInvisible) str = str.replace(InvisibleCharactersRegExp, " ");
                    return str.replace(NullCharactersRegExp, "");
                }
                function bytesToString(bytes) {
                    assert(bytes !== null && _typeof(bytes) === "object" && bytes.length !== undefined, "Invalid argument for bytesToString");
                    var length = bytes.length;
                    var MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    var strBuf = [];
                    for(var i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        var chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    assert(typeof str === "string", "Invalid argument for stringToBytes");
                    var length = str.length;
                    var bytes = new Uint8Array(length);
                    for(var i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function arrayByteLength(arr) {
                    if (arr.length !== undefined) return arr.length;
                    assert(arr.byteLength !== undefined, "arrayByteLength - invalid argument.");
                    return arr.byteLength;
                }
                function arraysToBytes(arr) {
                    var length = arr.length;
                    if (length === 1 && arr[0] instanceof Uint8Array) return arr[0];
                    var resultLength = 0;
                    for(var i = 0; i < length; i++)resultLength += arrayByteLength(arr[i]);
                    var pos = 0;
                    var data = new Uint8Array(resultLength);
                    for(var _i = 0; _i < length; _i++){
                        var item = arr[_i];
                        if (!(item instanceof Uint8Array)) {
                            if (typeof item === "string") item = stringToBytes(item);
                            else item = new Uint8Array(item);
                        }
                        var itemLength = item.byteLength;
                        data.set(item, pos);
                        pos += itemLength;
                    }
                    return data;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    var obj = Object.create(null);
                    var _iterator = _createForOfIteratorHelper(map), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value = _step$value[1];
                            obj[key] = value;
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return obj;
                }
                function isLittleEndian() {
                    var buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    var view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                var IsLittleEndianCached = {
                    get value () {
                        return shadow(this, "value", isLittleEndian());
                    }
                };
                exports.IsLittleEndianCached = IsLittleEndianCached;
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                var IsEvalSupportedCached = {
                    get value () {
                        return shadow(this, "value", isEvalSupported());
                    }
                };
                exports.IsEvalSupportedCached = IsEvalSupportedCached;
                var hexNumbers = _toConsumableArray(Array(256).keys()).map(function(n) {
                    return n.toString(16).padStart(2, "0");
                });
                var Util = /*#__PURE__*/ function() {
                    function Util() {
                        _classCallCheck(this, Util);
                    }
                    _createClass(Util, null, [
                        {
                            key: "makeHexColor",
                            value: function makeHexColor(r, g, b) {
                                return "#".concat(hexNumbers[r]).concat(hexNumbers[g]).concat(hexNumbers[b]);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(m1, m2) {
                                return [
                                    m1[0] * m2[0] + m1[2] * m2[1],
                                    m1[1] * m2[0] + m1[3] * m2[1],
                                    m1[0] * m2[2] + m1[2] * m2[3],
                                    m1[1] * m2[2] + m1[3] * m2[3],
                                    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                                    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                                ];
                            }
                        },
                        {
                            key: "applyTransform",
                            value: function applyTransform(p, m) {
                                var xt = p[0] * m[0] + p[1] * m[2] + m[4];
                                var yt = p[0] * m[1] + p[1] * m[3] + m[5];
                                return [
                                    xt,
                                    yt
                                ];
                            }
                        },
                        {
                            key: "applyInverseTransform",
                            value: function applyInverseTransform(p, m) {
                                var d = m[0] * m[3] - m[1] * m[2];
                                var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                                var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                                return [
                                    xt,
                                    yt
                                ];
                            }
                        },
                        {
                            key: "getAxialAlignedBoundingBox",
                            value: function getAxialAlignedBoundingBox(r, m) {
                                var p1 = Util.applyTransform(r, m);
                                var p2 = Util.applyTransform(r.slice(2, 4), m);
                                var p3 = Util.applyTransform([
                                    r[0],
                                    r[3]
                                ], m);
                                var p4 = Util.applyTransform([
                                    r[2],
                                    r[1]
                                ], m);
                                return [
                                    Math.min(p1[0], p2[0], p3[0], p4[0]),
                                    Math.min(p1[1], p2[1], p3[1], p4[1]),
                                    Math.max(p1[0], p2[0], p3[0], p4[0]),
                                    Math.max(p1[1], p2[1], p3[1], p4[1])
                                ];
                            }
                        },
                        {
                            key: "inverseTransform",
                            value: function inverseTransform(m) {
                                var d = m[0] * m[3] - m[1] * m[2];
                                return [
                                    m[3] / d,
                                    -m[1] / d,
                                    -m[2] / d,
                                    m[0] / d,
                                    (m[2] * m[5] - m[4] * m[3]) / d,
                                    (m[4] * m[1] - m[5] * m[0]) / d
                                ];
                            }
                        },
                        {
                            key: "apply3dTransform",
                            value: function apply3dTransform(m, v) {
                                return [
                                    m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
                                    m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
                                    m[6] * v[0] + m[7] * v[1] + m[8] * v[2]
                                ];
                            }
                        },
                        {
                            key: "singularValueDecompose2dScale",
                            value: function singularValueDecompose2dScale(m) {
                                var transpose = [
                                    m[0],
                                    m[2],
                                    m[1],
                                    m[3]
                                ];
                                var a = m[0] * transpose[0] + m[1] * transpose[2];
                                var b = m[0] * transpose[1] + m[1] * transpose[3];
                                var c = m[2] * transpose[0] + m[3] * transpose[2];
                                var d = m[2] * transpose[1] + m[3] * transpose[3];
                                var first = (a + d) / 2;
                                var second = Math.sqrt(Math.pow(a + d, 2) - 4 * (a * d - c * b)) / 2;
                                var sx = first + second || 1;
                                var sy = first - second || 1;
                                return [
                                    Math.sqrt(sx),
                                    Math.sqrt(sy)
                                ];
                            }
                        },
                        {
                            key: "normalizeRect",
                            value: function normalizeRect(rect) {
                                var r = rect.slice(0);
                                if (rect[0] > rect[2]) {
                                    r[0] = rect[2];
                                    r[2] = rect[0];
                                }
                                if (rect[1] > rect[3]) {
                                    r[1] = rect[3];
                                    r[3] = rect[1];
                                }
                                return r;
                            }
                        },
                        {
                            key: "intersect",
                            value: function intersect(rect1, rect2) {
                                function compare(a, b) {
                                    return a - b;
                                }
                                var orderedX = [
                                    rect1[0],
                                    rect1[2],
                                    rect2[0],
                                    rect2[2]
                                ].sort(compare);
                                var orderedY = [
                                    rect1[1],
                                    rect1[3],
                                    rect2[1],
                                    rect2[3]
                                ].sort(compare);
                                var result = [];
                                rect1 = Util.normalizeRect(rect1);
                                rect2 = Util.normalizeRect(rect2);
                                if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
                                    result[0] = orderedX[1];
                                    result[2] = orderedX[2];
                                } else return null;
                                if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
                                    result[1] = orderedY[1];
                                    result[3] = orderedY[2];
                                } else return null;
                                return result;
                            }
                        },
                        {
                            key: "bezierBoundingBox",
                            value: function bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                                var tvalues = [], bounds = [
                                    [],
                                    []
                                ];
                                var a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                                for(var i = 0; i < 2; ++i){
                                    if (i === 0) {
                                        b = 6 * x0 - 12 * x1 + 6 * x2;
                                        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                        c = 3 * x1 - 3 * x0;
                                    } else {
                                        b = 6 * y0 - 12 * y1 + 6 * y2;
                                        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                        c = 3 * y1 - 3 * y0;
                                    }
                                    if (Math.abs(a) < 1e-12) {
                                        if (Math.abs(b) < 1e-12) continue;
                                        t = -c / b;
                                        if (0 < t && t < 1) tvalues.push(t);
                                        continue;
                                    }
                                    b2ac = b * b - 4 * c * a;
                                    sqrtb2ac = Math.sqrt(b2ac);
                                    if (b2ac < 0) continue;
                                    t1 = (-b + sqrtb2ac) / (2 * a);
                                    if (0 < t1 && t1 < 1) tvalues.push(t1);
                                    t2 = (-b - sqrtb2ac) / (2 * a);
                                    if (0 < t2 && t2 < 1) tvalues.push(t2);
                                }
                                var j = tvalues.length, mt;
                                var jlen = j;
                                while(j--){
                                    t = tvalues[j];
                                    mt = 1 - t;
                                    bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                                    bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                                }
                                bounds[0][jlen] = x0;
                                bounds[1][jlen] = y0;
                                bounds[0][jlen + 1] = x3;
                                bounds[1][jlen + 1] = y3;
                                bounds[0].length = bounds[1].length = jlen + 2;
                                return [
                                    Math.min.apply(Math, _toConsumableArray(bounds[0])),
                                    Math.min.apply(Math, _toConsumableArray(bounds[1])),
                                    Math.max.apply(Math, _toConsumableArray(bounds[0])),
                                    Math.max.apply(Math, _toConsumableArray(bounds[1]))
                                ];
                            }
                        }
                    ]);
                    return Util;
                }();
                exports.Util = Util;
                var PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    var length = str.length, strBuf = [];
                    if (str[0] === "\xFE" && str[1] === "\xFF") for(var i = 2; i < length; i += 2)strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
                    else if (str[0] === "\xFF" && str[1] === "\xFE") for(var _i2 = 2; _i2 < length; _i2 += 2)strBuf.push(String.fromCharCode(str.charCodeAt(_i2 + 1) << 8 | str.charCodeAt(_i2)));
                    else for(var _i3 = 0; _i3 < length; ++_i3){
                        var code = PDFStringTranslateTable[str.charCodeAt(_i3)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(_i3));
                    }
                    return strBuf.join("");
                }
                function escapeString(str) {
                    return str.replace(/([()\\\n\r])/g, function(match) {
                        if (match === "\n") return "\\n";
                        else if (match === "\r") return "\\r";
                        return "\\".concat(match);
                    });
                }
                function isAscii(str) {
                    return /^[\x00-\x7F]*$/.test(str);
                }
                function stringToUTF16BEString(str) {
                    var buf = [
                        "\xFE\xFF"
                    ];
                    for(var i = 0, ii = str.length; i < ii; i++){
                        var _char = str.charCodeAt(i);
                        buf.push(String.fromCharCode(_char >> 8 & 0xff), String.fromCharCode(_char & 0xff));
                    }
                    return buf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isBool(v) {
                    return typeof v === "boolean";
                }
                function isNum(v) {
                    return typeof v === "number";
                }
                function isString(v) {
                    return typeof v === "string";
                }
                function isArrayBuffer(v) {
                    return _typeof(v) === "object" && v !== null && v.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(var i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate() {
                    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
                    var buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                function createPromiseCapability() {
                    var capability = Object.create(null);
                    var isSettled = false;
                    Object.defineProperty(capability, "settled", {
                        get: function get() {
                            return isSettled;
                        }
                    });
                    capability.promise = new Promise(function(resolve, reject) {
                        capability.resolve = function(data) {
                            isSettled = true;
                            resolve(data);
                        };
                        capability.reject = function(reason) {
                            isSettled = true;
                            reject(reason);
                        };
                    });
                    return capability;
                }
                function createObjectURL(data) {
                    var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var buffer = "data:".concat(contentType, ";base64,");
                    for(var i = 0, ii = data.length; i < ii; i += 3){
                        var b1 = data[i] & 0xff;
                        var b2 = data[i + 1] & 0xff;
                        var b3 = data[i + 2] & 0xff;
                        var d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        var d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        var d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var _is_node = __w_pdfjs_require__(6);
                if (typeof globalThis === "undefined" || !globalThis._pdfjsCompatibilityChecked) {
                    if (typeof globalThis === "undefined" || globalThis.Math !== Math) globalThis = __w_pdfjs_require__(7);
                    globalThis._pdfjsCompatibilityChecked = true;
                    (function checkNodeBtoa() {
                        if (globalThis.btoa || !_is_node.isNodeJS) return;
                        globalThis.btoa = function(chars) {
                            return $55a8cc56a2378350$require$Buffer.from(chars, "binary").toString("base64");
                        };
                    })();
                    (function checkNodeAtob() {
                        if (globalThis.atob || !_is_node.isNodeJS) return;
                        globalThis.atob = function(input) {
                            return $55a8cc56a2378350$require$Buffer.from(input, "base64").toString("binary");
                        };
                    })();
                    (function checkDOMMatrix() {
                        if (globalThis.DOMMatrix || !_is_node.isNodeJS) return;
                        globalThis.DOMMatrix = __w_pdfjs_require__(69);
                    })();
                    (function checkObjectFromEntries() {
                        if (Object.fromEntries) return;
                        __w_pdfjs_require__(70);
                    })();
                    (function checkPromise() {
                        if (globalThis.Promise.allSettled) return;
                        globalThis.Promise = __w_pdfjs_require__(97);
                    })();
                    (function checkReadableStream() {
                        if (globalThis.ReadableStream || !_is_node.isNodeJS) return;
                        globalThis.ReadableStream = __w_pdfjs_require__(134).ReadableStream;
                    })();
                }
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isNodeJS = void 0;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var isNodeJS = false;
                exports.isNodeJS = isNodeJS;
            /***/ },
            /* 7 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                __w_pdfjs_require__(8);
                module1.exports = __w_pdfjs_require__(10);
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var $ = __w_pdfjs_require__(9);
                var global1 = __w_pdfjs_require__(10);
                $({
                    global: true
                }, {
                    globalThis: global1
                });
            /***/ },
            /* 9 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var getOwnPropertyDescriptor = __w_pdfjs_require__(11).f;
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var redefine = __w_pdfjs_require__(50);
                var setGlobal = __w_pdfjs_require__(41);
                var copyConstructorProperties = __w_pdfjs_require__(57);
                var isForced = __w_pdfjs_require__(68);
                module1.exports = function(options, source) {
                    var TARGET = options.target;
                    var GLOBAL = options.global;
                    var STATIC = options.stat;
                    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                    if (GLOBAL) target = global1;
                    else if (STATIC) target = global1[TARGET] || setGlobal(TARGET, {});
                    else target = (global1[TARGET] || {}).prototype;
                    if (target) for(key in source){
                        sourceProperty = source[key];
                        if (options.noTargetGet) {
                            descriptor = getOwnPropertyDescriptor(target, key);
                            targetProperty = descriptor && descriptor.value;
                        } else targetProperty = target[key];
                        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                        if (!FORCED && targetProperty !== undefined) {
                            if (typeof sourceProperty == typeof targetProperty) continue;
                            copyConstructorProperties(sourceProperty, targetProperty);
                        }
                        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                        redefine(target, key, sourceProperty, options);
                    }
                };
            /***/ },
            /* 10 */ /***/ (module1)=>{
                var check = function(it) {
                    return it && it.Math == Math && it;
                };
                module1.exports = check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof $parcel$global == 'object' && $parcel$global) || function() {
                    return this;
                }() || Function('return this')();
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var call = __w_pdfjs_require__(14);
                var propertyIsEnumerableModule = __w_pdfjs_require__(15);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                var toIndexedObject = __w_pdfjs_require__(17);
                var toPropertyKey = __w_pdfjs_require__(22);
                var hasOwn = __w_pdfjs_require__(42);
                var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
                var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                    O = toIndexedObject(O);
                    P = toPropertyKey(P);
                    if (IE8_DOM_DEFINE) try {
                        return $getOwnPropertyDescriptor(O, P);
                    } catch (error) {}
                    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
                };
            /***/ },
            /* 12 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                module1.exports = !fails(function() {
                    return Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1] != 7;
                });
            /***/ },
            /* 13 */ /***/ (module1)=>{
                module1.exports = function(exec) {
                    try {
                        return !!exec();
                    } catch (error) {
                        return true;
                    }
                };
            /***/ },
            /* 14 */ /***/ (module1)=>{
                var call = Function.prototype.call;
                module1.exports = call.bind ? call.bind(call) : function() {
                    return call.apply(call, arguments);
                };
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                var $propertyIsEnumerable = {}.propertyIsEnumerable;
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
                    1: 2
                }, 1);
                exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                    var descriptor = getOwnPropertyDescriptor(this, V);
                    return !!descriptor && descriptor.enumerable;
                } : $propertyIsEnumerable;
            /***/ },
            /* 16 */ /***/ (module1)=>{
                module1.exports = function(bitmap, value) {
                    return {
                        enumerable: !(bitmap & 1),
                        configurable: !(bitmap & 2),
                        writable: !(bitmap & 4),
                        value: value
                    };
                };
            /***/ },
            /* 17 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var IndexedObject = __w_pdfjs_require__(18);
                var requireObjectCoercible = __w_pdfjs_require__(21);
                module1.exports = function(it) {
                    return IndexedObject(requireObjectCoercible(it));
                };
            /***/ },
            /* 18 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var uncurryThis = __w_pdfjs_require__(19);
                var fails = __w_pdfjs_require__(13);
                var classof = __w_pdfjs_require__(20);
                var Object1 = global1.Object;
                var split = uncurryThis(''.split);
                module1.exports = fails(function() {
                    return !Object1('z').propertyIsEnumerable(0);
                }) ? function(it) {
                    return classof(it) == 'String' ? split(it, '') : Object1(it);
                } : Object1;
            /***/ },
            /* 19 */ /***/ (module1)=>{
                var FunctionPrototype = Function.prototype;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                var callBind = bind && bind.bind(call);
                module1.exports = bind ? function(fn) {
                    return fn && callBind(call, fn);
                } : function(fn) {
                    return fn && function() {
                        return call.apply(fn, arguments);
                    };
                };
            /***/ },
            /* 20 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var toString = uncurryThis({}.toString);
                var stringSlice = uncurryThis(''.slice);
                module1.exports = function(it) {
                    return stringSlice(toString(it), 8, -1);
                };
            /***/ },
            /* 21 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var TypeError1 = global1.TypeError;
                module1.exports = function(it) {
                    if (it == undefined) throw TypeError1("Can't call method on " + it);
                    return it;
                };
            /***/ },
            /* 22 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toPrimitive = __w_pdfjs_require__(23);
                var isSymbol = __w_pdfjs_require__(26);
                module1.exports = function(argument) {
                    var key = toPrimitive(argument, 'string');
                    return isSymbol(key) ? key : key + '';
                };
            /***/ },
            /* 23 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var call = __w_pdfjs_require__(14);
                var isObject = __w_pdfjs_require__(24);
                var isSymbol = __w_pdfjs_require__(26);
                var getMethod = __w_pdfjs_require__(33);
                var ordinaryToPrimitive = __w_pdfjs_require__(36);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TypeError1 = global1.TypeError;
                var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                module1.exports = function(input, pref) {
                    if (!isObject(input) || isSymbol(input)) return input;
                    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
                    var result;
                    if (exoticToPrim) {
                        if (pref === undefined) pref = 'default';
                        result = call(exoticToPrim, input, pref);
                        if (!isObject(result) || isSymbol(result)) return result;
                        throw TypeError1("Can't convert object to primitive value");
                    }
                    if (pref === undefined) pref = 'number';
                    return ordinaryToPrimitive(input, pref);
                };
            /***/ },
            /* 24 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var isCallable = __w_pdfjs_require__(25);
                module1.exports = function(it) {
                    return typeof it == 'object' ? it !== null : isCallable(it);
                };
            /***/ },
            /* 25 */ /***/ (module1)=>{
                module1.exports = function(argument) {
                    return typeof argument == 'function';
                };
            /***/ },
            /* 26 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var getBuiltIn = __w_pdfjs_require__(27);
                var isCallable = __w_pdfjs_require__(25);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var USE_SYMBOL_AS_UID = __w_pdfjs_require__(29);
                var Object1 = global1.Object;
                module1.exports = USE_SYMBOL_AS_UID ? function(it) {
                    return typeof it == 'symbol';
                } : function(it) {
                    var $Symbol = getBuiltIn('Symbol');
                    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object1(it));
                };
            /***/ },
            /* 27 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var aFunction = function(argument) {
                    return isCallable(argument) ? argument : undefined;
                };
                module1.exports = function(namespace, method) {
                    return arguments.length < 2 ? aFunction(global1[namespace]) : global1[namespace] && global1[namespace][method];
                };
            /***/ },
            /* 28 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                module1.exports = uncurryThis({}.isPrototypeOf);
            /***/ },
            /* 29 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var NATIVE_SYMBOL = __w_pdfjs_require__(30);
                module1.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
            /***/ },
            /* 30 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var V8_VERSION = __w_pdfjs_require__(31);
                var fails = __w_pdfjs_require__(13);
                module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                    var symbol = Symbol();
                    return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
                });
            /***/ },
            /* 31 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var userAgent = __w_pdfjs_require__(32);
                var process = global1.process;
                var Deno = global1.Deno;
                var versions = process && process.versions || Deno && Deno.version;
                var v8 = versions && versions.v8;
                var match, version;
                if (v8) {
                    match = v8.split('.');
                    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
                }
                if (!version && userAgent) {
                    match = userAgent.match(/Edge\/(\d+)/);
                    if (!match || match[1] >= 74) {
                        match = userAgent.match(/Chrome\/(\d+)/);
                        if (match) version = +match[1];
                    }
                }
                module1.exports = version;
            /***/ },
            /* 32 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var getBuiltIn = __w_pdfjs_require__(27);
                module1.exports = getBuiltIn('navigator', 'userAgent') || '';
            /***/ },
            /* 33 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var aCallable = __w_pdfjs_require__(34);
                module1.exports = function(V, P) {
                    var func = V[P];
                    return func == null ? undefined : aCallable(func);
                };
            /***/ },
            /* 34 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var tryToString = __w_pdfjs_require__(35);
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (isCallable(argument)) return argument;
                    throw TypeError1(tryToString(argument) + ' is not a function');
                };
            /***/ },
            /* 35 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var String1 = global1.String;
                module1.exports = function(argument) {
                    try {
                        return String1(argument);
                    } catch (error) {
                        return 'Object';
                    }
                };
            /***/ },
            /* 36 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var call = __w_pdfjs_require__(14);
                var isCallable = __w_pdfjs_require__(25);
                var isObject = __w_pdfjs_require__(24);
                var TypeError1 = global1.TypeError;
                module1.exports = function(input, pref) {
                    var fn, val;
                    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
                    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    throw TypeError1("Can't convert object to primitive value");
                };
            /***/ },
            /* 37 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var shared = __w_pdfjs_require__(38);
                var hasOwn = __w_pdfjs_require__(42);
                var uid = __w_pdfjs_require__(44);
                var NATIVE_SYMBOL = __w_pdfjs_require__(30);
                var USE_SYMBOL_AS_UID = __w_pdfjs_require__(29);
                var WellKnownSymbolsStore = shared('wks');
                var Symbol1 = global1.Symbol;
                var symbolFor = Symbol1 && Symbol1['for'];
                var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
                module1.exports = function(name) {
                    if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
                        var description = 'Symbol.' + name;
                        if (NATIVE_SYMBOL && hasOwn(Symbol1, name)) WellKnownSymbolsStore[name] = Symbol1[name];
                        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
                        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
                    }
                    return WellKnownSymbolsStore[name];
                };
            /***/ },
            /* 38 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var IS_PURE = __w_pdfjs_require__(39);
                var store = __w_pdfjs_require__(40);
                (module1.exports = function(key, value) {
                    return store[key] || (store[key] = value !== undefined ? value : {});
                })('versions', []).push({
                    version: '3.19.3',
                    mode: IS_PURE ? 'pure' : 'global',
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            /***/ },
            /* 39 */ /***/ (module1)=>{
                module1.exports = false;
            /***/ },
            /* 40 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var setGlobal = __w_pdfjs_require__(41);
                var SHARED = '__core-js_shared__';
                var store = global1[SHARED] || setGlobal(SHARED, {});
                module1.exports = store;
            /***/ },
            /* 41 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var defineProperty = Object.defineProperty;
                module1.exports = function(key, value) {
                    try {
                        defineProperty(global1, key, {
                            value: value,
                            configurable: true,
                            writable: true
                        });
                    } catch (error) {
                        global1[key] = value;
                    }
                    return value;
                };
            /***/ },
            /* 42 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var toObject = __w_pdfjs_require__(43);
                var hasOwnProperty = uncurryThis({}.hasOwnProperty);
                module1.exports = Object.hasOwn || function hasOwn(it, key) {
                    return hasOwnProperty(toObject(it), key);
                };
            /***/ },
            /* 43 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var requireObjectCoercible = __w_pdfjs_require__(21);
                var Object1 = global1.Object;
                module1.exports = function(argument) {
                    return Object1(requireObjectCoercible(argument));
                };
            /***/ },
            /* 44 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var id = 0;
                var postfix = Math.random();
                var toString = uncurryThis(1.0.toString);
                module1.exports = function(key) {
                    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
                };
            /***/ },
            /* 45 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var fails = __w_pdfjs_require__(13);
                var createElement = __w_pdfjs_require__(46);
                module1.exports = !DESCRIPTORS && !fails(function() {
                    return Object.defineProperty(createElement('div'), 'a', {
                        get: function() {
                            return 7;
                        }
                    }).a != 7;
                });
            /***/ },
            /* 46 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isObject = __w_pdfjs_require__(24);
                var document1 = global1.document;
                var EXISTS = isObject(document1) && isObject(document1.createElement);
                module1.exports = function(it) {
                    return EXISTS ? document1.createElement(it) : {};
                };
            /***/ },
            /* 47 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var definePropertyModule = __w_pdfjs_require__(48);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                module1.exports = DESCRIPTORS ? function(object, key, value) {
                    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                } : function(object, key, value) {
                    object[key] = value;
                    return object;
                };
            /***/ },
            /* 48 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
                var anObject = __w_pdfjs_require__(49);
                var toPropertyKey = __w_pdfjs_require__(22);
                var TypeError1 = global1.TypeError;
                var $defineProperty = Object.defineProperty;
                exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPropertyKey(P);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE) try {
                        return $defineProperty(O, P, Attributes);
                    } catch (error) {}
                    if ('get' in Attributes || 'set' in Attributes) throw TypeError1('Accessors not supported');
                    if ('value' in Attributes) O[P] = Attributes.value;
                    return O;
                };
            /***/ },
            /* 49 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isObject = __w_pdfjs_require__(24);
                var String1 = global1.String;
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (isObject(argument)) return argument;
                    throw TypeError1(String1(argument) + ' is not an object');
                };
            /***/ },
            /* 50 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var hasOwn = __w_pdfjs_require__(42);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var setGlobal = __w_pdfjs_require__(41);
                var inspectSource = __w_pdfjs_require__(51);
                var InternalStateModule = __w_pdfjs_require__(52);
                var CONFIGURABLE_FUNCTION_NAME = __w_pdfjs_require__(56).CONFIGURABLE;
                var getInternalState = InternalStateModule.get;
                var enforceInternalState = InternalStateModule.enforce;
                var TEMPLATE = String(String).split('String');
                (module1.exports = function(O, key, value, options) {
                    var unsafe = options ? !!options.unsafe : false;
                    var simple = options ? !!options.enumerable : false;
                    var noTargetGet = options ? !!options.noTargetGet : false;
                    var name = options && options.name !== undefined ? options.name : key;
                    var state;
                    if (isCallable(value)) {
                        if (String(name).slice(0, 7) === 'Symbol(') name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
                        if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) createNonEnumerableProperty(value, 'name', name);
                        state = enforceInternalState(value);
                        if (!state.source) state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
                    }
                    if (O === global1) {
                        if (simple) O[key] = value;
                        else setGlobal(key, value);
                        return;
                    } else if (!unsafe) delete O[key];
                    else if (!noTargetGet && O[key]) simple = true;
                    if (simple) O[key] = value;
                    else createNonEnumerableProperty(O, key, value);
                })(Function.prototype, 'toString', function toString() {
                    return isCallable(this) && getInternalState(this).source || inspectSource(this);
                });
            /***/ },
            /* 51 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var isCallable = __w_pdfjs_require__(25);
                var store = __w_pdfjs_require__(40);
                var functionToString = uncurryThis(Function.toString);
                if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
                    return functionToString(it);
                };
                module1.exports = store.inspectSource;
            /***/ },
            /* 52 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var NATIVE_WEAK_MAP = __w_pdfjs_require__(53);
                var global1 = __w_pdfjs_require__(10);
                var uncurryThis = __w_pdfjs_require__(19);
                var isObject = __w_pdfjs_require__(24);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var hasOwn = __w_pdfjs_require__(42);
                var shared = __w_pdfjs_require__(40);
                var sharedKey = __w_pdfjs_require__(54);
                var hiddenKeys = __w_pdfjs_require__(55);
                var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
                var TypeError1 = global1.TypeError;
                var WeakMap1 = global1.WeakMap;
                var set, get, has;
                var enforce = function(it) {
                    return has(it) ? get(it) : set(it, {});
                };
                var getterFor = function(TYPE) {
                    return function(it) {
                        var state;
                        if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError1('Incompatible receiver, ' + TYPE + ' required');
                        return state;
                    };
                };
                if (NATIVE_WEAK_MAP || shared.state) {
                    var store = shared.state || (shared.state = new WeakMap1());
                    var wmget = uncurryThis(store.get);
                    var wmhas = uncurryThis(store.has);
                    var wmset = uncurryThis(store.set);
                    set = function(it, metadata) {
                        if (wmhas(store, it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        wmset(store, it, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return wmget(store, it) || {};
                    };
                    has = function(it) {
                        return wmhas(store, it);
                    };
                } else {
                    var STATE = sharedKey('state');
                    hiddenKeys[STATE] = true;
                    set = function(it, metadata) {
                        if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        createNonEnumerableProperty(it, STATE, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return hasOwn(it, STATE) ? it[STATE] : {};
                    };
                    has = function(it) {
                        return hasOwn(it, STATE);
                    };
                }
                module1.exports = {
                    set: set,
                    get: get,
                    has: has,
                    enforce: enforce,
                    getterFor: getterFor
                };
            /***/ },
            /* 53 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var inspectSource = __w_pdfjs_require__(51);
                var WeakMap1 = global1.WeakMap;
                module1.exports = isCallable(WeakMap1) && /native code/.test(inspectSource(WeakMap1));
            /***/ },
            /* 54 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var shared = __w_pdfjs_require__(38);
                var uid = __w_pdfjs_require__(44);
                var keys = shared('keys');
                module1.exports = function(key) {
                    return keys[key] || (keys[key] = uid(key));
                };
            /***/ },
            /* 55 */ /***/ (module1)=>{
                module1.exports = {};
            /***/ },
            /* 56 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var hasOwn = __w_pdfjs_require__(42);
                var FunctionPrototype = Function.prototype;
                var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
                var EXISTS = hasOwn(FunctionPrototype, 'name');
                var PROPER = EXISTS && (function something() {}).name === 'something';
                var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
                module1.exports = {
                    EXISTS: EXISTS,
                    PROPER: PROPER,
                    CONFIGURABLE: CONFIGURABLE
                };
            /***/ },
            /* 57 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var hasOwn = __w_pdfjs_require__(42);
                var ownKeys = __w_pdfjs_require__(58);
                var getOwnPropertyDescriptorModule = __w_pdfjs_require__(11);
                var definePropertyModule = __w_pdfjs_require__(48);
                module1.exports = function(target, source) {
                    var keys = ownKeys(source);
                    var defineProperty = definePropertyModule.f;
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                    }
                };
            /***/ },
            /* 58 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var getBuiltIn = __w_pdfjs_require__(27);
                var uncurryThis = __w_pdfjs_require__(19);
                var getOwnPropertyNamesModule = __w_pdfjs_require__(59);
                var getOwnPropertySymbolsModule = __w_pdfjs_require__(67);
                var anObject = __w_pdfjs_require__(49);
                var concat = uncurryThis([].concat);
                module1.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
                };
            /***/ },
            /* 59 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                var internalObjectKeys = __w_pdfjs_require__(60);
                var enumBugKeys = __w_pdfjs_require__(66);
                var hiddenKeys = enumBugKeys.concat('length', 'prototype');
                exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                };
            /***/ },
            /* 60 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var hasOwn = __w_pdfjs_require__(42);
                var toIndexedObject = __w_pdfjs_require__(17);
                var indexOf = __w_pdfjs_require__(61).indexOf;
                var hiddenKeys = __w_pdfjs_require__(55);
                var push = uncurryThis([].push);
                module1.exports = function(object, names) {
                    var O = toIndexedObject(object);
                    var i = 0;
                    var result = [];
                    var key;
                    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
                    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
                    return result;
                };
            /***/ },
            /* 61 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toIndexedObject = __w_pdfjs_require__(17);
                var toAbsoluteIndex = __w_pdfjs_require__(62);
                var lengthOfArrayLike = __w_pdfjs_require__(64);
                var createMethod = function(IS_INCLUDES) {
                    return function($this, el, fromIndex) {
                        var O = toIndexedObject($this);
                        var length = lengthOfArrayLike(O);
                        var index = toAbsoluteIndex(fromIndex, length);
                        var value;
                        if (IS_INCLUDES && el != el) while(length > index){
                            value = O[index++];
                            if (value != value) return true;
                        }
                        else for(; length > index; index++){
                            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                        }
                        return !IS_INCLUDES && -1;
                    };
                };
                module1.exports = {
                    includes: createMethod(true),
                    indexOf: createMethod(false)
                };
            /***/ },
            /* 62 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toIntegerOrInfinity = __w_pdfjs_require__(63);
                var max = Math.max;
                var min = Math.min;
                module1.exports = function(index, length) {
                    var integer = toIntegerOrInfinity(index);
                    return integer < 0 ? max(integer + length, 0) : min(integer, length);
                };
            /***/ },
            /* 63 */ /***/ (module1)=>{
                var ceil = Math.ceil;
                var floor = Math.floor;
                module1.exports = function(argument) {
                    var number = +argument;
                    return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
                };
            /***/ },
            /* 64 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toLength = __w_pdfjs_require__(65);
                module1.exports = function(obj) {
                    return toLength(obj.length);
                };
            /***/ },
            /* 65 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toIntegerOrInfinity = __w_pdfjs_require__(63);
                var min = Math.min;
                module1.exports = function(argument) {
                    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0;
                };
            /***/ },
            /* 66 */ /***/ (module1)=>{
                module1.exports = [
                    'constructor',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'toLocaleString',
                    'toString',
                    'valueOf'
                ];
            /***/ },
            /* 67 */ /***/ (__unused_webpack_module, exports)=>{
                exports.f = Object.getOwnPropertySymbols;
            /***/ },
            /* 68 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                var isCallable = __w_pdfjs_require__(25);
                var replacement = /#|\.prototype\./;
                var isForced = function(feature, detection) {
                    var value = data[normalize(feature)];
                    return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
                };
                var normalize = isForced.normalize = function(string) {
                    return String(string).replace(replacement, '.').toLowerCase();
                };
                var data = isForced.data = {};
                var NATIVE = isForced.NATIVE = 'N';
                var POLYFILL = isForced.POLYFILL = 'P';
                module1.exports = isForced;
            /***/ },
            /* 69 */ /***/ (module1, exports, __w_pdfjs_require__)=>{
                "use strict";
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                (function(global1, factory) {
                    _typeof(exports) === 'object' && true ? module1.exports = factory() : (__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __w_pdfjs_require__, exports, module1) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                })(void 0, function() {
                    'use strict';
                    function fromArray(array) {
                        var m = new CSSMatrix();
                        var a = Array.from(array);
                        if (!a.every(function(n) {
                            return !Number.isNaN(n);
                        })) throw TypeError("CSSMatrix: \"" + array + "\" must only have numbers.");
                        if (a.length === 16) {
                            var m11 = a[0];
                            var m12 = a[1];
                            var m13 = a[2];
                            var m14 = a[3];
                            var m21 = a[4];
                            var m22 = a[5];
                            var m23 = a[6];
                            var m24 = a[7];
                            var m31 = a[8];
                            var m32 = a[9];
                            var m33 = a[10];
                            var m34 = a[11];
                            var m41 = a[12];
                            var m42 = a[13];
                            var m43 = a[14];
                            var m44 = a[15];
                            m.m11 = m11;
                            m.a = m11;
                            m.m21 = m21;
                            m.c = m21;
                            m.m31 = m31;
                            m.m41 = m41;
                            m.e = m41;
                            m.m12 = m12;
                            m.b = m12;
                            m.m22 = m22;
                            m.d = m22;
                            m.m32 = m32;
                            m.m42 = m42;
                            m.f = m42;
                            m.m13 = m13;
                            m.m23 = m23;
                            m.m33 = m33;
                            m.m43 = m43;
                            m.m14 = m14;
                            m.m24 = m24;
                            m.m34 = m34;
                            m.m44 = m44;
                        } else if (a.length === 6) {
                            var M11 = a[0];
                            var M12 = a[1];
                            var M21 = a[2];
                            var M22 = a[3];
                            var M41 = a[4];
                            var M42 = a[5];
                            m.m11 = M11;
                            m.a = M11;
                            m.m12 = M12;
                            m.b = M12;
                            m.m21 = M21;
                            m.c = M21;
                            m.m22 = M22;
                            m.d = M22;
                            m.m41 = M41;
                            m.e = M41;
                            m.m42 = M42;
                            m.f = M42;
                        } else throw new TypeError('CSSMatrix: expecting an Array of 6/16 values.');
                        return m;
                    }
                    function fromMatrix(m) {
                        var keys = Object.keys(new CSSMatrix());
                        if (_typeof(m) === 'object' && keys.every(function(k) {
                            return k in m;
                        })) return fromArray([
                            m.m11,
                            m.m12,
                            m.m13,
                            m.m14,
                            m.m21,
                            m.m22,
                            m.m23,
                            m.m24,
                            m.m31,
                            m.m32,
                            m.m33,
                            m.m34,
                            m.m41,
                            m.m42,
                            m.m43,
                            m.m44
                        ]);
                        throw TypeError("CSSMatrix: \"" + m + "\" is not a DOMMatrix / CSSMatrix / JSON compatible object.");
                    }
                    function fromString(source) {
                        if (typeof source !== 'string') throw TypeError("CSSMatrix: \"" + source + "\" is not a string.");
                        var str = String(source).replace(/\s/g, '');
                        var m = new CSSMatrix();
                        var invalidStringError = "CSSMatrix: invalid transform string \"" + source + "\"";
                        str.split(')').filter(function(f) {
                            return f;
                        }).forEach(function(tf) {
                            var ref = tf.split('(');
                            var prop = ref[0];
                            var value = ref[1];
                            if (!value) throw TypeError(invalidStringError);
                            var components = value.split(',').map(function(n) {
                                return n.includes('rad') ? parseFloat(n) * (180 / Math.PI) : parseFloat(n);
                            });
                            var x = components[0];
                            var y = components[1];
                            var z = components[2];
                            var a = components[3];
                            var xyz = [
                                x,
                                y,
                                z
                            ];
                            var xyza = [
                                x,
                                y,
                                z,
                                a
                            ];
                            if (prop === 'perspective' && x && [
                                y,
                                z
                            ].every(function(n) {
                                return n === undefined;
                            })) m.m34 = -1 / x;
                            else if (prop.includes('matrix') && [
                                6,
                                16
                            ].includes(components.length) && components.every(function(n) {
                                return !Number.isNaN(+n);
                            })) {
                                var values = components.map(function(n) {
                                    return Math.abs(n) < 1e-6 ? 0 : n;
                                });
                                m = m.multiply(fromArray(values));
                            } else if (prop === 'translate3d' && xyz.every(function(n) {
                                return !Number.isNaN(+n);
                            })) m = m.translate(x, y, z);
                            else if (prop === 'translate' && x && z === undefined) m = m.translate(x, y || 0, 0);
                            else if (prop === 'rotate3d' && xyza.every(function(n) {
                                return !Number.isNaN(+n);
                            }) && a) m = m.rotateAxisAngle(x, y, z, a);
                            else if (prop === 'rotate' && x && [
                                y,
                                z
                            ].every(function(n) {
                                return n === undefined;
                            })) m = m.rotate(0, 0, x);
                            else if (prop === 'scale3d' && xyz.every(function(n) {
                                return !Number.isNaN(+n);
                            }) && xyz.some(function(n) {
                                return n !== 1;
                            })) m = m.scale(x, y, z);
                            else if (prop === 'scale' && !Number.isNaN(x) && x !== 1 && z === undefined) {
                                var nosy = Number.isNaN(+y);
                                var sy = nosy ? x : y;
                                m = m.scale(x, sy, 1);
                            } else if (prop === 'skew' && x && z === undefined) {
                                m = m.skewX(x);
                                m = y ? m.skewY(y) : m;
                            } else if (/[XYZ]/.test(prop) && x && [
                                y,
                                z
                            ].every(function(n) {
                                return n === undefined;
                            }) && [
                                'translate',
                                'rotate',
                                'scale',
                                'skew'
                            ].some(function(p) {
                                return prop.includes(p);
                            })) {
                                if ([
                                    'skewX',
                                    'skewY'
                                ].includes(prop)) m = m[prop](x);
                                else {
                                    var fn = prop.replace(/[XYZ]/, '');
                                    var axis = prop.replace(fn, '');
                                    var idx = [
                                        'X',
                                        'Y',
                                        'Z'
                                    ].indexOf(axis);
                                    var axeValues = [
                                        idx === 0 ? x : 0,
                                        idx === 1 ? x : 0,
                                        idx === 2 ? x : 0
                                    ];
                                    m = m[fn].apply(m, axeValues);
                                }
                            } else throw TypeError(invalidStringError);
                        });
                        return m;
                    }
                    function Translate(x, y, z) {
                        var m = new CSSMatrix();
                        m.m41 = x;
                        m.e = x;
                        m.m42 = y;
                        m.f = y;
                        m.m43 = z;
                        return m;
                    }
                    function Rotate(rx, ry, rz) {
                        var m = new CSSMatrix();
                        var degToRad = Math.PI / 180;
                        var radX = rx * degToRad;
                        var radY = ry * degToRad;
                        var radZ = rz * degToRad;
                        var cosx = Math.cos(radX);
                        var sinx = -Math.sin(radX);
                        var cosy = Math.cos(radY);
                        var siny = -Math.sin(radY);
                        var cosz = Math.cos(radZ);
                        var sinz = -Math.sin(radZ);
                        var m11 = cosy * cosz;
                        var m12 = -cosy * sinz;
                        m.m11 = m11;
                        m.a = m11;
                        m.m12 = m12;
                        m.b = m12;
                        m.m13 = siny;
                        var m21 = sinx * siny * cosz + cosx * sinz;
                        m.m21 = m21;
                        m.c = m21;
                        var m22 = cosx * cosz - sinx * siny * sinz;
                        m.m22 = m22;
                        m.d = m22;
                        m.m23 = -sinx * cosy;
                        m.m31 = sinx * sinz - cosx * siny * cosz;
                        m.m32 = sinx * cosz + cosx * siny * sinz;
                        m.m33 = cosx * cosy;
                        return m;
                    }
                    function RotateAxisAngle(x, y, z, alpha) {
                        var m = new CSSMatrix();
                        var angle = alpha * (Math.PI / 360);
                        var sinA = Math.sin(angle);
                        var cosA = Math.cos(angle);
                        var sinA2 = sinA * sinA;
                        var length = Math.sqrt(x * x + y * y + z * z);
                        var X = x;
                        var Y = y;
                        var Z = z;
                        if (length === 0) {
                            X = 0;
                            Y = 0;
                            Z = 1;
                        } else {
                            X /= length;
                            Y /= length;
                            Z /= length;
                        }
                        var x2 = X * X;
                        var y2 = Y * Y;
                        var z2 = Z * Z;
                        var m11 = 1 - 2 * (y2 + z2) * sinA2;
                        m.m11 = m11;
                        m.a = m11;
                        var m12 = 2 * (X * Y * sinA2 + Z * sinA * cosA);
                        m.m12 = m12;
                        m.b = m12;
                        m.m13 = 2 * (X * Z * sinA2 - Y * sinA * cosA);
                        var m21 = 2 * (Y * X * sinA2 - Z * sinA * cosA);
                        m.m21 = m21;
                        m.c = m21;
                        var m22 = 1 - 2 * (z2 + x2) * sinA2;
                        m.m22 = m22;
                        m.d = m22;
                        m.m23 = 2 * (Y * Z * sinA2 + X * sinA * cosA);
                        m.m31 = 2 * (Z * X * sinA2 + Y * sinA * cosA);
                        m.m32 = 2 * (Z * Y * sinA2 - X * sinA * cosA);
                        m.m33 = 1 - 2 * (x2 + y2) * sinA2;
                        return m;
                    }
                    function Scale(x, y, z) {
                        var m = new CSSMatrix();
                        m.m11 = x;
                        m.a = x;
                        m.m22 = y;
                        m.d = y;
                        m.m33 = z;
                        return m;
                    }
                    function SkewX(angle) {
                        var m = new CSSMatrix();
                        var radA = angle * Math.PI / 180;
                        var t = Math.tan(radA);
                        m.m21 = t;
                        m.c = t;
                        return m;
                    }
                    function SkewY(angle) {
                        var m = new CSSMatrix();
                        var radA = angle * Math.PI / 180;
                        var t = Math.tan(radA);
                        m.m12 = t;
                        m.b = t;
                        return m;
                    }
                    function Multiply(m1, m2) {
                        var m11 = m2.m11 * m1.m11 + m2.m12 * m1.m21 + m2.m13 * m1.m31 + m2.m14 * m1.m41;
                        var m12 = m2.m11 * m1.m12 + m2.m12 * m1.m22 + m2.m13 * m1.m32 + m2.m14 * m1.m42;
                        var m13 = m2.m11 * m1.m13 + m2.m12 * m1.m23 + m2.m13 * m1.m33 + m2.m14 * m1.m43;
                        var m14 = m2.m11 * m1.m14 + m2.m12 * m1.m24 + m2.m13 * m1.m34 + m2.m14 * m1.m44;
                        var m21 = m2.m21 * m1.m11 + m2.m22 * m1.m21 + m2.m23 * m1.m31 + m2.m24 * m1.m41;
                        var m22 = m2.m21 * m1.m12 + m2.m22 * m1.m22 + m2.m23 * m1.m32 + m2.m24 * m1.m42;
                        var m23 = m2.m21 * m1.m13 + m2.m22 * m1.m23 + m2.m23 * m1.m33 + m2.m24 * m1.m43;
                        var m24 = m2.m21 * m1.m14 + m2.m22 * m1.m24 + m2.m23 * m1.m34 + m2.m24 * m1.m44;
                        var m31 = m2.m31 * m1.m11 + m2.m32 * m1.m21 + m2.m33 * m1.m31 + m2.m34 * m1.m41;
                        var m32 = m2.m31 * m1.m12 + m2.m32 * m1.m22 + m2.m33 * m1.m32 + m2.m34 * m1.m42;
                        var m33 = m2.m31 * m1.m13 + m2.m32 * m1.m23 + m2.m33 * m1.m33 + m2.m34 * m1.m43;
                        var m34 = m2.m31 * m1.m14 + m2.m32 * m1.m24 + m2.m33 * m1.m34 + m2.m34 * m1.m44;
                        var m41 = m2.m41 * m1.m11 + m2.m42 * m1.m21 + m2.m43 * m1.m31 + m2.m44 * m1.m41;
                        var m42 = m2.m41 * m1.m12 + m2.m42 * m1.m22 + m2.m43 * m1.m32 + m2.m44 * m1.m42;
                        var m43 = m2.m41 * m1.m13 + m2.m42 * m1.m23 + m2.m43 * m1.m33 + m2.m44 * m1.m43;
                        var m44 = m2.m41 * m1.m14 + m2.m42 * m1.m24 + m2.m43 * m1.m34 + m2.m44 * m1.m44;
                        return fromArray([
                            m11,
                            m12,
                            m13,
                            m14,
                            m21,
                            m22,
                            m23,
                            m24,
                            m31,
                            m32,
                            m33,
                            m34,
                            m41,
                            m42,
                            m43,
                            m44
                        ]);
                    }
                    var CSSMatrix = function CSSMatrix() {
                        var args = [], len = arguments.length;
                        while(len--)args[len] = arguments[len];
                        var m = this;
                        m.a = 1;
                        m.b = 0;
                        m.c = 0;
                        m.d = 1;
                        m.e = 0;
                        m.f = 0;
                        m.m11 = 1;
                        m.m12 = 0;
                        m.m13 = 0;
                        m.m14 = 0;
                        m.m21 = 0;
                        m.m22 = 1;
                        m.m23 = 0;
                        m.m24 = 0;
                        m.m31 = 0;
                        m.m32 = 0;
                        m.m33 = 1;
                        m.m34 = 0;
                        m.m41 = 0;
                        m.m42 = 0;
                        m.m43 = 0;
                        m.m44 = 1;
                        if (args && args.length) {
                            var ARGS = [
                                16,
                                6
                            ].some(function(l) {
                                return l === args.length;
                            }) ? args : args[0];
                            return m.setMatrixValue(ARGS);
                        }
                        return m;
                    };
                    var prototypeAccessors = {
                        isIdentity: {
                            configurable: true
                        },
                        is2D: {
                            configurable: true
                        }
                    };
                    prototypeAccessors.isIdentity.set = function(value) {
                        this.isIdentity = value;
                    };
                    prototypeAccessors.isIdentity.get = function() {
                        var m = this;
                        return m.m11 === 1 && m.m12 === 0 && m.m13 === 0 && m.m14 === 0 && m.m21 === 0 && m.m22 === 1 && m.m23 === 0 && m.m24 === 0 && m.m31 === 0 && m.m32 === 0 && m.m33 === 1 && m.m34 === 0 && m.m41 === 0 && m.m42 === 0 && m.m43 === 0 && m.m44 === 1;
                    };
                    prototypeAccessors.is2D.get = function() {
                        var m = this;
                        return m.m31 === 0 && m.m32 === 0 && m.m33 === 1 && m.m34 === 0 && m.m43 === 0 && m.m44 === 1;
                    };
                    prototypeAccessors.is2D.set = function(value) {
                        this.is2D = value;
                    };
                    CSSMatrix.prototype.setMatrixValue = function setMatrixValue(source) {
                        var m = this;
                        if ([
                            Array,
                            Float64Array,
                            Float32Array
                        ].some(function(a) {
                            return source instanceof a;
                        })) return fromArray(source);
                        if (typeof source === 'string' && source.length && source !== 'none') return fromString(source);
                        if (_typeof(source) === 'object') return fromMatrix(source);
                        return m;
                    };
                    CSSMatrix.prototype.toArray = function toArray() {
                        var m = this;
                        var pow = Math.pow(10, 6);
                        var result;
                        if (m.is2D) result = [
                            m.a,
                            m.b,
                            m.c,
                            m.d,
                            m.e,
                            m.f
                        ];
                        else result = [
                            m.m11,
                            m.m12,
                            m.m13,
                            m.m14,
                            m.m21,
                            m.m22,
                            m.m23,
                            m.m24,
                            m.m31,
                            m.m32,
                            m.m33,
                            m.m34,
                            m.m41,
                            m.m42,
                            m.m43,
                            m.m44
                        ];
                        return result.map(function(n) {
                            return Math.abs(n) < 1e-6 ? 0 : (n * pow >> 0) / pow;
                        });
                    };
                    CSSMatrix.prototype.toString = function toString() {
                        var m = this;
                        var values = m.toArray();
                        var type = m.is2D ? 'matrix' : 'matrix3d';
                        return type + "(" + values + ")";
                    };
                    CSSMatrix.prototype.toJSON = function toJSON() {
                        var m = this;
                        var is2D = m.is2D;
                        var isIdentity = m.isIdentity;
                        return Object.assign({}, m, {
                            is2D: is2D,
                            isIdentity: isIdentity
                        });
                    };
                    CSSMatrix.prototype.multiply = function multiply(m2) {
                        return Multiply(this, m2);
                    };
                    CSSMatrix.prototype.translate = function translate(x, y, z) {
                        var X = x;
                        var Y = y;
                        var Z = z;
                        if (Z === undefined) Z = 0;
                        if (Y === undefined) Y = 0;
                        return Multiply(this, Translate(X, Y, Z));
                    };
                    CSSMatrix.prototype.scale = function scale(x, y, z) {
                        var X = x;
                        var Y = y;
                        var Z = z;
                        if (Y === undefined) Y = x;
                        if (Z === undefined) Z = 1;
                        return Multiply(this, Scale(X, Y, Z));
                    };
                    CSSMatrix.prototype.rotate = function rotate(rx, ry, rz) {
                        var RX = rx;
                        var RY = ry;
                        var RZ = rz;
                        if (RY === undefined) RY = 0;
                        if (RZ === undefined) {
                            RZ = RX;
                            RX = 0;
                        }
                        return Multiply(this, Rotate(RX, RY, RZ));
                    };
                    CSSMatrix.prototype.rotateAxisAngle = function rotateAxisAngle(x, y, z, angle) {
                        if ([
                            x,
                            y,
                            z,
                            angle
                        ].some(function(n) {
                            return Number.isNaN(n);
                        })) throw new TypeError('CSSMatrix: expecting 4 values');
                        return Multiply(this, RotateAxisAngle(x, y, z, angle));
                    };
                    CSSMatrix.prototype.skewX = function skewX(angle) {
                        return Multiply(this, SkewX(angle));
                    };
                    CSSMatrix.prototype.skewY = function skewY(angle) {
                        return Multiply(this, SkewY(angle));
                    };
                    CSSMatrix.prototype.transformPoint = function transformPoint(v) {
                        var M = this;
                        var m = Translate(v.x, v.y, v.z);
                        m.m44 = v.w || 1;
                        m = M.multiply(m);
                        return {
                            x: m.m41,
                            y: m.m42,
                            z: m.m43,
                            w: m.m44
                        };
                    };
                    CSSMatrix.prototype.transform = function transform(t) {
                        var m = this;
                        var x = m.m11 * t.x + m.m12 * t.y + m.m13 * t.z + m.m14 * t.w;
                        var y = m.m21 * t.x + m.m22 * t.y + m.m23 * t.z + m.m24 * t.w;
                        var z = m.m31 * t.x + m.m32 * t.y + m.m33 * t.z + m.m34 * t.w;
                        var w = m.m41 * t.x + m.m42 * t.y + m.m43 * t.z + m.m44 * t.w;
                        return {
                            x: x / w,
                            y: y / w,
                            z: z / w,
                            w: w
                        };
                    };
                    Object.defineProperties(CSSMatrix.prototype, prototypeAccessors);
                    Object.assign(CSSMatrix, {
                        Translate: Translate,
                        Rotate: Rotate,
                        RotateAxisAngle: RotateAxisAngle,
                        Scale: Scale,
                        SkewX: SkewX,
                        SkewY: SkewY,
                        Multiply: Multiply,
                        fromArray: fromArray,
                        fromMatrix: fromMatrix,
                        fromString: fromString
                    });
                    var version = "0.0.24";
                    var Version = version;
                    Object.assign(CSSMatrix, {
                        Version: Version
                    });
                    return CSSMatrix;
                });
            /***/ },
            /* 70 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                __w_pdfjs_require__(71);
                __w_pdfjs_require__(86);
                var path = __w_pdfjs_require__(96);
                module1.exports = path.Object.fromEntries;
            /***/ },
            /* 71 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var toIndexedObject = __w_pdfjs_require__(17);
                var addToUnscopables = __w_pdfjs_require__(72);
                var Iterators = __w_pdfjs_require__(77);
                var InternalStateModule = __w_pdfjs_require__(52);
                var defineIterator = __w_pdfjs_require__(78);
                var ARRAY_ITERATOR = 'Array Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
                module1.exports = defineIterator(Array, 'Array', function(iterated, kind) {
                    setInternalState(this, {
                        type: ARRAY_ITERATOR,
                        target: toIndexedObject(iterated),
                        index: 0,
                        kind: kind
                    });
                }, function() {
                    var state = getInternalState(this);
                    var target = state.target;
                    var kind = state.kind;
                    var index = state.index++;
                    if (!target || index >= target.length) {
                        state.target = undefined;
                        return {
                            value: undefined,
                            done: true
                        };
                    }
                    if (kind == 'keys') return {
                        value: index,
                        done: false
                    };
                    if (kind == 'values') return {
                        value: target[index],
                        done: false
                    };
                    return {
                        value: [
                            index,
                            target[index]
                        ],
                        done: false
                    };
                }, 'values');
                Iterators.Arguments = Iterators.Array;
                addToUnscopables('keys');
                addToUnscopables('values');
                addToUnscopables('entries');
            /***/ },
            /* 72 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var create = __w_pdfjs_require__(73);
                var definePropertyModule = __w_pdfjs_require__(48);
                var UNSCOPABLES = wellKnownSymbol('unscopables');
                var ArrayPrototype = Array.prototype;
                if (ArrayPrototype[UNSCOPABLES] == undefined) definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
                    configurable: true,
                    value: create(null)
                });
                module1.exports = function(key) {
                    ArrayPrototype[UNSCOPABLES][key] = true;
                };
            /***/ },
            /* 73 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var anObject = __w_pdfjs_require__(49);
                var defineProperties = __w_pdfjs_require__(74);
                var enumBugKeys = __w_pdfjs_require__(66);
                var hiddenKeys = __w_pdfjs_require__(55);
                var html = __w_pdfjs_require__(76);
                var documentCreateElement = __w_pdfjs_require__(46);
                var sharedKey = __w_pdfjs_require__(54);
                var GT = '>';
                var LT = '<';
                var PROTOTYPE = 'prototype';
                var SCRIPT = 'script';
                var IE_PROTO = sharedKey('IE_PROTO');
                var EmptyConstructor = function() {};
                var scriptTag = function(content) {
                    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
                };
                var NullProtoObjectViaActiveX = function(activeXDocument) {
                    activeXDocument.write(scriptTag(''));
                    activeXDocument.close();
                    var temp = activeXDocument.parentWindow.Object;
                    activeXDocument = null;
                    return temp;
                };
                var NullProtoObjectViaIFrame = function() {
                    var iframe = documentCreateElement('iframe');
                    var JS = 'java' + SCRIPT + ':';
                    var iframeDocument;
                    iframe.style.display = 'none';
                    html.appendChild(iframe);
                    iframe.src = String(JS);
                    iframeDocument = iframe.contentWindow.document;
                    iframeDocument.open();
                    iframeDocument.write(scriptTag('document.F=Object'));
                    iframeDocument.close();
                    return iframeDocument.F;
                };
                var activeXDocument;
                var NullProtoObject = function() {
                    try {
                        activeXDocument = new ActiveXObject('htmlfile');
                    } catch (error) {}
                    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
                    var length = enumBugKeys.length;
                    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                    return NullProtoObject();
                };
                hiddenKeys[IE_PROTO] = true;
                module1.exports = Object.create || function create(O, Properties) {
                    var result;
                    if (O !== null) {
                        EmptyConstructor[PROTOTYPE] = anObject(O);
                        result = new EmptyConstructor();
                        EmptyConstructor[PROTOTYPE] = null;
                        result[IE_PROTO] = O;
                    } else result = NullProtoObject();
                    return Properties === undefined ? result : defineProperties(result, Properties);
                };
            /***/ },
            /* 74 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var definePropertyModule = __w_pdfjs_require__(48);
                var anObject = __w_pdfjs_require__(49);
                var toIndexedObject = __w_pdfjs_require__(17);
                var objectKeys = __w_pdfjs_require__(75);
                module1.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                    anObject(O);
                    var props = toIndexedObject(Properties);
                    var keys = objectKeys(Properties);
                    var length = keys.length;
                    var index = 0;
                    var key;
                    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
                    return O;
                };
            /***/ },
            /* 75 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var internalObjectKeys = __w_pdfjs_require__(60);
                var enumBugKeys = __w_pdfjs_require__(66);
                module1.exports = Object.keys || function keys(O) {
                    return internalObjectKeys(O, enumBugKeys);
                };
            /***/ },
            /* 76 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var getBuiltIn = __w_pdfjs_require__(27);
                module1.exports = getBuiltIn('document', 'documentElement');
            /***/ },
            /* 77 */ /***/ (module1)=>{
                module1.exports = {};
            /***/ },
            /* 78 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var call = __w_pdfjs_require__(14);
                var IS_PURE = __w_pdfjs_require__(39);
                var FunctionName = __w_pdfjs_require__(56);
                var isCallable = __w_pdfjs_require__(25);
                var createIteratorConstructor = __w_pdfjs_require__(79);
                var getPrototypeOf = __w_pdfjs_require__(81);
                var setPrototypeOf = __w_pdfjs_require__(84);
                var setToStringTag = __w_pdfjs_require__(83);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var redefine = __w_pdfjs_require__(50);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var Iterators = __w_pdfjs_require__(77);
                var IteratorsCore = __w_pdfjs_require__(80);
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol('iterator');
                var KEYS = 'keys';
                var VALUES = 'values';
                var ENTRIES = 'entries';
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                    createIteratorConstructor(IteratorConstructor, NAME, next);
                    var getIterationMethod = function(KIND) {
                        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                        switch(KIND){
                            case KEYS:
                                return function keys() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case VALUES:
                                return function values() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case ENTRIES:
                                return function entries() {
                                    return new IteratorConstructor(this, KIND);
                                };
                        }
                        return function() {
                            return new IteratorConstructor(this);
                        };
                    };
                    var TO_STRING_TAG = NAME + ' Iterator';
                    var INCORRECT_VALUES_NAME = false;
                    var IterablePrototype = Iterable.prototype;
                    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
                    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
                    var CurrentIteratorPrototype, methods, KEY;
                    if (anyNativeIterator) {
                        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
                            }
                            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                        }
                    }
                    if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
                        else {
                            INCORRECT_VALUES_NAME = true;
                            defaultIterator = function values() {
                                return call(nativeIterator, this);
                            };
                        }
                    }
                    if (DEFAULT) {
                        methods = {
                            values: getIterationMethod(VALUES),
                            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                            entries: getIterationMethod(ENTRIES)
                        };
                        if (FORCED) {
                            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
                        } else $({
                            target: NAME,
                            proto: true,
                            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                        }, methods);
                    }
                    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) redefine(IterablePrototype, ITERATOR, defaultIterator, {
                        name: DEFAULT
                    });
                    Iterators[NAME] = defaultIterator;
                    return methods;
                };
            /***/ },
            /* 79 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var IteratorPrototype = __w_pdfjs_require__(80).IteratorPrototype;
                var create = __w_pdfjs_require__(73);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                var setToStringTag = __w_pdfjs_require__(83);
                var Iterators = __w_pdfjs_require__(77);
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
                    var TO_STRING_TAG = NAME + ' Iterator';
                    IteratorConstructor.prototype = create(IteratorPrototype, {
                        next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
                    });
                    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                    Iterators[TO_STRING_TAG] = returnThis;
                    return IteratorConstructor;
                };
            /***/ },
            /* 80 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var fails = __w_pdfjs_require__(13);
                var isCallable = __w_pdfjs_require__(25);
                var create = __w_pdfjs_require__(73);
                var getPrototypeOf = __w_pdfjs_require__(81);
                var redefine = __w_pdfjs_require__(50);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var IS_PURE = __w_pdfjs_require__(39);
                var ITERATOR = wellKnownSymbol('iterator');
                var BUGGY_SAFARI_ITERATORS = false;
                var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
                if ([].keys) {
                    arrayIterator = [].keys();
                    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                    else {
                        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                    }
                }
                var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function() {
                    var test = {};
                    return IteratorPrototype[ITERATOR].call(test) !== test;
                });
                if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
                else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
                if (!isCallable(IteratorPrototype[ITERATOR])) redefine(IteratorPrototype, ITERATOR, function() {
                    return this;
                });
                module1.exports = {
                    IteratorPrototype: IteratorPrototype,
                    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
                };
            /***/ },
            /* 81 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var hasOwn = __w_pdfjs_require__(42);
                var isCallable = __w_pdfjs_require__(25);
                var toObject = __w_pdfjs_require__(43);
                var sharedKey = __w_pdfjs_require__(54);
                var CORRECT_PROTOTYPE_GETTER = __w_pdfjs_require__(82);
                var IE_PROTO = sharedKey('IE_PROTO');
                var Object1 = global1.Object;
                var ObjectPrototype = Object1.prototype;
                module1.exports = CORRECT_PROTOTYPE_GETTER ? Object1.getPrototypeOf : function(O) {
                    var object = toObject(O);
                    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
                    var constructor = object.constructor;
                    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
                    return object instanceof Object1 ? ObjectPrototype : null;
                };
            /***/ },
            /* 82 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                module1.exports = !fails(function() {
                    function F() {}
                    F.prototype.constructor = null;
                    return Object.getPrototypeOf(new F()) !== F.prototype;
                });
            /***/ },
            /* 83 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var defineProperty = __w_pdfjs_require__(48).f;
                var hasOwn = __w_pdfjs_require__(42);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                module1.exports = function(it, TAG, STATIC) {
                    if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
                        configurable: true,
                        value: TAG
                    });
                };
            /***/ },
            /* 84 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var anObject = __w_pdfjs_require__(49);
                var aPossiblePrototype = __w_pdfjs_require__(85);
                module1.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
                    var CORRECT_SETTER = false;
                    var test = {};
                    var setter;
                    try {
                        setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
                        setter(test, []);
                        CORRECT_SETTER = test instanceof Array;
                    } catch (error) {}
                    return function setPrototypeOf(O, proto) {
                        anObject(O);
                        aPossiblePrototype(proto);
                        if (CORRECT_SETTER) setter(O, proto);
                        else O.__proto__ = proto;
                        return O;
                    };
                }() : undefined);
            /***/ },
            /* 85 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var String1 = global1.String;
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (typeof argument == 'object' || isCallable(argument)) return argument;
                    throw TypeError1("Can't set " + String1(argument) + ' as a prototype');
                };
            /***/ },
            /* 86 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var $ = __w_pdfjs_require__(9);
                var iterate = __w_pdfjs_require__(87);
                var createProperty = __w_pdfjs_require__(95);
                $({
                    target: 'Object',
                    stat: true
                }, {
                    fromEntries: function fromEntries(iterable) {
                        var obj = {};
                        iterate(iterable, function(k, v) {
                            createProperty(obj, k, v);
                        }, {
                            AS_ENTRIES: true
                        });
                        return obj;
                    }
                });
            /***/ },
            /* 87 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var bind = __w_pdfjs_require__(88);
                var call = __w_pdfjs_require__(14);
                var anObject = __w_pdfjs_require__(49);
                var tryToString = __w_pdfjs_require__(35);
                var isArrayIteratorMethod = __w_pdfjs_require__(89);
                var lengthOfArrayLike = __w_pdfjs_require__(64);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var getIterator = __w_pdfjs_require__(90);
                var getIteratorMethod = __w_pdfjs_require__(91);
                var iteratorClose = __w_pdfjs_require__(94);
                var TypeError1 = global1.TypeError;
                var Result = function(stopped, result) {
                    this.stopped = stopped;
                    this.result = result;
                };
                var ResultPrototype = Result.prototype;
                module1.exports = function(iterable, unboundFunction, options) {
                    var that = options && options.that;
                    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
                    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
                    var INTERRUPTED = !!(options && options.INTERRUPTED);
                    var fn = bind(unboundFunction, that);
                    var iterator, iterFn, index, length, result, next, step;
                    var stop = function(condition) {
                        if (iterator) iteratorClose(iterator, 'normal', condition);
                        return new Result(true, condition);
                    };
                    var callFn = function(value) {
                        if (AS_ENTRIES) {
                            anObject(value);
                            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                        }
                        return INTERRUPTED ? fn(value, stop) : fn(value);
                    };
                    if (IS_ITERATOR) iterator = iterable;
                    else {
                        iterFn = getIteratorMethod(iterable);
                        if (!iterFn) throw TypeError1(tryToString(iterable) + ' is not iterable');
                        if (isArrayIteratorMethod(iterFn)) {
                            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                                result = callFn(iterable[index]);
                                if (result && isPrototypeOf(ResultPrototype, result)) return result;
                            }
                            return new Result(false);
                        }
                        iterator = getIterator(iterable, iterFn);
                    }
                    next = iterator.next;
                    while(!(step = call(next, iterator)).done){
                        try {
                            result = callFn(step.value);
                        } catch (error) {
                            iteratorClose(iterator, 'throw', error);
                        }
                        if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
                    }
                    return new Result(false);
                };
            /***/ },
            /* 88 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var aCallable = __w_pdfjs_require__(34);
                var bind = uncurryThis(uncurryThis.bind);
                module1.exports = function(fn, that) {
                    aCallable(fn);
                    return that === undefined ? fn : bind ? bind(fn, that) : function() {
                        return fn.apply(that, arguments);
                    };
                };
            /***/ },
            /* 89 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var Iterators = __w_pdfjs_require__(77);
                var ITERATOR = wellKnownSymbol('iterator');
                var ArrayPrototype = Array.prototype;
                module1.exports = function(it) {
                    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                };
            /***/ },
            /* 90 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var call = __w_pdfjs_require__(14);
                var aCallable = __w_pdfjs_require__(34);
                var anObject = __w_pdfjs_require__(49);
                var tryToString = __w_pdfjs_require__(35);
                var getIteratorMethod = __w_pdfjs_require__(91);
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument, usingIterator) {
                    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
                    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
                    throw TypeError1(tryToString(argument) + ' is not iterable');
                };
            /***/ },
            /* 91 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var classof = __w_pdfjs_require__(92);
                var getMethod = __w_pdfjs_require__(33);
                var Iterators = __w_pdfjs_require__(77);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var ITERATOR = wellKnownSymbol('iterator');
                module1.exports = function(it) {
                    if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
                };
            /***/ },
            /* 92 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(93);
                var isCallable = __w_pdfjs_require__(25);
                var classofRaw = __w_pdfjs_require__(20);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var Object1 = global1.Object;
                var CORRECT_ARGUMENTS = classofRaw(function() {
                    return arguments;
                }()) == 'Arguments';
                var tryGet = function(it, key) {
                    try {
                        return it[key];
                    } catch (error) {}
                };
                module1.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                    var O, tag, result;
                    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object1(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
                };
            /***/ },
            /* 93 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var test = {};
                test[TO_STRING_TAG] = 'z';
                module1.exports = String(test) === '[object z]';
            /***/ },
            /* 94 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var call = __w_pdfjs_require__(14);
                var anObject = __w_pdfjs_require__(49);
                var getMethod = __w_pdfjs_require__(33);
                module1.exports = function(iterator, kind, value) {
                    var innerResult, innerError;
                    anObject(iterator);
                    try {
                        innerResult = getMethod(iterator, 'return');
                        if (!innerResult) {
                            if (kind === 'throw') throw value;
                            return value;
                        }
                        innerResult = call(innerResult, iterator);
                    } catch (error) {
                        innerError = true;
                        innerResult = error;
                    }
                    if (kind === 'throw') throw value;
                    if (innerError) throw innerResult;
                    anObject(innerResult);
                    return value;
                };
            /***/ },
            /* 95 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var toPropertyKey = __w_pdfjs_require__(22);
                var definePropertyModule = __w_pdfjs_require__(48);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                module1.exports = function(object, key, value) {
                    var propertyKey = toPropertyKey(key);
                    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                    else object[propertyKey] = value;
                };
            /***/ },
            /* 96 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                module1.exports = global1;
            /***/ },
            /* 97 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                __w_pdfjs_require__(98);
                __w_pdfjs_require__(71);
                __w_pdfjs_require__(105);
                __w_pdfjs_require__(107);
                __w_pdfjs_require__(129);
                __w_pdfjs_require__(130);
                __w_pdfjs_require__(131);
                __w_pdfjs_require__(132);
                var path = __w_pdfjs_require__(96);
                module1.exports = path.Promise;
            /***/ },
            /* 98 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var global1 = __w_pdfjs_require__(10);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var getPrototypeOf = __w_pdfjs_require__(81);
                var setPrototypeOf = __w_pdfjs_require__(84);
                var copyConstructorProperties = __w_pdfjs_require__(57);
                var create = __w_pdfjs_require__(73);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                var clearErrorStack = __w_pdfjs_require__(99);
                var installErrorCause = __w_pdfjs_require__(101);
                var iterate = __w_pdfjs_require__(87);
                var normalizeStringArgument = __w_pdfjs_require__(102);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var ERROR_STACK_INSTALLABLE = __w_pdfjs_require__(104);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var Error1 = global1.Error;
                var push = [].push;
                var $AggregateError = function AggregateError(errors, message) {
                    var options = arguments.length > 2 ? arguments[2] : undefined;
                    var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
                    var that;
                    if (setPrototypeOf) that = setPrototypeOf(new Error1(undefined), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
                    else {
                        that = isInstance ? this : create(AggregateErrorPrototype);
                        createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
                    }
                    createNonEnumerableProperty(that, 'message', normalizeStringArgument(message, ''));
                    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
                    installErrorCause(that, options);
                    var errorsArray = [];
                    iterate(errors, push, {
                        that: errorsArray
                    });
                    createNonEnumerableProperty(that, 'errors', errorsArray);
                    return that;
                };
                if (setPrototypeOf) setPrototypeOf($AggregateError, Error1);
                else copyConstructorProperties($AggregateError, Error1);
                var AggregateErrorPrototype = $AggregateError.prototype = create(Error1.prototype, {
                    constructor: createPropertyDescriptor(1, $AggregateError),
                    message: createPropertyDescriptor(1, ''),
                    name: createPropertyDescriptor(1, 'AggregateError')
                });
                $({
                    global: true
                }, {
                    AggregateError: $AggregateError
                });
            /***/ },
            /* 99 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var arraySlice = __w_pdfjs_require__(100);
                var replace = uncurryThis(''.replace);
                var split = uncurryThis(''.split);
                var join = uncurryThis([].join);
                var TEST = function(arg) {
                    return String(Error(arg).stack);
                }('zxcasd');
                var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
                var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
                var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);
                module1.exports = function(stack, dropEntries) {
                    if (typeof stack != 'string') return stack;
                    if (IS_V8_OR_CHAKRA_STACK) while(dropEntries--)stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
                    else if (IS_FIREFOX_OR_SAFARI_STACK) return join(arraySlice(split(stack, '\n'), dropEntries), '\n');
                    return stack;
                };
            /***/ },
            /* 100 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var toAbsoluteIndex = __w_pdfjs_require__(62);
                var lengthOfArrayLike = __w_pdfjs_require__(64);
                var createProperty = __w_pdfjs_require__(95);
                var Array1 = global1.Array;
                var max = Math.max;
                module1.exports = function(O, start, end) {
                    var length = lengthOfArrayLike(O);
                    var k = toAbsoluteIndex(start, length);
                    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                    var result = Array1(max(fin - k, 0));
                    for(var n = 0; k < fin; k++, n++)createProperty(result, n, O[k]);
                    result.length = n;
                    return result;
                };
            /***/ },
            /* 101 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var isObject = __w_pdfjs_require__(24);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                module1.exports = function(O, options) {
                    if (isObject(options) && 'cause' in options) createNonEnumerableProperty(O, 'cause', options.cause);
                };
            /***/ },
            /* 102 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toString = __w_pdfjs_require__(103);
                module1.exports = function(argument, $default) {
                    return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
                };
            /***/ },
            /* 103 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var classof = __w_pdfjs_require__(92);
                var String1 = global1.String;
                module1.exports = function(argument) {
                    if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
                    return String1(argument);
                };
            /***/ },
            /* 104 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                module1.exports = !fails(function() {
                    var error = Error('a');
                    if (!('stack' in error)) return true;
                    Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
                    return error.stack !== 7;
                });
            /***/ },
            /* 105 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(93);
                var redefine = __w_pdfjs_require__(50);
                var toString = __w_pdfjs_require__(106);
                if (!TO_STRING_TAG_SUPPORT) redefine(Object.prototype, 'toString', toString, {
                    unsafe: true
                });
            /***/ },
            /* 106 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(93);
                var classof = __w_pdfjs_require__(92);
                module1.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
                    return '[object ' + classof(this) + ']';
                };
            /***/ },
            /* 107 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var IS_PURE = __w_pdfjs_require__(39);
                var global1 = __w_pdfjs_require__(10);
                var getBuiltIn = __w_pdfjs_require__(27);
                var call = __w_pdfjs_require__(14);
                var NativePromise = __w_pdfjs_require__(108);
                var redefine = __w_pdfjs_require__(50);
                var redefineAll = __w_pdfjs_require__(109);
                var setPrototypeOf = __w_pdfjs_require__(84);
                var setToStringTag = __w_pdfjs_require__(83);
                var setSpecies = __w_pdfjs_require__(110);
                var aCallable = __w_pdfjs_require__(34);
                var isCallable = __w_pdfjs_require__(25);
                var isObject = __w_pdfjs_require__(24);
                var anInstance = __w_pdfjs_require__(111);
                var inspectSource = __w_pdfjs_require__(51);
                var iterate = __w_pdfjs_require__(87);
                var checkCorrectnessOfIteration = __w_pdfjs_require__(112);
                var speciesConstructor = __w_pdfjs_require__(113);
                var task = __w_pdfjs_require__(116).set;
                var microtask = __w_pdfjs_require__(121);
                var promiseResolve = __w_pdfjs_require__(124);
                var hostReportErrors = __w_pdfjs_require__(126);
                var newPromiseCapabilityModule = __w_pdfjs_require__(125);
                var perform = __w_pdfjs_require__(127);
                var InternalStateModule = __w_pdfjs_require__(52);
                var isForced = __w_pdfjs_require__(68);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var IS_BROWSER = __w_pdfjs_require__(128);
                var IS_NODE = __w_pdfjs_require__(120);
                var V8_VERSION = __w_pdfjs_require__(31);
                var SPECIES = wellKnownSymbol('species');
                var PROMISE = 'Promise';
                var getInternalState = InternalStateModule.getterFor(PROMISE);
                var setInternalState = InternalStateModule.set;
                var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
                var NativePromisePrototype = NativePromise && NativePromise.prototype;
                var PromiseConstructor = NativePromise;
                var PromisePrototype = NativePromisePrototype;
                var TypeError1 = global1.TypeError;
                var document1 = global1.document;
                var process = global1.process;
                var newPromiseCapability = newPromiseCapabilityModule.f;
                var newGenericPromiseCapability = newPromiseCapability;
                var DISPATCH_EVENT = !!(document1 && document1.createEvent && global1.dispatchEvent);
                var NATIVE_REJECTION_EVENT = isCallable(global1.PromiseRejectionEvent);
                var UNHANDLED_REJECTION = 'unhandledrejection';
                var REJECTION_HANDLED = 'rejectionhandled';
                var PENDING = 0;
                var FULFILLED = 1;
                var REJECTED = 2;
                var HANDLED = 1;
                var UNHANDLED = 2;
                var SUBCLASSING = false;
                var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
                var FORCED = isForced(PROMISE, function() {
                    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
                    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
                    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
                    if (IS_PURE && !PromisePrototype['finally']) return true;
                    if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
                    var promise = new PromiseConstructor(function(resolve) {
                        resolve(1);
                    });
                    var FakePromise = function(exec) {
                        exec(function() {}, function() {});
                    };
                    var constructor = promise.constructor = {};
                    constructor[SPECIES] = FakePromise;
                    SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
                    if (!SUBCLASSING) return true;
                    return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
                });
                var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
                    PromiseConstructor.all(iterable)['catch'](function() {});
                });
                var isThenable = function(it) {
                    var then;
                    return isObject(it) && isCallable(then = it.then) ? then : false;
                };
                var notify = function(state, isReject) {
                    if (state.notified) return;
                    state.notified = true;
                    var chain = state.reactions;
                    microtask(function() {
                        var value = state.value;
                        var ok = state.state == FULFILLED;
                        var index = 0;
                        while(chain.length > index){
                            var reaction = chain[index++];
                            var handler = ok ? reaction.ok : reaction.fail;
                            var resolve = reaction.resolve;
                            var reject = reaction.reject;
                            var domain = reaction.domain;
                            var result, then, exited;
                            try {
                                if (handler) {
                                    if (!ok) {
                                        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                                        state.rejection = HANDLED;
                                    }
                                    if (handler === true) result = value;
                                    else {
                                        if (domain) domain.enter();
                                        result = handler(value);
                                        if (domain) {
                                            domain.exit();
                                            exited = true;
                                        }
                                    }
                                    if (result === reaction.promise) reject(TypeError1('Promise-chain cycle'));
                                    else if (then = isThenable(result)) call(then, result, resolve, reject);
                                    else resolve(result);
                                } else reject(value);
                            } catch (error) {
                                if (domain && !exited) domain.exit();
                                reject(error);
                            }
                        }
                        state.reactions = [];
                        state.notified = false;
                        if (isReject && !state.rejection) onUnhandled(state);
                    });
                };
                var dispatchEvent = function(name, promise, reason) {
                    var event, handler;
                    if (DISPATCH_EVENT) {
                        event = document1.createEvent('Event');
                        event.promise = promise;
                        event.reason = reason;
                        event.initEvent(name, false, true);
                        global1.dispatchEvent(event);
                    } else event = {
                        promise: promise,
                        reason: reason
                    };
                    if (!NATIVE_REJECTION_EVENT && (handler = global1['on' + name])) handler(event);
                    else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
                };
                var onUnhandled = function(state) {
                    call(task, global1, function() {
                        var promise = state.facade;
                        var value = state.value;
                        var IS_UNHANDLED = isUnhandled(state);
                        var result;
                        if (IS_UNHANDLED) {
                            result = perform(function() {
                                if (IS_NODE) process.emit('unhandledRejection', value, promise);
                                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                            });
                            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                            if (result.error) throw result.value;
                        }
                    });
                };
                var isUnhandled = function(state) {
                    return state.rejection !== HANDLED && !state.parent;
                };
                var onHandleUnhandled = function(state) {
                    call(task, global1, function() {
                        var promise = state.facade;
                        if (IS_NODE) process.emit('rejectionHandled', promise);
                        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
                    });
                };
                var bind = function(fn, state, unwrap) {
                    return function(value) {
                        fn(state, value, unwrap);
                    };
                };
                var internalReject = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    state.value = value;
                    state.state = REJECTED;
                    notify(state, true);
                };
                var internalResolve = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    try {
                        if (state.facade === value) throw TypeError1("Promise can't be resolved itself");
                        var then = isThenable(value);
                        if (then) microtask(function() {
                            var wrapper = {
                                done: false
                            };
                            try {
                                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
                            } catch (error) {
                                internalReject(wrapper, error, state);
                            }
                        });
                        else {
                            state.value = value;
                            state.state = FULFILLED;
                            notify(state, false);
                        }
                    } catch (error) {
                        internalReject({
                            done: false
                        }, error, state);
                    }
                };
                if (FORCED) {
                    PromiseConstructor = function Promise1(executor) {
                        anInstance(this, PromisePrototype);
                        aCallable(executor);
                        call(Internal, this);
                        var state = getInternalState(this);
                        try {
                            executor(bind(internalResolve, state), bind(internalReject, state));
                        } catch (error) {
                            internalReject(state, error);
                        }
                    };
                    PromisePrototype = PromiseConstructor.prototype;
                    Internal = function Promise1(executor) {
                        setInternalState(this, {
                            type: PROMISE,
                            done: false,
                            notified: false,
                            parent: false,
                            reactions: [],
                            rejection: false,
                            state: PENDING,
                            value: undefined
                        });
                    };
                    Internal.prototype = redefineAll(PromisePrototype, {
                        then: function then(onFulfilled, onRejected) {
                            var state = getInternalPromiseState(this);
                            var reactions = state.reactions;
                            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                            reaction.fail = isCallable(onRejected) && onRejected;
                            reaction.domain = IS_NODE ? process.domain : undefined;
                            state.parent = true;
                            reactions[reactions.length] = reaction;
                            if (state.state != PENDING) notify(state, false);
                            return reaction.promise;
                        },
                        'catch': function(onRejected) {
                            return this.then(undefined, onRejected);
                        }
                    });
                    OwnPromiseCapability = function() {
                        var promise = new Internal();
                        var state = getInternalState(promise);
                        this.promise = promise;
                        this.resolve = bind(internalResolve, state);
                        this.reject = bind(internalReject, state);
                    };
                    newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
                        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
                    };
                    if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
                        nativeThen = NativePromisePrototype.then;
                        if (!SUBCLASSING) {
                            redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                                var that = this;
                                return new PromiseConstructor(function(resolve, reject) {
                                    call(nativeThen, that, resolve, reject);
                                }).then(onFulfilled, onRejected);
                            }, {
                                unsafe: true
                            });
                            redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], {
                                unsafe: true
                            });
                        }
                        try {
                            delete NativePromisePrototype.constructor;
                        } catch (error) {}
                        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
                    }
                }
                $({
                    global: true,
                    wrap: true,
                    forced: FORCED
                }, {
                    Promise: PromiseConstructor
                });
                setToStringTag(PromiseConstructor, PROMISE, false, true);
                setSpecies(PROMISE);
                PromiseWrapper = getBuiltIn(PROMISE);
                $({
                    target: PROMISE,
                    stat: true,
                    forced: FORCED
                }, {
                    reject: function reject(r) {
                        var capability = newPromiseCapability(this);
                        call(capability.reject, undefined, r);
                        return capability.promise;
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: IS_PURE || FORCED
                }, {
                    resolve: function resolve(x) {
                        return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    all: function all(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call($promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = value;
                                    --remaining || resolve(values);
                                }, reject);
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    },
                    race: function race(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            iterate(iterable, function(promise) {
                                call($promiseResolve, C, promise).then(capability.resolve, reject);
                            });
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /* 108 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                module1.exports = global1.Promise;
            /***/ },
            /* 109 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var redefine = __w_pdfjs_require__(50);
                module1.exports = function(target, src, options) {
                    for(var key in src)redefine(target, key, src[key], options);
                    return target;
                };
            /***/ },
            /* 110 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var getBuiltIn = __w_pdfjs_require__(27);
                var definePropertyModule = __w_pdfjs_require__(48);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(CONSTRUCTOR_NAME) {
                    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
                    var defineProperty = definePropertyModule.f;
                    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineProperty(Constructor, SPECIES, {
                        configurable: true,
                        get: function() {
                            return this;
                        }
                    });
                };
            /***/ },
            /* 111 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var TypeError1 = global1.TypeError;
                module1.exports = function(it, Prototype) {
                    if (isPrototypeOf(Prototype, it)) return it;
                    throw TypeError1('Incorrect invocation');
                };
            /***/ },
            /* 112 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var ITERATOR = wellKnownSymbol('iterator');
                var SAFE_CLOSING = false;
                try {
                    var called = 0;
                    var iteratorWithReturn = {
                        next: function() {
                            return {
                                done: !!called++
                            };
                        },
                        'return': function() {
                            SAFE_CLOSING = true;
                        }
                    };
                    iteratorWithReturn[ITERATOR] = function() {
                        return this;
                    };
                    Array.from(iteratorWithReturn, function() {
                        throw 2;
                    });
                } catch (error) {}
                module1.exports = function(exec, SKIP_CLOSING) {
                    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                    var ITERATION_SUPPORT = false;
                    try {
                        var object = {};
                        object[ITERATOR] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: ITERATION_SUPPORT = true
                                    };
                                }
                            };
                        };
                        exec(object);
                    } catch (error) {}
                    return ITERATION_SUPPORT;
                };
            /***/ },
            /* 113 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var anObject = __w_pdfjs_require__(49);
                var aConstructor = __w_pdfjs_require__(114);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(O, defaultConstructor) {
                    var C = anObject(O).constructor;
                    var S;
                    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
                };
            /***/ },
            /* 114 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isConstructor = __w_pdfjs_require__(115);
                var tryToString = __w_pdfjs_require__(35);
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (isConstructor(argument)) return argument;
                    throw TypeError1(tryToString(argument) + ' is not a constructor');
                };
            /***/ },
            /* 115 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var fails = __w_pdfjs_require__(13);
                var isCallable = __w_pdfjs_require__(25);
                var classof = __w_pdfjs_require__(92);
                var getBuiltIn = __w_pdfjs_require__(27);
                var inspectSource = __w_pdfjs_require__(51);
                var noop = function() {};
                var empty = [];
                var construct = getBuiltIn('Reflect', 'construct');
                var constructorRegExp = /^\s*(?:class|function)\b/;
                var exec = uncurryThis(constructorRegExp.exec);
                var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
                var isConstructorModern = function(argument) {
                    if (!isCallable(argument)) return false;
                    try {
                        construct(noop, empty, argument);
                        return true;
                    } catch (error) {
                        return false;
                    }
                };
                var isConstructorLegacy = function(argument) {
                    if (!isCallable(argument)) return false;
                    switch(classof(argument)){
                        case 'AsyncFunction':
                        case 'GeneratorFunction':
                        case 'AsyncGeneratorFunction':
                            return false;
                    }
                    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
                };
                module1.exports = !construct || fails(function() {
                    var called;
                    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                        called = true;
                    }) || called;
                }) ? isConstructorLegacy : isConstructorModern;
            /***/ },
            /* 116 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var apply = __w_pdfjs_require__(117);
                var bind = __w_pdfjs_require__(88);
                var isCallable = __w_pdfjs_require__(25);
                var hasOwn = __w_pdfjs_require__(42);
                var fails = __w_pdfjs_require__(13);
                var html = __w_pdfjs_require__(76);
                var arraySlice = __w_pdfjs_require__(118);
                var createElement = __w_pdfjs_require__(46);
                var IS_IOS = __w_pdfjs_require__(119);
                var IS_NODE = __w_pdfjs_require__(120);
                var set = global1.setImmediate;
                var clear = global1.clearImmediate;
                var process = global1.process;
                var Dispatch = global1.Dispatch;
                var Function1 = global1.Function;
                var MessageChannel = global1.MessageChannel;
                var String1 = global1.String;
                var counter = 0;
                var queue = {};
                var ONREADYSTATECHANGE = 'onreadystatechange';
                var location, defer, channel, port;
                try {
                    location = global1.location;
                } catch (error) {}
                var run = function(id) {
                    if (hasOwn(queue, id)) {
                        var fn = queue[id];
                        delete queue[id];
                        fn();
                    }
                };
                var runner = function(id) {
                    return function() {
                        run(id);
                    };
                };
                var listener = function(event) {
                    run(event.data);
                };
                var post = function(id) {
                    global1.postMessage(String1(id), location.protocol + '//' + location.host);
                };
                if (!set || !clear) {
                    set = function setImmediate(fn) {
                        var args = arraySlice(arguments, 1);
                        queue[++counter] = function() {
                            apply(isCallable(fn) ? fn : Function1(fn), undefined, args);
                        };
                        defer(counter);
                        return counter;
                    };
                    clear = function clearImmediate(id) {
                        delete queue[id];
                    };
                    if (IS_NODE) defer = function(id) {
                        process.nextTick(runner(id));
                    };
                    else if (Dispatch && Dispatch.now) defer = function(id) {
                        Dispatch.now(runner(id));
                    };
                    else if (MessageChannel && !IS_IOS) {
                        channel = new MessageChannel();
                        port = channel.port2;
                        channel.port1.onmessage = listener;
                        defer = bind(port.postMessage, port);
                    } else if (global1.addEventListener && isCallable(global1.postMessage) && !global1.importScripts && location && location.protocol !== 'file:' && !fails(post)) {
                        defer = post;
                        global1.addEventListener('message', listener, false);
                    } else if (ONREADYSTATECHANGE in createElement('script')) defer = function(id) {
                        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
                            html.removeChild(this);
                            run(id);
                        };
                    };
                    else defer = function(id) {
                        setTimeout(runner(id), 0);
                    };
                }
                module1.exports = {
                    set: set,
                    clear: clear
                };
            /***/ },
            /* 117 */ /***/ (module1)=>{
                var FunctionPrototype = Function.prototype;
                var apply = FunctionPrototype.apply;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                module1.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function() {
                    return call.apply(apply, arguments);
                });
            /***/ },
            /* 118 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                module1.exports = uncurryThis([].slice);
            /***/ },
            /* 119 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var userAgent = __w_pdfjs_require__(32);
                module1.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
            /***/ },
            /* 120 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var classof = __w_pdfjs_require__(20);
                var global1 = __w_pdfjs_require__(10);
                module1.exports = classof(global1.process) == 'process';
            /***/ },
            /* 121 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var bind = __w_pdfjs_require__(88);
                var getOwnPropertyDescriptor = __w_pdfjs_require__(11).f;
                var macrotask = __w_pdfjs_require__(116).set;
                var IS_IOS = __w_pdfjs_require__(119);
                var IS_IOS_PEBBLE = __w_pdfjs_require__(122);
                var IS_WEBOS_WEBKIT = __w_pdfjs_require__(123);
                var IS_NODE = __w_pdfjs_require__(120);
                var MutationObserver = global1.MutationObserver || global1.WebKitMutationObserver;
                var document1 = global1.document;
                var process = global1.process;
                var Promise1 = global1.Promise;
                var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global1, 'queueMicrotask');
                var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
                var flush, head, last, notify, toggle, node, promise, then;
                if (!queueMicrotask) {
                    flush = function() {
                        var parent, fn;
                        if (IS_NODE && (parent = process.domain)) parent.exit();
                        while(head){
                            fn = head.fn;
                            head = head.next;
                            try {
                                fn();
                            } catch (error) {
                                if (head) notify();
                                else last = undefined;
                                throw error;
                            }
                        }
                        last = undefined;
                        if (parent) parent.enter();
                    };
                    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document1) {
                        toggle = true;
                        node = document1.createTextNode('');
                        new MutationObserver(flush).observe(node, {
                            characterData: true
                        });
                        notify = function() {
                            node.data = toggle = !toggle;
                        };
                    } else if (!IS_IOS_PEBBLE && Promise1 && Promise1.resolve) {
                        promise = Promise1.resolve(undefined);
                        promise.constructor = Promise1;
                        then = bind(promise.then, promise);
                        notify = function() {
                            then(flush);
                        };
                    } else if (IS_NODE) notify = function() {
                        process.nextTick(flush);
                    };
                    else {
                        macrotask = bind(macrotask, global1);
                        notify = function() {
                            macrotask(flush);
                        };
                    }
                }
                module1.exports = queueMicrotask || function(fn) {
                    var task = {
                        fn: fn,
                        next: undefined
                    };
                    if (last) last.next = task;
                    if (!head) {
                        head = task;
                        notify();
                    }
                    last = task;
                };
            /***/ },
            /* 122 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var userAgent = __w_pdfjs_require__(32);
                var global1 = __w_pdfjs_require__(10);
                module1.exports = /ipad|iphone|ipod/i.test(userAgent) && global1.Pebble !== undefined;
            /***/ },
            /* 123 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var userAgent = __w_pdfjs_require__(32);
                module1.exports = /web0s(?!.*chrome)/i.test(userAgent);
            /***/ },
            /* 124 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var anObject = __w_pdfjs_require__(49);
                var isObject = __w_pdfjs_require__(24);
                var newPromiseCapability = __w_pdfjs_require__(125);
                module1.exports = function(C, x) {
                    anObject(C);
                    if (isObject(x) && x.constructor === C) return x;
                    var promiseCapability = newPromiseCapability.f(C);
                    var resolve = promiseCapability.resolve;
                    resolve(x);
                    return promiseCapability.promise;
                };
            /***/ },
            /* 125 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var aCallable = __w_pdfjs_require__(34);
                var PromiseCapability = function(C) {
                    var resolve, reject;
                    this.promise = new C(function($$resolve, $$reject) {
                        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
                        resolve = $$resolve;
                        reject = $$reject;
                    });
                    this.resolve = aCallable(resolve);
                    this.reject = aCallable(reject);
                };
                module1.exports.f = function(C) {
                    return new PromiseCapability(C);
                };
            /***/ },
            /* 126 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                module1.exports = function(a, b) {
                    var console1 = global1.console;
                    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
                };
            /***/ },
            /* 127 */ /***/ (module1)=>{
                module1.exports = function(exec) {
                    try {
                        return {
                            error: false,
                            value: exec()
                        };
                    } catch (error) {
                        return {
                            error: true,
                            value: error
                        };
                    }
                };
            /***/ },
            /* 128 */ /***/ (module1)=>{
                module1.exports = typeof window == 'object';
            /***/ },
            /* 129 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var call = __w_pdfjs_require__(14);
                var aCallable = __w_pdfjs_require__(34);
                var newPromiseCapabilityModule = __w_pdfjs_require__(125);
                var perform = __w_pdfjs_require__(127);
                var iterate = __w_pdfjs_require__(87);
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    allSettled: function allSettled(iterable) {
                        var C = this;
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: 'fulfilled',
                                        value: value
                                    };
                                    --remaining || resolve(values);
                                }, function(error) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: 'rejected',
                                        reason: error
                                    };
                                    --remaining || resolve(values);
                                });
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /* 130 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var aCallable = __w_pdfjs_require__(34);
                var getBuiltIn = __w_pdfjs_require__(27);
                var call = __w_pdfjs_require__(14);
                var newPromiseCapabilityModule = __w_pdfjs_require__(125);
                var perform = __w_pdfjs_require__(127);
                var iterate = __w_pdfjs_require__(87);
                var PROMISE_ANY_ERROR = 'No one promise resolved';
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    any: function any(iterable) {
                        var C = this;
                        var AggregateError = getBuiltIn('AggregateError');
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var errors = [];
                            var counter = 0;
                            var remaining = 1;
                            var alreadyResolved = false;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyRejected = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyResolved = true;
                                    resolve(value);
                                }, function(error) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyRejected = true;
                                    errors[index] = error;
                                    --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                                });
                            });
                            --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /* 131 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var IS_PURE = __w_pdfjs_require__(39);
                var NativePromise = __w_pdfjs_require__(108);
                var fails = __w_pdfjs_require__(13);
                var getBuiltIn = __w_pdfjs_require__(27);
                var isCallable = __w_pdfjs_require__(25);
                var speciesConstructor = __w_pdfjs_require__(113);
                var promiseResolve = __w_pdfjs_require__(124);
                var redefine = __w_pdfjs_require__(50);
                var NON_GENERIC = !!NativePromise && fails(function() {
                    NativePromise.prototype['finally'].call({
                        then: function() {}
                    }, function() {});
                });
                $({
                    target: 'Promise',
                    proto: true,
                    real: true,
                    forced: NON_GENERIC
                }, {
                    'finally': function(onFinally) {
                        var C = speciesConstructor(this, getBuiltIn('Promise'));
                        var isFunction = isCallable(onFinally);
                        return this.then(isFunction ? function(x) {
                            return promiseResolve(C, onFinally()).then(function() {
                                return x;
                            });
                        } : onFinally, isFunction ? function(e) {
                            return promiseResolve(C, onFinally()).then(function() {
                                throw e;
                            });
                        } : onFinally);
                    }
                });
                if (!IS_PURE && isCallable(NativePromise)) {
                    var method = getBuiltIn('Promise').prototype['finally'];
                    if (NativePromise.prototype['finally'] !== method) redefine(NativePromise.prototype, 'finally', method, {
                        unsafe: true
                    });
                }
            /***/ },
            /* 132 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var charAt = __w_pdfjs_require__(133).charAt;
                var toString = __w_pdfjs_require__(103);
                var InternalStateModule = __w_pdfjs_require__(52);
                var defineIterator = __w_pdfjs_require__(78);
                var STRING_ITERATOR = 'String Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
                defineIterator(String, 'String', function(iterated) {
                    setInternalState(this, {
                        type: STRING_ITERATOR,
                        string: toString(iterated),
                        index: 0
                    });
                }, function next() {
                    var state = getInternalState(this);
                    var string = state.string;
                    var index = state.index;
                    var point;
                    if (index >= string.length) return {
                        value: undefined,
                        done: true
                    };
                    point = charAt(string, index);
                    state.index += point.length;
                    return {
                        value: point,
                        done: false
                    };
                });
            /***/ },
            /* 133 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var toIntegerOrInfinity = __w_pdfjs_require__(63);
                var toString = __w_pdfjs_require__(103);
                var requireObjectCoercible = __w_pdfjs_require__(21);
                var charAt = uncurryThis(''.charAt);
                var charCodeAt = uncurryThis(''.charCodeAt);
                var stringSlice = uncurryThis(''.slice);
                var createMethod = function(CONVERT_TO_STRING) {
                    return function($this, pos) {
                        var S = toString(requireObjectCoercible($this));
                        var position = toIntegerOrInfinity(pos);
                        var size = S.length;
                        var first, second;
                        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                        first = charCodeAt(S, position);
                        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
                    };
                };
                module1.exports = {
                    codeAt: createMethod(false),
                    charAt: createMethod(true)
                };
            /***/ },
            /* 134 */ /***/ function(__unused_webpack_module, exports) {
                (function(global1, factory) {
                    factory(exports);
                })(this, function(exports) {
                    'use strict';
                    var SymbolPolyfill = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol : function(description) {
                        return "Symbol(" + description + ")";
                    };
                    function noop() {
                        return undefined;
                    }
                    function getGlobals() {
                        if (typeof self !== 'undefined') return self;
                        else if (typeof window !== 'undefined') return window;
                        else if (typeof $parcel$global !== 'undefined') return $parcel$global;
                        return undefined;
                    }
                    var globals = getGlobals();
                    function typeIsObject(x) {
                        return typeof x === 'object' && x !== null || typeof x === 'function';
                    }
                    var rethrowAssertionErrorRejection = noop;
                    var originalPromise = Promise;
                    var originalPromiseThen = Promise.prototype.then;
                    var originalPromiseResolve = Promise.resolve.bind(originalPromise);
                    var originalPromiseReject = Promise.reject.bind(originalPromise);
                    function newPromise(executor) {
                        return new originalPromise(executor);
                    }
                    function promiseResolvedWith(value) {
                        return originalPromiseResolve(value);
                    }
                    function promiseRejectedWith(reason) {
                        return originalPromiseReject(reason);
                    }
                    function PerformPromiseThen(promise, onFulfilled, onRejected) {
                        return originalPromiseThen.call(promise, onFulfilled, onRejected);
                    }
                    function uponPromise(promise, onFulfilled, onRejected) {
                        PerformPromiseThen(PerformPromiseThen(promise, onFulfilled, onRejected), undefined, rethrowAssertionErrorRejection);
                    }
                    function uponFulfillment(promise, onFulfilled) {
                        uponPromise(promise, onFulfilled);
                    }
                    function uponRejection(promise, onRejected) {
                        uponPromise(promise, undefined, onRejected);
                    }
                    function transformPromiseWith(promise, fulfillmentHandler, rejectionHandler) {
                        return PerformPromiseThen(promise, fulfillmentHandler, rejectionHandler);
                    }
                    function setPromiseIsHandledToTrue(promise) {
                        PerformPromiseThen(promise, undefined, rethrowAssertionErrorRejection);
                    }
                    var queueMicrotask = function() {
                        var globalQueueMicrotask = globals && globals.queueMicrotask;
                        if (typeof globalQueueMicrotask === 'function') return globalQueueMicrotask;
                        var resolvedPromise = promiseResolvedWith(undefined);
                        return function(fn) {
                            return PerformPromiseThen(resolvedPromise, fn);
                        };
                    }();
                    function reflectCall(F, V, args) {
                        if (typeof F !== 'function') throw new TypeError('Argument is not a function');
                        return Function.prototype.apply.call(F, V, args);
                    }
                    function promiseCall(F, V, args) {
                        try {
                            return promiseResolvedWith(reflectCall(F, V, args));
                        } catch (value) {
                            return promiseRejectedWith(value);
                        }
                    }
                    var QUEUE_MAX_ARRAY_SIZE = 16384;
                    var SimpleQueue = function() {
                        function SimpleQueue() {
                            this._cursor = 0;
                            this._size = 0;
                            this._front = {
                                _elements: [],
                                _next: undefined
                            };
                            this._back = this._front;
                            this._cursor = 0;
                            this._size = 0;
                        }
                        Object.defineProperty(SimpleQueue.prototype, "length", {
                            get: function() {
                                return this._size;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        SimpleQueue.prototype.push = function(element) {
                            var oldBack = this._back;
                            var newBack = oldBack;
                            if (oldBack._elements.length === QUEUE_MAX_ARRAY_SIZE - 1) newBack = {
                                _elements: [],
                                _next: undefined
                            };
                            oldBack._elements.push(element);
                            if (newBack !== oldBack) {
                                this._back = newBack;
                                oldBack._next = newBack;
                            }
                            ++this._size;
                        };
                        SimpleQueue.prototype.shift = function() {
                            var oldFront = this._front;
                            var newFront = oldFront;
                            var oldCursor = this._cursor;
                            var newCursor = oldCursor + 1;
                            var elements = oldFront._elements;
                            var element = elements[oldCursor];
                            if (newCursor === QUEUE_MAX_ARRAY_SIZE) {
                                newFront = oldFront._next;
                                newCursor = 0;
                            }
                            --this._size;
                            this._cursor = newCursor;
                            if (oldFront !== newFront) this._front = newFront;
                            elements[oldCursor] = undefined;
                            return element;
                        };
                        SimpleQueue.prototype.forEach = function(callback) {
                            var i = this._cursor;
                            var node = this._front;
                            var elements = node._elements;
                            while(i !== elements.length || node._next !== undefined){
                                if (i === elements.length) {
                                    node = node._next;
                                    elements = node._elements;
                                    i = 0;
                                    if (elements.length === 0) break;
                                }
                                callback(elements[i]);
                                ++i;
                            }
                        };
                        SimpleQueue.prototype.peek = function() {
                            var front = this._front;
                            var cursor = this._cursor;
                            return front._elements[cursor];
                        };
                        return SimpleQueue;
                    }();
                    function ReadableStreamReaderGenericInitialize(reader, stream) {
                        reader._ownerReadableStream = stream;
                        stream._reader = reader;
                        if (stream._state === 'readable') defaultReaderClosedPromiseInitialize(reader);
                        else if (stream._state === 'closed') defaultReaderClosedPromiseInitializeAsResolved(reader);
                        else defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
                    }
                    function ReadableStreamReaderGenericCancel(reader, reason) {
                        var stream = reader._ownerReadableStream;
                        return ReadableStreamCancel(stream, reason);
                    }
                    function ReadableStreamReaderGenericRelease(reader) {
                        if (reader._ownerReadableStream._state === 'readable') defaultReaderClosedPromiseReject(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
                        else defaultReaderClosedPromiseResetToRejected(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
                        reader._ownerReadableStream._reader = undefined;
                        reader._ownerReadableStream = undefined;
                    }
                    function readerLockException(name) {
                        return new TypeError('Cannot ' + name + ' a stream using a released reader');
                    }
                    function defaultReaderClosedPromiseInitialize(reader) {
                        reader._closedPromise = newPromise(function(resolve, reject) {
                            reader._closedPromise_resolve = resolve;
                            reader._closedPromise_reject = reject;
                        });
                    }
                    function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
                        defaultReaderClosedPromiseInitialize(reader);
                        defaultReaderClosedPromiseReject(reader, reason);
                    }
                    function defaultReaderClosedPromiseInitializeAsResolved(reader) {
                        defaultReaderClosedPromiseInitialize(reader);
                        defaultReaderClosedPromiseResolve(reader);
                    }
                    function defaultReaderClosedPromiseReject(reader, reason) {
                        if (reader._closedPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue(reader._closedPromise);
                        reader._closedPromise_reject(reason);
                        reader._closedPromise_resolve = undefined;
                        reader._closedPromise_reject = undefined;
                    }
                    function defaultReaderClosedPromiseResetToRejected(reader, reason) {
                        defaultReaderClosedPromiseInitializeAsRejected(reader, reason);
                    }
                    function defaultReaderClosedPromiseResolve(reader) {
                        if (reader._closedPromise_resolve === undefined) return;
                        reader._closedPromise_resolve(undefined);
                        reader._closedPromise_resolve = undefined;
                        reader._closedPromise_reject = undefined;
                    }
                    var AbortSteps = SymbolPolyfill('[[AbortSteps]]');
                    var ErrorSteps = SymbolPolyfill('[[ErrorSteps]]');
                    var CancelSteps = SymbolPolyfill('[[CancelSteps]]');
                    var PullSteps = SymbolPolyfill('[[PullSteps]]');
                    var NumberIsFinite = Number.isFinite || function(x) {
                        return typeof x === 'number' && isFinite(x);
                    };
                    var MathTrunc = Math.trunc || function(v) {
                        return v < 0 ? Math.ceil(v) : Math.floor(v);
                    };
                    function isDictionary(x) {
                        return typeof x === 'object' || typeof x === 'function';
                    }
                    function assertDictionary(obj, context) {
                        if (obj !== undefined && !isDictionary(obj)) throw new TypeError(context + " is not an object.");
                    }
                    function assertFunction(x, context) {
                        if (typeof x !== 'function') throw new TypeError(context + " is not a function.");
                    }
                    function isObject(x) {
                        return typeof x === 'object' && x !== null || typeof x === 'function';
                    }
                    function assertObject(x, context) {
                        if (!isObject(x)) throw new TypeError(context + " is not an object.");
                    }
                    function assertRequiredArgument(x, position, context) {
                        if (x === undefined) throw new TypeError("Parameter " + position + " is required in '" + context + "'.");
                    }
                    function assertRequiredField(x, field, context) {
                        if (x === undefined) throw new TypeError(field + " is required in '" + context + "'.");
                    }
                    function convertUnrestrictedDouble(value) {
                        return Number(value);
                    }
                    function censorNegativeZero(x) {
                        return x === 0 ? 0 : x;
                    }
                    function integerPart(x) {
                        return censorNegativeZero(MathTrunc(x));
                    }
                    function convertUnsignedLongLongWithEnforceRange(value, context) {
                        var lowerBound = 0;
                        var upperBound = Number.MAX_SAFE_INTEGER;
                        var x = Number(value);
                        x = censorNegativeZero(x);
                        if (!NumberIsFinite(x)) throw new TypeError(context + " is not a finite number");
                        x = integerPart(x);
                        if (x < lowerBound || x > upperBound) throw new TypeError(context + " is outside the accepted range of " + lowerBound + " to " + upperBound + ", inclusive");
                        if (!NumberIsFinite(x) || x === 0) return 0;
                        return x;
                    }
                    function assertReadableStream(x, context) {
                        if (!IsReadableStream(x)) throw new TypeError(context + " is not a ReadableStream.");
                    }
                    function AcquireReadableStreamDefaultReader(stream) {
                        return new ReadableStreamDefaultReader(stream);
                    }
                    function ReadableStreamAddReadRequest(stream, readRequest) {
                        stream._reader._readRequests.push(readRequest);
                    }
                    function ReadableStreamFulfillReadRequest(stream, chunk, done) {
                        var reader = stream._reader;
                        var readRequest = reader._readRequests.shift();
                        if (done) readRequest._closeSteps();
                        else readRequest._chunkSteps(chunk);
                    }
                    function ReadableStreamGetNumReadRequests(stream) {
                        return stream._reader._readRequests.length;
                    }
                    function ReadableStreamHasDefaultReader(stream) {
                        var reader = stream._reader;
                        if (reader === undefined) return false;
                        if (!IsReadableStreamDefaultReader(reader)) return false;
                        return true;
                    }
                    var ReadableStreamDefaultReader = function() {
                        function ReadableStreamDefaultReader(stream) {
                            assertRequiredArgument(stream, 1, 'ReadableStreamDefaultReader');
                            assertReadableStream(stream, 'First parameter');
                            if (IsReadableStreamLocked(stream)) throw new TypeError('This stream has already been locked for exclusive reading by another reader');
                            ReadableStreamReaderGenericInitialize(this, stream);
                            this._readRequests = new SimpleQueue();
                        }
                        Object.defineProperty(ReadableStreamDefaultReader.prototype, "closed", {
                            get: function() {
                                if (!IsReadableStreamDefaultReader(this)) return promiseRejectedWith(defaultReaderBrandCheckException('closed'));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamDefaultReader.prototype.cancel = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsReadableStreamDefaultReader(this)) return promiseRejectedWith(defaultReaderBrandCheckException('cancel'));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('cancel'));
                            return ReadableStreamReaderGenericCancel(this, reason);
                        };
                        ReadableStreamDefaultReader.prototype.read = function() {
                            if (!IsReadableStreamDefaultReader(this)) return promiseRejectedWith(defaultReaderBrandCheckException('read'));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('read from'));
                            var resolvePromise;
                            var rejectPromise;
                            var promise = newPromise(function(resolve, reject) {
                                resolvePromise = resolve;
                                rejectPromise = reject;
                            });
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    return resolvePromise({
                                        value: chunk,
                                        done: false
                                    });
                                },
                                _closeSteps: function() {
                                    return resolvePromise({
                                        value: undefined,
                                        done: true
                                    });
                                },
                                _errorSteps: function(e) {
                                    return rejectPromise(e);
                                }
                            };
                            ReadableStreamDefaultReaderRead(this, readRequest);
                            return promise;
                        };
                        ReadableStreamDefaultReader.prototype.releaseLock = function() {
                            if (!IsReadableStreamDefaultReader(this)) throw defaultReaderBrandCheckException('releaseLock');
                            if (this._ownerReadableStream === undefined) return;
                            if (this._readRequests.length > 0) throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
                            ReadableStreamReaderGenericRelease(this);
                        };
                        return ReadableStreamDefaultReader;
                    }();
                    Object.defineProperties(ReadableStreamDefaultReader.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        read: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamDefaultReader.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamDefaultReader',
                        configurable: true
                    });
                    function IsReadableStreamDefaultReader(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) return false;
                        return x instanceof ReadableStreamDefaultReader;
                    }
                    function ReadableStreamDefaultReaderRead(reader, readRequest) {
                        var stream = reader._ownerReadableStream;
                        stream._disturbed = true;
                        if (stream._state === 'closed') readRequest._closeSteps();
                        else if (stream._state === 'errored') readRequest._errorSteps(stream._storedError);
                        else stream._readableStreamController[PullSteps](readRequest);
                    }
                    function defaultReaderBrandCheckException(name) {
                        return new TypeError("ReadableStreamDefaultReader.prototype." + name + " can only be used on a ReadableStreamDefaultReader");
                    }
                    var _a;
                    var AsyncIteratorPrototype;
                    if (typeof SymbolPolyfill.asyncIterator === 'symbol') {
                        AsyncIteratorPrototype = (_a = {}, _a[SymbolPolyfill.asyncIterator] = function() {
                            return this;
                        }, _a);
                        Object.defineProperty(AsyncIteratorPrototype, SymbolPolyfill.asyncIterator, {
                            enumerable: false
                        });
                    }
                    var ReadableStreamAsyncIteratorImpl = function() {
                        function ReadableStreamAsyncIteratorImpl(reader, preventCancel) {
                            this._ongoingPromise = undefined;
                            this._isFinished = false;
                            this._reader = reader;
                            this._preventCancel = preventCancel;
                        }
                        ReadableStreamAsyncIteratorImpl.prototype.next = function() {
                            var _this = this;
                            var nextSteps = function() {
                                return _this._nextSteps();
                            };
                            this._ongoingPromise = this._ongoingPromise ? transformPromiseWith(this._ongoingPromise, nextSteps, nextSteps) : nextSteps();
                            return this._ongoingPromise;
                        };
                        ReadableStreamAsyncIteratorImpl.prototype.return = function(value) {
                            var _this = this;
                            var returnSteps = function() {
                                return _this._returnSteps(value);
                            };
                            return this._ongoingPromise ? transformPromiseWith(this._ongoingPromise, returnSteps, returnSteps) : returnSteps();
                        };
                        ReadableStreamAsyncIteratorImpl.prototype._nextSteps = function() {
                            var _this = this;
                            if (this._isFinished) return Promise.resolve({
                                value: undefined,
                                done: true
                            });
                            var reader = this._reader;
                            if (reader._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('iterate'));
                            var resolvePromise;
                            var rejectPromise;
                            var promise = newPromise(function(resolve, reject) {
                                resolvePromise = resolve;
                                rejectPromise = reject;
                            });
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    _this._ongoingPromise = undefined;
                                    queueMicrotask(function() {
                                        return resolvePromise({
                                            value: chunk,
                                            done: false
                                        });
                                    });
                                },
                                _closeSteps: function() {
                                    _this._ongoingPromise = undefined;
                                    _this._isFinished = true;
                                    ReadableStreamReaderGenericRelease(reader);
                                    resolvePromise({
                                        value: undefined,
                                        done: true
                                    });
                                },
                                _errorSteps: function(reason) {
                                    _this._ongoingPromise = undefined;
                                    _this._isFinished = true;
                                    ReadableStreamReaderGenericRelease(reader);
                                    rejectPromise(reason);
                                }
                            };
                            ReadableStreamDefaultReaderRead(reader, readRequest);
                            return promise;
                        };
                        ReadableStreamAsyncIteratorImpl.prototype._returnSteps = function(value) {
                            if (this._isFinished) return Promise.resolve({
                                value: value,
                                done: true
                            });
                            this._isFinished = true;
                            var reader = this._reader;
                            if (reader._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('finish iterating'));
                            if (!this._preventCancel) {
                                var result = ReadableStreamReaderGenericCancel(reader, value);
                                ReadableStreamReaderGenericRelease(reader);
                                return transformPromiseWith(result, function() {
                                    return {
                                        value: value,
                                        done: true
                                    };
                                });
                            }
                            ReadableStreamReaderGenericRelease(reader);
                            return promiseResolvedWith({
                                value: value,
                                done: true
                            });
                        };
                        return ReadableStreamAsyncIteratorImpl;
                    }();
                    var ReadableStreamAsyncIteratorPrototype = {
                        next: function() {
                            if (!IsReadableStreamAsyncIterator(this)) return promiseRejectedWith(streamAsyncIteratorBrandCheckException('next'));
                            return this._asyncIteratorImpl.next();
                        },
                        return: function(value) {
                            if (!IsReadableStreamAsyncIterator(this)) return promiseRejectedWith(streamAsyncIteratorBrandCheckException('return'));
                            return this._asyncIteratorImpl.return(value);
                        }
                    };
                    if (AsyncIteratorPrototype !== undefined) Object.setPrototypeOf(ReadableStreamAsyncIteratorPrototype, AsyncIteratorPrototype);
                    function AcquireReadableStreamAsyncIterator(stream, preventCancel) {
                        var reader = AcquireReadableStreamDefaultReader(stream);
                        var impl = new ReadableStreamAsyncIteratorImpl(reader, preventCancel);
                        var iterator = Object.create(ReadableStreamAsyncIteratorPrototype);
                        iterator._asyncIteratorImpl = impl;
                        return iterator;
                    }
                    function IsReadableStreamAsyncIterator(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_asyncIteratorImpl')) return false;
                        try {
                            return x._asyncIteratorImpl instanceof ReadableStreamAsyncIteratorImpl;
                        } catch (_a) {
                            return false;
                        }
                    }
                    function streamAsyncIteratorBrandCheckException(name) {
                        return new TypeError("ReadableStreamAsyncIterator." + name + " can only be used on a ReadableSteamAsyncIterator");
                    }
                    var NumberIsNaN = Number.isNaN || function(x) {
                        return x !== x;
                    };
                    function CreateArrayFromList(elements) {
                        return elements.slice();
                    }
                    function CopyDataBlockBytes(dest, destOffset, src, srcOffset, n) {
                        new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
                    }
                    function TransferArrayBuffer(O) {
                        return O;
                    }
                    function IsDetachedBuffer(O) {
                        return false;
                    }
                    function ArrayBufferSlice(buffer, begin, end) {
                        if (buffer.slice) return buffer.slice(begin, end);
                        var length = end - begin;
                        var slice = new ArrayBuffer(length);
                        CopyDataBlockBytes(slice, 0, buffer, begin, length);
                        return slice;
                    }
                    function IsNonNegativeNumber(v) {
                        if (typeof v !== 'number') return false;
                        if (NumberIsNaN(v)) return false;
                        if (v < 0) return false;
                        return true;
                    }
                    function CloneAsUint8Array(O) {
                        var buffer = ArrayBufferSlice(O.buffer, O.byteOffset, O.byteOffset + O.byteLength);
                        return new Uint8Array(buffer);
                    }
                    function DequeueValue(container) {
                        var pair = container._queue.shift();
                        container._queueTotalSize -= pair.size;
                        if (container._queueTotalSize < 0) container._queueTotalSize = 0;
                        return pair.value;
                    }
                    function EnqueueValueWithSize(container, value, size) {
                        if (!IsNonNegativeNumber(size) || size === Infinity) throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
                        container._queue.push({
                            value: value,
                            size: size
                        });
                        container._queueTotalSize += size;
                    }
                    function PeekQueueValue(container) {
                        var pair = container._queue.peek();
                        return pair.value;
                    }
                    function ResetQueue(container) {
                        container._queue = new SimpleQueue();
                        container._queueTotalSize = 0;
                    }
                    var ReadableStreamBYOBRequest = function() {
                        function ReadableStreamBYOBRequest() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(ReadableStreamBYOBRequest.prototype, "view", {
                            get: function() {
                                if (!IsReadableStreamBYOBRequest(this)) throw byobRequestBrandCheckException('view');
                                return this._view;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamBYOBRequest.prototype.respond = function(bytesWritten) {
                            if (!IsReadableStreamBYOBRequest(this)) throw byobRequestBrandCheckException('respond');
                            assertRequiredArgument(bytesWritten, 1, 'respond');
                            bytesWritten = convertUnsignedLongLongWithEnforceRange(bytesWritten, 'First parameter');
                            if (this._associatedReadableByteStreamController === undefined) throw new TypeError('This BYOB request has been invalidated');
                            IsDetachedBuffer(this._view.buffer);
                            ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
                        };
                        ReadableStreamBYOBRequest.prototype.respondWithNewView = function(view) {
                            if (!IsReadableStreamBYOBRequest(this)) throw byobRequestBrandCheckException('respondWithNewView');
                            assertRequiredArgument(view, 1, 'respondWithNewView');
                            if (!ArrayBuffer.isView(view)) throw new TypeError('You can only respond with array buffer views');
                            if (this._associatedReadableByteStreamController === undefined) throw new TypeError('This BYOB request has been invalidated');
                            IsDetachedBuffer(view.buffer);
                            ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
                        };
                        return ReadableStreamBYOBRequest;
                    }();
                    Object.defineProperties(ReadableStreamBYOBRequest.prototype, {
                        respond: {
                            enumerable: true
                        },
                        respondWithNewView: {
                            enumerable: true
                        },
                        view: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamBYOBRequest.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamBYOBRequest',
                        configurable: true
                    });
                    var ReadableByteStreamController = function() {
                        function ReadableByteStreamController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(ReadableByteStreamController.prototype, "byobRequest", {
                            get: function() {
                                if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('byobRequest');
                                return ReadableByteStreamControllerGetBYOBRequest(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(ReadableByteStreamController.prototype, "desiredSize", {
                            get: function() {
                                if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('desiredSize');
                                return ReadableByteStreamControllerGetDesiredSize(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableByteStreamController.prototype.close = function() {
                            if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('close');
                            if (this._closeRequested) throw new TypeError('The stream has already been closed; do not close it again!');
                            var state = this._controlledReadableByteStream._state;
                            if (state !== 'readable') throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
                            ReadableByteStreamControllerClose(this);
                        };
                        ReadableByteStreamController.prototype.enqueue = function(chunk) {
                            if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('enqueue');
                            assertRequiredArgument(chunk, 1, 'enqueue');
                            if (!ArrayBuffer.isView(chunk)) throw new TypeError('chunk must be an array buffer view');
                            if (chunk.byteLength === 0) throw new TypeError('chunk must have non-zero byteLength');
                            if (chunk.buffer.byteLength === 0) throw new TypeError("chunk's buffer must have non-zero byteLength");
                            if (this._closeRequested) throw new TypeError('stream is closed or draining');
                            var state = this._controlledReadableByteStream._state;
                            if (state !== 'readable') throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
                            ReadableByteStreamControllerEnqueue(this, chunk);
                        };
                        ReadableByteStreamController.prototype.error = function(e) {
                            if (e === void 0) e = undefined;
                            if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('error');
                            ReadableByteStreamControllerError(this, e);
                        };
                        ReadableByteStreamController.prototype[CancelSteps] = function(reason) {
                            ReadableByteStreamControllerClearPendingPullIntos(this);
                            ResetQueue(this);
                            var result = this._cancelAlgorithm(reason);
                            ReadableByteStreamControllerClearAlgorithms(this);
                            return result;
                        };
                        ReadableByteStreamController.prototype[PullSteps] = function(readRequest) {
                            var stream = this._controlledReadableByteStream;
                            if (this._queueTotalSize > 0) {
                                var entry = this._queue.shift();
                                this._queueTotalSize -= entry.byteLength;
                                ReadableByteStreamControllerHandleQueueDrain(this);
                                var view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
                                readRequest._chunkSteps(view);
                                return;
                            }
                            var autoAllocateChunkSize = this._autoAllocateChunkSize;
                            if (autoAllocateChunkSize !== undefined) {
                                var buffer = void 0;
                                try {
                                    buffer = new ArrayBuffer(autoAllocateChunkSize);
                                } catch (bufferE) {
                                    readRequest._errorSteps(bufferE);
                                    return;
                                }
                                var pullIntoDescriptor = {
                                    buffer: buffer,
                                    bufferByteLength: autoAllocateChunkSize,
                                    byteOffset: 0,
                                    byteLength: autoAllocateChunkSize,
                                    bytesFilled: 0,
                                    elementSize: 1,
                                    viewConstructor: Uint8Array,
                                    readerType: 'default'
                                };
                                this._pendingPullIntos.push(pullIntoDescriptor);
                            }
                            ReadableStreamAddReadRequest(stream, readRequest);
                            ReadableByteStreamControllerCallPullIfNeeded(this);
                        };
                        return ReadableByteStreamController;
                    }();
                    Object.defineProperties(ReadableByteStreamController.prototype, {
                        close: {
                            enumerable: true
                        },
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        byobRequest: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableByteStreamController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableByteStreamController',
                        configurable: true
                    });
                    function IsReadableByteStreamController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableByteStream')) return false;
                        return x instanceof ReadableByteStreamController;
                    }
                    function IsReadableStreamBYOBRequest(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) return false;
                        return x instanceof ReadableStreamBYOBRequest;
                    }
                    function ReadableByteStreamControllerCallPullIfNeeded(controller) {
                        var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
                        if (!shouldPull) return;
                        if (controller._pulling) {
                            controller._pullAgain = true;
                            return;
                        }
                        controller._pulling = true;
                        var pullPromise = controller._pullAlgorithm();
                        uponPromise(pullPromise, function() {
                            controller._pulling = false;
                            if (controller._pullAgain) {
                                controller._pullAgain = false;
                                ReadableByteStreamControllerCallPullIfNeeded(controller);
                            }
                        }, function(e) {
                            ReadableByteStreamControllerError(controller, e);
                        });
                    }
                    function ReadableByteStreamControllerClearPendingPullIntos(controller) {
                        ReadableByteStreamControllerInvalidateBYOBRequest(controller);
                        controller._pendingPullIntos = new SimpleQueue();
                    }
                    function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
                        var done = false;
                        if (stream._state === 'closed') done = true;
                        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
                        if (pullIntoDescriptor.readerType === 'default') ReadableStreamFulfillReadRequest(stream, filledView, done);
                        else ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
                    }
                    function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
                        var bytesFilled = pullIntoDescriptor.bytesFilled;
                        var elementSize = pullIntoDescriptor.elementSize;
                        return new pullIntoDescriptor.viewConstructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
                    }
                    function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
                        controller._queue.push({
                            buffer: buffer,
                            byteOffset: byteOffset,
                            byteLength: byteLength
                        });
                        controller._queueTotalSize += byteLength;
                    }
                    function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
                        var elementSize = pullIntoDescriptor.elementSize;
                        var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
                        var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
                        var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
                        var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
                        var totalBytesToCopyRemaining = maxBytesToCopy;
                        var ready = false;
                        if (maxAlignedBytes > currentAlignedBytes) {
                            totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
                            ready = true;
                        }
                        var queue = controller._queue;
                        while(totalBytesToCopyRemaining > 0){
                            var headOfQueue = queue.peek();
                            var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
                            var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
                            CopyDataBlockBytes(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
                            if (headOfQueue.byteLength === bytesToCopy) queue.shift();
                            else {
                                headOfQueue.byteOffset += bytesToCopy;
                                headOfQueue.byteLength -= bytesToCopy;
                            }
                            controller._queueTotalSize -= bytesToCopy;
                            ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
                            totalBytesToCopyRemaining -= bytesToCopy;
                        }
                        return ready;
                    }
                    function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
                        pullIntoDescriptor.bytesFilled += size;
                    }
                    function ReadableByteStreamControllerHandleQueueDrain(controller) {
                        if (controller._queueTotalSize === 0 && controller._closeRequested) {
                            ReadableByteStreamControllerClearAlgorithms(controller);
                            ReadableStreamClose(controller._controlledReadableByteStream);
                        } else ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
                        if (controller._byobRequest === null) return;
                        controller._byobRequest._associatedReadableByteStreamController = undefined;
                        controller._byobRequest._view = null;
                        controller._byobRequest = null;
                    }
                    function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
                        while(controller._pendingPullIntos.length > 0){
                            if (controller._queueTotalSize === 0) return;
                            var pullIntoDescriptor = controller._pendingPullIntos.peek();
                            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor)) {
                                ReadableByteStreamControllerShiftPendingPullInto(controller);
                                ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
                            }
                        }
                    }
                    function ReadableByteStreamControllerPullInto(controller, view, readIntoRequest) {
                        var stream = controller._controlledReadableByteStream;
                        var elementSize = 1;
                        if (view.constructor !== DataView) elementSize = view.constructor.BYTES_PER_ELEMENT;
                        var ctor = view.constructor;
                        var buffer = TransferArrayBuffer(view.buffer);
                        var pullIntoDescriptor = {
                            buffer: buffer,
                            bufferByteLength: buffer.byteLength,
                            byteOffset: view.byteOffset,
                            byteLength: view.byteLength,
                            bytesFilled: 0,
                            elementSize: elementSize,
                            viewConstructor: ctor,
                            readerType: 'byob'
                        };
                        if (controller._pendingPullIntos.length > 0) {
                            controller._pendingPullIntos.push(pullIntoDescriptor);
                            ReadableStreamAddReadIntoRequest(stream, readIntoRequest);
                            return;
                        }
                        if (stream._state === 'closed') {
                            var emptyView = new ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
                            readIntoRequest._closeSteps(emptyView);
                            return;
                        }
                        if (controller._queueTotalSize > 0) {
                            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor)) {
                                var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
                                ReadableByteStreamControllerHandleQueueDrain(controller);
                                readIntoRequest._chunkSteps(filledView);
                                return;
                            }
                            if (controller._closeRequested) {
                                var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
                                ReadableByteStreamControllerError(controller, e);
                                readIntoRequest._errorSteps(e);
                                return;
                            }
                        }
                        controller._pendingPullIntos.push(pullIntoDescriptor);
                        ReadableStreamAddReadIntoRequest(stream, readIntoRequest);
                        ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
                        var stream = controller._controlledReadableByteStream;
                        if (ReadableStreamHasBYOBReader(stream)) while(ReadableStreamGetNumReadIntoRequests(stream) > 0){
                            var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
                            ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
                        }
                    }
                    function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
                        ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
                        if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) return;
                        ReadableByteStreamControllerShiftPendingPullInto(controller);
                        var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
                        if (remainderSize > 0) {
                            var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
                            var remainder = ArrayBufferSlice(pullIntoDescriptor.buffer, end - remainderSize, end);
                            ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
                        }
                        pullIntoDescriptor.bytesFilled -= remainderSize;
                        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
                        ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
                    }
                    function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
                        var firstDescriptor = controller._pendingPullIntos.peek();
                        ReadableByteStreamControllerInvalidateBYOBRequest(controller);
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'closed') ReadableByteStreamControllerRespondInClosedState(controller);
                        else ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
                        ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerShiftPendingPullInto(controller) {
                        var descriptor = controller._pendingPullIntos.shift();
                        return descriptor;
                    }
                    function ReadableByteStreamControllerShouldCallPull(controller) {
                        var stream = controller._controlledReadableByteStream;
                        if (stream._state !== 'readable') return false;
                        if (controller._closeRequested) return false;
                        if (!controller._started) return false;
                        if (ReadableStreamHasDefaultReader(stream) && ReadableStreamGetNumReadRequests(stream) > 0) return true;
                        if (ReadableStreamHasBYOBReader(stream) && ReadableStreamGetNumReadIntoRequests(stream) > 0) return true;
                        var desiredSize = ReadableByteStreamControllerGetDesiredSize(controller);
                        if (desiredSize > 0) return true;
                        return false;
                    }
                    function ReadableByteStreamControllerClearAlgorithms(controller) {
                        controller._pullAlgorithm = undefined;
                        controller._cancelAlgorithm = undefined;
                    }
                    function ReadableByteStreamControllerClose(controller) {
                        var stream = controller._controlledReadableByteStream;
                        if (controller._closeRequested || stream._state !== 'readable') return;
                        if (controller._queueTotalSize > 0) {
                            controller._closeRequested = true;
                            return;
                        }
                        if (controller._pendingPullIntos.length > 0) {
                            var firstPendingPullInto = controller._pendingPullIntos.peek();
                            if (firstPendingPullInto.bytesFilled > 0) {
                                var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
                                ReadableByteStreamControllerError(controller, e);
                                throw e;
                            }
                        }
                        ReadableByteStreamControllerClearAlgorithms(controller);
                        ReadableStreamClose(stream);
                    }
                    function ReadableByteStreamControllerEnqueue(controller, chunk) {
                        var stream = controller._controlledReadableByteStream;
                        if (controller._closeRequested || stream._state !== 'readable') return;
                        var buffer = chunk.buffer;
                        var byteOffset = chunk.byteOffset;
                        var byteLength = chunk.byteLength;
                        var transferredBuffer = TransferArrayBuffer(buffer);
                        if (controller._pendingPullIntos.length > 0) {
                            var firstPendingPullInto = controller._pendingPullIntos.peek();
                            IsDetachedBuffer(firstPendingPullInto.buffer);
                            firstPendingPullInto.buffer = TransferArrayBuffer(firstPendingPullInto.buffer);
                        }
                        ReadableByteStreamControllerInvalidateBYOBRequest(controller);
                        if (ReadableStreamHasDefaultReader(stream)) {
                            if (ReadableStreamGetNumReadRequests(stream) === 0) ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                            else {
                                if (controller._pendingPullIntos.length > 0) ReadableByteStreamControllerShiftPendingPullInto(controller);
                                var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
                                ReadableStreamFulfillReadRequest(stream, transferredView, false);
                            }
                        } else if (ReadableStreamHasBYOBReader(stream)) {
                            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                            ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
                        } else ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                        ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerError(controller, e) {
                        var stream = controller._controlledReadableByteStream;
                        if (stream._state !== 'readable') return;
                        ReadableByteStreamControllerClearPendingPullIntos(controller);
                        ResetQueue(controller);
                        ReadableByteStreamControllerClearAlgorithms(controller);
                        ReadableStreamError(stream, e);
                    }
                    function ReadableByteStreamControllerGetBYOBRequest(controller) {
                        if (controller._byobRequest === null && controller._pendingPullIntos.length > 0) {
                            var firstDescriptor = controller._pendingPullIntos.peek();
                            var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
                            var byobRequest = Object.create(ReadableStreamBYOBRequest.prototype);
                            SetUpReadableStreamBYOBRequest(byobRequest, controller, view);
                            controller._byobRequest = byobRequest;
                        }
                        return controller._byobRequest;
                    }
                    function ReadableByteStreamControllerGetDesiredSize(controller) {
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'errored') return null;
                        if (state === 'closed') return 0;
                        return controller._strategyHWM - controller._queueTotalSize;
                    }
                    function ReadableByteStreamControllerRespond(controller, bytesWritten) {
                        var firstDescriptor = controller._pendingPullIntos.peek();
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'closed') {
                            if (bytesWritten !== 0) throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
                        } else {
                            if (bytesWritten === 0) throw new TypeError('bytesWritten must be greater than 0 when calling respond() on a readable stream');
                            if (firstDescriptor.bytesFilled + bytesWritten > firstDescriptor.byteLength) throw new RangeError('bytesWritten out of range');
                        }
                        firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
                        ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
                    }
                    function ReadableByteStreamControllerRespondWithNewView(controller, view) {
                        var firstDescriptor = controller._pendingPullIntos.peek();
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'closed') {
                            if (view.byteLength !== 0) throw new TypeError('The view\'s length must be 0 when calling respondWithNewView() on a closed stream');
                        } else {
                            if (view.byteLength === 0) throw new TypeError('The view\'s length must be greater than 0 when calling respondWithNewView() on a readable stream');
                        }
                        if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) throw new RangeError('The region specified by view does not match byobRequest');
                        if (firstDescriptor.bufferByteLength !== view.buffer.byteLength) throw new RangeError('The buffer of view has different capacity than byobRequest');
                        if (firstDescriptor.bytesFilled + view.byteLength > firstDescriptor.byteLength) throw new RangeError('The region specified by view is larger than byobRequest');
                        var viewByteLength = view.byteLength;
                        firstDescriptor.buffer = TransferArrayBuffer(view.buffer);
                        ReadableByteStreamControllerRespondInternal(controller, viewByteLength);
                    }
                    function SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize) {
                        controller._controlledReadableByteStream = stream;
                        controller._pullAgain = false;
                        controller._pulling = false;
                        controller._byobRequest = null;
                        controller._queue = controller._queueTotalSize = undefined;
                        ResetQueue(controller);
                        controller._closeRequested = false;
                        controller._started = false;
                        controller._strategyHWM = highWaterMark;
                        controller._pullAlgorithm = pullAlgorithm;
                        controller._cancelAlgorithm = cancelAlgorithm;
                        controller._autoAllocateChunkSize = autoAllocateChunkSize;
                        controller._pendingPullIntos = new SimpleQueue();
                        stream._readableStreamController = controller;
                        var startResult = startAlgorithm();
                        uponPromise(promiseResolvedWith(startResult), function() {
                            controller._started = true;
                            ReadableByteStreamControllerCallPullIfNeeded(controller);
                        }, function(r) {
                            ReadableByteStreamControllerError(controller, r);
                        });
                    }
                    function SetUpReadableByteStreamControllerFromUnderlyingSource(stream, underlyingByteSource, highWaterMark) {
                        var controller = Object.create(ReadableByteStreamController.prototype);
                        var startAlgorithm = function() {
                            return undefined;
                        };
                        var pullAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var cancelAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (underlyingByteSource.start !== undefined) startAlgorithm = function() {
                            return underlyingByteSource.start(controller);
                        };
                        if (underlyingByteSource.pull !== undefined) pullAlgorithm = function() {
                            return underlyingByteSource.pull(controller);
                        };
                        if (underlyingByteSource.cancel !== undefined) cancelAlgorithm = function(reason) {
                            return underlyingByteSource.cancel(reason);
                        };
                        var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
                        if (autoAllocateChunkSize === 0) throw new TypeError('autoAllocateChunkSize must be greater than 0');
                        SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize);
                    }
                    function SetUpReadableStreamBYOBRequest(request, controller, view) {
                        request._associatedReadableByteStreamController = controller;
                        request._view = view;
                    }
                    function byobRequestBrandCheckException(name) {
                        return new TypeError("ReadableStreamBYOBRequest.prototype." + name + " can only be used on a ReadableStreamBYOBRequest");
                    }
                    function byteStreamControllerBrandCheckException(name) {
                        return new TypeError("ReadableByteStreamController.prototype." + name + " can only be used on a ReadableByteStreamController");
                    }
                    function AcquireReadableStreamBYOBReader(stream) {
                        return new ReadableStreamBYOBReader(stream);
                    }
                    function ReadableStreamAddReadIntoRequest(stream, readIntoRequest) {
                        stream._reader._readIntoRequests.push(readIntoRequest);
                    }
                    function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
                        var reader = stream._reader;
                        var readIntoRequest = reader._readIntoRequests.shift();
                        if (done) readIntoRequest._closeSteps(chunk);
                        else readIntoRequest._chunkSteps(chunk);
                    }
                    function ReadableStreamGetNumReadIntoRequests(stream) {
                        return stream._reader._readIntoRequests.length;
                    }
                    function ReadableStreamHasBYOBReader(stream) {
                        var reader = stream._reader;
                        if (reader === undefined) return false;
                        if (!IsReadableStreamBYOBReader(reader)) return false;
                        return true;
                    }
                    var ReadableStreamBYOBReader = function() {
                        function ReadableStreamBYOBReader(stream) {
                            assertRequiredArgument(stream, 1, 'ReadableStreamBYOBReader');
                            assertReadableStream(stream, 'First parameter');
                            if (IsReadableStreamLocked(stream)) throw new TypeError('This stream has already been locked for exclusive reading by another reader');
                            if (!IsReadableByteStreamController(stream._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
                            ReadableStreamReaderGenericInitialize(this, stream);
                            this._readIntoRequests = new SimpleQueue();
                        }
                        Object.defineProperty(ReadableStreamBYOBReader.prototype, "closed", {
                            get: function() {
                                if (!IsReadableStreamBYOBReader(this)) return promiseRejectedWith(byobReaderBrandCheckException('closed'));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamBYOBReader.prototype.cancel = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsReadableStreamBYOBReader(this)) return promiseRejectedWith(byobReaderBrandCheckException('cancel'));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('cancel'));
                            return ReadableStreamReaderGenericCancel(this, reason);
                        };
                        ReadableStreamBYOBReader.prototype.read = function(view) {
                            if (!IsReadableStreamBYOBReader(this)) return promiseRejectedWith(byobReaderBrandCheckException('read'));
                            if (!ArrayBuffer.isView(view)) return promiseRejectedWith(new TypeError('view must be an array buffer view'));
                            if (view.byteLength === 0) return promiseRejectedWith(new TypeError('view must have non-zero byteLength'));
                            if (view.buffer.byteLength === 0) return promiseRejectedWith(new TypeError("view's buffer must have non-zero byteLength"));
                            IsDetachedBuffer(view.buffer);
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('read from'));
                            var resolvePromise;
                            var rejectPromise;
                            var promise = newPromise(function(resolve, reject) {
                                resolvePromise = resolve;
                                rejectPromise = reject;
                            });
                            var readIntoRequest = {
                                _chunkSteps: function(chunk) {
                                    return resolvePromise({
                                        value: chunk,
                                        done: false
                                    });
                                },
                                _closeSteps: function(chunk) {
                                    return resolvePromise({
                                        value: chunk,
                                        done: true
                                    });
                                },
                                _errorSteps: function(e) {
                                    return rejectPromise(e);
                                }
                            };
                            ReadableStreamBYOBReaderRead(this, view, readIntoRequest);
                            return promise;
                        };
                        ReadableStreamBYOBReader.prototype.releaseLock = function() {
                            if (!IsReadableStreamBYOBReader(this)) throw byobReaderBrandCheckException('releaseLock');
                            if (this._ownerReadableStream === undefined) return;
                            if (this._readIntoRequests.length > 0) throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
                            ReadableStreamReaderGenericRelease(this);
                        };
                        return ReadableStreamBYOBReader;
                    }();
                    Object.defineProperties(ReadableStreamBYOBReader.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        read: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamBYOBReader.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamBYOBReader',
                        configurable: true
                    });
                    function IsReadableStreamBYOBReader(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) return false;
                        return x instanceof ReadableStreamBYOBReader;
                    }
                    function ReadableStreamBYOBReaderRead(reader, view, readIntoRequest) {
                        var stream = reader._ownerReadableStream;
                        stream._disturbed = true;
                        if (stream._state === 'errored') readIntoRequest._errorSteps(stream._storedError);
                        else ReadableByteStreamControllerPullInto(stream._readableStreamController, view, readIntoRequest);
                    }
                    function byobReaderBrandCheckException(name) {
                        return new TypeError("ReadableStreamBYOBReader.prototype." + name + " can only be used on a ReadableStreamBYOBReader");
                    }
                    function ExtractHighWaterMark(strategy, defaultHWM) {
                        var highWaterMark = strategy.highWaterMark;
                        if (highWaterMark === undefined) return defaultHWM;
                        if (NumberIsNaN(highWaterMark) || highWaterMark < 0) throw new RangeError('Invalid highWaterMark');
                        return highWaterMark;
                    }
                    function ExtractSizeAlgorithm(strategy) {
                        var size = strategy.size;
                        if (!size) return function() {
                            return 1;
                        };
                        return size;
                    }
                    function convertQueuingStrategy(init, context) {
                        assertDictionary(init, context);
                        var highWaterMark = init === null || init === void 0 ? void 0 : init.highWaterMark;
                        var size = init === null || init === void 0 ? void 0 : init.size;
                        return {
                            highWaterMark: highWaterMark === undefined ? undefined : convertUnrestrictedDouble(highWaterMark),
                            size: size === undefined ? undefined : convertQueuingStrategySize(size, context + " has member 'size' that")
                        };
                    }
                    function convertQueuingStrategySize(fn, context) {
                        assertFunction(fn, context);
                        return function(chunk) {
                            return convertUnrestrictedDouble(fn(chunk));
                        };
                    }
                    function convertUnderlyingSink(original, context) {
                        assertDictionary(original, context);
                        var abort = original === null || original === void 0 ? void 0 : original.abort;
                        var close = original === null || original === void 0 ? void 0 : original.close;
                        var start = original === null || original === void 0 ? void 0 : original.start;
                        var type = original === null || original === void 0 ? void 0 : original.type;
                        var write = original === null || original === void 0 ? void 0 : original.write;
                        return {
                            abort: abort === undefined ? undefined : convertUnderlyingSinkAbortCallback(abort, original, context + " has member 'abort' that"),
                            close: close === undefined ? undefined : convertUnderlyingSinkCloseCallback(close, original, context + " has member 'close' that"),
                            start: start === undefined ? undefined : convertUnderlyingSinkStartCallback(start, original, context + " has member 'start' that"),
                            write: write === undefined ? undefined : convertUnderlyingSinkWriteCallback(write, original, context + " has member 'write' that"),
                            type: type
                        };
                    }
                    function convertUnderlyingSinkAbortCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(reason) {
                            return promiseCall(fn, original, [
                                reason
                            ]);
                        };
                    }
                    function convertUnderlyingSinkCloseCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function() {
                            return promiseCall(fn, original, []);
                        };
                    }
                    function convertUnderlyingSinkStartCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return reflectCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertUnderlyingSinkWriteCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(chunk, controller) {
                            return promiseCall(fn, original, [
                                chunk,
                                controller
                            ]);
                        };
                    }
                    function assertWritableStream(x, context) {
                        if (!IsWritableStream(x)) throw new TypeError(context + " is not a WritableStream.");
                    }
                    function isAbortSignal(value) {
                        if (typeof value !== 'object' || value === null) return false;
                        try {
                            return typeof value.aborted === 'boolean';
                        } catch (_a) {
                            return false;
                        }
                    }
                    var supportsAbortController = typeof AbortController === 'function';
                    function createAbortController() {
                        if (supportsAbortController) return new AbortController();
                        return undefined;
                    }
                    var WritableStream = function() {
                        function WritableStream(rawUnderlyingSink, rawStrategy) {
                            if (rawUnderlyingSink === void 0) rawUnderlyingSink = {};
                            if (rawStrategy === void 0) rawStrategy = {};
                            if (rawUnderlyingSink === undefined) rawUnderlyingSink = null;
                            else assertObject(rawUnderlyingSink, 'First parameter');
                            var strategy = convertQueuingStrategy(rawStrategy, 'Second parameter');
                            var underlyingSink = convertUnderlyingSink(rawUnderlyingSink, 'First parameter');
                            InitializeWritableStream(this);
                            var type = underlyingSink.type;
                            if (type !== undefined) throw new RangeError('Invalid type is specified');
                            var sizeAlgorithm = ExtractSizeAlgorithm(strategy);
                            var highWaterMark = ExtractHighWaterMark(strategy, 1);
                            SetUpWritableStreamDefaultControllerFromUnderlyingSink(this, underlyingSink, highWaterMark, sizeAlgorithm);
                        }
                        Object.defineProperty(WritableStream.prototype, "locked", {
                            get: function() {
                                if (!IsWritableStream(this)) throw streamBrandCheckException$2('locked');
                                return IsWritableStreamLocked(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStream.prototype.abort = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsWritableStream(this)) return promiseRejectedWith(streamBrandCheckException$2('abort'));
                            if (IsWritableStreamLocked(this)) return promiseRejectedWith(new TypeError('Cannot abort a stream that already has a writer'));
                            return WritableStreamAbort(this, reason);
                        };
                        WritableStream.prototype.close = function() {
                            if (!IsWritableStream(this)) return promiseRejectedWith(streamBrandCheckException$2('close'));
                            if (IsWritableStreamLocked(this)) return promiseRejectedWith(new TypeError('Cannot close a stream that already has a writer'));
                            if (WritableStreamCloseQueuedOrInFlight(this)) return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'));
                            return WritableStreamClose(this);
                        };
                        WritableStream.prototype.getWriter = function() {
                            if (!IsWritableStream(this)) throw streamBrandCheckException$2('getWriter');
                            return AcquireWritableStreamDefaultWriter(this);
                        };
                        return WritableStream;
                    }();
                    Object.defineProperties(WritableStream.prototype, {
                        abort: {
                            enumerable: true
                        },
                        close: {
                            enumerable: true
                        },
                        getWriter: {
                            enumerable: true
                        },
                        locked: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(WritableStream.prototype, SymbolPolyfill.toStringTag, {
                        value: 'WritableStream',
                        configurable: true
                    });
                    function AcquireWritableStreamDefaultWriter(stream) {
                        return new WritableStreamDefaultWriter(stream);
                    }
                    function CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
                        if (highWaterMark === void 0) highWaterMark = 1;
                        if (sizeAlgorithm === void 0) sizeAlgorithm = function() {
                            return 1;
                        };
                        var stream = Object.create(WritableStream.prototype);
                        InitializeWritableStream(stream);
                        var controller = Object.create(WritableStreamDefaultController.prototype);
                        SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
                        return stream;
                    }
                    function InitializeWritableStream(stream) {
                        stream._state = 'writable';
                        stream._storedError = undefined;
                        stream._writer = undefined;
                        stream._writableStreamController = undefined;
                        stream._writeRequests = new SimpleQueue();
                        stream._inFlightWriteRequest = undefined;
                        stream._closeRequest = undefined;
                        stream._inFlightCloseRequest = undefined;
                        stream._pendingAbortRequest = undefined;
                        stream._backpressure = false;
                    }
                    function IsWritableStream(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) return false;
                        return x instanceof WritableStream;
                    }
                    function IsWritableStreamLocked(stream) {
                        if (stream._writer === undefined) return false;
                        return true;
                    }
                    function WritableStreamAbort(stream, reason) {
                        var _a;
                        if (stream._state === 'closed' || stream._state === 'errored') return promiseResolvedWith(undefined);
                        stream._writableStreamController._abortReason = reason;
                        (_a = stream._writableStreamController._abortController) === null || _a === void 0 || _a.abort();
                        var state = stream._state;
                        if (state === 'closed' || state === 'errored') return promiseResolvedWith(undefined);
                        if (stream._pendingAbortRequest !== undefined) return stream._pendingAbortRequest._promise;
                        var wasAlreadyErroring = false;
                        if (state === 'erroring') {
                            wasAlreadyErroring = true;
                            reason = undefined;
                        }
                        var promise = newPromise(function(resolve, reject) {
                            stream._pendingAbortRequest = {
                                _promise: undefined,
                                _resolve: resolve,
                                _reject: reject,
                                _reason: reason,
                                _wasAlreadyErroring: wasAlreadyErroring
                            };
                        });
                        stream._pendingAbortRequest._promise = promise;
                        if (!wasAlreadyErroring) WritableStreamStartErroring(stream, reason);
                        return promise;
                    }
                    function WritableStreamClose(stream) {
                        var state = stream._state;
                        if (state === 'closed' || state === 'errored') return promiseRejectedWith(new TypeError("The stream (in " + state + " state) is not in the writable state and cannot be closed"));
                        var promise = newPromise(function(resolve, reject) {
                            var closeRequest = {
                                _resolve: resolve,
                                _reject: reject
                            };
                            stream._closeRequest = closeRequest;
                        });
                        var writer = stream._writer;
                        if (writer !== undefined && stream._backpressure && state === 'writable') defaultWriterReadyPromiseResolve(writer);
                        WritableStreamDefaultControllerClose(stream._writableStreamController);
                        return promise;
                    }
                    function WritableStreamAddWriteRequest(stream) {
                        var promise = newPromise(function(resolve, reject) {
                            var writeRequest = {
                                _resolve: resolve,
                                _reject: reject
                            };
                            stream._writeRequests.push(writeRequest);
                        });
                        return promise;
                    }
                    function WritableStreamDealWithRejection(stream, error) {
                        var state = stream._state;
                        if (state === 'writable') {
                            WritableStreamStartErroring(stream, error);
                            return;
                        }
                        WritableStreamFinishErroring(stream);
                    }
                    function WritableStreamStartErroring(stream, reason) {
                        var controller = stream._writableStreamController;
                        stream._state = 'erroring';
                        stream._storedError = reason;
                        var writer = stream._writer;
                        if (writer !== undefined) WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
                        if (!WritableStreamHasOperationMarkedInFlight(stream) && controller._started) WritableStreamFinishErroring(stream);
                    }
                    function WritableStreamFinishErroring(stream) {
                        stream._state = 'errored';
                        stream._writableStreamController[ErrorSteps]();
                        var storedError = stream._storedError;
                        stream._writeRequests.forEach(function(writeRequest) {
                            writeRequest._reject(storedError);
                        });
                        stream._writeRequests = new SimpleQueue();
                        if (stream._pendingAbortRequest === undefined) {
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                            return;
                        }
                        var abortRequest = stream._pendingAbortRequest;
                        stream._pendingAbortRequest = undefined;
                        if (abortRequest._wasAlreadyErroring) {
                            abortRequest._reject(storedError);
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                            return;
                        }
                        var promise = stream._writableStreamController[AbortSteps](abortRequest._reason);
                        uponPromise(promise, function() {
                            abortRequest._resolve();
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                        }, function(reason) {
                            abortRequest._reject(reason);
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                        });
                    }
                    function WritableStreamFinishInFlightWrite(stream) {
                        stream._inFlightWriteRequest._resolve(undefined);
                        stream._inFlightWriteRequest = undefined;
                    }
                    function WritableStreamFinishInFlightWriteWithError(stream, error) {
                        stream._inFlightWriteRequest._reject(error);
                        stream._inFlightWriteRequest = undefined;
                        WritableStreamDealWithRejection(stream, error);
                    }
                    function WritableStreamFinishInFlightClose(stream) {
                        stream._inFlightCloseRequest._resolve(undefined);
                        stream._inFlightCloseRequest = undefined;
                        var state = stream._state;
                        if (state === 'erroring') {
                            stream._storedError = undefined;
                            if (stream._pendingAbortRequest !== undefined) {
                                stream._pendingAbortRequest._resolve();
                                stream._pendingAbortRequest = undefined;
                            }
                        }
                        stream._state = 'closed';
                        var writer = stream._writer;
                        if (writer !== undefined) defaultWriterClosedPromiseResolve(writer);
                    }
                    function WritableStreamFinishInFlightCloseWithError(stream, error) {
                        stream._inFlightCloseRequest._reject(error);
                        stream._inFlightCloseRequest = undefined;
                        if (stream._pendingAbortRequest !== undefined) {
                            stream._pendingAbortRequest._reject(error);
                            stream._pendingAbortRequest = undefined;
                        }
                        WritableStreamDealWithRejection(stream, error);
                    }
                    function WritableStreamCloseQueuedOrInFlight(stream) {
                        if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) return false;
                        return true;
                    }
                    function WritableStreamHasOperationMarkedInFlight(stream) {
                        if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) return false;
                        return true;
                    }
                    function WritableStreamMarkCloseRequestInFlight(stream) {
                        stream._inFlightCloseRequest = stream._closeRequest;
                        stream._closeRequest = undefined;
                    }
                    function WritableStreamMarkFirstWriteRequestInFlight(stream) {
                        stream._inFlightWriteRequest = stream._writeRequests.shift();
                    }
                    function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
                        if (stream._closeRequest !== undefined) {
                            stream._closeRequest._reject(stream._storedError);
                            stream._closeRequest = undefined;
                        }
                        var writer = stream._writer;
                        if (writer !== undefined) defaultWriterClosedPromiseReject(writer, stream._storedError);
                    }
                    function WritableStreamUpdateBackpressure(stream, backpressure) {
                        var writer = stream._writer;
                        if (writer !== undefined && backpressure !== stream._backpressure) {
                            if (backpressure) defaultWriterReadyPromiseReset(writer);
                            else defaultWriterReadyPromiseResolve(writer);
                        }
                        stream._backpressure = backpressure;
                    }
                    var WritableStreamDefaultWriter = function() {
                        function WritableStreamDefaultWriter(stream) {
                            assertRequiredArgument(stream, 1, 'WritableStreamDefaultWriter');
                            assertWritableStream(stream, 'First parameter');
                            if (IsWritableStreamLocked(stream)) throw new TypeError('This stream has already been locked for exclusive writing by another writer');
                            this._ownerWritableStream = stream;
                            stream._writer = this;
                            var state = stream._state;
                            if (state === 'writable') {
                                if (!WritableStreamCloseQueuedOrInFlight(stream) && stream._backpressure) defaultWriterReadyPromiseInitialize(this);
                                else defaultWriterReadyPromiseInitializeAsResolved(this);
                                defaultWriterClosedPromiseInitialize(this);
                            } else if (state === 'erroring') {
                                defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
                                defaultWriterClosedPromiseInitialize(this);
                            } else if (state === 'closed') {
                                defaultWriterReadyPromiseInitializeAsResolved(this);
                                defaultWriterClosedPromiseInitializeAsResolved(this);
                            } else {
                                var storedError = stream._storedError;
                                defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
                                defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
                            }
                        }
                        Object.defineProperty(WritableStreamDefaultWriter.prototype, "closed", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('closed'));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultWriter.prototype, "desiredSize", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter(this)) throw defaultWriterBrandCheckException('desiredSize');
                                if (this._ownerWritableStream === undefined) throw defaultWriterLockException('desiredSize');
                                return WritableStreamDefaultWriterGetDesiredSize(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultWriter.prototype, "ready", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('ready'));
                                return this._readyPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStreamDefaultWriter.prototype.abort = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('abort'));
                            if (this._ownerWritableStream === undefined) return promiseRejectedWith(defaultWriterLockException('abort'));
                            return WritableStreamDefaultWriterAbort(this, reason);
                        };
                        WritableStreamDefaultWriter.prototype.close = function() {
                            if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('close'));
                            var stream = this._ownerWritableStream;
                            if (stream === undefined) return promiseRejectedWith(defaultWriterLockException('close'));
                            if (WritableStreamCloseQueuedOrInFlight(stream)) return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'));
                            return WritableStreamDefaultWriterClose(this);
                        };
                        WritableStreamDefaultWriter.prototype.releaseLock = function() {
                            if (!IsWritableStreamDefaultWriter(this)) throw defaultWriterBrandCheckException('releaseLock');
                            var stream = this._ownerWritableStream;
                            if (stream === undefined) return;
                            WritableStreamDefaultWriterRelease(this);
                        };
                        WritableStreamDefaultWriter.prototype.write = function(chunk) {
                            if (chunk === void 0) chunk = undefined;
                            if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('write'));
                            if (this._ownerWritableStream === undefined) return promiseRejectedWith(defaultWriterLockException('write to'));
                            return WritableStreamDefaultWriterWrite(this, chunk);
                        };
                        return WritableStreamDefaultWriter;
                    }();
                    Object.defineProperties(WritableStreamDefaultWriter.prototype, {
                        abort: {
                            enumerable: true
                        },
                        close: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        write: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        },
                        ready: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(WritableStreamDefaultWriter.prototype, SymbolPolyfill.toStringTag, {
                        value: 'WritableStreamDefaultWriter',
                        configurable: true
                    });
                    function IsWritableStreamDefaultWriter(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) return false;
                        return x instanceof WritableStreamDefaultWriter;
                    }
                    function WritableStreamDefaultWriterAbort(writer, reason) {
                        var stream = writer._ownerWritableStream;
                        return WritableStreamAbort(stream, reason);
                    }
                    function WritableStreamDefaultWriterClose(writer) {
                        var stream = writer._ownerWritableStream;
                        return WritableStreamClose(stream);
                    }
                    function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
                        var stream = writer._ownerWritableStream;
                        var state = stream._state;
                        if (WritableStreamCloseQueuedOrInFlight(stream) || state === 'closed') return promiseResolvedWith(undefined);
                        if (state === 'errored') return promiseRejectedWith(stream._storedError);
                        return WritableStreamDefaultWriterClose(writer);
                    }
                    function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
                        if (writer._closedPromiseState === 'pending') defaultWriterClosedPromiseReject(writer, error);
                        else defaultWriterClosedPromiseResetToRejected(writer, error);
                    }
                    function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
                        if (writer._readyPromiseState === 'pending') defaultWriterReadyPromiseReject(writer, error);
                        else defaultWriterReadyPromiseResetToRejected(writer, error);
                    }
                    function WritableStreamDefaultWriterGetDesiredSize(writer) {
                        var stream = writer._ownerWritableStream;
                        var state = stream._state;
                        if (state === 'errored' || state === 'erroring') return null;
                        if (state === 'closed') return 0;
                        return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
                    }
                    function WritableStreamDefaultWriterRelease(writer) {
                        var stream = writer._ownerWritableStream;
                        var releasedError = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
                        WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
                        WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
                        stream._writer = undefined;
                        writer._ownerWritableStream = undefined;
                    }
                    function WritableStreamDefaultWriterWrite(writer, chunk) {
                        var stream = writer._ownerWritableStream;
                        var controller = stream._writableStreamController;
                        var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
                        if (stream !== writer._ownerWritableStream) return promiseRejectedWith(defaultWriterLockException('write to'));
                        var state = stream._state;
                        if (state === 'errored') return promiseRejectedWith(stream._storedError);
                        if (WritableStreamCloseQueuedOrInFlight(stream) || state === 'closed') return promiseRejectedWith(new TypeError('The stream is closing or closed and cannot be written to'));
                        if (state === 'erroring') return promiseRejectedWith(stream._storedError);
                        var promise = WritableStreamAddWriteRequest(stream);
                        WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
                        return promise;
                    }
                    var closeSentinel = {};
                    var WritableStreamDefaultController = function() {
                        function WritableStreamDefaultController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(WritableStreamDefaultController.prototype, "abortReason", {
                            get: function() {
                                if (!IsWritableStreamDefaultController(this)) throw defaultControllerBrandCheckException$2('abortReason');
                                return this._abortReason;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultController.prototype, "signal", {
                            get: function() {
                                if (!IsWritableStreamDefaultController(this)) throw defaultControllerBrandCheckException$2('signal');
                                if (this._abortController === undefined) throw new TypeError('WritableStreamDefaultController.prototype.signal is not supported');
                                return this._abortController.signal;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStreamDefaultController.prototype.error = function(e) {
                            if (e === void 0) e = undefined;
                            if (!IsWritableStreamDefaultController(this)) throw defaultControllerBrandCheckException$2('error');
                            var state = this._controlledWritableStream._state;
                            if (state !== 'writable') return;
                            WritableStreamDefaultControllerError(this, e);
                        };
                        WritableStreamDefaultController.prototype[AbortSteps] = function(reason) {
                            var result = this._abortAlgorithm(reason);
                            WritableStreamDefaultControllerClearAlgorithms(this);
                            return result;
                        };
                        WritableStreamDefaultController.prototype[ErrorSteps] = function() {
                            ResetQueue(this);
                        };
                        return WritableStreamDefaultController;
                    }();
                    Object.defineProperties(WritableStreamDefaultController.prototype, {
                        abortReason: {
                            enumerable: true
                        },
                        signal: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(WritableStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'WritableStreamDefaultController',
                        configurable: true
                    });
                    function IsWritableStreamDefaultController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledWritableStream')) return false;
                        return x instanceof WritableStreamDefaultController;
                    }
                    function SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
                        controller._controlledWritableStream = stream;
                        stream._writableStreamController = controller;
                        controller._queue = undefined;
                        controller._queueTotalSize = undefined;
                        ResetQueue(controller);
                        controller._abortReason = undefined;
                        controller._abortController = createAbortController();
                        controller._started = false;
                        controller._strategySizeAlgorithm = sizeAlgorithm;
                        controller._strategyHWM = highWaterMark;
                        controller._writeAlgorithm = writeAlgorithm;
                        controller._closeAlgorithm = closeAlgorithm;
                        controller._abortAlgorithm = abortAlgorithm;
                        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                        WritableStreamUpdateBackpressure(stream, backpressure);
                        var startResult = startAlgorithm();
                        var startPromise = promiseResolvedWith(startResult);
                        uponPromise(startPromise, function() {
                            controller._started = true;
                            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                        }, function(r) {
                            controller._started = true;
                            WritableStreamDealWithRejection(stream, r);
                        });
                    }
                    function SetUpWritableStreamDefaultControllerFromUnderlyingSink(stream, underlyingSink, highWaterMark, sizeAlgorithm) {
                        var controller = Object.create(WritableStreamDefaultController.prototype);
                        var startAlgorithm = function() {
                            return undefined;
                        };
                        var writeAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var closeAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var abortAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (underlyingSink.start !== undefined) startAlgorithm = function() {
                            return underlyingSink.start(controller);
                        };
                        if (underlyingSink.write !== undefined) writeAlgorithm = function(chunk) {
                            return underlyingSink.write(chunk, controller);
                        };
                        if (underlyingSink.close !== undefined) closeAlgorithm = function() {
                            return underlyingSink.close();
                        };
                        if (underlyingSink.abort !== undefined) abortAlgorithm = function(reason) {
                            return underlyingSink.abort(reason);
                        };
                        SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
                    }
                    function WritableStreamDefaultControllerClearAlgorithms(controller) {
                        controller._writeAlgorithm = undefined;
                        controller._closeAlgorithm = undefined;
                        controller._abortAlgorithm = undefined;
                        controller._strategySizeAlgorithm = undefined;
                    }
                    function WritableStreamDefaultControllerClose(controller) {
                        EnqueueValueWithSize(controller, closeSentinel, 0);
                        WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                    }
                    function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
                        try {
                            return controller._strategySizeAlgorithm(chunk);
                        } catch (chunkSizeE) {
                            WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
                            return 1;
                        }
                    }
                    function WritableStreamDefaultControllerGetDesiredSize(controller) {
                        return controller._strategyHWM - controller._queueTotalSize;
                    }
                    function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
                        try {
                            EnqueueValueWithSize(controller, chunk, chunkSize);
                        } catch (enqueueE) {
                            WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
                            return;
                        }
                        var stream = controller._controlledWritableStream;
                        if (!WritableStreamCloseQueuedOrInFlight(stream) && stream._state === 'writable') {
                            var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                            WritableStreamUpdateBackpressure(stream, backpressure);
                        }
                        WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                    }
                    function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
                        var stream = controller._controlledWritableStream;
                        if (!controller._started) return;
                        if (stream._inFlightWriteRequest !== undefined) return;
                        var state = stream._state;
                        if (state === 'erroring') {
                            WritableStreamFinishErroring(stream);
                            return;
                        }
                        if (controller._queue.length === 0) return;
                        var value = PeekQueueValue(controller);
                        if (value === closeSentinel) WritableStreamDefaultControllerProcessClose(controller);
                        else WritableStreamDefaultControllerProcessWrite(controller, value);
                    }
                    function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
                        if (controller._controlledWritableStream._state === 'writable') WritableStreamDefaultControllerError(controller, error);
                    }
                    function WritableStreamDefaultControllerProcessClose(controller) {
                        var stream = controller._controlledWritableStream;
                        WritableStreamMarkCloseRequestInFlight(stream);
                        DequeueValue(controller);
                        var sinkClosePromise = controller._closeAlgorithm();
                        WritableStreamDefaultControllerClearAlgorithms(controller);
                        uponPromise(sinkClosePromise, function() {
                            WritableStreamFinishInFlightClose(stream);
                        }, function(reason) {
                            WritableStreamFinishInFlightCloseWithError(stream, reason);
                        });
                    }
                    function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
                        var stream = controller._controlledWritableStream;
                        WritableStreamMarkFirstWriteRequestInFlight(stream);
                        var sinkWritePromise = controller._writeAlgorithm(chunk);
                        uponPromise(sinkWritePromise, function() {
                            WritableStreamFinishInFlightWrite(stream);
                            var state = stream._state;
                            DequeueValue(controller);
                            if (!WritableStreamCloseQueuedOrInFlight(stream) && state === 'writable') {
                                var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                                WritableStreamUpdateBackpressure(stream, backpressure);
                            }
                            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                        }, function(reason) {
                            if (stream._state === 'writable') WritableStreamDefaultControllerClearAlgorithms(controller);
                            WritableStreamFinishInFlightWriteWithError(stream, reason);
                        });
                    }
                    function WritableStreamDefaultControllerGetBackpressure(controller) {
                        var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
                        return desiredSize <= 0;
                    }
                    function WritableStreamDefaultControllerError(controller, error) {
                        var stream = controller._controlledWritableStream;
                        WritableStreamDefaultControllerClearAlgorithms(controller);
                        WritableStreamStartErroring(stream, error);
                    }
                    function streamBrandCheckException$2(name) {
                        return new TypeError("WritableStream.prototype." + name + " can only be used on a WritableStream");
                    }
                    function defaultControllerBrandCheckException$2(name) {
                        return new TypeError("WritableStreamDefaultController.prototype." + name + " can only be used on a WritableStreamDefaultController");
                    }
                    function defaultWriterBrandCheckException(name) {
                        return new TypeError("WritableStreamDefaultWriter.prototype." + name + " can only be used on a WritableStreamDefaultWriter");
                    }
                    function defaultWriterLockException(name) {
                        return new TypeError('Cannot ' + name + ' a stream using a released writer');
                    }
                    function defaultWriterClosedPromiseInitialize(writer) {
                        writer._closedPromise = newPromise(function(resolve, reject) {
                            writer._closedPromise_resolve = resolve;
                            writer._closedPromise_reject = reject;
                            writer._closedPromiseState = 'pending';
                        });
                    }
                    function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
                        defaultWriterClosedPromiseInitialize(writer);
                        defaultWriterClosedPromiseReject(writer, reason);
                    }
                    function defaultWriterClosedPromiseInitializeAsResolved(writer) {
                        defaultWriterClosedPromiseInitialize(writer);
                        defaultWriterClosedPromiseResolve(writer);
                    }
                    function defaultWriterClosedPromiseReject(writer, reason) {
                        if (writer._closedPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue(writer._closedPromise);
                        writer._closedPromise_reject(reason);
                        writer._closedPromise_resolve = undefined;
                        writer._closedPromise_reject = undefined;
                        writer._closedPromiseState = 'rejected';
                    }
                    function defaultWriterClosedPromiseResetToRejected(writer, reason) {
                        defaultWriterClosedPromiseInitializeAsRejected(writer, reason);
                    }
                    function defaultWriterClosedPromiseResolve(writer) {
                        if (writer._closedPromise_resolve === undefined) return;
                        writer._closedPromise_resolve(undefined);
                        writer._closedPromise_resolve = undefined;
                        writer._closedPromise_reject = undefined;
                        writer._closedPromiseState = 'resolved';
                    }
                    function defaultWriterReadyPromiseInitialize(writer) {
                        writer._readyPromise = newPromise(function(resolve, reject) {
                            writer._readyPromise_resolve = resolve;
                            writer._readyPromise_reject = reject;
                        });
                        writer._readyPromiseState = 'pending';
                    }
                    function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
                        defaultWriterReadyPromiseInitialize(writer);
                        defaultWriterReadyPromiseReject(writer, reason);
                    }
                    function defaultWriterReadyPromiseInitializeAsResolved(writer) {
                        defaultWriterReadyPromiseInitialize(writer);
                        defaultWriterReadyPromiseResolve(writer);
                    }
                    function defaultWriterReadyPromiseReject(writer, reason) {
                        if (writer._readyPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue(writer._readyPromise);
                        writer._readyPromise_reject(reason);
                        writer._readyPromise_resolve = undefined;
                        writer._readyPromise_reject = undefined;
                        writer._readyPromiseState = 'rejected';
                    }
                    function defaultWriterReadyPromiseReset(writer) {
                        defaultWriterReadyPromiseInitialize(writer);
                    }
                    function defaultWriterReadyPromiseResetToRejected(writer, reason) {
                        defaultWriterReadyPromiseInitializeAsRejected(writer, reason);
                    }
                    function defaultWriterReadyPromiseResolve(writer) {
                        if (writer._readyPromise_resolve === undefined) return;
                        writer._readyPromise_resolve(undefined);
                        writer._readyPromise_resolve = undefined;
                        writer._readyPromise_reject = undefined;
                        writer._readyPromiseState = 'fulfilled';
                    }
                    var NativeDOMException = typeof DOMException !== 'undefined' ? DOMException : undefined;
                    function isDOMExceptionConstructor(ctor) {
                        if (!(typeof ctor === 'function' || typeof ctor === 'object')) return false;
                        try {
                            new ctor();
                            return true;
                        } catch (_a) {
                            return false;
                        }
                    }
                    function createDOMExceptionPolyfill() {
                        var ctor = function DOMException1(message, name) {
                            this.message = message || '';
                            this.name = name || 'Error';
                            if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        };
                        ctor.prototype = Object.create(Error.prototype);
                        Object.defineProperty(ctor.prototype, 'constructor', {
                            value: ctor,
                            writable: true,
                            configurable: true
                        });
                        return ctor;
                    }
                    var DOMException$1 = isDOMExceptionConstructor(NativeDOMException) ? NativeDOMException : createDOMExceptionPolyfill();
                    function ReadableStreamPipeTo(source, dest, preventClose, preventAbort, preventCancel, signal) {
                        var reader = AcquireReadableStreamDefaultReader(source);
                        var writer = AcquireWritableStreamDefaultWriter(dest);
                        source._disturbed = true;
                        var shuttingDown = false;
                        var currentWrite = promiseResolvedWith(undefined);
                        return newPromise(function(resolve, reject) {
                            var abortAlgorithm;
                            if (signal !== undefined) {
                                abortAlgorithm = function() {
                                    var error = new DOMException$1('Aborted', 'AbortError');
                                    var actions = [];
                                    if (!preventAbort) actions.push(function() {
                                        if (dest._state === 'writable') return WritableStreamAbort(dest, error);
                                        return promiseResolvedWith(undefined);
                                    });
                                    if (!preventCancel) actions.push(function() {
                                        if (source._state === 'readable') return ReadableStreamCancel(source, error);
                                        return promiseResolvedWith(undefined);
                                    });
                                    shutdownWithAction(function() {
                                        return Promise.all(actions.map(function(action) {
                                            return action();
                                        }));
                                    }, true, error);
                                };
                                if (signal.aborted) {
                                    abortAlgorithm();
                                    return;
                                }
                                signal.addEventListener('abort', abortAlgorithm);
                            }
                            function pipeLoop() {
                                return newPromise(function(resolveLoop, rejectLoop) {
                                    function next(done) {
                                        if (done) resolveLoop();
                                        else PerformPromiseThen(pipeStep(), next, rejectLoop);
                                    }
                                    next(false);
                                });
                            }
                            function pipeStep() {
                                if (shuttingDown) return promiseResolvedWith(true);
                                return PerformPromiseThen(writer._readyPromise, function() {
                                    return newPromise(function(resolveRead, rejectRead) {
                                        ReadableStreamDefaultReaderRead(reader, {
                                            _chunkSteps: function(chunk) {
                                                currentWrite = PerformPromiseThen(WritableStreamDefaultWriterWrite(writer, chunk), undefined, noop);
                                                resolveRead(false);
                                            },
                                            _closeSteps: function() {
                                                return resolveRead(true);
                                            },
                                            _errorSteps: rejectRead
                                        });
                                    });
                                });
                            }
                            isOrBecomesErrored(source, reader._closedPromise, function(storedError) {
                                if (!preventAbort) shutdownWithAction(function() {
                                    return WritableStreamAbort(dest, storedError);
                                }, true, storedError);
                                else shutdown(true, storedError);
                            });
                            isOrBecomesErrored(dest, writer._closedPromise, function(storedError) {
                                if (!preventCancel) shutdownWithAction(function() {
                                    return ReadableStreamCancel(source, storedError);
                                }, true, storedError);
                                else shutdown(true, storedError);
                            });
                            isOrBecomesClosed(source, reader._closedPromise, function() {
                                if (!preventClose) shutdownWithAction(function() {
                                    return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
                                });
                                else shutdown();
                            });
                            if (WritableStreamCloseQueuedOrInFlight(dest) || dest._state === 'closed') {
                                var destClosed_1 = new TypeError('the destination writable stream closed before all data could be piped to it');
                                if (!preventCancel) shutdownWithAction(function() {
                                    return ReadableStreamCancel(source, destClosed_1);
                                }, true, destClosed_1);
                                else shutdown(true, destClosed_1);
                            }
                            setPromiseIsHandledToTrue(pipeLoop());
                            function waitForWritesToFinish() {
                                var oldCurrentWrite = currentWrite;
                                return PerformPromiseThen(currentWrite, function() {
                                    return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
                                });
                            }
                            function isOrBecomesErrored(stream, promise, action) {
                                if (stream._state === 'errored') action(stream._storedError);
                                else uponRejection(promise, action);
                            }
                            function isOrBecomesClosed(stream, promise, action) {
                                if (stream._state === 'closed') action();
                                else uponFulfillment(promise, action);
                            }
                            function shutdownWithAction(action, originalIsError, originalError) {
                                if (shuttingDown) return;
                                shuttingDown = true;
                                if (dest._state === 'writable' && !WritableStreamCloseQueuedOrInFlight(dest)) uponFulfillment(waitForWritesToFinish(), doTheRest);
                                else doTheRest();
                                function doTheRest() {
                                    uponPromise(action(), function() {
                                        return finalize(originalIsError, originalError);
                                    }, function(newError) {
                                        return finalize(true, newError);
                                    });
                                }
                            }
                            function shutdown(isError, error) {
                                if (shuttingDown) return;
                                shuttingDown = true;
                                if (dest._state === 'writable' && !WritableStreamCloseQueuedOrInFlight(dest)) uponFulfillment(waitForWritesToFinish(), function() {
                                    return finalize(isError, error);
                                });
                                else finalize(isError, error);
                            }
                            function finalize(isError, error) {
                                WritableStreamDefaultWriterRelease(writer);
                                ReadableStreamReaderGenericRelease(reader);
                                if (signal !== undefined) signal.removeEventListener('abort', abortAlgorithm);
                                if (isError) reject(error);
                                else resolve(undefined);
                            }
                        });
                    }
                    var ReadableStreamDefaultController = function() {
                        function ReadableStreamDefaultController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(ReadableStreamDefaultController.prototype, "desiredSize", {
                            get: function() {
                                if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('desiredSize');
                                return ReadableStreamDefaultControllerGetDesiredSize(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamDefaultController.prototype.close = function() {
                            if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('close');
                            if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(this)) throw new TypeError('The stream is not in a state that permits close');
                            ReadableStreamDefaultControllerClose(this);
                        };
                        ReadableStreamDefaultController.prototype.enqueue = function(chunk) {
                            if (chunk === void 0) chunk = undefined;
                            if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('enqueue');
                            if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(this)) throw new TypeError('The stream is not in a state that permits enqueue');
                            return ReadableStreamDefaultControllerEnqueue(this, chunk);
                        };
                        ReadableStreamDefaultController.prototype.error = function(e) {
                            if (e === void 0) e = undefined;
                            if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('error');
                            ReadableStreamDefaultControllerError(this, e);
                        };
                        ReadableStreamDefaultController.prototype[CancelSteps] = function(reason) {
                            ResetQueue(this);
                            var result = this._cancelAlgorithm(reason);
                            ReadableStreamDefaultControllerClearAlgorithms(this);
                            return result;
                        };
                        ReadableStreamDefaultController.prototype[PullSteps] = function(readRequest) {
                            var stream = this._controlledReadableStream;
                            if (this._queue.length > 0) {
                                var chunk = DequeueValue(this);
                                if (this._closeRequested && this._queue.length === 0) {
                                    ReadableStreamDefaultControllerClearAlgorithms(this);
                                    ReadableStreamClose(stream);
                                } else ReadableStreamDefaultControllerCallPullIfNeeded(this);
                                readRequest._chunkSteps(chunk);
                            } else {
                                ReadableStreamAddReadRequest(stream, readRequest);
                                ReadableStreamDefaultControllerCallPullIfNeeded(this);
                            }
                        };
                        return ReadableStreamDefaultController;
                    }();
                    Object.defineProperties(ReadableStreamDefaultController.prototype, {
                        close: {
                            enumerable: true
                        },
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamDefaultController',
                        configurable: true
                    });
                    function IsReadableStreamDefaultController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableStream')) return false;
                        return x instanceof ReadableStreamDefaultController;
                    }
                    function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
                        var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
                        if (!shouldPull) return;
                        if (controller._pulling) {
                            controller._pullAgain = true;
                            return;
                        }
                        controller._pulling = true;
                        var pullPromise = controller._pullAlgorithm();
                        uponPromise(pullPromise, function() {
                            controller._pulling = false;
                            if (controller._pullAgain) {
                                controller._pullAgain = false;
                                ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                            }
                        }, function(e) {
                            ReadableStreamDefaultControllerError(controller, e);
                        });
                    }
                    function ReadableStreamDefaultControllerShouldCallPull(controller) {
                        var stream = controller._controlledReadableStream;
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) return false;
                        if (!controller._started) return false;
                        if (IsReadableStreamLocked(stream) && ReadableStreamGetNumReadRequests(stream) > 0) return true;
                        var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
                        if (desiredSize > 0) return true;
                        return false;
                    }
                    function ReadableStreamDefaultControllerClearAlgorithms(controller) {
                        controller._pullAlgorithm = undefined;
                        controller._cancelAlgorithm = undefined;
                        controller._strategySizeAlgorithm = undefined;
                    }
                    function ReadableStreamDefaultControllerClose(controller) {
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) return;
                        var stream = controller._controlledReadableStream;
                        controller._closeRequested = true;
                        if (controller._queue.length === 0) {
                            ReadableStreamDefaultControllerClearAlgorithms(controller);
                            ReadableStreamClose(stream);
                        }
                    }
                    function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) return;
                        var stream = controller._controlledReadableStream;
                        if (IsReadableStreamLocked(stream) && ReadableStreamGetNumReadRequests(stream) > 0) ReadableStreamFulfillReadRequest(stream, chunk, false);
                        else {
                            var chunkSize = void 0;
                            try {
                                chunkSize = controller._strategySizeAlgorithm(chunk);
                            } catch (chunkSizeE) {
                                ReadableStreamDefaultControllerError(controller, chunkSizeE);
                                throw chunkSizeE;
                            }
                            try {
                                EnqueueValueWithSize(controller, chunk, chunkSize);
                            } catch (enqueueE) {
                                ReadableStreamDefaultControllerError(controller, enqueueE);
                                throw enqueueE;
                            }
                        }
                        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                    }
                    function ReadableStreamDefaultControllerError(controller, e) {
                        var stream = controller._controlledReadableStream;
                        if (stream._state !== 'readable') return;
                        ResetQueue(controller);
                        ReadableStreamDefaultControllerClearAlgorithms(controller);
                        ReadableStreamError(stream, e);
                    }
                    function ReadableStreamDefaultControllerGetDesiredSize(controller) {
                        var state = controller._controlledReadableStream._state;
                        if (state === 'errored') return null;
                        if (state === 'closed') return 0;
                        return controller._strategyHWM - controller._queueTotalSize;
                    }
                    function ReadableStreamDefaultControllerHasBackpressure(controller) {
                        if (ReadableStreamDefaultControllerShouldCallPull(controller)) return false;
                        return true;
                    }
                    function ReadableStreamDefaultControllerCanCloseOrEnqueue(controller) {
                        var state = controller._controlledReadableStream._state;
                        if (!controller._closeRequested && state === 'readable') return true;
                        return false;
                    }
                    function SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
                        controller._controlledReadableStream = stream;
                        controller._queue = undefined;
                        controller._queueTotalSize = undefined;
                        ResetQueue(controller);
                        controller._started = false;
                        controller._closeRequested = false;
                        controller._pullAgain = false;
                        controller._pulling = false;
                        controller._strategySizeAlgorithm = sizeAlgorithm;
                        controller._strategyHWM = highWaterMark;
                        controller._pullAlgorithm = pullAlgorithm;
                        controller._cancelAlgorithm = cancelAlgorithm;
                        stream._readableStreamController = controller;
                        var startResult = startAlgorithm();
                        uponPromise(promiseResolvedWith(startResult), function() {
                            controller._started = true;
                            ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                        }, function(r) {
                            ReadableStreamDefaultControllerError(controller, r);
                        });
                    }
                    function SetUpReadableStreamDefaultControllerFromUnderlyingSource(stream, underlyingSource, highWaterMark, sizeAlgorithm) {
                        var controller = Object.create(ReadableStreamDefaultController.prototype);
                        var startAlgorithm = function() {
                            return undefined;
                        };
                        var pullAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var cancelAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (underlyingSource.start !== undefined) startAlgorithm = function() {
                            return underlyingSource.start(controller);
                        };
                        if (underlyingSource.pull !== undefined) pullAlgorithm = function() {
                            return underlyingSource.pull(controller);
                        };
                        if (underlyingSource.cancel !== undefined) cancelAlgorithm = function(reason) {
                            return underlyingSource.cancel(reason);
                        };
                        SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
                    }
                    function defaultControllerBrandCheckException$1(name) {
                        return new TypeError("ReadableStreamDefaultController.prototype." + name + " can only be used on a ReadableStreamDefaultController");
                    }
                    function ReadableStreamTee(stream, cloneForBranch2) {
                        if (IsReadableByteStreamController(stream._readableStreamController)) return ReadableByteStreamTee(stream);
                        return ReadableStreamDefaultTee(stream);
                    }
                    function ReadableStreamDefaultTee(stream, cloneForBranch2) {
                        var reader = AcquireReadableStreamDefaultReader(stream);
                        var reading = false;
                        var readAgain = false;
                        var canceled1 = false;
                        var canceled2 = false;
                        var reason1;
                        var reason2;
                        var branch1;
                        var branch2;
                        var resolveCancelPromise;
                        var cancelPromise = newPromise(function(resolve) {
                            resolveCancelPromise = resolve;
                        });
                        function pullAlgorithm() {
                            if (reading) {
                                readAgain = true;
                                return promiseResolvedWith(undefined);
                            }
                            reading = true;
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    queueMicrotask(function() {
                                        readAgain = false;
                                        var chunk1 = chunk;
                                        var chunk2 = chunk;
                                        if (!canceled1) ReadableStreamDefaultControllerEnqueue(branch1._readableStreamController, chunk1);
                                        if (!canceled2) ReadableStreamDefaultControllerEnqueue(branch2._readableStreamController, chunk2);
                                        reading = false;
                                        if (readAgain) pullAlgorithm();
                                    });
                                },
                                _closeSteps: function() {
                                    reading = false;
                                    if (!canceled1) ReadableStreamDefaultControllerClose(branch1._readableStreamController);
                                    if (!canceled2) ReadableStreamDefaultControllerClose(branch2._readableStreamController);
                                    if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                                },
                                _errorSteps: function() {
                                    reading = false;
                                }
                            };
                            ReadableStreamDefaultReaderRead(reader, readRequest);
                            return promiseResolvedWith(undefined);
                        }
                        function cancel1Algorithm(reason) {
                            canceled1 = true;
                            reason1 = reason;
                            if (canceled2) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function cancel2Algorithm(reason) {
                            canceled2 = true;
                            reason2 = reason;
                            if (canceled1) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function startAlgorithm() {}
                        branch1 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel1Algorithm);
                        branch2 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel2Algorithm);
                        uponRejection(reader._closedPromise, function(r) {
                            ReadableStreamDefaultControllerError(branch1._readableStreamController, r);
                            ReadableStreamDefaultControllerError(branch2._readableStreamController, r);
                            if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                        });
                        return [
                            branch1,
                            branch2
                        ];
                    }
                    function ReadableByteStreamTee(stream) {
                        var reader = AcquireReadableStreamDefaultReader(stream);
                        var reading = false;
                        var readAgainForBranch1 = false;
                        var readAgainForBranch2 = false;
                        var canceled1 = false;
                        var canceled2 = false;
                        var reason1;
                        var reason2;
                        var branch1;
                        var branch2;
                        var resolveCancelPromise;
                        var cancelPromise = newPromise(function(resolve) {
                            resolveCancelPromise = resolve;
                        });
                        function forwardReaderError(thisReader) {
                            uponRejection(thisReader._closedPromise, function(r) {
                                if (thisReader !== reader) return;
                                ReadableByteStreamControllerError(branch1._readableStreamController, r);
                                ReadableByteStreamControllerError(branch2._readableStreamController, r);
                                if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                            });
                        }
                        function pullWithDefaultReader() {
                            if (IsReadableStreamBYOBReader(reader)) {
                                ReadableStreamReaderGenericRelease(reader);
                                reader = AcquireReadableStreamDefaultReader(stream);
                                forwardReaderError(reader);
                            }
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    queueMicrotask(function() {
                                        readAgainForBranch1 = false;
                                        readAgainForBranch2 = false;
                                        var chunk1 = chunk;
                                        var chunk2 = chunk;
                                        if (!canceled1 && !canceled2) try {
                                            chunk2 = CloneAsUint8Array(chunk);
                                        } catch (cloneE) {
                                            ReadableByteStreamControllerError(branch1._readableStreamController, cloneE);
                                            ReadableByteStreamControllerError(branch2._readableStreamController, cloneE);
                                            resolveCancelPromise(ReadableStreamCancel(stream, cloneE));
                                            return;
                                        }
                                        if (!canceled1) ReadableByteStreamControllerEnqueue(branch1._readableStreamController, chunk1);
                                        if (!canceled2) ReadableByteStreamControllerEnqueue(branch2._readableStreamController, chunk2);
                                        reading = false;
                                        if (readAgainForBranch1) pull1Algorithm();
                                        else if (readAgainForBranch2) pull2Algorithm();
                                    });
                                },
                                _closeSteps: function() {
                                    reading = false;
                                    if (!canceled1) ReadableByteStreamControllerClose(branch1._readableStreamController);
                                    if (!canceled2) ReadableByteStreamControllerClose(branch2._readableStreamController);
                                    if (branch1._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond(branch1._readableStreamController, 0);
                                    if (branch2._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond(branch2._readableStreamController, 0);
                                    if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                                },
                                _errorSteps: function() {
                                    reading = false;
                                }
                            };
                            ReadableStreamDefaultReaderRead(reader, readRequest);
                        }
                        function pullWithBYOBReader(view, forBranch2) {
                            if (IsReadableStreamDefaultReader(reader)) {
                                ReadableStreamReaderGenericRelease(reader);
                                reader = AcquireReadableStreamBYOBReader(stream);
                                forwardReaderError(reader);
                            }
                            var byobBranch = forBranch2 ? branch2 : branch1;
                            var otherBranch = forBranch2 ? branch1 : branch2;
                            var readIntoRequest = {
                                _chunkSteps: function(chunk) {
                                    queueMicrotask(function() {
                                        readAgainForBranch1 = false;
                                        readAgainForBranch2 = false;
                                        var byobCanceled = forBranch2 ? canceled2 : canceled1;
                                        var otherCanceled = forBranch2 ? canceled1 : canceled2;
                                        if (!otherCanceled) {
                                            var clonedChunk = void 0;
                                            try {
                                                clonedChunk = CloneAsUint8Array(chunk);
                                            } catch (cloneE) {
                                                ReadableByteStreamControllerError(byobBranch._readableStreamController, cloneE);
                                                ReadableByteStreamControllerError(otherBranch._readableStreamController, cloneE);
                                                resolveCancelPromise(ReadableStreamCancel(stream, cloneE));
                                                return;
                                            }
                                            if (!byobCanceled) ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                                            ReadableByteStreamControllerEnqueue(otherBranch._readableStreamController, clonedChunk);
                                        } else if (!byobCanceled) ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                                        reading = false;
                                        if (readAgainForBranch1) pull1Algorithm();
                                        else if (readAgainForBranch2) pull2Algorithm();
                                    });
                                },
                                _closeSteps: function(chunk) {
                                    reading = false;
                                    var byobCanceled = forBranch2 ? canceled2 : canceled1;
                                    var otherCanceled = forBranch2 ? canceled1 : canceled2;
                                    if (!byobCanceled) ReadableByteStreamControllerClose(byobBranch._readableStreamController);
                                    if (!otherCanceled) ReadableByteStreamControllerClose(otherBranch._readableStreamController);
                                    if (chunk !== undefined) {
                                        if (!byobCanceled) ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                                        if (!otherCanceled && otherBranch._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond(otherBranch._readableStreamController, 0);
                                    }
                                    if (!byobCanceled || !otherCanceled) resolveCancelPromise(undefined);
                                },
                                _errorSteps: function() {
                                    reading = false;
                                }
                            };
                            ReadableStreamBYOBReaderRead(reader, view, readIntoRequest);
                        }
                        function pull1Algorithm() {
                            if (reading) {
                                readAgainForBranch1 = true;
                                return promiseResolvedWith(undefined);
                            }
                            reading = true;
                            var byobRequest = ReadableByteStreamControllerGetBYOBRequest(branch1._readableStreamController);
                            if (byobRequest === null) pullWithDefaultReader();
                            else pullWithBYOBReader(byobRequest._view, false);
                            return promiseResolvedWith(undefined);
                        }
                        function pull2Algorithm() {
                            if (reading) {
                                readAgainForBranch2 = true;
                                return promiseResolvedWith(undefined);
                            }
                            reading = true;
                            var byobRequest = ReadableByteStreamControllerGetBYOBRequest(branch2._readableStreamController);
                            if (byobRequest === null) pullWithDefaultReader();
                            else pullWithBYOBReader(byobRequest._view, true);
                            return promiseResolvedWith(undefined);
                        }
                        function cancel1Algorithm(reason) {
                            canceled1 = true;
                            reason1 = reason;
                            if (canceled2) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function cancel2Algorithm(reason) {
                            canceled2 = true;
                            reason2 = reason;
                            if (canceled1) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function startAlgorithm() {}
                        branch1 = CreateReadableByteStream(startAlgorithm, pull1Algorithm, cancel1Algorithm);
                        branch2 = CreateReadableByteStream(startAlgorithm, pull2Algorithm, cancel2Algorithm);
                        forwardReaderError(reader);
                        return [
                            branch1,
                            branch2
                        ];
                    }
                    function convertUnderlyingDefaultOrByteSource(source, context) {
                        assertDictionary(source, context);
                        var original = source;
                        var autoAllocateChunkSize = original === null || original === void 0 ? void 0 : original.autoAllocateChunkSize;
                        var cancel = original === null || original === void 0 ? void 0 : original.cancel;
                        var pull = original === null || original === void 0 ? void 0 : original.pull;
                        var start = original === null || original === void 0 ? void 0 : original.start;
                        var type = original === null || original === void 0 ? void 0 : original.type;
                        return {
                            autoAllocateChunkSize: autoAllocateChunkSize === undefined ? undefined : convertUnsignedLongLongWithEnforceRange(autoAllocateChunkSize, context + " has member 'autoAllocateChunkSize' that"),
                            cancel: cancel === undefined ? undefined : convertUnderlyingSourceCancelCallback(cancel, original, context + " has member 'cancel' that"),
                            pull: pull === undefined ? undefined : convertUnderlyingSourcePullCallback(pull, original, context + " has member 'pull' that"),
                            start: start === undefined ? undefined : convertUnderlyingSourceStartCallback(start, original, context + " has member 'start' that"),
                            type: type === undefined ? undefined : convertReadableStreamType(type, context + " has member 'type' that")
                        };
                    }
                    function convertUnderlyingSourceCancelCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(reason) {
                            return promiseCall(fn, original, [
                                reason
                            ]);
                        };
                    }
                    function convertUnderlyingSourcePullCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return promiseCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertUnderlyingSourceStartCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return reflectCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertReadableStreamType(type, context) {
                        type = "" + type;
                        if (type !== 'bytes') throw new TypeError(context + " '" + type + "' is not a valid enumeration value for ReadableStreamType");
                        return type;
                    }
                    function convertReaderOptions(options, context) {
                        assertDictionary(options, context);
                        var mode = options === null || options === void 0 ? void 0 : options.mode;
                        return {
                            mode: mode === undefined ? undefined : convertReadableStreamReaderMode(mode, context + " has member 'mode' that")
                        };
                    }
                    function convertReadableStreamReaderMode(mode, context) {
                        mode = "" + mode;
                        if (mode !== 'byob') throw new TypeError(context + " '" + mode + "' is not a valid enumeration value for ReadableStreamReaderMode");
                        return mode;
                    }
                    function convertIteratorOptions(options, context) {
                        assertDictionary(options, context);
                        var preventCancel = options === null || options === void 0 ? void 0 : options.preventCancel;
                        return {
                            preventCancel: Boolean(preventCancel)
                        };
                    }
                    function convertPipeOptions(options, context) {
                        assertDictionary(options, context);
                        var preventAbort = options === null || options === void 0 ? void 0 : options.preventAbort;
                        var preventCancel = options === null || options === void 0 ? void 0 : options.preventCancel;
                        var preventClose = options === null || options === void 0 ? void 0 : options.preventClose;
                        var signal = options === null || options === void 0 ? void 0 : options.signal;
                        if (signal !== undefined) assertAbortSignal(signal, context + " has member 'signal' that");
                        return {
                            preventAbort: Boolean(preventAbort),
                            preventCancel: Boolean(preventCancel),
                            preventClose: Boolean(preventClose),
                            signal: signal
                        };
                    }
                    function assertAbortSignal(signal, context) {
                        if (!isAbortSignal(signal)) throw new TypeError(context + " is not an AbortSignal.");
                    }
                    function convertReadableWritablePair(pair, context) {
                        assertDictionary(pair, context);
                        var readable = pair === null || pair === void 0 ? void 0 : pair.readable;
                        assertRequiredField(readable, 'readable', 'ReadableWritablePair');
                        assertReadableStream(readable, context + " has member 'readable' that");
                        var writable = pair === null || pair === void 0 ? void 0 : pair.writable;
                        assertRequiredField(writable, 'writable', 'ReadableWritablePair');
                        assertWritableStream(writable, context + " has member 'writable' that");
                        return {
                            readable: readable,
                            writable: writable
                        };
                    }
                    var ReadableStream1 = function() {
                        function ReadableStream1(rawUnderlyingSource, rawStrategy) {
                            if (rawUnderlyingSource === void 0) rawUnderlyingSource = {};
                            if (rawStrategy === void 0) rawStrategy = {};
                            if (rawUnderlyingSource === undefined) rawUnderlyingSource = null;
                            else assertObject(rawUnderlyingSource, 'First parameter');
                            var strategy = convertQueuingStrategy(rawStrategy, 'Second parameter');
                            var underlyingSource = convertUnderlyingDefaultOrByteSource(rawUnderlyingSource, 'First parameter');
                            InitializeReadableStream(this);
                            if (underlyingSource.type === 'bytes') {
                                if (strategy.size !== undefined) throw new RangeError('The strategy for a byte stream cannot have a size function');
                                var highWaterMark = ExtractHighWaterMark(strategy, 0);
                                SetUpReadableByteStreamControllerFromUnderlyingSource(this, underlyingSource, highWaterMark);
                            } else {
                                var sizeAlgorithm = ExtractSizeAlgorithm(strategy);
                                var highWaterMark = ExtractHighWaterMark(strategy, 1);
                                SetUpReadableStreamDefaultControllerFromUnderlyingSource(this, underlyingSource, highWaterMark, sizeAlgorithm);
                            }
                        }
                        Object.defineProperty(ReadableStream1.prototype, "locked", {
                            get: function() {
                                if (!IsReadableStream(this)) throw streamBrandCheckException$1('locked');
                                return IsReadableStreamLocked(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStream1.prototype.cancel = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsReadableStream(this)) return promiseRejectedWith(streamBrandCheckException$1('cancel'));
                            if (IsReadableStreamLocked(this)) return promiseRejectedWith(new TypeError('Cannot cancel a stream that already has a reader'));
                            return ReadableStreamCancel(this, reason);
                        };
                        ReadableStream1.prototype.getReader = function(rawOptions) {
                            if (rawOptions === void 0) rawOptions = undefined;
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('getReader');
                            var options = convertReaderOptions(rawOptions, 'First parameter');
                            if (options.mode === undefined) return AcquireReadableStreamDefaultReader(this);
                            return AcquireReadableStreamBYOBReader(this);
                        };
                        ReadableStream1.prototype.pipeThrough = function(rawTransform, rawOptions) {
                            if (rawOptions === void 0) rawOptions = {};
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('pipeThrough');
                            assertRequiredArgument(rawTransform, 1, 'pipeThrough');
                            var transform = convertReadableWritablePair(rawTransform, 'First parameter');
                            var options = convertPipeOptions(rawOptions, 'Second parameter');
                            if (IsReadableStreamLocked(this)) throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream');
                            if (IsWritableStreamLocked(transform.writable)) throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream');
                            var promise = ReadableStreamPipeTo(this, transform.writable, options.preventClose, options.preventAbort, options.preventCancel, options.signal);
                            setPromiseIsHandledToTrue(promise);
                            return transform.readable;
                        };
                        ReadableStream1.prototype.pipeTo = function(destination, rawOptions) {
                            if (rawOptions === void 0) rawOptions = {};
                            if (!IsReadableStream(this)) return promiseRejectedWith(streamBrandCheckException$1('pipeTo'));
                            if (destination === undefined) return promiseRejectedWith("Parameter 1 is required in 'pipeTo'.");
                            if (!IsWritableStream(destination)) return promiseRejectedWith(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
                            var options;
                            try {
                                options = convertPipeOptions(rawOptions, 'Second parameter');
                            } catch (e) {
                                return promiseRejectedWith(e);
                            }
                            if (IsReadableStreamLocked(this)) return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
                            if (IsWritableStreamLocked(destination)) return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
                            return ReadableStreamPipeTo(this, destination, options.preventClose, options.preventAbort, options.preventCancel, options.signal);
                        };
                        ReadableStream1.prototype.tee = function() {
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('tee');
                            var branches = ReadableStreamTee(this);
                            return CreateArrayFromList(branches);
                        };
                        ReadableStream1.prototype.values = function(rawOptions) {
                            if (rawOptions === void 0) rawOptions = undefined;
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('values');
                            var options = convertIteratorOptions(rawOptions, 'First parameter');
                            return AcquireReadableStreamAsyncIterator(this, options.preventCancel);
                        };
                        return ReadableStream1;
                    }();
                    Object.defineProperties(ReadableStream1.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        getReader: {
                            enumerable: true
                        },
                        pipeThrough: {
                            enumerable: true
                        },
                        pipeTo: {
                            enumerable: true
                        },
                        tee: {
                            enumerable: true
                        },
                        values: {
                            enumerable: true
                        },
                        locked: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStream1.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStream',
                        configurable: true
                    });
                    if (typeof SymbolPolyfill.asyncIterator === 'symbol') Object.defineProperty(ReadableStream1.prototype, SymbolPolyfill.asyncIterator, {
                        value: ReadableStream1.prototype.values,
                        writable: true,
                        configurable: true
                    });
                    function CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
                        if (highWaterMark === void 0) highWaterMark = 1;
                        if (sizeAlgorithm === void 0) sizeAlgorithm = function() {
                            return 1;
                        };
                        var stream = Object.create(ReadableStream1.prototype);
                        InitializeReadableStream(stream);
                        var controller = Object.create(ReadableStreamDefaultController.prototype);
                        SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
                        return stream;
                    }
                    function CreateReadableByteStream(startAlgorithm, pullAlgorithm, cancelAlgorithm) {
                        var stream = Object.create(ReadableStream1.prototype);
                        InitializeReadableStream(stream);
                        var controller = Object.create(ReadableByteStreamController.prototype);
                        SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, 0, undefined);
                        return stream;
                    }
                    function InitializeReadableStream(stream) {
                        stream._state = 'readable';
                        stream._reader = undefined;
                        stream._storedError = undefined;
                        stream._disturbed = false;
                    }
                    function IsReadableStream(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) return false;
                        return x instanceof ReadableStream1;
                    }
                    function IsReadableStreamLocked(stream) {
                        if (stream._reader === undefined) return false;
                        return true;
                    }
                    function ReadableStreamCancel(stream, reason) {
                        stream._disturbed = true;
                        if (stream._state === 'closed') return promiseResolvedWith(undefined);
                        if (stream._state === 'errored') return promiseRejectedWith(stream._storedError);
                        ReadableStreamClose(stream);
                        var reader = stream._reader;
                        if (reader !== undefined && IsReadableStreamBYOBReader(reader)) {
                            reader._readIntoRequests.forEach(function(readIntoRequest) {
                                readIntoRequest._closeSteps(undefined);
                            });
                            reader._readIntoRequests = new SimpleQueue();
                        }
                        var sourceCancelPromise = stream._readableStreamController[CancelSteps](reason);
                        return transformPromiseWith(sourceCancelPromise, noop);
                    }
                    function ReadableStreamClose(stream) {
                        stream._state = 'closed';
                        var reader = stream._reader;
                        if (reader === undefined) return;
                        defaultReaderClosedPromiseResolve(reader);
                        if (IsReadableStreamDefaultReader(reader)) {
                            reader._readRequests.forEach(function(readRequest) {
                                readRequest._closeSteps();
                            });
                            reader._readRequests = new SimpleQueue();
                        }
                    }
                    function ReadableStreamError(stream, e) {
                        stream._state = 'errored';
                        stream._storedError = e;
                        var reader = stream._reader;
                        if (reader === undefined) return;
                        defaultReaderClosedPromiseReject(reader, e);
                        if (IsReadableStreamDefaultReader(reader)) {
                            reader._readRequests.forEach(function(readRequest) {
                                readRequest._errorSteps(e);
                            });
                            reader._readRequests = new SimpleQueue();
                        } else {
                            reader._readIntoRequests.forEach(function(readIntoRequest) {
                                readIntoRequest._errorSteps(e);
                            });
                            reader._readIntoRequests = new SimpleQueue();
                        }
                    }
                    function streamBrandCheckException$1(name) {
                        return new TypeError("ReadableStream.prototype." + name + " can only be used on a ReadableStream");
                    }
                    function convertQueuingStrategyInit(init, context) {
                        assertDictionary(init, context);
                        var highWaterMark = init === null || init === void 0 ? void 0 : init.highWaterMark;
                        assertRequiredField(highWaterMark, 'highWaterMark', 'QueuingStrategyInit');
                        return {
                            highWaterMark: convertUnrestrictedDouble(highWaterMark)
                        };
                    }
                    var byteLengthSizeFunction = function(chunk) {
                        return chunk.byteLength;
                    };
                    Object.defineProperty(byteLengthSizeFunction, 'name', {
                        value: 'size',
                        configurable: true
                    });
                    var ByteLengthQueuingStrategy = function() {
                        function ByteLengthQueuingStrategy(options) {
                            assertRequiredArgument(options, 1, 'ByteLengthQueuingStrategy');
                            options = convertQueuingStrategyInit(options, 'First parameter');
                            this._byteLengthQueuingStrategyHighWaterMark = options.highWaterMark;
                        }
                        Object.defineProperty(ByteLengthQueuingStrategy.prototype, "highWaterMark", {
                            get: function() {
                                if (!IsByteLengthQueuingStrategy(this)) throw byteLengthBrandCheckException('highWaterMark');
                                return this._byteLengthQueuingStrategyHighWaterMark;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(ByteLengthQueuingStrategy.prototype, "size", {
                            get: function() {
                                if (!IsByteLengthQueuingStrategy(this)) throw byteLengthBrandCheckException('size');
                                return byteLengthSizeFunction;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return ByteLengthQueuingStrategy;
                    }();
                    Object.defineProperties(ByteLengthQueuingStrategy.prototype, {
                        highWaterMark: {
                            enumerable: true
                        },
                        size: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ByteLengthQueuingStrategy.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ByteLengthQueuingStrategy',
                        configurable: true
                    });
                    function byteLengthBrandCheckException(name) {
                        return new TypeError("ByteLengthQueuingStrategy.prototype." + name + " can only be used on a ByteLengthQueuingStrategy");
                    }
                    function IsByteLengthQueuingStrategy(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_byteLengthQueuingStrategyHighWaterMark')) return false;
                        return x instanceof ByteLengthQueuingStrategy;
                    }
                    var countSizeFunction = function() {
                        return 1;
                    };
                    Object.defineProperty(countSizeFunction, 'name', {
                        value: 'size',
                        configurable: true
                    });
                    var CountQueuingStrategy = function() {
                        function CountQueuingStrategy(options) {
                            assertRequiredArgument(options, 1, 'CountQueuingStrategy');
                            options = convertQueuingStrategyInit(options, 'First parameter');
                            this._countQueuingStrategyHighWaterMark = options.highWaterMark;
                        }
                        Object.defineProperty(CountQueuingStrategy.prototype, "highWaterMark", {
                            get: function() {
                                if (!IsCountQueuingStrategy(this)) throw countBrandCheckException('highWaterMark');
                                return this._countQueuingStrategyHighWaterMark;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(CountQueuingStrategy.prototype, "size", {
                            get: function() {
                                if (!IsCountQueuingStrategy(this)) throw countBrandCheckException('size');
                                return countSizeFunction;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return CountQueuingStrategy;
                    }();
                    Object.defineProperties(CountQueuingStrategy.prototype, {
                        highWaterMark: {
                            enumerable: true
                        },
                        size: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(CountQueuingStrategy.prototype, SymbolPolyfill.toStringTag, {
                        value: 'CountQueuingStrategy',
                        configurable: true
                    });
                    function countBrandCheckException(name) {
                        return new TypeError("CountQueuingStrategy.prototype." + name + " can only be used on a CountQueuingStrategy");
                    }
                    function IsCountQueuingStrategy(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_countQueuingStrategyHighWaterMark')) return false;
                        return x instanceof CountQueuingStrategy;
                    }
                    function convertTransformer(original, context) {
                        assertDictionary(original, context);
                        var flush = original === null || original === void 0 ? void 0 : original.flush;
                        var readableType = original === null || original === void 0 ? void 0 : original.readableType;
                        var start = original === null || original === void 0 ? void 0 : original.start;
                        var transform = original === null || original === void 0 ? void 0 : original.transform;
                        var writableType = original === null || original === void 0 ? void 0 : original.writableType;
                        return {
                            flush: flush === undefined ? undefined : convertTransformerFlushCallback(flush, original, context + " has member 'flush' that"),
                            readableType: readableType,
                            start: start === undefined ? undefined : convertTransformerStartCallback(start, original, context + " has member 'start' that"),
                            transform: transform === undefined ? undefined : convertTransformerTransformCallback(transform, original, context + " has member 'transform' that"),
                            writableType: writableType
                        };
                    }
                    function convertTransformerFlushCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return promiseCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertTransformerStartCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return reflectCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertTransformerTransformCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(chunk, controller) {
                            return promiseCall(fn, original, [
                                chunk,
                                controller
                            ]);
                        };
                    }
                    var TransformStream = function() {
                        function TransformStream(rawTransformer, rawWritableStrategy, rawReadableStrategy) {
                            if (rawTransformer === void 0) rawTransformer = {};
                            if (rawWritableStrategy === void 0) rawWritableStrategy = {};
                            if (rawReadableStrategy === void 0) rawReadableStrategy = {};
                            if (rawTransformer === undefined) rawTransformer = null;
                            var writableStrategy = convertQueuingStrategy(rawWritableStrategy, 'Second parameter');
                            var readableStrategy = convertQueuingStrategy(rawReadableStrategy, 'Third parameter');
                            var transformer = convertTransformer(rawTransformer, 'First parameter');
                            if (transformer.readableType !== undefined) throw new RangeError('Invalid readableType specified');
                            if (transformer.writableType !== undefined) throw new RangeError('Invalid writableType specified');
                            var readableHighWaterMark = ExtractHighWaterMark(readableStrategy, 0);
                            var readableSizeAlgorithm = ExtractSizeAlgorithm(readableStrategy);
                            var writableHighWaterMark = ExtractHighWaterMark(writableStrategy, 1);
                            var writableSizeAlgorithm = ExtractSizeAlgorithm(writableStrategy);
                            var startPromise_resolve;
                            var startPromise = newPromise(function(resolve) {
                                startPromise_resolve = resolve;
                            });
                            InitializeTransformStream(this, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
                            SetUpTransformStreamDefaultControllerFromTransformer(this, transformer);
                            if (transformer.start !== undefined) startPromise_resolve(transformer.start(this._transformStreamController));
                            else startPromise_resolve(undefined);
                        }
                        Object.defineProperty(TransformStream.prototype, "readable", {
                            get: function() {
                                if (!IsTransformStream(this)) throw streamBrandCheckException('readable');
                                return this._readable;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(TransformStream.prototype, "writable", {
                            get: function() {
                                if (!IsTransformStream(this)) throw streamBrandCheckException('writable');
                                return this._writable;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return TransformStream;
                    }();
                    Object.defineProperties(TransformStream.prototype, {
                        readable: {
                            enumerable: true
                        },
                        writable: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(TransformStream.prototype, SymbolPolyfill.toStringTag, {
                        value: 'TransformStream',
                        configurable: true
                    });
                    function InitializeTransformStream(stream, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm) {
                        function startAlgorithm() {
                            return startPromise;
                        }
                        function writeAlgorithm(chunk) {
                            return TransformStreamDefaultSinkWriteAlgorithm(stream, chunk);
                        }
                        function abortAlgorithm(reason) {
                            return TransformStreamDefaultSinkAbortAlgorithm(stream, reason);
                        }
                        function closeAlgorithm() {
                            return TransformStreamDefaultSinkCloseAlgorithm(stream);
                        }
                        stream._writable = CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, writableHighWaterMark, writableSizeAlgorithm);
                        function pullAlgorithm() {
                            return TransformStreamDefaultSourcePullAlgorithm(stream);
                        }
                        function cancelAlgorithm(reason) {
                            TransformStreamErrorWritableAndUnblockWrite(stream, reason);
                            return promiseResolvedWith(undefined);
                        }
                        stream._readable = CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
                        stream._backpressure = undefined;
                        stream._backpressureChangePromise = undefined;
                        stream._backpressureChangePromise_resolve = undefined;
                        TransformStreamSetBackpressure(stream, true);
                        stream._transformStreamController = undefined;
                    }
                    function IsTransformStream(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) return false;
                        return x instanceof TransformStream;
                    }
                    function TransformStreamError(stream, e) {
                        ReadableStreamDefaultControllerError(stream._readable._readableStreamController, e);
                        TransformStreamErrorWritableAndUnblockWrite(stream, e);
                    }
                    function TransformStreamErrorWritableAndUnblockWrite(stream, e) {
                        TransformStreamDefaultControllerClearAlgorithms(stream._transformStreamController);
                        WritableStreamDefaultControllerErrorIfNeeded(stream._writable._writableStreamController, e);
                        if (stream._backpressure) TransformStreamSetBackpressure(stream, false);
                    }
                    function TransformStreamSetBackpressure(stream, backpressure) {
                        if (stream._backpressureChangePromise !== undefined) stream._backpressureChangePromise_resolve();
                        stream._backpressureChangePromise = newPromise(function(resolve) {
                            stream._backpressureChangePromise_resolve = resolve;
                        });
                        stream._backpressure = backpressure;
                    }
                    var TransformStreamDefaultController = function() {
                        function TransformStreamDefaultController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(TransformStreamDefaultController.prototype, "desiredSize", {
                            get: function() {
                                if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('desiredSize');
                                var readableController = this._controlledTransformStream._readable._readableStreamController;
                                return ReadableStreamDefaultControllerGetDesiredSize(readableController);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        TransformStreamDefaultController.prototype.enqueue = function(chunk) {
                            if (chunk === void 0) chunk = undefined;
                            if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('enqueue');
                            TransformStreamDefaultControllerEnqueue(this, chunk);
                        };
                        TransformStreamDefaultController.prototype.error = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('error');
                            TransformStreamDefaultControllerError(this, reason);
                        };
                        TransformStreamDefaultController.prototype.terminate = function() {
                            if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('terminate');
                            TransformStreamDefaultControllerTerminate(this);
                        };
                        return TransformStreamDefaultController;
                    }();
                    Object.defineProperties(TransformStreamDefaultController.prototype, {
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        terminate: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(TransformStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'TransformStreamDefaultController',
                        configurable: true
                    });
                    function IsTransformStreamDefaultController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) return false;
                        return x instanceof TransformStreamDefaultController;
                    }
                    function SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm) {
                        controller._controlledTransformStream = stream;
                        stream._transformStreamController = controller;
                        controller._transformAlgorithm = transformAlgorithm;
                        controller._flushAlgorithm = flushAlgorithm;
                    }
                    function SetUpTransformStreamDefaultControllerFromTransformer(stream, transformer) {
                        var controller = Object.create(TransformStreamDefaultController.prototype);
                        var transformAlgorithm = function(chunk) {
                            try {
                                TransformStreamDefaultControllerEnqueue(controller, chunk);
                                return promiseResolvedWith(undefined);
                            } catch (transformResultE) {
                                return promiseRejectedWith(transformResultE);
                            }
                        };
                        var flushAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (transformer.transform !== undefined) transformAlgorithm = function(chunk) {
                            return transformer.transform(chunk, controller);
                        };
                        if (transformer.flush !== undefined) flushAlgorithm = function() {
                            return transformer.flush(controller);
                        };
                        SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm);
                    }
                    function TransformStreamDefaultControllerClearAlgorithms(controller) {
                        controller._transformAlgorithm = undefined;
                        controller._flushAlgorithm = undefined;
                    }
                    function TransformStreamDefaultControllerEnqueue(controller, chunk) {
                        var stream = controller._controlledTransformStream;
                        var readableController = stream._readable._readableStreamController;
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController)) throw new TypeError('Readable side is not in a state that permits enqueue');
                        try {
                            ReadableStreamDefaultControllerEnqueue(readableController, chunk);
                        } catch (e) {
                            TransformStreamErrorWritableAndUnblockWrite(stream, e);
                            throw stream._readable._storedError;
                        }
                        var backpressure = ReadableStreamDefaultControllerHasBackpressure(readableController);
                        if (backpressure !== stream._backpressure) TransformStreamSetBackpressure(stream, true);
                    }
                    function TransformStreamDefaultControllerError(controller, e) {
                        TransformStreamError(controller._controlledTransformStream, e);
                    }
                    function TransformStreamDefaultControllerPerformTransform(controller, chunk) {
                        var transformPromise = controller._transformAlgorithm(chunk);
                        return transformPromiseWith(transformPromise, undefined, function(r) {
                            TransformStreamError(controller._controlledTransformStream, r);
                            throw r;
                        });
                    }
                    function TransformStreamDefaultControllerTerminate(controller) {
                        var stream = controller._controlledTransformStream;
                        var readableController = stream._readable._readableStreamController;
                        ReadableStreamDefaultControllerClose(readableController);
                        var error = new TypeError('TransformStream terminated');
                        TransformStreamErrorWritableAndUnblockWrite(stream, error);
                    }
                    function TransformStreamDefaultSinkWriteAlgorithm(stream, chunk) {
                        var controller = stream._transformStreamController;
                        if (stream._backpressure) {
                            var backpressureChangePromise = stream._backpressureChangePromise;
                            return transformPromiseWith(backpressureChangePromise, function() {
                                var writable = stream._writable;
                                var state = writable._state;
                                if (state === 'erroring') throw writable._storedError;
                                return TransformStreamDefaultControllerPerformTransform(controller, chunk);
                            });
                        }
                        return TransformStreamDefaultControllerPerformTransform(controller, chunk);
                    }
                    function TransformStreamDefaultSinkAbortAlgorithm(stream, reason) {
                        TransformStreamError(stream, reason);
                        return promiseResolvedWith(undefined);
                    }
                    function TransformStreamDefaultSinkCloseAlgorithm(stream) {
                        var readable = stream._readable;
                        var controller = stream._transformStreamController;
                        var flushPromise = controller._flushAlgorithm();
                        TransformStreamDefaultControllerClearAlgorithms(controller);
                        return transformPromiseWith(flushPromise, function() {
                            if (readable._state === 'errored') throw readable._storedError;
                            ReadableStreamDefaultControllerClose(readable._readableStreamController);
                        }, function(r) {
                            TransformStreamError(stream, r);
                            throw readable._storedError;
                        });
                    }
                    function TransformStreamDefaultSourcePullAlgorithm(stream) {
                        TransformStreamSetBackpressure(stream, false);
                        return stream._backpressureChangePromise;
                    }
                    function defaultControllerBrandCheckException(name) {
                        return new TypeError("TransformStreamDefaultController.prototype." + name + " can only be used on a TransformStreamDefaultController");
                    }
                    function streamBrandCheckException(name) {
                        return new TypeError("TransformStream.prototype." + name + " can only be used on a TransformStream");
                    }
                    exports.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy;
                    exports.CountQueuingStrategy = CountQueuingStrategy;
                    exports.ReadableByteStreamController = ReadableByteStreamController;
                    exports.ReadableStream = ReadableStream1;
                    exports.ReadableStreamBYOBReader = ReadableStreamBYOBReader;
                    exports.ReadableStreamBYOBRequest = ReadableStreamBYOBRequest;
                    exports.ReadableStreamDefaultController = ReadableStreamDefaultController;
                    exports.ReadableStreamDefaultReader = ReadableStreamDefaultReader;
                    exports.TransformStream = TransformStream;
                    exports.TransformStreamDefaultController = TransformStreamDefaultController;
                    exports.WritableStream = WritableStream;
                    exports.WritableStreamDefaultController = WritableStreamDefaultController;
                    exports.WritableStreamDefaultWriter = WritableStreamDefaultWriter;
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                });
            /***/ },
            /* 135 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var BaseCanvasFactory = /*#__PURE__*/ function() {
                    function BaseCanvasFactory() {
                        _classCallCheck(this, BaseCanvasFactory);
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    _createClass(BaseCanvasFactory, [
                        {
                            key: "create",
                            value: function create(width, height) {
                                if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                                var canvas = this._createCanvas(width, height);
                                return {
                                    canvas: canvas,
                                    context: canvas.getContext("2d")
                                };
                            }
                        },
                        {
                            key: "reset",
                            value: function reset(canvasAndContext, width, height) {
                                if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                                if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                                canvasAndContext.canvas.width = width;
                                canvasAndContext.canvas.height = height;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy(canvasAndContext) {
                                if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                                canvasAndContext.canvas.width = 0;
                                canvasAndContext.canvas.height = 0;
                                canvasAndContext.canvas = null;
                                canvasAndContext.context = null;
                            }
                        },
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                            }
                        }
                    ]);
                    return BaseCanvasFactory;
                }();
                exports.BaseCanvasFactory = BaseCanvasFactory;
                var BaseCMapReaderFactory = /*#__PURE__*/ function() {
                    function BaseCMapReaderFactory(_ref) {
                        var _ref$baseUrl = _ref.baseUrl, baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl, _ref$isCompressed = _ref.isCompressed, isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed;
                        _classCallCheck(this, BaseCMapReaderFactory);
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    _createClass(BaseCMapReaderFactory, [
                        {
                            key: "fetch",
                            value: function() {
                                var _fetch = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(_ref2) {
                                    var _this = this;
                                    var name, url, compressionType;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                name = _ref2.name;
                                                if (this.baseUrl) {
                                                    _context.next = 3;
                                                    break;
                                                }
                                                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                                            case 3:
                                                if (name) {
                                                    _context.next = 5;
                                                    break;
                                                }
                                                throw new Error("CMap name must be specified.");
                                            case 5:
                                                url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                                                compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                                                return _context.abrupt("return", this._fetchData(url, compressionType)["catch"](function(reason) {
                                                    throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "", "CMap at: ").concat(url));
                                                }));
                                            case 8:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function fetch1(_x) {
                                    return _fetch.apply(this, arguments);
                                }
                                return fetch1;
                            }()
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                (0, _util.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseCMapReaderFactory;
                }();
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                var BaseStandardFontDataFactory = /*#__PURE__*/ function() {
                    function BaseStandardFontDataFactory(_ref3) {
                        var _ref3$baseUrl = _ref3.baseUrl, baseUrl = _ref3$baseUrl === void 0 ? null : _ref3$baseUrl;
                        _classCallCheck(this, BaseStandardFontDataFactory);
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    _createClass(BaseStandardFontDataFactory, [
                        {
                            key: "fetch",
                            value: function() {
                                var _fetch2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2(_ref4) {
                                    var filename, url;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                filename = _ref4.filename;
                                                if (this.baseUrl) {
                                                    _context2.next = 3;
                                                    break;
                                                }
                                                throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                                            case 3:
                                                if (filename) {
                                                    _context2.next = 5;
                                                    break;
                                                }
                                                throw new Error("Font filename must be specified.");
                                            case 5:
                                                url = "".concat(this.baseUrl).concat(filename);
                                                return _context2.abrupt("return", this._fetchData(url)["catch"](function(reason) {
                                                    throw new Error("Unable to load font data at: ".concat(url));
                                                }));
                                            case 7:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function fetch1(_x2) {
                                    return _fetch2.apply(this, arguments);
                                }
                                return fetch1;
                            }()
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                (0, _util.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseStandardFontDataFactory;
                }();
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                var BaseSVGFactory = /*#__PURE__*/ function() {
                    function BaseSVGFactory() {
                        _classCallCheck(this, BaseSVGFactory);
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    _createClass(BaseSVGFactory, [
                        {
                            key: "create",
                            value: function create(width, height) {
                                if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                                var svg = this._createSVG("svg:svg");
                                svg.setAttribute("version", "1.1");
                                svg.setAttribute("width", "".concat(width, "px"));
                                svg.setAttribute("height", "".concat(height, "px"));
                                svg.setAttribute("preserveAspectRatio", "none");
                                svg.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
                                return svg;
                            }
                        },
                        {
                            key: "createElement",
                            value: function createElement(type) {
                                if (typeof type !== "string") throw new Error("Invalid SVG element type");
                                return this._createSVG(type);
                            }
                        },
                        {
                            key: "_createSVG",
                            value: function _createSVG(type) {
                                (0, _util.unreachable)("Abstract method `_createSVG` called.");
                            }
                        }
                    ]);
                    return BaseSVGFactory;
                }();
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 136 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.build = exports.RenderTask = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                exports.getDocument = getDocument;
                exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
                exports.version = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _font_loader = __w_pdfjs_require__(137);
                var _node_utils = __w_pdfjs_require__(138);
                var _annotation_storage = __w_pdfjs_require__(139);
                var _canvas = __w_pdfjs_require__(140);
                var _worker_options = __w_pdfjs_require__(142);
                var _is_node = __w_pdfjs_require__(6);
                var _message_handler = __w_pdfjs_require__(143);
                var _metadata = __w_pdfjs_require__(144);
                var _optional_content_config = __w_pdfjs_require__(145);
                var _transport_stream = __w_pdfjs_require__(146);
                var _xfa_text = __w_pdfjs_require__(147);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _classPrivateFieldInitSpec(obj, privateMap, value) {
                    _checkPrivateRedeclaration(obj, privateMap);
                    privateMap.set(obj, value);
                }
                function _checkPrivateRedeclaration(obj, privateCollection) {
                    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function _classPrivateFieldSet(receiver, privateMap, value) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
                    _classApplyDescriptorSet(receiver, descriptor, value);
                    return value;
                }
                function _classApplyDescriptorSet(receiver, descriptor, value) {
                    if (descriptor.set) descriptor.set.call(receiver, value);
                    else {
                        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
                        descriptor.value = value;
                    }
                }
                function _classPrivateFieldGet(receiver, privateMap) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
                    return _classApplyDescriptorGet(receiver, descriptor);
                }
                function _classExtractFieldDescriptor(receiver, privateMap, action) {
                    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
                    return privateMap.get(receiver);
                }
                function _classApplyDescriptorGet(receiver, descriptor) {
                    if (descriptor.get) return descriptor.get.call(receiver);
                    return descriptor.value;
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof1(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var DEFAULT_RANGE_CHUNK_SIZE = 65536;
                var RENDERING_CANCELLED_TIMEOUT = 100;
                var DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                var DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                var DefaultStandardFontDataFactory = _is_node.isNodeJS ? _node_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                var createPDFNetworkStream;
                function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
                    createPDFNetworkStream = pdfNetworkStreamFactory;
                }
                function getDocument(src) {
                    var task = new PDFDocumentLoadingTask();
                    var source;
                    if (typeof src === "string" || src instanceof URL) source = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) source = {
                        data: src
                    };
                    else if (src instanceof PDFDataRangeTransport) source = {
                        range: src
                    };
                    else {
                        if (_typeof(src) !== "object") throw new Error("Invalid parameter in getDocument, need either string, URL, Uint8Array, or parameter object.");
                        if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                        source = src;
                    }
                    var params = Object.create(null);
                    var rangeTransport = null, worker = null;
                    for(var key in source){
                        var value = source[key];
                        switch(key){
                            case "url":
                                if (typeof window !== "undefined") try {
                                    params[key] = new URL(value, window.location).href;
                                    continue;
                                } catch (ex) {
                                    (0, _util.warn)("Cannot create valid URL: \"".concat(ex, "\"."));
                                }
                                else if (typeof value === "string" || value instanceof URL) {
                                    params[key] = value.toString();
                                    continue;
                                }
                                throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                            case "range":
                                rangeTransport = value;
                                continue;
                            case "worker":
                                worker = value;
                                continue;
                            case "data":
                                if (_is_node.isNodeJS && typeof $55a8cc56a2378350$require$Buffer !== "undefined" && value instanceof $55a8cc56a2378350$require$Buffer) params[key] = new Uint8Array(value);
                                else if (value instanceof Uint8Array) break;
                                else if (typeof value === "string") params[key] = (0, _util.stringToBytes)(value);
                                else if (_typeof(value) === "object" && value !== null && !isNaN(value.length)) params[key] = new Uint8Array(value);
                                else if ((0, _util.isArrayBuffer)(value)) params[key] = new Uint8Array(value);
                                else throw new Error("Invalid PDF binary data: either typed array, string, or array-like object is expected in the data property.");
                                continue;
                        }
                        params[key] = value;
                    }
                    params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
                    params.CMapReaderFactory = params.CMapReaderFactory || DefaultCMapReaderFactory;
                    params.StandardFontDataFactory = params.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    params.ignoreErrors = params.stopAtErrors !== true;
                    params.fontExtraProperties = params.fontExtraProperties === true;
                    params.pdfBug = params.pdfBug === true;
                    params.enableXfa = params.enableXfa === true;
                    if (typeof params.docBaseUrl !== "string" || (0, _display_utils.isDataScheme)(params.docBaseUrl)) params.docBaseUrl = null;
                    if (!Number.isInteger(params.maxImageSize)) params.maxImageSize = -1;
                    if (typeof params.useWorkerFetch !== "boolean") params.useWorkerFetch = params.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && params.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory;
                    if (typeof params.isEvalSupported !== "boolean") params.isEvalSupported = true;
                    if (typeof params.disableFontFace !== "boolean") params.disableFontFace = _is_node.isNodeJS;
                    if (typeof params.useSystemFonts !== "boolean") params.useSystemFonts = !_is_node.isNodeJS && !params.disableFontFace;
                    if (typeof params.ownerDocument === "undefined") params.ownerDocument = globalThis.document;
                    if (typeof params.disableRange !== "boolean") params.disableRange = false;
                    if (typeof params.disableStream !== "boolean") params.disableStream = false;
                    if (typeof params.disableAutoFetch !== "boolean") params.disableAutoFetch = false;
                    (0, _util.setVerbosityLevel)(params.verbosity);
                    if (!worker) {
                        var workerParams = {
                            verbosity: params.verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    var docId = task.docId;
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        var workerIdPromise = _fetchDocument(worker, params, rangeTransport, docId);
                        var networkStreamPromise = new Promise(function(resolve) {
                            var networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: params.length,
                                initialData: params.initialData,
                                progressiveDone: params.progressiveDone,
                                contentDispositionFilename: params.contentDispositionFilename,
                                disableRange: params.disableRange,
                                disableStream: params.disableStream
                            }, rangeTransport);
                            else if (!params.data) networkStream = createPDFNetworkStream({
                                url: params.url,
                                length: params.length,
                                httpHeaders: params.httpHeaders,
                                withCredentials: params.withCredentials,
                                rangeChunkSize: params.rangeChunkSize,
                                disableRange: params.disableRange,
                                disableStream: params.disableStream
                            });
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function(_ref) {
                            var _ref2 = _slicedToArray(_ref, 2), workerId = _ref2[0], networkStream = _ref2[1];
                            if (task.destroyed) throw new Error("Loading aborted");
                            var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            var transport = new WorkerTransport(messageHandler, task, networkStream, params);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    })["catch"](task._capability.reject);
                    return task;
                }
                function _fetchDocument(_x, _x2, _x3, _x4) {
                    return _fetchDocument2.apply(this, arguments);
                }
                function _fetchDocument2() {
                    _fetchDocument2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee7(worker, source, pdfDataRangeTransport, docId) {
                        var workerId;
                        return _regenerator["default"].wrap(function _callee7$(_context7) {
                            while(true)switch(_context7.prev = _context7.next){
                                case 0:
                                    if (!worker.destroyed) {
                                        _context7.next = 2;
                                        break;
                                    }
                                    throw new Error("Worker was destroyed");
                                case 2:
                                    if (pdfDataRangeTransport) {
                                        source.length = pdfDataRangeTransport.length;
                                        source.initialData = pdfDataRangeTransport.initialData;
                                        source.progressiveDone = pdfDataRangeTransport.progressiveDone;
                                        source.contentDispositionFilename = pdfDataRangeTransport.contentDispositionFilename;
                                    }
                                    _context7.next = 5;
                                    return worker.messageHandler.sendWithPromise("GetDocRequest", {
                                        docId: docId,
                                        apiVersion: '2.12.313',
                                        source: {
                                            data: source.data,
                                            url: source.url,
                                            password: source.password,
                                            disableAutoFetch: source.disableAutoFetch,
                                            rangeChunkSize: source.rangeChunkSize,
                                            length: source.length
                                        },
                                        maxImageSize: source.maxImageSize,
                                        disableFontFace: source.disableFontFace,
                                        docBaseUrl: source.docBaseUrl,
                                        ignoreErrors: source.ignoreErrors,
                                        isEvalSupported: source.isEvalSupported,
                                        fontExtraProperties: source.fontExtraProperties,
                                        enableXfa: source.enableXfa,
                                        useSystemFonts: source.useSystemFonts,
                                        cMapUrl: source.useWorkerFetch ? source.cMapUrl : null,
                                        standardFontDataUrl: source.useWorkerFetch ? source.standardFontDataUrl : null
                                    });
                                case 5:
                                    workerId = _context7.sent;
                                    if (!worker.destroyed) {
                                        _context7.next = 8;
                                        break;
                                    }
                                    throw new Error("Worker was destroyed");
                                case 8:
                                    return _context7.abrupt("return", workerId);
                                case 9:
                                case "end":
                                    return _context7.stop();
                            }
                        }, _callee7);
                    }));
                    return _fetchDocument2.apply(this, arguments);
                }
                var PDFDocumentLoadingTask = /*#__PURE__*/ function() {
                    function PDFDocumentLoadingTask() {
                        _classCallCheck(this, PDFDocumentLoadingTask);
                        this._capability = (0, _util.createPromiseCapability)();
                        this._transport = null;
                        this._worker = null;
                        this.docId = "d".concat(PDFDocumentLoadingTask.idCounters.doc++);
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                        this.onUnsupportedFeature = null;
                    }
                    _createClass(PDFDocumentLoadingTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                var _destroy = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var _this$_transport;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                this.destroyed = true;
                                                _context.next = 3;
                                                return (_this$_transport = this._transport) === null || _this$_transport === void 0 ? void 0 : _this$_transport.destroy();
                                            case 3:
                                                this._transport = null;
                                                if (this._worker) {
                                                    this._worker.destroy();
                                                    this._worker = null;
                                                }
                                            case 5:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function destroy() {
                                    return _destroy.apply(this, arguments);
                                }
                                return destroy;
                            }()
                        }
                    ], [
                        {
                            key: "idCounters",
                            get: function get() {
                                return (0, _util.shadow)(this, "idCounters", {
                                    doc: 0
                                });
                            }
                        }
                    ]);
                    return PDFDocumentLoadingTask;
                }();
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                var PDFDataRangeTransport = /*#__PURE__*/ function() {
                    function PDFDataRangeTransport(length, initialData) {
                        var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck(this, PDFDataRangeTransport);
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = (0, _util.createPromiseCapability)();
                    }
                    _createClass(PDFDataRangeTransport, [
                        {
                            key: "addRangeListener",
                            value: function addRangeListener(listener) {
                                this._rangeListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressListener",
                            value: function addProgressListener(listener) {
                                this._progressListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressiveReadListener",
                            value: function addProgressiveReadListener(listener) {
                                this._progressiveReadListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressiveDoneListener",
                            value: function addProgressiveDoneListener(listener) {
                                this._progressiveDoneListeners.push(listener);
                            }
                        },
                        {
                            key: "onDataRange",
                            value: function onDataRange(begin, chunk) {
                                var _iterator = _createForOfIteratorHelper(this._rangeListeners), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var listener = _step.value;
                                        listener(begin, chunk);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        },
                        {
                            key: "onDataProgress",
                            value: function onDataProgress(loaded, total) {
                                var _this = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator2 = _createForOfIteratorHelper(_this._progressListeners), _step2;
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            var listener = _step2.value;
                                            listener(loaded, total);
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveRead",
                            value: function onDataProgressiveRead(chunk) {
                                var _this2 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator3 = _createForOfIteratorHelper(_this2._progressiveReadListeners), _step3;
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            var listener = _step3.value;
                                            listener(chunk);
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveDone",
                            value: function onDataProgressiveDone() {
                                var _this3 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator4 = _createForOfIteratorHelper(_this3._progressiveDoneListeners), _step4;
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            var listener = _step4.value;
                                            listener();
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "transportReady",
                            value: function transportReady() {
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "requestDataRange",
                            value: function requestDataRange(begin, end) {
                                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                            }
                        },
                        {
                            key: "abort",
                            value: function abort() {}
                        }
                    ]);
                    return PDFDataRangeTransport;
                }();
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                var PDFDocumentProxy = /*#__PURE__*/ function() {
                    function PDFDocumentProxy(pdfInfo, transport) {
                        var _this4 = this;
                        _classCallCheck(this, PDFDocumentProxy);
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "fingerprint", {
                            get: function get() {
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead.");
                                return this.fingerprints[0];
                            }
                        });
                        Object.defineProperty(this, "getStats", {
                            value: function() {
                                var _value = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead.");
                                                return _context2.abrupt("return", _this4.stats || {
                                                    streamTypes: {},
                                                    fontTypes: {}
                                                });
                                            case 2:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2);
                                }));
                                function value() {
                                    return _value.apply(this, arguments);
                                }
                                return value;
                            }()
                        });
                    }
                    _createClass(PDFDocumentProxy, [
                        {
                            key: "annotationStorage",
                            get: function get() {
                                return this._transport.annotationStorage;
                            }
                        },
                        {
                            key: "numPages",
                            get: function get() {
                                return this._pdfInfo.numPages;
                            }
                        },
                        {
                            key: "fingerprints",
                            get: function get() {
                                return this._pdfInfo.fingerprints;
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return this._transport.stats;
                            }
                        },
                        {
                            key: "isPureXfa",
                            get: function get() {
                                return !!this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "allXfaHtml",
                            get: function get() {
                                return this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage(pageNumber) {
                                return this._transport.getPage(pageNumber);
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex(ref) {
                                return this._transport.getPageIndex(ref);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations() {
                                return this._transport.getDestinations();
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination(id) {
                                return this._transport.getDestination(id);
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels() {
                                return this._transport.getPageLabels();
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout() {
                                return this._transport.getPageLayout();
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode() {
                                return this._transport.getPageMode();
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences() {
                                return this._transport.getViewerPreferences();
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction() {
                                return this._transport.getOpenAction();
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments() {
                                return this._transport.getAttachments();
                            }
                        },
                        {
                            key: "getJavaScript",
                            value: function getJavaScript() {
                                return this._transport.getJavaScript();
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions() {
                                return this._transport.getDocJSActions();
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline() {
                                return this._transport.getOutline();
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig() {
                                return this._transport.getOptionalContentConfig();
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions() {
                                return this._transport.getPermissions();
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata() {
                                return this._transport.getMetadata();
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo() {
                                return this._transport.getMarkInfo();
                            }
                        },
                        {
                            key: "getData",
                            value: function getData() {
                                return this._transport.getData();
                            }
                        },
                        {
                            key: "getDownloadInfo",
                            value: function getDownloadInfo() {
                                return this._transport.downloadInfoCapability.promise;
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup() {
                                var keepLoadedFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                return this.loadingTask.destroy();
                            }
                        },
                        {
                            key: "loadingParams",
                            get: function get() {
                                return this._transport.loadingParams;
                            }
                        },
                        {
                            key: "loadingTask",
                            get: function get() {
                                return this._transport.loadingTask;
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument() {
                                if (this._transport.annotationStorage.size <= 0) (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                                return this._transport.saveDocument();
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects() {
                                return this._transport.getFieldObjects();
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions() {
                                return this._transport.hasJSActions();
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds() {
                                return this._transport.getCalculationOrderIds();
                            }
                        }
                    ]);
                    return PDFDocumentProxy;
                }();
                exports.PDFDocumentProxy = PDFDocumentProxy;
                var PDFPageProxy = /*#__PURE__*/ function() {
                    function PDFPageProxy(pageIndex, pageInfo, transport, ownerDocument) {
                        var pdfBug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                        _classCallCheck(this, PDFPageProxy);
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._ownerDocument = ownerDocument;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this.cleanupAfterRender = false;
                        this.pendingCleanup = false;
                        this._intentStates = new Map();
                        this._annotationPromises = new Map();
                        this.destroyed = false;
                    }
                    _createClass(PDFPageProxy, [
                        {
                            key: "pageNumber",
                            get: function get() {
                                return this._pageIndex + 1;
                            }
                        },
                        {
                            key: "rotate",
                            get: function get() {
                                return this._pageInfo.rotate;
                            }
                        },
                        {
                            key: "ref",
                            get: function get() {
                                return this._pageInfo.ref;
                            }
                        },
                        {
                            key: "userUnit",
                            get: function get() {
                                return this._pageInfo.userUnit;
                            }
                        },
                        {
                            key: "view",
                            get: function get() {
                                return this._pageInfo.view;
                            }
                        },
                        {
                            key: "getViewport",
                            value: function getViewport() {
                                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, scale = _ref3.scale, _ref3$rotation = _ref3.rotation, rotation = _ref3$rotation === void 0 ? this.rotate : _ref3$rotation, _ref3$offsetX = _ref3.offsetX, offsetX = _ref3$offsetX === void 0 ? 0 : _ref3$offsetX, _ref3$offsetY = _ref3.offsetY, offsetY = _ref3$offsetY === void 0 ? 0 : _ref3$offsetY, _ref3$dontFlip = _ref3.dontFlip, dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
                                return new _display_utils.PageViewport({
                                    viewBox: this.view,
                                    scale: scale,
                                    rotation: rotation,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    dontFlip: dontFlip
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations() {
                                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$intent = _ref4.intent, intent = _ref4$intent === void 0 ? "display" : _ref4$intent;
                                var intentArgs = this._transport.getRenderingIntent(intent);
                                var promise = this._annotationPromises.get(intentArgs.cacheKey);
                                if (!promise) {
                                    promise = this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                                    this._annotationPromises.set(intentArgs.cacheKey, promise);
                                    promise = promise.then(function(annotations) {
                                        var _iterator5 = _createForOfIteratorHelper(annotations), _step5;
                                        try {
                                            var _loop = function _loop() {
                                                var annotation = _step5.value;
                                                if (annotation.titleObj !== undefined) Object.defineProperty(annotation, "title", {
                                                    get: function get() {
                                                        (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead.");
                                                        return annotation.titleObj.str;
                                                    }
                                                });
                                                if (annotation.contentsObj !== undefined) Object.defineProperty(annotation, "contents", {
                                                    get: function get() {
                                                        (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead.");
                                                        return annotation.contentsObj.str;
                                                    }
                                                });
                                            };
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;)_loop();
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        return annotations;
                                    });
                                }
                                return promise;
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions() {
                                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
                            }
                        },
                        {
                            key: "getXfa",
                            value: function() {
                                var _getXfa = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee3() {
                                    var _this$_transport$_htm;
                                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                                        while(true)switch(_context3.prev = _context3.next){
                                            case 0:
                                                return _context3.abrupt("return", ((_this$_transport$_htm = this._transport._htmlForXfa) === null || _this$_transport$_htm === void 0 ? void 0 : _this$_transport$_htm.children[this._pageIndex]) || null);
                                            case 1:
                                            case "end":
                                                return _context3.stop();
                                        }
                                    }, _callee3, this);
                                }));
                                function getXfa() {
                                    return _getXfa.apply(this, arguments);
                                }
                                return getXfa;
                            }()
                        },
                        {
                            key: "render",
                            value: function render(_ref5) {
                                var _arguments$, _arguments$2, _this5 = this, _intentState;
                                var canvasContext = _ref5.canvasContext, viewport = _ref5.viewport, _ref5$intent = _ref5.intent, intent = _ref5$intent === void 0 ? "display" : _ref5$intent, _ref5$annotationMode = _ref5.annotationMode, annotationMode = _ref5$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref5$annotationMode, _ref5$transform = _ref5.transform, transform = _ref5$transform === void 0 ? null : _ref5$transform, _ref5$imageLayer = _ref5.imageLayer, imageLayer = _ref5$imageLayer === void 0 ? null : _ref5$imageLayer, _ref5$canvasFactory = _ref5.canvasFactory, canvasFactory = _ref5$canvasFactory === void 0 ? null : _ref5$canvasFactory, _ref5$background = _ref5.background, background = _ref5$background === void 0 ? null : _ref5$background, _ref5$optionalContent = _ref5.optionalContentConfigPromise, optionalContentConfigPromise = _ref5$optionalContent === void 0 ? null : _ref5$optionalContent, _ref5$annotationCanva = _ref5.annotationCanvasMap, annotationCanvasMap = _ref5$annotationCanva === void 0 ? null : _ref5$annotationCanva;
                                if (((_arguments$ = arguments[0]) === null || _arguments$ === void 0 ? void 0 : _arguments$.renderInteractiveForms) !== undefined) {
                                    (0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead.");
                                    if (arguments[0].renderInteractiveForms === true && annotationMode === _util.AnnotationMode.ENABLE) annotationMode = _util.AnnotationMode.ENABLE_FORMS;
                                }
                                if (((_arguments$2 = arguments[0]) === null || _arguments$2 === void 0 ? void 0 : _arguments$2.includeAnnotationStorage) !== undefined) {
                                    (0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead.");
                                    if (arguments[0].includeAnnotationStorage === true && annotationMode === _util.AnnotationMode.ENABLE) annotationMode = _util.AnnotationMode.ENABLE_STORAGE;
                                }
                                if (this._stats) this._stats.time("Overall");
                                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode);
                                this.pendingCleanup = false;
                                if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                                var intentState = this._intentStates.get(intentArgs.cacheKey);
                                if (!intentState) {
                                    intentState = Object.create(null);
                                    this._intentStates.set(intentArgs.cacheKey, intentState);
                                }
                                if (intentState.streamReaderCancelTimeout) {
                                    clearTimeout(intentState.streamReaderCancelTimeout);
                                    intentState.streamReaderCancelTimeout = null;
                                }
                                var canvasFactoryInstance = canvasFactory || new DefaultCanvasFactory({
                                    ownerDocument: this._ownerDocument
                                });
                                var intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                                if (!intentState.displayReadyCapability) {
                                    intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
                                    intentState.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false
                                    };
                                    if (this._stats) this._stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs);
                                }
                                var complete = function complete(error) {
                                    intentState.renderTasks["delete"](internalRenderTask);
                                    if (_this5.cleanupAfterRender || intentPrint) _this5.pendingCleanup = true;
                                    _this5._tryCleanup();
                                    if (error) {
                                        internalRenderTask.capability.reject(error);
                                        _this5._abortOperatorList({
                                            intentState: intentState,
                                            reason: error instanceof Error ? error : new Error(error)
                                        });
                                    } else internalRenderTask.capability.resolve();
                                    if (_this5._stats) {
                                        _this5._stats.timeEnd("Rendering");
                                        _this5._stats.timeEnd("Overall");
                                    }
                                };
                                var internalRenderTask = new InternalRenderTask({
                                    callback: complete,
                                    params: {
                                        canvasContext: canvasContext,
                                        viewport: viewport,
                                        transform: transform,
                                        imageLayer: imageLayer,
                                        background: background
                                    },
                                    objs: this.objs,
                                    commonObjs: this.commonObjs,
                                    annotationCanvasMap: annotationCanvasMap,
                                    operatorList: intentState.operatorList,
                                    pageIndex: this._pageIndex,
                                    canvasFactory: canvasFactoryInstance,
                                    useRequestAnimationFrame: !intentPrint,
                                    pdfBug: this._pdfBug
                                });
                                ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(internalRenderTask);
                                var renderTask = internalRenderTask.task;
                                Promise.all([
                                    intentState.displayReadyCapability.promise,
                                    optionalContentConfigPromise
                                ]).then(function(_ref6) {
                                    var _ref7 = _slicedToArray(_ref6, 2), transparency = _ref7[0], optionalContentConfig = _ref7[1];
                                    if (_this5.pendingCleanup) {
                                        complete();
                                        return;
                                    }
                                    if (_this5._stats) _this5._stats.time("Rendering");
                                    internalRenderTask.initializeGraphics({
                                        transparency: transparency,
                                        optionalContentConfig: optionalContentConfig
                                    });
                                    internalRenderTask.operatorListChanged();
                                })["catch"](complete);
                                return renderTask;
                            }
                        },
                        {
                            key: "getOperatorList",
                            value: function getOperatorList() {
                                var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref8$intent = _ref8.intent, intent = _ref8$intent === void 0 ? "display" : _ref8$intent, _ref8$annotationMode = _ref8.annotationMode, annotationMode = _ref8$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref8$annotationMode;
                                function operatorListChanged() {
                                    if (intentState.operatorList.lastChunk) {
                                        intentState.opListReadCapability.resolve(intentState.operatorList);
                                        intentState.renderTasks["delete"](opListTask);
                                    }
                                }
                                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, true);
                                var intentState = this._intentStates.get(intentArgs.cacheKey);
                                if (!intentState) {
                                    intentState = Object.create(null);
                                    this._intentStates.set(intentArgs.cacheKey, intentState);
                                }
                                var opListTask;
                                if (!intentState.opListReadCapability) {
                                    var _intentState2;
                                    opListTask = Object.create(null);
                                    opListTask.operatorListChanged = operatorListChanged;
                                    intentState.opListReadCapability = (0, _util.createPromiseCapability)();
                                    ((_intentState2 = intentState).renderTasks || (_intentState2.renderTasks = new Set())).add(opListTask);
                                    intentState.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false
                                    };
                                    if (this._stats) this._stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs);
                                }
                                return intentState.opListReadCapability.promise;
                            }
                        },
                        {
                            key: "streamTextContent",
                            value: function streamTextContent() {
                                var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref9$normalizeWhites = _ref9.normalizeWhitespace, normalizeWhitespace = _ref9$normalizeWhites === void 0 ? false : _ref9$normalizeWhites, _ref9$disableCombineT = _ref9.disableCombineTextItems, disableCombineTextItems = _ref9$disableCombineT === void 0 ? false : _ref9$disableCombineT, _ref9$includeMarkedCo = _ref9.includeMarkedContent, includeMarkedContent = _ref9$includeMarkedCo === void 0 ? false : _ref9$includeMarkedCo;
                                var TEXT_CONTENT_CHUNK_SIZE = 100;
                                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                                    pageIndex: this._pageIndex,
                                    normalizeWhitespace: normalizeWhitespace === true,
                                    combineTextItems: disableCombineTextItems !== true,
                                    includeMarkedContent: includeMarkedContent === true
                                }, {
                                    highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                                    size: function size(textContent) {
                                        return textContent.items.length;
                                    }
                                });
                            }
                        },
                        {
                            key: "getTextContent",
                            value: function getTextContent() {
                                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                if (this._transport._htmlForXfa) return this.getXfa().then(function(xfa) {
                                    return _xfa_text.XfaText.textContent(xfa);
                                });
                                var readableStream = this.streamTextContent(params);
                                return new Promise(function(resolve, reject) {
                                    function pump() {
                                        reader.read().then(function(_ref10) {
                                            var _textContent$items;
                                            var value = _ref10.value, done = _ref10.done;
                                            if (done) {
                                                resolve(textContent);
                                                return;
                                            }
                                            Object.assign(textContent.styles, value.styles);
                                            (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));
                                            pump();
                                        }, reject);
                                    }
                                    var reader = readableStream.getReader();
                                    var textContent = {
                                        items: [],
                                        styles: Object.create(null)
                                    };
                                    pump();
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree() {
                                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
                            }
                        },
                        {
                            key: "_destroy",
                            value: function _destroy() {
                                this.destroyed = true;
                                var waitOn = [];
                                var _iterator6 = _createForOfIteratorHelper(this._intentStates.values()), _step6;
                                try {
                                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                        var intentState = _step6.value;
                                        this._abortOperatorList({
                                            intentState: intentState,
                                            reason: new Error("Page was destroyed."),
                                            force: true
                                        });
                                        if (intentState.opListReadCapability) continue;
                                        var _iterator7 = _createForOfIteratorHelper(intentState.renderTasks), _step7;
                                        try {
                                            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                                var internalRenderTask = _step7.value;
                                                waitOn.push(internalRenderTask.completed);
                                                internalRenderTask.cancel();
                                            }
                                        } catch (err) {
                                            _iterator7.e(err);
                                        } finally{
                                            _iterator7.f();
                                        }
                                    }
                                } catch (err) {
                                    _iterator6.e(err);
                                } finally{
                                    _iterator6.f();
                                }
                                this.objs.clear();
                                this._annotationPromises.clear();
                                this._jsActionsPromise = null;
                                this._structTreePromise = null;
                                this.pendingCleanup = false;
                                return Promise.all(waitOn);
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup() {
                                var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                this.pendingCleanup = true;
                                return this._tryCleanup(resetStats);
                            }
                        },
                        {
                            key: "_tryCleanup",
                            value: function _tryCleanup() {
                                var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this.pendingCleanup) return false;
                                var _iterator8 = _createForOfIteratorHelper(this._intentStates.values()), _step8;
                                try {
                                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                        var _step8$value = _step8.value, renderTasks = _step8$value.renderTasks, operatorList = _step8$value.operatorList;
                                        if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                                    }
                                } catch (err) {
                                    _iterator8.e(err);
                                } finally{
                                    _iterator8.f();
                                }
                                this._intentStates.clear();
                                this.objs.clear();
                                this._annotationPromises.clear();
                                this._jsActionsPromise = null;
                                this._structTreePromise = null;
                                if (resetStats && this._stats) this._stats = new _display_utils.StatTimer();
                                this.pendingCleanup = false;
                                return true;
                            }
                        },
                        {
                            key: "_startRenderPage",
                            value: function _startRenderPage(transparency, cacheKey) {
                                var intentState = this._intentStates.get(cacheKey);
                                if (!intentState) return;
                                if (this._stats) this._stats.timeEnd("Page Request");
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.resolve(transparency);
                            }
                        },
                        {
                            key: "_renderPageChunk",
                            value: function _renderPageChunk(operatorListChunk, intentState) {
                                for(var i = 0, ii = operatorListChunk.length; i < ii; i++){
                                    intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                                    intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                                }
                                intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                                var _iterator9 = _createForOfIteratorHelper(intentState.renderTasks), _step9;
                                try {
                                    for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                                        var internalRenderTask = _step9.value;
                                        internalRenderTask.operatorListChanged();
                                    }
                                } catch (err) {
                                    _iterator9.e(err);
                                } finally{
                                    _iterator9.f();
                                }
                                if (operatorListChunk.lastChunk) this._tryCleanup();
                            }
                        },
                        {
                            key: "_pumpOperatorList",
                            value: function _pumpOperatorList(_ref11) {
                                var _this6 = this;
                                var renderingIntent = _ref11.renderingIntent, cacheKey = _ref11.cacheKey;
                                var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                                    pageIndex: this._pageIndex,
                                    intent: renderingIntent,
                                    cacheKey: cacheKey,
                                    annotationStorage: renderingIntent & _util.RenderingIntentFlag.ANNOTATIONS_STORAGE ? this._transport.annotationStorage.serializable : null
                                });
                                var reader = readableStream.getReader();
                                var intentState = this._intentStates.get(cacheKey);
                                intentState.streamReader = reader;
                                var pump = function pump() {
                                    reader.read().then(function(_ref12) {
                                        var value = _ref12.value, done = _ref12.done;
                                        if (done) {
                                            intentState.streamReader = null;
                                            return;
                                        }
                                        if (_this6._transport.destroyed) return;
                                        _this6._renderPageChunk(value, intentState);
                                        pump();
                                    }, function(reason) {
                                        intentState.streamReader = null;
                                        if (_this6._transport.destroyed) return;
                                        if (intentState.operatorList) {
                                            intentState.operatorList.lastChunk = true;
                                            var _iterator10 = _createForOfIteratorHelper(intentState.renderTasks), _step10;
                                            try {
                                                for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                                                    var internalRenderTask = _step10.value;
                                                    internalRenderTask.operatorListChanged();
                                                }
                                            } catch (err) {
                                                _iterator10.e(err);
                                            } finally{
                                                _iterator10.f();
                                            }
                                            _this6._tryCleanup();
                                        }
                                        if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                        else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                        else throw reason;
                                    });
                                };
                                pump();
                            }
                        },
                        {
                            key: "_abortOperatorList",
                            value: function _abortOperatorList(_ref13) {
                                var _this7 = this;
                                var intentState = _ref13.intentState, reason = _ref13.reason, _ref13$force = _ref13.force, force = _ref13$force === void 0 ? false : _ref13$force;
                                if (!intentState.streamReader) return;
                                if (!force) {
                                    if (intentState.renderTasks.size > 0) return;
                                    if (reason instanceof _display_utils.RenderingCancelledException) {
                                        intentState.streamReaderCancelTimeout = setTimeout(function() {
                                            _this7._abortOperatorList({
                                                intentState: intentState,
                                                reason: reason,
                                                force: true
                                            });
                                            intentState.streamReaderCancelTimeout = null;
                                        }, RENDERING_CANCELLED_TIMEOUT);
                                        return;
                                    }
                                }
                                intentState.streamReader.cancel(new _util.AbortException(reason.message))["catch"](function() {});
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                var _iterator11 = _createForOfIteratorHelper(this._intentStates), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var _step11$value = _slicedToArray(_step11.value, 2), curCacheKey = _step11$value[0], curIntentState = _step11$value[1];
                                        if (curIntentState === intentState) {
                                            this._intentStates["delete"](curCacheKey);
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator11.e(err);
                                } finally{
                                    _iterator11.f();
                                }
                                this.cleanup();
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return this._stats;
                            }
                        }
                    ]);
                    return PDFPageProxy;
                }();
                exports.PDFPageProxy = PDFPageProxy;
                var LoopbackPort = /*#__PURE__*/ function() {
                    function LoopbackPort() {
                        _classCallCheck(this, LoopbackPort);
                        this._listeners = [];
                        this._deferred = Promise.resolve();
                    }
                    _createClass(LoopbackPort, [
                        {
                            key: "postMessage",
                            value: function postMessage(obj, transfers) {
                                var _this8 = this;
                                function cloneValue(object) {
                                    if (globalThis.structuredClone) return globalThis.structuredClone(object, transfers);
                                    function fallbackCloneValue(value) {
                                        if (typeof value === "function" || _typeof(value) === "symbol" || value instanceof URL) throw new Error("LoopbackPort.postMessage - cannot clone: ".concat(value === null || value === void 0 ? void 0 : value.toString()));
                                        if (_typeof(value) !== "object" || value === null) return value;
                                        if (cloned.has(value)) return cloned.get(value);
                                        var buffer, result;
                                        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
                                            if (transfers !== null && transfers !== void 0 && transfers.includes(buffer)) result = new value.constructor(buffer, value.byteOffset, value.byteLength);
                                            else result = new value.constructor(value);
                                            cloned.set(value, result);
                                            return result;
                                        }
                                        if (value instanceof Map) {
                                            result = new Map();
                                            cloned.set(value, result);
                                            var _iterator12 = _createForOfIteratorHelper(value), _step12;
                                            try {
                                                for(_iterator12.s(); !(_step12 = _iterator12.n()).done;){
                                                    var _step12$value = _slicedToArray(_step12.value, 2), key = _step12$value[0], val = _step12$value[1];
                                                    result.set(key, fallbackCloneValue(val));
                                                }
                                            } catch (err) {
                                                _iterator12.e(err);
                                            } finally{
                                                _iterator12.f();
                                            }
                                            return result;
                                        }
                                        if (value instanceof Set) {
                                            result = new Set();
                                            cloned.set(value, result);
                                            var _iterator13 = _createForOfIteratorHelper(value), _step13;
                                            try {
                                                for(_iterator13.s(); !(_step13 = _iterator13.n()).done;){
                                                    var _val = _step13.value;
                                                    result.add(fallbackCloneValue(_val));
                                                }
                                            } catch (err) {
                                                _iterator13.e(err);
                                            } finally{
                                                _iterator13.f();
                                            }
                                            return result;
                                        }
                                        result = Array.isArray(value) ? [] : Object.create(null);
                                        cloned.set(value, result);
                                        for(var i in value){
                                            var _value$hasOwnProperty;
                                            var desc = void 0, p = value;
                                            while(!(desc = Object.getOwnPropertyDescriptor(p, i)))p = Object.getPrototypeOf(p);
                                            if (typeof desc.value === "undefined") continue;
                                            if (typeof desc.value === "function" && !((_value$hasOwnProperty = value.hasOwnProperty) !== null && _value$hasOwnProperty !== void 0 && _value$hasOwnProperty.call(value, i))) continue;
                                            result[i] = fallbackCloneValue(desc.value);
                                        }
                                        return result;
                                    }
                                    var cloned = new WeakMap();
                                    return fallbackCloneValue(object);
                                }
                                var event = {
                                    data: cloneValue(obj)
                                };
                                this._deferred.then(function() {
                                    var _iterator14 = _createForOfIteratorHelper(_this8._listeners), _step14;
                                    try {
                                        for(_iterator14.s(); !(_step14 = _iterator14.n()).done;){
                                            var listener = _step14.value;
                                            listener.call(_this8, event);
                                        }
                                    } catch (err) {
                                        _iterator14.e(err);
                                    } finally{
                                        _iterator14.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "addEventListener",
                            value: function addEventListener(name, listener) {
                                this._listeners.push(listener);
                            }
                        },
                        {
                            key: "removeEventListener",
                            value: function removeEventListener(name, listener) {
                                var i = this._listeners.indexOf(listener);
                                this._listeners.splice(i, 1);
                            }
                        },
                        {
                            key: "terminate",
                            value: function terminate() {
                                this._listeners.length = 0;
                            }
                        }
                    ]);
                    return LoopbackPort;
                }();
                exports.LoopbackPort = LoopbackPort;
                var PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                if (_is_node.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object") {
                    var _document, _document$currentScri;
                    var pdfjsFilePath = (_document = document) === null || _document === void 0 ? void 0 : (_document$currentScri = _document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    var wrapper = "importScripts(\"".concat(url, "\");");
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                var PDFWorker = /*#__PURE__*/ function() {
                    function PDFWorker() {
                        var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref14$name = _ref14.name, name = _ref14$name === void 0 ? null : _ref14$name, _ref14$port = _ref14.port, port = _ref14$port === void 0 ? null : _ref14$port, _ref14$verbosity = _ref14.verbosity, verbosity = _ref14$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref14$verbosity;
                        _classCallCheck(this, PDFWorker);
                        if (port && PDFWorker._workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = (0, _util.createPromiseCapability)();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            PDFWorker._workerPorts.set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    _createClass(PDFWorker, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._readyCapability.promise;
                            }
                        },
                        {
                            key: "port",
                            get: function get() {
                                return this._port;
                            }
                        },
                        {
                            key: "messageHandler",
                            get: function get() {
                                return this._messageHandler;
                            }
                        },
                        {
                            key: "_initializeFromPort",
                            value: function _initializeFromPort(port) {
                                this._port = port;
                                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                                this._messageHandler.on("ready", function() {});
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "_initialize",
                            value: function _initialize() {
                                var _this9 = this;
                                if (typeof Worker !== "undefined" && !PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                                    var workerSrc = PDFWorker.workerSrc;
                                    try {
                                        if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                        var worker = new Worker(workerSrc);
                                        var messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                        var terminateEarly = function terminateEarly() {
                                            worker.removeEventListener("error", onWorkerError);
                                            messageHandler.destroy();
                                            worker.terminate();
                                            if (_this9.destroyed) _this9._readyCapability.reject(new Error("Worker was destroyed"));
                                            else _this9._setupFakeWorker();
                                        };
                                        var onWorkerError = function onWorkerError() {
                                            if (!_this9._webWorker) terminateEarly();
                                        };
                                        worker.addEventListener("error", onWorkerError);
                                        messageHandler.on("test", function(data) {
                                            worker.removeEventListener("error", onWorkerError);
                                            if (_this9.destroyed) {
                                                terminateEarly();
                                                return;
                                            }
                                            if (data) {
                                                _this9._messageHandler = messageHandler;
                                                _this9._port = worker;
                                                _this9._webWorker = worker;
                                                _this9._readyCapability.resolve();
                                                messageHandler.send("configure", {
                                                    verbosity: _this9.verbosity
                                                });
                                            } else {
                                                _this9._setupFakeWorker();
                                                messageHandler.destroy();
                                                worker.terminate();
                                            }
                                        });
                                        messageHandler.on("ready", function(data) {
                                            worker.removeEventListener("error", onWorkerError);
                                            if (_this9.destroyed) {
                                                terminateEarly();
                                                return;
                                            }
                                            try {
                                                sendTest();
                                            } catch (e) {
                                                _this9._setupFakeWorker();
                                            }
                                        });
                                        var sendTest = function sendTest() {
                                            var testObj = new Uint8Array([
                                                255
                                            ]);
                                            try {
                                                messageHandler.send("test", testObj, [
                                                    testObj.buffer
                                                ]);
                                            } catch (ex) {
                                                (0, _util.warn)("Cannot use postMessage transfers.");
                                                testObj[0] = 0;
                                                messageHandler.send("test", testObj);
                                            }
                                        };
                                        sendTest();
                                        return;
                                    } catch (e) {
                                        (0, _util.info)("The worker has been disabled.");
                                    }
                                }
                                this._setupFakeWorker();
                            }
                        },
                        {
                            key: "_setupFakeWorker",
                            value: function _setupFakeWorker() {
                                var _this10 = this;
                                if (!PDFWorkerUtil.isWorkerDisabled) {
                                    (0, _util.warn)("Setting up fake worker.");
                                    PDFWorkerUtil.isWorkerDisabled = true;
                                }
                                PDFWorker._setupFakeWorkerGlobal.then(function(WorkerMessageHandler) {
                                    if (_this10.destroyed) {
                                        _this10._readyCapability.reject(new Error("Worker was destroyed"));
                                        return;
                                    }
                                    var port = new LoopbackPort();
                                    _this10._port = port;
                                    var id = "fake".concat(PDFWorkerUtil.fakeWorkerId++);
                                    var workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                                    WorkerMessageHandler.setup(workerHandler, port);
                                    var messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                                    _this10._messageHandler = messageHandler;
                                    _this10._readyCapability.resolve();
                                    messageHandler.send("configure", {
                                        verbosity: _this10.verbosity
                                    });
                                })["catch"](function(reason) {
                                    _this10._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.destroyed = true;
                                if (this._webWorker) {
                                    this._webWorker.terminate();
                                    this._webWorker = null;
                                }
                                PDFWorker._workerPorts["delete"](this._port);
                                this._port = null;
                                if (this._messageHandler) {
                                    this._messageHandler.destroy();
                                    this._messageHandler = null;
                                }
                            }
                        }
                    ], [
                        {
                            key: "_workerPorts",
                            get: function get() {
                                return (0, _util.shadow)(this, "_workerPorts", new WeakMap());
                            }
                        },
                        {
                            key: "fromPort",
                            value: function fromPort(params) {
                                if (!(params !== null && params !== void 0 && params.port)) throw new Error("PDFWorker.fromPort - invalid method signature.");
                                if (this._workerPorts.has(params.port)) return this._workerPorts.get(params.port);
                                return new PDFWorker(params);
                            }
                        },
                        {
                            key: "workerSrc",
                            get: function get() {
                                if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                                if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                                    if (!_is_node.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                                    return PDFWorkerUtil.fallbackWorkerSrc;
                                }
                                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                            }
                        },
                        {
                            key: "_mainThreadWorkerMessageHandler",
                            get: function get() {
                                try {
                                    var _globalThis$pdfjsWork;
                                    return ((_globalThis$pdfjsWork = globalThis.pdfjsWorker) === null || _globalThis$pdfjsWork === void 0 ? void 0 : _globalThis$pdfjsWork.WorkerMessageHandler) || null;
                                } catch (ex) {
                                    return null;
                                }
                            }
                        },
                        {
                            key: "_setupFakeWorkerGlobal",
                            get: function get() {
                                var _this11 = this;
                                var loader = /*#__PURE__*/ function() {
                                    var _ref15 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee4() {
                                        var mainWorkerMessageHandler, worker;
                                        return _regenerator["default"].wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    mainWorkerMessageHandler = _this11._mainThreadWorkerMessageHandler;
                                                    if (!mainWorkerMessageHandler) {
                                                        _context4.next = 3;
                                                        break;
                                                    }
                                                    return _context4.abrupt("return", mainWorkerMessageHandler);
                                                case 3:
                                                    if (!(_is_node.isNodeJS && true)) {
                                                        _context4.next = 6;
                                                        break;
                                                    }
                                                    worker = eval("require")(_this11.workerSrc);
                                                    return _context4.abrupt("return", worker.WorkerMessageHandler);
                                                case 6:
                                                    _context4.next = 8;
                                                    return (0, _display_utils.loadScript)(_this11.workerSrc);
                                                case 8:
                                                    return _context4.abrupt("return", window.pdfjsWorker.WorkerMessageHandler);
                                                case 9:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function loader() {
                                        return _ref15.apply(this, arguments);
                                    };
                                }();
                                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                            }
                        }
                    ]);
                    return PDFWorker;
                }();
                exports.PDFWorker = PDFWorker;
                PDFWorker.getWorkerSrc = function() {
                    (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead.");
                    return this.workerSrc;
                };
                var _docStats = /*#__PURE__*/ new WeakMap();
                var _pageCache = /*#__PURE__*/ new WeakMap();
                var _pagePromises = /*#__PURE__*/ new WeakMap();
                var _metadataPromise = /*#__PURE__*/ new WeakMap();
                var WorkerTransport = /*#__PURE__*/ function() {
                    function WorkerTransport(messageHandler, loadingTask, networkStream, params) {
                        _classCallCheck(this, WorkerTransport);
                        _classPrivateFieldInitSpec(this, _docStats, {
                            writable: true,
                            value: null
                        });
                        _classPrivateFieldInitSpec(this, _pageCache, {
                            writable: true,
                            value: new Map()
                        });
                        _classPrivateFieldInitSpec(this, _pagePromises, {
                            writable: true,
                            value: new Map()
                        });
                        _classPrivateFieldInitSpec(this, _metadataPromise, {
                            writable: true,
                            value: null
                        });
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            docId: loadingTask.docId,
                            onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        if (!params.useWorkerFetch) {
                            this.CMapReaderFactory = new params.CMapReaderFactory({
                                baseUrl: params.cMapUrl,
                                isCompressed: params.cMapPacked
                            });
                            this.StandardFontDataFactory = new params.StandardFontDataFactory({
                                baseUrl: params.standardFontDataUrl
                            });
                        }
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._passwordCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = (0, _util.createPromiseCapability)();
                        this.setupMessageHandler();
                    }
                    _createClass(WorkerTransport, [
                        {
                            key: "annotationStorage",
                            get: function get() {
                                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return _classPrivateFieldGet(this, _docStats);
                            }
                        },
                        {
                            key: "getRenderingIntent",
                            value: function getRenderingIntent(intent) {
                                var annotationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.AnnotationMode.ENABLE;
                                var isOpList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                                var renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                                var lastModified = "";
                                switch(intent){
                                    case "any":
                                        renderingIntent = _util.RenderingIntentFlag.ANY;
                                        break;
                                    case "display":
                                        break;
                                    case "print":
                                        renderingIntent = _util.RenderingIntentFlag.PRINT;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid intent: ".concat(intent));
                                }
                                switch(annotationMode){
                                    case _util.AnnotationMode.DISABLE:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                        break;
                                    case _util.AnnotationMode.ENABLE:
                                        break;
                                    case _util.AnnotationMode.ENABLE_FORMS:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                        break;
                                    case _util.AnnotationMode.ENABLE_STORAGE:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                        lastModified = this.annotationStorage.lastModified;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
                                }
                                if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                                return {
                                    renderingIntent: renderingIntent,
                                    cacheKey: "".concat(renderingIntent, "_").concat(lastModified)
                                };
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _this12 = this;
                                if (this.destroyCapability) return this.destroyCapability.promise;
                                this.destroyed = true;
                                this.destroyCapability = (0, _util.createPromiseCapability)();
                                if (this._passwordCapability) this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                                var waitOn = [];
                                var _iterator15 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values()), _step15;
                                try {
                                    for(_iterator15.s(); !(_step15 = _iterator15.n()).done;){
                                        var page = _step15.value;
                                        waitOn.push(page._destroy());
                                    }
                                } catch (err) {
                                    _iterator15.e(err);
                                } finally{
                                    _iterator15.f();
                                }
                                _classPrivateFieldGet(this, _pageCache).clear();
                                _classPrivateFieldGet(this, _pagePromises).clear();
                                if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                                var terminated = this.messageHandler.sendWithPromise("Terminate", null);
                                waitOn.push(terminated);
                                Promise.all(waitOn).then(function() {
                                    _this12.commonObjs.clear();
                                    _this12.fontLoader.clear();
                                    _classPrivateFieldSet(_this12, _metadataPromise, null);
                                    _this12._getFieldObjectsPromise = null;
                                    _this12._hasJSActionsPromise = null;
                                    if (_this12._networkStream) _this12._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                                    if (_this12.messageHandler) {
                                        _this12.messageHandler.destroy();
                                        _this12.messageHandler = null;
                                    }
                                    _this12.destroyCapability.resolve();
                                }, this.destroyCapability.reject);
                                return this.destroyCapability.promise;
                            }
                        },
                        {
                            key: "setupMessageHandler",
                            value: function setupMessageHandler() {
                                var _this13 = this;
                                var messageHandler = this.messageHandler, loadingTask = this.loadingTask;
                                messageHandler.on("GetReader", function(data, sink) {
                                    (0, _util.assert)(_this13._networkStream, "GetReader - no `IPDFStream` instance available.");
                                    _this13._fullReader = _this13._networkStream.getFullReader();
                                    _this13._fullReader.onProgress = function(evt) {
                                        _this13._lastProgress = {
                                            loaded: evt.loaded,
                                            total: evt.total
                                        };
                                    };
                                    sink.onPull = function() {
                                        _this13._fullReader.read().then(function(_ref16) {
                                            var value = _ref16.value, done = _ref16.done;
                                            if (done) {
                                                sink.close();
                                                return;
                                            }
                                            (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetReader - expected an ArrayBuffer.");
                                            sink.enqueue(new Uint8Array(value), 1, [
                                                value
                                            ]);
                                        })["catch"](function(reason) {
                                            sink.error(reason);
                                        });
                                    };
                                    sink.onCancel = function(reason) {
                                        _this13._fullReader.cancel(reason);
                                        sink.ready["catch"](function(readyReason) {
                                            if (_this13.destroyed) return;
                                            throw readyReason;
                                        });
                                    };
                                });
                                messageHandler.on("ReaderHeadersReady", function(data) {
                                    var headersCapability = (0, _util.createPromiseCapability)();
                                    var fullReader = _this13._fullReader;
                                    fullReader.headersReady.then(function() {
                                        if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                            if (_this13._lastProgress) {
                                                var _loadingTask$onProgre;
                                                (_loadingTask$onProgre = loadingTask.onProgress) === null || _loadingTask$onProgre === void 0 || _loadingTask$onProgre.call(loadingTask, _this13._lastProgress);
                                            }
                                            fullReader.onProgress = function(evt) {
                                                var _loadingTask$onProgre2;
                                                (_loadingTask$onProgre2 = loadingTask.onProgress) === null || _loadingTask$onProgre2 === void 0 || _loadingTask$onProgre2.call(loadingTask, {
                                                    loaded: evt.loaded,
                                                    total: evt.total
                                                });
                                            };
                                        }
                                        headersCapability.resolve({
                                            isStreamingSupported: fullReader.isStreamingSupported,
                                            isRangeSupported: fullReader.isRangeSupported,
                                            contentLength: fullReader.contentLength
                                        });
                                    }, headersCapability.reject);
                                    return headersCapability.promise;
                                });
                                messageHandler.on("GetRangeReader", function(data, sink) {
                                    (0, _util.assert)(_this13._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                                    var rangeReader = _this13._networkStream.getRangeReader(data.begin, data.end);
                                    if (!rangeReader) {
                                        sink.close();
                                        return;
                                    }
                                    sink.onPull = function() {
                                        rangeReader.read().then(function(_ref17) {
                                            var value = _ref17.value, done = _ref17.done;
                                            if (done) {
                                                sink.close();
                                                return;
                                            }
                                            (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetRangeReader - expected an ArrayBuffer.");
                                            sink.enqueue(new Uint8Array(value), 1, [
                                                value
                                            ]);
                                        })["catch"](function(reason) {
                                            sink.error(reason);
                                        });
                                    };
                                    sink.onCancel = function(reason) {
                                        rangeReader.cancel(reason);
                                        sink.ready["catch"](function(readyReason) {
                                            if (_this13.destroyed) return;
                                            throw readyReason;
                                        });
                                    };
                                });
                                messageHandler.on("GetDoc", function(_ref18) {
                                    var pdfInfo = _ref18.pdfInfo;
                                    _this13._numPages = pdfInfo.numPages;
                                    _this13._htmlForXfa = pdfInfo.htmlForXfa;
                                    delete pdfInfo.htmlForXfa;
                                    loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this13));
                                });
                                messageHandler.on("DocException", function(ex) {
                                    var reason;
                                    switch(ex.name){
                                        case "PasswordException":
                                            reason = new _util.PasswordException(ex.message, ex.code);
                                            break;
                                        case "InvalidPDFException":
                                            reason = new _util.InvalidPDFException(ex.message);
                                            break;
                                        case "MissingPDFException":
                                            reason = new _util.MissingPDFException(ex.message);
                                            break;
                                        case "UnexpectedResponseException":
                                            reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                            break;
                                        case "UnknownErrorException":
                                            reason = new _util.UnknownErrorException(ex.message, ex.details);
                                            break;
                                        default:
                                            (0, _util.unreachable)("DocException - expected a valid Error.");
                                    }
                                    loadingTask._capability.reject(reason);
                                });
                                messageHandler.on("PasswordRequest", function(exception) {
                                    _this13._passwordCapability = (0, _util.createPromiseCapability)();
                                    if (loadingTask.onPassword) {
                                        var updatePassword = function updatePassword(password) {
                                            _this13._passwordCapability.resolve({
                                                password: password
                                            });
                                        };
                                        try {
                                            loadingTask.onPassword(updatePassword, exception.code);
                                        } catch (ex) {
                                            _this13._passwordCapability.reject(ex);
                                        }
                                    } else _this13._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                                    return _this13._passwordCapability.promise;
                                });
                                messageHandler.on("DataLoaded", function(data) {
                                    var _loadingTask$onProgre3;
                                    (_loadingTask$onProgre3 = loadingTask.onProgress) === null || _loadingTask$onProgre3 === void 0 || _loadingTask$onProgre3.call(loadingTask, {
                                        loaded: data.length,
                                        total: data.length
                                    });
                                    _this13.downloadInfoCapability.resolve(data);
                                });
                                messageHandler.on("StartRenderPage", function(data) {
                                    if (_this13.destroyed) return;
                                    var page = _classPrivateFieldGet(_this13, _pageCache).get(data.pageIndex);
                                    page._startRenderPage(data.transparency, data.cacheKey);
                                });
                                messageHandler.on("commonobj", function(_ref19) {
                                    var _globalThis$FontInspe;
                                    var _ref20 = _slicedToArray(_ref19, 3), id = _ref20[0], type = _ref20[1], exportedData = _ref20[2];
                                    if (_this13.destroyed) return;
                                    if (_this13.commonObjs.has(id)) return;
                                    switch(type){
                                        case "Font":
                                            var params = _this13._params;
                                            if ("error" in exportedData) {
                                                var exportedError = exportedData.error;
                                                (0, _util.warn)("Error during font loading: ".concat(exportedError));
                                                _this13.commonObjs.resolve(id, exportedError);
                                                break;
                                            }
                                            var fontRegistry = null;
                                            if (params.pdfBug && (_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled) fontRegistry = {
                                                registerFont: function registerFont(font, url) {
                                                    globalThis.FontInspector.fontAdded(font, url);
                                                }
                                            };
                                            var font = new _font_loader.FontFaceObject(exportedData, {
                                                isEvalSupported: params.isEvalSupported,
                                                disableFontFace: params.disableFontFace,
                                                ignoreErrors: params.ignoreErrors,
                                                onUnsupportedFeature: _this13._onUnsupportedFeature.bind(_this13),
                                                fontRegistry: fontRegistry
                                            });
                                            _this13.fontLoader.bind(font)["catch"](function(reason) {
                                                return messageHandler.sendWithPromise("FontFallback", {
                                                    id: id
                                                });
                                            })["finally"](function() {
                                                if (!params.fontExtraProperties && font.data) font.data = null;
                                                _this13.commonObjs.resolve(id, font);
                                            });
                                            break;
                                        case "FontPath":
                                        case "Image":
                                            _this13.commonObjs.resolve(id, exportedData);
                                            break;
                                        default:
                                            throw new Error("Got unknown common object type ".concat(type));
                                    }
                                });
                                messageHandler.on("obj", function(_ref21) {
                                    var _imageData$data;
                                    var _ref22 = _slicedToArray(_ref21, 4), id = _ref22[0], pageIndex = _ref22[1], type = _ref22[2], imageData = _ref22[3];
                                    if (_this13.destroyed) return;
                                    var pageProxy = _classPrivateFieldGet(_this13, _pageCache).get(pageIndex);
                                    if (pageProxy.objs.has(id)) return;
                                    switch(type){
                                        case "Image":
                                            pageProxy.objs.resolve(id, imageData);
                                            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
                                            if ((imageData === null || imageData === void 0 ? void 0 : (_imageData$data = imageData.data) === null || _imageData$data === void 0 ? void 0 : _imageData$data.length) > MAX_IMAGE_SIZE_TO_STORE) pageProxy.cleanupAfterRender = true;
                                            break;
                                        case "Pattern":
                                            pageProxy.objs.resolve(id, imageData);
                                            break;
                                        default:
                                            throw new Error("Got unknown object type ".concat(type));
                                    }
                                });
                                messageHandler.on("DocProgress", function(data) {
                                    var _loadingTask$onProgre4;
                                    if (_this13.destroyed) return;
                                    (_loadingTask$onProgre4 = loadingTask.onProgress) === null || _loadingTask$onProgre4 === void 0 || _loadingTask$onProgre4.call(loadingTask, {
                                        loaded: data.loaded,
                                        total: data.total
                                    });
                                });
                                messageHandler.on("DocStats", function(data) {
                                    if (_this13.destroyed) return;
                                    _classPrivateFieldSet(_this13, _docStats, Object.freeze({
                                        streamTypes: Object.freeze(data.streamTypes),
                                        fontTypes: Object.freeze(data.fontTypes)
                                    }));
                                });
                                messageHandler.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
                                messageHandler.on("FetchBuiltInCMap", function(data) {
                                    if (_this13.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this13.CMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this13.CMapReaderFactory.fetch(data);
                                });
                                messageHandler.on("FetchStandardFontData", function(data) {
                                    if (_this13.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this13.StandardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this13.StandardFontDataFactory.fetch(data);
                                });
                            }
                        },
                        {
                            key: "_onUnsupportedFeature",
                            value: function _onUnsupportedFeature(_ref23) {
                                var _this$loadingTask$onU, _this$loadingTask;
                                var featureId = _ref23.featureId;
                                if (this.destroyed) return;
                                (_this$loadingTask$onU = (_this$loadingTask = this.loadingTask).onUnsupportedFeature) === null || _this$loadingTask$onU === void 0 || _this$loadingTask$onU.call(_this$loadingTask, featureId);
                            }
                        },
                        {
                            key: "getData",
                            value: function getData() {
                                return this.messageHandler.sendWithPromise("GetData", null);
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage(pageNumber) {
                                var _this14 = this;
                                if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request"));
                                var pageIndex = pageNumber - 1, cachedPromise = _classPrivateFieldGet(this, _pagePromises).get(pageIndex);
                                if (cachedPromise) return cachedPromise;
                                var promise = this.messageHandler.sendWithPromise("GetPage", {
                                    pageIndex: pageIndex
                                }).then(function(pageInfo) {
                                    if (_this14.destroyed) throw new Error("Transport destroyed");
                                    var page = new PDFPageProxy(pageIndex, pageInfo, _this14, _this14._params.ownerDocument, _this14._params.pdfBug);
                                    _classPrivateFieldGet(_this14, _pageCache).set(pageIndex, page);
                                    return page;
                                });
                                _classPrivateFieldGet(this, _pagePromises).set(pageIndex, promise);
                                return promise;
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex(ref) {
                                return this.messageHandler.sendWithPromise("GetPageIndex", {
                                    ref: ref
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations(pageIndex, intent) {
                                return this.messageHandler.sendWithPromise("GetAnnotations", {
                                    pageIndex: pageIndex,
                                    intent: intent
                                });
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument() {
                                var _this$_fullReader$fil, _this$_fullReader, _this15 = this;
                                return this.messageHandler.sendWithPromise("SaveDocument", {
                                    isPureXfa: !!this._htmlForXfa,
                                    numPages: this._numPages,
                                    annotationStorage: this.annotationStorage.serializable,
                                    filename: (_this$_fullReader$fil = (_this$_fullReader = this._fullReader) === null || _this$_fullReader === void 0 ? void 0 : _this$_fullReader.filename) !== null && _this$_fullReader$fil !== void 0 ? _this$_fullReader$fil : null
                                })["finally"](function() {
                                    _this15.annotationStorage.resetModified();
                                });
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects() {
                                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions() {
                                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds() {
                                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations() {
                                return this.messageHandler.sendWithPromise("GetDestinations", null);
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination(id) {
                                if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                                return this.messageHandler.sendWithPromise("GetDestination", {
                                    id: id
                                });
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels() {
                                return this.messageHandler.sendWithPromise("GetPageLabels", null);
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout() {
                                return this.messageHandler.sendWithPromise("GetPageLayout", null);
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode() {
                                return this.messageHandler.sendWithPromise("GetPageMode", null);
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences() {
                                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction() {
                                return this.messageHandler.sendWithPromise("GetOpenAction", null);
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments() {
                                return this.messageHandler.sendWithPromise("GetAttachments", null);
                            }
                        },
                        {
                            key: "getJavaScript",
                            value: function getJavaScript() {
                                return this.messageHandler.sendWithPromise("GetJavaScript", null);
                            }
                        },
                        {
                            key: "getDocJSActions",
                            value: function getDocJSActions() {
                                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
                            }
                        },
                        {
                            key: "getPageJSActions",
                            value: function getPageJSActions(pageIndex) {
                                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                                    pageIndex: pageIndex
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree(pageIndex) {
                                return this.messageHandler.sendWithPromise("GetStructTree", {
                                    pageIndex: pageIndex
                                });
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline() {
                                return this.messageHandler.sendWithPromise("GetOutline", null);
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig() {
                                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(function(results) {
                                    return new _optional_content_config.OptionalContentConfig(results);
                                });
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions() {
                                return this.messageHandler.sendWithPromise("GetPermissions", null);
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata() {
                                var _this16 = this;
                                return _classPrivateFieldGet(this, _metadataPromise) || _classPrivateFieldSet(this, _metadataPromise, this.messageHandler.sendWithPromise("GetMetadata", null).then(function(results) {
                                    var _this16$_fullReader$f, _this16$_fullReader, _this16$_fullReader$c, _this16$_fullReader2;
                                    return {
                                        info: results[0],
                                        metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                        contentDispositionFilename: (_this16$_fullReader$f = (_this16$_fullReader = _this16._fullReader) === null || _this16$_fullReader === void 0 ? void 0 : _this16$_fullReader.filename) !== null && _this16$_fullReader$f !== void 0 ? _this16$_fullReader$f : null,
                                        contentLength: (_this16$_fullReader$c = (_this16$_fullReader2 = _this16._fullReader) === null || _this16$_fullReader2 === void 0 ? void 0 : _this16$_fullReader2.contentLength) !== null && _this16$_fullReader$c !== void 0 ? _this16$_fullReader$c : null
                                    };
                                }));
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo() {
                                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                            }
                        },
                        {
                            key: "startCleanup",
                            value: function() {
                                var _startCleanup = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee5() {
                                    var keepLoadedFonts, _iterator16, _step16, page, cleanupSuccessful, _args5 = arguments;
                                    return _regenerator["default"].wrap(function _callee5$(_context5) {
                                        while(true)switch(_context5.prev = _context5.next){
                                            case 0:
                                                keepLoadedFonts = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
                                                _context5.next = 3;
                                                return this.messageHandler.sendWithPromise("Cleanup", null);
                                            case 3:
                                                if (!this.destroyed) {
                                                    _context5.next = 5;
                                                    break;
                                                }
                                                return _context5.abrupt("return");
                                            case 5:
                                                _iterator16 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values());
                                                _context5.prev = 6;
                                                _iterator16.s();
                                            case 8:
                                                if ((_step16 = _iterator16.n()).done) {
                                                    _context5.next = 15;
                                                    break;
                                                }
                                                page = _step16.value;
                                                cleanupSuccessful = page.cleanup();
                                                if (cleanupSuccessful) {
                                                    _context5.next = 13;
                                                    break;
                                                }
                                                throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
                                            case 13:
                                                _context5.next = 8;
                                                break;
                                            case 15:
                                                _context5.next = 20;
                                                break;
                                            case 17:
                                                _context5.prev = 17;
                                                _context5.t0 = _context5["catch"](6);
                                                _iterator16.e(_context5.t0);
                                            case 20:
                                                _context5.prev = 20;
                                                _iterator16.f();
                                                return _context5.finish(20);
                                            case 23:
                                                this.commonObjs.clear();
                                                if (!keepLoadedFonts) this.fontLoader.clear();
                                                _classPrivateFieldSet(this, _metadataPromise, null);
                                                this._getFieldObjectsPromise = null;
                                                this._hasJSActionsPromise = null;
                                            case 28:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }, _callee5, this, [
                                        [
                                            6,
                                            17,
                                            20,
                                            23
                                        ]
                                    ]);
                                }));
                                function startCleanup() {
                                    return _startCleanup.apply(this, arguments);
                                }
                                return startCleanup;
                            }()
                        },
                        {
                            key: "loadingParams",
                            get: function get() {
                                var params = this._params;
                                return (0, _util.shadow)(this, "loadingParams", {
                                    disableAutoFetch: params.disableAutoFetch,
                                    enableXfa: params.enableXfa
                                });
                            }
                        }
                    ]);
                    return WorkerTransport;
                }();
                var PDFObjects = /*#__PURE__*/ function() {
                    function PDFObjects() {
                        _classCallCheck(this, PDFObjects);
                        this._objs = Object.create(null);
                    }
                    _createClass(PDFObjects, [
                        {
                            key: "_ensureObj",
                            value: function _ensureObj(objId) {
                                if (this._objs[objId]) return this._objs[objId];
                                return this._objs[objId] = {
                                    capability: (0, _util.createPromiseCapability)(),
                                    data: null,
                                    resolved: false
                                };
                            }
                        },
                        {
                            key: "get",
                            value: function get(objId) {
                                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                if (callback) {
                                    this._ensureObj(objId).capability.promise.then(callback);
                                    return null;
                                }
                                var obj = this._objs[objId];
                                if (!obj || !obj.resolved) throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
                                return obj.data;
                            }
                        },
                        {
                            key: "has",
                            value: function has(objId) {
                                var obj = this._objs[objId];
                                return (obj === null || obj === void 0 ? void 0 : obj.resolved) || false;
                            }
                        },
                        {
                            key: "resolve",
                            value: function resolve(objId, data) {
                                var obj = this._ensureObj(objId);
                                obj.resolved = true;
                                obj.data = data;
                                obj.capability.resolve(data);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this._objs = Object.create(null);
                            }
                        }
                    ]);
                    return PDFObjects;
                }();
                var RenderTask = /*#__PURE__*/ function() {
                    function RenderTask(internalRenderTask) {
                        _classCallCheck(this, RenderTask);
                        this._internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    _createClass(RenderTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._internalRenderTask.capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                this._internalRenderTask.cancel();
                            }
                        }
                    ]);
                    return RenderTask;
                }();
                exports.RenderTask = RenderTask;
                var InternalRenderTask = /*#__PURE__*/ function() {
                    function InternalRenderTask(_ref24) {
                        var callback = _ref24.callback, params = _ref24.params, objs = _ref24.objs, commonObjs = _ref24.commonObjs, annotationCanvasMap = _ref24.annotationCanvasMap, operatorList = _ref24.operatorList, pageIndex = _ref24.pageIndex, canvasFactory = _ref24.canvasFactory, _ref24$useRequestAnim = _ref24.useRequestAnimationFrame, useRequestAnimationFrame = _ref24$useRequestAnim === void 0 ? false : _ref24$useRequestAnim, _ref24$pdfBug = _ref24.pdfBug, pdfBug = _ref24$pdfBug === void 0 ? false : _ref24$pdfBug;
                        _classCallCheck(this, InternalRenderTask);
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this._pdfBug = pdfBug;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = (0, _util.createPromiseCapability)();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    _createClass(InternalRenderTask, [
                        {
                            key: "completed",
                            get: function get() {
                                return this.capability.promise["catch"](function() {});
                            }
                        },
                        {
                            key: "initializeGraphics",
                            value: function initializeGraphics(_ref25) {
                                var _globalThis$StepperMa;
                                var _ref25$transparency = _ref25.transparency, transparency = _ref25$transparency === void 0 ? false : _ref25$transparency, optionalContentConfig = _ref25.optionalContentConfig;
                                if (this.cancelled) return;
                                if (this._canvas) {
                                    if (InternalRenderTask.canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                                    InternalRenderTask.canvasInUse.add(this._canvas);
                                }
                                if (this._pdfBug && (_globalThis$StepperMa = globalThis.StepperManager) !== null && _globalThis$StepperMa !== void 0 && _globalThis$StepperMa.enabled) {
                                    this.stepper = globalThis.StepperManager.create(this._pageIndex);
                                    this.stepper.init(this.operatorList);
                                    this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                                }
                                var _this$params = this.params, canvasContext = _this$params.canvasContext, viewport = _this$params.viewport, transform = _this$params.transform, imageLayer = _this$params.imageLayer, background = _this$params.background;
                                this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, imageLayer, optionalContentConfig, this.annotationCanvasMap);
                                this.gfx.beginDrawing({
                                    transform: transform,
                                    viewport: viewport,
                                    transparency: transparency,
                                    background: background
                                });
                                this.operatorListIdx = 0;
                                this.graphicsReady = true;
                                if (this.graphicsReadyCallback) this.graphicsReadyCallback();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                                this.running = false;
                                this.cancelled = true;
                                if (this.gfx) this.gfx.endDrawing();
                                if (this._canvas) InternalRenderTask.canvasInUse["delete"](this._canvas);
                                this.callback(error || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), "canvas"));
                            }
                        },
                        {
                            key: "operatorListChanged",
                            value: function operatorListChanged() {
                                if (!this.graphicsReady) {
                                    if (!this.graphicsReadyCallback) this.graphicsReadyCallback = this._continueBound;
                                    return;
                                }
                                if (this.stepper) this.stepper.updateOperatorList(this.operatorList);
                                if (this.running) return;
                                this._continue();
                            }
                        },
                        {
                            key: "_continue",
                            value: function _continue() {
                                this.running = true;
                                if (this.cancelled) return;
                                if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                                else this._scheduleNext();
                            }
                        },
                        {
                            key: "_scheduleNext",
                            value: function _scheduleNext() {
                                var _this17 = this;
                                if (this._useRequestAnimationFrame) window.requestAnimationFrame(function() {
                                    _this17._nextBound()["catch"](_this17._cancelBound);
                                });
                                else Promise.resolve().then(this._nextBound)["catch"](this._cancelBound);
                            }
                        },
                        {
                            key: "_next",
                            value: function() {
                                var _next2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee6() {
                                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                                        while(true)switch(_context6.prev = _context6.next){
                                            case 0:
                                                if (!this.cancelled) {
                                                    _context6.next = 2;
                                                    break;
                                                }
                                                return _context6.abrupt("return");
                                            case 2:
                                                this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                                                if (this.operatorListIdx === this.operatorList.argsArray.length) {
                                                    this.running = false;
                                                    if (this.operatorList.lastChunk) {
                                                        this.gfx.endDrawing();
                                                        if (this._canvas) InternalRenderTask.canvasInUse["delete"](this._canvas);
                                                        this.callback();
                                                    }
                                                }
                                            case 4:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }, _callee6, this);
                                }));
                                function _next() {
                                    return _next2.apply(this, arguments);
                                }
                                return _next;
                            }()
                        }
                    ], [
                        {
                            key: "canvasInUse",
                            get: function get() {
                                return (0, _util.shadow)(this, "canvasInUse", new WeakSet());
                            }
                        }
                    ]);
                    return InternalRenderTask;
                }();
                var version = '2.12.313';
                exports.version = version;
                var build = 'a2ae56f39';
                exports.build = build;
            /***/ },
            /* 137 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var BaseFontLoader = /*#__PURE__*/ function() {
                    function BaseFontLoader(_ref) {
                        var docId = _ref.docId, onUnsupportedFeature = _ref.onUnsupportedFeature, _ref$ownerDocument = _ref.ownerDocument, ownerDocument = _ref$ownerDocument === void 0 ? globalThis.document : _ref$ownerDocument, _ref$styleElement = _ref.styleElement, styleElement = _ref$styleElement === void 0 ? null : _ref$styleElement;
                        _classCallCheck(this, BaseFontLoader);
                        if (this.constructor === BaseFontLoader) (0, _util.unreachable)("Cannot initialize BaseFontLoader.");
                        this.docId = docId;
                        this._onUnsupportedFeature = onUnsupportedFeature;
                        this._document = ownerDocument;
                        this.nativeFontFaces = [];
                        this.styleElement = null;
                    }
                    _createClass(BaseFontLoader, [
                        {
                            key: "addNativeFontFace",
                            value: function addNativeFontFace(nativeFontFace) {
                                this.nativeFontFaces.push(nativeFontFace);
                                this._document.fonts.add(nativeFontFace);
                            }
                        },
                        {
                            key: "insertRule",
                            value: function insertRule(rule) {
                                var styleElement = this.styleElement;
                                if (!styleElement) {
                                    styleElement = this.styleElement = this._document.createElement("style");
                                    styleElement.id = "PDFJS_FONT_STYLE_TAG_".concat(this.docId);
                                    this._document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
                                }
                                var styleSheet = styleElement.sheet;
                                styleSheet.insertRule(rule, styleSheet.cssRules.length);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                var _iterator = _createForOfIteratorHelper(this.nativeFontFaces), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var nativeFontFace = _step.value;
                                        this._document.fonts["delete"](nativeFontFace);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                this.nativeFontFaces.length = 0;
                                if (this.styleElement) {
                                    this.styleElement.remove();
                                    this.styleElement = null;
                                }
                            }
                        },
                        {
                            key: "bind",
                            value: function() {
                                var _bind = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(font) {
                                    var _this = this;
                                    var nativeFontFace, rule;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                if (!(font.attached || font.missingFile)) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                return _context.abrupt("return");
                                            case 2:
                                                font.attached = true;
                                                if (!this.isFontLoadingAPISupported) {
                                                    _context.next = 19;
                                                    break;
                                                }
                                                nativeFontFace = font.createNativeFontFace();
                                                if (!nativeFontFace) {
                                                    _context.next = 18;
                                                    break;
                                                }
                                                this.addNativeFontFace(nativeFontFace);
                                                _context.prev = 7;
                                                _context.next = 10;
                                                return nativeFontFace.loaded;
                                            case 10:
                                                _context.next = 18;
                                                break;
                                            case 12:
                                                _context.prev = 12;
                                                _context.t0 = _context["catch"](7);
                                                this._onUnsupportedFeature({
                                                    featureId: _util.UNSUPPORTED_FEATURES.errorFontLoadNative
                                                });
                                                (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context.t0, "'."));
                                                font.disableFontFace = true;
                                                throw _context.t0;
                                            case 18:
                                                return _context.abrupt("return");
                                            case 19:
                                                rule = font.createFontFaceRule();
                                                if (!rule) {
                                                    _context.next = 26;
                                                    break;
                                                }
                                                this.insertRule(rule);
                                                if (!this.isSyncFontLoadingSupported) {
                                                    _context.next = 24;
                                                    break;
                                                }
                                                return _context.abrupt("return");
                                            case 24:
                                                _context.next = 26;
                                                return new Promise(function(resolve) {
                                                    var request = _this._queueLoadingCallback(resolve);
                                                    _this._prepareFontLoadEvent([
                                                        rule
                                                    ], [
                                                        font
                                                    ], request);
                                                });
                                            case 26:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this, [
                                        [
                                            7,
                                            12
                                        ]
                                    ]);
                                }));
                                function bind(_x) {
                                    return _bind.apply(this, arguments);
                                }
                                return bind;
                            }()
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback(callback) {
                                (0, _util.unreachable)("Abstract method `_queueLoadingCallback`.");
                            }
                        },
                        {
                            key: "isFontLoadingAPISupported",
                            get: function get() {
                                var _this$_document;
                                var hasFonts = !!((_this$_document = this._document) !== null && _this$_document !== void 0 && _this$_document.fonts);
                                return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                            }
                        },
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get() {
                                (0, _util.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get() {
                                (0, _util.unreachable)("Abstract method `_loadTestFont`.");
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent(rules, fontsToLoad, request) {
                                (0, _util.unreachable)("Abstract method `_prepareFontLoadEvent`.");
                            }
                        }
                    ]);
                    return BaseFontLoader;
                }();
                var FontLoader;
                exports.FontLoader = FontLoader;
                exports.FontLoader = FontLoader = /*#__PURE__*/ function(_BaseFontLoader) {
                    _inherits(GenericFontLoader, _BaseFontLoader);
                    var _super = _createSuper(GenericFontLoader);
                    function GenericFontLoader(params) {
                        var _this2;
                        _classCallCheck(this, GenericFontLoader);
                        _this2 = _super.call(this, params);
                        _this2.loadingContext = {
                            requests: [],
                            nextRequestId: 0
                        };
                        _this2.loadTestFontId = 0;
                        return _this2;
                    }
                    _createClass(GenericFontLoader, [
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get() {
                                var supported = false;
                                if (typeof navigator === "undefined") supported = true;
                                else {
                                    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                                    if ((m === null || m === void 0 ? void 0 : m[1]) >= 14) supported = true;
                                }
                                return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                            }
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback(callback) {
                                function completeRequest() {
                                    (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                                    request.done = true;
                                    while(context.requests.length > 0 && context.requests[0].done){
                                        var otherRequest = context.requests.shift();
                                        setTimeout(otherRequest.callback, 0);
                                    }
                                }
                                var context = this.loadingContext;
                                var request = {
                                    id: "pdfjs-font-loading-".concat(context.nextRequestId++),
                                    done: false,
                                    complete: completeRequest,
                                    callback: callback
                                };
                                context.requests.push(request);
                                return request;
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get() {
                                var getLoadTestFont = function getLoadTestFont() {
                                    return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                                };
                                return (0, _util.shadow)(this, "_loadTestFont", getLoadTestFont());
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent(rules, fonts, request) {
                                function int32(data, offset) {
                                    return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                                }
                                function spliceString(s, offset, remove, insert) {
                                    var chunk1 = s.substring(0, offset);
                                    var chunk2 = s.substring(offset + remove);
                                    return chunk1 + insert + chunk2;
                                }
                                var i, ii;
                                var canvas = this._document.createElement("canvas");
                                canvas.width = 1;
                                canvas.height = 1;
                                var ctx = canvas.getContext("2d");
                                var called = 0;
                                function isFontReady(name, callback) {
                                    called++;
                                    if (called > 30) {
                                        (0, _util.warn)("Load test font never loaded.");
                                        callback();
                                        return;
                                    }
                                    ctx.font = "30px " + name;
                                    ctx.fillText(".", 0, 20);
                                    var imageData = ctx.getImageData(0, 0, 1, 1);
                                    if (imageData.data[3] > 0) {
                                        callback();
                                        return;
                                    }
                                    setTimeout(isFontReady.bind(null, name, callback));
                                }
                                var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
                                var data = this._loadTestFont;
                                var COMMENT_OFFSET = 976;
                                data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                                var CFF_CHECKSUM_OFFSET = 16;
                                var XXXX_VALUE = 0x58585858;
                                var checksum = int32(data, CFF_CHECKSUM_OFFSET);
                                for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                                if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                                data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                                var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
                                var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
                                this.insertRule(rule);
                                var names = [];
                                var _iterator2 = _createForOfIteratorHelper(fonts), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var font = _step2.value;
                                        names.push(font.loadedName);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                names.push(loadTestFontId);
                                var div = this._document.createElement("div");
                                div.style.visibility = "hidden";
                                div.style.width = div.style.height = "10px";
                                div.style.position = "absolute";
                                div.style.top = div.style.left = "0px";
                                for(var _i = 0, _names = names; _i < _names.length; _i++){
                                    var name = _names[_i];
                                    var span = this._document.createElement("span");
                                    span.textContent = "Hi";
                                    span.style.fontFamily = name;
                                    div.appendChild(span);
                                }
                                this._document.body.appendChild(div);
                                isFontReady(loadTestFontId, function() {
                                    div.remove();
                                    request.complete();
                                });
                            }
                        }
                    ]);
                    return GenericFontLoader;
                }(BaseFontLoader);
                var FontFaceObject = /*#__PURE__*/ function() {
                    function FontFaceObject(translatedData, _ref2) {
                        var _ref2$isEvalSupported = _ref2.isEvalSupported, isEvalSupported = _ref2$isEvalSupported === void 0 ? true : _ref2$isEvalSupported, _ref2$disableFontFace = _ref2.disableFontFace, disableFontFace = _ref2$disableFontFace === void 0 ? false : _ref2$disableFontFace, _ref2$ignoreErrors = _ref2.ignoreErrors, ignoreErrors = _ref2$ignoreErrors === void 0 ? false : _ref2$ignoreErrors, onUnsupportedFeature = _ref2.onUnsupportedFeature, _ref2$fontRegistry = _ref2.fontRegistry, fontRegistry = _ref2$fontRegistry === void 0 ? null : _ref2$fontRegistry;
                        _classCallCheck(this, FontFaceObject);
                        this.compiledGlyphs = Object.create(null);
                        for(var i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._onUnsupportedFeature = onUnsupportedFeature;
                        this.fontRegistry = fontRegistry;
                    }
                    _createClass(FontFaceObject, [
                        {
                            key: "createNativeFontFace",
                            value: function createNativeFontFace() {
                                if (!this.data || this.disableFontFace) return null;
                                var nativeFontFace;
                                if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                                else {
                                    var css = {
                                        weight: this.cssFontInfo.fontWeight
                                    };
                                    if (this.cssFontInfo.italicAngle) css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
                                    nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                                }
                                if (this.fontRegistry) this.fontRegistry.registerFont(this);
                                return nativeFontFace;
                            }
                        },
                        {
                            key: "createFontFaceRule",
                            value: function createFontFaceRule() {
                                if (!this.data || this.disableFontFace) return null;
                                var data = (0, _util.bytesToString)(this.data);
                                var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data), ");");
                                var rule;
                                if (!this.cssFontInfo) rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");
                                else {
                                    var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
                                    if (this.cssFontInfo.italicAngle) css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
                                    rule = "@font-face {font-family:\"".concat(this.cssFontInfo.fontFamily, "\";").concat(css, "src:").concat(url, "}");
                                }
                                if (this.fontRegistry) this.fontRegistry.registerFont(this, url);
                                return rule;
                            }
                        },
                        {
                            key: "getPathGenerator",
                            value: function getPathGenerator(objs, character) {
                                if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                                var cmds;
                                try {
                                    cmds = objs.get(this.loadedName + "_path_" + character);
                                } catch (ex) {
                                    if (!this.ignoreErrors) throw ex;
                                    this._onUnsupportedFeature({
                                        featureId: _util.UNSUPPORTED_FEATURES.errorFontGetPath
                                    });
                                    (0, _util.warn)("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
                                    return this.compiledGlyphs[character] = function(c, size) {};
                                }
                                if (this.isEvalSupported && _util.IsEvalSupportedCached.value) {
                                    var jsBuf = [];
                                    var _iterator3 = _createForOfIteratorHelper(cmds), _step3;
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            var current = _step3.value;
                                            var args = current.args !== undefined ? current.args.join(",") : "";
                                            jsBuf.push("c.", current.cmd, "(", args, ");\n");
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                                }
                                return this.compiledGlyphs[character] = function(c, size) {
                                    var _iterator4 = _createForOfIteratorHelper(cmds), _step4;
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            var _current = _step4.value;
                                            if (_current.cmd === "scale") _current.args = [
                                                size,
                                                -size
                                            ];
                                            c[_current.cmd].apply(c, _current.args);
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                };
                            }
                        }
                    ]);
                    return FontFaceObject;
                }();
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 138 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(135);
                var _is_node = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(4);
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var NodeCanvasFactory = function NodeCanvasFactory() {
                    _classCallCheck(this, NodeCanvasFactory);
                    (0, _util.unreachable)("Not implemented: NodeCanvasFactory");
                };
                exports.NodeCanvasFactory = NodeCanvasFactory;
                var NodeCMapReaderFactory = function NodeCMapReaderFactory() {
                    _classCallCheck(this, NodeCMapReaderFactory);
                    (0, _util.unreachable)("Not implemented: NodeCMapReaderFactory");
                };
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                var NodeStandardFontDataFactory = function NodeStandardFontDataFactory() {
                    _classCallCheck(this, NodeStandardFontDataFactory);
                    (0, _util.unreachable)("Not implemented: NodeStandardFontDataFactory");
                };
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
                if (_is_node.isNodeJS) {
                    var fetchData = function fetchData(url) {
                        return new Promise(function(resolve, reject) {
                            var fs = (parcelRequire("gFNhN"));
                            fs.readFile(url, function(error, data) {
                                if (error || !data) {
                                    reject(new Error(error));
                                    return;
                                }
                                resolve(new Uint8Array(data));
                            });
                        });
                    };
                    exports.NodeCanvasFactory = NodeCanvasFactory = /*#__PURE__*/ function(_BaseCanvasFactory) {
                        _inherits(NodeCanvasFactory, _BaseCanvasFactory);
                        var _super = _createSuper(NodeCanvasFactory);
                        function NodeCanvasFactory() {
                            _classCallCheck(this, NodeCanvasFactory);
                            return _super.apply(this, arguments);
                        }
                        _createClass(NodeCanvasFactory, [
                            {
                                key: "_createCanvas",
                                value: function _createCanvas(width, height) {
                                    var Canvas = (parcelRequire("gFNhN"));
                                    return Canvas.createCanvas(width, height);
                                }
                            }
                        ]);
                        return NodeCanvasFactory;
                    }(_base_factory.BaseCanvasFactory);
                    exports.NodeCMapReaderFactory = NodeCMapReaderFactory = /*#__PURE__*/ function(_BaseCMapReaderFactor) {
                        _inherits(NodeCMapReaderFactory, _BaseCMapReaderFactor);
                        var _super2 = _createSuper(NodeCMapReaderFactory);
                        function NodeCMapReaderFactory() {
                            _classCallCheck(this, NodeCMapReaderFactory);
                            return _super2.apply(this, arguments);
                        }
                        _createClass(NodeCMapReaderFactory, [
                            {
                                key: "_fetchData",
                                value: function _fetchData(url, compressionType) {
                                    return fetchData(url).then(function(data) {
                                        return {
                                            cMapData: data,
                                            compressionType: compressionType
                                        };
                                    });
                                }
                            }
                        ]);
                        return NodeCMapReaderFactory;
                    }(_base_factory.BaseCMapReaderFactory);
                    exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory = /*#__PURE__*/ function(_BaseStandardFontData) {
                        _inherits(NodeStandardFontDataFactory, _BaseStandardFontData);
                        var _super3 = _createSuper(NodeStandardFontDataFactory);
                        function NodeStandardFontDataFactory() {
                            _classCallCheck(this, NodeStandardFontDataFactory);
                            return _super3.apply(this, arguments);
                        }
                        _createClass(NodeStandardFontDataFactory, [
                            {
                                key: "_fetchData",
                                value: function _fetchData(url) {
                                    return fetchData(url);
                                }
                            }
                        ]);
                        return NodeStandardFontDataFactory;
                    }(_base_factory.BaseStandardFontDataFactory);
                }
            /***/ },
            /* 139 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(4);
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var AnnotationStorage = /*#__PURE__*/ function() {
                    function AnnotationStorage() {
                        _classCallCheck(this, AnnotationStorage);
                        this._storage = new Map();
                        this._timeStamp = Date.now();
                        this._modified = false;
                        this.onSetModified = null;
                        this.onResetModified = null;
                    }
                    _createClass(AnnotationStorage, [
                        {
                            key: "getValue",
                            value: function getValue(key, defaultValue) {
                                var value = this._storage.get(key);
                                if (value === undefined) return defaultValue;
                                return Object.assign(defaultValue, value);
                            }
                        },
                        {
                            key: "setValue",
                            value: function setValue(key, value) {
                                var obj = this._storage.get(key);
                                var modified = false;
                                if (obj !== undefined) for(var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++){
                                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), entry = _Object$entries$_i[0], val = _Object$entries$_i[1];
                                    if (obj[entry] !== val) {
                                        modified = true;
                                        obj[entry] = val;
                                    }
                                }
                                else {
                                    modified = true;
                                    this._storage.set(key, value);
                                }
                                if (modified) {
                                    this._timeStamp = Date.now();
                                    this._setModified();
                                }
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll() {
                                return this._storage.size > 0 ? (0, _util.objectFromMap)(this._storage) : null;
                            }
                        },
                        {
                            key: "size",
                            get: function get() {
                                return this._storage.size;
                            }
                        },
                        {
                            key: "_setModified",
                            value: function _setModified() {
                                if (!this._modified) {
                                    this._modified = true;
                                    if (typeof this.onSetModified === "function") this.onSetModified();
                                }
                            }
                        },
                        {
                            key: "resetModified",
                            value: function resetModified() {
                                if (this._modified) {
                                    this._modified = false;
                                    if (typeof this.onResetModified === "function") this.onResetModified();
                                }
                            }
                        },
                        {
                            key: "serializable",
                            get: function get() {
                                return this._storage.size > 0 ? this._storage : null;
                            }
                        },
                        {
                            key: "lastModified",
                            get: function get() {
                                return this._timeStamp.toString();
                            }
                        }
                    ]);
                    return AnnotationStorage;
                }();
                exports.AnnotationStorage = AnnotationStorage;
            /***/ },
            /* 140 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(4);
                var _pattern_helper = __w_pdfjs_require__(141);
                var _display_utils = __w_pdfjs_require__(1);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                var MIN_FONT_SIZE = 16;
                var MAX_FONT_SIZE = 100;
                var MAX_GROUP_SIZE = 4096;
                var EXECUTION_TIME = 15;
                var EXECUTION_STEPS = 10;
                var COMPILE_TYPE3_GLYPHS = true;
                var MAX_SIZE_TO_COMPILE = 1000;
                var FULL_CHUNK_HEIGHT = 16;
                var LINEWIDTH_SCALE_FACTOR = 1.000001;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = function() {
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                function addContextCurrentTransform(ctx) {
                    if (ctx.mozCurrentTransform) return;
                    ctx._originalSave = ctx.save;
                    ctx._originalRestore = ctx.restore;
                    ctx._originalRotate = ctx.rotate;
                    ctx._originalScale = ctx.scale;
                    ctx._originalTranslate = ctx.translate;
                    ctx._originalTransform = ctx.transform;
                    ctx._originalSetTransform = ctx.setTransform;
                    ctx._originalResetTransform = ctx.resetTransform;
                    ctx._transformMatrix = ctx._transformMatrix || [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ];
                    ctx._transformStack = [];
                    try {
                        var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(ctx), "lineWidth");
                        ctx._setLineWidth = desc.set;
                        ctx._getLineWidth = desc.get;
                        Object.defineProperty(ctx, "lineWidth", {
                            set: function setLineWidth(width) {
                                this._setLineWidth(width * LINEWIDTH_SCALE_FACTOR);
                            },
                            get: function getLineWidth() {
                                return this._getLineWidth();
                            }
                        });
                    } catch (_) {}
                    Object.defineProperty(ctx, "mozCurrentTransform", {
                        get: function getCurrentTransform() {
                            return this._transformMatrix;
                        }
                    });
                    Object.defineProperty(ctx, "mozCurrentTransformInverse", {
                        get: function getCurrentTransformInverse() {
                            var _this$_transformMatri = _slicedToArray(this._transformMatrix, 6), a = _this$_transformMatri[0], b = _this$_transformMatri[1], c = _this$_transformMatri[2], d = _this$_transformMatri[3], e = _this$_transformMatri[4], f = _this$_transformMatri[5];
                            var ad_bc = a * d - b * c;
                            var bc_ad = b * c - a * d;
                            return [
                                d / ad_bc,
                                b / bc_ad,
                                c / bc_ad,
                                a / ad_bc,
                                (d * e - c * f) / bc_ad,
                                (b * e - a * f) / ad_bc
                            ];
                        }
                    });
                    ctx.save = function ctxSave() {
                        var old = this._transformMatrix;
                        this._transformStack.push(old);
                        this._transformMatrix = old.slice(0, 6);
                        this._originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        var prev = this._transformStack.pop();
                        if (prev) {
                            this._transformMatrix = prev;
                            this._originalRestore();
                        }
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        var m = this._transformMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                        this._originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        var m = this._transformMatrix;
                        m[0] *= x;
                        m[1] *= x;
                        m[2] *= y;
                        m[3] *= y;
                        this._originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        var m = this._transformMatrix;
                        this._transformMatrix = [
                            m[0] * a + m[2] * b,
                            m[1] * a + m[3] * b,
                            m[0] * c + m[2] * d,
                            m[1] * c + m[3] * d,
                            m[0] * e + m[2] * f + m[4],
                            m[1] * e + m[3] * f + m[5]
                        ];
                        ctx._originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        this._transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        ctx._originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        this._transformMatrix = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        ctx._originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        var cosValue = Math.cos(angle);
                        var sinValue = Math.sin(angle);
                        var m = this._transformMatrix;
                        this._transformMatrix = [
                            m[0] * cosValue + m[2] * sinValue,
                            m[1] * cosValue + m[3] * sinValue,
                            m[0] * -sinValue + m[2] * cosValue,
                            m[1] * -sinValue + m[3] * cosValue,
                            m[4],
                            m[5]
                        ];
                        this._originalRotate(angle);
                    };
                }
                var CachedCanvases = /*#__PURE__*/ function() {
                    function CachedCanvases(canvasFactory) {
                        _classCallCheck(this, CachedCanvases);
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    _createClass(CachedCanvases, [
                        {
                            key: "getCanvas",
                            value: function getCanvas(id, width, height, trackTransform) {
                                var canvasEntry;
                                if (this.cache[id] !== undefined) {
                                    canvasEntry = this.cache[id];
                                    this.canvasFactory.reset(canvasEntry, width, height);
                                    canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
                                } else {
                                    canvasEntry = this.canvasFactory.create(width, height);
                                    this.cache[id] = canvasEntry;
                                }
                                if (trackTransform) addContextCurrentTransform(canvasEntry.context);
                                return canvasEntry;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                for(var id in this.cache){
                                    var canvasEntry = this.cache[id];
                                    this.canvasFactory.destroy(canvasEntry);
                                    delete this.cache[id];
                                }
                            }
                        }
                    ]);
                    return CachedCanvases;
                }();
                function compileType3Glyph(imgData) {
                    var POINT_TO_PROCESS_LIMIT = 1000;
                    var POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    var width = imgData.width, height = imgData.height, width1 = width + 1;
                    var i, ii, j, j0;
                    var points = new Uint8Array(width1 * (height + 1));
                    var lineSize = width + 7 & -8, data0 = imgData.data;
                    var data = new Uint8Array(lineSize * height);
                    var pos = 0;
                    for(i = 0, ii = data0.length; i < ii; i++){
                        var elem = data0[i];
                        var mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    var count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    var steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    var outlines = [];
                    for(i = 0; count && i <= height; i++){
                        var p = i * width1;
                        var end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        var coords = [
                            p % width1,
                            i
                        ];
                        var p0 = p;
                        var type = points[p];
                        do {
                            var step = steps[type];
                            do p += step;
                            while (!points[p]);
                            var pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            coords.push(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        outlines.push(coords);
                        --i;
                    }
                    var drawOutline = function drawOutline(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.beginPath();
                        for(var k = 0, kk = outlines.length; k < kk; k++){
                            var o = outlines[k];
                            c.moveTo(o[0], o[1]);
                            for(var l = 2, ll = o.length; l < ll; l += 2)c.lineTo(o[l], o[l + 1]);
                        }
                        c.fill();
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                var CanvasExtraState = /*#__PURE__*/ function() {
                    function CanvasExtraState(width, height) {
                        _classCallCheck(this, CanvasExtraState);
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = null;
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    _createClass(CanvasExtraState, [
                        {
                            key: "clone",
                            value: function clone() {
                                var clone = Object.create(this);
                                clone.clipBox = this.clipBox.slice();
                                return clone;
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint(x, y) {
                                this.x = x;
                                this.y = y;
                            }
                        },
                        {
                            key: "updatePathMinMax",
                            value: function updatePathMinMax(transform, x, y) {
                                var _Util$applyTransform = _util.Util.applyTransform([
                                    x,
                                    y
                                ], transform);
                                var _Util$applyTransform2 = _slicedToArray(_Util$applyTransform, 2);
                                x = _Util$applyTransform2[0];
                                y = _Util$applyTransform2[1];
                                this.minX = Math.min(this.minX, x);
                                this.minY = Math.min(this.minY, y);
                                this.maxX = Math.max(this.maxX, x);
                                this.maxY = Math.max(this.maxY, y);
                            }
                        },
                        {
                            key: "updateCurvePathMinMax",
                            value: function updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3) {
                                var box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                                this.updatePathMinMax(transform, box[0], box[1]);
                                this.updatePathMinMax(transform, box[2], box[3]);
                            }
                        },
                        {
                            key: "getPathBoundingBox",
                            value: function getPathBoundingBox() {
                                var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
                                var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var box = [
                                    this.minX,
                                    this.minY,
                                    this.maxX,
                                    this.maxY
                                ];
                                if (pathType === _pattern_helper.PathType.STROKE) {
                                    if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                                    var scale = _util.Util.singularValueDecompose2dScale(transform);
                                    var xStrokePad = scale[0] * this.lineWidth / 2;
                                    var yStrokePad = scale[1] * this.lineWidth / 2;
                                    box[0] -= xStrokePad;
                                    box[1] -= yStrokePad;
                                    box[2] += xStrokePad;
                                    box[3] += yStrokePad;
                                }
                                return box;
                            }
                        },
                        {
                            key: "updateClipFromPath",
                            value: function updateClipFromPath() {
                                var intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                                this.startNewPathAndClipBox(intersect || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            }
                        },
                        {
                            key: "startNewPathAndClipBox",
                            value: function startNewPathAndClipBox(box) {
                                this.clipBox = box;
                                this.minX = Infinity;
                                this.minY = Infinity;
                                this.maxX = 0;
                                this.maxY = 0;
                            }
                        },
                        {
                            key: "getClippedPathBoundingBox",
                            value: function getClippedPathBoundingBox() {
                                var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
                                var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                            }
                        }
                    ]);
                    return CanvasExtraState;
                }();
                function putBinaryImageData(ctx, imgData) {
                    var transferMaps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    var height = imgData.height, width = imgData.width;
                    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    var srcPos = 0, destPos;
                    var src = imgData.data;
                    var dest = chunkImgData.data;
                    var i, j, thisChunkHeight, elemsInThisChunk;
                    var transferMapRed, transferMapGreen, transferMapBlue, transferMapGray;
                    if (transferMaps) switch(transferMaps.length){
                        case 1:
                            transferMapRed = transferMaps[0];
                            transferMapGreen = transferMaps[0];
                            transferMapBlue = transferMaps[0];
                            transferMapGray = transferMaps[0];
                            break;
                        case 4:
                            transferMapRed = transferMaps[0];
                            transferMapGreen = transferMaps[1];
                            transferMapBlue = transferMaps[2];
                            transferMapGray = transferMaps[3];
                            break;
                    }
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        var srcLength = src.byteLength;
                        var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        var dest32DataLength = dest32.length;
                        var fullSrcDiff = width + 7 >> 3;
                        var white = 0xffffffff;
                        var black = _util.IsLittleEndianCached.value ? 0xff000000 : 0x000000ff;
                        if (transferMapGray) {
                            if (transferMapGray[0] === 0xff && transferMapGray[0xff] === 0) {
                                var _ref = [
                                    black,
                                    white
                                ];
                                white = _ref[0];
                                black = _ref[1];
                            }
                        }
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                var srcDiff = srcLength - srcPos;
                                var k = 0;
                                var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                var kEndUnrolled = kEnd & -8;
                                var mask = 0;
                                var srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        var hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            if (hasTransferMaps) for(var _k = 0; _k < elemsInThisChunk; _k += 4){
                                if (transferMapRed) dest[_k + 0] = transferMapRed[dest[_k + 0]];
                                if (transferMapGreen) dest[_k + 1] = transferMapGreen[dest[_k + 1]];
                                if (transferMapBlue) dest[_k + 2] = transferMapBlue[dest[_k + 2]];
                            }
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            if (hasTransferMaps) for(var _k2 = 0; _k2 < elemsInThisChunk; _k2 += 4){
                                if (transferMapRed) dest[_k2 + 0] = transferMapRed[dest[_k2 + 0]];
                                if (transferMapGreen) dest[_k2 + 1] = transferMapGreen[dest[_k2 + 1]];
                                if (transferMapBlue) dest[_k2 + 2] = transferMapBlue[dest[_k2 + 2]];
                            }
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        var _hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            if (_hasTransferMaps) for(var _k3 = 0; _k3 < destPos; _k3 += 4){
                                if (transferMapRed) dest[_k3 + 0] = transferMapRed[dest[_k3 + 0]];
                                if (transferMapGreen) dest[_k3 + 1] = transferMapGreen[dest[_k3 + 1]];
                                if (transferMapBlue) dest[_k3 + 2] = transferMapBlue[dest[_k3 + 2]];
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error("bad image kind: ".concat(imgData.kind));
                }
                function putBinaryImageMask(ctx, imgData) {
                    var height = imgData.height, width = imgData.width;
                    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    var srcPos = 0;
                    var src = imgData.data;
                    var dest = chunkImgData.data;
                    for(var i = 0; i < totalChunks; i++){
                        var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        var destPos = 3;
                        for(var j = 0; j < thisChunkHeight; j++){
                            var elem = void 0, mask = 0;
                            for(var k = 0; k < width; k++){
                                if (!mask) {
                                    elem = src[srcPos++];
                                    mask = 128;
                                }
                                dest[destPos] = elem & mask ? 0 : 255;
                                destPos += 4;
                                mask >>= 1;
                            }
                        }
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    var properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font"
                    ];
                    for(var i = 0, ii = properties.length; i < ii; i++){
                        var property = properties[i];
                        if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    }
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = "#000000";
                    ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    var length = bytes.length;
                    for(var i = 3; i < length; i += 4){
                        var alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            var alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    var length = maskData.length;
                    var scale = 1 / 255;
                    for(var i = 3; i < length; i += 4){
                        var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    var length = maskData.length;
                    for(var i = 3; i < length; i += 4){
                        var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    var hasBackdrop = !!backdrop;
                    var r0 = hasBackdrop ? backdrop[0] : 0;
                    var g0 = hasBackdrop ? backdrop[1] : 0;
                    var b0 = hasBackdrop ? backdrop[2] : 0;
                    var composeFn;
                    if (subtype === "Luminosity") composeFn = composeSMaskLuminosity;
                    else composeFn = composeSMaskAlpha;
                    var PIXELS_TO_PROCESS = 1048576;
                    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(var row = 0; row < height; row += chunkSize){
                        var chunkHeight = Math.min(chunkSize, height - row);
                        var maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        var layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    var layerOffsetX = layerBox[0];
                    var layerOffsetY = layerBox[1];
                    var layerWidth = layerBox[2] - layerOffsetX;
                    var layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    var scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    var actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                var LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var NORMAL_CLIP = {};
                var EO_CLIP = {};
                var CanvasGraphics = /*#__PURE__*/ function() {
                    function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer, optionalContentConfig, annotationCanvasMap) {
                        _classCallCheck(this, CanvasGraphics);
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.imageLayer = imageLayer;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        if (canvasCtx) addContextCurrentTransform(canvasCtx);
                        this._cachedGetSinglePixelWidth = null;
                    }
                    _createClass(CanvasGraphics, [
                        {
                            key: "beginDrawing",
                            value: function beginDrawing(_ref2) {
                                var transform = _ref2.transform, viewport = _ref2.viewport, _ref2$transparency = _ref2.transparency, transparency = _ref2$transparency === void 0 ? false : _ref2$transparency, _ref2$background = _ref2.background, background = _ref2$background === void 0 ? null : _ref2$background;
                                var width = this.ctx.canvas.width;
                                var height = this.ctx.canvas.height;
                                this.ctx.save();
                                this.ctx.fillStyle = background || "rgb(255, 255, 255)";
                                this.ctx.fillRect(0, 0, width, height);
                                this.ctx.restore();
                                if (transparency) {
                                    var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height, true);
                                    this.compositeCtx = this.ctx;
                                    this.transparentCanvas = transparentCanvas.canvas;
                                    this.ctx = transparentCanvas.context;
                                    this.ctx.save();
                                    this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                                }
                                this.ctx.save();
                                resetCtxToDefault(this.ctx);
                                if (transform) {
                                    this.ctx.transform.apply(this.ctx, transform);
                                    this.outputScaleX = transform[0];
                                    this.outputScaleY = transform[0];
                                }
                                this.ctx.transform.apply(this.ctx, viewport.transform);
                                this.viewportScale = viewport.scale;
                                this.baseTransform = this.ctx.mozCurrentTransform.slice();
                                this._combinedScaleFactor = Math.hypot(this.baseTransform[0], this.baseTransform[2]);
                                if (this.imageLayer) this.imageLayer.beginLayout();
                            }
                        },
                        {
                            key: "executeOperatorList",
                            value: function executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                                var argsArray = operatorList.argsArray;
                                var fnArray = operatorList.fnArray;
                                var i = executionStartIdx || 0;
                                var argsArrayLen = argsArray.length;
                                if (argsArrayLen === i) return i;
                                var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                                var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                                var steps = 0;
                                var commonObjs = this.commonObjs;
                                var objs = this.objs;
                                var fnId;
                                while(true){
                                    if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                        stepper.breakIt(i, continueCallback);
                                        return i;
                                    }
                                    fnId = fnArray[i];
                                    if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                                    else {
                                        var _iterator = _createForOfIteratorHelper(argsArray[i]), _step;
                                        try {
                                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                                var depObjId = _step.value;
                                                var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                                if (!objsPool.has(depObjId)) {
                                                    objsPool.get(depObjId, continueCallback);
                                                    return i;
                                                }
                                            }
                                        } catch (err) {
                                            _iterator.e(err);
                                        } finally{
                                            _iterator.f();
                                        }
                                    }
                                    i++;
                                    if (i === argsArrayLen) return i;
                                    if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                        if (Date.now() > endTime) {
                                            continueCallback();
                                            return i;
                                        }
                                        steps = 0;
                                    }
                                }
                            }
                        },
                        {
                            key: "endDrawing",
                            value: function endDrawing() {
                                while(this.stateStack.length || this.current.activeSMask !== null)this.restore();
                                this.ctx.restore();
                                if (this.transparentCanvas) {
                                    this.ctx = this.compositeCtx;
                                    this.ctx.save();
                                    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                    this.ctx.drawImage(this.transparentCanvas, 0, 0);
                                    this.ctx.restore();
                                    this.transparentCanvas = null;
                                }
                                this.cachedCanvases.clear();
                                this.cachedPatterns.clear();
                                if (this.imageLayer) this.imageLayer.endLayout();
                            }
                        },
                        {
                            key: "_scaleImage",
                            value: function _scaleImage(img, inverseTransform) {
                                var width = img.width;
                                var height = img.height;
                                var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                                var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                                var paintWidth = width, paintHeight = height;
                                var tmpCanvasId = "prescale1";
                                var tmpCanvas, tmpCtx;
                                while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                                    var newWidth = paintWidth, newHeight = paintHeight;
                                    if (widthScale > 2 && paintWidth > 1) {
                                        newWidth = Math.ceil(paintWidth / 2);
                                        widthScale /= paintWidth / newWidth;
                                    }
                                    if (heightScale > 2 && paintHeight > 1) {
                                        newHeight = Math.ceil(paintHeight / 2);
                                        heightScale /= paintHeight / newHeight;
                                    }
                                    tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                                    tmpCtx = tmpCanvas.context;
                                    tmpCtx.clearRect(0, 0, newWidth, newHeight);
                                    tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                                    img = tmpCanvas.canvas;
                                    paintWidth = newWidth;
                                    paintHeight = newHeight;
                                    tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                                }
                                return {
                                    img: img,
                                    paintWidth: paintWidth,
                                    paintHeight: paintHeight
                                };
                            }
                        },
                        {
                            key: "_createMaskCanvas",
                            value: function _createMaskCanvas(img) {
                                var ctx = this.ctx;
                                var width = img.width, height = img.height;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                                var maskCtx = maskCanvas.context;
                                putBinaryImageMask(maskCtx, img);
                                var objToCanvas = ctx.mozCurrentTransform;
                                var maskToCanvas = _util.Util.transform(objToCanvas, [
                                    1 / width,
                                    0,
                                    0,
                                    -1 / height,
                                    0,
                                    0
                                ]);
                                maskToCanvas = _util.Util.transform(maskToCanvas, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    -height
                                ]);
                                var cord1 = _util.Util.applyTransform([
                                    0,
                                    0
                                ], maskToCanvas);
                                var cord2 = _util.Util.applyTransform([
                                    width,
                                    height
                                ], maskToCanvas);
                                var rect = _util.Util.normalizeRect([
                                    cord1[0],
                                    cord1[1],
                                    cord2[0],
                                    cord2[1]
                                ]);
                                var drawnWidth = Math.ceil(rect[2] - rect[0]);
                                var drawnHeight = Math.ceil(rect[3] - rect[1]);
                                var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight, true);
                                var fillCtx = fillCanvas.context;
                                var offsetX = Math.min(cord1[0], cord2[0]);
                                var offsetY = Math.min(cord1[1], cord2[1]);
                                fillCtx.translate(-offsetX, -offsetY);
                                fillCtx.transform.apply(fillCtx, maskToCanvas);
                                var scaled = this._scaleImage(maskCanvas.canvas, fillCtx.mozCurrentTransformInverse);
                                fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled(fillCtx.mozCurrentTransform, img.interpolate);
                                fillCtx.drawImage(scaled.img, 0, 0, scaled.img.width, scaled.img.height, 0, 0, width, height);
                                fillCtx.globalCompositeOperation = "source-in";
                                var inverse = _util.Util.transform(fillCtx.mozCurrentTransformInverse, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    -offsetX,
                                    -offsetY
                                ]);
                                fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                                fillCtx.fillRect(0, 0, width, height);
                                return {
                                    canvas: fillCanvas.canvas,
                                    offsetX: Math.round(offsetX),
                                    offsetY: Math.round(offsetY)
                                };
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth(width) {
                                this.current.lineWidth = width;
                                this.ctx.lineWidth = width;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap(style) {
                                this.ctx.lineCap = LINE_CAP_STYLES[style];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin(style) {
                                this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit(limit) {
                                this.ctx.miterLimit = limit;
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash(dashArray, dashPhase) {
                                var ctx = this.ctx;
                                if (ctx.setLineDash !== undefined) {
                                    ctx.setLineDash(dashArray);
                                    ctx.lineDashOffset = dashPhase;
                                }
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent(intent) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness(flatness) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState(states) {
                                for(var i = 0, ii = states.length; i < ii; i++){
                                    var state = states[i];
                                    var key = state[0];
                                    var value = state[1];
                                    switch(key){
                                        case "LW":
                                            this.setLineWidth(value);
                                            break;
                                        case "LC":
                                            this.setLineCap(value);
                                            break;
                                        case "LJ":
                                            this.setLineJoin(value);
                                            break;
                                        case "ML":
                                            this.setMiterLimit(value);
                                            break;
                                        case "D":
                                            this.setDash(value[0], value[1]);
                                            break;
                                        case "RI":
                                            this.setRenderingIntent(value);
                                            break;
                                        case "FL":
                                            this.setFlatness(value);
                                            break;
                                        case "Font":
                                            this.setFont(value[0], value[1]);
                                            break;
                                        case "CA":
                                            this.current.strokeAlpha = state[1];
                                            break;
                                        case "ca":
                                            this.current.fillAlpha = state[1];
                                            this.ctx.globalAlpha = state[1];
                                            break;
                                        case "BM":
                                            this.ctx.globalCompositeOperation = value;
                                            break;
                                        case "SMask":
                                            this.current.activeSMask = value ? this.tempSMask : null;
                                            this.tempSMask = null;
                                            this.checkSMaskState();
                                            break;
                                        case "TR":
                                            this.current.transferMaps = value;
                                    }
                                }
                            }
                        },
                        {
                            key: "checkSMaskState",
                            value: function checkSMaskState() {
                                var inSMaskMode = !!this.suspendedCtx;
                                if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                                else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                            }
                        },
                        {
                            key: "beginSMaskMode",
                            value: function beginSMaskMode() {
                                if (this.suspendedCtx) throw new Error("beginSMaskMode called while already in smask mode");
                                var drawnWidth = this.ctx.canvas.width;
                                var drawnHeight = this.ctx.canvas.height;
                                var cacheId = "smaskGroupAt" + this.groupLevel;
                                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                                this.suspendedCtx = this.ctx;
                                this.ctx = scratchCanvas.context;
                                var ctx = this.ctx;
                                ctx.setTransform.apply(ctx, this.suspendedCtx.mozCurrentTransform);
                                copyCtxState(this.suspendedCtx, ctx);
                                mirrorContextOperations(ctx, this.suspendedCtx);
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                            }
                        },
                        {
                            key: "endSMaskMode",
                            value: function endSMaskMode() {
                                if (!this.suspendedCtx) throw new Error("endSMaskMode called while not in smask mode");
                                this.ctx._removeMirroring();
                                copyCtxState(this.ctx, this.suspendedCtx);
                                this.ctx = this.suspendedCtx;
                                this.current.activeSMask = null;
                                this.suspendedCtx = null;
                            }
                        },
                        {
                            key: "compose",
                            value: function compose(dirtyBox) {
                                if (!this.current.activeSMask) return;
                                if (!dirtyBox) dirtyBox = [
                                    0,
                                    0,
                                    this.ctx.canvas.width,
                                    this.ctx.canvas.height
                                ];
                                else {
                                    dirtyBox[0] = Math.floor(dirtyBox[0]);
                                    dirtyBox[1] = Math.floor(dirtyBox[1]);
                                    dirtyBox[2] = Math.ceil(dirtyBox[2]);
                                    dirtyBox[3] = Math.ceil(dirtyBox[3]);
                                }
                                var smask = this.current.activeSMask;
                                var suspendedCtx = this.suspendedCtx;
                                composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                                this.ctx.save();
                                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                                this.ctx.restore();
                            }
                        },
                        {
                            key: "save",
                            value: function save() {
                                this.ctx.save();
                                var old = this.current;
                                this.stateStack.push(old);
                                this.current = old.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore() {
                                if (this.stateStack.length === 0 && this.current.activeSMask) this.endSMaskMode();
                                if (this.stateStack.length !== 0) {
                                    this.current = this.stateStack.pop();
                                    this.ctx.restore();
                                    this.checkSMaskState();
                                    this.pendingClip = null;
                                    this._cachedGetSinglePixelWidth = null;
                                }
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(a, b, c, d, e, f) {
                                this.ctx.transform(a, b, c, d, e, f);
                                this._cachedGetSinglePixelWidth = null;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath(ops, args) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var x = current.x, y = current.y;
                                var startX, startY;
                                for(var i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                                    case _util.OPS.rectangle:
                                        x = args[j++];
                                        y = args[j++];
                                        var width = args[j++];
                                        var height = args[j++];
                                        var xw = x + width;
                                        var yh = y + height;
                                        ctx.moveTo(x, y);
                                        if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                        else {
                                            ctx.lineTo(xw, y);
                                            ctx.lineTo(xw, yh);
                                            ctx.lineTo(x, yh);
                                        }
                                        current.updatePathMinMax(ctx.mozCurrentTransform, x, y);
                                        current.updatePathMinMax(ctx.mozCurrentTransform, xw, yh);
                                        ctx.closePath();
                                        break;
                                    case _util.OPS.moveTo:
                                        x = args[j++];
                                        y = args[j++];
                                        ctx.moveTo(x, y);
                                        current.updatePathMinMax(ctx.mozCurrentTransform, x, y);
                                        break;
                                    case _util.OPS.lineTo:
                                        x = args[j++];
                                        y = args[j++];
                                        ctx.lineTo(x, y);
                                        current.updatePathMinMax(ctx.mozCurrentTransform, x, y);
                                        break;
                                    case _util.OPS.curveTo:
                                        startX = x;
                                        startY = y;
                                        x = args[j + 4];
                                        y = args[j + 5];
                                        ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                        current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                        j += 6;
                                        break;
                                    case _util.OPS.curveTo2:
                                        startX = x;
                                        startY = y;
                                        ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                        current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                        x = args[j + 2];
                                        y = args[j + 3];
                                        j += 4;
                                        break;
                                    case _util.OPS.curveTo3:
                                        startX = x;
                                        startY = y;
                                        x = args[j + 2];
                                        y = args[j + 3];
                                        ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                        current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, args[j], args[j + 1], x, y, x, y);
                                        j += 4;
                                        break;
                                    case _util.OPS.closePath:
                                        ctx.closePath();
                                        break;
                                }
                                current.setCurrentPoint(x, y);
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath() {
                                this.ctx.closePath();
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke(consumePath) {
                                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                                var ctx = this.ctx;
                                var strokeColor = this.current.strokeColor;
                                ctx.globalAlpha = this.current.strokeAlpha;
                                if (this.contentVisible) {
                                    if (_typeof(strokeColor) === "object" && strokeColor !== null && strokeColor !== void 0 && strokeColor.getPattern) {
                                        var lineWidth = this.getSinglePixelWidth();
                                        ctx.save();
                                        ctx.strokeStyle = strokeColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.STROKE);
                                        ctx.lineWidth = Math.max(lineWidth, this.current.lineWidth);
                                        ctx.stroke();
                                        ctx.restore();
                                    } else {
                                        var _lineWidth = this.getSinglePixelWidth();
                                        if (_lineWidth < 0 && -_lineWidth >= this.current.lineWidth) {
                                            ctx.save();
                                            ctx.resetTransform();
                                            ctx.lineWidth = Math.round(this._combinedScaleFactor);
                                            ctx.stroke();
                                            ctx.restore();
                                        } else {
                                            ctx.lineWidth = Math.max(_lineWidth, this.current.lineWidth);
                                            ctx.stroke();
                                        }
                                    }
                                }
                                if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                                ctx.globalAlpha = this.current.fillAlpha;
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "fill",
                            value: function fill(consumePath) {
                                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                                var ctx = this.ctx;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var needRestore = false;
                                if (isPatternFill) {
                                    ctx.save();
                                    ctx.fillStyle = fillColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL);
                                    needRestore = true;
                                }
                                var intersect = this.current.getClippedPathBoundingBox();
                                if (this.contentVisible && intersect !== null) {
                                    if (this.pendingEOFill) {
                                        ctx.fill("evenodd");
                                        this.pendingEOFill = false;
                                    } else ctx.fill();
                                }
                                if (needRestore) ctx.restore();
                                if (consumePath) this.consumePath(intersect);
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill() {
                                this.pendingEOFill = true;
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke() {
                                this.fill(false);
                                this.stroke(false);
                                this.consumePath();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke() {
                                this.pendingEOFill = true;
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke() {
                                this.pendingEOFill = true;
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath() {
                                this.consumePath();
                            }
                        },
                        {
                            key: "clip",
                            value: function clip() {
                                this.pendingClip = NORMAL_CLIP;
                            }
                        },
                        {
                            key: "eoClip",
                            value: function eoClip() {
                                this.pendingClip = EO_CLIP;
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText() {
                                this.current.textMatrix = _util.IDENTITY_MATRIX;
                                this.current.textMatrixScale = 1;
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "endText",
                            value: function endText() {
                                var paths = this.pendingTextPaths;
                                var ctx = this.ctx;
                                if (paths === undefined) {
                                    ctx.beginPath();
                                    return;
                                }
                                ctx.save();
                                ctx.beginPath();
                                for(var i = 0; i < paths.length; i++){
                                    var path = paths[i];
                                    ctx.setTransform.apply(ctx, path.transform);
                                    ctx.translate(path.x, path.y);
                                    path.addToPath(ctx, path.fontSize);
                                }
                                ctx.restore();
                                ctx.clip();
                                ctx.beginPath();
                                delete this.pendingTextPaths;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing(spacing) {
                                this.current.charSpacing = spacing;
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing(spacing) {
                                this.current.wordSpacing = spacing;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale(scale) {
                                this.current.textHScale = scale / 100;
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading(leading) {
                                this.current.leading = -leading;
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont(fontRefName, size) {
                                var fontObj = this.commonObjs.get(fontRefName);
                                var current = this.current;
                                if (!fontObj) throw new Error("Can't find font for ".concat(fontRefName));
                                current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                                if (size < 0) {
                                    size = -size;
                                    current.fontDirection = -1;
                                } else current.fontDirection = 1;
                                this.current.font = fontObj;
                                this.current.fontSize = size;
                                if (fontObj.isType3Font) return;
                                var name = fontObj.loadedName || "sans-serif";
                                var bold = "normal";
                                if (fontObj.black) bold = "900";
                                else if (fontObj.bold) bold = "bold";
                                var italic = fontObj.italic ? "italic" : "normal";
                                var typeface = "\"".concat(name, "\", ").concat(fontObj.fallbackName);
                                var browserFontSize = size;
                                if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                                else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                                this.current.fontSizeScale = size / browserFontSize;
                                this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode(mode) {
                                this.current.textRenderingMode = mode;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise(rise) {
                                this.current.textRise = rise;
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText(x, y) {
                                this.current.x = this.current.lineX += x;
                                this.current.y = this.current.lineY += y;
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText(x, y) {
                                this.setLeading(-y);
                                this.moveText(x, y);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix(a, b, c, d, e, f) {
                                this.current.textMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                this.current.textMatrixScale = Math.hypot(a, b);
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "paintChar",
                            value: function paintChar(character, x, y, patternTransform, resetLineWidthToOne) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var font = current.font;
                                var textRenderingMode = current.textRenderingMode;
                                var fontSize = current.fontSize / current.fontSizeScale;
                                var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                                var patternFill = current.patternFill && !font.missingFile;
                                var addToPath;
                                if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                                if (font.disableFontFace || patternFill) {
                                    ctx.save();
                                    ctx.translate(x, y);
                                    ctx.beginPath();
                                    addToPath(ctx, fontSize);
                                    if (patternTransform) ctx.setTransform.apply(ctx, patternTransform);
                                    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                        if (resetLineWidthToOne) {
                                            ctx.resetTransform();
                                            ctx.lineWidth = Math.round(this._combinedScaleFactor);
                                        }
                                        ctx.stroke();
                                    }
                                    ctx.restore();
                                } else {
                                    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                        if (resetLineWidthToOne) {
                                            ctx.save();
                                            ctx.moveTo(x, y);
                                            ctx.resetTransform();
                                            ctx.lineWidth = Math.round(this._combinedScaleFactor);
                                            ctx.strokeText(character, 0, 0);
                                            ctx.restore();
                                        } else ctx.strokeText(character, x, y);
                                    }
                                }
                                if (isAddToPathSet) {
                                    var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                                    paths.push({
                                        transform: ctx.mozCurrentTransform,
                                        x: x,
                                        y: y,
                                        fontSize: fontSize,
                                        addToPath: addToPath
                                    });
                                }
                            }
                        },
                        {
                            key: "isFontSubpixelAAEnabled",
                            get: function get() {
                                var _this$cachedCanvases$ = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10), ctx = _this$cachedCanvases$.context;
                                ctx.scale(1.5, 1);
                                ctx.fillText("I", 0, 10);
                                var data = ctx.getImageData(0, 0, 10, 10).data;
                                var enabled = false;
                                for(var i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                                    enabled = true;
                                    break;
                                }
                                return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                            }
                        },
                        {
                            key: "showText",
                            value: function showText(glyphs) {
                                var current = this.current;
                                var font = current.font;
                                if (font.isType3Font) return this.showType3Text(glyphs);
                                var fontSize = current.fontSize;
                                if (fontSize === 0) return undefined;
                                var ctx = this.ctx;
                                var fontSizeScale = current.fontSizeScale;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var fontDirection = current.fontDirection;
                                var textHScale = current.textHScale * fontDirection;
                                var glyphsLength = glyphs.length;
                                var vertical = font.vertical;
                                var spacingDir = vertical ? 1 : -1;
                                var defaultVMetrics = font.defaultVMetrics;
                                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                                var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                                ctx.save();
                                ctx.transform.apply(ctx, current.textMatrix);
                                ctx.translate(current.x, current.y + current.textRise);
                                if (fontDirection > 0) ctx.scale(textHScale, -1);
                                else ctx.scale(textHScale, 1);
                                var patternTransform;
                                if (current.patternFill) {
                                    ctx.save();
                                    var pattern = current.fillColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL);
                                    patternTransform = ctx.mozCurrentTransform;
                                    ctx.restore();
                                    ctx.fillStyle = pattern;
                                }
                                var lineWidth = current.lineWidth;
                                var resetLineWidthToOne = false;
                                var scale = current.textMatrixScale;
                                if (scale === 0 || lineWidth === 0) {
                                    var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                        this._cachedGetSinglePixelWidth = null;
                                        lineWidth = this.getSinglePixelWidth();
                                        resetLineWidthToOne = lineWidth < 0;
                                    }
                                } else lineWidth /= scale;
                                if (fontSizeScale !== 1.0) {
                                    ctx.scale(fontSizeScale, fontSizeScale);
                                    lineWidth /= fontSizeScale;
                                }
                                ctx.lineWidth = lineWidth;
                                var x = 0, i;
                                for(i = 0; i < glyphsLength; ++i){
                                    var glyph = glyphs[i];
                                    if ((0, _util.isNum)(glyph)) {
                                        x += spacingDir * glyph * fontSize / 1000;
                                        continue;
                                    }
                                    var restoreNeeded = false;
                                    var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                    var character = glyph.fontChar;
                                    var accent = glyph.accent;
                                    var scaledX = void 0, scaledY = void 0;
                                    var width = glyph.width;
                                    if (vertical) {
                                        var vmetric = glyph.vmetric || defaultVMetrics;
                                        var vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                        var vy = vmetric[2] * widthAdvanceScale;
                                        width = vmetric ? -vmetric[0] : width;
                                        scaledX = vx / fontSizeScale;
                                        scaledY = (x + vy) / fontSizeScale;
                                    } else {
                                        scaledX = x / fontSizeScale;
                                        scaledY = 0;
                                    }
                                    if (font.remeasure && width > 0) {
                                        var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                        if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                            var characterScaleX = width / measuredWidth;
                                            restoreNeeded = true;
                                            ctx.save();
                                            ctx.scale(characterScaleX, 1);
                                            scaledX /= characterScaleX;
                                        } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                                    }
                                    if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                        if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                        else {
                                            this.paintChar(character, scaledX, scaledY, patternTransform, resetLineWidthToOne);
                                            if (accent) {
                                                var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                                var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                                this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform, resetLineWidthToOne);
                                            }
                                        }
                                    }
                                    var charWidth = void 0;
                                    if (vertical) charWidth = width * widthAdvanceScale - spacing * fontDirection;
                                    else charWidth = width * widthAdvanceScale + spacing * fontDirection;
                                    x += charWidth;
                                    if (restoreNeeded) ctx.restore();
                                }
                                if (vertical) current.y -= x;
                                else current.x += x * textHScale;
                                ctx.restore();
                                this.compose();
                                return undefined;
                            }
                        },
                        {
                            key: "showType3Text",
                            value: function showType3Text(glyphs) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var font = current.font;
                                var fontSize = current.fontSize;
                                var fontDirection = current.fontDirection;
                                var spacingDir = font.vertical ? 1 : -1;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var textHScale = current.textHScale * fontDirection;
                                var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                var glyphsLength = glyphs.length;
                                var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                                var i, glyph, width, spacingLength;
                                if (isTextInvisible || fontSize === 0) return;
                                this._cachedGetSinglePixelWidth = null;
                                ctx.save();
                                ctx.transform.apply(ctx, current.textMatrix);
                                ctx.translate(current.x, current.y);
                                ctx.scale(textHScale, fontDirection);
                                for(i = 0; i < glyphsLength; ++i){
                                    glyph = glyphs[i];
                                    if ((0, _util.isNum)(glyph)) {
                                        spacingLength = spacingDir * glyph * fontSize / 1000;
                                        this.ctx.translate(spacingLength, 0);
                                        current.x += spacingLength * textHScale;
                                        continue;
                                    }
                                    var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                    var operatorList = font.charProcOperatorList[glyph.operatorListId];
                                    if (!operatorList) {
                                        (0, _util.warn)("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
                                        continue;
                                    }
                                    if (this.contentVisible) {
                                        this.processingType3 = glyph;
                                        this.save();
                                        ctx.scale(fontSize, fontSize);
                                        ctx.transform.apply(ctx, fontMatrix);
                                        this.executeOperatorList(operatorList);
                                        this.restore();
                                    }
                                    var transformed = _util.Util.applyTransform([
                                        glyph.width,
                                        0
                                    ], fontMatrix);
                                    width = transformed[0] * fontSize + spacing;
                                    ctx.translate(width, 0);
                                    current.x += width * textHScale;
                                }
                                ctx.restore();
                                this.processingType3 = null;
                            }
                        },
                        {
                            key: "setCharWidth",
                            value: function setCharWidth(xWidth, yWidth) {}
                        },
                        {
                            key: "setCharWidthAndBounds",
                            value: function setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                                this.ctx.rect(llx, lly, urx - llx, ury - lly);
                                this.clip();
                                this.endPath();
                            }
                        },
                        {
                            key: "getColorN_Pattern",
                            value: function getColorN_Pattern(IR) {
                                var _this = this;
                                var pattern;
                                if (IR[0] === "TilingPattern") {
                                    var color = IR[1];
                                    var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
                                    var canvasGraphicsFactory = {
                                        createCanvasGraphics: function createCanvasGraphics(ctx) {
                                            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
                                        }
                                    };
                                    pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                                } else pattern = this._getPattern(IR[1], IR[2]);
                                return pattern;
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN() {
                                this.current.strokeColor = this.getColorN_Pattern(arguments);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN() {
                                this.current.fillColor = this.getColorN_Pattern(arguments);
                                this.current.patternFill = true;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor(r, g, b) {
                                var color = _util.Util.makeHexColor(r, g, b);
                                this.ctx.strokeStyle = color;
                                this.current.strokeColor = color;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor(r, g, b) {
                                var color = _util.Util.makeHexColor(r, g, b);
                                this.ctx.fillStyle = color;
                                this.current.fillColor = color;
                                this.current.patternFill = false;
                            }
                        },
                        {
                            key: "_getPattern",
                            value: function _getPattern(objId) {
                                var matrix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var pattern;
                                if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                                else {
                                    pattern = (0, _pattern_helper.getShadingPattern)(this.objs.get(objId));
                                    this.cachedPatterns.set(objId, pattern);
                                }
                                if (matrix) pattern.matrix = matrix;
                                return pattern;
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill(objId) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                this.save();
                                var pattern = this._getPattern(objId);
                                ctx.fillStyle = pattern.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.SHADING);
                                var inv = ctx.mozCurrentTransformInverse;
                                if (inv) {
                                    var canvas = ctx.canvas;
                                    var width = canvas.width;
                                    var height = canvas.height;
                                    var bl = _util.Util.applyTransform([
                                        0,
                                        0
                                    ], inv);
                                    var br = _util.Util.applyTransform([
                                        0,
                                        height
                                    ], inv);
                                    var ul = _util.Util.applyTransform([
                                        width,
                                        0
                                    ], inv);
                                    var ur = _util.Util.applyTransform([
                                        width,
                                        height
                                    ], inv);
                                    var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                                    var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                                    var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                                    var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                                    this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                                } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                                this.compose(this.current.getClippedPathBoundingBox());
                                this.restore();
                            }
                        },
                        {
                            key: "beginInlineImage",
                            value: function beginInlineImage() {
                                (0, _util.unreachable)("Should not call beginInlineImage");
                            }
                        },
                        {
                            key: "beginImageData",
                            value: function beginImageData() {
                                (0, _util.unreachable)("Should not call beginImageData");
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin(matrix, bbox) {
                                if (!this.contentVisible) return;
                                this.save();
                                this.baseTransformStack.push(this.baseTransform);
                                if (Array.isArray(matrix) && matrix.length === 6) this.transform.apply(this, matrix);
                                this.baseTransform = this.ctx.mozCurrentTransform;
                                if (bbox) {
                                    var width = bbox[2] - bbox[0];
                                    var height = bbox[3] - bbox[1];
                                    this.ctx.rect(bbox[0], bbox[1], width, height);
                                    this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox[0], bbox[1]);
                                    this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox[2], bbox[3]);
                                    this.clip();
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd() {
                                if (!this.contentVisible) return;
                                this.restore();
                                this.baseTransform = this.baseTransformStack.pop();
                            }
                        },
                        {
                            key: "beginGroup",
                            value: function beginGroup(group) {
                                if (!this.contentVisible) return;
                                this.save();
                                var suspendedCtx = this.suspendedCtx;
                                if (this.current.activeSMask) {
                                    this.suspendedCtx = null;
                                    this.current.activeSMask = null;
                                }
                                var currentCtx = this.ctx;
                                if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                                if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                                var currentTransform = currentCtx.mozCurrentTransform;
                                if (group.matrix) currentCtx.transform.apply(currentCtx, group.matrix);
                                if (!group.bbox) throw new Error("Bounding box is required.");
                                var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
                                var canvasBounds = [
                                    0,
                                    0,
                                    currentCtx.canvas.width,
                                    currentCtx.canvas.height
                                ];
                                bounds = _util.Util.intersect(bounds, canvasBounds) || [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                var offsetX = Math.floor(bounds[0]);
                                var offsetY = Math.floor(bounds[1]);
                                var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                                var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                                var scaleX = 1, scaleY = 1;
                                if (drawnWidth > MAX_GROUP_SIZE) {
                                    scaleX = drawnWidth / MAX_GROUP_SIZE;
                                    drawnWidth = MAX_GROUP_SIZE;
                                }
                                if (drawnHeight > MAX_GROUP_SIZE) {
                                    scaleY = drawnHeight / MAX_GROUP_SIZE;
                                    drawnHeight = MAX_GROUP_SIZE;
                                }
                                this.current.startNewPathAndClipBox([
                                    0,
                                    0,
                                    drawnWidth,
                                    drawnHeight
                                ]);
                                var cacheId = "groupAt" + this.groupLevel;
                                if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                                var groupCtx = scratchCanvas.context;
                                groupCtx.scale(1 / scaleX, 1 / scaleY);
                                groupCtx.translate(-offsetX, -offsetY);
                                groupCtx.transform.apply(groupCtx, currentTransform);
                                if (group.smask) this.smaskStack.push({
                                    canvas: scratchCanvas.canvas,
                                    context: groupCtx,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    scaleX: scaleX,
                                    scaleY: scaleY,
                                    subtype: group.smask.subtype,
                                    backdrop: group.smask.backdrop,
                                    transferMap: group.smask.transferMap || null,
                                    startTransformInverse: null
                                });
                                else {
                                    currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                                    currentCtx.translate(offsetX, offsetY);
                                    currentCtx.scale(scaleX, scaleY);
                                    currentCtx.save();
                                }
                                copyCtxState(currentCtx, groupCtx);
                                this.ctx = groupCtx;
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                                this.groupStack.push({
                                    ctx: currentCtx,
                                    suspendedCtx: suspendedCtx
                                });
                                this.groupLevel++;
                            }
                        },
                        {
                            key: "endGroup",
                            value: function endGroup(group) {
                                if (!this.contentVisible) return;
                                this.groupLevel--;
                                var groupCtx = this.ctx;
                                var _this$groupStack$pop = this.groupStack.pop(), ctx = _this$groupStack$pop.ctx, suspendedCtx = _this$groupStack$pop.suspendedCtx;
                                this.ctx = ctx;
                                this.ctx.imageSmoothingEnabled = false;
                                if (suspendedCtx) this.suspendedCtx = suspendedCtx;
                                if (group.smask) {
                                    this.tempSMask = this.smaskStack.pop();
                                    this.restore();
                                } else {
                                    this.ctx.restore();
                                    var currentMtx = this.ctx.mozCurrentTransform;
                                    this.restore();
                                    this.ctx.save();
                                    this.ctx.setTransform.apply(this.ctx, currentMtx);
                                    var dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                        0,
                                        0,
                                        groupCtx.canvas.width,
                                        groupCtx.canvas.height
                                    ], currentMtx);
                                    this.ctx.drawImage(groupCtx.canvas, 0, 0);
                                    this.ctx.restore();
                                    this.compose(dirtyBox);
                                }
                            }
                        },
                        {
                            key: "beginAnnotations",
                            value: function beginAnnotations() {
                                this.save();
                                if (this.baseTransform) this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                            }
                        },
                        {
                            key: "endAnnotations",
                            value: function endAnnotations() {
                                this.restore();
                            }
                        },
                        {
                            key: "beginAnnotation",
                            value: function beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                                this.save();
                                if (Array.isArray(rect) && rect.length === 4) {
                                    var width = rect[2] - rect[0];
                                    var height = rect[3] - rect[1];
                                    if (hasOwnCanvas && this.annotationCanvasMap) {
                                        transform = transform.slice();
                                        transform[4] -= rect[0];
                                        transform[5] -= rect[1];
                                        rect = rect.slice();
                                        rect[0] = rect[1] = 0;
                                        rect[2] = width;
                                        rect[3] = height;
                                        var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(this.ctx.mozCurrentTransform), _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2), scaleX = _Util$singularValueDe2[0], scaleY = _Util$singularValueDe2[1];
                                        var viewportScale = this.viewportScale;
                                        var canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                        var canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                        this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                        var _this$annotationCanva = this.annotationCanvas, canvas = _this$annotationCanva.canvas, context = _this$annotationCanva.context;
                                        canvas.style.width = "calc(".concat(width, "px * var(--viewport-scale-factor))");
                                        canvas.style.height = "calc(".concat(height, "px * var(--viewport-scale-factor))");
                                        this.annotationCanvasMap.set(id, canvas);
                                        this.annotationCanvas.savedCtx = this.ctx;
                                        this.ctx = context;
                                        this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                        addContextCurrentTransform(this.ctx);
                                        resetCtxToDefault(this.ctx);
                                    } else {
                                        resetCtxToDefault(this.ctx);
                                        this.ctx.rect(rect[0], rect[1], width, height);
                                        this.clip();
                                        this.endPath();
                                    }
                                }
                                this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                                this.transform.apply(this, transform);
                                this.transform.apply(this, matrix);
                            }
                        },
                        {
                            key: "endAnnotation",
                            value: function endAnnotation() {
                                if (this.annotationCanvas) {
                                    this.ctx = this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas;
                                }
                                this.restore();
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject(img) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var width = img.width, height = img.height;
                                var glyph = this.processingType3;
                                if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
                                    if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) glyph.compiled = compileType3Glyph({
                                        data: img.data,
                                        width: width,
                                        height: height
                                    });
                                    else glyph.compiled = null;
                                }
                                if (glyph !== null && glyph !== void 0 && glyph.compiled) {
                                    glyph.compiled(ctx);
                                    return;
                                }
                                var mask = this._createMaskCanvas(img);
                                var maskCanvas = mask.canvas;
                                ctx.save();
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                                ctx.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectRepeat",
                            value: function paintImageMaskXObjectRepeat(imgData, scaleX) {
                                var skewX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                                var skewY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                                var scaleY = arguments.length > 4 ? arguments[4] : undefined;
                                var positions = arguments.length > 5 ? arguments[5] : undefined;
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                ctx.save();
                                var currentTransform = ctx.mozCurrentTransform;
                                ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                                var mask = this._createMaskCanvas(imgData);
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                for(var i = 0, ii = positions.length; i < ii; i += 2){
                                    var trans = _util.Util.transform(currentTransform, [
                                        scaleX,
                                        skewX,
                                        skewY,
                                        scaleY,
                                        positions[i],
                                        positions[i + 1]
                                    ]);
                                    var _Util$applyTransform3 = _util.Util.applyTransform([
                                        0,
                                        0
                                    ], trans), _Util$applyTransform4 = _slicedToArray(_Util$applyTransform3, 2), x = _Util$applyTransform4[0], y = _Util$applyTransform4[1];
                                    ctx.drawImage(mask.canvas, x, y);
                                }
                                ctx.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectGroup",
                            value: function paintImageMaskXObjectGroup(images) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                for(var i = 0, ii = images.length; i < ii; i++){
                                    var image = images[i];
                                    var width = image.width, height = image.height;
                                    var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                                    var maskCtx = maskCanvas.context;
                                    maskCtx.save();
                                    putBinaryImageMask(maskCtx, image);
                                    maskCtx.globalCompositeOperation = "source-in";
                                    maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL) : fillColor;
                                    maskCtx.fillRect(0, 0, width, height);
                                    maskCtx.restore();
                                    ctx.save();
                                    ctx.transform.apply(ctx, image.transform);
                                    ctx.scale(1, -1);
                                    ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                                    ctx.restore();
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject(objId) {
                                if (!this.contentVisible) return;
                                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                this.paintInlineImageXObject(imgData);
                            }
                        },
                        {
                            key: "paintImageXObjectRepeat",
                            value: function paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                                if (!this.contentVisible) return;
                                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                var width = imgData.width;
                                var height = imgData.height;
                                var map = [];
                                for(var i = 0, ii = positions.length; i < ii; i += 2)map.push({
                                    transform: [
                                        scaleX,
                                        0,
                                        0,
                                        scaleY,
                                        positions[i],
                                        positions[i + 1]
                                    ],
                                    x: 0,
                                    y: 0,
                                    w: width,
                                    h: height
                                });
                                this.paintInlineImageXObjectGroup(imgData, map);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject(imgData) {
                                if (!this.contentVisible) return;
                                var width = imgData.width;
                                var height = imgData.height;
                                var ctx = this.ctx;
                                this.save();
                                ctx.scale(1 / width, -1 / height);
                                var imgToPaint;
                                if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                                else {
                                    var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                                    var tmpCtx = tmpCanvas.context;
                                    putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                                    imgToPaint = tmpCanvas.canvas;
                                }
                                var scaled = this._scaleImage(imgToPaint, ctx.mozCurrentTransformInverse);
                                ctx.imageSmoothingEnabled = getImageSmoothingEnabled(ctx.mozCurrentTransform, imgData.interpolate);
                                ctx.drawImage(scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                                if (this.imageLayer) {
                                    var position = this.getCanvasPosition(0, -height);
                                    this.imageLayer.appendImage({
                                        imgData: imgData,
                                        left: position[0],
                                        top: position[1],
                                        width: width / ctx.mozCurrentTransformInverse[0],
                                        height: height / ctx.mozCurrentTransformInverse[3]
                                    });
                                }
                                this.compose();
                                this.restore();
                            }
                        },
                        {
                            key: "paintInlineImageXObjectGroup",
                            value: function paintInlineImageXObjectGroup(imgData, map) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var w = imgData.width;
                                var h = imgData.height;
                                var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                                var tmpCtx = tmpCanvas.context;
                                putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                                for(var i = 0, ii = map.length; i < ii; i++){
                                    var entry = map[i];
                                    ctx.save();
                                    ctx.transform.apply(ctx, entry.transform);
                                    ctx.scale(1, -1);
                                    ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                                    if (this.imageLayer) {
                                        var position = this.getCanvasPosition(entry.x, entry.y);
                                        this.imageLayer.appendImage({
                                            imgData: imgData,
                                            left: position[0],
                                            top: position[1],
                                            width: w,
                                            height: h
                                        });
                                    }
                                    ctx.restore();
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask() {
                                if (!this.contentVisible) return;
                                this.ctx.fillRect(0, 0, 1, 1);
                                this.compose();
                            }
                        },
                        {
                            key: "markPoint",
                            value: function markPoint(tag) {}
                        },
                        {
                            key: "markPointProps",
                            value: function markPointProps(tag, properties) {}
                        },
                        {
                            key: "beginMarkedContent",
                            value: function beginMarkedContent(tag) {
                                this.markedContentStack.push({
                                    visible: true
                                });
                            }
                        },
                        {
                            key: "beginMarkedContentProps",
                            value: function beginMarkedContentProps(tag, properties) {
                                if (tag === "OC") this.markedContentStack.push({
                                    visible: this.optionalContentConfig.isVisible(properties)
                                });
                                else this.markedContentStack.push({
                                    visible: true
                                });
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "endMarkedContent",
                            value: function endMarkedContent() {
                                this.markedContentStack.pop();
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "beginCompat",
                            value: function beginCompat() {}
                        },
                        {
                            key: "endCompat",
                            value: function endCompat() {}
                        },
                        {
                            key: "consumePath",
                            value: function consumePath(clipBox) {
                                if (this.pendingClip) this.current.updateClipFromPath();
                                if (!this.pendingClip) this.compose(clipBox);
                                var ctx = this.ctx;
                                if (this.pendingClip) {
                                    if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                    else ctx.clip();
                                    this.pendingClip = null;
                                }
                                this.current.startNewPathAndClipBox(this.current.clipBox);
                                ctx.beginPath();
                            }
                        },
                        {
                            key: "getSinglePixelWidth",
                            value: function getSinglePixelWidth() {
                                if (this._cachedGetSinglePixelWidth === null) {
                                    var m = this.ctx.mozCurrentTransform;
                                    var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                    var sqNorm1 = Math.pow(m[0], 2) + Math.pow(m[2], 2);
                                    var sqNorm2 = Math.pow(m[1], 2) + Math.pow(m[3], 2);
                                    var pixelHeight = Math.sqrt(Math.max(sqNorm1, sqNorm2)) / absDet;
                                    if (sqNorm1 !== sqNorm2 && this._combinedScaleFactor * pixelHeight > 1) this._cachedGetSinglePixelWidth = -(this._combinedScaleFactor * pixelHeight);
                                    else if (absDet > Number.EPSILON) this._cachedGetSinglePixelWidth = pixelHeight;
                                    else this._cachedGetSinglePixelWidth = 1;
                                }
                                return this._cachedGetSinglePixelWidth;
                            }
                        },
                        {
                            key: "getCanvasPosition",
                            value: function getCanvasPosition(x, y) {
                                var transform = this.ctx.mozCurrentTransform;
                                return [
                                    transform[0] * x + transform[2] * y + transform[4],
                                    transform[1] * x + transform[3] * y + transform[5]
                                ];
                            }
                        },
                        {
                            key: "isContentVisible",
                            value: function isContentVisible() {
                                for(var i = this.markedContentStack.length - 1; i >= 0; i--){
                                    if (!this.markedContentStack[i].visible) return false;
                                }
                                return true;
                            }
                        }
                    ]);
                    return CanvasGraphics;
                }();
                exports.CanvasGraphics = CanvasGraphics;
                for(var op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 141 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(4);
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox || typeof Path2D === "undefined") return;
                    var width = bbox[2] - bbox[0];
                    var height = bbox[3] - bbox[1];
                    var region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                var BaseShadingPattern = /*#__PURE__*/ function() {
                    function BaseShadingPattern() {
                        _classCallCheck(this, BaseShadingPattern);
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    _createClass(BaseShadingPattern, [
                        {
                            key: "getPattern",
                            value: function getPattern() {
                                (0, _util.unreachable)("Abstract method `getPattern` called.");
                            }
                        }
                    ]);
                    return BaseShadingPattern;
                }();
                var RadialAxialShadingPattern = /*#__PURE__*/ function(_BaseShadingPattern) {
                    _inherits(RadialAxialShadingPattern, _BaseShadingPattern);
                    var _super = _createSuper(RadialAxialShadingPattern);
                    function RadialAxialShadingPattern(IR) {
                        var _this;
                        _classCallCheck(this, RadialAxialShadingPattern);
                        _this = _super.call(this);
                        _this._type = IR[1];
                        _this._bbox = IR[2];
                        _this._colorStops = IR[3];
                        _this._p0 = IR[4];
                        _this._p1 = IR[5];
                        _this._r0 = IR[6];
                        _this._r1 = IR[7];
                        _this.matrix = null;
                        return _this;
                    }
                    _createClass(RadialAxialShadingPattern, [
                        {
                            key: "_createGradient",
                            value: function _createGradient(ctx) {
                                var grad;
                                if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                                else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                                var _iterator = _createForOfIteratorHelper(this._colorStops), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var colorStop = _step.value;
                                        grad.addColorStop(colorStop[0], colorStop[1]);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                return grad;
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                var pattern;
                                if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                                    var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, ctx.mozCurrentTransform) || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ];
                                    var width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                                    var height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                                    var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                                    var tmpCtx = tmpCanvas.context;
                                    tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                                    tmpCtx.beginPath();
                                    tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                                    tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                                    inverse = _util.Util.transform(inverse, [
                                        1,
                                        0,
                                        0,
                                        1,
                                        ownerBBox[0],
                                        ownerBBox[1]
                                    ]);
                                    tmpCtx.transform.apply(tmpCtx, owner.baseTransform);
                                    if (this.matrix) tmpCtx.transform.apply(tmpCtx, this.matrix);
                                    applyBoundingBox(tmpCtx, this._bbox);
                                    tmpCtx.fillStyle = this._createGradient(tmpCtx);
                                    tmpCtx.fill();
                                    pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                                    var domMatrix = new DOMMatrix(inverse);
                                    try {
                                        pattern.setTransform(domMatrix);
                                    } catch (ex) {
                                        (0, _util.warn)("RadialAxialShadingPattern.getPattern: \"".concat(ex === null || ex === void 0 ? void 0 : ex.message, "\"."));
                                    }
                                } else {
                                    applyBoundingBox(ctx, this._bbox);
                                    pattern = this._createGradient(ctx);
                                }
                                return pattern;
                            }
                        }
                    ]);
                    return RadialAxialShadingPattern;
                }(BaseShadingPattern);
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    var coords = context.coords, colors = context.colors;
                    var bytes = data.data, rowSize = data.width * 4;
                    var tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    var c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    var c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    var c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    var minY = Math.round(y1), maxY = Math.round(y3);
                    var xa, car, cag, cab;
                    var xb, cbr, cbg, cbb;
                    for(var y = minY; y <= maxY; y++){
                        if (y < y2) {
                            var _k = void 0;
                            if (y < y1) _k = 0;
                            else _k = (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * _k;
                            car = c1r - (c1r - c2r) * _k;
                            cag = c1g - (c1g - c2g) * _k;
                            cab = c1b - (c1b - c2b) * _k;
                        } else {
                            var _k2 = void 0;
                            if (y > y3) _k2 = 1;
                            else if (y2 === y3) _k2 = 0;
                            else _k2 = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * _k2;
                            car = c2r - (c2r - c3r) * _k2;
                            cag = c2g - (c2g - c3g) * _k2;
                            cab = c2b - (c2b - c3b) * _k2;
                        }
                        var k = void 0;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        var x1_ = Math.round(Math.min(xa, xb));
                        var x2_ = Math.round(Math.max(xa, xb));
                        var j = rowSize * y + x1_ * 4;
                        for(var x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    var ps = figure.coords;
                    var cs = figure.colors;
                    var i, ii;
                    switch(figure.type){
                        case "lattice":
                            var verticesPerRow = figure.verticesPerRow;
                            var rows = Math.floor(ps.length / verticesPerRow) - 1;
                            var cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                var q = i * verticesPerRow;
                                for(var j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                var MeshShadingPattern = /*#__PURE__*/ function(_BaseShadingPattern2) {
                    _inherits(MeshShadingPattern, _BaseShadingPattern2);
                    var _super2 = _createSuper(MeshShadingPattern);
                    function MeshShadingPattern(IR) {
                        var _this2;
                        _classCallCheck(this, MeshShadingPattern);
                        _this2 = _super2.call(this);
                        _this2._coords = IR[2];
                        _this2._colors = IR[3];
                        _this2._figures = IR[4];
                        _this2._bounds = IR[5];
                        _this2._bbox = IR[7];
                        _this2._background = IR[8];
                        _this2.matrix = null;
                        return _this2;
                    }
                    _createClass(MeshShadingPattern, [
                        {
                            key: "_createMeshCanvas",
                            value: function _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                                var EXPECTED_SCALE = 1.1;
                                var MAX_PATTERN_SIZE = 3000;
                                var BORDER_SIZE = 2;
                                var offsetX = Math.floor(this._bounds[0]);
                                var offsetY = Math.floor(this._bounds[1]);
                                var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                                var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                                var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                                var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                                var scaleX = boundsWidth / width;
                                var scaleY = boundsHeight / height;
                                var context = {
                                    coords: this._coords,
                                    colors: this._colors,
                                    offsetX: -offsetX,
                                    offsetY: -offsetY,
                                    scaleX: 1 / scaleX,
                                    scaleY: 1 / scaleY
                                };
                                var paddedWidth = width + BORDER_SIZE * 2;
                                var paddedHeight = height + BORDER_SIZE * 2;
                                var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                                var tmpCtx = tmpCanvas.context;
                                var data = tmpCtx.createImageData(width, height);
                                if (backgroundColor) {
                                    var bytes = data.data;
                                    for(var i = 0, ii = bytes.length; i < ii; i += 4){
                                        bytes[i] = backgroundColor[0];
                                        bytes[i + 1] = backgroundColor[1];
                                        bytes[i + 2] = backgroundColor[2];
                                        bytes[i + 3] = 255;
                                    }
                                }
                                var _iterator2 = _createForOfIteratorHelper(this._figures), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var figure = _step2.value;
                                        drawFigure(data, figure, context);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                                var canvas = tmpCanvas.canvas;
                                return {
                                    canvas: canvas,
                                    offsetX: offsetX - BORDER_SIZE * scaleX,
                                    offsetY: offsetY - BORDER_SIZE * scaleY,
                                    scaleX: scaleX,
                                    scaleY: scaleY
                                };
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                applyBoundingBox(ctx, this._bbox);
                                var scale;
                                if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
                                else {
                                    scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                                    if (this.matrix) {
                                        var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                        scale = [
                                            scale[0] * matrixScale[0],
                                            scale[1] * matrixScale[1]
                                        ];
                                    }
                                }
                                var temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                                if (pathType !== PathType.SHADING) {
                                    ctx.setTransform.apply(ctx, owner.baseTransform);
                                    if (this.matrix) ctx.transform.apply(ctx, this.matrix);
                                }
                                ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                                ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                                return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                            }
                        }
                    ]);
                    return MeshShadingPattern;
                }(BaseShadingPattern);
                var DummyShadingPattern = /*#__PURE__*/ function(_BaseShadingPattern3) {
                    _inherits(DummyShadingPattern, _BaseShadingPattern3);
                    var _super3 = _createSuper(DummyShadingPattern);
                    function DummyShadingPattern() {
                        _classCallCheck(this, DummyShadingPattern);
                        return _super3.apply(this, arguments);
                    }
                    _createClass(DummyShadingPattern, [
                        {
                            key: "getPattern",
                            value: function getPattern() {
                                return "hotpink";
                            }
                        }
                    ]);
                    return DummyShadingPattern;
                }(BaseShadingPattern);
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error("Unknown IR type: ".concat(IR[0]));
                }
                var PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                var TilingPattern = /*#__PURE__*/ function() {
                    function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
                        _classCallCheck(this, TilingPattern);
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    _createClass(TilingPattern, [
                        {
                            key: "createPatternCanvas",
                            value: function createPatternCanvas(owner) {
                                var operatorList = this.operatorList;
                                var bbox = this.bbox;
                                var xstep = this.xstep;
                                var ystep = this.ystep;
                                var paintType = this.paintType;
                                var tilingType = this.tilingType;
                                var color = this.color;
                                var canvasGraphicsFactory = this.canvasGraphicsFactory;
                                (0, _util.info)("TilingType: " + tilingType);
                                var x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                                var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                                var combinedScale = [
                                    matrixScale[0] * curMatrixScale[0],
                                    matrixScale[1] * curMatrixScale[1]
                                ];
                                var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                                var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                                var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                                var tmpCtx = tmpCanvas.context;
                                var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                                graphics.groupLevel = owner.groupLevel;
                                this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                                var adjustedX0 = x0;
                                var adjustedY0 = y0;
                                var adjustedX1 = x1;
                                var adjustedY1 = y1;
                                if (x0 < 0) {
                                    adjustedX0 = 0;
                                    adjustedX1 += Math.abs(x0);
                                }
                                if (y0 < 0) {
                                    adjustedY0 = 0;
                                    adjustedY1 += Math.abs(y0);
                                }
                                tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                                graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                                this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                                graphics.baseTransform = graphics.ctx.mozCurrentTransform.slice();
                                graphics.executeOperatorList(operatorList);
                                graphics.endDrawing();
                                return {
                                    canvas: tmpCanvas.canvas,
                                    scaleX: dimx.scale,
                                    scaleY: dimy.scale,
                                    offsetX: adjustedX0,
                                    offsetY: adjustedY0
                                };
                            }
                        },
                        {
                            key: "getSizeAndScale",
                            value: function getSizeAndScale(step, realOutputSize, scale) {
                                step = Math.abs(step);
                                var maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                                var size = Math.ceil(step * scale);
                                if (size >= maxSize) size = maxSize;
                                else scale = size / step;
                                return {
                                    scale: scale,
                                    size: size
                                };
                            }
                        },
                        {
                            key: "clipBbox",
                            value: function clipBbox(graphics, x0, y0, x1, y1) {
                                var bboxWidth = x1 - x0;
                                var bboxHeight = y1 - y0;
                                graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                                graphics.clip();
                                graphics.endPath();
                            }
                        },
                        {
                            key: "setFillAndStrokeStyleToContext",
                            value: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
                                var context = graphics.ctx, current = graphics.current;
                                switch(paintType){
                                    case PaintType.COLORED:
                                        var ctx = this.ctx;
                                        context.fillStyle = ctx.fillStyle;
                                        context.strokeStyle = ctx.strokeStyle;
                                        current.fillColor = ctx.fillStyle;
                                        current.strokeColor = ctx.strokeStyle;
                                        break;
                                    case PaintType.UNCOLORED:
                                        var cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                        context.fillStyle = cssColor;
                                        context.strokeStyle = cssColor;
                                        current.fillColor = cssColor;
                                        current.strokeColor = cssColor;
                                        break;
                                    default:
                                        throw new _util.FormatError("Unsupported paint type: ".concat(paintType));
                                }
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                var matrix = inverse;
                                if (pathType !== PathType.SHADING) {
                                    matrix = _util.Util.transform(matrix, owner.baseTransform);
                                    if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                                }
                                var temporaryPatternCanvas = this.createPatternCanvas(owner);
                                var domMatrix = new DOMMatrix(matrix);
                                domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                                domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                                var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                                try {
                                    pattern.setTransform(domMatrix);
                                } catch (ex) {
                                    (0, _util.warn)("TilingPattern.getPattern: \"".concat(ex === null || ex === void 0 ? void 0 : ex.message, "\"."));
                                }
                                return pattern;
                            }
                        }
                    ], [
                        {
                            key: "MAX_PATTERN_SIZE",
                            get: function get() {
                                return (0, _util.shadow)(this, "MAX_PATTERN_SIZE", 3000);
                            }
                        }
                    ]);
                    return TilingPattern;
                }();
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 142 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                var GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === undefined ? null : GlobalWorkerOptions.workerPort;
                GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === undefined ? "" : GlobalWorkerOptions.workerSrc;
            /***/ },
            /* 143 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                var StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || _typeof(reason) === "object" && reason !== null)) {
                        (0, _util.warn)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                        return reason;
                    }
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                var MessageHandler = /*#__PURE__*/ function() {
                    function MessageHandler(sourceName, targetName, comObj) {
                        var _this = this;
                        _classCallCheck(this, MessageHandler);
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = function(event) {
                            var data = event.data;
                            if (data.targetName !== _this.sourceName) return;
                            if (data.stream) {
                                _this._processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                var callbackId = data.callbackId;
                                var capability = _this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error("Cannot resolve callback ".concat(callbackId));
                                delete _this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            var action = _this.actionHandler[data.action];
                            if (!action) throw new Error("Unknown action from worker: ".concat(data.action));
                            if (data.callbackId) {
                                var cbSourceName = _this.sourceName;
                                var cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                _this._createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    _createClass(MessageHandler, [
                        {
                            key: "on",
                            value: function on(actionName, handler) {
                                var ah = this.actionHandler;
                                if (ah[actionName]) throw new Error("There is already an actionName called \"".concat(actionName, "\""));
                                ah[actionName] = handler;
                            }
                        },
                        {
                            key: "send",
                            value: function send(actionName, data, transfers) {
                                this.comObj.postMessage({
                                    sourceName: this.sourceName,
                                    targetName: this.targetName,
                                    action: actionName,
                                    data: data
                                }, transfers);
                            }
                        },
                        {
                            key: "sendWithPromise",
                            value: function sendWithPromise(actionName, data, transfers) {
                                var callbackId = this.callbackId++;
                                var capability = (0, _util.createPromiseCapability)();
                                this.callbackCapabilities[callbackId] = capability;
                                try {
                                    this.comObj.postMessage({
                                        sourceName: this.sourceName,
                                        targetName: this.targetName,
                                        action: actionName,
                                        callbackId: callbackId,
                                        data: data
                                    }, transfers);
                                } catch (ex) {
                                    capability.reject(ex);
                                }
                                return capability.promise;
                            }
                        },
                        {
                            key: "sendWithStream",
                            value: function sendWithStream(actionName, data, queueingStrategy, transfers) {
                                var _this2 = this;
                                var streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                                return new ReadableStream({
                                    start: function start(controller) {
                                        var startCapability = (0, _util.createPromiseCapability)();
                                        _this2.streamControllers[streamId] = {
                                            controller: controller,
                                            startCall: startCapability,
                                            pullCall: null,
                                            cancelCall: null,
                                            isClosed: false
                                        };
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            action: actionName,
                                            streamId: streamId,
                                            data: data,
                                            desiredSize: controller.desiredSize
                                        }, transfers);
                                        return startCapability.promise;
                                    },
                                    pull: function pull(controller) {
                                        var pullCapability = (0, _util.createPromiseCapability)();
                                        _this2.streamControllers[streamId].pullCall = pullCapability;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.PULL,
                                            streamId: streamId,
                                            desiredSize: controller.desiredSize
                                        });
                                        return pullCapability.promise;
                                    },
                                    cancel: function cancel(reason) {
                                        (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                        var cancelCapability = (0, _util.createPromiseCapability)();
                                        _this2.streamControllers[streamId].cancelCall = cancelCapability;
                                        _this2.streamControllers[streamId].isClosed = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.CANCEL,
                                            streamId: streamId,
                                            reason: wrapReason(reason)
                                        });
                                        return cancelCapability.promise;
                                    }
                                }, queueingStrategy);
                            }
                        },
                        {
                            key: "_createStreamSink",
                            value: function _createStreamSink(data) {
                                var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                                var self1 = this, action = this.actionHandler[data.action];
                                var streamSink = {
                                    enqueue: function enqueue(chunk) {
                                        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                                        var transfers = arguments.length > 2 ? arguments[2] : undefined;
                                        if (this.isCancelled) return;
                                        var lastDesiredSize = this.desiredSize;
                                        this.desiredSize -= size;
                                        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                            this.sinkCapability = (0, _util.createPromiseCapability)();
                                            this.ready = this.sinkCapability.promise;
                                        }
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.ENQUEUE,
                                            streamId: streamId,
                                            chunk: chunk
                                        }, transfers);
                                    },
                                    close: function close() {
                                        if (this.isCancelled) return;
                                        this.isCancelled = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.CLOSE,
                                            streamId: streamId
                                        });
                                        delete self1.streamSinks[streamId];
                                    },
                                    error: function error(reason) {
                                        (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                        if (this.isCancelled) return;
                                        this.isCancelled = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.ERROR,
                                            streamId: streamId,
                                            reason: wrapReason(reason)
                                        });
                                    },
                                    sinkCapability: (0, _util.createPromiseCapability)(),
                                    onPull: null,
                                    onCancel: null,
                                    isCancelled: false,
                                    desiredSize: data.desiredSize,
                                    ready: null
                                };
                                streamSink.sinkCapability.resolve();
                                streamSink.ready = streamSink.sinkCapability.promise;
                                this.streamSinks[streamId] = streamSink;
                                new Promise(function(resolve) {
                                    resolve(action(data.data, streamSink));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.START_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.START_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                            }
                        },
                        {
                            key: "_processStreamMessage",
                            value: function _processStreamMessage(data) {
                                var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                                var streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                                switch(data.stream){
                                    case StreamKind.START_COMPLETE:
                                        if (data.success) streamController.startCall.resolve();
                                        else streamController.startCall.reject(wrapReason(data.reason));
                                        break;
                                    case StreamKind.PULL_COMPLETE:
                                        if (data.success) streamController.pullCall.resolve();
                                        else streamController.pullCall.reject(wrapReason(data.reason));
                                        break;
                                    case StreamKind.PULL:
                                        if (!streamSink) {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.PULL_COMPLETE,
                                                streamId: streamId,
                                                success: true
                                            });
                                            break;
                                        }
                                        if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                        streamSink.desiredSize = data.desiredSize;
                                        new Promise(function(resolve) {
                                            resolve(streamSink.onPull && streamSink.onPull());
                                        }).then(function() {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.PULL_COMPLETE,
                                                streamId: streamId,
                                                success: true
                                            });
                                        }, function(reason) {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.PULL_COMPLETE,
                                                streamId: streamId,
                                                reason: wrapReason(reason)
                                            });
                                        });
                                        break;
                                    case StreamKind.ENQUEUE:
                                        (0, _util.assert)(streamController, "enqueue should have stream controller");
                                        if (streamController.isClosed) break;
                                        streamController.controller.enqueue(data.chunk);
                                        break;
                                    case StreamKind.CLOSE:
                                        (0, _util.assert)(streamController, "close should have stream controller");
                                        if (streamController.isClosed) break;
                                        streamController.isClosed = true;
                                        streamController.controller.close();
                                        this._deleteStreamController(streamController, streamId);
                                        break;
                                    case StreamKind.ERROR:
                                        (0, _util.assert)(streamController, "error should have stream controller");
                                        streamController.controller.error(wrapReason(data.reason));
                                        this._deleteStreamController(streamController, streamId);
                                        break;
                                    case StreamKind.CANCEL_COMPLETE:
                                        if (data.success) streamController.cancelCall.resolve();
                                        else streamController.cancelCall.reject(wrapReason(data.reason));
                                        this._deleteStreamController(streamController, streamId);
                                        break;
                                    case StreamKind.CANCEL:
                                        if (!streamSink) break;
                                        new Promise(function(resolve) {
                                            resolve(streamSink.onCancel && streamSink.onCancel(wrapReason(data.reason)));
                                        }).then(function() {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.CANCEL_COMPLETE,
                                                streamId: streamId,
                                                success: true
                                            });
                                        }, function(reason) {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.CANCEL_COMPLETE,
                                                streamId: streamId,
                                                reason: wrapReason(reason)
                                            });
                                        });
                                        streamSink.sinkCapability.reject(wrapReason(data.reason));
                                        streamSink.isCancelled = true;
                                        delete this.streamSinks[streamId];
                                        break;
                                    default:
                                        throw new Error("Unexpected stream case");
                                }
                            }
                        },
                        {
                            key: "_deleteStreamController",
                            value: function() {
                                var _deleteStreamController2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(streamController, streamId) {
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                _context.next = 2;
                                                return Promise.allSettled([
                                                    streamController.startCall && streamController.startCall.promise,
                                                    streamController.pullCall && streamController.pullCall.promise,
                                                    streamController.cancelCall && streamController.cancelCall.promise
                                                ]);
                                            case 2:
                                                delete this.streamControllers[streamId];
                                            case 3:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function _deleteStreamController(_x, _x2) {
                                    return _deleteStreamController2.apply(this, arguments);
                                }
                                return _deleteStreamController;
                            }()
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.comObj.removeEventListener("message", this._onComObjOnMessage);
                            }
                        }
                    ]);
                    return MessageHandler;
                }();
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 144 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(4);
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _classPrivateFieldInitSpec(obj, privateMap, value) {
                    _checkPrivateRedeclaration(obj, privateMap);
                    privateMap.set(obj, value);
                }
                function _checkPrivateRedeclaration(obj, privateCollection) {
                    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function _classPrivateFieldGet(receiver, privateMap) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
                    return _classApplyDescriptorGet(receiver, descriptor);
                }
                function _classApplyDescriptorGet(receiver, descriptor) {
                    if (descriptor.get) return descriptor.get.call(receiver);
                    return descriptor.value;
                }
                function _classPrivateFieldSet(receiver, privateMap, value) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
                    _classApplyDescriptorSet(receiver, descriptor, value);
                    return value;
                }
                function _classExtractFieldDescriptor(receiver, privateMap, action) {
                    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
                    return privateMap.get(receiver);
                }
                function _classApplyDescriptorSet(receiver, descriptor, value) {
                    if (descriptor.set) descriptor.set.call(receiver, value);
                    else {
                        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
                        descriptor.value = value;
                    }
                }
                var _metadataMap = /*#__PURE__*/ new WeakMap();
                var _data = /*#__PURE__*/ new WeakMap();
                var Metadata = /*#__PURE__*/ function() {
                    function Metadata(_ref) {
                        var parsedData = _ref.parsedData, rawData = _ref.rawData;
                        _classCallCheck(this, Metadata);
                        _classPrivateFieldInitSpec(this, _metadataMap, {
                            writable: true,
                            value: void 0
                        });
                        _classPrivateFieldInitSpec(this, _data, {
                            writable: true,
                            value: void 0
                        });
                        _classPrivateFieldSet(this, _metadataMap, parsedData);
                        _classPrivateFieldSet(this, _data, rawData);
                    }
                    _createClass(Metadata, [
                        {
                            key: "getRaw",
                            value: function getRaw() {
                                return _classPrivateFieldGet(this, _data);
                            }
                        },
                        {
                            key: "get",
                            value: function get(name) {
                                var _classPrivateFieldGet2;
                                return (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _metadataMap).get(name)) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : null;
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll() {
                                return (0, _util.objectFromMap)(_classPrivateFieldGet(this, _metadataMap));
                            }
                        },
                        {
                            key: "has",
                            value: function has(name) {
                                return _classPrivateFieldGet(this, _metadataMap).has(name);
                            }
                        }
                    ]);
                    return Metadata;
                }();
                exports.Metadata = Metadata;
            /***/ },
            /* 145 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(4);
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var OptionalContentGroup = function OptionalContentGroup(name, intent) {
                    _classCallCheck(this, OptionalContentGroup);
                    this.visible = true;
                    this.name = name;
                    this.intent = intent;
                };
                var OptionalContentConfig = /*#__PURE__*/ function() {
                    function OptionalContentConfig(data) {
                        _classCallCheck(this, OptionalContentConfig);
                        this.name = null;
                        this.creator = null;
                        this._order = null;
                        this._groups = new Map();
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this._order = data.order;
                        var _iterator = _createForOfIteratorHelper(data.groups), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var _group = _step.value;
                                this._groups.set(_group.id, new OptionalContentGroup(_group.name, _group.intent));
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        if (data.baseState === "OFF") {
                            var _iterator2 = _createForOfIteratorHelper(this._groups), _step2;
                            try {
                                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                    var group = _step2.value;
                                    group.visible = false;
                                }
                            } catch (err) {
                                _iterator2.e(err);
                            } finally{
                                _iterator2.f();
                            }
                        }
                        var _iterator3 = _createForOfIteratorHelper(data.on), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var on = _step3.value;
                                this._groups.get(on).visible = true;
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                        var _iterator4 = _createForOfIteratorHelper(data.off), _step4;
                        try {
                            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                var off = _step4.value;
                                this._groups.get(off).visible = false;
                            }
                        } catch (err) {
                            _iterator4.e(err);
                        } finally{
                            _iterator4.f();
                        }
                    }
                    _createClass(OptionalContentConfig, [
                        {
                            key: "_evaluateVisibilityExpression",
                            value: function _evaluateVisibilityExpression(array) {
                                var length = array.length;
                                if (length < 2) return true;
                                var operator = array[0];
                                for(var i = 1; i < length; i++){
                                    var element = array[i];
                                    var state = void 0;
                                    if (Array.isArray(element)) state = this._evaluateVisibilityExpression(element);
                                    else if (this._groups.has(element)) state = this._groups.get(element).visible;
                                    else {
                                        (0, _util.warn)("Optional content group not found: ".concat(element));
                                        return true;
                                    }
                                    switch(operator){
                                        case "And":
                                            if (!state) return false;
                                            break;
                                        case "Or":
                                            if (state) return true;
                                            break;
                                        case "Not":
                                            return !state;
                                        default:
                                            return true;
                                    }
                                }
                                return operator === "And";
                            }
                        },
                        {
                            key: "isVisible",
                            value: function isVisible(group) {
                                if (this._groups.size === 0) return true;
                                if (!group) {
                                    (0, _util.warn)("Optional content group not defined.");
                                    return true;
                                }
                                if (group.type === "OCG") {
                                    if (!this._groups.has(group.id)) {
                                        (0, _util.warn)("Optional content group not found: ".concat(group.id));
                                        return true;
                                    }
                                    return this._groups.get(group.id).visible;
                                } else if (group.type === "OCMD") {
                                    if (group.expression) return this._evaluateVisibilityExpression(group.expression);
                                    if (!group.policy || group.policy === "AnyOn") {
                                        var _iterator5 = _createForOfIteratorHelper(group.ids), _step5;
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                var id = _step5.value;
                                                if (!this._groups.has(id)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(id));
                                                    return true;
                                                }
                                                if (this._groups.get(id).visible) return true;
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        return false;
                                    } else if (group.policy === "AllOn") {
                                        var _iterator6 = _createForOfIteratorHelper(group.ids), _step6;
                                        try {
                                            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                                var _id = _step6.value;
                                                if (!this._groups.has(_id)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(_id));
                                                    return true;
                                                }
                                                if (!this._groups.get(_id).visible) return false;
                                            }
                                        } catch (err) {
                                            _iterator6.e(err);
                                        } finally{
                                            _iterator6.f();
                                        }
                                        return true;
                                    } else if (group.policy === "AnyOff") {
                                        var _iterator7 = _createForOfIteratorHelper(group.ids), _step7;
                                        try {
                                            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                                var _id2 = _step7.value;
                                                if (!this._groups.has(_id2)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(_id2));
                                                    return true;
                                                }
                                                if (!this._groups.get(_id2).visible) return true;
                                            }
                                        } catch (err) {
                                            _iterator7.e(err);
                                        } finally{
                                            _iterator7.f();
                                        }
                                        return false;
                                    } else if (group.policy === "AllOff") {
                                        var _iterator8 = _createForOfIteratorHelper(group.ids), _step8;
                                        try {
                                            for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                                var _id3 = _step8.value;
                                                if (!this._groups.has(_id3)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(_id3));
                                                    return true;
                                                }
                                                if (this._groups.get(_id3).visible) return false;
                                            }
                                        } catch (err) {
                                            _iterator8.e(err);
                                        } finally{
                                            _iterator8.f();
                                        }
                                        return true;
                                    }
                                    (0, _util.warn)("Unknown optional content policy ".concat(group.policy, "."));
                                    return true;
                                }
                                (0, _util.warn)("Unknown group type ".concat(group.type, "."));
                                return true;
                            }
                        },
                        {
                            key: "setVisibility",
                            value: function setVisibility(id) {
                                var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                                if (!this._groups.has(id)) {
                                    (0, _util.warn)("Optional content group not found: ".concat(id));
                                    return;
                                }
                                this._groups.get(id).visible = !!visible;
                            }
                        },
                        {
                            key: "getOrder",
                            value: function getOrder() {
                                if (!this._groups.size) return null;
                                if (this._order) return this._order.slice();
                                return Array.from(this._groups.keys());
                            }
                        },
                        {
                            key: "getGroups",
                            value: function getGroups() {
                                return this._groups.size > 0 ? (0, _util.objectFromMap)(this._groups) : null;
                            }
                        },
                        {
                            key: "getGroup",
                            value: function getGroup(id) {
                                return this._groups.get(id) || null;
                            }
                        }
                    ]);
                    return OptionalContentConfig;
                }();
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 146 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PDFDataTransportStream = /*#__PURE__*/ function() {
                    function PDFDataTransportStream(params, pdfDataRangeTransport) {
                        var _this = this;
                        _classCallCheck(this, PDFDataTransportStream);
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = params.progressiveDone || false;
                        this._contentDispositionFilename = params.contentDispositionFilename || null;
                        var initialData = params.initialData;
                        if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
                            var buffer = new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !params.disableStream;
                        this._isRangeSupported = !params.disableRange;
                        this._contentLength = params.length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener(function(begin, chunk) {
                            _this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener(function(loaded, total) {
                            _this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener(function(chunk) {
                            _this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(function() {
                            _this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _createClass(PDFDataTransportStream, [
                        {
                            key: "_onReceiveData",
                            value: function _onReceiveData(args) {
                                var buffer = new Uint8Array(args.chunk).buffer;
                                if (args.begin === undefined) {
                                    if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                                    else this._queuedChunks.push(buffer);
                                } else {
                                    var found = this._rangeReaders.some(function(rangeReader) {
                                        if (rangeReader._begin !== args.begin) return false;
                                        rangeReader._enqueue(buffer);
                                        return true;
                                    });
                                    (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                                }
                            }
                        },
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this$_fullRequestRea, _this$_fullRequestRea2;
                                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                if (evt.total === undefined) {
                                    var firstReader = this._rangeReaders[0];
                                    if (firstReader !== null && firstReader !== void 0 && firstReader.onProgress) firstReader.onProgress({
                                        loaded: evt.loaded
                                    });
                                } else {
                                    var fullReader = this._fullRequestReader;
                                    if (fullReader !== null && fullReader !== void 0 && fullReader.onProgress) fullReader.onProgress({
                                        loaded: evt.loaded,
                                        total: evt.total
                                    });
                                }
                            }
                        },
                        {
                            key: "_onProgressiveDone",
                            value: function _onProgressiveDone() {
                                if (this._fullRequestReader) this._fullRequestReader.progressiveDone();
                                this._progressiveDone = true;
                            }
                        },
                        {
                            key: "_removeRangeReader",
                            value: function _removeRangeReader(reader) {
                                var i = this._rangeReaders.indexOf(reader);
                                if (i >= 0) this._rangeReaders.splice(i, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                                var queuedChunks = this._queuedChunks;
                                this._queuedChunks = null;
                                return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                                this._pdfDataRangeTransport.requestDataRange(begin, end);
                                this._rangeReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                this._pdfDataRangeTransport.abort();
                            }
                        }
                    ]);
                    return PDFDataTransportStream;
                }();
                exports.PDFDataTransportStream = PDFDataTransportStream;
                var PDFDataTransportStreamReader = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamReader(stream, queuedChunks) {
                        var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck(this, PDFDataTransportStreamReader);
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        var _iterator2 = _createForOfIteratorHelper(this._queuedChunks), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var chunk = _step2.value;
                                this._loaded += chunk.byteLength;
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _createClass(PDFDataTransportStreamReader, [
                        {
                            key: "_enqueue",
                            value: function _enqueue(chunk) {
                                if (this._done) return;
                                if (this._requests.length > 0) {
                                    var requestCapability = this._requests.shift();
                                    requestCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                } else this._queuedChunks.push(chunk);
                                this._loaded += chunk.byteLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersReady;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._stream._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._stream._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._stream._contentLength;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                if (!(this._queuedChunks.length > 0)) {
                                                    _context.next = 3;
                                                    break;
                                                }
                                                chunk = this._queuedChunks.shift();
                                                return _context.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 3:
                                                if (!this._done) {
                                                    _context.next = 5;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 5:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context.abrupt("return", requestCapability.promise);
                                            case 8:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iterator3 = _createForOfIteratorHelper(this._requests), _step3;
                                try {
                                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                        var requestCapability = _step3.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator3.e(err);
                                } finally{
                                    _iterator3.f();
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "progressiveDone",
                            value: function progressiveDone() {
                                if (this._done) return;
                                this._done = true;
                            }
                        }
                    ]);
                    return PDFDataTransportStreamReader;
                }();
                var PDFDataTransportStreamRangeReader = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamRangeReader(stream, begin, end) {
                        _classCallCheck(this, PDFDataTransportStreamRangeReader);
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _createClass(PDFDataTransportStreamRangeReader, [
                        {
                            key: "_enqueue",
                            value: function _enqueue(chunk) {
                                if (this._done) return;
                                if (this._requests.length === 0) this._queuedChunk = chunk;
                                else {
                                    var requestsCapability = this._requests.shift();
                                    requestsCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                    var _iterator4 = _createForOfIteratorHelper(this._requests), _step4;
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            var requestCapability = _step4.value;
                                            requestCapability.resolve({
                                                value: undefined,
                                                done: true
                                            });
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                    this._requests.length = 0;
                                }
                                this._done = true;
                                this._stream._removeRangeReader(this);
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                if (!this._queuedChunk) {
                                                    _context2.next = 4;
                                                    break;
                                                }
                                                chunk = this._queuedChunk;
                                                this._queuedChunk = null;
                                                return _context2.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 4:
                                                if (!this._done) {
                                                    _context2.next = 6;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 6:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context2.abrupt("return", requestCapability.promise);
                                            case 9:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iterator5 = _createForOfIteratorHelper(this._requests), _step5;
                                try {
                                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                        var requestCapability = _step5.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator5.e(err);
                                } finally{
                                    _iterator5.f();
                                }
                                this._requests.length = 0;
                                this._stream._removeRangeReader(this);
                            }
                        }
                    ]);
                    return PDFDataTransportStreamRangeReader;
                }();
            /***/ },
            /* 147 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var XfaText = /*#__PURE__*/ function() {
                    function XfaText() {
                        _classCallCheck(this, XfaText);
                    }
                    _createClass(XfaText, null, [
                        {
                            key: "textContent",
                            value: function textContent(xfa) {
                                var items = [];
                                var output = {
                                    items: items,
                                    styles: Object.create(null)
                                };
                                function walk(node) {
                                    var _node$attributes;
                                    if (!node) return;
                                    var str = null;
                                    var name = node.name;
                                    if (name === "#text") str = node.value;
                                    else if (!XfaText.shouldBuildText(name)) return;
                                    else if (node !== null && node !== void 0 && (_node$attributes = node.attributes) !== null && _node$attributes !== void 0 && _node$attributes.textContent) str = node.attributes.textContent;
                                    else if (node.value) str = node.value;
                                    if (str !== null) items.push({
                                        str: str
                                    });
                                    if (!node.children) return;
                                    var _iterator = _createForOfIteratorHelper(node.children), _step;
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            var child = _step.value;
                                            walk(child);
                                        }
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                }
                                walk(xfa);
                                return output;
                            }
                        },
                        {
                            key: "shouldBuildText",
                            value: function shouldBuildText(name) {
                                return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                            }
                        }
                    ]);
                    return XfaText;
                }();
                exports.XfaText = XfaText;
            /***/ },
            /* 148 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(139);
                var _scripting_utils = __w_pdfjs_require__(149);
                var _xfa_layer = __w_pdfjs_require__(150);
                function _classStaticPrivateMethodGet(receiver, classConstructor, method) {
                    _classCheckPrivateStaticAccess(receiver, classConstructor);
                    return method;
                }
                function _classCheckPrivateStaticAccess(receiver, classConstructor) {
                    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
                }
                function _get(target, property, receiver) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
                    else _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) return desc.get.call(receiver);
                        return desc.value;
                    };
                    return _get(target, property, receiver || target);
                }
                function _superPropBase(object, property) {
                    while(!Object.prototype.hasOwnProperty.call(object, property)){
                        object = _getPrototypeOf(object);
                        if (object === null) break;
                    }
                    return object;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var DEFAULT_TAB_INDEX = 1000;
                var GetElementsByNameSet = new WeakSet();
                var AnnotationElementFactory = /*#__PURE__*/ function() {
                    function AnnotationElementFactory() {
                        _classCallCheck(this, AnnotationElementFactory);
                    }
                    _createClass(AnnotationElementFactory, null, [
                        {
                            key: "create",
                            value: function create(parameters) {
                                var subtype = parameters.data.annotationType;
                                switch(subtype){
                                    case _util.AnnotationType.LINK:
                                        return new LinkAnnotationElement(parameters);
                                    case _util.AnnotationType.TEXT:
                                        return new TextAnnotationElement(parameters);
                                    case _util.AnnotationType.WIDGET:
                                        var fieldType = parameters.data.fieldType;
                                        switch(fieldType){
                                            case "Tx":
                                                return new TextWidgetAnnotationElement(parameters);
                                            case "Btn":
                                                if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                                else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                                return new PushButtonWidgetAnnotationElement(parameters);
                                            case "Ch":
                                                return new ChoiceWidgetAnnotationElement(parameters);
                                        }
                                        return new WidgetAnnotationElement(parameters);
                                    case _util.AnnotationType.POPUP:
                                        return new PopupAnnotationElement(parameters);
                                    case _util.AnnotationType.FREETEXT:
                                        return new FreeTextAnnotationElement(parameters);
                                    case _util.AnnotationType.LINE:
                                        return new LineAnnotationElement(parameters);
                                    case _util.AnnotationType.SQUARE:
                                        return new SquareAnnotationElement(parameters);
                                    case _util.AnnotationType.CIRCLE:
                                        return new CircleAnnotationElement(parameters);
                                    case _util.AnnotationType.POLYLINE:
                                        return new PolylineAnnotationElement(parameters);
                                    case _util.AnnotationType.CARET:
                                        return new CaretAnnotationElement(parameters);
                                    case _util.AnnotationType.INK:
                                        return new InkAnnotationElement(parameters);
                                    case _util.AnnotationType.POLYGON:
                                        return new PolygonAnnotationElement(parameters);
                                    case _util.AnnotationType.HIGHLIGHT:
                                        return new HighlightAnnotationElement(parameters);
                                    case _util.AnnotationType.UNDERLINE:
                                        return new UnderlineAnnotationElement(parameters);
                                    case _util.AnnotationType.SQUIGGLY:
                                        return new SquigglyAnnotationElement(parameters);
                                    case _util.AnnotationType.STRIKEOUT:
                                        return new StrikeOutAnnotationElement(parameters);
                                    case _util.AnnotationType.STAMP:
                                        return new StampAnnotationElement(parameters);
                                    case _util.AnnotationType.FILEATTACHMENT:
                                        return new FileAttachmentAnnotationElement(parameters);
                                    default:
                                        return new AnnotationElement(parameters);
                                }
                            }
                        }
                    ]);
                    return AnnotationElementFactory;
                }();
                var AnnotationElement = /*#__PURE__*/ function() {
                    function AnnotationElement(parameters) {
                        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$isRenderable = _ref.isRenderable, isRenderable = _ref$isRenderable === void 0 ? false : _ref$isRenderable, _ref$ignoreBorder = _ref.ignoreBorder, ignoreBorder = _ref$ignoreBorder === void 0 ? false : _ref$ignoreBorder, _ref$createQuadrilate = _ref.createQuadrilaterals, createQuadrilaterals = _ref$createQuadrilate === void 0 ? false : _ref$createQuadrilate;
                        _classCallCheck(this, AnnotationElement);
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.page = parameters.page;
                        this.viewport = parameters.viewport;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this._mouseState = parameters.mouseState;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this.quadrilaterals = this._createQuadrilaterals(ignoreBorder);
                    }
                    _createClass(AnnotationElement, [
                        {
                            key: "_createContainer",
                            value: function _createContainer() {
                                var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                var data = this.data, page = this.page, viewport = this.viewport;
                                var container = document.createElement("section");
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                container.setAttribute("data-annotation-id", data.id);
                                var rect = _util.Util.normalizeRect([
                                    data.rect[0],
                                    page.view[3] - data.rect[1] + page.view[1],
                                    data.rect[2],
                                    page.view[3] - data.rect[3] + page.view[1]
                                ]);
                                if (data.hasOwnCanvas) {
                                    var transform = viewport.transform.slice();
                                    var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(transform), _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2), scaleX = _Util$singularValueDe2[0], scaleY = _Util$singularValueDe2[1];
                                    width = Math.ceil(width * scaleX);
                                    height = Math.ceil(height * scaleY);
                                    rect[0] *= scaleX;
                                    rect[1] *= scaleY;
                                    for(var i = 0; i < 4; i++)transform[i] = Math.sign(transform[i]);
                                    container.style.transform = "matrix(".concat(transform.join(","), ")");
                                } else container.style.transform = "matrix(".concat(viewport.transform.join(","), ")");
                                container.style.transformOrigin = "".concat(-rect[0], "px ").concat(-rect[1], "px");
                                if (!ignoreBorder && data.borderStyle.width > 0) {
                                    container.style.borderWidth = "".concat(data.borderStyle.width, "px");
                                    if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
                                        width -= 2 * data.borderStyle.width;
                                        height -= 2 * data.borderStyle.width;
                                    }
                                    var horizontalRadius = data.borderStyle.horizontalCornerRadius;
                                    var verticalRadius = data.borderStyle.verticalCornerRadius;
                                    if (horizontalRadius > 0 || verticalRadius > 0) {
                                        var radius = "".concat(horizontalRadius, "px / ").concat(verticalRadius, "px");
                                        container.style.borderRadius = radius;
                                    }
                                    switch(data.borderStyle.style){
                                        case _util.AnnotationBorderStyleType.SOLID:
                                            container.style.borderStyle = "solid";
                                            break;
                                        case _util.AnnotationBorderStyleType.DASHED:
                                            container.style.borderStyle = "dashed";
                                            break;
                                        case _util.AnnotationBorderStyleType.BEVELED:
                                            (0, _util.warn)("Unimplemented border style: beveled");
                                            break;
                                        case _util.AnnotationBorderStyleType.INSET:
                                            (0, _util.warn)("Unimplemented border style: inset");
                                            break;
                                        case _util.AnnotationBorderStyleType.UNDERLINE:
                                            container.style.borderBottomStyle = "solid";
                                            break;
                                        default:
                                            break;
                                    }
                                    var borderColor = data.borderColor || data.color || null;
                                    if (borderColor) container.style.borderColor = _util.Util.makeHexColor(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
                                    else container.style.borderWidth = 0;
                                }
                                container.style.left = "".concat(rect[0], "px");
                                container.style.top = "".concat(rect[1], "px");
                                if (data.hasOwnCanvas) container.style.width = container.style.height = "auto";
                                else {
                                    container.style.width = "".concat(width, "px");
                                    container.style.height = "".concat(height, "px");
                                }
                                return container;
                            }
                        },
                        {
                            key: "_createQuadrilaterals",
                            value: function _createQuadrilaterals() {
                                var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this.data.quadPoints) return null;
                                var quadrilaterals = [];
                                var savedRect = this.data.rect;
                                var _iterator = _createForOfIteratorHelper(this.data.quadPoints), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var quadPoint = _step.value;
                                        this.data.rect = [
                                            quadPoint[2].x,
                                            quadPoint[2].y,
                                            quadPoint[1].x,
                                            quadPoint[1].y
                                        ];
                                        quadrilaterals.push(this._createContainer(ignoreBorder));
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                this.data.rect = savedRect;
                                return quadrilaterals;
                            }
                        },
                        {
                            key: "_createPopup",
                            value: function _createPopup(trigger, data) {
                                var container = this.container;
                                if (this.quadrilaterals) {
                                    trigger = trigger || this.quadrilaterals;
                                    container = this.quadrilaterals[0];
                                }
                                if (!trigger) {
                                    trigger = document.createElement("div");
                                    trigger.style.height = container.style.height;
                                    trigger.style.width = container.style.width;
                                    container.appendChild(trigger);
                                }
                                var popupElement = new PopupElement({
                                    container: container,
                                    trigger: trigger,
                                    color: data.color,
                                    titleObj: data.titleObj,
                                    modificationDate: data.modificationDate,
                                    contentsObj: data.contentsObj,
                                    richText: data.richText,
                                    hideWrapper: true
                                });
                                var popup = popupElement.render();
                                popup.style.left = container.style.width;
                                container.appendChild(popup);
                            }
                        },
                        {
                            key: "_renderQuadrilaterals",
                            value: function _renderQuadrilaterals(className) {
                                var _iterator2 = _createForOfIteratorHelper(this.quadrilaterals), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var quadrilateral = _step2.value;
                                        quadrilateral.className = className;
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                return this.quadrilaterals;
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                            }
                        },
                        {
                            key: "_getElementsByName",
                            value: function _getElementsByName(name) {
                                var skipId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var fields = [];
                                if (this._fieldObjects) {
                                    var fieldObj = this._fieldObjects[name];
                                    if (fieldObj) {
                                        var _iterator3 = _createForOfIteratorHelper(fieldObj), _step3;
                                        try {
                                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                                var _step3$value = _step3.value, page = _step3$value.page, id = _step3$value.id, exportValues = _step3$value.exportValues;
                                                if (page === -1) continue;
                                                if (id === skipId) continue;
                                                var exportValue = typeof exportValues === "string" ? exportValues : null;
                                                var domElement = document.getElementById(id);
                                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                                    (0, _util.warn)("_getElementsByName - element not allowed: ".concat(id));
                                                    continue;
                                                }
                                                fields.push({
                                                    id: id,
                                                    exportValue: exportValue,
                                                    domElement: domElement
                                                });
                                            }
                                        } catch (err) {
                                            _iterator3.e(err);
                                        } finally{
                                            _iterator3.f();
                                        }
                                    }
                                    return fields;
                                }
                                var _iterator4 = _createForOfIteratorHelper(document.getElementsByName(name)), _step4;
                                try {
                                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                        var _domElement = _step4.value;
                                        var _id = _domElement.id, _exportValue = _domElement.exportValue;
                                        if (_id === skipId) continue;
                                        if (!GetElementsByNameSet.has(_domElement)) continue;
                                        fields.push({
                                            id: _id,
                                            exportValue: _exportValue,
                                            domElement: _domElement
                                        });
                                    }
                                } catch (err) {
                                    _iterator4.e(err);
                                } finally{
                                    _iterator4.f();
                                }
                                return fields;
                            }
                        }
                    ], [
                        {
                            key: "platform",
                            get: function get() {
                                var platform = typeof navigator !== "undefined" ? navigator.platform : "";
                                return (0, _util.shadow)(this, "platform", {
                                    isWin: platform.includes("Win"),
                                    isMac: platform.includes("Mac")
                                });
                            }
                        }
                    ]);
                    return AnnotationElement;
                }();
                var LinkAnnotationElement = /*#__PURE__*/ function(_AnnotationElement) {
                    _inherits(LinkAnnotationElement, _AnnotationElement);
                    var _super = _createSuper(LinkAnnotationElement);
                    function LinkAnnotationElement(parameters) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        _classCallCheck(this, LinkAnnotationElement);
                        var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action || parameters.data.isTooltipOnly || parameters.data.resetForm || parameters.data.actions && (parameters.data.actions.Action || parameters.data.actions["Mouse Up"] || parameters.data.actions["Mouse Down"]));
                        return _super.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: !!(options !== null && options !== void 0 && options.ignoreBorder),
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(LinkAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var data = this.data, linkService = this.linkService;
                                var link = document.createElement("a");
                                if (data.url) {
                                    var _linkService$addLinkA;
                                    if (!linkService.addLinkAttributes) (0, _util.warn)("LinkAnnotationElement.render - missing `addLinkAttributes`-method on the `linkService`-instance.");
                                    (_linkService$addLinkA = linkService.addLinkAttributes) === null || _linkService$addLinkA === void 0 || _linkService$addLinkA.call(linkService, link, data.url, data.newWindow);
                                } else if (data.action) this._bindNamedAction(link, data.action);
                                else if (data.dest) this._bindLink(link, data.dest);
                                else {
                                    var hasClickAction = false;
                                    if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                        hasClickAction = true;
                                        this._bindJSAction(link, data);
                                    }
                                    if (data.resetForm) this._bindResetFormAction(link, data.resetForm);
                                    else if (!hasClickAction) this._bindLink(link, "");
                                }
                                if (this.quadrilaterals) return this._renderQuadrilaterals("linkAnnotation").map(function(quadrilateral, index) {
                                    var linkElement = index === 0 ? link : link.cloneNode();
                                    quadrilateral.appendChild(linkElement);
                                    return quadrilateral;
                                });
                                this.container.className = "linkAnnotation";
                                this.container.appendChild(link);
                                return this.container;
                            }
                        },
                        {
                            key: "_bindLink",
                            value: function _bindLink(link, destination) {
                                var _this = this;
                                link.href = this.linkService.getDestinationHash(destination);
                                link.onclick = function() {
                                    if (destination) _this.linkService.goToDestination(destination);
                                    return false;
                                };
                                if (destination || destination === "") link.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindNamedAction",
                            value: function _bindNamedAction(link, action) {
                                var _this2 = this;
                                link.href = this.linkService.getAnchorUrl("");
                                link.onclick = function() {
                                    _this2.linkService.executeNamedAction(action);
                                    return false;
                                };
                                link.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindJSAction",
                            value: function _bindJSAction(link, data) {
                                var _this3 = this;
                                link.href = this.linkService.getAnchorUrl("");
                                var map = new Map([
                                    [
                                        "Action",
                                        "onclick"
                                    ],
                                    [
                                        "Mouse Up",
                                        "onmouseup"
                                    ],
                                    [
                                        "Mouse Down",
                                        "onmousedown"
                                    ]
                                ]);
                                var _loop = function _loop() {
                                    var name = _Object$keys[_i2];
                                    var jsName = map.get(name);
                                    if (!jsName) return "continue";
                                    link[jsName] = function() {
                                        var _this3$linkService$ev;
                                        (_this3$linkService$ev = _this3.linkService.eventBus) === null || _this3$linkService$ev === void 0 || _this3$linkService$ev.dispatch("dispatcheventinsandbox", {
                                            source: _this3,
                                            detail: {
                                                id: data.id,
                                                name: name
                                            }
                                        });
                                        return false;
                                    };
                                };
                                for(var _i2 = 0, _Object$keys = Object.keys(data.actions); _i2 < _Object$keys.length; _i2++){
                                    var _ret = _loop();
                                    if (_ret === "continue") continue;
                                }
                                if (!link.onclick) link.onclick = function() {
                                    return false;
                                };
                                link.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindResetFormAction",
                            value: function _bindResetFormAction(link, resetForm) {
                                var _this4 = this;
                                var otherClickAction = link.onclick;
                                if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                                link.className = "internalLink";
                                if (!this._fieldObjects) {
                                    (0, _util.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.');
                                    if (!otherClickAction) link.onclick = function() {
                                        return false;
                                    };
                                    return;
                                }
                                link.onclick = function() {
                                    if (otherClickAction) otherClickAction();
                                    var resetFormFields = resetForm.fields, resetFormRefs = resetForm.refs, include = resetForm.include;
                                    var allFields = [];
                                    if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                        var fieldIds = new Set(resetFormRefs);
                                        var _iterator5 = _createForOfIteratorHelper(resetFormFields), _step5;
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                var fieldName = _step5.value;
                                                var _fields = _this4._fieldObjects[fieldName] || [];
                                                var _iterator7 = _createForOfIteratorHelper(_fields), _step7;
                                                try {
                                                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                                        var id = _step7.value.id;
                                                        fieldIds.add(id);
                                                    }
                                                } catch (err) {
                                                    _iterator7.e(err);
                                                } finally{
                                                    _iterator7.f();
                                                }
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        for(var _i3 = 0, _Object$values = Object.values(_this4._fieldObjects); _i3 < _Object$values.length; _i3++){
                                            var fields = _Object$values[_i3];
                                            var _iterator6 = _createForOfIteratorHelper(fields), _step6;
                                            try {
                                                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                                    var field = _step6.value;
                                                    if (fieldIds.has(field.id) === include) allFields.push(field);
                                                }
                                            } catch (err) {
                                                _iterator6.e(err);
                                            } finally{
                                                _iterator6.f();
                                            }
                                        }
                                    } else for(var _i4 = 0, _Object$values2 = Object.values(_this4._fieldObjects); _i4 < _Object$values2.length; _i4++){
                                        var _fields2 = _Object$values2[_i4];
                                        allFields.push.apply(allFields, _toConsumableArray(_fields2));
                                    }
                                    var storage = _this4.annotationStorage;
                                    var allIds = [];
                                    for(var _i5 = 0, _allFields = allFields; _i5 < _allFields.length; _i5++){
                                        var _field = _allFields[_i5];
                                        var _id2 = _field.id;
                                        allIds.push(_id2);
                                        switch(_field.type){
                                            case "text":
                                                var value = _field.defaultValue || "";
                                                storage.setValue(_id2, {
                                                    value: value,
                                                    valueAsString: value
                                                });
                                                break;
                                            case "checkbox":
                                            case "radiobutton":
                                                var _value = _field.defaultValue === _field.exportValues;
                                                storage.setValue(_id2, {
                                                    value: _value
                                                });
                                                break;
                                            case "combobox":
                                            case "listbox":
                                                var _value2 = _field.defaultValue || "";
                                                storage.setValue(_id2, {
                                                    value: _value2
                                                });
                                                break;
                                            default:
                                                continue;
                                        }
                                        var domElement = document.getElementById(_id2);
                                        if (!domElement || !GetElementsByNameSet.has(domElement)) continue;
                                        domElement.dispatchEvent(new Event("resetform"));
                                    }
                                    if (_this4.enableScripting) {
                                        var _this4$linkService$ev;
                                        (_this4$linkService$ev = _this4.linkService.eventBus) === null || _this4$linkService$ev === void 0 || _this4$linkService$ev.dispatch("dispatcheventinsandbox", {
                                            source: _this4,
                                            detail: {
                                                id: "app",
                                                ids: allIds,
                                                name: "ResetForm"
                                            }
                                        });
                                    }
                                    return false;
                                };
                            }
                        }
                    ]);
                    return LinkAnnotationElement;
                }(AnnotationElement);
                var TextAnnotationElement = /*#__PURE__*/ function(_AnnotationElement2) {
                    _inherits(TextAnnotationElement, _AnnotationElement2);
                    var _super2 = _createSuper(TextAnnotationElement);
                    function TextAnnotationElement(parameters) {
                        var _parameters$data$titl, _parameters$data$cont, _parameters$data$rich;
                        _classCallCheck(this, TextAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl = parameters.data.titleObj) !== null && _parameters$data$titl !== void 0 && _parameters$data$titl.str || (_parameters$data$cont = parameters.data.contentsObj) !== null && _parameters$data$cont !== void 0 && _parameters$data$cont.str || (_parameters$data$rich = parameters.data.richText) !== null && _parameters$data$rich !== void 0 && _parameters$data$rich.str);
                        return _super2.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    _createClass(TextAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "textAnnotation";
                                var image = document.createElement("img");
                                image.style.height = this.container.style.height;
                                image.style.width = this.container.style.width;
                                image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                                image.alt = "[{{type}} Annotation]";
                                image.dataset.l10nId = "text_annotation_type";
                                image.dataset.l10nArgs = JSON.stringify({
                                    type: this.data.name
                                });
                                if (!this.data.hasPopup) this._createPopup(image, this.data);
                                this.container.appendChild(image);
                                return this.container;
                            }
                        }
                    ]);
                    return TextAnnotationElement;
                }(AnnotationElement);
                var WidgetAnnotationElement = /*#__PURE__*/ function(_AnnotationElement3) {
                    _inherits(WidgetAnnotationElement, _AnnotationElement3);
                    var _super3 = _createSuper(WidgetAnnotationElement);
                    function WidgetAnnotationElement() {
                        _classCallCheck(this, WidgetAnnotationElement);
                        return _super3.apply(this, arguments);
                    }
                    _createClass(WidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                                return this.container;
                            }
                        },
                        {
                            key: "_getKeyModifier",
                            value: function _getKeyModifier(event) {
                                var _AnnotationElement$pl = AnnotationElement.platform, isWin = _AnnotationElement$pl.isWin, isMac = _AnnotationElement$pl.isMac;
                                return isWin && event.ctrlKey || isMac && event.metaKey;
                            }
                        },
                        {
                            key: "_setEventListener",
                            value: function _setEventListener(element, baseName, eventName, valueGetter) {
                                var _this5 = this;
                                if (baseName.includes("mouse")) element.addEventListener(baseName, function(event) {
                                    var _this5$linkService$ev;
                                    (_this5$linkService$ev = _this5.linkService.eventBus) === null || _this5$linkService$ev === void 0 || _this5$linkService$ev.dispatch("dispatcheventinsandbox", {
                                        source: _this5,
                                        detail: {
                                            id: _this5.data.id,
                                            name: eventName,
                                            value: valueGetter(event),
                                            shift: event.shiftKey,
                                            modifier: _this5._getKeyModifier(event)
                                        }
                                    });
                                });
                                else element.addEventListener(baseName, function(event) {
                                    var _this5$linkService$ev2;
                                    (_this5$linkService$ev2 = _this5.linkService.eventBus) === null || _this5$linkService$ev2 === void 0 || _this5$linkService$ev2.dispatch("dispatcheventinsandbox", {
                                        source: _this5,
                                        detail: {
                                            id: _this5.data.id,
                                            name: eventName,
                                            value: event.target.checked
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "_setEventListeners",
                            value: function _setEventListeners(element, names, getter) {
                                var _iterator8 = _createForOfIteratorHelper(names), _step8;
                                try {
                                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                        var _this$data$actions;
                                        var _step8$value = _slicedToArray(_step8.value, 2), baseName = _step8$value[0], eventName = _step8$value[1];
                                        if (eventName === "Action" || (_this$data$actions = this.data.actions) !== null && _this$data$actions !== void 0 && _this$data$actions[eventName]) this._setEventListener(element, baseName, eventName, getter);
                                    }
                                } catch (err) {
                                    _iterator8.e(err);
                                } finally{
                                    _iterator8.f();
                                }
                            }
                        },
                        {
                            key: "_setBackgroundColor",
                            value: function _setBackgroundColor(element) {
                                var color = this.data.backgroundColor || null;
                                element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                            }
                        },
                        {
                            key: "_dispatchEventFromSandbox",
                            value: function _dispatchEventFromSandbox(actions, jsEvent) {
                                var _this6 = this;
                                var setColor = function setColor(jsName, styleName, event) {
                                    var color = event.detail[jsName];
                                    event.target.style[styleName] = _scripting_utils.ColorConverters["".concat(color[0], "_HTML")](color.slice(1));
                                };
                                var commonActions = {
                                    display: function display(event) {
                                        var hidden = event.detail.display % 2 === 1;
                                        event.target.style.visibility = hidden ? "hidden" : "visible";
                                        _this6.annotationStorage.setValue(_this6.data.id, {
                                            hidden: hidden,
                                            print: event.detail.display === 0 || event.detail.display === 3
                                        });
                                    },
                                    print: function print(event) {
                                        _this6.annotationStorage.setValue(_this6.data.id, {
                                            print: event.detail.print
                                        });
                                    },
                                    hidden: function hidden(event) {
                                        event.target.style.visibility = event.detail.hidden ? "hidden" : "visible";
                                        _this6.annotationStorage.setValue(_this6.data.id, {
                                            hidden: event.detail.hidden
                                        });
                                    },
                                    focus: function focus(event) {
                                        setTimeout(function() {
                                            return event.target.focus({
                                                preventScroll: false
                                            });
                                        }, 0);
                                    },
                                    userName: function userName(event) {
                                        event.target.title = event.detail.userName;
                                    },
                                    readonly: function readonly(event) {
                                        if (event.detail.readonly) event.target.setAttribute("readonly", "");
                                        else event.target.removeAttribute("readonly");
                                    },
                                    required: function required(event) {
                                        if (event.detail.required) event.target.setAttribute("required", "");
                                        else event.target.removeAttribute("required");
                                    },
                                    bgColor: function bgColor(event) {
                                        setColor("bgColor", "backgroundColor", event);
                                    },
                                    fillColor: function fillColor(event) {
                                        setColor("fillColor", "backgroundColor", event);
                                    },
                                    fgColor: function fgColor(event) {
                                        setColor("fgColor", "color", event);
                                    },
                                    textColor: function textColor(event) {
                                        setColor("textColor", "color", event);
                                    },
                                    borderColor: function borderColor(event) {
                                        setColor("borderColor", "borderColor", event);
                                    },
                                    strokeColor: function strokeColor(event) {
                                        setColor("strokeColor", "borderColor", event);
                                    }
                                };
                                for(var _i6 = 0, _Object$keys2 = Object.keys(jsEvent.detail); _i6 < _Object$keys2.length; _i6++){
                                    var name = _Object$keys2[_i6];
                                    var action = actions[name] || commonActions[name];
                                    if (action) action(jsEvent);
                                }
                            }
                        }
                    ]);
                    return WidgetAnnotationElement;
                }(AnnotationElement);
                var TextWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem) {
                    _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
                    var _super4 = _createSuper(TextWidgetAnnotationElement);
                    function TextWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, TextWidgetAnnotationElement);
                        var isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        return _super4.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    _createClass(TextWidgetAnnotationElement, [
                        {
                            key: "setPropertyOnSiblings",
                            value: function setPropertyOnSiblings(base, key, value, keyInStorage) {
                                var storage = this.annotationStorage;
                                var _iterator9 = _createForOfIteratorHelper(this._getElementsByName(base.name, base.id)), _step9;
                                try {
                                    for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                                        var element = _step9.value;
                                        if (element.domElement) element.domElement[key] = value;
                                        storage.setValue(element.id, _defineProperty({}, keyInStorage, value));
                                    }
                                } catch (err) {
                                    _iterator9.e(err);
                                } finally{
                                    _iterator9.f();
                                }
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this7 = this;
                                var storage = this.annotationStorage;
                                var id = this.data.id;
                                this.container.className = "textWidgetAnnotation";
                                var element = null;
                                if (this.renderForms) {
                                    var storedData = storage.getValue(id, {
                                        value: this.data.fieldValue,
                                        valueAsString: this.data.fieldValue
                                    });
                                    var textContent = storedData.valueAsString || storedData.value || "";
                                    var elementData = {
                                        userValue: null,
                                        formattedValue: null,
                                        beforeInputSelectionRange: null,
                                        beforeInputValue: null
                                    };
                                    if (this.data.multiLine) {
                                        element = document.createElement("textarea");
                                        element.textContent = textContent;
                                    } else {
                                        element = document.createElement("input");
                                        element.type = "text";
                                        element.setAttribute("value", textContent);
                                    }
                                    GetElementsByNameSet.add(element);
                                    element.disabled = this.data.readOnly;
                                    element.name = this.data.fieldName;
                                    element.tabIndex = DEFAULT_TAB_INDEX;
                                    elementData.userValue = textContent;
                                    element.setAttribute("id", id);
                                    element.addEventListener("input", function(event) {
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                        _this7.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                    });
                                    element.addEventListener("resetform", function(event) {
                                        var defaultValue = _this7.data.defaultFieldValue || "";
                                        element.value = elementData.userValue = defaultValue;
                                        delete elementData.formattedValue;
                                    });
                                    var blurListener = function blurListener(event) {
                                        if (elementData.formattedValue) event.target.value = elementData.formattedValue;
                                        event.target.scrollLeft = 0;
                                        elementData.beforeInputSelectionRange = null;
                                    };
                                    if (this.enableScripting && this.hasJSActions) {
                                        var _this$data$actions2;
                                        element.addEventListener("focus", function(event) {
                                            if (elementData.userValue) event.target.value = elementData.userValue;
                                        });
                                        element.addEventListener("updatefromsandbox", function(jsEvent) {
                                            var actions = {
                                                value: function value(event) {
                                                    elementData.userValue = event.detail.value || "";
                                                    storage.setValue(id, {
                                                        value: elementData.userValue.toString()
                                                    });
                                                    if (!elementData.formattedValue) event.target.value = elementData.userValue;
                                                },
                                                valueAsString: function valueAsString(event) {
                                                    elementData.formattedValue = event.detail.valueAsString || "";
                                                    if (event.target !== document.activeElement) event.target.value = elementData.formattedValue;
                                                    storage.setValue(id, {
                                                        formattedValue: elementData.formattedValue
                                                    });
                                                },
                                                selRange: function selRange(event) {
                                                    var _event$detail$selRang = _slicedToArray(event.detail.selRange, 2), selStart = _event$detail$selRang[0], selEnd = _event$detail$selRang[1];
                                                    if (selStart >= 0 && selEnd < event.target.value.length) event.target.setSelectionRange(selStart, selEnd);
                                                }
                                            };
                                            _this7._dispatchEventFromSandbox(actions, jsEvent);
                                        });
                                        element.addEventListener("keydown", function(event) {
                                            var _this7$linkService$ev;
                                            elementData.beforeInputValue = event.target.value;
                                            var commitKey = -1;
                                            if (event.key === "Escape") commitKey = 0;
                                            else if (event.key === "Enter") commitKey = 2;
                                            else if (event.key === "Tab") commitKey = 3;
                                            if (commitKey === -1) return;
                                            elementData.userValue = event.target.value;
                                            (_this7$linkService$ev = _this7.linkService.eventBus) === null || _this7$linkService$ev === void 0 || _this7$linkService$ev.dispatch("dispatcheventinsandbox", {
                                                source: _this7,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: event.target.value,
                                                    willCommit: true,
                                                    commitKey: commitKey,
                                                    selStart: event.target.selectionStart,
                                                    selEnd: event.target.selectionEnd
                                                }
                                            });
                                        });
                                        var _blurListener = blurListener;
                                        blurListener = null;
                                        element.addEventListener("blur", function(event) {
                                            if (_this7._mouseState.isDown) {
                                                var _this7$linkService$ev2;
                                                elementData.userValue = event.target.value;
                                                (_this7$linkService$ev2 = _this7.linkService.eventBus) === null || _this7$linkService$ev2 === void 0 || _this7$linkService$ev2.dispatch("dispatcheventinsandbox", {
                                                    source: _this7,
                                                    detail: {
                                                        id: id,
                                                        name: "Keystroke",
                                                        value: event.target.value,
                                                        willCommit: true,
                                                        commitKey: 1,
                                                        selStart: event.target.selectionStart,
                                                        selEnd: event.target.selectionEnd
                                                    }
                                                });
                                            }
                                            _blurListener(event);
                                        });
                                        element.addEventListener("mousedown", function(event) {
                                            elementData.beforeInputValue = event.target.value;
                                            elementData.beforeInputSelectionRange = null;
                                        });
                                        element.addEventListener("keyup", function(event) {
                                            if (event.target.selectionStart === event.target.selectionEnd) elementData.beforeInputSelectionRange = null;
                                        });
                                        element.addEventListener("select", function(event) {
                                            elementData.beforeInputSelectionRange = [
                                                event.target.selectionStart,
                                                event.target.selectionEnd
                                            ];
                                        });
                                        if ((_this$data$actions2 = this.data.actions) !== null && _this$data$actions2 !== void 0 && _this$data$actions2.Keystroke) element.addEventListener("input", function(event) {
                                            var _this7$linkService$ev3;
                                            var selStart = -1;
                                            var selEnd = -1;
                                            if (elementData.beforeInputSelectionRange) {
                                                var _elementData$beforeIn = _slicedToArray(elementData.beforeInputSelectionRange, 2);
                                                selStart = _elementData$beforeIn[0];
                                                selEnd = _elementData$beforeIn[1];
                                            }
                                            (_this7$linkService$ev3 = _this7.linkService.eventBus) === null || _this7$linkService$ev3 === void 0 || _this7$linkService$ev3.dispatch("dispatcheventinsandbox", {
                                                source: _this7,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: elementData.beforeInputValue,
                                                    change: event.data,
                                                    willCommit: false,
                                                    selStart: selStart,
                                                    selEnd: selEnd
                                                }
                                            });
                                        });
                                        this._setEventListeners(element, [
                                            [
                                                "focus",
                                                "Focus"
                                            ],
                                            [
                                                "blur",
                                                "Blur"
                                            ],
                                            [
                                                "mousedown",
                                                "Mouse Down"
                                            ],
                                            [
                                                "mouseenter",
                                                "Mouse Enter"
                                            ],
                                            [
                                                "mouseleave",
                                                "Mouse Exit"
                                            ],
                                            [
                                                "mouseup",
                                                "Mouse Up"
                                            ]
                                        ], function(event) {
                                            return event.target.value;
                                        });
                                    }
                                    if (blurListener) element.addEventListener("blur", blurListener);
                                    if (this.data.maxLen !== null) element.maxLength = this.data.maxLen;
                                    if (this.data.comb) {
                                        var fieldWidth = this.data.rect[2] - this.data.rect[0];
                                        var combWidth = fieldWidth / this.data.maxLen;
                                        element.classList.add("comb");
                                        element.style.letterSpacing = "calc(".concat(combWidth, "px - 1ch)");
                                    }
                                } else {
                                    element = document.createElement("div");
                                    element.textContent = this.data.fieldValue;
                                    element.style.verticalAlign = "middle";
                                    element.style.display = "table-cell";
                                }
                                this._setTextStyle(element);
                                this._setBackgroundColor(element);
                                this.container.appendChild(element);
                                return this.container;
                            }
                        },
                        {
                            key: "_setTextStyle",
                            value: function _setTextStyle(element) {
                                var TEXT_ALIGNMENT = [
                                    "left",
                                    "center",
                                    "right"
                                ];
                                var _this$data$defaultApp = this.data.defaultAppearanceData, fontSize = _this$data$defaultApp.fontSize, fontColor = _this$data$defaultApp.fontColor;
                                var style = element.style;
                                if (fontSize) style.fontSize = "".concat(fontSize, "px");
                                style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                                if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                            }
                        }
                    ]);
                    return TextWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var CheckboxWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem2) {
                    _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
                    var _super5 = _createSuper(CheckboxWidgetAnnotationElement);
                    function CheckboxWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, CheckboxWidgetAnnotationElement);
                        return _super5.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    _createClass(CheckboxWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this8 = this;
                                var storage = this.annotationStorage;
                                var data = this.data;
                                var id = data.id;
                                var value = storage.getValue(id, {
                                    value: data.exportValue === data.fieldValue
                                }).value;
                                if (typeof value === "string") {
                                    value = value !== "Off";
                                    storage.setValue(id, {
                                        value: value
                                    });
                                }
                                this.container.className = "buttonWidgetAnnotation checkBox";
                                var element = document.createElement("input");
                                GetElementsByNameSet.add(element);
                                element.disabled = data.readOnly;
                                element.type = "checkbox";
                                element.name = data.fieldName;
                                if (value) element.setAttribute("checked", true);
                                element.setAttribute("id", id);
                                element.setAttribute("exportValue", data.exportValue);
                                element.tabIndex = DEFAULT_TAB_INDEX;
                                element.addEventListener("change", function(event) {
                                    var _event$target = event.target, name = _event$target.name, checked = _event$target.checked;
                                    var _iterator10 = _createForOfIteratorHelper(_this8._getElementsByName(name, id)), _step10;
                                    try {
                                        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                                            var checkbox = _step10.value;
                                            var curChecked = checked && checkbox.exportValue === data.exportValue;
                                            if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                            storage.setValue(checkbox.id, {
                                                value: curChecked
                                            });
                                        }
                                    } catch (err) {
                                        _iterator10.e(err);
                                    } finally{
                                        _iterator10.f();
                                    }
                                    storage.setValue(id, {
                                        value: checked
                                    });
                                });
                                element.addEventListener("resetform", function(event) {
                                    var defaultValue = data.defaultFieldValue || "Off";
                                    event.target.checked = defaultValue === data.exportValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function value(event) {
                                                event.target.checked = event.detail.value !== "Off";
                                                storage.setValue(id, {
                                                    value: event.target.checked
                                                });
                                            }
                                        };
                                        _this8._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    this._setEventListeners(element, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element);
                                this.container.appendChild(element);
                                return this.container;
                            }
                        }
                    ]);
                    return CheckboxWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var RadioButtonWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem3) {
                    _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
                    var _super6 = _createSuper(RadioButtonWidgetAnnotationElement);
                    function RadioButtonWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, RadioButtonWidgetAnnotationElement);
                        return _super6.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    _createClass(RadioButtonWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this9 = this;
                                this.container.className = "buttonWidgetAnnotation radioButton";
                                var storage = this.annotationStorage;
                                var data = this.data;
                                var id = data.id;
                                var value = storage.getValue(id, {
                                    value: data.fieldValue === data.buttonValue
                                }).value;
                                if (typeof value === "string") {
                                    value = value !== data.buttonValue;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                }
                                var element = document.createElement("input");
                                GetElementsByNameSet.add(element);
                                element.disabled = data.readOnly;
                                element.type = "radio";
                                element.name = data.fieldName;
                                if (value) element.setAttribute("checked", true);
                                element.setAttribute("id", id);
                                element.tabIndex = DEFAULT_TAB_INDEX;
                                element.addEventListener("change", function(event) {
                                    var _event$target2 = event.target, name = _event$target2.name, checked = _event$target2.checked;
                                    var _iterator11 = _createForOfIteratorHelper(_this9._getElementsByName(name, id)), _step11;
                                    try {
                                        for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                            var radio = _step11.value;
                                            storage.setValue(radio.id, {
                                                value: false
                                            });
                                        }
                                    } catch (err) {
                                        _iterator11.e(err);
                                    } finally{
                                        _iterator11.f();
                                    }
                                    storage.setValue(id, {
                                        value: checked
                                    });
                                });
                                element.addEventListener("resetform", function(event) {
                                    var defaultValue = data.defaultFieldValue;
                                    event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    var pdfButtonValue = data.buttonValue;
                                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function value(event) {
                                                var checked = pdfButtonValue === event.detail.value;
                                                var _iterator12 = _createForOfIteratorHelper(_this9._getElementsByName(event.target.name)), _step12;
                                                try {
                                                    for(_iterator12.s(); !(_step12 = _iterator12.n()).done;){
                                                        var radio = _step12.value;
                                                        var curChecked = checked && radio.id === id;
                                                        if (radio.domElement) radio.domElement.checked = curChecked;
                                                        storage.setValue(radio.id, {
                                                            value: curChecked
                                                        });
                                                    }
                                                } catch (err) {
                                                    _iterator12.e(err);
                                                } finally{
                                                    _iterator12.f();
                                                }
                                            }
                                        };
                                        _this9._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    this._setEventListeners(element, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element);
                                this.container.appendChild(element);
                                return this.container;
                            }
                        }
                    ]);
                    return RadioButtonWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var PushButtonWidgetAnnotationElement = /*#__PURE__*/ function(_LinkAnnotationElemen) {
                    _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);
                    var _super7 = _createSuper(PushButtonWidgetAnnotationElement);
                    function PushButtonWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, PushButtonWidgetAnnotationElement);
                        return _super7.call(this, parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    _createClass(PushButtonWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var container = _get(_getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), "render", this).call(this);
                                container.className = "buttonWidgetAnnotation pushButton";
                                if (this.data.alternativeText) container.title = this.data.alternativeText;
                                return container;
                            }
                        }
                    ]);
                    return PushButtonWidgetAnnotationElement;
                }(LinkAnnotationElement);
                var ChoiceWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem4) {
                    _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
                    var _super8 = _createSuper(ChoiceWidgetAnnotationElement);
                    function ChoiceWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, ChoiceWidgetAnnotationElement);
                        return _super8.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    _createClass(ChoiceWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this10 = this;
                                this.container.className = "choiceWidgetAnnotation";
                                var storage = this.annotationStorage;
                                var id = this.data.id;
                                storage.getValue(id, {
                                    value: this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : undefined
                                });
                                var fontSize = this.data.defaultAppearanceData.fontSize;
                                if (!fontSize) fontSize = 9;
                                var fontSizeStyle = "calc(".concat(fontSize, "px * var(--zoom-factor))");
                                var selectElement = document.createElement("select");
                                GetElementsByNameSet.add(selectElement);
                                selectElement.disabled = this.data.readOnly;
                                selectElement.name = this.data.fieldName;
                                selectElement.setAttribute("id", id);
                                selectElement.tabIndex = DEFAULT_TAB_INDEX;
                                selectElement.style.fontSize = "".concat(fontSize, "px");
                                if (!this.data.combo) {
                                    selectElement.size = this.data.options.length;
                                    if (this.data.multiSelect) selectElement.multiple = true;
                                }
                                selectElement.addEventListener("resetform", function(event) {
                                    var defaultValue = _this10.data.defaultFieldValue;
                                    var _iterator13 = _createForOfIteratorHelper(selectElement.options), _step13;
                                    try {
                                        for(_iterator13.s(); !(_step13 = _iterator13.n()).done;){
                                            var option = _step13.value;
                                            option.selected = option.value === defaultValue;
                                        }
                                    } catch (err) {
                                        _iterator13.e(err);
                                    } finally{
                                        _iterator13.f();
                                    }
                                });
                                var _iterator14 = _createForOfIteratorHelper(this.data.options), _step14;
                                try {
                                    for(_iterator14.s(); !(_step14 = _iterator14.n()).done;){
                                        var option = _step14.value;
                                        var optionElement = document.createElement("option");
                                        optionElement.textContent = option.displayValue;
                                        optionElement.value = option.exportValue;
                                        if (this.data.combo) optionElement.style.fontSize = fontSizeStyle;
                                        if (this.data.fieldValue.includes(option.exportValue)) optionElement.setAttribute("selected", true);
                                        selectElement.appendChild(optionElement);
                                    }
                                } catch (err) {
                                    _iterator14.e(err);
                                } finally{
                                    _iterator14.f();
                                }
                                var getValue = function getValue(event, isExport) {
                                    var name = isExport ? "value" : "textContent";
                                    var options = event.target.options;
                                    if (!event.target.multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                                    return Array.prototype.filter.call(options, function(option) {
                                        return option.selected;
                                    }).map(function(option) {
                                        return option[name];
                                    });
                                };
                                var getItems = function getItems(event) {
                                    var options = event.target.options;
                                    return Array.prototype.map.call(options, function(option) {
                                        return {
                                            displayValue: option.textContent,
                                            exportValue: option.value
                                        };
                                    });
                                };
                                if (this.enableScripting && this.hasJSActions) {
                                    selectElement.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function value(event) {
                                                var value = event.detail.value;
                                                var values = new Set(Array.isArray(value) ? value : [
                                                    value
                                                ]);
                                                var _iterator15 = _createForOfIteratorHelper(selectElement.options), _step15;
                                                try {
                                                    for(_iterator15.s(); !(_step15 = _iterator15.n()).done;){
                                                        var option = _step15.value;
                                                        option.selected = values.has(option.value);
                                                    }
                                                } catch (err) {
                                                    _iterator15.e(err);
                                                } finally{
                                                    _iterator15.f();
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(event, true)
                                                });
                                            },
                                            multipleSelection: function multipleSelection(event) {
                                                selectElement.multiple = true;
                                            },
                                            remove: function remove(event) {
                                                var options = selectElement.options;
                                                var index = event.detail.remove;
                                                options[index].selected = false;
                                                selectElement.remove(index);
                                                if (options.length > 0) {
                                                    var i = Array.prototype.findIndex.call(options, function(option) {
                                                        return option.selected;
                                                    });
                                                    if (i === -1) options[0].selected = true;
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(event, true),
                                                    items: getItems(event)
                                                });
                                            },
                                            clear: function clear(event) {
                                                while(selectElement.length !== 0)selectElement.remove(0);
                                                storage.setValue(id, {
                                                    value: null,
                                                    items: []
                                                });
                                            },
                                            insert: function insert(event) {
                                                var _event$detail$insert = event.detail.insert, index = _event$detail$insert.index, displayValue = _event$detail$insert.displayValue, exportValue = _event$detail$insert.exportValue;
                                                var optionElement = document.createElement("option");
                                                optionElement.textContent = displayValue;
                                                optionElement.value = exportValue;
                                                selectElement.insertBefore(optionElement, selectElement.children[index]);
                                                storage.setValue(id, {
                                                    value: getValue(event, true),
                                                    items: getItems(event)
                                                });
                                            },
                                            items: function items(event) {
                                                var items = event.detail.items;
                                                while(selectElement.length !== 0)selectElement.remove(0);
                                                var _iterator16 = _createForOfIteratorHelper(items), _step16;
                                                try {
                                                    for(_iterator16.s(); !(_step16 = _iterator16.n()).done;){
                                                        var item = _step16.value;
                                                        var displayValue = item.displayValue, exportValue = item.exportValue;
                                                        var optionElement = document.createElement("option");
                                                        optionElement.textContent = displayValue;
                                                        optionElement.value = exportValue;
                                                        selectElement.appendChild(optionElement);
                                                    }
                                                } catch (err) {
                                                    _iterator16.e(err);
                                                } finally{
                                                    _iterator16.f();
                                                }
                                                if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                                storage.setValue(id, {
                                                    value: getValue(event, true),
                                                    items: getItems(event)
                                                });
                                            },
                                            indices: function indices(event) {
                                                var indices = new Set(event.detail.indices);
                                                var _iterator17 = _createForOfIteratorHelper(event.target.options), _step17;
                                                try {
                                                    for(_iterator17.s(); !(_step17 = _iterator17.n()).done;){
                                                        var option = _step17.value;
                                                        option.selected = indices.has(option.index);
                                                    }
                                                } catch (err) {
                                                    _iterator17.e(err);
                                                } finally{
                                                    _iterator17.f();
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(event, true)
                                                });
                                            },
                                            editable: function editable(event) {
                                                event.target.disabled = !event.detail.editable;
                                            }
                                        };
                                        _this10._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    selectElement.addEventListener("input", function(event) {
                                        var _this10$linkService$e;
                                        var exportValue = getValue(event, true);
                                        var value = getValue(event, false);
                                        storage.setValue(id, {
                                            value: exportValue
                                        });
                                        (_this10$linkService$e = _this10.linkService.eventBus) === null || _this10$linkService$e === void 0 || _this10$linkService$e.dispatch("dispatcheventinsandbox", {
                                            source: _this10,
                                            detail: {
                                                id: id,
                                                name: "Keystroke",
                                                value: value,
                                                changeEx: exportValue,
                                                willCommit: true,
                                                commitKey: 1,
                                                keyDown: false
                                            }
                                        });
                                    });
                                    this._setEventListeners(selectElement, [
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ],
                                        [
                                            "input",
                                            "Action"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                } else selectElement.addEventListener("input", function(event) {
                                    storage.setValue(id, {
                                        value: getValue(event)
                                    });
                                });
                                this._setBackgroundColor(selectElement);
                                this.container.appendChild(selectElement);
                                return this.container;
                            }
                        }
                    ]);
                    return ChoiceWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var PopupAnnotationElement = /*#__PURE__*/ function(_AnnotationElement4) {
                    _inherits(PopupAnnotationElement, _AnnotationElement4);
                    var _super9 = _createSuper(PopupAnnotationElement);
                    function PopupAnnotationElement(parameters) {
                        var _parameters$data$titl2, _parameters$data$cont2, _parameters$data$rich2;
                        _classCallCheck(this, PopupAnnotationElement);
                        var isRenderable = !!((_parameters$data$titl2 = parameters.data.titleObj) !== null && _parameters$data$titl2 !== void 0 && _parameters$data$titl2.str || (_parameters$data$cont2 = parameters.data.contentsObj) !== null && _parameters$data$cont2 !== void 0 && _parameters$data$cont2.str || (_parameters$data$rich2 = parameters.data.richText) !== null && _parameters$data$rich2 !== void 0 && _parameters$data$rich2.str);
                        return _super9.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    _createClass(PopupAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var IGNORE_TYPES = [
                                    "Line",
                                    "Square",
                                    "Circle",
                                    "PolyLine",
                                    "Polygon",
                                    "Ink"
                                ];
                                this.container.className = "popupAnnotation";
                                if (IGNORE_TYPES.includes(this.data.parentType)) return this.container;
                                var selector = "[data-annotation-id=\"".concat(this.data.parentId, "\"]");
                                var parentElements = this.layer.querySelectorAll(selector);
                                if (parentElements.length === 0) return this.container;
                                var popup = new PopupElement({
                                    container: this.container,
                                    trigger: Array.from(parentElements),
                                    color: this.data.color,
                                    titleObj: this.data.titleObj,
                                    modificationDate: this.data.modificationDate,
                                    contentsObj: this.data.contentsObj,
                                    richText: this.data.richText
                                });
                                var page = this.page;
                                var rect = _util.Util.normalizeRect([
                                    this.data.parentRect[0],
                                    page.view[3] - this.data.parentRect[1] + page.view[1],
                                    this.data.parentRect[2],
                                    page.view[3] - this.data.parentRect[3] + page.view[1]
                                ]);
                                var popupLeft = rect[0] + this.data.parentRect[2] - this.data.parentRect[0];
                                var popupTop = rect[1];
                                this.container.style.transformOrigin = "".concat(-popupLeft, "px ").concat(-popupTop, "px");
                                this.container.style.left = "".concat(popupLeft, "px");
                                this.container.style.top = "".concat(popupTop, "px");
                                this.container.appendChild(popup.render());
                                return this.container;
                            }
                        }
                    ]);
                    return PopupAnnotationElement;
                }(AnnotationElement);
                var PopupElement = /*#__PURE__*/ function() {
                    function PopupElement(parameters) {
                        _classCallCheck(this, PopupElement);
                        this.container = parameters.container;
                        this.trigger = parameters.trigger;
                        this.color = parameters.color;
                        this.titleObj = parameters.titleObj;
                        this.modificationDate = parameters.modificationDate;
                        this.contentsObj = parameters.contentsObj;
                        this.richText = parameters.richText;
                        this.hideWrapper = parameters.hideWrapper || false;
                        this.pinned = false;
                    }
                    _createClass(PopupElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this$richText, _this$contentsObj;
                                var BACKGROUND_ENLIGHT = 0.7;
                                var wrapper = document.createElement("div");
                                wrapper.className = "popupWrapper";
                                this.hideElement = this.hideWrapper ? wrapper : this.container;
                                this.hideElement.hidden = true;
                                var popup = document.createElement("div");
                                popup.className = "popup";
                                var color = this.color;
                                if (color) {
                                    var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
                                    var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
                                    var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
                                    popup.style.backgroundColor = _util.Util.makeHexColor(r | 0, g | 0, b | 0);
                                }
                                var title = document.createElement("h1");
                                title.dir = this.titleObj.dir;
                                title.textContent = this.titleObj.str;
                                popup.appendChild(title);
                                var dateObject = _display_utils.PDFDateString.toDateObject(this.modificationDate);
                                if (dateObject) {
                                    var modificationDate = document.createElement("span");
                                    modificationDate.className = "popupDate";
                                    modificationDate.textContent = "{{date}}, {{time}}";
                                    modificationDate.dataset.l10nId = "annotation_date_string";
                                    modificationDate.dataset.l10nArgs = JSON.stringify({
                                        date: dateObject.toLocaleDateString(),
                                        time: dateObject.toLocaleTimeString()
                                    });
                                    popup.appendChild(modificationDate);
                                }
                                if ((_this$richText = this.richText) !== null && _this$richText !== void 0 && _this$richText.str && (!((_this$contentsObj = this.contentsObj) !== null && _this$contentsObj !== void 0 && _this$contentsObj.str) || this.contentsObj.str === this.richText.str)) {
                                    _xfa_layer.XfaLayer.render({
                                        xfaHtml: this.richText.html,
                                        intent: "richText",
                                        div: popup
                                    });
                                    popup.lastChild.className = "richText popupContent";
                                } else {
                                    var contents = this._formatContents(this.contentsObj);
                                    popup.appendChild(contents);
                                }
                                if (!Array.isArray(this.trigger)) this.trigger = [
                                    this.trigger
                                ];
                                var _iterator18 = _createForOfIteratorHelper(this.trigger), _step18;
                                try {
                                    for(_iterator18.s(); !(_step18 = _iterator18.n()).done;){
                                        var element = _step18.value;
                                        element.addEventListener("click", this._toggle.bind(this));
                                        element.addEventListener("mouseover", this._show.bind(this, false));
                                        element.addEventListener("mouseout", this._hide.bind(this, false));
                                    }
                                } catch (err) {
                                    _iterator18.e(err);
                                } finally{
                                    _iterator18.f();
                                }
                                popup.addEventListener("click", this._hide.bind(this, true));
                                wrapper.appendChild(popup);
                                return wrapper;
                            }
                        },
                        {
                            key: "_formatContents",
                            value: function _formatContents(_ref2) {
                                var str = _ref2.str, dir = _ref2.dir;
                                var p = document.createElement("p");
                                p.className = "popupContent";
                                p.dir = dir;
                                var lines = str.split(/(?:\r\n?|\n)/);
                                for(var i = 0, ii = lines.length; i < ii; ++i){
                                    var line = lines[i];
                                    p.appendChild(document.createTextNode(line));
                                    if (i < ii - 1) p.appendChild(document.createElement("br"));
                                }
                                return p;
                            }
                        },
                        {
                            key: "_toggle",
                            value: function _toggle() {
                                if (this.pinned) this._hide(true);
                                else this._show(true);
                            }
                        },
                        {
                            key: "_show",
                            value: function _show() {
                                var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (pin) this.pinned = true;
                                if (this.hideElement.hidden) {
                                    this.hideElement.hidden = false;
                                    this.container.style.zIndex += 1;
                                }
                            }
                        },
                        {
                            key: "_hide",
                            value: function _hide() {
                                var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                                if (unpin) this.pinned = false;
                                if (!this.hideElement.hidden && !this.pinned) {
                                    this.hideElement.hidden = true;
                                    this.container.style.zIndex -= 1;
                                }
                            }
                        }
                    ]);
                    return PopupElement;
                }();
                var FreeTextAnnotationElement = /*#__PURE__*/ function(_AnnotationElement5) {
                    _inherits(FreeTextAnnotationElement, _AnnotationElement5);
                    var _super10 = _createSuper(FreeTextAnnotationElement);
                    function FreeTextAnnotationElement(parameters) {
                        var _parameters$data$titl3, _parameters$data$cont3, _parameters$data$rich3;
                        _classCallCheck(this, FreeTextAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl3 = parameters.data.titleObj) !== null && _parameters$data$titl3 !== void 0 && _parameters$data$titl3.str || (_parameters$data$cont3 = parameters.data.contentsObj) !== null && _parameters$data$cont3 !== void 0 && _parameters$data$cont3.str || (_parameters$data$rich3 = parameters.data.richText) !== null && _parameters$data$rich3 !== void 0 && _parameters$data$rich3.str);
                        return _super10.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(FreeTextAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "freeTextAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return FreeTextAnnotationElement;
                }(AnnotationElement);
                var LineAnnotationElement = /*#__PURE__*/ function(_AnnotationElement6) {
                    _inherits(LineAnnotationElement, _AnnotationElement6);
                    var _super11 = _createSuper(LineAnnotationElement);
                    function LineAnnotationElement(parameters) {
                        var _parameters$data$titl4, _parameters$data$cont4, _parameters$data$rich4;
                        _classCallCheck(this, LineAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl4 = parameters.data.titleObj) !== null && _parameters$data$titl4 !== void 0 && _parameters$data$titl4.str || (_parameters$data$cont4 = parameters.data.contentsObj) !== null && _parameters$data$cont4 !== void 0 && _parameters$data$cont4.str || (_parameters$data$rich4 = parameters.data.richText) !== null && _parameters$data$rich4 !== void 0 && _parameters$data$rich4.str);
                        return _super11.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(LineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "lineAnnotation";
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var line = this.svgFactory.createElement("svg:line");
                                line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                                line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                                line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                                line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                                line.setAttribute("stroke-width", data.borderStyle.width || 1);
                                line.setAttribute("stroke", "transparent");
                                line.setAttribute("fill", "transparent");
                                svg.appendChild(line);
                                this.container.append(svg);
                                this._createPopup(line, data);
                                return this.container;
                            }
                        }
                    ]);
                    return LineAnnotationElement;
                }(AnnotationElement);
                var SquareAnnotationElement = /*#__PURE__*/ function(_AnnotationElement7) {
                    _inherits(SquareAnnotationElement, _AnnotationElement7);
                    var _super12 = _createSuper(SquareAnnotationElement);
                    function SquareAnnotationElement(parameters) {
                        var _parameters$data$titl5, _parameters$data$cont5, _parameters$data$rich5;
                        _classCallCheck(this, SquareAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl5 = parameters.data.titleObj) !== null && _parameters$data$titl5 !== void 0 && _parameters$data$titl5.str || (_parameters$data$cont5 = parameters.data.contentsObj) !== null && _parameters$data$cont5 !== void 0 && _parameters$data$cont5.str || (_parameters$data$rich5 = parameters.data.richText) !== null && _parameters$data$rich5 !== void 0 && _parameters$data$rich5.str);
                        return _super12.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(SquareAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "squareAnnotation";
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var borderWidth = data.borderStyle.width;
                                var square = this.svgFactory.createElement("svg:rect");
                                square.setAttribute("x", borderWidth / 2);
                                square.setAttribute("y", borderWidth / 2);
                                square.setAttribute("width", width - borderWidth);
                                square.setAttribute("height", height - borderWidth);
                                square.setAttribute("stroke-width", borderWidth || 1);
                                square.setAttribute("stroke", "transparent");
                                square.setAttribute("fill", "transparent");
                                svg.appendChild(square);
                                this.container.append(svg);
                                this._createPopup(square, data);
                                return this.container;
                            }
                        }
                    ]);
                    return SquareAnnotationElement;
                }(AnnotationElement);
                var CircleAnnotationElement = /*#__PURE__*/ function(_AnnotationElement8) {
                    _inherits(CircleAnnotationElement, _AnnotationElement8);
                    var _super13 = _createSuper(CircleAnnotationElement);
                    function CircleAnnotationElement(parameters) {
                        var _parameters$data$titl6, _parameters$data$cont6, _parameters$data$rich6;
                        _classCallCheck(this, CircleAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl6 = parameters.data.titleObj) !== null && _parameters$data$titl6 !== void 0 && _parameters$data$titl6.str || (_parameters$data$cont6 = parameters.data.contentsObj) !== null && _parameters$data$cont6 !== void 0 && _parameters$data$cont6.str || (_parameters$data$rich6 = parameters.data.richText) !== null && _parameters$data$rich6 !== void 0 && _parameters$data$rich6.str);
                        return _super13.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(CircleAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "circleAnnotation";
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var borderWidth = data.borderStyle.width;
                                var circle = this.svgFactory.createElement("svg:ellipse");
                                circle.setAttribute("cx", width / 2);
                                circle.setAttribute("cy", height / 2);
                                circle.setAttribute("rx", width / 2 - borderWidth / 2);
                                circle.setAttribute("ry", height / 2 - borderWidth / 2);
                                circle.setAttribute("stroke-width", borderWidth || 1);
                                circle.setAttribute("stroke", "transparent");
                                circle.setAttribute("fill", "transparent");
                                svg.appendChild(circle);
                                this.container.append(svg);
                                this._createPopup(circle, data);
                                return this.container;
                            }
                        }
                    ]);
                    return CircleAnnotationElement;
                }(AnnotationElement);
                var PolylineAnnotationElement = /*#__PURE__*/ function(_AnnotationElement9) {
                    _inherits(PolylineAnnotationElement, _AnnotationElement9);
                    var _super14 = _createSuper(PolylineAnnotationElement);
                    function PolylineAnnotationElement(parameters) {
                        var _parameters$data$titl7, _parameters$data$cont7, _parameters$data$rich7;
                        var _this11;
                        _classCallCheck(this, PolylineAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl7 = parameters.data.titleObj) !== null && _parameters$data$titl7 !== void 0 && _parameters$data$titl7.str || (_parameters$data$cont7 = parameters.data.contentsObj) !== null && _parameters$data$cont7 !== void 0 && _parameters$data$cont7.str || (_parameters$data$rich7 = parameters.data.richText) !== null && _parameters$data$rich7 !== void 0 && _parameters$data$rich7.str);
                        _this11 = _super14.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                        _this11.containerClassName = "polylineAnnotation";
                        _this11.svgElementName = "svg:polyline";
                        return _this11;
                    }
                    _createClass(PolylineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = this.containerClassName;
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var points = [];
                                var _iterator19 = _createForOfIteratorHelper(data.vertices), _step19;
                                try {
                                    for(_iterator19.s(); !(_step19 = _iterator19.n()).done;){
                                        var coordinate = _step19.value;
                                        var x = coordinate.x - data.rect[0];
                                        var y = data.rect[3] - coordinate.y;
                                        points.push(x + "," + y);
                                    }
                                } catch (err) {
                                    _iterator19.e(err);
                                } finally{
                                    _iterator19.f();
                                }
                                points = points.join(" ");
                                var polyline = this.svgFactory.createElement(this.svgElementName);
                                polyline.setAttribute("points", points);
                                polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                                polyline.setAttribute("stroke", "transparent");
                                polyline.setAttribute("fill", "transparent");
                                svg.appendChild(polyline);
                                this.container.append(svg);
                                this._createPopup(polyline, data);
                                return this.container;
                            }
                        }
                    ]);
                    return PolylineAnnotationElement;
                }(AnnotationElement);
                var PolygonAnnotationElement = /*#__PURE__*/ function(_PolylineAnnotationEl) {
                    _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
                    var _super15 = _createSuper(PolygonAnnotationElement);
                    function PolygonAnnotationElement(parameters) {
                        var _this12;
                        _classCallCheck(this, PolygonAnnotationElement);
                        _this12 = _super15.call(this, parameters);
                        _this12.containerClassName = "polygonAnnotation";
                        _this12.svgElementName = "svg:polygon";
                        return _this12;
                    }
                    return PolygonAnnotationElement;
                }(PolylineAnnotationElement);
                var CaretAnnotationElement = /*#__PURE__*/ function(_AnnotationElement10) {
                    _inherits(CaretAnnotationElement, _AnnotationElement10);
                    var _super16 = _createSuper(CaretAnnotationElement);
                    function CaretAnnotationElement(parameters) {
                        var _parameters$data$titl8, _parameters$data$cont8, _parameters$data$rich8;
                        _classCallCheck(this, CaretAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl8 = parameters.data.titleObj) !== null && _parameters$data$titl8 !== void 0 && _parameters$data$titl8.str || (_parameters$data$cont8 = parameters.data.contentsObj) !== null && _parameters$data$cont8 !== void 0 && _parameters$data$cont8.str || (_parameters$data$rich8 = parameters.data.richText) !== null && _parameters$data$rich8 !== void 0 && _parameters$data$rich8.str);
                        return _super16.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(CaretAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "caretAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return CaretAnnotationElement;
                }(AnnotationElement);
                var InkAnnotationElement = /*#__PURE__*/ function(_AnnotationElement11) {
                    _inherits(InkAnnotationElement, _AnnotationElement11);
                    var _super17 = _createSuper(InkAnnotationElement);
                    function InkAnnotationElement(parameters) {
                        var _parameters$data$titl9, _parameters$data$cont9, _parameters$data$rich9;
                        var _this13;
                        _classCallCheck(this, InkAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl9 = parameters.data.titleObj) !== null && _parameters$data$titl9 !== void 0 && _parameters$data$titl9.str || (_parameters$data$cont9 = parameters.data.contentsObj) !== null && _parameters$data$cont9 !== void 0 && _parameters$data$cont9.str || (_parameters$data$rich9 = parameters.data.richText) !== null && _parameters$data$rich9 !== void 0 && _parameters$data$rich9.str);
                        _this13 = _super17.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                        _this13.containerClassName = "inkAnnotation";
                        _this13.svgElementName = "svg:polyline";
                        return _this13;
                    }
                    _createClass(InkAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = this.containerClassName;
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var _iterator20 = _createForOfIteratorHelper(data.inkLists), _step20;
                                try {
                                    for(_iterator20.s(); !(_step20 = _iterator20.n()).done;){
                                        var inkList = _step20.value;
                                        var points = [];
                                        var _iterator21 = _createForOfIteratorHelper(inkList), _step21;
                                        try {
                                            for(_iterator21.s(); !(_step21 = _iterator21.n()).done;){
                                                var coordinate = _step21.value;
                                                var x = coordinate.x - data.rect[0];
                                                var y = data.rect[3] - coordinate.y;
                                                points.push("".concat(x, ",").concat(y));
                                            }
                                        } catch (err) {
                                            _iterator21.e(err);
                                        } finally{
                                            _iterator21.f();
                                        }
                                        points = points.join(" ");
                                        var polyline = this.svgFactory.createElement(this.svgElementName);
                                        polyline.setAttribute("points", points);
                                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                                        polyline.setAttribute("stroke", "transparent");
                                        polyline.setAttribute("fill", "transparent");
                                        this._createPopup(polyline, data);
                                        svg.appendChild(polyline);
                                    }
                                } catch (err) {
                                    _iterator20.e(err);
                                } finally{
                                    _iterator20.f();
                                }
                                this.container.append(svg);
                                return this.container;
                            }
                        }
                    ]);
                    return InkAnnotationElement;
                }(AnnotationElement);
                var HighlightAnnotationElement = /*#__PURE__*/ function(_AnnotationElement12) {
                    _inherits(HighlightAnnotationElement, _AnnotationElement12);
                    var _super18 = _createSuper(HighlightAnnotationElement);
                    function HighlightAnnotationElement(parameters) {
                        var _parameters$data$titl10, _parameters$data$cont10, _parameters$data$rich10;
                        _classCallCheck(this, HighlightAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl10 = parameters.data.titleObj) !== null && _parameters$data$titl10 !== void 0 && _parameters$data$titl10.str || (_parameters$data$cont10 = parameters.data.contentsObj) !== null && _parameters$data$cont10 !== void 0 && _parameters$data$cont10.str || (_parameters$data$rich10 = parameters.data.richText) !== null && _parameters$data$rich10 !== void 0 && _parameters$data$rich10.str);
                        return _super18.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(HighlightAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("highlightAnnotation");
                                this.container.className = "highlightAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return HighlightAnnotationElement;
                }(AnnotationElement);
                var UnderlineAnnotationElement = /*#__PURE__*/ function(_AnnotationElement13) {
                    _inherits(UnderlineAnnotationElement, _AnnotationElement13);
                    var _super19 = _createSuper(UnderlineAnnotationElement);
                    function UnderlineAnnotationElement(parameters) {
                        var _parameters$data$titl11, _parameters$data$cont11, _parameters$data$rich11;
                        _classCallCheck(this, UnderlineAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl11 = parameters.data.titleObj) !== null && _parameters$data$titl11 !== void 0 && _parameters$data$titl11.str || (_parameters$data$cont11 = parameters.data.contentsObj) !== null && _parameters$data$cont11 !== void 0 && _parameters$data$cont11.str || (_parameters$data$rich11 = parameters.data.richText) !== null && _parameters$data$rich11 !== void 0 && _parameters$data$rich11.str);
                        return _super19.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(UnderlineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("underlineAnnotation");
                                this.container.className = "underlineAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return UnderlineAnnotationElement;
                }(AnnotationElement);
                var SquigglyAnnotationElement = /*#__PURE__*/ function(_AnnotationElement14) {
                    _inherits(SquigglyAnnotationElement, _AnnotationElement14);
                    var _super20 = _createSuper(SquigglyAnnotationElement);
                    function SquigglyAnnotationElement(parameters) {
                        var _parameters$data$titl12, _parameters$data$cont12, _parameters$data$rich12;
                        _classCallCheck(this, SquigglyAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl12 = parameters.data.titleObj) !== null && _parameters$data$titl12 !== void 0 && _parameters$data$titl12.str || (_parameters$data$cont12 = parameters.data.contentsObj) !== null && _parameters$data$cont12 !== void 0 && _parameters$data$cont12.str || (_parameters$data$rich12 = parameters.data.richText) !== null && _parameters$data$rich12 !== void 0 && _parameters$data$rich12.str);
                        return _super20.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(SquigglyAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("squigglyAnnotation");
                                this.container.className = "squigglyAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return SquigglyAnnotationElement;
                }(AnnotationElement);
                var StrikeOutAnnotationElement = /*#__PURE__*/ function(_AnnotationElement15) {
                    _inherits(StrikeOutAnnotationElement, _AnnotationElement15);
                    var _super21 = _createSuper(StrikeOutAnnotationElement);
                    function StrikeOutAnnotationElement(parameters) {
                        var _parameters$data$titl13, _parameters$data$cont13, _parameters$data$rich13;
                        _classCallCheck(this, StrikeOutAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl13 = parameters.data.titleObj) !== null && _parameters$data$titl13 !== void 0 && _parameters$data$titl13.str || (_parameters$data$cont13 = parameters.data.contentsObj) !== null && _parameters$data$cont13 !== void 0 && _parameters$data$cont13.str || (_parameters$data$rich13 = parameters.data.richText) !== null && _parameters$data$rich13 !== void 0 && _parameters$data$rich13.str);
                        return _super21.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(StrikeOutAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("strikeoutAnnotation");
                                this.container.className = "strikeoutAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return StrikeOutAnnotationElement;
                }(AnnotationElement);
                var StampAnnotationElement = /*#__PURE__*/ function(_AnnotationElement16) {
                    _inherits(StampAnnotationElement, _AnnotationElement16);
                    var _super22 = _createSuper(StampAnnotationElement);
                    function StampAnnotationElement(parameters) {
                        var _parameters$data$titl14, _parameters$data$cont14, _parameters$data$rich14;
                        _classCallCheck(this, StampAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl14 = parameters.data.titleObj) !== null && _parameters$data$titl14 !== void 0 && _parameters$data$titl14.str || (_parameters$data$cont14 = parameters.data.contentsObj) !== null && _parameters$data$cont14 !== void 0 && _parameters$data$cont14.str || (_parameters$data$rich14 = parameters.data.richText) !== null && _parameters$data$rich14 !== void 0 && _parameters$data$rich14.str);
                        return _super22.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(StampAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "stampAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return StampAnnotationElement;
                }(AnnotationElement);
                var FileAttachmentAnnotationElement = /*#__PURE__*/ function(_AnnotationElement17) {
                    _inherits(FileAttachmentAnnotationElement, _AnnotationElement17);
                    var _super23 = _createSuper(FileAttachmentAnnotationElement);
                    function FileAttachmentAnnotationElement(parameters) {
                        var _this14$linkService$e;
                        var _this14;
                        _classCallCheck(this, FileAttachmentAnnotationElement);
                        _this14 = _super23.call(this, parameters, {
                            isRenderable: true
                        });
                        var _this14$data$file = _this14.data.file, filename = _this14$data$file.filename, content = _this14$data$file.content;
                        _this14.filename = (0, _display_utils.getFilenameFromUrl)(filename);
                        _this14.content = content;
                        (_this14$linkService$e = _this14.linkService.eventBus) === null || _this14$linkService$e === void 0 || _this14$linkService$e.dispatch("fileattachmentannotation", {
                            source: _assertThisInitialized(_this14),
                            id: (0, _util.stringToPDFString)(filename),
                            filename: filename,
                            content: content
                        });
                        return _this14;
                    }
                    _createClass(FileAttachmentAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this$data$titleObj, _this$data$contentsOb;
                                this.container.className = "fileAttachmentAnnotation";
                                var trigger = document.createElement("div");
                                trigger.style.height = this.container.style.height;
                                trigger.style.width = this.container.style.width;
                                trigger.addEventListener("dblclick", this._download.bind(this));
                                if (!this.data.hasPopup && ((_this$data$titleObj = this.data.titleObj) !== null && _this$data$titleObj !== void 0 && _this$data$titleObj.str || (_this$data$contentsOb = this.data.contentsObj) !== null && _this$data$contentsOb !== void 0 && _this$data$contentsOb.str || this.data.richText)) this._createPopup(trigger, this.data);
                                this.container.appendChild(trigger);
                                return this.container;
                            }
                        },
                        {
                            key: "_download",
                            value: function _download() {
                                var _this$downloadManager;
                                (_this$downloadManager = this.downloadManager) === null || _this$downloadManager === void 0 || _this$downloadManager.openOrDownloadData(this.container, this.content, this.filename);
                            }
                        }
                    ]);
                    return FileAttachmentAnnotationElement;
                }(AnnotationElement);
                var AnnotationLayer = /*#__PURE__*/ function() {
                    function AnnotationLayer() {
                        _classCallCheck(this, AnnotationLayer);
                    }
                    _createClass(AnnotationLayer, null, [
                        {
                            key: "render",
                            value: function render(parameters) {
                                var sortedAnnotations = [], popupAnnotations = [];
                                var _iterator22 = _createForOfIteratorHelper(parameters.annotations), _step22;
                                try {
                                    for(_iterator22.s(); !(_step22 = _iterator22.n()).done;){
                                        var _data = _step22.value;
                                        if (!_data) continue;
                                        if (_data.annotationType === _util.AnnotationType.POPUP) {
                                            popupAnnotations.push(_data);
                                            continue;
                                        }
                                        sortedAnnotations.push(_data);
                                    }
                                } catch (err) {
                                    _iterator22.e(err);
                                } finally{
                                    _iterator22.f();
                                }
                                if (popupAnnotations.length) sortedAnnotations.push.apply(sortedAnnotations, popupAnnotations);
                                var div = parameters.div;
                                for(var _i7 = 0, _sortedAnnotations = sortedAnnotations; _i7 < _sortedAnnotations.length; _i7++){
                                    var data = _sortedAnnotations[_i7];
                                    var element = AnnotationElementFactory.create({
                                        data: data,
                                        layer: div,
                                        page: parameters.page,
                                        viewport: parameters.viewport,
                                        linkService: parameters.linkService,
                                        downloadManager: parameters.downloadManager,
                                        imageResourcesPath: parameters.imageResourcesPath || "",
                                        renderForms: parameters.renderForms !== false,
                                        svgFactory: new _display_utils.DOMSVGFactory(),
                                        annotationStorage: parameters.annotationStorage || new _annotation_storage.AnnotationStorage(),
                                        enableScripting: parameters.enableScripting,
                                        hasJSActions: parameters.hasJSActions,
                                        fieldObjects: parameters.fieldObjects,
                                        mouseState: parameters.mouseState || {
                                            isDown: false
                                        }
                                    });
                                    if (element.isRenderable) {
                                        var rendered = element.render();
                                        if (data.hidden) rendered.style.visibility = "hidden";
                                        if (Array.isArray(rendered)) {
                                            var _iterator23 = _createForOfIteratorHelper(rendered), _step23;
                                            try {
                                                for(_iterator23.s(); !(_step23 = _iterator23.n()).done;){
                                                    var renderedElement = _step23.value;
                                                    div.appendChild(renderedElement);
                                                }
                                            } catch (err) {
                                                _iterator23.e(err);
                                            } finally{
                                                _iterator23.f();
                                            }
                                        } else if (element instanceof PopupAnnotationElement) div.prepend(rendered);
                                        else div.appendChild(rendered);
                                    }
                                }
                                _classStaticPrivateMethodGet(this, AnnotationLayer, _setAnnotationCanvasMap).call(this, div, parameters.annotationCanvasMap);
                            }
                        },
                        {
                            key: "update",
                            value: function update(parameters) {
                                var page = parameters.page, viewport = parameters.viewport, annotations = parameters.annotations, annotationCanvasMap = parameters.annotationCanvasMap, div = parameters.div;
                                var transform = viewport.transform;
                                var matrix = "matrix(".concat(transform.join(","), ")");
                                var scale, ownMatrix;
                                var _iterator24 = _createForOfIteratorHelper(annotations), _step24;
                                try {
                                    for(_iterator24.s(); !(_step24 = _iterator24.n()).done;){
                                        var data = _step24.value;
                                        var elements = div.querySelectorAll("[data-annotation-id=\"".concat(data.id, "\"]"));
                                        if (elements) {
                                            var _iterator25 = _createForOfIteratorHelper(elements), _step25;
                                            try {
                                                for(_iterator25.s(); !(_step25 = _iterator25.n()).done;){
                                                    var element = _step25.value;
                                                    if (data.hasOwnCanvas) {
                                                        var rect = _util.Util.normalizeRect([
                                                            data.rect[0],
                                                            page.view[3] - data.rect[1] + page.view[1],
                                                            data.rect[2],
                                                            page.view[3] - data.rect[3] + page.view[1]
                                                        ]);
                                                        if (!ownMatrix) {
                                                            scale = Math.abs(transform[0] || transform[1]);
                                                            var ownTransform = transform.slice();
                                                            for(var i = 0; i < 4; i++)ownTransform[i] = Math.sign(ownTransform[i]);
                                                            ownMatrix = "matrix(".concat(ownTransform.join(","), ")");
                                                        }
                                                        var left = rect[0] * scale;
                                                        var top = rect[1] * scale;
                                                        element.style.left = "".concat(left, "px");
                                                        element.style.top = "".concat(top, "px");
                                                        element.style.transformOrigin = "".concat(-left, "px ").concat(-top, "px");
                                                        element.style.transform = ownMatrix;
                                                    } else element.style.transform = matrix;
                                                }
                                            } catch (err) {
                                                _iterator25.e(err);
                                            } finally{
                                                _iterator25.f();
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _iterator24.e(err);
                                } finally{
                                    _iterator24.f();
                                }
                                _classStaticPrivateMethodGet(this, AnnotationLayer, _setAnnotationCanvasMap).call(this, div, annotationCanvasMap);
                                div.hidden = false;
                            }
                        }
                    ]);
                    return AnnotationLayer;
                }();
                exports.AnnotationLayer = AnnotationLayer;
                function _setAnnotationCanvasMap(div, annotationCanvasMap) {
                    if (!annotationCanvasMap) return;
                    var _iterator26 = _createForOfIteratorHelper(annotationCanvasMap), _step26;
                    try {
                        for(_iterator26.s(); !(_step26 = _iterator26.n()).done;){
                            var _step26$value = _slicedToArray(_step26.value, 2), id = _step26$value[0], canvas = _step26$value[1];
                            var element = div.querySelector("[data-annotation-id=\"".concat(id, "\"]"));
                            if (!element) continue;
                            var firstChild = element.firstChild;
                            if (firstChild.nodeName === "CANVAS") element.replaceChild(canvas, firstChild);
                            else element.insertBefore(canvas, firstChild);
                        }
                    } catch (err) {
                        _iterator26.e(err);
                    } finally{
                        _iterator26.f();
                    }
                    annotationCanvasMap.clear();
                }
            /***/ },
            /* 149 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                var ColorConverters = /*#__PURE__*/ function() {
                    function ColorConverters() {
                        _classCallCheck(this, ColorConverters);
                    }
                    _createClass(ColorConverters, null, [
                        {
                            key: "CMYK_G",
                            value: function CMYK_G(_ref) {
                                var _ref2 = _slicedToArray(_ref, 4), c = _ref2[0], y = _ref2[1], m = _ref2[2], k = _ref2[3];
                                return [
                                    "G",
                                    1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                                ];
                            }
                        },
                        {
                            key: "G_CMYK",
                            value: function G_CMYK(_ref3) {
                                var _ref4 = _slicedToArray(_ref3, 1), g = _ref4[0];
                                return [
                                    "CMYK",
                                    0,
                                    0,
                                    0,
                                    1 - g
                                ];
                            }
                        },
                        {
                            key: "G_RGB",
                            value: function G_RGB(_ref5) {
                                var _ref6 = _slicedToArray(_ref5, 1), g = _ref6[0];
                                return [
                                    "RGB",
                                    g,
                                    g,
                                    g
                                ];
                            }
                        },
                        {
                            key: "G_HTML",
                            value: function G_HTML(_ref7) {
                                var _ref8 = _slicedToArray(_ref7, 1), g = _ref8[0];
                                var G = makeColorComp(g);
                                return "#".concat(G).concat(G).concat(G);
                            }
                        },
                        {
                            key: "RGB_G",
                            value: function RGB_G(_ref9) {
                                var _ref10 = _slicedToArray(_ref9, 3), r = _ref10[0], g = _ref10[1], b = _ref10[2];
                                return [
                                    "G",
                                    0.3 * r + 0.59 * g + 0.11 * b
                                ];
                            }
                        },
                        {
                            key: "RGB_HTML",
                            value: function RGB_HTML(_ref11) {
                                var _ref12 = _slicedToArray(_ref11, 3), r = _ref12[0], g = _ref12[1], b = _ref12[2];
                                var R = makeColorComp(r);
                                var G = makeColorComp(g);
                                var B = makeColorComp(b);
                                return "#".concat(R).concat(G).concat(B);
                            }
                        },
                        {
                            key: "T_HTML",
                            value: function T_HTML() {
                                return "#00000000";
                            }
                        },
                        {
                            key: "CMYK_RGB",
                            value: function CMYK_RGB(_ref13) {
                                var _ref14 = _slicedToArray(_ref13, 4), c = _ref14[0], y = _ref14[1], m = _ref14[2], k = _ref14[3];
                                return [
                                    "RGB",
                                    1 - Math.min(1, c + k),
                                    1 - Math.min(1, m + k),
                                    1 - Math.min(1, y + k)
                                ];
                            }
                        },
                        {
                            key: "CMYK_HTML",
                            value: function CMYK_HTML(components) {
                                return this.RGB_HTML(this.CMYK_RGB(components));
                            }
                        },
                        {
                            key: "RGB_CMYK",
                            value: function RGB_CMYK(_ref15) {
                                var _ref16 = _slicedToArray(_ref15, 3), r = _ref16[0], g = _ref16[1], b = _ref16[2];
                                var c = 1 - r;
                                var m = 1 - g;
                                var y = 1 - b;
                                var k = Math.min(c, m, y);
                                return [
                                    "CMYK",
                                    c,
                                    m,
                                    y,
                                    k
                                ];
                            }
                        }
                    ]);
                    return ColorConverters;
                }();
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 150 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _util = __w_pdfjs_require__(4);
                var _xfa_text = __w_pdfjs_require__(147);
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var XfaLayer = /*#__PURE__*/ function() {
                    function XfaLayer() {
                        _classCallCheck(this, XfaLayer);
                    }
                    _createClass(XfaLayer, null, [
                        {
                            key: "setupStorage",
                            value: function setupStorage(html, id, element, storage, intent) {
                                var storedData = storage.getValue(id, {
                                    value: null
                                });
                                switch(element.name){
                                    case "textarea":
                                        if (storedData.value !== null) html.textContent = storedData.value;
                                        if (intent === "print") break;
                                        html.addEventListener("input", function(event) {
                                            storage.setValue(id, {
                                                value: event.target.value
                                            });
                                        });
                                        break;
                                    case "input":
                                        if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                            if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                            else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                            if (intent === "print") break;
                                            html.addEventListener("change", function(event) {
                                                storage.setValue(id, {
                                                    value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                                });
                                            });
                                        } else {
                                            if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                            if (intent === "print") break;
                                            html.addEventListener("input", function(event) {
                                                storage.setValue(id, {
                                                    value: event.target.value
                                                });
                                            });
                                        }
                                        break;
                                    case "select":
                                        if (storedData.value !== null) {
                                            var _iterator = _createForOfIteratorHelper(element.children), _step;
                                            try {
                                                for(_iterator.s(); !(_step = _iterator.n()).done;){
                                                    var option = _step.value;
                                                    if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                                }
                                            } catch (err) {
                                                _iterator.e(err);
                                            } finally{
                                                _iterator.f();
                                            }
                                        }
                                        html.addEventListener("input", function(event) {
                                            var options = event.target.options;
                                            var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                        });
                                        break;
                                }
                            }
                        },
                        {
                            key: "setAttributes",
                            value: function setAttributes(_ref) {
                                var html = _ref.html, element = _ref.element, _ref$storage = _ref.storage, storage = _ref$storage === void 0 ? null : _ref$storage, intent = _ref.intent, linkService = _ref.linkService;
                                var attributes = element.attributes;
                                var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                                if (attributes.type === "radio") attributes.name = "".concat(attributes.name, "-").concat(intent);
                                for(var _i = 0, _Object$entries = Object.entries(attributes); _i < _Object$entries.length; _i++){
                                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                                    if (value === null || value === undefined || key === "dataId") continue;
                                    if (key !== "style") {
                                        if (key === "textContent") html.textContent = value;
                                        else if (key === "class") {
                                            if (value.length) html.setAttribute(key, value.join(" "));
                                        } else {
                                            if (isHTMLAnchorElement && (key === "href" || key === "newWindow")) continue;
                                            html.setAttribute(key, value);
                                        }
                                    } else Object.assign(html.style, value);
                                }
                                if (isHTMLAnchorElement) {
                                    var _linkService$addLinkA;
                                    if (!linkService.addLinkAttributes) (0, _util.warn)("XfaLayer.setAttribute - missing `addLinkAttributes`-method on the `linkService`-instance.");
                                    (_linkService$addLinkA = linkService.addLinkAttributes) === null || _linkService$addLinkA === void 0 || _linkService$addLinkA.call(linkService, html, attributes.href, attributes.newWindow);
                                }
                                if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                            }
                        },
                        {
                            key: "render",
                            value: function render(parameters) {
                                var storage = parameters.annotationStorage;
                                var linkService = parameters.linkService;
                                var root = parameters.xfaHtml;
                                var intent = parameters.intent || "display";
                                var rootHtml = document.createElement(root.name);
                                if (root.attributes) this.setAttributes({
                                    html: rootHtml,
                                    element: root,
                                    intent: intent,
                                    linkService: linkService
                                });
                                var stack = [
                                    [
                                        root,
                                        -1,
                                        rootHtml
                                    ]
                                ];
                                var rootDiv = parameters.div;
                                rootDiv.appendChild(rootHtml);
                                if (parameters.viewport) {
                                    var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                                    rootDiv.style.transform = transform;
                                }
                                if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                                var textDivs = [];
                                while(stack.length > 0){
                                    var _child$attributes;
                                    var _stack = _slicedToArray(stack[stack.length - 1], 3), parent = _stack[0], i = _stack[1], html = _stack[2];
                                    if (i + 1 === parent.children.length) {
                                        stack.pop();
                                        continue;
                                    }
                                    var child = parent.children[++stack[stack.length - 1][1]];
                                    if (child === null) continue;
                                    var name = child.name;
                                    if (name === "#text") {
                                        var node = document.createTextNode(child.value);
                                        textDivs.push(node);
                                        html.appendChild(node);
                                        continue;
                                    }
                                    var childHtml = void 0;
                                    if (child !== null && child !== void 0 && (_child$attributes = child.attributes) !== null && _child$attributes !== void 0 && _child$attributes.xmlns) childHtml = document.createElementNS(child.attributes.xmlns, name);
                                    else childHtml = document.createElement(name);
                                    html.appendChild(childHtml);
                                    if (child.attributes) this.setAttributes({
                                        html: childHtml,
                                        element: child,
                                        storage: storage,
                                        intent: intent,
                                        linkService: linkService
                                    });
                                    if (child.children && child.children.length > 0) stack.push([
                                        child,
                                        -1,
                                        childHtml
                                    ]);
                                    else if (child.value) {
                                        var _node = document.createTextNode(child.value);
                                        if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(_node);
                                        childHtml.appendChild(_node);
                                    }
                                }
                                var _iterator2 = _createForOfIteratorHelper(rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var el = _step2.value;
                                        el.setAttribute("readOnly", true);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                return {
                                    textDivs: textDivs
                                };
                            }
                        },
                        {
                            key: "update",
                            value: function update(parameters) {
                                var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                                parameters.div.style.transform = transform;
                                parameters.div.hidden = false;
                            }
                        }
                    ]);
                    return XfaLayer;
                }();
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 151 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.renderTextLayer = renderTextLayer;
                var _util = __w_pdfjs_require__(4);
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                var MAX_TEXT_DIVS_TO_RENDER = 100000;
                var DEFAULT_FONT_SIZE = 30;
                var DEFAULT_FONT_ASCENT = 0.8;
                var ascentCache = new Map();
                var AllWhitespaceRegexp = /^\s+$/g;
                function getAscent(fontFamily, ctx) {
                    var cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    ctx.save();
                    ctx.font = "".concat(DEFAULT_FONT_SIZE, "px ").concat(fontFamily);
                    var metrics = ctx.measureText("");
                    var ascent = metrics.fontBoundingBoxAscent;
                    var descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        ctx.restore();
                        var ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    var pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(var i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(var _i = 0, ii = pixels.length; _i < ii; _i += 4)if (pixels[_i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(_i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.restore();
                    if (ascent) {
                        var _ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, _ratio);
                        return _ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles, ctx) {
                    var textDiv = document.createElement("span");
                    var textDivProperties = task._enhanceTextSelection ? {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        originalTransform: null,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        scale: 1
                    } : {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL
                    };
                    task._textDivs.push(textDiv);
                    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
                    var angle = Math.atan2(tx[1], tx[0]);
                    var style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    var fontHeight = Math.hypot(tx[2], tx[3]);
                    var fontAscent = fontHeight * getAscent(style.fontFamily, ctx);
                    var left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    textDiv.style.left = "".concat(left, "px");
                    textDiv.style.top = "".concat(top, "px");
                    textDiv.style.fontSize = "".concat(fontHeight, "px");
                    textDiv.style.fontFamily = style.fontFamily;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    var shouldScaleText = false;
                    if (geom.str.length > 1 || task._enhanceTextSelection && AllWhitespaceRegexp.test(geom.str)) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        var absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) {
                        if (style.vertical) textDivProperties.canvasWidth = geom.height * task._viewport.scale;
                        else textDivProperties.canvasWidth = geom.width * task._viewport.scale;
                    }
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._textContentStream) task._layoutText(textDiv);
                    if (task._enhanceTextSelection && textDivProperties.hasText) {
                        var angleCos = 1, angleSin = 0;
                        if (angle !== 0) {
                            angleCos = Math.cos(angle);
                            angleSin = Math.sin(angle);
                        }
                        var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
                        var divHeight = fontHeight;
                        var m, b;
                        if (angle !== 0) {
                            m = [
                                angleCos,
                                angleSin,
                                -angleSin,
                                angleCos,
                                left,
                                top
                            ];
                            b = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                divWidth,
                                divHeight
                            ], m);
                        } else b = [
                            left,
                            top,
                            left + divWidth,
                            top + divHeight
                        ];
                        task._bounds.push({
                            left: b[0],
                            top: b[1],
                            right: b[2],
                            bottom: b[3],
                            div: textDiv,
                            size: [
                                divWidth,
                                divHeight
                            ],
                            m: m
                        });
                    }
                }
                function render(task) {
                    if (task._canceled) return;
                    var textDivs = task._textDivs;
                    var capability = task._capability;
                    var textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        task._renderingDone = true;
                        capability.resolve();
                        return;
                    }
                    if (!task._textContentStream) for(var i = 0; i < textDivsLength; i++)task._layoutText(textDivs[i]);
                    task._renderingDone = true;
                    capability.resolve();
                }
                function findPositiveMin(ts, offset, count) {
                    var result = 0;
                    for(var i = 0; i < count; i++){
                        var t = ts[offset++];
                        if (t > 0) result = result ? Math.min(t, result) : t;
                    }
                    return result;
                }
                function expand(task) {
                    var bounds = task._bounds;
                    var viewport = task._viewport;
                    var expanded = expandBounds(viewport.width, viewport.height, bounds);
                    for(var i = 0; i < expanded.length; i++){
                        var div = bounds[i].div;
                        var divProperties = task._textDivProperties.get(div);
                        if (divProperties.angle === 0) {
                            divProperties.paddingLeft = bounds[i].left - expanded[i].left;
                            divProperties.paddingTop = bounds[i].top - expanded[i].top;
                            divProperties.paddingRight = expanded[i].right - bounds[i].right;
                            divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
                            task._textDivProperties.set(div, divProperties);
                            continue;
                        }
                        var e = expanded[i], b = bounds[i];
                        var m = b.m, c = m[0], s = m[1];
                        var points = [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                b.size[1]
                            ],
                            [
                                b.size[0],
                                0
                            ],
                            b.size
                        ];
                        var ts = new Float64Array(64);
                        for(var j = 0, jj = points.length; j < jj; j++){
                            var t = _util.Util.applyTransform(points[j], m);
                            ts[j + 0] = c && (e.left - t[0]) / c;
                            ts[j + 4] = s && (e.top - t[1]) / s;
                            ts[j + 8] = c && (e.right - t[0]) / c;
                            ts[j + 12] = s && (e.bottom - t[1]) / s;
                            ts[j + 16] = s && (e.left - t[0]) / -s;
                            ts[j + 20] = c && (e.top - t[1]) / c;
                            ts[j + 24] = s && (e.right - t[0]) / -s;
                            ts[j + 28] = c && (e.bottom - t[1]) / c;
                            ts[j + 32] = c && (e.left - t[0]) / -c;
                            ts[j + 36] = s && (e.top - t[1]) / -s;
                            ts[j + 40] = c && (e.right - t[0]) / -c;
                            ts[j + 44] = s && (e.bottom - t[1]) / -s;
                            ts[j + 48] = s && (e.left - t[0]) / s;
                            ts[j + 52] = c && (e.top - t[1]) / -c;
                            ts[j + 56] = s && (e.right - t[0]) / s;
                            ts[j + 60] = c && (e.bottom - t[1]) / -c;
                        }
                        var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
                        divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
                        divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
                        divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
                        divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
                        task._textDivProperties.set(div, divProperties);
                    }
                }
                function expandBounds(width, height, boxes) {
                    var bounds = boxes.map(function(box, i) {
                        return {
                            x1: box.left,
                            y1: box.top,
                            x2: box.right,
                            y2: box.bottom,
                            index: i,
                            x1New: undefined,
                            x2New: undefined
                        };
                    });
                    expandBoundsLTR(width, bounds);
                    var expanded = new Array(boxes.length);
                    var _iterator = _createForOfIteratorHelper(bounds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var b = _step.value;
                            var i = b.index;
                            expanded[i] = {
                                left: b.x1New,
                                top: 0,
                                right: b.x2New,
                                bottom: 0
                            };
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    boxes.map(function(box, i) {
                        var e = expanded[i], b = bounds[i];
                        b.x1 = box.top;
                        b.y1 = width - e.right;
                        b.x2 = box.bottom;
                        b.y2 = width - e.left;
                        b.index = i;
                        b.x1New = undefined;
                        b.x2New = undefined;
                    });
                    expandBoundsLTR(height, bounds);
                    var _iterator2 = _createForOfIteratorHelper(bounds), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _b = _step2.value;
                            var _i2 = _b.index;
                            expanded[_i2].top = _b.x1New;
                            expanded[_i2].bottom = _b.x2New;
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    return expanded;
                }
                function expandBoundsLTR(width, bounds) {
                    bounds.sort(function(a, b) {
                        return a.x1 - b.x1 || a.index - b.index;
                    });
                    var fakeBoundary = {
                        x1: -Infinity,
                        y1: -Infinity,
                        x2: 0,
                        y2: Infinity,
                        index: -1,
                        x1New: 0,
                        x2New: 0
                    };
                    var horizon = [
                        {
                            start: -Infinity,
                            end: Infinity,
                            boundary: fakeBoundary
                        }
                    ];
                    var _iterator3 = _createForOfIteratorHelper(bounds), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var boundary = _step3.value;
                            var i = 0;
                            while(i < horizon.length && horizon[i].end <= boundary.y1)i++;
                            var j = horizon.length - 1;
                            while(j >= 0 && horizon[j].start >= boundary.y2)j--;
                            var _horizonPart = void 0, _affectedBoundary = void 0;
                            var q = void 0, k = void 0, maxXNew = -Infinity;
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                var xNew = void 0;
                                if (_affectedBoundary.x2 > boundary.x1) xNew = _affectedBoundary.index > boundary.index ? _affectedBoundary.x1New : boundary.x1;
                                else if (_affectedBoundary.x2New === undefined) xNew = (_affectedBoundary.x2 + boundary.x1) / 2;
                                else xNew = _affectedBoundary.x2New;
                                if (xNew > maxXNew) maxXNew = xNew;
                            }
                            boundary.x1New = maxXNew;
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                if (_affectedBoundary.x2New === undefined) {
                                    if (_affectedBoundary.x2 > boundary.x1) {
                                        if (_affectedBoundary.index > boundary.index) _affectedBoundary.x2New = _affectedBoundary.x2;
                                    } else _affectedBoundary.x2New = maxXNew;
                                } else if (_affectedBoundary.x2New > maxXNew) _affectedBoundary.x2New = Math.max(maxXNew, _affectedBoundary.x2);
                            }
                            var changedHorizon = [];
                            var lastBoundary = null;
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                var useBoundary = _affectedBoundary.x2 > boundary.x2 ? _affectedBoundary : boundary;
                                if (lastBoundary === useBoundary) changedHorizon[changedHorizon.length - 1].end = _horizonPart.end;
                                else {
                                    changedHorizon.push({
                                        start: _horizonPart.start,
                                        end: _horizonPart.end,
                                        boundary: useBoundary
                                    });
                                    lastBoundary = useBoundary;
                                }
                            }
                            if (horizon[i].start < boundary.y1) {
                                changedHorizon[0].start = boundary.y1;
                                changedHorizon.unshift({
                                    start: horizon[i].start,
                                    end: boundary.y1,
                                    boundary: horizon[i].boundary
                                });
                            }
                            if (boundary.y2 < horizon[j].end) {
                                changedHorizon[changedHorizon.length - 1].end = boundary.y2;
                                changedHorizon.push({
                                    start: boundary.y2,
                                    end: horizon[j].end,
                                    boundary: horizon[j].boundary
                                });
                            }
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                if (_affectedBoundary.x2New !== undefined) continue;
                                var used = false;
                                for(k = i - 1; !used && k >= 0 && horizon[k].start >= _affectedBoundary.y1; k--)used = horizon[k].boundary === _affectedBoundary;
                                for(k = j + 1; !used && k < horizon.length && horizon[k].end <= _affectedBoundary.y2; k++)used = horizon[k].boundary === _affectedBoundary;
                                for(k = 0; !used && k < changedHorizon.length; k++)used = changedHorizon[k].boundary === _affectedBoundary;
                                if (!used) _affectedBoundary.x2New = maxXNew;
                            }
                            Array.prototype.splice.apply(horizon, [
                                i,
                                j - i + 1
                            ].concat(changedHorizon));
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                    for(var _i3 = 0, _horizon = horizon; _i3 < _horizon.length; _i3++){
                        var horizonPart = _horizon[_i3];
                        var affectedBoundary = horizonPart.boundary;
                        if (affectedBoundary.x2New === undefined) affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
                    }
                }
                var TextLayerRenderTask = /*#__PURE__*/ function() {
                    function TextLayerRenderTask(_ref) {
                        var _globalThis$FontInspe, _this = this;
                        var textContent = _ref.textContent, textContentStream = _ref.textContentStream, container = _ref.container, viewport = _ref.viewport, textDivs = _ref.textDivs, textContentItemsStr = _ref.textContentItemsStr, enhanceTextSelection = _ref.enhanceTextSelection;
                        _classCallCheck(this, TextLayerRenderTask);
                        this._textContent = textContent;
                        this._textContentStream = textContentStream;
                        this._container = container;
                        this._document = container.ownerDocument;
                        this._viewport = viewport;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._enhanceTextSelection = !!enhanceTextSelection;
                        this._fontInspectorEnabled = !!((_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled);
                        this._reader = null;
                        this._layoutTextLastFontSize = null;
                        this._layoutTextLastFontFamily = null;
                        this._layoutTextCtx = null;
                        this._textDivProperties = new WeakMap();
                        this._renderingDone = false;
                        this._canceled = false;
                        this._capability = (0, _util.createPromiseCapability)();
                        this._renderTimer = null;
                        this._bounds = [];
                        this._capability.promise["finally"](function() {
                            if (!_this._enhanceTextSelection) _this._textDivProperties = null;
                            if (_this._layoutTextCtx) {
                                _this._layoutTextCtx.canvas.width = 0;
                                _this._layoutTextCtx.canvas.height = 0;
                                _this._layoutTextCtx = null;
                            }
                        })["catch"](function() {});
                    }
                    _createClass(TextLayerRenderTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                this._canceled = true;
                                if (this._reader) {
                                    this._reader.cancel(new _util.AbortException("TextLayer task cancelled."))["catch"](function() {});
                                    this._reader = null;
                                }
                                if (this._renderTimer !== null) {
                                    clearTimeout(this._renderTimer);
                                    this._renderTimer = null;
                                }
                                this._capability.reject(new Error("TextLayer task cancelled."));
                            }
                        },
                        {
                            key: "_processItems",
                            value: function _processItems(items, styleCache) {
                                for(var i = 0, len = items.length; i < len; i++){
                                    if (items[i].str === undefined) {
                                        if (items[i].type === "beginMarkedContentProps" || items[i].type === "beginMarkedContent") {
                                            var parent = this._container;
                                            this._container = document.createElement("span");
                                            this._container.classList.add("markedContent");
                                            if (items[i].id !== null) this._container.setAttribute("id", "".concat(items[i].id));
                                            parent.appendChild(this._container);
                                        } else if (items[i].type === "endMarkedContent") this._container = this._container.parentNode;
                                        continue;
                                    }
                                    this._textContentItemsStr.push(items[i].str);
                                    appendText(this, items[i], styleCache, this._layoutTextCtx);
                                }
                            }
                        },
                        {
                            key: "_layoutText",
                            value: function _layoutText(textDiv) {
                                var textDivProperties = this._textDivProperties.get(textDiv);
                                var transform = "";
                                if (textDivProperties.canvasWidth !== 0 && textDivProperties.hasText) {
                                    var _textDiv$style = textDiv.style, fontSize = _textDiv$style.fontSize, fontFamily = _textDiv$style.fontFamily;
                                    if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
                                        this._layoutTextCtx.font = "".concat(fontSize, " ").concat(fontFamily);
                                        this._layoutTextLastFontSize = fontSize;
                                        this._layoutTextLastFontFamily = fontFamily;
                                    }
                                    var _this$_layoutTextCtx$ = this._layoutTextCtx.measureText(textDiv.textContent), width = _this$_layoutTextCtx$.width;
                                    if (width > 0) {
                                        var scale = textDivProperties.canvasWidth / width;
                                        if (this._enhanceTextSelection) textDivProperties.scale = scale;
                                        transform = "scaleX(".concat(scale, ")");
                                    }
                                }
                                if (textDivProperties.angle !== 0) transform = "rotate(".concat(textDivProperties.angle, "deg) ").concat(transform);
                                if (transform.length > 0) {
                                    if (this._enhanceTextSelection) textDivProperties.originalTransform = transform;
                                    textDiv.style.transform = transform;
                                }
                                if (textDivProperties.hasText) this._container.appendChild(textDiv);
                                if (textDivProperties.hasEOL) {
                                    var br = document.createElement("br");
                                    br.setAttribute("role", "presentation");
                                    this._container.appendChild(br);
                                }
                            }
                        },
                        {
                            key: "_render",
                            value: function _render() {
                                var _this2 = this;
                                var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                                var capability = (0, _util.createPromiseCapability)();
                                var styleCache = Object.create(null);
                                var canvas = this._document.createElement("canvas");
                                canvas.height = canvas.width = DEFAULT_FONT_SIZE;
                                canvas.mozOpaque = true;
                                this._layoutTextCtx = canvas.getContext("2d", {
                                    alpha: false
                                });
                                if (this._textContent) {
                                    var textItems = this._textContent.items;
                                    var textStyles = this._textContent.styles;
                                    this._processItems(textItems, textStyles);
                                    capability.resolve();
                                } else if (this._textContentStream) {
                                    var pump = function pump() {
                                        _this2._reader.read().then(function(_ref2) {
                                            var value = _ref2.value, done = _ref2.done;
                                            if (done) {
                                                capability.resolve();
                                                return;
                                            }
                                            Object.assign(styleCache, value.styles);
                                            _this2._processItems(value.items, styleCache);
                                            pump();
                                        }, capability.reject);
                                    };
                                    this._reader = this._textContentStream.getReader();
                                    pump();
                                } else throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                                capability.promise.then(function() {
                                    styleCache = null;
                                    if (!timeout) render(_this2);
                                    else _this2._renderTimer = setTimeout(function() {
                                        render(_this2);
                                        _this2._renderTimer = null;
                                    }, timeout);
                                }, this._capability.reject);
                            }
                        },
                        {
                            key: "expandTextDivs",
                            value: function expandTextDivs() {
                                var expandDivs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this._enhanceTextSelection || !this._renderingDone) return;
                                if (this._bounds !== null) {
                                    expand(this);
                                    this._bounds = null;
                                }
                                var transformBuf = [], paddingBuf = [];
                                for(var i = 0, ii = this._textDivs.length; i < ii; i++){
                                    var div = this._textDivs[i];
                                    var divProps = this._textDivProperties.get(div);
                                    if (!divProps.hasText) continue;
                                    if (expandDivs) {
                                        transformBuf.length = 0;
                                        paddingBuf.length = 0;
                                        if (divProps.originalTransform) transformBuf.push(divProps.originalTransform);
                                        if (divProps.paddingTop > 0) {
                                            paddingBuf.push("".concat(divProps.paddingTop, "px"));
                                            transformBuf.push("translateY(".concat(-divProps.paddingTop, "px)"));
                                        } else paddingBuf.push(0);
                                        if (divProps.paddingRight > 0) paddingBuf.push("".concat(divProps.paddingRight / divProps.scale, "px"));
                                        else paddingBuf.push(0);
                                        if (divProps.paddingBottom > 0) paddingBuf.push("".concat(divProps.paddingBottom, "px"));
                                        else paddingBuf.push(0);
                                        if (divProps.paddingLeft > 0) {
                                            paddingBuf.push("".concat(divProps.paddingLeft / divProps.scale, "px"));
                                            transformBuf.push("translateX(".concat(-divProps.paddingLeft / divProps.scale, "px)"));
                                        } else paddingBuf.push(0);
                                        div.style.padding = paddingBuf.join(" ");
                                        if (transformBuf.length) div.style.transform = transformBuf.join(" ");
                                    } else {
                                        div.style.padding = null;
                                        div.style.transform = divProps.originalTransform;
                                    }
                                }
                            }
                        }
                    ]);
                    return TextLayerRenderTask;
                }();
                function renderTextLayer(renderParameters) {
                    var task = new TextLayerRenderTask({
                        textContent: renderParameters.textContent,
                        textContentStream: renderParameters.textContentStream,
                        container: renderParameters.container,
                        viewport: renderParameters.viewport,
                        textDivs: renderParameters.textDivs,
                        textContentItemsStr: renderParameters.textContentItemsStr,
                        enhanceTextSelection: renderParameters.enhanceTextSelection
                    });
                    task._render(renderParameters.timeout);
                    return task;
                }
            /***/ },
            /* 152 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _is_node = __w_pdfjs_require__(6);
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var SVGGraphics = function SVGGraphics() {
                    _classCallCheck(this, SVGGraphics);
                    (0, _util.unreachable)("Not implemented: SVGGraphics");
                };
                exports.SVGGraphics = SVGGraphics;
                var opListToTree = function opListToTree(opList) {
                    var opTree = [];
                    var tmp = [];
                    var _iterator = _createForOfIteratorHelper(opList), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var opListElement = _step.value;
                            if (opListElement.fn === "save") {
                                opTree.push({
                                    fnId: 92,
                                    fn: "group",
                                    items: []
                                });
                                tmp.push(opTree);
                                opTree = opTree[opTree.length - 1].items;
                                continue;
                            }
                            if (opListElement.fn === "restore") opTree = tmp.pop();
                            else opTree.push(opListElement);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return opTree;
                };
                var pf = function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    var s = value.toFixed(10);
                    var i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                };
                var pm = function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return "scale(".concat(pf(m[0]), " ").concat(pf(m[3]), ")");
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            var a = Math.acos(m[0]) * 180 / Math.PI;
                            return "rotate(".concat(pf(a), ")");
                        }
                    } else {
                        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return "translate(".concat(pf(m[4]), " ").concat(pf(m[5]), ")");
                    }
                    return "matrix(".concat(pf(m[0]), " ").concat(pf(m[1]), " ").concat(pf(m[2]), " ").concat(pf(m[3]), " ").concat(pf(m[4]), " ") + "".concat(pf(m[5]), ")");
                };
                var SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                var XML_NS = "http://www.w3.org/XML/1998/namespace";
                var XLINK_NS = "http://www.w3.org/1999/xlink";
                var LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var convertImgDataToPng = function() {
                    var PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    var CHUNK_WRAPPER_SIZE = 12;
                    var crcTable = new Int32Array(256);
                    for(var i = 0; i < 256; i++){
                        var c = i;
                        for(var h = 0; h < 8; h++)if (c & 1) c = 0xedb88320 ^ c >> 1 & 0x7fffffff;
                        else c = c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        var crc = -1;
                        for(var _i = start; _i < end; _i++){
                            var a = (crc ^ data[_i]) & 0xff;
                            var b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        var p = offset;
                        var len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        var crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        var a = 1;
                        var b = 0;
                        for(var _i2 = start; _i2 < end; ++_i2){
                            a = (a + (data[_i2] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_is_node.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            var input;
                            if (parseInt($17tgv.versions.node) >= 8) input = literals;
                            else input = $55a8cc56a2378350$require$Buffer.from(literals);
                            var output = (parcelRequire("gFNhN")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        var len = literals.length;
                        var maxBlockLength = 0xffff;
                        var deflateBlocks = Math.ceil(len / maxBlockLength);
                        var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        var pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        var pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        var adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        var width = imgData.width;
                        var height = imgData.height;
                        var bitDepth, colorType, lineSize;
                        var bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        var literals = new Uint8Array((1 + lineSize) * height);
                        var offsetLiterals = 0, offsetBytes = 0;
                        for(var y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(var _y = 0; _y < height; _y++){
                                offsetLiterals++;
                                for(var _i3 = 0; _i3 < lineSize; _i3++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        var ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        var idat = deflateSync(literals);
                        var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        var data = new Uint8Array(pngLength);
                        var offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return (0, _util.createObjectURL)(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                var SVGExtraState = /*#__PURE__*/ function() {
                    function SVGExtraState() {
                        _classCallCheck(this, SVGExtraState);
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    _createClass(SVGExtraState, [
                        {
                            key: "clone",
                            value: function clone() {
                                return Object.create(this);
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint(x, y) {
                                this.x = x;
                                this.y = y;
                            }
                        }
                    ]);
                    return SVGExtraState;
                }();
                var clipCount = 0;
                var maskCount = 0;
                var shadingCount = 0;
                exports.SVGGraphics = SVGGraphics = /*#__PURE__*/ function() {
                    function SVGGraphics(commonObjs, objs) {
                        var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        _classCallCheck(this, SVGGraphics);
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(var op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    _createClass(SVGGraphics, [
                        {
                            key: "save",
                            value: function save() {
                                this.transformStack.push(this.transformMatrix);
                                var old = this.current;
                                this.extraStack.push(old);
                                this.current = old.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore() {
                                this.transformMatrix = this.transformStack.pop();
                                this.current = this.extraStack.pop();
                                this.pendingClip = null;
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "group",
                            value: function group(items) {
                                this.save();
                                this.executeOpTree(items);
                                this.restore();
                            }
                        },
                        {
                            key: "loadDependencies",
                            value: function loadDependencies(operatorList) {
                                var _this = this;
                                var fnArray = operatorList.fnArray;
                                var argsArray = operatorList.argsArray;
                                for(var i = 0, ii = fnArray.length; i < ii; i++){
                                    if (fnArray[i] !== _util.OPS.dependency) continue;
                                    var _iterator2 = _createForOfIteratorHelper(argsArray[i]), _step2;
                                    try {
                                        var _loop = function _loop() {
                                            var obj = _step2.value;
                                            var objsPool = obj.startsWith("g_") ? _this.commonObjs : _this.objs;
                                            var promise = new Promise(function(resolve) {
                                                objsPool.get(obj, resolve);
                                            });
                                            _this.current.dependencies.push(promise);
                                        };
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                }
                                return Promise.all(this.current.dependencies);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(a, b, c, d, e, f) {
                                var transformMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "getSVG",
                            value: function getSVG(operatorList, viewport) {
                                var _this2 = this;
                                this.viewport = viewport;
                                var svgElement = this._initialize(viewport);
                                return this.loadDependencies(operatorList).then(function() {
                                    _this2.transformMatrix = _util.IDENTITY_MATRIX;
                                    _this2.executeOpTree(_this2.convertOpList(operatorList));
                                    return svgElement;
                                });
                            }
                        },
                        {
                            key: "convertOpList",
                            value: function convertOpList(operatorList) {
                                var operatorIdMapping = this._operatorIdMapping;
                                var argsArray = operatorList.argsArray;
                                var fnArray = operatorList.fnArray;
                                var opList = [];
                                for(var i = 0, ii = fnArray.length; i < ii; i++){
                                    var fnId = fnArray[i];
                                    opList.push({
                                        fnId: fnId,
                                        fn: operatorIdMapping[fnId],
                                        args: argsArray[i]
                                    });
                                }
                                return opListToTree(opList);
                            }
                        },
                        {
                            key: "executeOpTree",
                            value: function executeOpTree(opTree) {
                                var _iterator3 = _createForOfIteratorHelper(opTree), _step3;
                                try {
                                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                        var opTreeElement = _step3.value;
                                        var fn = opTreeElement.fn;
                                        var fnId = opTreeElement.fnId;
                                        var args = opTreeElement.args;
                                        switch(fnId | 0){
                                            case _util.OPS.beginText:
                                                this.beginText();
                                                break;
                                            case _util.OPS.dependency:
                                                break;
                                            case _util.OPS.setLeading:
                                                this.setLeading(args);
                                                break;
                                            case _util.OPS.setLeadingMoveText:
                                                this.setLeadingMoveText(args[0], args[1]);
                                                break;
                                            case _util.OPS.setFont:
                                                this.setFont(args);
                                                break;
                                            case _util.OPS.showText:
                                                this.showText(args[0]);
                                                break;
                                            case _util.OPS.showSpacedText:
                                                this.showText(args[0]);
                                                break;
                                            case _util.OPS.endText:
                                                this.endText();
                                                break;
                                            case _util.OPS.moveText:
                                                this.moveText(args[0], args[1]);
                                                break;
                                            case _util.OPS.setCharSpacing:
                                                this.setCharSpacing(args[0]);
                                                break;
                                            case _util.OPS.setWordSpacing:
                                                this.setWordSpacing(args[0]);
                                                break;
                                            case _util.OPS.setHScale:
                                                this.setHScale(args[0]);
                                                break;
                                            case _util.OPS.setTextMatrix:
                                                this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                                break;
                                            case _util.OPS.setTextRise:
                                                this.setTextRise(args[0]);
                                                break;
                                            case _util.OPS.setTextRenderingMode:
                                                this.setTextRenderingMode(args[0]);
                                                break;
                                            case _util.OPS.setLineWidth:
                                                this.setLineWidth(args[0]);
                                                break;
                                            case _util.OPS.setLineJoin:
                                                this.setLineJoin(args[0]);
                                                break;
                                            case _util.OPS.setLineCap:
                                                this.setLineCap(args[0]);
                                                break;
                                            case _util.OPS.setMiterLimit:
                                                this.setMiterLimit(args[0]);
                                                break;
                                            case _util.OPS.setFillRGBColor:
                                                this.setFillRGBColor(args[0], args[1], args[2]);
                                                break;
                                            case _util.OPS.setStrokeRGBColor:
                                                this.setStrokeRGBColor(args[0], args[1], args[2]);
                                                break;
                                            case _util.OPS.setStrokeColorN:
                                                this.setStrokeColorN(args);
                                                break;
                                            case _util.OPS.setFillColorN:
                                                this.setFillColorN(args);
                                                break;
                                            case _util.OPS.shadingFill:
                                                this.shadingFill(args[0]);
                                                break;
                                            case _util.OPS.setDash:
                                                this.setDash(args[0], args[1]);
                                                break;
                                            case _util.OPS.setRenderingIntent:
                                                this.setRenderingIntent(args[0]);
                                                break;
                                            case _util.OPS.setFlatness:
                                                this.setFlatness(args[0]);
                                                break;
                                            case _util.OPS.setGState:
                                                this.setGState(args[0]);
                                                break;
                                            case _util.OPS.fill:
                                                this.fill();
                                                break;
                                            case _util.OPS.eoFill:
                                                this.eoFill();
                                                break;
                                            case _util.OPS.stroke:
                                                this.stroke();
                                                break;
                                            case _util.OPS.fillStroke:
                                                this.fillStroke();
                                                break;
                                            case _util.OPS.eoFillStroke:
                                                this.eoFillStroke();
                                                break;
                                            case _util.OPS.clip:
                                                this.clip("nonzero");
                                                break;
                                            case _util.OPS.eoClip:
                                                this.clip("evenodd");
                                                break;
                                            case _util.OPS.paintSolidColorImageMask:
                                                this.paintSolidColorImageMask();
                                                break;
                                            case _util.OPS.paintImageXObject:
                                                this.paintImageXObject(args[0]);
                                                break;
                                            case _util.OPS.paintInlineImageXObject:
                                                this.paintInlineImageXObject(args[0]);
                                                break;
                                            case _util.OPS.paintImageMaskXObject:
                                                this.paintImageMaskXObject(args[0]);
                                                break;
                                            case _util.OPS.paintFormXObjectBegin:
                                                this.paintFormXObjectBegin(args[0], args[1]);
                                                break;
                                            case _util.OPS.paintFormXObjectEnd:
                                                this.paintFormXObjectEnd();
                                                break;
                                            case _util.OPS.closePath:
                                                this.closePath();
                                                break;
                                            case _util.OPS.closeStroke:
                                                this.closeStroke();
                                                break;
                                            case _util.OPS.closeFillStroke:
                                                this.closeFillStroke();
                                                break;
                                            case _util.OPS.closeEOFillStroke:
                                                this.closeEOFillStroke();
                                                break;
                                            case _util.OPS.nextLine:
                                                this.nextLine();
                                                break;
                                            case _util.OPS.transform:
                                                this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                                break;
                                            case _util.OPS.constructPath:
                                                this.constructPath(args[0], args[1]);
                                                break;
                                            case _util.OPS.endPath:
                                                this.endPath();
                                                break;
                                            case 92:
                                                this.group(opTreeElement.items);
                                                break;
                                            default:
                                                (0, _util.warn)("Unimplemented operator ".concat(fn));
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator3.e(err);
                                } finally{
                                    _iterator3.f();
                                }
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing(wordSpacing) {
                                this.current.wordSpacing = wordSpacing;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing(charSpacing) {
                                this.current.charSpacing = charSpacing;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix(a, b, c, d, e, f) {
                                var current = this.current;
                                current.textMatrix = current.lineMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                current.textMatrixScale = Math.hypot(a, b);
                                current.x = current.lineX = 0;
                                current.y = current.lineY = 0;
                                current.xcoords = [];
                                current.ycoords = [];
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                current.txtElement = this.svgFactory.createElement("svg:text");
                                current.txtElement.appendChild(current.tspan);
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText() {
                                var current = this.current;
                                current.x = current.lineX = 0;
                                current.y = current.lineY = 0;
                                current.textMatrix = _util.IDENTITY_MATRIX;
                                current.lineMatrix = _util.IDENTITY_MATRIX;
                                current.textMatrixScale = 1;
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.txtElement = this.svgFactory.createElement("svg:text");
                                current.txtgrp = this.svgFactory.createElement("svg:g");
                                current.xcoords = [];
                                current.ycoords = [];
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText(x, y) {
                                var current = this.current;
                                current.x = current.lineX += x;
                                current.y = current.lineY += y;
                                current.xcoords = [];
                                current.ycoords = [];
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                            }
                        },
                        {
                            key: "showText",
                            value: function showText(glyphs) {
                                var current = this.current;
                                var font = current.font;
                                var fontSize = current.fontSize;
                                if (fontSize === 0) return;
                                var fontSizeScale = current.fontSizeScale;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var fontDirection = current.fontDirection;
                                var textHScale = current.textHScale * fontDirection;
                                var vertical = font.vertical;
                                var spacingDir = vertical ? 1 : -1;
                                var defaultVMetrics = font.defaultVMetrics;
                                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                                var x = 0;
                                var _iterator4 = _createForOfIteratorHelper(glyphs), _step4;
                                try {
                                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                        var glyph = _step4.value;
                                        if (glyph === null) {
                                            x += fontDirection * wordSpacing;
                                            continue;
                                        } else if ((0, _util.isNum)(glyph)) {
                                            x += spacingDir * glyph * fontSize / 1000;
                                            continue;
                                        }
                                        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                        var character = glyph.fontChar;
                                        var scaledX = void 0, scaledY = void 0;
                                        var width = glyph.width;
                                        if (vertical) {
                                            var vx = void 0;
                                            var vmetric = glyph.vmetric || defaultVMetrics;
                                            vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                            vx = -vx * widthAdvanceScale;
                                            var vy = vmetric[2] * widthAdvanceScale;
                                            width = vmetric ? -vmetric[0] : width;
                                            scaledX = vx / fontSizeScale;
                                            scaledY = (x + vy) / fontSizeScale;
                                        } else {
                                            scaledX = x / fontSizeScale;
                                            scaledY = 0;
                                        }
                                        if (glyph.isInFont || font.missingFile) {
                                            current.xcoords.push(current.x + scaledX);
                                            if (vertical) current.ycoords.push(-current.y + scaledY);
                                            current.tspan.textContent += character;
                                        }
                                        var charWidth = void 0;
                                        if (vertical) charWidth = width * widthAdvanceScale - spacing * fontDirection;
                                        else charWidth = width * widthAdvanceScale + spacing * fontDirection;
                                        x += charWidth;
                                    }
                                } catch (err) {
                                    _iterator4.e(err);
                                } finally{
                                    _iterator4.f();
                                }
                                current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                                if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                                else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                if (vertical) current.y -= x;
                                else current.x += x * textHScale;
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                                if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                                var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                    if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                                    if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                                } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                                else current.tspan.setAttributeNS(null, "fill", "none");
                                if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                    var lineWidthScale = 1 / (current.textMatrixScale || 1);
                                    this._setStrokeAttributes(current.tspan, lineWidthScale);
                                }
                                var textMatrix = current.textMatrix;
                                if (current.textRise !== 0) {
                                    textMatrix = textMatrix.slice();
                                    textMatrix[5] += current.textRise;
                                }
                                current.txtElement.setAttributeNS(null, "transform", "".concat(pm(textMatrix), " scale(").concat(pf(textHScale), ", -1)"));
                                current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                                current.txtElement.appendChild(current.tspan);
                                current.txtgrp.appendChild(current.txtElement);
                                this._ensureTransformGroup().appendChild(current.txtElement);
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText(x, y) {
                                this.setLeading(-y);
                                this.moveText(x, y);
                            }
                        },
                        {
                            key: "addFontStyle",
                            value: function addFontStyle(fontObj) {
                                if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                                if (!this.cssStyle) {
                                    this.cssStyle = this.svgFactory.createElement("svg:style");
                                    this.cssStyle.setAttributeNS(null, "type", "text/css");
                                    this.defs.appendChild(this.cssStyle);
                                }
                                var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                                this.cssStyle.textContent += "@font-face { font-family: \"".concat(fontObj.loadedName, "\";") + " src: url(".concat(url, "); }\n");
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont(details) {
                                var current = this.current;
                                var fontObj = this.commonObjs.get(details[0]);
                                var size = details[1];
                                current.font = fontObj;
                                if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                                    this.addFontStyle(fontObj);
                                    this.embeddedFonts[fontObj.loadedName] = fontObj;
                                }
                                current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                var bold = "normal";
                                if (fontObj.black) bold = "900";
                                else if (fontObj.bold) bold = "bold";
                                var italic = fontObj.italic ? "italic" : "normal";
                                if (size < 0) {
                                    size = -size;
                                    current.fontDirection = -1;
                                } else current.fontDirection = 1;
                                current.fontSize = size;
                                current.fontFamily = fontObj.loadedName;
                                current.fontWeight = bold;
                                current.fontStyle = italic;
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                current.xcoords = [];
                                current.ycoords = [];
                            }
                        },
                        {
                            key: "endText",
                            value: function endText() {
                                var _current$txtElement;
                                var current = this.current;
                                if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && (_current$txtElement = current.txtElement) !== null && _current$txtElement !== void 0 && _current$txtElement.hasChildNodes()) {
                                    current.element = current.txtElement;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth(width) {
                                if (width > 0) this.current.lineWidth = width;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap(style) {
                                this.current.lineCap = LINE_CAP_STYLES[style];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin(style) {
                                this.current.lineJoin = LINE_JOIN_STYLES[style];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit(limit) {
                                this.current.miterLimit = limit;
                            }
                        },
                        {
                            key: "setStrokeAlpha",
                            value: function setStrokeAlpha(strokeAlpha) {
                                this.current.strokeAlpha = strokeAlpha;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor(r, g, b) {
                                this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                            }
                        },
                        {
                            key: "setFillAlpha",
                            value: function setFillAlpha(fillAlpha) {
                                this.current.fillAlpha = fillAlpha;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor(r, g, b) {
                                this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                                this.current.tspan = this.svgFactory.createElement("svg:tspan");
                                this.current.xcoords = [];
                                this.current.ycoords = [];
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN(args) {
                                this.current.strokeColor = this._makeColorN_Pattern(args);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN(args) {
                                this.current.fillColor = this._makeColorN_Pattern(args);
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill(args) {
                                var width = this.viewport.width;
                                var height = this.viewport.height;
                                var inv = _util.Util.inverseTransform(this.transformMatrix);
                                var bl = _util.Util.applyTransform([
                                    0,
                                    0
                                ], inv);
                                var br = _util.Util.applyTransform([
                                    0,
                                    height
                                ], inv);
                                var ul = _util.Util.applyTransform([
                                    width,
                                    0
                                ], inv);
                                var ur = _util.Util.applyTransform([
                                    width,
                                    height
                                ], inv);
                                var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                                var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                                var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                                var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", x0);
                                rect.setAttributeNS(null, "y", y0);
                                rect.setAttributeNS(null, "width", x1 - x0);
                                rect.setAttributeNS(null, "height", y1 - y0);
                                rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                                if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                                this._ensureTransformGroup().appendChild(rect);
                            }
                        },
                        {
                            key: "_makeColorN_Pattern",
                            value: function _makeColorN_Pattern(args) {
                                if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                                return this._makeShadingPattern(args);
                            }
                        },
                        {
                            key: "_makeTilingPattern",
                            value: function _makeTilingPattern(args) {
                                var color = args[1];
                                var operatorList = args[2];
                                var matrix = args[3] || _util.IDENTITY_MATRIX;
                                var _args$ = _slicedToArray(args[4], 4), x0 = _args$[0], y0 = _args$[1], x1 = _args$[2], y1 = _args$[3];
                                var xstep = args[5];
                                var ystep = args[6];
                                var paintType = args[7];
                                var tilingId = "shading".concat(shadingCount++);
                                var _Util$normalizeRect = _util.Util.normalizeRect([].concat(_toConsumableArray(_util.Util.applyTransform([
                                    x0,
                                    y0
                                ], matrix)), _toConsumableArray(_util.Util.applyTransform([
                                    x1,
                                    y1
                                ], matrix)))), _Util$normalizeRect2 = _slicedToArray(_Util$normalizeRect, 4), tx0 = _Util$normalizeRect2[0], ty0 = _Util$normalizeRect2[1], tx1 = _Util$normalizeRect2[2], ty1 = _Util$normalizeRect2[3];
                                var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(matrix), _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2), xscale = _Util$singularValueDe2[0], yscale = _Util$singularValueDe2[1];
                                var txstep = xstep * xscale;
                                var tystep = ystep * yscale;
                                var tiling = this.svgFactory.createElement("svg:pattern");
                                tiling.setAttributeNS(null, "id", tilingId);
                                tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                                tiling.setAttributeNS(null, "width", txstep);
                                tiling.setAttributeNS(null, "height", tystep);
                                tiling.setAttributeNS(null, "x", "".concat(tx0));
                                tiling.setAttributeNS(null, "y", "".concat(ty0));
                                var svg = this.svg;
                                var transformMatrix = this.transformMatrix;
                                var fillColor = this.current.fillColor;
                                var strokeColor = this.current.strokeColor;
                                var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                                this.svg = bbox;
                                this.transformMatrix = matrix;
                                if (paintType === 2) {
                                    var cssColor = _util.Util.makeHexColor.apply(_util.Util, _toConsumableArray(color));
                                    this.current.fillColor = cssColor;
                                    this.current.strokeColor = cssColor;
                                }
                                this.executeOpTree(this.convertOpList(operatorList));
                                this.svg = svg;
                                this.transformMatrix = transformMatrix;
                                this.current.fillColor = fillColor;
                                this.current.strokeColor = strokeColor;
                                tiling.appendChild(bbox.childNodes[0]);
                                this.defs.appendChild(tiling);
                                return "url(#".concat(tilingId, ")");
                            }
                        },
                        {
                            key: "_makeShadingPattern",
                            value: function _makeShadingPattern(args) {
                                if (typeof args === "string") args = this.objs.get(args);
                                switch(args[0]){
                                    case "RadialAxial":
                                        var shadingId = "shading".concat(shadingCount++);
                                        var colorStops = args[3];
                                        var gradient;
                                        switch(args[1]){
                                            case "axial":
                                                var point0 = args[4];
                                                var point1 = args[5];
                                                gradient = this.svgFactory.createElement("svg:linearGradient");
                                                gradient.setAttributeNS(null, "id", shadingId);
                                                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient.setAttributeNS(null, "x1", point0[0]);
                                                gradient.setAttributeNS(null, "y1", point0[1]);
                                                gradient.setAttributeNS(null, "x2", point1[0]);
                                                gradient.setAttributeNS(null, "y2", point1[1]);
                                                break;
                                            case "radial":
                                                var focalPoint = args[4];
                                                var circlePoint = args[5];
                                                var focalRadius = args[6];
                                                var circleRadius = args[7];
                                                gradient = this.svgFactory.createElement("svg:radialGradient");
                                                gradient.setAttributeNS(null, "id", shadingId);
                                                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                                gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                                gradient.setAttributeNS(null, "r", circleRadius);
                                                gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                                gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                                gradient.setAttributeNS(null, "fr", focalRadius);
                                                break;
                                            default:
                                                throw new Error("Unknown RadialAxial type: ".concat(args[1]));
                                        }
                                        var _iterator5 = _createForOfIteratorHelper(colorStops), _step5;
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                var colorStop = _step5.value;
                                                var stop = this.svgFactory.createElement("svg:stop");
                                                stop.setAttributeNS(null, "offset", colorStop[0]);
                                                stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                                gradient.appendChild(stop);
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        this.defs.appendChild(gradient);
                                        return "url(#".concat(shadingId, ")");
                                    case "Mesh":
                                        (0, _util.warn)("Unimplemented pattern Mesh");
                                        return null;
                                    case "Dummy":
                                        return "hotpink";
                                    default:
                                        throw new Error("Unknown IR type: ".concat(args[0]));
                                }
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash(dashArray, dashPhase) {
                                this.current.dashArray = dashArray;
                                this.current.dashPhase = dashPhase;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath(ops, args) {
                                var current = this.current;
                                var x = current.x, y = current.y;
                                var d = [];
                                var j = 0;
                                var _iterator6 = _createForOfIteratorHelper(ops), _step6;
                                try {
                                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                        var op = _step6.value;
                                        switch(op | 0){
                                            case _util.OPS.rectangle:
                                                x = args[j++];
                                                y = args[j++];
                                                var width = args[j++];
                                                var height = args[j++];
                                                var xw = x + width;
                                                var yh = y + height;
                                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                                break;
                                            case _util.OPS.moveTo:
                                                x = args[j++];
                                                y = args[j++];
                                                d.push("M", pf(x), pf(y));
                                                break;
                                            case _util.OPS.lineTo:
                                                x = args[j++];
                                                y = args[j++];
                                                d.push("L", pf(x), pf(y));
                                                break;
                                            case _util.OPS.curveTo:
                                                x = args[j + 4];
                                                y = args[j + 5];
                                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                                j += 6;
                                                break;
                                            case _util.OPS.curveTo2:
                                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                                x = args[j + 2];
                                                y = args[j + 3];
                                                j += 4;
                                                break;
                                            case _util.OPS.curveTo3:
                                                x = args[j + 2];
                                                y = args[j + 3];
                                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                                j += 4;
                                                break;
                                            case _util.OPS.closePath:
                                                d.push("Z");
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator6.e(err);
                                } finally{
                                    _iterator6.f();
                                }
                                d = d.join(" ");
                                if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                                else {
                                    current.path = this.svgFactory.createElement("svg:path");
                                    this._ensureTransformGroup().appendChild(current.path);
                                }
                                current.path.setAttributeNS(null, "d", d);
                                current.path.setAttributeNS(null, "fill", "none");
                                current.element = current.path;
                                current.setCurrentPoint(x, y);
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath() {
                                var current = this.current;
                                current.path = null;
                                if (!this.pendingClip) return;
                                if (!current.element) {
                                    this.pendingClip = null;
                                    return;
                                }
                                var clipId = "clippath".concat(clipCount++);
                                var clipPath = this.svgFactory.createElement("svg:clipPath");
                                clipPath.setAttributeNS(null, "id", clipId);
                                clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                                var clipElement = current.element.cloneNode(true);
                                if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                                else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                                this.pendingClip = null;
                                clipPath.appendChild(clipElement);
                                this.defs.appendChild(clipPath);
                                if (current.activeClipUrl) {
                                    current.clipGroup = null;
                                    var _iterator7 = _createForOfIteratorHelper(this.extraStack), _step7;
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            var prev = _step7.value;
                                            prev.clipGroup = null;
                                        }
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                                }
                                current.activeClipUrl = "url(#".concat(clipId, ")");
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "clip",
                            value: function clip(type) {
                                this.pendingClip = type;
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath() {
                                var current = this.current;
                                if (current.path) {
                                    var d = "".concat(current.path.getAttributeNS(null, "d"), "Z");
                                    current.path.setAttributeNS(null, "d", d);
                                }
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading(leading) {
                                this.current.leading = -leading;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise(textRise) {
                                this.current.textRise = textRise;
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode(textRenderingMode) {
                                this.current.textRenderingMode = textRenderingMode;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale(scale) {
                                this.current.textHScale = scale / 100;
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent(intent) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness(flatness) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState(states) {
                                var _iterator8 = _createForOfIteratorHelper(states), _step8;
                                try {
                                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                        var _step8$value = _slicedToArray(_step8.value, 2), key = _step8$value[0], value = _step8$value[1];
                                        switch(key){
                                            case "LW":
                                                this.setLineWidth(value);
                                                break;
                                            case "LC":
                                                this.setLineCap(value);
                                                break;
                                            case "LJ":
                                                this.setLineJoin(value);
                                                break;
                                            case "ML":
                                                this.setMiterLimit(value);
                                                break;
                                            case "D":
                                                this.setDash(value[0], value[1]);
                                                break;
                                            case "RI":
                                                this.setRenderingIntent(value);
                                                break;
                                            case "FL":
                                                this.setFlatness(value);
                                                break;
                                            case "Font":
                                                this.setFont(value);
                                                break;
                                            case "CA":
                                                this.setStrokeAlpha(value);
                                                break;
                                            case "ca":
                                                this.setFillAlpha(value);
                                                break;
                                            default:
                                                (0, _util.warn)("Unimplemented graphic state operator ".concat(key));
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator8.e(err);
                                } finally{
                                    _iterator8.f();
                                }
                            }
                        },
                        {
                            key: "fill",
                            value: function fill() {
                                var current = this.current;
                                if (current.element) {
                                    current.element.setAttributeNS(null, "fill", current.fillColor);
                                    current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke() {
                                var current = this.current;
                                if (current.element) {
                                    this._setStrokeAttributes(current.element);
                                    current.element.setAttributeNS(null, "fill", "none");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "_setStrokeAttributes",
                            value: function _setStrokeAttributes(element) {
                                var lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                                var current = this.current;
                                var dashArray = current.dashArray;
                                if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                                    return lineWidthScale * value;
                                });
                                element.setAttributeNS(null, "stroke", current.strokeColor);
                                element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                                element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                                element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                                element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                                element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                                element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                                element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill() {
                                if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke() {
                                this.stroke();
                                this.fill();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke() {
                                if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke() {
                                this.closePath();
                                this.eoFillStroke();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask() {
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", "0");
                                rect.setAttributeNS(null, "y", "0");
                                rect.setAttributeNS(null, "width", "1px");
                                rect.setAttributeNS(null, "height", "1px");
                                rect.setAttributeNS(null, "fill", this.current.fillColor);
                                this._ensureTransformGroup().appendChild(rect);
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject(objId) {
                                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
                                    return;
                                }
                                this.paintInlineImageXObject(imgData);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject(imgData, mask) {
                                var width = imgData.width;
                                var height = imgData.height;
                                var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                                var cliprect = this.svgFactory.createElement("svg:rect");
                                cliprect.setAttributeNS(null, "x", "0");
                                cliprect.setAttributeNS(null, "y", "0");
                                cliprect.setAttributeNS(null, "width", pf(width));
                                cliprect.setAttributeNS(null, "height", pf(height));
                                this.current.element = cliprect;
                                this.clip("nonzero");
                                var imgEl = this.svgFactory.createElement("svg:image");
                                imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                                imgEl.setAttributeNS(null, "x", "0");
                                imgEl.setAttributeNS(null, "y", pf(-height));
                                imgEl.setAttributeNS(null, "width", pf(width) + "px");
                                imgEl.setAttributeNS(null, "height", pf(height) + "px");
                                imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / width), " ").concat(pf(-1 / height), ")"));
                                if (mask) mask.appendChild(imgEl);
                                else this._ensureTransformGroup().appendChild(imgEl);
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject(imgData) {
                                var current = this.current;
                                var width = imgData.width;
                                var height = imgData.height;
                                var fillColor = current.fillColor;
                                current.maskId = "mask".concat(maskCount++);
                                var mask = this.svgFactory.createElement("svg:mask");
                                mask.setAttributeNS(null, "id", current.maskId);
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", "0");
                                rect.setAttributeNS(null, "y", "0");
                                rect.setAttributeNS(null, "width", pf(width));
                                rect.setAttributeNS(null, "height", pf(height));
                                rect.setAttributeNS(null, "fill", fillColor);
                                rect.setAttributeNS(null, "mask", "url(#".concat(current.maskId, ")"));
                                this.defs.appendChild(mask);
                                this._ensureTransformGroup().appendChild(rect);
                                this.paintInlineImageXObject(imgData, mask);
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin(matrix, bbox) {
                                if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                                if (bbox) {
                                    var width = bbox[2] - bbox[0];
                                    var height = bbox[3] - bbox[1];
                                    var cliprect = this.svgFactory.createElement("svg:rect");
                                    cliprect.setAttributeNS(null, "x", bbox[0]);
                                    cliprect.setAttributeNS(null, "y", bbox[1]);
                                    cliprect.setAttributeNS(null, "width", pf(width));
                                    cliprect.setAttributeNS(null, "height", pf(height));
                                    this.current.element = cliprect;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd() {}
                        },
                        {
                            key: "_initialize",
                            value: function _initialize(viewport) {
                                var svg = this.svgFactory.create(viewport.width, viewport.height);
                                var definitions = this.svgFactory.createElement("svg:defs");
                                svg.appendChild(definitions);
                                this.defs = definitions;
                                var rootGroup = this.svgFactory.createElement("svg:g");
                                rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                                svg.appendChild(rootGroup);
                                this.svg = rootGroup;
                                return svg;
                            }
                        },
                        {
                            key: "_ensureClipGroup",
                            value: function _ensureClipGroup() {
                                if (!this.current.clipGroup) {
                                    var clipGroup = this.svgFactory.createElement("svg:g");
                                    clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                                    this.svg.appendChild(clipGroup);
                                    this.current.clipGroup = clipGroup;
                                }
                                return this.current.clipGroup;
                            }
                        },
                        {
                            key: "_ensureTransformGroup",
                            value: function _ensureTransformGroup() {
                                if (!this.tgrp) {
                                    this.tgrp = this.svgFactory.createElement("svg:g");
                                    this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                                    if (this.current.activeClipUrl) this._ensureClipGroup().appendChild(this.tgrp);
                                    else this.svg.appendChild(this.tgrp);
                                }
                                return this.tgrp;
                            }
                        }
                    ]);
                    return SVGGraphics;
                }();
            /***/ },
            /* 153 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _network_utils = __w_pdfjs_require__(154);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var fs = (parcelRequire("gFNhN"));
                var http = (parcelRequire("gFNhN"));
                var https = (parcelRequire("gFNhN"));
                var url = (parcelRequire("gFNhN"));
                var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    var parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse("file:///".concat(sourceUrl));
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                var PDFNodeStream = /*#__PURE__*/ function() {
                    function PDFNodeStream(source) {
                        _classCallCheck(this, PDFNodeStream);
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass(PDFNodeStream, [
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this$_fullRequestRea, _this$_fullRequestRea2;
                                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                                this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(start, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                                this._rangeRequestReaders.push(rangeReader);
                                return rangeReader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        }
                    ]);
                    return PDFNodeStream;
                }();
                exports.PDFNodeStream = PDFNodeStream;
                var BaseFullReader = /*#__PURE__*/ function() {
                    function BaseFullReader(stream) {
                        _classCallCheck(this, BaseFullReader);
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        var source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = (0, _util.createPromiseCapability)();
                        this._headersCapability = (0, _util.createPromiseCapability)();
                    }
                    _createClass(BaseFullReader, [
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var chunk, buffer;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                _context.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                if (!this._done) {
                                                    _context.next = 4;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 4:
                                                if (!this._storedError) {
                                                    _context.next = 6;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 6:
                                                chunk = this._readableStream.read();
                                                if (!(chunk === null)) {
                                                    _context.next = 10;
                                                    break;
                                                }
                                                this._readCapability = (0, _util.createPromiseCapability)();
                                                return _context.abrupt("return", this.read());
                                            case 10:
                                                this._loaded += chunk.length;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded,
                                                    total: this._contentLength
                                                });
                                                buffer = new Uint8Array(chunk).buffer;
                                                return _context.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 14:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (!this._readableStream) {
                                    this._error(reason);
                                    return;
                                }
                                this._readableStream.destroy(reason);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error(reason) {
                                this._storedError = reason;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream(readableStream) {
                                var _this = this;
                                this._readableStream = readableStream;
                                readableStream.on("readable", function() {
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("end", function() {
                                    readableStream.destroy();
                                    _this._done = true;
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("error", function(reason) {
                                    _this._error(reason);
                                });
                                if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseFullReader;
                }();
                var BaseRangeReader = /*#__PURE__*/ function() {
                    function BaseRangeReader(stream) {
                        _classCallCheck(this, BaseRangeReader);
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = (0, _util.createPromiseCapability)();
                        var source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    _createClass(BaseRangeReader, [
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var chunk, buffer;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                _context2.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                if (!this._done) {
                                                    _context2.next = 4;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 4:
                                                if (!this._storedError) {
                                                    _context2.next = 6;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 6:
                                                chunk = this._readableStream.read();
                                                if (!(chunk === null)) {
                                                    _context2.next = 10;
                                                    break;
                                                }
                                                this._readCapability = (0, _util.createPromiseCapability)();
                                                return _context2.abrupt("return", this.read());
                                            case 10:
                                                this._loaded += chunk.length;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded
                                                });
                                                buffer = new Uint8Array(chunk).buffer;
                                                return _context2.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 14:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (!this._readableStream) {
                                    this._error(reason);
                                    return;
                                }
                                this._readableStream.destroy(reason);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error(reason) {
                                this._storedError = reason;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream(readableStream) {
                                var _this2 = this;
                                this._readableStream = readableStream;
                                readableStream.on("readable", function() {
                                    _this2._readCapability.resolve();
                                });
                                readableStream.on("end", function() {
                                    readableStream.destroy();
                                    _this2._done = true;
                                    _this2._readCapability.resolve();
                                });
                                readableStream.on("error", function(reason) {
                                    _this2._error(reason);
                                });
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseRangeReader;
                }();
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                var PDFNodeStreamFullReader = /*#__PURE__*/ function(_BaseFullReader) {
                    _inherits(PDFNodeStreamFullReader, _BaseFullReader);
                    var _super = _createSuper(PDFNodeStreamFullReader);
                    function PDFNodeStreamFullReader(stream) {
                        var _this3;
                        _classCallCheck(this, PDFNodeStreamFullReader);
                        _this3 = _super.call(this, stream);
                        var handleResponse = function handleResponse(response) {
                            if (response.statusCode === 404) {
                                var error = new _util.MissingPDFException("Missing PDF \"".concat(_this3._url, "\"."));
                                _this3._storedError = error;
                                _this3._headersCapability.reject(error);
                                return;
                            }
                            _this3._headersCapability.resolve();
                            _this3._setReadableStream(response);
                            var getResponseHeader = function getResponseHeader(name) {
                                return _this3._readableStream.headers[name.toLowerCase()];
                            };
                            var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: _this3._rangeChunkSize,
                                disableRange: _this3._disableRange
                            }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                            _this3._isRangeSupported = allowRangeRequests;
                            _this3._contentLength = suggestedLength || _this3._contentLength;
                            _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        _this3._request = null;
                        if (_this3._url.protocol === "http:") _this3._request = http.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
                        else _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
                        _this3._request.on("error", function(reason) {
                            _this3._storedError = reason;
                            _this3._headersCapability.reject(reason);
                        });
                        _this3._request.end();
                        return _this3;
                    }
                    return PDFNodeStreamFullReader;
                }(BaseFullReader);
                var PDFNodeStreamRangeReader = /*#__PURE__*/ function(_BaseRangeReader) {
                    _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
                    var _super2 = _createSuper(PDFNodeStreamRangeReader);
                    function PDFNodeStreamRangeReader(stream, start, end) {
                        var _this4;
                        _classCallCheck(this, PDFNodeStreamRangeReader);
                        _this4 = _super2.call(this, stream);
                        _this4._httpHeaders = {};
                        for(var property in stream.httpHeaders){
                            var value = stream.httpHeaders[property];
                            if (typeof value === "undefined") continue;
                            _this4._httpHeaders[property] = value;
                        }
                        _this4._httpHeaders.Range = "bytes=".concat(start, "-").concat(end - 1);
                        var handleResponse = function handleResponse(response) {
                            if (response.statusCode === 404) {
                                var error = new _util.MissingPDFException("Missing PDF \"".concat(_this4._url, "\"."));
                                _this4._storedError = error;
                                return;
                            }
                            _this4._setReadableStream(response);
                        };
                        _this4._request = null;
                        if (_this4._url.protocol === "http:") _this4._request = http.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
                        else _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
                        _this4._request.on("error", function(reason) {
                            _this4._storedError = reason;
                        });
                        _this4._request.end();
                        return _this4;
                    }
                    return PDFNodeStreamRangeReader;
                }(BaseRangeReader);
                var PDFNodeStreamFsFullReader = /*#__PURE__*/ function(_BaseFullReader2) {
                    _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
                    var _super3 = _createSuper(PDFNodeStreamFsFullReader);
                    function PDFNodeStreamFsFullReader(stream) {
                        var _this5;
                        _classCallCheck(this, PDFNodeStreamFsFullReader);
                        _this5 = _super3.call(this, stream);
                        var path = decodeURIComponent(_this5._url.path);
                        if (fileUriRegex.test(_this5._url.href)) path = path.replace(/^\//, "");
                        fs.lstat(path, function(error, stat) {
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException("Missing PDF \"".concat(path, "\"."));
                                _this5._storedError = error;
                                _this5._headersCapability.reject(error);
                                return;
                            }
                            _this5._contentLength = stat.size;
                            _this5._setReadableStream(fs.createReadStream(path));
                            _this5._headersCapability.resolve();
                        });
                        return _this5;
                    }
                    return PDFNodeStreamFsFullReader;
                }(BaseFullReader);
                var PDFNodeStreamFsRangeReader = /*#__PURE__*/ function(_BaseRangeReader2) {
                    _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
                    var _super4 = _createSuper(PDFNodeStreamFsRangeReader);
                    function PDFNodeStreamFsRangeReader(stream, start, end) {
                        var _this6;
                        _classCallCheck(this, PDFNodeStreamFsRangeReader);
                        _this6 = _super4.call(this, stream);
                        var path = decodeURIComponent(_this6._url.path);
                        if (fileUriRegex.test(_this6._url.href)) path = path.replace(/^\//, "");
                        _this6._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                        return _this6;
                    }
                    return PDFNodeStreamFsRangeReader;
                }(BaseRangeReader);
            /***/ },
            /* 154 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(4);
                var _content_disposition = __w_pdfjs_require__(155);
                var _display_utils = __w_pdfjs_require__(1);
                function validateRangeRequestCapabilities(_ref) {
                    var getResponseHeader = _ref.getResponseHeader, isHttp = _ref.isHttp, rangeChunkSize = _ref.rangeChunkSize, disableRange = _ref.disableRange;
                    (0, _util.assert)(rangeChunkSize > 0, "Range chunk size must be larger than zero");
                    var returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    var length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    var contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    var contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch (ex) {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException("Unexpected server response (".concat(status, ") while retrieving PDF \"").concat(url, "\"."), status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 155 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(4);
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    var needsEncodingFixup = true;
                    var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        var filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        var _filename = rfc2047decode(tmp);
                        return fixupEncoding(_filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        var _filename2 = rfc2616unquote(tmp);
                        _filename2 = rfc2047decode(_filename2);
                        return fixupEncoding(_filename2);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                var decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                var buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch (e) {
                                if (/^utf-?8$/i.test(encoding)) try {
                                    value = decodeURIComponent(escape(value));
                                    needsEncodingFixup = false;
                                } catch (err) {}
                            }
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        var matches = [];
                        var match;
                        var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            var _match = match, _match2 = _slicedToArray(_match, 4), n = _match2[1], quot = _match2[2], part = _match2[3];
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        var parts = [];
                        for(var _n2 = 0; _n2 < matches.length; ++_n2){
                            if (!(_n2 in matches)) break;
                            var _matches$_n = _slicedToArray(matches[_n2], 2), _quot = _matches$_n[0], _part = _matches$_n[1];
                            _part = rfc2616unquote(_part);
                            if (_quot) {
                                _part = unescape(_part);
                                if (_n2 === 0) _part = rfc5987decode(_part);
                            }
                            parts.push(_part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            var parts = value.slice(1).split('\\"');
                            for(var i = 0; i < parts.length; ++i){
                                var quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replace(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        var encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        var encoding = extvalue.slice(0, encodingend);
                        var langvalue = extvalue.slice(encodingend + 1);
                        var value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replace(/_/g, " ");
                                text = text.replace(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch (e) {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 156 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _network_utils = __w_pdfjs_require__(154);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var OK_RESPONSE = 200;
                var PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    var data = xhr.response;
                    if (typeof data !== "string") return data;
                    var array = (0, _util.stringToBytes)(data);
                    return array.buffer;
                }
                var NetworkManager = /*#__PURE__*/ function() {
                    function NetworkManager(url) {
                        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _classCallCheck(this, NetworkManager);
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.getXhr = args.getXhr || function NetworkManager_getXhr() {
                            return new XMLHttpRequest();
                        };
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    _createClass(NetworkManager, [
                        {
                            key: "requestRange",
                            value: function requestRange(begin, end, listeners) {
                                var args = {
                                    begin: begin,
                                    end: end
                                };
                                for(var prop in listeners)args[prop] = listeners[prop];
                                return this.request(args);
                            }
                        },
                        {
                            key: "requestFull",
                            value: function requestFull(listeners) {
                                return this.request(listeners);
                            }
                        },
                        {
                            key: "request",
                            value: function request(args) {
                                var xhr = this.getXhr();
                                var xhrId = this.currXhrId++;
                                var pendingRequest = this.pendingRequests[xhrId] = {
                                    xhr: xhr
                                };
                                xhr.open("GET", this.url);
                                xhr.withCredentials = this.withCredentials;
                                for(var property in this.httpHeaders){
                                    var value = this.httpHeaders[property];
                                    if (typeof value === "undefined") continue;
                                    xhr.setRequestHeader(property, value);
                                }
                                if (this.isHttp && "begin" in args && "end" in args) {
                                    xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
                                    pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                                } else pendingRequest.expectedStatus = OK_RESPONSE;
                                xhr.responseType = "arraybuffer";
                                if (args.onError) xhr.onerror = function(evt) {
                                    args.onError(xhr.status);
                                };
                                xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                                xhr.onprogress = this.onProgress.bind(this, xhrId);
                                pendingRequest.onHeadersReceived = args.onHeadersReceived;
                                pendingRequest.onDone = args.onDone;
                                pendingRequest.onError = args.onError;
                                pendingRequest.onProgress = args.onProgress;
                                xhr.send(null);
                                return xhrId;
                            }
                        },
                        {
                            key: "onProgress",
                            value: function onProgress(xhrId, evt) {
                                var _pendingRequest$onPro;
                                var pendingRequest = this.pendingRequests[xhrId];
                                if (!pendingRequest) return;
                                (_pendingRequest$onPro = pendingRequest.onProgress) === null || _pendingRequest$onPro === void 0 || _pendingRequest$onPro.call(pendingRequest, evt);
                            }
                        },
                        {
                            key: "onStateChange",
                            value: function onStateChange(xhrId, evt) {
                                var pendingRequest = this.pendingRequests[xhrId];
                                if (!pendingRequest) return;
                                var xhr = pendingRequest.xhr;
                                if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                                    pendingRequest.onHeadersReceived();
                                    delete pendingRequest.onHeadersReceived;
                                }
                                if (xhr.readyState !== 4) return;
                                if (!(xhrId in this.pendingRequests)) return;
                                delete this.pendingRequests[xhrId];
                                if (xhr.status === 0 && this.isHttp) {
                                    var _pendingRequest$onErr;
                                    (_pendingRequest$onErr = pendingRequest.onError) === null || _pendingRequest$onErr === void 0 || _pendingRequest$onErr.call(pendingRequest, xhr.status);
                                    return;
                                }
                                var xhrStatus = xhr.status || OK_RESPONSE;
                                var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                                if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                                    var _pendingRequest$onErr2;
                                    (_pendingRequest$onErr2 = pendingRequest.onError) === null || _pendingRequest$onErr2 === void 0 || _pendingRequest$onErr2.call(pendingRequest, xhr.status);
                                    return;
                                }
                                var chunk = getArrayBuffer(xhr);
                                if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                                    var rangeHeader = xhr.getResponseHeader("Content-Range");
                                    var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                                    pendingRequest.onDone({
                                        begin: parseInt(matches[1], 10),
                                        chunk: chunk
                                    });
                                } else if (chunk) pendingRequest.onDone({
                                    begin: 0,
                                    chunk: chunk
                                });
                                else {
                                    var _pendingRequest$onErr3;
                                    (_pendingRequest$onErr3 = pendingRequest.onError) === null || _pendingRequest$onErr3 === void 0 || _pendingRequest$onErr3.call(pendingRequest, xhr.status);
                                }
                            }
                        },
                        {
                            key: "getRequestXhr",
                            value: function getRequestXhr(xhrId) {
                                return this.pendingRequests[xhrId].xhr;
                            }
                        },
                        {
                            key: "isPendingRequest",
                            value: function isPendingRequest(xhrId) {
                                return xhrId in this.pendingRequests;
                            }
                        },
                        {
                            key: "abortRequest",
                            value: function abortRequest(xhrId) {
                                var xhr = this.pendingRequests[xhrId].xhr;
                                delete this.pendingRequests[xhrId];
                                xhr.abort();
                            }
                        }
                    ]);
                    return NetworkManager;
                }();
                var PDFNetworkStream = /*#__PURE__*/ function() {
                    function PDFNetworkStream(source) {
                        _classCallCheck(this, PDFNetworkStream);
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass(PDFNetworkStream, [
                        {
                            key: "_onRangeRequestReaderClosed",
                            value: function _onRangeRequestReaderClosed(reader) {
                                var i = this._rangeRequestReaders.indexOf(reader);
                                if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                                reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                                this._rangeRequestReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                var _this$_fullRequestRea;
                                (_this$_fullRequestRea = this._fullRequestReader) === null || _this$_fullRequestRea === void 0 || _this$_fullRequestRea.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        }
                    ]);
                    return PDFNetworkStream;
                }();
                exports.PDFNetworkStream = PDFNetworkStream;
                var PDFNetworkStreamFullRequestReader = /*#__PURE__*/ function() {
                    function PDFNetworkStreamFullRequestReader(manager, source) {
                        _classCallCheck(this, PDFNetworkStreamFullRequestReader);
                        this._manager = manager;
                        var args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = (0, _util.createPromiseCapability)();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _createClass(PDFNetworkStreamFullRequestReader, [
                        {
                            key: "_onHeadersReceived",
                            value: function _onHeadersReceived() {
                                var fullRequestXhrId = this._fullRequestId;
                                var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                                var getResponseHeader = function getResponseHeader(name) {
                                    return fullRequestXhr.getResponseHeader(name);
                                };
                                var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                                    getResponseHeader: getResponseHeader,
                                    isHttp: this._manager.isHttp,
                                    rangeChunkSize: this._rangeChunkSize,
                                    disableRange: this._disableRange
                                }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                                if (allowRangeRequests) this._isRangeSupported = true;
                                this._contentLength = suggestedLength || this._contentLength;
                                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                                if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                                this._headersReceivedCapability.resolve();
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone(data) {
                                if (data) {
                                    if (this._requests.length > 0) {
                                        var requestCapability = this._requests.shift();
                                        requestCapability.resolve({
                                            value: data.chunk,
                                            done: false
                                        });
                                    } else this._cachedChunks.push(data.chunk);
                                }
                                this._done = true;
                                if (this._cachedChunks.length > 0) return;
                                var _iterator2 = _createForOfIteratorHelper(this._requests), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var _requestCapability = _step2.value;
                                        _requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError(status) {
                                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                                this._headersReceivedCapability.reject(this._storedError);
                                var _iterator3 = _createForOfIteratorHelper(this._requests), _step3;
                                try {
                                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                        var requestCapability = _step3.value;
                                        requestCapability.reject(this._storedError);
                                    }
                                } catch (err) {
                                    _iterator3.e(err);
                                } finally{
                                    _iterator3.f();
                                }
                                this._requests.length = 0;
                                this._cachedChunks.length = 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                var _this$onProgress;
                                (_this$onProgress = this.onProgress) === null || _this$onProgress === void 0 || _this$onProgress.call(this, {
                                    loaded: evt.loaded,
                                    total: evt.lengthComputable ? evt.total : this._contentLength
                                });
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersReceivedCapability.promise;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                if (!this._storedError) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 2:
                                                if (!(this._cachedChunks.length > 0)) {
                                                    _context.next = 5;
                                                    break;
                                                }
                                                chunk = this._cachedChunks.shift();
                                                return _context.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 5:
                                                if (!this._done) {
                                                    _context.next = 7;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 7:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context.abrupt("return", requestCapability.promise);
                                            case 10:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                this._headersReceivedCapability.reject(reason);
                                var _iterator4 = _createForOfIteratorHelper(this._requests), _step4;
                                try {
                                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                        var requestCapability = _step4.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator4.e(err);
                                } finally{
                                    _iterator4.f();
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                                this._fullRequestReader = null;
                            }
                        }
                    ]);
                    return PDFNetworkStreamFullRequestReader;
                }();
                var PDFNetworkStreamRangeRequestReader = /*#__PURE__*/ function() {
                    function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
                        _classCallCheck(this, PDFNetworkStreamRangeRequestReader);
                        this._manager = manager;
                        var args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _createClass(PDFNetworkStreamRangeRequestReader, [
                        {
                            key: "_close",
                            value: function _close() {
                                var _this$onClosed;
                                (_this$onClosed = this.onClosed) === null || _this$onClosed === void 0 || _this$onClosed.call(this, this);
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone(data) {
                                var chunk = data.chunk;
                                if (this._requests.length > 0) {
                                    var requestCapability = this._requests.shift();
                                    requestCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                } else this._queuedChunk = chunk;
                                this._done = true;
                                var _iterator5 = _createForOfIteratorHelper(this._requests), _step5;
                                try {
                                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                        var _requestCapability2 = _step5.value;
                                        _requestCapability2.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator5.e(err);
                                } finally{
                                    _iterator5.f();
                                }
                                this._requests.length = 0;
                                this._close();
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError(status) {
                                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                                var _iterator6 = _createForOfIteratorHelper(this._requests), _step6;
                                try {
                                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                        var requestCapability = _step6.value;
                                        requestCapability.reject(this._storedError);
                                    }
                                } catch (err) {
                                    _iterator6.e(err);
                                } finally{
                                    _iterator6.f();
                                }
                                this._requests.length = 0;
                                this._queuedChunk = null;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                if (!this.isStreamingSupported) {
                                    var _this$onProgress2;
                                    (_this$onProgress2 = this.onProgress) === null || _this$onProgress2 === void 0 || _this$onProgress2.call(this, {
                                        loaded: evt.loaded
                                    });
                                }
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                if (!this._storedError) {
                                                    _context2.next = 2;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 2:
                                                if (!(this._queuedChunk !== null)) {
                                                    _context2.next = 6;
                                                    break;
                                                }
                                                chunk = this._queuedChunk;
                                                this._queuedChunk = null;
                                                return _context2.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 6:
                                                if (!this._done) {
                                                    _context2.next = 8;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 8:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context2.abrupt("return", requestCapability.promise);
                                            case 11:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iterator7 = _createForOfIteratorHelper(this._requests), _step7;
                                try {
                                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                        var requestCapability = _step7.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator7.e(err);
                                } finally{
                                    _iterator7.f();
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                                this._close();
                            }
                        }
                    ]);
                    return PDFNetworkStreamRangeRequestReader;
                }();
            /***/ },
            /* 157 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _network_utils = __w_pdfjs_require__(154);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    var headers = new Headers();
                    for(var property in httpHeaders){
                        var value = httpHeaders[property];
                        if (typeof value === "undefined") continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                var PDFFetchStream = /*#__PURE__*/ function() {
                    function PDFFetchStream(source) {
                        _classCallCheck(this, PDFFetchStream);
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass(PDFFetchStream, [
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this$_fullRequestRea, _this$_fullRequestRea2;
                                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFFetchStreamReader(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var reader = new PDFFetchStreamRangeReader(this, begin, end);
                                this._rangeRequestReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        }
                    ]);
                    return PDFFetchStream;
                }();
                exports.PDFFetchStream = PDFFetchStream;
                var PDFFetchStreamReader = /*#__PURE__*/ function() {
                    function PDFFetchStreamReader(stream) {
                        var _this = this;
                        _classCallCheck(this, PDFFetchStreamReader);
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        var source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = (0, _util.createPromiseCapability)();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        var url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            _this._reader = response.body.getReader();
                            _this._headersCapability.resolve();
                            var getResponseHeader = function getResponseHeader(name) {
                                return response.headers.get(name);
                            };
                            var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: _this._stream.isHttp,
                                rangeChunkSize: _this._rangeChunkSize,
                                disableRange: _this._disableRange
                            }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                            _this._isRangeSupported = allowRangeRequests;
                            _this._contentLength = suggestedLength || _this._contentLength;
                            _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!_this._isStreamingSupported && _this._isRangeSupported) _this.cancel(new _util.AbortException("Streaming is disabled."));
                        })["catch"](this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    _createClass(PDFFetchStreamReader, [
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var _yield$this$_reader$r, value, done, buffer;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                _context.next = 2;
                                                return this._headersCapability.promise;
                                            case 2:
                                                _context.next = 4;
                                                return this._reader.read();
                                            case 4:
                                                _yield$this$_reader$r = _context.sent;
                                                value = _yield$this$_reader$r.value;
                                                done = _yield$this$_reader$r.done;
                                                if (!done) {
                                                    _context.next = 9;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: value,
                                                    done: done
                                                });
                                            case 9:
                                                this._loaded += value.byteLength;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded,
                                                    total: this._contentLength
                                                });
                                                buffer = new Uint8Array(value).buffer;
                                                return _context.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 13:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (this._reader) this._reader.cancel(reason);
                                if (this._abortController) this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamReader;
                }();
                var PDFFetchStreamRangeReader = /*#__PURE__*/ function() {
                    function PDFFetchStreamRangeReader(stream, begin, end) {
                        var _this2 = this;
                        _classCallCheck(this, PDFFetchStreamRangeReader);
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        var source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = (0, _util.createPromiseCapability)();
                        this._isStreamingSupported = !source.disableStream;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
                        var url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            _this2._readCapability.resolve();
                            _this2._reader = response.body.getReader();
                        })["catch"](this._readCapability.reject);
                        this.onProgress = null;
                    }
                    _createClass(PDFFetchStreamRangeReader, [
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var _yield$this$_reader$r2, value, done, buffer;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                _context2.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                _context2.next = 4;
                                                return this._reader.read();
                                            case 4:
                                                _yield$this$_reader$r2 = _context2.sent;
                                                value = _yield$this$_reader$r2.value;
                                                done = _yield$this$_reader$r2.done;
                                                if (!done) {
                                                    _context2.next = 9;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: value,
                                                    done: done
                                                });
                                            case 9:
                                                this._loaded += value.byteLength;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded
                                                });
                                                buffer = new Uint8Array(value).buffer;
                                                return _context2.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 13:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (this._reader) this._reader.cancel(reason);
                                if (this._abortController) this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamRangeReader;
                }();
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/node module decorator */ /******/ (()=>{
            /******/ __w_pdfjs_require__.nmd = (module1)=>{
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        (()=>{
            "use strict";
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function get() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function get() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function get() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function get() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function get() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "LinkTarget", {
                enumerable: true,
                get: function get() {
                    return _display_utils.LinkTarget;
                }
            });
            Object.defineProperty(exports, "LoopbackPort", {
                enumerable: true,
                get: function get() {
                    return _api.LoopbackPort;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function get() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function get() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function get() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function get() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function get() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function get() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function get() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function get() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function get() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function get() {
                    return _svg.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UNSUPPORTED_FEATURES", {
                enumerable: true,
                get: function get() {
                    return _util.UNSUPPORTED_FEATURES;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function get() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function get() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function get() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function get() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "addLinkAttributes", {
                enumerable: true,
                get: function get() {
                    return _display_utils.addLinkAttributes;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function get() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createObjectURL", {
                enumerable: true,
                get: function get() {
                    return _util.createObjectURL;
                }
            });
            Object.defineProperty(exports, "createPromiseCapability", {
                enumerable: true,
                get: function get() {
                    return _util.createPromiseCapability;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function get() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function get() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function get() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function get() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "removeNullCharacters", {
                enumerable: true,
                get: function get() {
                    return _util.removeNullCharacters;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function get() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function get() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function get() {
                    return _api.version;
                }
            });
            var _display_utils = __w_pdfjs_require__(1);
            var _util = __w_pdfjs_require__(4);
            var _api = __w_pdfjs_require__(136);
            var _annotation_layer = __w_pdfjs_require__(148);
            var _worker_options = __w_pdfjs_require__(142);
            var _is_node = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(151);
            var _svg = __w_pdfjs_require__(152);
            var _xfa_layer = __w_pdfjs_require__(150);
            var pdfjsVersion = '2.12.313';
            var pdfjsBuild = 'a2ae56f39';
            if (_is_node.isNodeJS) {
                var _require = __w_pdfjs_require__(153), PDFNodeStream = _require.PDFNodeStream;
                (0, _api.setPDFNetworkStreamFactory)(function(params) {
                    return new PDFNodeStream(params);
                });
            } else {
                var _require2 = __w_pdfjs_require__(156), PDFNetworkStream = _require2.PDFNetworkStream;
                var _require3 = __w_pdfjs_require__(157), PDFFetchStream = _require3.PDFFetchStream;
                (0, _api.setPDFNetworkStreamFactory)(function(params) {
                    if ((0, _display_utils.isValidFetchUrl)(params.url)) return new PDFFetchStream(params);
                    return new PDFNetworkStream(params);
                });
            }
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("98IaM", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6a772037c784145c$export$a143d493d941bafc; }, function (v) { return $6a772037c784145c$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6a772037c784145c$export$f99ded8fe4b79145; }, function (v) { return $6a772037c784145c$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6a772037c784145c$export$a143d493d941bafc;
var $6a772037c784145c$export$e4cf37d7f6fb9e0a;
var $6a772037c784145c$export$f99ded8fe4b79145;
var $6a772037c784145c$export$599f31c3813fae4d;
'use strict';

var $71dnm = parcelRequire("71dnm");

var $7VnKB = parcelRequire("7VnKB");
const $6a772037c784145c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6a772037c784145c$export$a143d493d941bafc = $6a772037c784145c$var$Buffer;
$6a772037c784145c$export$e4cf37d7f6fb9e0a = $6a772037c784145c$var$SlowBuffer;
$6a772037c784145c$export$f99ded8fe4b79145 = 50;
const $6a772037c784145c$var$K_MAX_LENGTH = 0x7fffffff;
$6a772037c784145c$export$599f31c3813fae4d = $6a772037c784145c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6a772037c784145c$var$Buffer.TYPED_ARRAY_SUPPORT = $6a772037c784145c$var$typedArraySupport();
if (!$6a772037c784145c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6a772037c784145c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6a772037c784145c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6a772037c784145c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6a772037c784145c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6a772037c784145c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6a772037c784145c$var$createBuffer(length) {
    if (length > $6a772037c784145c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6a772037c784145c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6a772037c784145c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6a772037c784145c$var$allocUnsafe(arg);
    }
    return $6a772037c784145c$var$from(arg, encodingOrOffset, length);
}
$6a772037c784145c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6a772037c784145c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6a772037c784145c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6a772037c784145c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6a772037c784145c$var$isInstance(value, ArrayBuffer) || value && $6a772037c784145c$var$isInstance(value.buffer, ArrayBuffer)) return $6a772037c784145c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6a772037c784145c$var$isInstance(value, SharedArrayBuffer) || value && $6a772037c784145c$var$isInstance(value.buffer, SharedArrayBuffer))) return $6a772037c784145c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6a772037c784145c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6a772037c784145c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6a772037c784145c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6a772037c784145c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6a772037c784145c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6a772037c784145c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6a772037c784145c$var$Buffer, Uint8Array);
function $6a772037c784145c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6a772037c784145c$var$alloc(size, fill, encoding) {
    $6a772037c784145c$var$assertSize(size);
    if (size <= 0) return $6a772037c784145c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6a772037c784145c$var$createBuffer(size).fill(fill, encoding) : $6a772037c784145c$var$createBuffer(size).fill(fill);
    return $6a772037c784145c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6a772037c784145c$var$Buffer.alloc = function(size, fill, encoding) {
    return $6a772037c784145c$var$alloc(size, fill, encoding);
};
function $6a772037c784145c$var$allocUnsafe(size) {
    $6a772037c784145c$var$assertSize(size);
    return $6a772037c784145c$var$createBuffer(size < 0 ? 0 : $6a772037c784145c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6a772037c784145c$var$Buffer.allocUnsafe = function(size) {
    return $6a772037c784145c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6a772037c784145c$var$Buffer.allocUnsafeSlow = function(size) {
    return $6a772037c784145c$var$allocUnsafe(size);
};
function $6a772037c784145c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6a772037c784145c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6a772037c784145c$var$byteLength(string, encoding) | 0;
    let buf = $6a772037c784145c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6a772037c784145c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6a772037c784145c$var$checked(array.length) | 0;
    const buf = $6a772037c784145c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6a772037c784145c$var$fromArrayView(arrayView) {
    if ($6a772037c784145c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6a772037c784145c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6a772037c784145c$var$fromArrayLike(arrayView);
}
function $6a772037c784145c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6a772037c784145c$var$Buffer.prototype);
    return buf;
}
function $6a772037c784145c$var$fromObject(obj) {
    if ($6a772037c784145c$var$Buffer.isBuffer(obj)) {
        const len = $6a772037c784145c$var$checked(obj.length) | 0;
        const buf = $6a772037c784145c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6a772037c784145c$var$numberIsNaN(obj.length)) return $6a772037c784145c$var$createBuffer(0);
        return $6a772037c784145c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6a772037c784145c$var$fromArrayLike(obj.data);
}
function $6a772037c784145c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6a772037c784145c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6a772037c784145c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6a772037c784145c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6a772037c784145c$var$Buffer.alloc(+length);
}
$6a772037c784145c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6a772037c784145c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6a772037c784145c$var$Buffer.compare = function compare(a, b) {
    if ($6a772037c784145c$var$isInstance(a, Uint8Array)) a = $6a772037c784145c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6a772037c784145c$var$isInstance(b, Uint8Array)) b = $6a772037c784145c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6a772037c784145c$var$Buffer.isBuffer(a) || !$6a772037c784145c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6a772037c784145c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6a772037c784145c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6a772037c784145c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6a772037c784145c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6a772037c784145c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) buf = $6a772037c784145c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6a772037c784145c$var$byteLength(string, encoding) {
    if ($6a772037c784145c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6a772037c784145c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6a772037c784145c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6a772037c784145c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6a772037c784145c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6a772037c784145c$var$Buffer.byteLength = $6a772037c784145c$var$byteLength;
function $6a772037c784145c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6a772037c784145c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6a772037c784145c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6a772037c784145c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6a772037c784145c$var$latin1Slice(this, start, end);
        case 'base64':
            return $6a772037c784145c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6a772037c784145c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6a772037c784145c$var$Buffer.prototype._isBuffer = true;
function $6a772037c784145c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6a772037c784145c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6a772037c784145c$var$swap(this, i, i + 1);
    return this;
};
$6a772037c784145c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6a772037c784145c$var$swap(this, i, i + 3);
        $6a772037c784145c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6a772037c784145c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6a772037c784145c$var$swap(this, i, i + 7);
        $6a772037c784145c$var$swap(this, i + 1, i + 6);
        $6a772037c784145c$var$swap(this, i + 2, i + 5);
        $6a772037c784145c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6a772037c784145c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6a772037c784145c$var$utf8Slice(this, 0, length);
    return $6a772037c784145c$var$slowToString.apply(this, arguments);
};
$6a772037c784145c$var$Buffer.prototype.toLocaleString = $6a772037c784145c$var$Buffer.prototype.toString;
$6a772037c784145c$var$Buffer.prototype.equals = function equals(b) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6a772037c784145c$var$Buffer.compare(this, b) === 0;
};
$6a772037c784145c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6a772037c784145c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6a772037c784145c$var$customInspectSymbol) $6a772037c784145c$var$Buffer.prototype[$6a772037c784145c$var$customInspectSymbol] = $6a772037c784145c$var$Buffer.prototype.inspect;
$6a772037c784145c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6a772037c784145c$var$isInstance(target, Uint8Array)) target = $6a772037c784145c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6a772037c784145c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6a772037c784145c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6a772037c784145c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6a772037c784145c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6a772037c784145c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6a772037c784145c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6a772037c784145c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6a772037c784145c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6a772037c784145c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6a772037c784145c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6a772037c784145c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6a772037c784145c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6a772037c784145c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6a772037c784145c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6a772037c784145c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6a772037c784145c$var$utf8Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6a772037c784145c$var$asciiWrite(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$asciiToBytes(string), buf, offset, length);
}
function $6a772037c784145c$var$base64Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$base64ToBytes(string), buf, offset, length);
}
function $6a772037c784145c$var$ucs2Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6a772037c784145c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6a772037c784145c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6a772037c784145c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6a772037c784145c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6a772037c784145c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6a772037c784145c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6a772037c784145c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6a772037c784145c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $71dnm.fromByteArray(buf);
    else return $71dnm.fromByteArray(buf.slice(start, end));
}
function $6a772037c784145c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6a772037c784145c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6a772037c784145c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6a772037c784145c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6a772037c784145c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6a772037c784145c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6a772037c784145c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6a772037c784145c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6a772037c784145c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6a772037c784145c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6a772037c784145c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6a772037c784145c$var$Buffer.prototype.readUintLE = $6a772037c784145c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readUintBE = $6a772037c784145c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readUint8 = $6a772037c784145c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6a772037c784145c$var$Buffer.prototype.readUint16LE = $6a772037c784145c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6a772037c784145c$var$Buffer.prototype.readUint16BE = $6a772037c784145c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6a772037c784145c$var$Buffer.prototype.readUint32LE = $6a772037c784145c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6a772037c784145c$var$Buffer.prototype.readUint32BE = $6a772037c784145c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6a772037c784145c$var$Buffer.prototype.readBigUInt64LE = $6a772037c784145c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6a772037c784145c$var$Buffer.prototype.readBigUInt64BE = $6a772037c784145c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6a772037c784145c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6a772037c784145c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6a772037c784145c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6a772037c784145c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6a772037c784145c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6a772037c784145c$var$Buffer.prototype.readBigInt64LE = $6a772037c784145c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6a772037c784145c$var$Buffer.prototype.readBigInt64BE = $6a772037c784145c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6a772037c784145c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return $7VnKB.read(this, offset, true, 23, 4);
};
$6a772037c784145c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return $7VnKB.read(this, offset, false, 23, 4);
};
$6a772037c784145c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 8, this.length);
    return $7VnKB.read(this, offset, true, 52, 8);
};
$6a772037c784145c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 8, this.length);
    return $7VnKB.read(this, offset, false, 52, 8);
};
function $6a772037c784145c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6a772037c784145c$var$Buffer.prototype.writeUintLE = $6a772037c784145c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeUintBE = $6a772037c784145c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeUint8 = $6a772037c784145c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6a772037c784145c$var$Buffer.prototype.writeUint16LE = $6a772037c784145c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeUint16BE = $6a772037c784145c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeUint32LE = $6a772037c784145c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeUint32BE = $6a772037c784145c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6a772037c784145c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6a772037c784145c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6a772037c784145c$var$Buffer.prototype.writeBigUInt64LE = $6a772037c784145c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6a772037c784145c$var$Buffer.prototype.writeBigUInt64BE = $6a772037c784145c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6a772037c784145c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6a772037c784145c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeBigInt64LE = $6a772037c784145c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6a772037c784145c$var$Buffer.prototype.writeBigInt64BE = $6a772037c784145c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6a772037c784145c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6a772037c784145c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7VnKB.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6a772037c784145c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeFloat(this, value, offset, true, noAssert);
};
$6a772037c784145c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeFloat(this, value, offset, false, noAssert);
};
function $6a772037c784145c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7VnKB.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6a772037c784145c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeDouble(this, value, offset, true, noAssert);
};
$6a772037c784145c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6a772037c784145c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6a772037c784145c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6a772037c784145c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6a772037c784145c$var$Buffer.isBuffer(val) ? val : $6a772037c784145c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6a772037c784145c$var$errors = {};
function $6a772037c784145c$var$E(sym, getMessage, Base) {
    $6a772037c784145c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$6a772037c784145c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6a772037c784145c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6a772037c784145c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6a772037c784145c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6a772037c784145c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6a772037c784145c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6a772037c784145c$var$checkBounds(buf, offset, byteLength) {
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6a772037c784145c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6a772037c784145c$var$checkBounds(buf, offset, byteLength);
}
function $6a772037c784145c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6a772037c784145c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6a772037c784145c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6a772037c784145c$var$validateNumber(value, type);
        throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6a772037c784145c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6a772037c784145c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6a772037c784145c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6a772037c784145c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6a772037c784145c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6a772037c784145c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6a772037c784145c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6a772037c784145c$var$base64ToBytes(str) {
    return $71dnm.toByteArray($6a772037c784145c$var$base64clean(str));
}
function $6a772037c784145c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6a772037c784145c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6a772037c784145c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6a772037c784145c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6a772037c784145c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6a772037c784145c$var$BufferBigIntNotDefined : fn;
}
function $6a772037c784145c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("71dnm", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $51c300904a140497$export$d622b2ad8d90c771; }, function (v) { return $51c300904a140497$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $51c300904a140497$export$6100ba28696e12de; }, function (v) { return $51c300904a140497$export$6100ba28696e12de = v; });
var $51c300904a140497$export$a48f0734ac7c2329;
var $51c300904a140497$export$d622b2ad8d90c771;
var $51c300904a140497$export$6100ba28696e12de;
'use strict';
$51c300904a140497$export$a48f0734ac7c2329 = $51c300904a140497$var$byteLength;
$51c300904a140497$export$d622b2ad8d90c771 = $51c300904a140497$var$toByteArray;
$51c300904a140497$export$6100ba28696e12de = $51c300904a140497$var$fromByteArray;
var $51c300904a140497$var$lookup = [];
var $51c300904a140497$var$revLookup = [];
var $51c300904a140497$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $51c300904a140497$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $51c300904a140497$var$i = 0, $51c300904a140497$var$len = $51c300904a140497$var$code.length; $51c300904a140497$var$i < $51c300904a140497$var$len; ++$51c300904a140497$var$i){
    $51c300904a140497$var$lookup[$51c300904a140497$var$i] = $51c300904a140497$var$code[$51c300904a140497$var$i];
    $51c300904a140497$var$revLookup[$51c300904a140497$var$code.charCodeAt($51c300904a140497$var$i)] = $51c300904a140497$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$51c300904a140497$var$revLookup['-'.charCodeAt(0)] = 62;
$51c300904a140497$var$revLookup['_'.charCodeAt(0)] = 63;
function $51c300904a140497$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $51c300904a140497$var$byteLength(b64) {
    var lens = $51c300904a140497$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $51c300904a140497$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $51c300904a140497$var$toByteArray(b64) {
    var tmp;
    var lens = $51c300904a140497$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $51c300904a140497$var$Arr($51c300904a140497$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 18 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 2 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 10 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $51c300904a140497$var$tripletToBase64(num) {
    return $51c300904a140497$var$lookup[num >> 18 & 0x3F] + $51c300904a140497$var$lookup[num >> 12 & 0x3F] + $51c300904a140497$var$lookup[num >> 6 & 0x3F] + $51c300904a140497$var$lookup[num & 0x3F];
}
function $51c300904a140497$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($51c300904a140497$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $51c300904a140497$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($51c300904a140497$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($51c300904a140497$var$lookup[tmp >> 2] + $51c300904a140497$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($51c300904a140497$var$lookup[tmp >> 10] + $51c300904a140497$var$lookup[tmp >> 4 & 0x3F] + $51c300904a140497$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7VnKB", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $5c5047a9af555f4a$export$aafa59e2e03f2942; }, function (v) { return $5c5047a9af555f4a$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $5c5047a9af555f4a$export$68d8715fc104d294; }, function (v) { return $5c5047a9af555f4a$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5c5047a9af555f4a$export$aafa59e2e03f2942;
var $5c5047a9af555f4a$export$68d8715fc104d294;
$5c5047a9af555f4a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5c5047a9af555f4a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("17tgv", function(module, exports) {
// shim for using process in browser
var $0d0d255e14f785b6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0d0d255e14f785b6$var$cachedSetTimeout;
var $0d0d255e14f785b6$var$cachedClearTimeout;
function $0d0d255e14f785b6$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $0d0d255e14f785b6$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        else $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        else $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    }
})();
function $0d0d255e14f785b6$var$runTimeout(fun) {
    if ($0d0d255e14f785b6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedSetTimeout === $0d0d255e14f785b6$var$defaultSetTimout || !$0d0d255e14f785b6$var$cachedSetTimeout) && setTimeout) {
        $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0d0d255e14f785b6$var$runClearTimeout(marker) {
    if ($0d0d255e14f785b6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedClearTimeout === $0d0d255e14f785b6$var$defaultClearTimeout || !$0d0d255e14f785b6$var$cachedClearTimeout) && clearTimeout) {
        $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0d0d255e14f785b6$var$queue = [];
var $0d0d255e14f785b6$var$draining = false;
var $0d0d255e14f785b6$var$currentQueue;
var $0d0d255e14f785b6$var$queueIndex = -1;
function $0d0d255e14f785b6$var$cleanUpNextTick() {
    if (!$0d0d255e14f785b6$var$draining || !$0d0d255e14f785b6$var$currentQueue) return;
    $0d0d255e14f785b6$var$draining = false;
    if ($0d0d255e14f785b6$var$currentQueue.length) $0d0d255e14f785b6$var$queue = $0d0d255e14f785b6$var$currentQueue.concat($0d0d255e14f785b6$var$queue);
    else $0d0d255e14f785b6$var$queueIndex = -1;
    if ($0d0d255e14f785b6$var$queue.length) $0d0d255e14f785b6$var$drainQueue();
}
function $0d0d255e14f785b6$var$drainQueue() {
    if ($0d0d255e14f785b6$var$draining) return;
    var timeout = $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$cleanUpNextTick);
    $0d0d255e14f785b6$var$draining = true;
    var len = $0d0d255e14f785b6$var$queue.length;
    while(len){
        $0d0d255e14f785b6$var$currentQueue = $0d0d255e14f785b6$var$queue;
        $0d0d255e14f785b6$var$queue = [];
        while(++$0d0d255e14f785b6$var$queueIndex < len)if ($0d0d255e14f785b6$var$currentQueue) $0d0d255e14f785b6$var$currentQueue[$0d0d255e14f785b6$var$queueIndex].run();
        $0d0d255e14f785b6$var$queueIndex = -1;
        len = $0d0d255e14f785b6$var$queue.length;
    }
    $0d0d255e14f785b6$var$currentQueue = null;
    $0d0d255e14f785b6$var$draining = false;
    $0d0d255e14f785b6$var$runClearTimeout(timeout);
}
$0d0d255e14f785b6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0d0d255e14f785b6$var$queue.push(new $0d0d255e14f785b6$var$Item(fun, args));
    if ($0d0d255e14f785b6$var$queue.length === 1 && !$0d0d255e14f785b6$var$draining) $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$drainQueue);
};
// v8 likes predictible objects
function $0d0d255e14f785b6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0d0d255e14f785b6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0d0d255e14f785b6$var$process.title = 'browser';
$0d0d255e14f785b6$var$process.browser = true;
$0d0d255e14f785b6$var$process.env = {};
$0d0d255e14f785b6$var$process.argv = [];
$0d0d255e14f785b6$var$process.version = ''; // empty string to avoid regexp issues
$0d0d255e14f785b6$var$process.versions = {};
function $0d0d255e14f785b6$var$noop() {}
$0d0d255e14f785b6$var$process.on = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.addListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.once = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.off = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeAllListeners = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.emit = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependOnceListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.listeners = function(name) {
    return [];
};
$0d0d255e14f785b6$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$0d0d255e14f785b6$var$process.cwd = function() {
    return '/';
};
$0d0d255e14f785b6$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$0d0d255e14f785b6$var$process.umask = function() {
    return 0;
};

});

parcelRegister("gFNhN", function(module, exports) {
"use strict";

});


parcelRegister("kh2Rv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $4H3Nt = parcelRequire("4H3Nt");
function $ec279d803f66d50f$var$emptyFunction() {}
function $ec279d803f66d50f$var$emptyFunctionWithReset() {}
$ec279d803f66d50f$var$emptyFunctionWithReset.resetWarningCache = $ec279d803f66d50f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4H3Nt) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ec279d803f66d50f$var$emptyFunctionWithReset,
        resetWarningCache: $ec279d803f66d50f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4H3Nt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $36ae1f94766f6c68$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $36ae1f94766f6c68$var$ReactPropTypesSecret;

});


parcelRegister("i5SyM", function(module, exports) {

$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });
$parcel$export(module.exports, "default", function () { return $d2c3041c97de683a$export$2e2bcd8739ae039; });

var $8ZNRc = parcelRequire("8ZNRc");

var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $fOGHK = parcelRequire("fOGHK");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $vdtyq.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $lU1Um.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread(_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $vdtyq.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $lU1Um.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === '?' ? '\\?' : c;
    }).join('|'), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var ResourceStore = function(_EventEmitter) {
    (0, $7kInc.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $vdtyq.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $6o8oQ.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $lU1Um.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $7kInc.default)(Translator, _EventEmitter);
    var _super = _createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $vdtyq.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $6o8oQ.default)(_this));
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $6o8oQ.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = baseLogger.create('translator');
        return _this;
    }
    (0, $lU1Um.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $8ZNRc.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
                        interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $vdtyq.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    (0, $lU1Um.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    'v1',
    'v2',
    'v3'
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $vdtyq.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
    }
    (0, $lU1Um.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? 'ordinal' : 'cardinal'
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = 'plural';
                    else if (suffix === 1) suffix = '';
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === 'v1') {
                    if (suffix === 1) return '';
                    if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $vdtyq.default)(this, Interpolator);
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $lU1Um.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (options && options.hasOwnProperty(matchedVar)) value = '';
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = _objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        var p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(';');
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(':'), _opt$split2 = (0, $fOGHK.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $vdtyq.default)(this, Formatter);
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
                    style: 'currency'
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || 'day');
                };
            }),
            list: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $lU1Um.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$5(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $7kInc.default)(Connector, _EventEmitter);
    var _super = _createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $vdtyq.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $6o8oQ.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create('backendConnector');
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $lU1Um.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $8ZNRc.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $8ZNRc.default)(args[2]) === 'object' || (0, $8ZNRc.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$6(Object(source), true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $7kInc.default)(I18n, _EventEmitter);
    var _super = _createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $vdtyq.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $6o8oQ.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $6o8oQ.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $kNXwL.default)(_this, (0, $6o8oQ.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $lU1Um.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === 'string') options.defaultNS = options.ns;
                    else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== 'undefined') formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
                if (module.type === 'formatter') this.modules.formatter = module;
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    'cimode',
                    'dev'
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        'cimode',
                        'dev'
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit('languageChanging', lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $8ZNRc.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || '.';
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam',
                    'ckb'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $8k2Uc.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;
var $d2c3041c97de683a$export$2e2bcd8739ae039 = instance;

});
parcelRegister("8ZNRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68cab1d0bf278cf6$export$2e2bcd8739ae039; });
function $68cab1d0bf278cf6$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $68cab1d0bf278cf6$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $68cab1d0bf278cf6$export$2e2bcd8739ae039(o);
}

});

parcelRegister("vdtyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05dd595adecf7ee3$export$2e2bcd8739ae039; });
function $05dd595adecf7ee3$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lU1Um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff204ed3b2150eb1$export$2e2bcd8739ae039; });

var $3mYeD = parcelRequire("3mYeD");
function $ff204ed3b2150eb1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3mYeD.default)(o.key), o);
    }
}
function $ff204ed3b2150eb1$export$2e2bcd8739ae039(e, r, t) {
    return r && $ff204ed3b2150eb1$var$_defineProperties(e.prototype, r), t && $ff204ed3b2150eb1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("3mYeD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274226961e1566b9$export$2e2bcd8739ae039; });

var $8ZNRc = parcelRequire("8ZNRc");

var $fdh06 = parcelRequire("fdh06");
function $274226961e1566b9$export$2e2bcd8739ae039(t) {
    var i = (0, $fdh06.default)(t, "string");
    return "symbol" == (0, $8ZNRc.default)(i) ? i : i + "";
}

});
parcelRegister("fdh06", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13541e5a88ec4dd$export$2e2bcd8739ae039; });

var $8ZNRc = parcelRequire("8ZNRc");
function $b13541e5a88ec4dd$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8ZNRc.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8ZNRc.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("6o8oQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a6b7ffb37dfa0f8$export$2e2bcd8739ae039; });
function $4a6b7ffb37dfa0f8$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("7kInc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $556cd23fac47f479$export$2e2bcd8739ae039; });

var $dtYFN = parcelRequire("dtYFN");
function $556cd23fac47f479$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $dtYFN.default)(t, e);
}

});
parcelRegister("dtYFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0d0c37df867b82$export$2e2bcd8739ae039; });
function $9d0d0c37df867b82$export$2e2bcd8739ae039(t, e) {
    return $9d0d0c37df867b82$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9d0d0c37df867b82$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("kNXwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2568f2b7932cb22$export$2e2bcd8739ae039; });

var $8ZNRc = parcelRequire("8ZNRc");

var $6o8oQ = parcelRequire("6o8oQ");
function $f2568f2b7932cb22$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8ZNRc.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $6o8oQ.default)(t);
}

});

parcelRegister("lV8DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff55a031e82added$export$2e2bcd8739ae039; });
function $ff55a031e82added$export$2e2bcd8739ae039(t) {
    return $ff55a031e82added$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ff55a031e82added$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8k2Uc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60f271ecc98b033c$export$2e2bcd8739ae039; });

var $3mYeD = parcelRequire("3mYeD");
function $60f271ecc98b033c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3mYeD.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("fOGHK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b83ca6c65827237e$export$2e2bcd8739ae039; });

var $c9QmJ = parcelRequire("c9QmJ");

var $9Vqi3 = parcelRequire("9Vqi3");

var $biFy3 = parcelRequire("biFy3");

var $6MgCo = parcelRequire("6MgCo");
function $b83ca6c65827237e$export$2e2bcd8739ae039(r) {
    return (0, $c9QmJ.default)(r) || (0, $9Vqi3.default)(r) || (0, $biFy3.default)(r) || (0, $6MgCo.default)();
}

});
parcelRegister("c9QmJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d9ef205826c89ae$export$2e2bcd8739ae039; });
function $8d9ef205826c89ae$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("9Vqi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $739dd4a0018a6e6b$export$2e2bcd8739ae039; });
function $739dd4a0018a6e6b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("biFy3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83a19ac171244ba6$export$2e2bcd8739ae039; });

var $4rfJf = parcelRequire("4rfJf");
function $83a19ac171244ba6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $4rfJf.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $4rfJf.default)(r, a) : void 0;
    }
}

});
parcelRegister("4rfJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33b5e26e8768d07a$export$2e2bcd8739ae039; });
function $33b5e26e8768d07a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("6MgCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ef41dca29d02c66$export$2e2bcd8739ae039; });
function $4ef41dca29d02c66$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



var $34bdccd3101c6af6$exports = {};
$parcel$extendImportMap({
    "dpH0O": "logo-white.1587133f.svg",
    "ZqBv6": "logo-white-sign.95fe99b0.svg",
    "2u7A5": "icon-close.65a96558.svg",
    "jgqIf": "icon-close-dark.8c5b4a2e.svg",
    "j8NPw": "team.9c796d25.png",
    "bQG3t": "icon-todo.80d86c0b.svg",
    "7dBsJ": "icon-todo-pink.8106e8fb.svg",
    "9Yhvd": "icon-images.8054be74.svg",
    "i9pZP": "icon-images-pink.b2597afb.svg",
    "gJHxr": "icon-files.227d29c0.svg",
    "cOMgj": "icon-files-pink.2ccc8dfa.svg",
    "65pvn": "icon-user.0255f3e6.svg",
    "bKK12": "no-messages.0c8072a4.svg",
    "bzfmz": "no-messages-white.8ed0d0df.svg",
    "9Pwxj": "icon-messages.83e5e3b0.svg",
    "faMD4": "icon-share-with.49f66cc9.svg",
    "e28S4": "flower.a98210e3.svg",
    "goRe2": "menu.fb6dee9d.svg",
    "7pu9e": "pdf.worker.entry.d62f3b7f.js",
    "lMPH0": "icon-download.27799736.svg",
    "atD8y": "icon-preview.7e9f1012.svg",
    "ipHR2": "doc-pdf-thumb.9c869b6b.svg",
    "20uZv": "doc-pdf-yellow-thumb.6ad7fc77.svg",
    "esd5a": "button-arrow-white.4deca32b.svg",
    "1e1FO": "button-arrow-dark.52398b57.svg",
    "1z9Zn": "bankid-white.f48ac33e.svg",
    "9unJC": "show-password.c3383fc9.svg",
    "ki3b4": "bankid-dark.48882680.svg",
    "dCEl3": "circle-dark.d163b9a1.svg",
    "dKZtz": "circle-white.27e28a32.svg",
    "6dNgT": "circle-checked-dark.e1e24208.svg",
    "257jE": "circle-checked-white.6a39ae01.svg",
    "4CiMo": "circle-exc.a7d7b587.svg",
    "9f0xV": "todo-arrow-dark.cdf13345.svg",
    "8eVce": "todo-arrow.6354c225.svg",
    "7tEnp": "icon-user-dark.5a9665e8.svg",
    "nAxKQ": "todo-done-triangle.534e7d74.svg"
});

var $14fc2f3a09df08ae$exports = {};
'use strict';

$14fc2f3a09df08ae$exports = (parcelRequire("2Qwp0"));



var $6VKBH = parcelRequire("6VKBH");
var $9oYhG = parcelRequire("9oYhG");

var $6VKBH = parcelRequire("6VKBH");

var $fV6gF = parcelRequire("fV6gF");
var $5Tp4j = parcelRequire("5Tp4j");

var $cLZZ4 = parcelRequire("cLZZ4");

var $37IZD = parcelRequire("37IZD");

var $6VKBH = parcelRequire("6VKBH");

var $9FJRw = parcelRequire("9FJRw");
const $2ad358cdcd1d5061$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $2ad358cdcd1d5061$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $2ad358cdcd1d5061$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $fV6gF.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $2ad358cdcd1d5061$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $2ad358cdcd1d5061$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $2ad358cdcd1d5061$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $2ad358cdcd1d5061$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $2ad358cdcd1d5061$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $2ad358cdcd1d5061$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($2ad358cdcd1d5061$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $37IZD.addGlobalEventProcessor), (0, $9FJRw.getCurrentHub));
        $2ad358cdcd1d5061$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = (event, hint)=>callback(event, hint, client);
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $2ad358cdcd1d5061$export$2d8f5188773bcddd(integration) {
    const client = (0, $6VKBH.getClient)();
    if (!client || !client.addIntegration) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $2ad358cdcd1d5061$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $2ad358cdcd1d5061$export$afa219bf23651160(name, fn) {
    const ConvertedIntegration = function ConvertedIntegration(...args) {
        return fn(...args);
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $2ad358cdcd1d5061$export$2323046b9414659f(fn) {
    return fn;
}


let $5d90bba78ce1a0b2$var$originalFunctionToString;
const $5d90bba78ce1a0b2$var$INTEGRATION_NAME = 'FunctionToString';
const $5d90bba78ce1a0b2$var$SETUP_CLIENTS = new WeakMap();
const $5d90bba78ce1a0b2$var$_functionToStringIntegration = ()=>{
    return {
        name: $5d90bba78ce1a0b2$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $5d90bba78ce1a0b2$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $9oYhG.getOriginalFunction)(this);
                    const context = $5d90bba78ce1a0b2$var$SETUP_CLIENTS.has((0, $6VKBH.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $5d90bba78ce1a0b2$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $5d90bba78ce1a0b2$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $5d90bba78ce1a0b2$export$7918117e9202e4fb = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($5d90bba78ce1a0b2$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5d90bba78ce1a0b2$export$da4704525c20ae79 = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($5d90bba78ce1a0b2$var$INTEGRATION_NAME, $5d90bba78ce1a0b2$export$7918117e9202e4fb);


var $9FJRw = parcelRequire("9FJRw");
var $4m2mz = parcelRequire("4m2mz");

var $5Tp4j = parcelRequire("5Tp4j");
/** Regular expression used to parse a Dsn. */ const $4b93eccddbf210f5$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $4b93eccddbf210f5$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $4b93eccddbf210f5$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $4b93eccddbf210f5$export$b892860177f70a30(str) {
    const match = $4b93eccddbf210f5$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $5Tp4j.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $4b93eccddbf210f5$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $4b93eccddbf210f5$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $4b93eccddbf210f5$var$validateDsn(dsn) {
    if (!(0, $4m2mz.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $5Tp4j.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $5Tp4j.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$4b93eccddbf210f5$var$isValidProtocol(protocol)) {
        (0, $5Tp4j.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $5Tp4j.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $4b93eccddbf210f5$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $4b93eccddbf210f5$export$b892860177f70a30(from) : $4b93eccddbf210f5$var$dsnFromComponents(from);
    if (!components || !$4b93eccddbf210f5$var$validateDsn(components)) return undefined;
    return components;
}


var $9oYhG = parcelRequire("9oYhG");
const $5863b5dafb0cdaeb$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $5863b5dafb0cdaeb$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $5863b5dafb0cdaeb$var$_getIngestEndpoint(dsn) {
    return `${$5863b5dafb0cdaeb$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $5863b5dafb0cdaeb$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $9oYhG.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $5863b5dafb0cdaeb$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $5863b5dafb0cdaeb$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$5863b5dafb0cdaeb$var$_getIngestEndpoint(dsn)}?${$5863b5dafb0cdaeb$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $5863b5dafb0cdaeb$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $4b93eccddbf210f5$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$5863b5dafb0cdaeb$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $4b93eccddbf210f5$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $fV6gF = parcelRequire("fV6gF");
var $5Tp4j = parcelRequire("5Tp4j");
var $7NyaU = parcelRequire("7NyaU");

var $cLZZ4 = parcelRequire("cLZZ4");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $86be64ea59cd1f1d$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $86be64ea59cd1f1d$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $86be64ea59cd1f1d$var$INTEGRATION_NAME = 'InboundFilters';
const $86be64ea59cd1f1d$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $86be64ea59cd1f1d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $86be64ea59cd1f1d$var$_mergeOptions(options, clientOptions);
            return $86be64ea59cd1f1d$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $86be64ea59cd1f1d$export$cb3c5c2ceb9818ba = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($86be64ea59cd1f1d$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $86be64ea59cd1f1d$export$2ffbb5359dcc6be4 = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($86be64ea59cd1f1d$var$INTEGRATION_NAME, $86be64ea59cd1f1d$export$cb3c5c2ceb9818ba);
function $86be64ea59cd1f1d$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $86be64ea59cd1f1d$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $86be64ea59cd1f1d$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $86be64ea59cd1f1d$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $86be64ea59cd1f1d$var$_isSentryError(event)) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $fV6gF.getEventDescription)(event)}`);
        return true;
    }
    if ($86be64ea59cd1f1d$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $fV6gF.getEventDescription)(event)}`);
        return true;
    }
    if ($86be64ea59cd1f1d$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $fV6gF.getEventDescription)(event)}`);
        return true;
    }
    if ($86be64ea59cd1f1d$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $fV6gF.getEventDescription)(event)}.\nUrl: ${$86be64ea59cd1f1d$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$86be64ea59cd1f1d$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $fV6gF.getEventDescription)(event)}.\nUrl: ${$86be64ea59cd1f1d$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $86be64ea59cd1f1d$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $86be64ea59cd1f1d$var$_getPossibleEventMessages(event).some((message)=>(0, $7NyaU.stringMatchesSomePattern)(message, ignoreErrors));
}
function $86be64ea59cd1f1d$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $7NyaU.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $86be64ea59cd1f1d$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $86be64ea59cd1f1d$var$_getEventFilterUrl(event);
    return !url ? false : (0, $7NyaU.stringMatchesSomePattern)(url, denyUrls);
}
function $86be64ea59cd1f1d$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $86be64ea59cd1f1d$var$_getEventFilterUrl(event);
    return !url ? true : (0, $7NyaU.stringMatchesSomePattern)(url, allowUrls);
}
function $86be64ea59cd1f1d$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $cLZZ4.DEBUG_BUILD) && possibleMessages.length === 0) (0, $5Tp4j.logger).error(`Could not extract message for event ${(0, $fV6gF.getEventDescription)(event)}`);
    return possibleMessages;
}
function $86be64ea59cd1f1d$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $86be64ea59cd1f1d$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $86be64ea59cd1f1d$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $86be64ea59cd1f1d$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).error(`Cannot extract url for event ${(0, $fV6gF.getEventDescription)(event)}`);
        return null;
    }
}


var $5Tp4j = parcelRequire("5Tp4j");

var $cLZZ4 = parcelRequire("cLZZ4");

var $6VKBH = parcelRequire("6VKBH");

var $9FJRw = parcelRequire("9FJRw");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $ff713cfe0b3b8789$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $cLZZ4.DEBUG_BUILD) (0, $5Tp4j.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $5Tp4j.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $6VKBH.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $ff713cfe0b3b8789$export$ecb76f41d43c0e43(client);
    $ff713cfe0b3b8789$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $ff713cfe0b3b8789$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9FJRw.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $ff713cfe0b3b8789$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}



var $9oYhG = parcelRequire("9oYhG");



var $iyFKK = parcelRequire("iyFKK");

var $iyFKK = parcelRequire("iyFKK");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $01357e1236744053$var$WINDOW = (0, $iyFKK.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $01357e1236744053$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $01357e1236744053$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $01357e1236744053$var$WINDOW && !!$01357e1236744053$var$WINDOW.history.pushState && !!$01357e1236744053$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $2dyEB = parcelRequire("2dyEB");
const $5b1a558274404ac4$var$WINDOW = (0, $iyFKK.GLOBAL_OBJ);
let $5b1a558274404ac4$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5b1a558274404ac4$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $5b1a558274404ac4$var$instrumentHistory);
}
function $5b1a558274404ac4$var$instrumentHistory() {
    if (!(0, $01357e1236744053$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $5b1a558274404ac4$var$WINDOW.onpopstate;
    $5b1a558274404ac4$var$WINDOW.onpopstate = function(...args) {
        const to = $5b1a558274404ac4$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $5b1a558274404ac4$var$lastHref;
        $5b1a558274404ac4$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $2dyEB.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $5b1a558274404ac4$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $5b1a558274404ac4$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $2dyEB.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $9oYhG.fill)($5b1a558274404ac4$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $9oYhG.fill)($5b1a558274404ac4$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}


var $5Tp4j = parcelRequire("5Tp4j");
var $iLMLM = parcelRequire("iLMLM");
var $4m2mz = parcelRequire("4m2mz");

var $5Tp4j = parcelRequire("5Tp4j");

var $iyFKK = parcelRequire("iyFKK");
// eslint-disable-next-line deprecation/deprecation
const $b044ba47d40f7a17$var$WINDOW = (0, $iyFKK.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $b044ba47d40f7a17$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $b044ba47d40f7a17$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $b044ba47d40f7a17$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $b044ba47d40f7a17$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $b044ba47d40f7a17$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b044ba47d40f7a17$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $b044ba47d40f7a17$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$b044ba47d40f7a17$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($b044ba47d40f7a17$export$18cf36ed71d733e7($b044ba47d40f7a17$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $b044ba47d40f7a17$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $b044ba47d40f7a17$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $4m2mz.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $b044ba47d40f7a17$export$531055a6c684a70a() {
    return 'ReportingObserver' in $b044ba47d40f7a17$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $b044ba47d40f7a17$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$b044ba47d40f7a17$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $e9C8i = parcelRequire("e9C8i");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $b8597c446ce77233$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $e9C8i.SDK_VERSION)
            })),
        version: (0, $e9C8i.SDK_VERSION)
    };
    options._metadata = metadata;
}



var $gAfIh = parcelRequire("gAfIh");

var $9oYhG = parcelRequire("9oYhG");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $580b11aed5f18f19$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $580b11aed5f18f19$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $580b11aed5f18f19$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $580b11aed5f18f19$export$604a45d95a155e2b(envelope, types) {
    return $580b11aed5f18f19$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $580b11aed5f18f19$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $580b11aed5f18f19$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $580b11aed5f18f19$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $580b11aed5f18f19$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $gAfIh.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $580b11aed5f18f19$var$concatBuffers(parts);
}
function $580b11aed5f18f19$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $580b11aed5f18f19$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $580b11aed5f18f19$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $580b11aed5f18f19$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $9oYhG.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $580b11aed5f18f19$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $580b11aed5f18f19$export$b11169581eeaf237(type) {
    return $580b11aed5f18f19$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $580b11aed5f18f19$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $580b11aed5f18f19$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4b93eccddbf210f5$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $9oYhG.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


var $fV6gF = parcelRequire("fV6gF");
var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");
var $kT15L = parcelRequire("kT15L");/** An error emitted by Sentry SDKs and related utilities. */ class $27ae15d40fdba271$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




var $cLZZ4 = parcelRequire("cLZZ4");

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9969c1c6bd18b14e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9969c1c6bd18b14e$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $580b11aed5f18f19$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4b93eccddbf210f5$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $580b11aed5f18f19$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9969c1c6bd18b14e$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $580b11aed5f18f19$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $9969c1c6bd18b14e$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $580b11aed5f18f19$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $580b11aed5f18f19$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}



var $6VKBH = parcelRequire("6VKBH");

var $9FJRw = parcelRequire("9FJRw");



var $9oYhG = parcelRequire("9oYhG");
/**
 * Generate bucket key from metric properties.
 */ function $71f4520dbe86a2bc$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $9oYhG.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $71f4520dbe86a2bc$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $71f4520dbe86a2bc$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $71f4520dbe86a2bc$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $71f4520dbe86a2bc$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $71f4520dbe86a2bc$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $71f4520dbe86a2bc$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $71f4520dbe86a2bc$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $71f4520dbe86a2bc$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $71f4520dbe86a2bc$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $71f4520dbe86a2bc$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $71f4520dbe86a2bc$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $71f4520dbe86a2bc$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $71f4520dbe86a2bc$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $d4e7988c0a35ea73$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $4b93eccddbf210f5$export$44d472fbb931a776)(dsn);
    const item = $d4e7988c0a35ea73$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $580b11aed5f18f19$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $d4e7988c0a35ea73$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $71f4520dbe86a2bc$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}



var $5cxyv = parcelRequire("5cxyv");

var $3Uyl3 = parcelRequire("3Uyl3");

var $hW2rK = parcelRequire("hW2rK");
const $6968324f8e388390$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $6968324f8e388390$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $4b93eccddbf210f5$export$128827c3562ec0cb)(options.dsn);
        else (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $5863b5dafb0cdaeb$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $fV6gF.checkOrSetAlreadyCaught)(exception)) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log($6968324f8e388390$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $aYpzJ.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $aYpzJ.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $fV6gF.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log($6968324f8e388390$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $5cxyv.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $kT15L.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $2ad358cdcd1d5061$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $2ad358cdcd1d5061$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $9969c1c6bd18b14e$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $580b11aed5f18f19$export$d650323442802f6f)(env, (0, $580b11aed5f18f19$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $9969c1c6bd18b14e$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $d4e7988c0a35ea73$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $2ad358cdcd1d5061$export$51abed9797baa598)(this, integrations);
        (0, $2ad358cdcd1d5061$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $5cxyv.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $kT15L.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $9FJRw.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $hW2rK.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $3Uyl3.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $cLZZ4.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $5Tp4j.logger).log(sentryError.message);
                else (0, $5Tp4j.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $6968324f8e388390$var$isTransactionEvent(event);
        const isError = $6968324f8e388390$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $kT15L.rejectedSyncPromise)(new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $6968324f8e388390$var$processBeforeSend(options, prepared, hint);
            return $6968324f8e388390$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).error('Error while sending event:', reason);
        });
        else (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $6968324f8e388390$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $aYpzJ.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $aYpzJ.isPlainObject)(event) && event !== null) throw new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $aYpzJ.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $6968324f8e388390$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($6968324f8e388390$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($6968324f8e388390$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $6968324f8e388390$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $6968324f8e388390$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $6968324f8e388390$export$9aac0b9f77928fbf(callback) {
    const client = (0, $6VKBH.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




var $7X4Jf = parcelRequire("7X4Jf");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $f0718285ff21325b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $7X4Jf.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $580b11aed5f18f19$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $hTyas = parcelRequire("hTyas");
var $5Tp4j = parcelRequire("5Tp4j");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $df1c1f9adc07fef2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $6VKBH = parcelRequire("6VKBH");

var $fV6gF = parcelRequire("fV6gF");
var $9oYhG = parcelRequire("9oYhG");
var $aYpzJ = parcelRequire("aYpzJ");
var $gAfIh = parcelRequire("gAfIh");
var $kT15L = parcelRequire("kT15L");
/**
 * This function creates an exception from a JavaScript Error
 */ function $052d169c7ba0dbe9$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $052d169c7ba0dbe9$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $052d169c7ba0dbe9$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $052d169c7ba0dbe9$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $6VKBH.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $aYpzJ.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $052d169c7ba0dbe9$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $gAfIh.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $052d169c7ba0dbe9$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $052d169c7ba0dbe9$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $052d169c7ba0dbe9$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $052d169c7ba0dbe9$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $052d169c7ba0dbe9$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $052d169c7ba0dbe9$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $052d169c7ba0dbe9$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($052d169c7ba0dbe9$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $052d169c7ba0dbe9$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $052d169c7ba0dbe9$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $052d169c7ba0dbe9$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $fV6gF.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $kT15L.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $052d169c7ba0dbe9$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $052d169c7ba0dbe9$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $kT15L.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $052d169c7ba0dbe9$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $aYpzJ.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $052d169c7ba0dbe9$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $aYpzJ.isDOMError)(exception) || (0, $aYpzJ.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $052d169c7ba0dbe9$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $aYpzJ.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $052d169c7ba0dbe9$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $fV6gF.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $aYpzJ.isError)(exception)) // we have a real Error object, do nothing
    return $052d169c7ba0dbe9$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $aYpzJ.isPlainObject)(exception) || (0, $aYpzJ.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $052d169c7ba0dbe9$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $fV6gF.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $052d169c7ba0dbe9$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $fV6gF.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $fV6gF.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $052d169c7ba0dbe9$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $052d169c7ba0dbe9$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $aYpzJ.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $052d169c7ba0dbe9$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9oYhG.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $aYpzJ.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $aYpzJ.isEvent)(exception)) {
        const className = $052d169c7ba0dbe9$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $052d169c7ba0dbe9$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




var $6VKBH = parcelRequire("6VKBH");

var $fV6gF = parcelRequire("fV6gF");
var $9oYhG = parcelRequire("9oYhG");
var $iyFKK = parcelRequire("iyFKK");
const $65295f3e0ade1f3b$export$56d8a8a25bd48b81 = (0, $iyFKK.GLOBAL_OBJ);
let $65295f3e0ade1f3b$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $65295f3e0ade1f3b$export$b79738ab10c590b2() {
    return $65295f3e0ade1f3b$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $65295f3e0ade1f3b$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $65295f3e0ade1f3b$var$ignoreOnError++;
    setTimeout(()=>{
        $65295f3e0ade1f3b$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $65295f3e0ade1f3b$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $9oYhG.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$65295f3e0ade1f3b$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $65295f3e0ade1f3b$export$1265a142ff5ba165();
            (0, $6VKBH.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $fV6gF.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $fV6gF.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $6VKBH.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9oYhG.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9oYhG.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $b0e98acba7b957af$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $4b93eccddbf210f5$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $b0e98acba7b957af$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $580b11aed5f18f19$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b0e98acba7b957af$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $cb594d2d4e74038e$export$1df9218a526d318d extends (0, $6968324f8e388390$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $hTyas.getSDKSource)();
        (0, $b8597c446ce77233$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document) (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $052d169c7ba0dbe9$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $052d169c7ba0dbe9$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $b0e98acba7b957af$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $f0718285ff21325b$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $4b93eccddbf210f5$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}





var $6VKBH = parcelRequire("6VKBH");

var $fV6gF = parcelRequire("fV6gF");

var $9oYhG = parcelRequire("9oYhG");

var $iyFKK = parcelRequire("iyFKK");

var $2dyEB = parcelRequire("2dyEB");
const $3644d9024b26489d$var$WINDOW = (0, $iyFKK.GLOBAL_OBJ);
const $3644d9024b26489d$var$DEBOUNCE_DURATION = 1000;
let $3644d9024b26489d$var$debounceTimerID;
let $3644d9024b26489d$var$lastCapturedEventType;
let $3644d9024b26489d$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3644d9024b26489d$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $3644d9024b26489d$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $3644d9024b26489d$export$3014bbf0af0e1d4a() {
    if (!$3644d9024b26489d$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $2dyEB.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $3644d9024b26489d$var$makeDOMEventHandler(triggerDOMHandler, true);
    $3644d9024b26489d$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $3644d9024b26489d$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $3644d9024b26489d$var$WINDOW[target] && $3644d9024b26489d$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $9oYhG.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $3644d9024b26489d$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $9oYhG.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $3644d9024b26489d$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $3644d9024b26489d$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $3644d9024b26489d$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $3644d9024b26489d$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $3644d9024b26489d$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $3644d9024b26489d$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($3644d9024b26489d$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $9oYhG.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $9oYhG.addNonEnumerableProperty)(target, '_sentryId', (0, $fV6gF.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$3644d9024b26489d$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $3644d9024b26489d$var$lastCapturedEventType = event.type;
            $3644d9024b26489d$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($3644d9024b26489d$var$debounceTimerID);
        $3644d9024b26489d$var$debounceTimerID = $3644d9024b26489d$var$WINDOW.setTimeout(()=>{
            $3644d9024b26489d$var$lastCapturedEventTargetId = undefined;
            $3644d9024b26489d$var$lastCapturedEventType = undefined;
        }, $3644d9024b26489d$var$DEBOUNCE_DURATION);
    };
}
function $3644d9024b26489d$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


var $5Tp4j = parcelRequire("5Tp4j");

var $9oYhG = parcelRequire("9oYhG");

var $iyFKK = parcelRequire("iyFKK");

var $2dyEB = parcelRequire("2dyEB");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cd386dbcd943a08d$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $cd386dbcd943a08d$var$instrumentConsole);
}
function $cd386dbcd943a08d$var$instrumentConsole() {
    if (!('console' in (0, $iyFKK.GLOBAL_OBJ))) return;
    (0, $5Tp4j.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $iyFKK.GLOBAL_OBJ).console)) return;
        (0, $9oYhG.fill)((0, $iyFKK.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $5Tp4j.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $2dyEB.triggerHandlers)('console', handlerData);
                const log = (0, $5Tp4j.originalConsoleMethods)[level];
                log && log.apply((0, $iyFKK.GLOBAL_OBJ).console, args);
            };
        });
    });
}


var $9oYhG = parcelRequire("9oYhG");


var $iyFKK = parcelRequire("iyFKK");

var $2dyEB = parcelRequire("2dyEB");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $04e991c4561f18e1$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $04e991c4561f18e1$var$instrumentFetch);
}
function $04e991c4561f18e1$var$instrumentFetch() {
    if (!(0, $b044ba47d40f7a17$export$c82d238e23c40b21)()) return;
    (0, $9oYhG.fill)((0, $iyFKK.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $04e991c4561f18e1$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $2dyEB.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $iyFKK.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $2dyEB.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $2dyEB.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $04e991c4561f18e1$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $04e991c4561f18e1$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($04e991c4561f18e1$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $04e991c4561f18e1$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $04e991c4561f18e1$var$getUrlFromResource(url),
            method: $04e991c4561f18e1$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $04e991c4561f18e1$var$getUrlFromResource(arg),
        method: $04e991c4561f18e1$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}


var $aYpzJ = parcelRequire("aYpzJ");

var $9oYhG = parcelRequire("9oYhG");

var $iyFKK = parcelRequire("iyFKK");

var $2dyEB = parcelRequire("2dyEB");
const $c03b20ad1c85097e$var$WINDOW = (0, $iyFKK.GLOBAL_OBJ);
const $c03b20ad1c85097e$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c03b20ad1c85097e$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $2dyEB.addHandler)(type, handler);
    (0, $2dyEB.maybeInstrument)(type, $c03b20ad1c85097e$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $c03b20ad1c85097e$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$c03b20ad1c85097e$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $9oYhG.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $aYpzJ.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $c03b20ad1c85097e$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$c03b20ad1c85097e$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$c03b20ad1c85097e$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $2dyEB.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $9oYhG.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $9oYhG.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$c03b20ad1c85097e$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $aYpzJ.isString)(header) && (0, $aYpzJ.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $9oYhG.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$c03b20ad1c85097e$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $2dyEB.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $c03b20ad1c85097e$var$parseUrl(url) {
    if ((0, $aYpzJ.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}


var $c9A3H = parcelRequire("c9A3H");
var $fV6gF = parcelRequire("fV6gF");
var $5Tp4j = parcelRequire("5Tp4j");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $46d559bf03833ae8$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $46d559bf03833ae8$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $46d559bf03833ae8$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $46d559bf03833ae8$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


var $7NyaU = parcelRequire("7NyaU");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $f04e5920fd683709$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $f04e5920fd683709$export$e01cef29b4327697(level) {
    return $f04e5920fd683709$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $f04e5920fd683709$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $f04e5920fd683709$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $d26ec31bd4d8a108$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $d26ec31bd4d8a108$var$INTEGRATION_NAME = 'Breadcrumbs';
const $d26ec31bd4d8a108$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $d26ec31bd4d8a108$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $cd386dbcd943a08d$export$1d6e0d073f9e6723)($d26ec31bd4d8a108$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $3644d9024b26489d$export$5aeffd3db2cf9df7)($d26ec31bd4d8a108$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $c03b20ad1c85097e$export$26ace48dd54c9aea)($d26ec31bd4d8a108$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $04e991c4561f18e1$export$f75d3c772c923df0)($d26ec31bd4d8a108$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $5b1a558274404ac4$export$3f18c56c58114e75)($d26ec31bd4d8a108$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $d26ec31bd4d8a108$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $d26ec31bd4d8a108$export$c079d904b326663a = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($d26ec31bd4d8a108$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d26ec31bd4d8a108$export$2dc68d50d56fbbd = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($d26ec31bd4d8a108$var$INTEGRATION_NAME, $d26ec31bd4d8a108$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $d26ec31bd4d8a108$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $6VKBH.getClient)() !== client) return;
        (0, $6VKBH.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $fV6gF.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $d26ec31bd4d8a108$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $6VKBH.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $d26ec31bd4d8a108$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$d26ec31bd4d8a108$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$d26ec31bd4d8a108$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $d26ec31bd4d8a108$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $d26ec31bd4d8a108$var$_isEvent(event) ? event.target : event;
            target = (0, $c9A3H.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $c9A3H.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $6VKBH.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $d26ec31bd4d8a108$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $6VKBH.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $f04e5920fd683709$export$d771ef054122c30a)(handlerData.level),
            message: (0, $7NyaU.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $7NyaU.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $6VKBH.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $d26ec31bd4d8a108$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $6VKBH.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $c03b20ad1c85097e$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $6VKBH.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $d26ec31bd4d8a108$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $6VKBH.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $6VKBH.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $6VKBH.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $d26ec31bd4d8a108$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $6VKBH.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $46d559bf03833ae8$export$7a5253c0f62e0150)((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $46d559bf03833ae8$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $46d559bf03833ae8$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $6VKBH.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $d26ec31bd4d8a108$var$_isEvent(event) {
    return !!event && !!event.target;
}




var $5Tp4j = parcelRequire("5Tp4j");

const $72980737aadd89ab$var$INTEGRATION_NAME = 'Dedupe';
const $72980737aadd89ab$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $72980737aadd89ab$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($72980737aadd89ab$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $72980737aadd89ab$export$6d39aa44cd0c7567 = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($72980737aadd89ab$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $72980737aadd89ab$export$688d98c249d31ad3 = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($72980737aadd89ab$var$INTEGRATION_NAME, $72980737aadd89ab$export$6d39aa44cd0c7567);
function $72980737aadd89ab$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($72980737aadd89ab$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($72980737aadd89ab$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $72980737aadd89ab$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$72980737aadd89ab$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$72980737aadd89ab$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $72980737aadd89ab$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $72980737aadd89ab$var$_getExceptionFromEvent(previousEvent);
    const currentException = $72980737aadd89ab$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$72980737aadd89ab$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$72980737aadd89ab$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $72980737aadd89ab$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $72980737aadd89ab$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $72980737aadd89ab$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $72980737aadd89ab$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $72980737aadd89ab$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $72980737aadd89ab$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $6VKBH = parcelRequire("6VKBH");

var $8BjtY = parcelRequire("8BjtY");
var $6fjdr = parcelRequire("6fjdr");
var $c9A3H = parcelRequire("c9A3H");
var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $50edb5d46f4984a5$var$INTEGRATION_NAME = 'GlobalHandlers';
const $50edb5d46f4984a5$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $50edb5d46f4984a5$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $50edb5d46f4984a5$var$_installGlobalOnErrorHandler(client);
                $50edb5d46f4984a5$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $50edb5d46f4984a5$var$_installGlobalOnUnhandledRejectionHandler(client);
                $50edb5d46f4984a5$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $50edb5d46f4984a5$export$66acc70e8cf2b71a = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($50edb5d46f4984a5$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $50edb5d46f4984a5$export$204155decbc90e5a = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($50edb5d46f4984a5$var$INTEGRATION_NAME, $50edb5d46f4984a5$export$66acc70e8cf2b71a);
function $50edb5d46f4984a5$var$_installGlobalOnErrorHandler(client) {
    (0, $8BjtY.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $50edb5d46f4984a5$var$getOptions();
        if ((0, $6VKBH.getClient)() !== client || (0, $65295f3e0ade1f3b$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $aYpzJ.isString)(msg) ? $50edb5d46f4984a5$var$_eventFromIncompleteOnError(msg, url, line, column) : $50edb5d46f4984a5$var$_enhanceEventWithInitialFrame((0, $052d169c7ba0dbe9$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $6VKBH.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $50edb5d46f4984a5$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $6fjdr.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $50edb5d46f4984a5$var$getOptions();
        if ((0, $6VKBH.getClient)() !== client || (0, $65295f3e0ade1f3b$export$b79738ab10c590b2)()) return;
        const error = $50edb5d46f4984a5$var$_getUnhandledRejectionError(e);
        const event = (0, $aYpzJ.isPrimitive)(error) ? $50edb5d46f4984a5$var$_eventFromRejectionWithPrimitive(error) : (0, $052d169c7ba0dbe9$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $6VKBH.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $50edb5d46f4984a5$var$_getUnhandledRejectionError(error) {
    if ((0, $aYpzJ.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $50edb5d46f4984a5$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $50edb5d46f4984a5$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $aYpzJ.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $50edb5d46f4984a5$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $50edb5d46f4984a5$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $aYpzJ.isString)(url) && url.length > 0 ? url : (0, $c9A3H.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $50edb5d46f4984a5$var$globalHandlerLog(type) {
    (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).log(`Global Handler attached: ${type}`);
}
function $50edb5d46f4984a5$var$getOptions() {
    const client = (0, $6VKBH.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $12524d36f36587a8$var$INTEGRATION_NAME = 'HttpContext';
const $12524d36f36587a8$var$_httpContextIntegration = ()=>{
    return {
        name: $12524d36f36587a8$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).navigator && !(0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).location && !(0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).location && (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $12524d36f36587a8$export$1378794447170364 = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($12524d36f36587a8$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $12524d36f36587a8$export$5d2ee9a544b09a94 = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($12524d36f36587a8$var$INTEGRATION_NAME, $12524d36f36587a8$export$1378794447170364);




var $aYpzJ = parcelRequire("aYpzJ");

var $7NyaU = parcelRequire("7NyaU");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $7c8f7bea50dd08a5$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $aYpzJ.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $7c8f7bea50dd08a5$var$truncateAggregateExceptions($7c8f7bea50dd08a5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $7c8f7bea50dd08a5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $aYpzJ.isInstanceOf)(error[key], Error)) {
        $7c8f7bea50dd08a5$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $7c8f7bea50dd08a5$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $7c8f7bea50dd08a5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $aYpzJ.isInstanceOf)(childError, Error)) {
            $7c8f7bea50dd08a5$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $7c8f7bea50dd08a5$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $7c8f7bea50dd08a5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $7c8f7bea50dd08a5$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $7c8f7bea50dd08a5$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $7c8f7bea50dd08a5$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $7NyaU.truncate)(exception.value, maxValueLength);
        return exception;
    });
}



const $2511860915c3df74$var$DEFAULT_KEY = 'cause';
const $2511860915c3df74$var$DEFAULT_LIMIT = 5;
const $2511860915c3df74$var$INTEGRATION_NAME = 'LinkedErrors';
const $2511860915c3df74$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $2511860915c3df74$var$DEFAULT_LIMIT;
    const key = options.key || $2511860915c3df74$var$DEFAULT_KEY;
    return {
        name: $2511860915c3df74$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $7c8f7bea50dd08a5$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $052d169c7ba0dbe9$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $2511860915c3df74$export$ebabb00eb7f3a395 = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($2511860915c3df74$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2511860915c3df74$export$8d1e60aaf616fb4f = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($2511860915c3df74$var$INTEGRATION_NAME, $2511860915c3df74$export$ebabb00eb7f3a395);




var $9oYhG = parcelRequire("9oYhG");
var $iLMLM = parcelRequire("iLMLM");

const $cf933686e321b3be$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $cf933686e321b3be$var$INTEGRATION_NAME = 'TryCatch';
const $cf933686e321b3be$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $cf933686e321b3be$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $9oYhG.fill)((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81), 'setTimeout', $cf933686e321b3be$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $9oYhG.fill)((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81), 'setInterval', $cf933686e321b3be$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $9oYhG.fill)((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81), 'requestAnimationFrame', $cf933686e321b3be$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81)) (0, $9oYhG.fill)(XMLHttpRequest.prototype, 'send', $cf933686e321b3be$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $cf933686e321b3be$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($cf933686e321b3be$var$_wrapEventTarget);
            }
        }
    };
};
const $cf933686e321b3be$export$59bfe9f1c76150e = (0, $2ad358cdcd1d5061$export$2323046b9414659f)($cf933686e321b3be$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $cf933686e321b3be$export$f1a018517668e6d3 = (0, $2ad358cdcd1d5061$export$afa219bf23651160)($cf933686e321b3be$var$INTEGRATION_NAME, $cf933686e321b3be$export$59bfe9f1c76150e);
function $cf933686e321b3be$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $65295f3e0ade1f3b$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $iLMLM.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cf933686e321b3be$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $65295f3e0ade1f3b$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $iLMLM.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $cf933686e321b3be$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9oYhG.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $iLMLM.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $9oYhG.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $iLMLM.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $65295f3e0ade1f3b$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $cf933686e321b3be$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $9oYhG.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $65295f3e0ade1f3b$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $iLMLM.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $65295f3e0ade1f3b$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $iLMLM.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $9oYhG.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



var $iLMLM = parcelRequire("iLMLM");
// global reference to slice
const $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION = '?';
const $a090f8fd4ca3ba44$var$OPERA10_PRIORITY = 10;
const $a090f8fd4ca3ba44$var$OPERA11_PRIORITY = 20;
const $a090f8fd4ca3ba44$var$CHROME_PRIORITY = 30;
const $a090f8fd4ca3ba44$var$WINJS_PRIORITY = 40;
const $a090f8fd4ca3ba44$var$GECKO_PRIORITY = 50;
function $a090f8fd4ca3ba44$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $a090f8fd4ca3ba44$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $a090f8fd4ca3ba44$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $a090f8fd4ca3ba44$var$chromeStackParserFn = (line)=>{
    const parts = $a090f8fd4ca3ba44$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $a090f8fd4ca3ba44$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $a090f8fd4ca3ba44$var$extractSafariExtensionDetails(parts[1] || $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION, parts[2]);
        return $a090f8fd4ca3ba44$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $a090f8fd4ca3ba44$export$263a749fff749872 = [
    $a090f8fd4ca3ba44$var$CHROME_PRIORITY,
    $a090f8fd4ca3ba44$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $a090f8fd4ca3ba44$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $a090f8fd4ca3ba44$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $a090f8fd4ca3ba44$var$gecko = (line)=>{
    const parts = $a090f8fd4ca3ba44$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $a090f8fd4ca3ba44$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION;
        [func, filename] = $a090f8fd4ca3ba44$var$extractSafariExtensionDetails(func, filename);
        return $a090f8fd4ca3ba44$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $a090f8fd4ca3ba44$export$cdba47a5dd2804d = [
    $a090f8fd4ca3ba44$var$GECKO_PRIORITY,
    $a090f8fd4ca3ba44$var$gecko
];
const $a090f8fd4ca3ba44$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $a090f8fd4ca3ba44$var$winjs = (line)=>{
    const parts = $a090f8fd4ca3ba44$var$winjsRegex.exec(line);
    return parts ? $a090f8fd4ca3ba44$var$createFrame(parts[2], parts[1] || $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $a090f8fd4ca3ba44$export$179460296da408e8 = [
    $a090f8fd4ca3ba44$var$WINJS_PRIORITY,
    $a090f8fd4ca3ba44$var$winjs
];
const $a090f8fd4ca3ba44$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $a090f8fd4ca3ba44$var$opera10 = (line)=>{
    const parts = $a090f8fd4ca3ba44$var$opera10Regex.exec(line);
    return parts ? $a090f8fd4ca3ba44$var$createFrame(parts[2], parts[3] || $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $a090f8fd4ca3ba44$export$f892b52c880ffc7a = [
    $a090f8fd4ca3ba44$var$OPERA10_PRIORITY,
    $a090f8fd4ca3ba44$var$opera10
];
const $a090f8fd4ca3ba44$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $a090f8fd4ca3ba44$var$opera11 = (line)=>{
    const parts = $a090f8fd4ca3ba44$var$opera11Regex.exec(line);
    return parts ? $a090f8fd4ca3ba44$var$createFrame(parts[5], parts[3] || parts[4] || $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $a090f8fd4ca3ba44$export$af11af13f09fb0dc = [
    $a090f8fd4ca3ba44$var$OPERA11_PRIORITY,
    $a090f8fd4ca3ba44$var$opera11
];
const $a090f8fd4ca3ba44$export$7197c0fe6554c079 = [
    $a090f8fd4ca3ba44$export$263a749fff749872,
    $a090f8fd4ca3ba44$export$cdba47a5dd2804d,
    $a090f8fd4ca3ba44$export$179460296da408e8
];
const $a090f8fd4ca3ba44$export$2b2b997d81bf3907 = (0, $iLMLM.createStackParser)(...$a090f8fd4ca3ba44$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $a090f8fd4ca3ba44$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $a090f8fd4ca3ba44$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $df671712b32c109e$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $df671712b32c109e$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $df671712b32c109e$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $df671712b32c109e$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $df671712b32c109e$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $df671712b32c109e$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $df671712b32c109e$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $df671712b32c109e$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $5Tp4j = parcelRequire("5Tp4j");

var $kT15L = parcelRequire("kT15L");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $a73163c59006d4db$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $kT15L.rejectedSyncPromise)(new (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $kT15L.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $kT15L.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $kT15L = parcelRequire("kT15L");

var $cLZZ4 = parcelRequire("cLZZ4");
const $4845bc231ea21bd5$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $4845bc231ea21bd5$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $a73163c59006d4db$export$85a4f67f852183e6)(options.bufferSize || $4845bc231ea21bd5$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $580b11aed5f18f19$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $580b11aed5f18f19$export$b11169581eeaf237)(type);
            if ((0, $df671712b32c109e$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $4845bc231ea21bd5$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $kT15L.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $580b11aed5f18f19$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $580b11aed5f18f19$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $4845bc231ea21bd5$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $580b11aed5f18f19$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $580b11aed5f18f19$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $df671712b32c109e$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $27ae15d40fdba271$export$5949942ba2a7c0e2)) {
                (0, $cLZZ4.DEBUG_BUILD) && (0, $5Tp4j.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $kT15L.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $4845bc231ea21bd5$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $kT15L = parcelRequire("kT15L");

var $5Tp4j = parcelRequire("5Tp4j");


let $517fa2f357267341$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $517fa2f357267341$export$8be2119ce08e3379() {
    if ($517fa2f357267341$var$cachedFetchImpl) return $517fa2f357267341$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $b044ba47d40f7a17$export$18cf36ed71d733e7)((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).fetch)) return $517fa2f357267341$var$cachedFetchImpl = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).fetch.bind((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81));
    const document = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $517fa2f357267341$var$cachedFetchImpl = fetchImpl.bind((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $517fa2f357267341$export$d499686d2dd738c6() {
    $517fa2f357267341$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $5d764bbe3c4b3074$export$b2311068c46d7cc8(options, nativeFetch = (0, $517fa2f357267341$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $517fa2f357267341$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $kT15L.rejectedSyncPromise)(e);
        }
    }
    return (0, $4845bc231ea21bd5$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $kT15L = parcelRequire("kT15L");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $6e3c8d7579a49494$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $6e3c8d7579a49494$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $kT15L.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $6e3c8d7579a49494$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $4845bc231ea21bd5$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $09e46be37637154f$export$5ef831fccfce35e5 = [
    (0, $86be64ea59cd1f1d$export$cb3c5c2ceb9818ba)(),
    (0, $5d90bba78ce1a0b2$export$7918117e9202e4fb)(),
    (0, $cf933686e321b3be$export$59bfe9f1c76150e)(),
    (0, $d26ec31bd4d8a108$export$c079d904b326663a)(),
    (0, $50edb5d46f4984a5$export$66acc70e8cf2b71a)(),
    (0, $2511860915c3df74$export$ebabb00eb7f3a395)(),
    (0, $72980737aadd89ab$export$6d39aa44cd0c7567)(),
    (0, $12524d36f36587a8$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $09e46be37637154f$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$09e46be37637154f$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $09e46be37637154f$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $09e46be37637154f$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $iLMLM.stackParserFromStackParserOptions)(options.stackParser || (0, $a090f8fd4ca3ba44$export$2b2b997d81bf3907)),
        integrations: (0, $2ad358cdcd1d5061$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $b044ba47d40f7a17$export$edf3cb81fd7d2a3e)() ? (0, $5d764bbe3c4b3074$export$b2311068c46d7cc8) : (0, $6e3c8d7579a49494$export$5e1441cee30d5a39))
    };
    (0, $ff713cfe0b3b8789$export$5333c3f1c58d9bc1)((0, $cb594d2d4e74038e$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $09e46be37637154f$var$startSessionTracking();
}
const $09e46be37637154f$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $9FJRw.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document) {
        (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $5863b5dafb0cdaeb$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document.head || (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $09e46be37637154f$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $09e46be37637154f$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $09e46be37637154f$export$4997ffc0176396a6(fn) {
    return (0, $65295f3e0ade1f3b$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $09e46be37637154f$var$startSessionTracking() {
    if (typeof (0, $65295f3e0ade1f3b$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $df1c1f9adc07fef2$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $6VKBH.startSession)({
        ignoreDuration: true
    });
    (0, $6VKBH.captureSession)();
    // We want to create a session for every navigation as well
    (0, $5b1a558274404ac4$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $6VKBH.startSession)({
                ignoreDuration: true
            });
            (0, $6VKBH.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $09e46be37637154f$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $6VKBH.getClient)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $496a7ca8d72a7cc9$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $b8597c446ce77233$export$b9f95b027256052c)(opts, 'react');
    (0, $09e46be37637154f$export$2cd8252107eb640b)(opts);
}



var $bFpVl = parcelRequire("bFpVl");/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $984caf93a01ec55f$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $fV6gF = parcelRequire("fV6gF");
var $9oYhG = parcelRequire("9oYhG");
var $aYpzJ = parcelRequire("aYpzJ");
var $gB5MK = parcelRequire("gB5MK");
var $5Tp4j = parcelRequire("5Tp4j");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d244f740f8e5a952$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function $c9782aebda9e1077$export$34db76d03eb96b7e(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    const clientOptions = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        getCurrentHub,
        'call',
        (_)=>_(),
        'access',
        (_2)=>_2.getClient,
        'call',
        (_3)=>_3(),
        'optionalAccess',
        (_4)=>_4.getOptions,
        'call',
        (_5)=>_5()
    ]);
    const instrumenter = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        clientOptions,
        'optionalAccess',
        (_6)=>_6.instrumenter
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}


/** Tracing integration for Apollo */ class $12155c12ea8508e8$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Apollo';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = $12155c12ea8508e8$export$3db3e396472fda8d.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $gB5MK.loadModule)('@nestjs/graphql');
        else this._module = this._module || (0, $gB5MK.loadModule)('apollo-server-core');
        return this._module;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $9oYhG.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                return function(...args) {
                    (0, $9oYhG.fill)(this.resolversExplorerService, 'explore', function(orig) {
                        return function() {
                            const resolvers = (0, $fV6gF.arrayify)(orig.call(this));
                            const instrumentedResolvers = $12155c12ea8508e8$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $9oYhG.fill)(pkg.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (0, $d244f740f8e5a952$export$16a28057038b10ef) {
                            if (this.config.schema) {
                                (0, $5Tp4j.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $5Tp4j.logger).warn();
                            } else if (this.config.modules) (0, $5Tp4j.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                            (0, $5Tp4j.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $fV6gF.arrayify)(this.config.resolvers);
                    this.config.resolvers = $12155c12ea8508e8$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$12155c12ea8508e8$export$3db3e396472fda8d.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function $12155c12ea8508e8$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                $12155c12ea8508e8$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $12155c12ea8508e8$var$wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, $9oYhG.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                parentSpan,
                'optionalAccess',
                (_2)=>_2.startChild,
                'call',
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: 'graphql.resolve',
                        origin: 'auto.graphql.apollo'
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $aYpzJ.isThenable)(rv)) return rv.then((res)=>{
                (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_4)=>_4.end,
                    'call',
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                span,
                'optionalAccess',
                (_6)=>_6.end,
                'call',
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}


var $aGB1Z = parcelRequire("aGB1Z");
var $j527G = parcelRequire("j527G");
var $6VKBH = parcelRequire("6VKBH");
var $eas0Q = parcelRequire("eas0Q");
var $dveIv = parcelRequire("dveIv");

var $c9A3H = parcelRequire("c9A3H");
var $5Tp4j = parcelRequire("5Tp4j");
var $UpCJO = parcelRequire("UpCJO");


var $j527G = parcelRequire("j527G");
var $9lgN8 = parcelRequire("9lgN8");

var $5Tp4j = parcelRequire("5Tp4j");


var $iyFKK = parcelRequire("iyFKK");
const $6319ad5bbb0c97e7$export$56d8a8a25bd48b81 = (0, $iyFKK.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $6e9524f724eec940$export$6f18f55521af71a1() {
    if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document) (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $j527G.getActiveTransaction)();
        if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $9lgN8.spanToJSON)(activeTransaction);
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}



var $iLMLM = parcelRequire("iLMLM");
var $5Tp4j = parcelRequire("5Tp4j");

const $0b8951ac527bdc53$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $333e482c67a8f73a$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b0c226ebf102022d$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $b0c226ebf102022d$export$6431553786c94949 = ()=>{
    if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $b0c226ebf102022d$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $039f968db95a5ef4$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $b0c226ebf102022d$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e24305dac17ec0a4$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $b0c226ebf102022d$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document && (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.prerendering || (0, $039f968db95a5ef4$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $333e482c67a8f73a$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $1b9b8c590ec3245b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $62da64ac344db0ae$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3a6907c996d73e30$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $e24305dac17ec0a4$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $1b9b8c590ec3245b$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $0b8951ac527bdc53$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $62da64ac344db0ae$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d6a0a7c8fa34d599$var$firstHiddenTime = -1;
const $d6a0a7c8fa34d599$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document && (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.visibilityState) $d6a0a7c8fa34d599$var$firstHiddenTime = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $d6a0a7c8fa34d599$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $62da64ac344db0ae$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $d6a0a7c8fa34d599$var$firstHiddenTime = timeStamp;
    }, true);
};
const $d6a0a7c8fa34d599$export$443f86b2c77012c4 = ()=>{
    if ($d6a0a7c8fa34d599$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $d6a0a7c8fa34d599$var$initHiddenTime();
        $d6a0a7c8fa34d599$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $d6a0a7c8fa34d599$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $c3fc9e4ed21c8525$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $d6a0a7c8fa34d599$export$443f86b2c77012c4)();
    const metric = (0, $e24305dac17ec0a4$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $1b9b8c590ec3245b$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $0b8951ac527bdc53$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $62da64ac344db0ae$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $b941fa2f0cb63d19$var$interactionCountEstimate = 0;
let $b941fa2f0cb63d19$var$minKnownInteractionId = Infinity;
let $b941fa2f0cb63d19$var$maxKnownInteractionId = 0;
const $b941fa2f0cb63d19$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $b941fa2f0cb63d19$var$minKnownInteractionId = Math.min($b941fa2f0cb63d19$var$minKnownInteractionId, e.interactionId);
            $b941fa2f0cb63d19$var$maxKnownInteractionId = Math.max($b941fa2f0cb63d19$var$maxKnownInteractionId, e.interactionId);
            $b941fa2f0cb63d19$var$interactionCountEstimate = $b941fa2f0cb63d19$var$maxKnownInteractionId ? ($b941fa2f0cb63d19$var$maxKnownInteractionId - $b941fa2f0cb63d19$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $b941fa2f0cb63d19$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $b941fa2f0cb63d19$export$8a962f2683a476d1 = ()=>{
    return $b941fa2f0cb63d19$var$po ? $b941fa2f0cb63d19$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $b941fa2f0cb63d19$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $b941fa2f0cb63d19$var$po) return;
    $b941fa2f0cb63d19$var$po = (0, $1b9b8c590ec3245b$export$d1203567a167490e)('event', $b941fa2f0cb63d19$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $79eed2ea8e6972fb$var$getInteractionCountForNavigation = ()=>{
    return (0, $b941fa2f0cb63d19$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $79eed2ea8e6972fb$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $79eed2ea8e6972fb$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $79eed2ea8e6972fb$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $79eed2ea8e6972fb$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $79eed2ea8e6972fb$var$longestInteractionList[$79eed2ea8e6972fb$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $79eed2ea8e6972fb$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $79eed2ea8e6972fb$var$longestInteractionList.length < $79eed2ea8e6972fb$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $79eed2ea8e6972fb$var$longestInteractionMap[interaction.id] = interaction;
            $79eed2ea8e6972fb$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $79eed2ea8e6972fb$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $79eed2ea8e6972fb$var$longestInteractionList.splice($79eed2ea8e6972fb$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $79eed2ea8e6972fb$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $79eed2ea8e6972fb$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($79eed2ea8e6972fb$var$longestInteractionList.length - 1, Math.floor($79eed2ea8e6972fb$var$getInteractionCountForNavigation() / 50));
    return $79eed2ea8e6972fb$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $79eed2ea8e6972fb$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $b941fa2f0cb63d19$export$67d90cda6b78a2eb)();
    const metric = (0, $e24305dac17ec0a4$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $79eed2ea8e6972fb$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$79eed2ea8e6972fb$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $79eed2ea8e6972fb$var$processEntry(entry);
            }
        });
        const inp = $79eed2ea8e6972fb$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $1b9b8c590ec3245b$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $0b8951ac527bdc53$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $62da64ac344db0ae$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $79eed2ea8e6972fb$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7cf137f1956aff4e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $7cf137f1956aff4e$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $d6a0a7c8fa34d599$export$443f86b2c77012c4)();
    const metric = (0, $e24305dac17ec0a4$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $039f968db95a5ef4$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $1b9b8c590ec3245b$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $0b8951ac527bdc53$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$7cf137f1956aff4e$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $7cf137f1956aff4e$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $62da64ac344db0ae$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $875edbcec7a24f4a$var$whenReady = (callback)=>{
    if (!(0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document) return;
    if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>$875edbcec7a24f4a$var$whenReady(callback), true);
    else if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$875edbcec7a24f4a$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $875edbcec7a24f4a$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $e24305dac17ec0a4$export$3c29b44508a0612b)('TTFB');
    const report = (0, $0b8951ac527bdc53$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $875edbcec7a24f4a$var$whenReady(()=>{
        const navEntry = (0, $b0c226ebf102022d$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $039f968db95a5ef4$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $ad44d413fc5e465d$var$handlers = {};
const $ad44d413fc5e465d$var$instrumented = {};
let $ad44d413fc5e465d$var$_previousCls;
let $ad44d413fc5e465d$var$_previousFid;
let $ad44d413fc5e465d$var$_previousLcp;
let $ad44d413fc5e465d$var$_previousTtfb;
let $ad44d413fc5e465d$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $ad44d413fc5e465d$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $ad44d413fc5e465d$var$addMetricObserver('cls', callback, $ad44d413fc5e465d$var$instrumentCls, $ad44d413fc5e465d$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $ad44d413fc5e465d$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $ad44d413fc5e465d$var$addMetricObserver('lcp', callback, $ad44d413fc5e465d$var$instrumentLcp, $ad44d413fc5e465d$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $ad44d413fc5e465d$export$699d9529c099a797(callback) {
    return $ad44d413fc5e465d$var$addMetricObserver('ttfb', callback, $ad44d413fc5e465d$var$instrumentTtfb, $ad44d413fc5e465d$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $ad44d413fc5e465d$export$2707d7471c0b918f(callback) {
    return $ad44d413fc5e465d$var$addMetricObserver('fid', callback, $ad44d413fc5e465d$var$instrumentFid, $ad44d413fc5e465d$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $ad44d413fc5e465d$export$da3b76aa2022cbd7(callback) {
    return $ad44d413fc5e465d$var$addMetricObserver('inp', callback, $ad44d413fc5e465d$var$instrumentInp, $ad44d413fc5e465d$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $ad44d413fc5e465d$export$69816c1a049f8db6(type, callback) {
    $ad44d413fc5e465d$var$addHandler(type, callback);
    if (!$ad44d413fc5e465d$var$instrumented[type]) {
        $ad44d413fc5e465d$var$instrumentPerformanceObserver(type);
        $ad44d413fc5e465d$var$instrumented[type] = true;
    }
    return $ad44d413fc5e465d$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $ad44d413fc5e465d$var$triggerHandlers(type, data) {
    const typeHandlers = $ad44d413fc5e465d$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $iLMLM.getFunctionName)(handler)}\nError:`, e);
    }
}
function $ad44d413fc5e465d$var$instrumentCls() {
    return (0, $3a6907c996d73e30$export$a7873055838e5ad8)((metric)=>{
        $ad44d413fc5e465d$var$triggerHandlers('cls', {
            metric: metric
        });
        $ad44d413fc5e465d$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $ad44d413fc5e465d$var$instrumentFid() {
    return (0, $c3fc9e4ed21c8525$export$39705a25c49af873)((metric)=>{
        $ad44d413fc5e465d$var$triggerHandlers('fid', {
            metric: metric
        });
        $ad44d413fc5e465d$var$_previousFid = metric;
    });
}
function $ad44d413fc5e465d$var$instrumentLcp() {
    return (0, $7cf137f1956aff4e$export$947b1626ab8d5632)((metric)=>{
        $ad44d413fc5e465d$var$triggerHandlers('lcp', {
            metric: metric
        });
        $ad44d413fc5e465d$var$_previousLcp = metric;
    });
}
function $ad44d413fc5e465d$var$instrumentTtfb() {
    return (0, $875edbcec7a24f4a$export$33a01e6c5f2c7e33)((metric)=>{
        $ad44d413fc5e465d$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $ad44d413fc5e465d$var$_previousTtfb = metric;
    });
}
function $ad44d413fc5e465d$var$instrumentInp() {
    return (0, $79eed2ea8e6972fb$export$7df4b36ecaed99e1)((metric)=>{
        $ad44d413fc5e465d$var$triggerHandlers('inp', {
            metric: metric
        });
        $ad44d413fc5e465d$var$_previousInp = metric;
    });
}
function $ad44d413fc5e465d$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $ad44d413fc5e465d$var$addHandler(type, callback);
    let stopListening;
    if (!$ad44d413fc5e465d$var$instrumented[type]) {
        stopListening = instrumentFn();
        $ad44d413fc5e465d$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $ad44d413fc5e465d$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $ad44d413fc5e465d$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $1b9b8c590ec3245b$export$d1203567a167490e)(type, (entries)=>{
        $ad44d413fc5e465d$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $ad44d413fc5e465d$var$addHandler(type, handler) {
    $ad44d413fc5e465d$var$handlers[type] = $ad44d413fc5e465d$var$handlers[type] || [];
    $ad44d413fc5e465d$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $ad44d413fc5e465d$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $ad44d413fc5e465d$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $3f4bb8339e5ea6a8$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $4b93eccddbf210f5$export$44d472fbb931a776)(dsn);
    const items = spans.map($3f4bb8339e5ea6a8$var$createSpanItem);
    return (0, $580b11aed5f18f19$export$f93f7f385160c44e)(headers, items);
}
function $3f4bb8339e5ea6a8$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


var $j527G = parcelRequire("j527G");
var $6VKBH = parcelRequire("6VKBH");
var $bFyHv = parcelRequire("bFyHv");
var $8swS4 = parcelRequire("8swS4");
var $j527G = parcelRequire("j527G");
/**
 * Adds a measurement to the current active transaction.
 */ function $6bcd5cacf200ae3c$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $j527G.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


var $rqtTb = parcelRequire("rqtTb");
var $9lgN8 = parcelRequire("9lgN8");

var $7X4Jf = parcelRequire("7X4Jf");
var $c9A3H = parcelRequire("c9A3H");
var $5Tp4j = parcelRequire("5Tp4j");




/**
 * Checks if a given value is a valid measurement value.
 */ function $e35b9b311af8d181$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $e35b9b311af8d181$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $982422649dc6c60f$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $982422649dc6c60f$var$msToSec(time) {
    return time / 1000;
}
function $982422649dc6c60f$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81) && (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).addEventListener && (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance;
}
let $982422649dc6c60f$var$_performanceCursor = 0;
let $982422649dc6c60f$var$_measurements = {};
let $982422649dc6c60f$var$_lcpEntry;
let $982422649dc6c60f$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $982422649dc6c60f$export$7c69f0412d101b88() {
    const performance = $982422649dc6c60f$var$getBrowserPerformanceAPI();
    if (performance && (0, $7X4Jf.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $982422649dc6c60f$var$_trackFID();
        const clsCallback = $982422649dc6c60f$var$_trackCLS();
        const lcpCallback = $982422649dc6c60f$var$_trackLCP();
        const ttfbCallback = $982422649dc6c60f$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $982422649dc6c60f$export$f396d19077034ad2() {
    (0, $ad44d413fc5e465d$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $j527G.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $982422649dc6c60f$var$msToSec((0, $7X4Jf.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $982422649dc6c60f$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $982422649dc6c60f$export$e27543e0976315e4() {
    (0, $ad44d413fc5e465d$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $j527G.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $982422649dc6c60f$var$msToSec((0, $7X4Jf.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $982422649dc6c60f$var$msToSec(entry.duration);
                const span = {
                    description: (0, $c9A3H.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $c9A3H.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $982422649dc6c60f$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $982422649dc6c60f$var$getBrowserPerformanceAPI();
    if (performance && (0, $7X4Jf.browserPerformanceTimeOrigin)) {
        const inpCallback = $982422649dc6c60f$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $982422649dc6c60f$var$_trackCLS() {
    return (0, $ad44d413fc5e465d$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding CLS');
        $982422649dc6c60f$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $982422649dc6c60f$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $982422649dc6c60f$var$_trackLCP() {
    return (0, $ad44d413fc5e465d$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding LCP');
        $982422649dc6c60f$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $982422649dc6c60f$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $982422649dc6c60f$var$_trackFID() {
    return (0, $ad44d413fc5e465d$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $982422649dc6c60f$var$msToSec((0, $7X4Jf.browserPerformanceTimeOrigin));
        const startTime = $982422649dc6c60f$var$msToSec(entry.startTime);
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding FID');
        $982422649dc6c60f$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $982422649dc6c60f$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $982422649dc6c60f$var$_trackTtfb() {
    return (0, $ad44d413fc5e465d$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding TTFB');
        $982422649dc6c60f$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $982422649dc6c60f$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $982422649dc6c60f$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $ad44d413fc5e465d$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $982422649dc6c60f$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $6VKBH.getClient)();
        if (!entry || !client) return;
        const interactionType = $982422649dc6c60f$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $982422649dc6c60f$var$msToSec((0, $7X4Jf.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $982422649dc6c60f$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $rqtTb.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $c9A3H.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $982422649dc6c60f$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $3f4bb8339e5ea6a8$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $982422649dc6c60f$export$5f8fa6b3467a7443(transaction) {
    const performance = $982422649dc6c60f$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).performance.getEntries || !(0, $7X4Jf.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $982422649dc6c60f$var$msToSec((0, $7X4Jf.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $9lgN8.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($982422649dc6c60f$var$_performanceCursor).forEach((entry)=>{
        const startTime = $982422649dc6c60f$var$msToSec(entry.startTime);
        const duration = $982422649dc6c60f$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $982422649dc6c60f$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $982422649dc6c60f$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $d6a0a7c8fa34d599$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding FP');
                        $982422649dc6c60f$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding FCP');
                        $982422649dc6c60f$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $982422649dc6c60f$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $982422649dc6c60f$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $982422649dc6c60f$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $982422649dc6c60f$var$_addTtfbRequestTimeToMeasurements($982422649dc6c60f$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$982422649dc6c60f$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $982422649dc6c60f$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $982422649dc6c60f$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $982422649dc6c60f$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $982422649dc6c60f$var$_measurements['mark.fid'];
        if (fidMark && $982422649dc6c60f$var$_measurements['fid']) {
            // create span for FID
            (0, $e35b9b311af8d181$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $982422649dc6c60f$var$msToSec($982422649dc6c60f$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $982422649dc6c60f$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $982422649dc6c60f$var$_measurements)) delete $982422649dc6c60f$var$_measurements.cls;
        Object.keys($982422649dc6c60f$var$_measurements).forEach((measurementName)=>{
            (0, $6bcd5cacf200ae3c$export$7cc31b475d33a706)(measurementName, $982422649dc6c60f$var$_measurements[measurementName].value, $982422649dc6c60f$var$_measurements[measurementName].unit);
        });
        $982422649dc6c60f$var$_tagMetricInfo(transaction);
    }
    $982422649dc6c60f$var$_lcpEntry = undefined;
    $982422649dc6c60f$var$_clsEntry = undefined;
    $982422649dc6c60f$var$_measurements = {};
}
/** Create measure related spans */ function $982422649dc6c60f$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $e35b9b311af8d181$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $982422649dc6c60f$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $982422649dc6c60f$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $982422649dc6c60f$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $982422649dc6c60f$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $982422649dc6c60f$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $982422649dc6c60f$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $982422649dc6c60f$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $e35b9b311af8d181$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $982422649dc6c60f$var$msToSec(start),
        endTimestamp: timeOrigin + $982422649dc6c60f$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $982422649dc6c60f$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $e35b9b311af8d181$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $982422649dc6c60f$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $982422649dc6c60f$var$msToSec(entry.responseEnd)
        });
        (0, $e35b9b311af8d181$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $982422649dc6c60f$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $982422649dc6c60f$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $982422649dc6c60f$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $46d559bf03833ae8$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $982422649dc6c60f$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $982422649dc6c60f$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $982422649dc6c60f$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $e35b9b311af8d181$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $982422649dc6c60f$var$_trackNavigator(transaction) {
    const navigator = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $e35b9b311af8d181$export$27169ccae1b439e3)(connection.rtt)) $982422649dc6c60f$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $e35b9b311af8d181$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $e35b9b311af8d181$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $982422649dc6c60f$var$_tagMetricInfo(transaction) {
    if ($982422649dc6c60f$var$_lcpEntry) {
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($982422649dc6c60f$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $c9A3H.htmlTreeAsString)($982422649dc6c60f$var$_lcpEntry.element));
        if ($982422649dc6c60f$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $982422649dc6c60f$var$_lcpEntry.id);
        if ($982422649dc6c60f$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $982422649dc6c60f$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $982422649dc6c60f$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($982422649dc6c60f$var$_clsEntry && $982422649dc6c60f$var$_clsEntry.sources) {
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding CLS Data');
        $982422649dc6c60f$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $c9A3H.htmlTreeAsString)(source.node)));
    }
}
function $982422649dc6c60f$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $982422649dc6c60f$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $982422649dc6c60f$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $b0c226ebf102022d$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $982422649dc6c60f$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $bFyHv.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $8swS4.isValidSampleRate)(sampleRate)) {
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}



var $6VKBH = parcelRequire("6VKBH");
var $3Uyl3 = parcelRequire("3Uyl3");
var $9FJRw = parcelRequire("9FJRw");
var $bFyHv = parcelRequire("bFyHv");
var $eas0Q = parcelRequire("eas0Q");
var $iI0FQ = parcelRequire("iI0FQ");
var $9lgN8 = parcelRequire("9lgN8");
var $aWXXn = parcelRequire("aWXXn");

var $hqP9w = parcelRequire("hqP9w");
var $7X4Jf = parcelRequire("7X4Jf");
var $UpCJO = parcelRequire("UpCJO");
var $7NyaU = parcelRequire("7NyaU");

var $6VKBH = parcelRequire("6VKBH");
var $3Uyl3 = parcelRequire("3Uyl3");
var $9FJRw = parcelRequire("9FJRw");
var $bFyHv = parcelRequire("bFyHv");
var $eas0Q = parcelRequire("eas0Q");
var $iI0FQ = parcelRequire("iI0FQ");
var $9lgN8 = parcelRequire("9lgN8");
var $aWXXn = parcelRequire("aWXXn");

var $hqP9w = parcelRequire("hqP9w");
var $UpCJO = parcelRequire("UpCJO");
var $aYpzJ = parcelRequire("aYpzJ");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $ee070199bb68ecbc$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $bFyHv.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $ee070199bb68ecbc$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $6VKBH.getCurrentScope)();
    const client = (0, $6VKBH.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $ee070199bb68ecbc$var$getFullURL(url);
    const host = fullUrl ? (0, $46d559bf03833ae8$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $aWXXn.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $ee070199bb68ecbc$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $ee070199bb68ecbc$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $9FJRw.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $9lgN8.spanToTraceHeader)(span) : (0, $UpCJO.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $hqP9w.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $3Uyl3.getDynamicSamplingContextFromSpan)(span) : (0, $3Uyl3.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $aYpzJ.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $aYpzJ.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $hqP9w.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $hqP9w.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $ee070199bb68ecbc$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $ee070199bb68ecbc$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $iI0FQ.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ const $a51e06bcefc07b23$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $a51e06bcefc07b23$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $a51e06bcefc07b23$export$15bd0305d05ad07b,
    tracePropagationTargets: $a51e06bcefc07b23$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $a51e06bcefc07b23$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $a51e06bcefc07b23$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $a51e06bcefc07b23$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$a51e06bcefc07b23$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $04e991c4561f18e1$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $ee070199bb68ecbc$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $a51e06bcefc07b23$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $46d559bf03833ae8$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $a51e06bcefc07b23$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $c03b20ad1c85097e$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $a51e06bcefc07b23$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $a51e06bcefc07b23$var$addHTTPTimings(createdSpan);
    });
}
function $a51e06bcefc07b23$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $a51e06bcefc07b23$var$addHTTPTimings(span) {
    const { url: url } = (0, $9lgN8.spanToJSON)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $ad44d413fc5e465d$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($a51e06bcefc07b23$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $a51e06bcefc07b23$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $a51e06bcefc07b23$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $a51e06bcefc07b23$var$getAbsoluteTime(time = 0) {
    return (((0, $7X4Jf.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $a51e06bcefc07b23$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $a51e06bcefc07b23$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $7X4Jf.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $a51e06bcefc07b23$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $a51e06bcefc07b23$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $7NyaU.stringMatchesSomePattern)(url, tracePropagationTargets || $a51e06bcefc07b23$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $a51e06bcefc07b23$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $c03b20ad1c85097e$export$55b6bb1e45c6cf59];
    if (!(0, $bFyHv.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $iI0FQ.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $6VKBH.getCurrentScope)();
    const isolationScope = (0, $9FJRw.getIsolationScope)();
    const fullUrl = $a51e06bcefc07b23$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $46d559bf03833ae8$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $aWXXn.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $6VKBH.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $9lgN8.spanToTraceHeader)(span) : (0, $UpCJO.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $hqP9w.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $3Uyl3.getDynamicSamplingContextFromSpan)(span) : (0, $3Uyl3.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $a51e06bcefc07b23$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $a51e06bcefc07b23$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $hqP9w.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $a51e06bcefc07b23$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



var $7X4Jf = parcelRequire("7X4Jf");
var $5Tp4j = parcelRequire("5Tp4j");


/**
 * Default function implementing pageload and navigation transactions
 */ function $2c6d70839faf26d2$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81) || !(0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location) {
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $7X4Jf.browserPerformanceTimeOrigin) ? (0, $7X4Jf.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $5b1a558274404ac4$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



const $b6ef7dc949d0f233$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $b6ef7dc949d0f233$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $dveIv.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $2c6d70839faf26d2$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $a51e06bcefc07b23$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $b6ef7dc949d0f233$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $b6ef7dc949d0f233$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $b6ef7dc949d0f233$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $aGB1Z.addTracingExtensions)();
        if (0, $d244f740f8e5a952$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$b6ef7dc949d0f233$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $982422649dc6c60f$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $982422649dc6c60f$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $982422649dc6c60f$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $982422649dc6c60f$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $d244f740f8e5a952$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $5Tp4j.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $6e9524f724eec940$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $a51e06bcefc07b23$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $b6ef7dc949d0f233$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $b6ef7dc949d0f233$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $UpCJO.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $aGB1Z.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document) {
                (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                    if ([
                        'interactive',
                        'complete'
                    ].includes((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $982422649dc6c60f$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $j527G.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $b6ef7dc949d0f233$var$getSource(this._latestRoute.context) : 'url'
                }
            };
            inflightInteractionTransaction = (0, $aGB1Z.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            if ((0, $6319ad5bbb0c97e7$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $6VKBH.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $j527G.getActiveTransaction)();
            const currentScope = (0, $6VKBH.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($b6ef7dc949d0f233$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === 'first-input') {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $b6ef7dc949d0f233$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $b6ef7dc949d0f233$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $ad44d413fc5e465d$export$69816c1a049f8db6)('event', handleEntries);
        (0, $ad44d413fc5e465d$export$69816c1a049f8db6)('first-input', handleEntries);
    }
}
/** Returns the value of a meta tag */ function $b6ef7dc949d0f233$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $c9A3H.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $b6ef7dc949d0f233$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $b6ef7dc949d0f233$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}

/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $283f7cc7c4858e9a$export$d0eaf3e94be578f6(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}



var $4m2mz = parcelRequire("4m2mz");

var $aYpzJ = parcelRequire("aYpzJ");

var $5Tp4j = parcelRequire("5Tp4j");

var $gAfIh = parcelRequire("gAfIh");

const $b3362eb632facfb2$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $b3362eb632facfb2$var$DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
const $b3362eb632facfb2$export$33c1c602a3538e5e = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function $b3362eb632facfb2$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === 'url') {
        // Attempt to grab a parameterized route off of the request
        const [name, source] = $b3362eb632facfb2$export$8c5ebee2e5bb9575(req, {
            path: true,
            method: true
        });
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute('baseUrl', req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData('query', $b3362eb632facfb2$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $b3362eb632facfb2$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = '';
    let source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, $46d559bf03833ae8$export$ce084c78234bd35)(req.originalUrl || req.url || '');
    let name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $b3362eb632facfb2$var$extractTransaction(req, type) {
    switch(type){
        case 'path':
            return $b3362eb632facfb2$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return $b3362eb632facfb2$export$8c5ebee2e5bb9575(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function $b3362eb632facfb2$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $b3362eb632facfb2$export$33c1c602a3538e5e;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $b3362eb632facfb2$export$b5c5d78255f11c84(req, options) {
    const { include: include = $b3362eb632facfb2$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    const host = headers.host || req.hostname || req.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || '';
    // absolute url
    const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case 'headers':
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes('cookies')) delete requestData.headers.cookie;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, $283f7cc7c4858e9a$export$d0eaf3e94be578f6)(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $b3362eb632facfb2$var$extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $aYpzJ.isString)(req.body) ? req.body : JSON.stringify((0, $gAfIh.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function $b3362eb632facfb2$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$b3362eb632facfb2$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $b3362eb632facfb2$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $b3362eb632facfb2$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $aYpzJ.isPlainObject)(req.user) ? $b3362eb632facfb2$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $b3362eb632facfb2$var$extractTransaction(req, include.transaction);
    return event;
}
function $b3362eb632facfb2$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || typeof URL !== 'undefined' && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function $b3362eb632facfb2$export$fee0927b05379c23(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, $4m2mz.DEBUG_BUILD) && (0, $5Tp4j.logger).warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $b3362eb632facfb2$export$49a11ed11911fd29(req) {
    const headers = $b3362eb632facfb2$export$fee0927b05379c23(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}


var $iyFKK = parcelRequire("iyFKK");
var $aYpzJ = parcelRequire("aYpzJ");
var $5Tp4j = parcelRequire("5Tp4j");

var $eas0Q = parcelRequire("eas0Q");
var $9lgN8 = parcelRequire("9lgN8");


/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $fca28e7cb34419cf$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Express';
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $fca28e7cb34419cf$export$6dafdd8fec05099d.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('ExpressIntegration is missing an Express instance');
            return;
        }
        if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('Express Integration is skipped because of instrumenter configuration.');
            return;
        }
        $fca28e7cb34419cf$var$instrumentMiddlewares(this._router, this._methods);
        $fca28e7cb34419cf$var$instrumentRouter(this._router);
    }
}
$fca28e7cb34419cf$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $fca28e7cb34419cf$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: 'auto.middleware.express'
                    });
                    res.once('finish', ()=>{
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_4)=>_4.end,
                        'call',
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.end,
                        'call',
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $fca28e7cb34419cf$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === 'function') return $fca28e7cb34419cf$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === 'function') return $fca28e7cb34419cf$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $fca28e7cb34419cf$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$fca28e7cb34419cf$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $fca28e7cb34419cf$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$fca28e7cb34419cf$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $fca28e7cb34419cf$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $fca28e7cb34419cf$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        let partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = $fca28e7cb34419cf$export$ea5dbbfd8423c1fa(req.originalUrl, req._reconstructedRoute, layer.path) || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split('/').filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes('*'))).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $46d559bf03833ae8$export$69dd85280a8d374c)((0, $46d559bf03833ae8$export$ce084c78234bd35)(req.originalUrl || '')) + numExtraSegments;
        const routeLength = (0, $46d559bf03833ae8$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $46d559bf03833ae8$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            const attributes = transaction && (0, $9lgN8.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || '/';
                const [name, source] = (0, $b3362eb632facfb2$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                });
                transaction.updateName(name);
                transaction.setAttribute((0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ const $fca28e7cb34419cf$export$bde9c19304d7dbd3 = (path, regexp, keys)=>{
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        keys,
        'access',
        (_10)=>_10[0],
        'optionalAccess',
        (_11)=>_11.offset
    ]) === undefined || (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        keys,
        'access',
        (_12)=>_12[0],
        'optionalAccess',
        (_13)=>_13.offset
    ]) === null) return undefined;
    const orderedKeys = keys.sort((a, b)=>a.offset - b.offset);
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    const pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ const execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ const [, ...paramIndices] = execResult.indices;
    if (paramIndices.length !== orderedKeys.length) return undefined;
    let resultPath = path;
    let indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach((item, index)=>{
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            const [startOffset, endOffset] = item;
            /**
       * isolate part before param
       */ const substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ const replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ const substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $fca28e7cb34419cf$var$getLayerRoutePathInfo(layer) {
    let lrp = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        layer,
        'access',
        (_14)=>_14.route,
        'optionalAccess',
        (_15)=>_15.path
    ]);
    const isRegex = (0, $aYpzJ.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        const [major] = (0, $iyFKK.GLOBAL_OBJ).process.versions.node.split('.').map(Number);
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = $fca28e7cb34419cf$export$bde9c19304d7dbd3(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($fca28e7cb34419cf$var$getNumberOfArrayUrlSegments(lrp) - (0, $46d559bf03833ae8$export$69dd85280a8d374c)(layer.path || ''), 0) : 0;
    const layerRoutePath = $fca28e7cb34419cf$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $fca28e7cb34419cf$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $46d559bf03833ae8$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $fca28e7cb34419cf$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(',');
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function $fca28e7cb34419cf$export$ea5dbbfd8423c1fa(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    const normalizeURL = (0, $46d559bf03833ae8$export$ce084c78234bd35)(originalUrl || '');
    const originalUrlSplit = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        normalizeURL,
        'optionalAccess',
        (_16)=>_16.split,
        'call',
        (_17)=>_17('/'),
        'access',
        (_18)=>_18.filter,
        'call',
        (_19)=>_19((v)=>!!v)
    ]);
    let tempCounter = 0;
    const currentOffset = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        reconstructedRoute,
        'optionalAccess',
        (_20)=>_20.split,
        'call',
        (_21)=>_21('/'),
        'access',
        (_22)=>_22.filter,
        'call',
        (_23)=>_23((v)=>!!v),
        'access',
        (_24)=>_24.length
    ]) || 0;
    const result = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
        layerPath,
        'optionalAccess',
        (_25)=>_25.split,
        'call',
        (_26)=>_26('/'),
        'access',
        (_27)=>_27.filter,
        'call',
        (_28)=>_28((segment)=>{
                if ((0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    originalUrlSplit,
                    'optionalAccess',
                    (_29)=>_29[currentOffset + tempCounter]
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            }),
        'access',
        (_30)=>_30.join,
        'call',
        (_31)=>_31('/')
    ]);
    return result;
}


var $j527G = parcelRequire("j527G");
var $9oYhG = parcelRequire("9oYhG");
var $aYpzJ = parcelRequire("aYpzJ");
var $gB5MK = parcelRequire("gB5MK");
var $5Tp4j = parcelRequire("5Tp4j");


/** Tracing integration for graphql package */ class $997b5709a9b4a4a7$export$b735d011553f1049 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GraphQL';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $997b5709a9b4a4a7$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $gB5MK.loadModule)('graphql/execution/execute.js');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('GraphQL Integration was unable to require graphql/execution package.');
            return;
        }
        (0, $9oYhG.fill)(pkg, 'execute', function(orig) {
            return function(...args) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: 'execute',
                            op: 'graphql.execute',
                            origin: 'auto.graphql.graphql'
                        })
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    scope,
                    'optionalAccess',
                    (_4)=>_4.setSpan,
                    'call',
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $aYpzJ.isThenable)(rv)) return rv.then((res)=>{
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.end,
                        'call',
                        (_7)=>_7()
                    ]);
                    // eslint-disable-next-line deprecation/deprecation
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        scope,
                        'optionalAccess',
                        (_8)=>_8.setSpan,
                        'call',
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_10)=>_10.end,
                    'call',
                    (_11)=>_11()
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    scope,
                    'optionalAccess',
                    (_12)=>_12.setSpan,
                    'call',
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$997b5709a9b4a4a7$export$b735d011553f1049.__initStatic();


var $bFyHv = parcelRequire("bFyHv");
var $dveIv = parcelRequire("dveIv");
var $9oYhG = parcelRequire("9oYhG");
var $aYpzJ = parcelRequire("aYpzJ");
var $gB5MK = parcelRequire("gB5MK");
var $5Tp4j = parcelRequire("5Tp4j");


// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $4a141dbb49c6f209$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $4a141dbb49c6f209$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function $4a141dbb49c6f209$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ class $4a141dbb49c6f209$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mongo';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $4a141dbb49c6f209$export$968aa4360b02a334.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $4a141dbb49c6f209$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        return this._module = this._module || (0, $gB5MK.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
    _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
    _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $9oYhG.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                // eslint-disable-next-line deprecation/deprecation
                const hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                const scope = hub.getScope();
                // eslint-disable-next-line deprecation/deprecation
                const client = hub.getClient();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const sendDefaultPii = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    client,
                    'optionalAccess',
                    (_2)=>_2.getOptions,
                    'call',
                    (_3)=>_3(),
                    'access',
                    (_4)=>_4.sendDefaultPii
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        parentSpan,
                        'optionalAccess',
                        (_5)=>_5.startChild,
                        'call',
                        (_6)=>_6(getSpanContext(this, operation, args, sendDefaultPii))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $aYpzJ.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            (_7)=>_7.end,
                            'call',
                            (_8)=>_8()
                        ]);
                        return res;
                    });
                    else if ($4a141dbb49c6f209$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once('close', ()=>{
                                (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                                    span,
                                    'optionalAccess',
                                    (_9)=>_9.end,
                                    'call',
                                    (_10)=>_10()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                (_11)=>_11.end,
                                'call',
                                (_12)=>_12()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            (_13)=>_13.end,
                            'call',
                            (_14)=>_14()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_15)=>_15.startChild,
                    'call',
                    (_16)=>_16(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_17)=>_17.end,
                        'call',
                        (_18)=>_18()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args, sendDefaultPii = false) {
        const data = {
            'db.system': 'mongodb',
            'db.name': collection.dbName,
            'db.operation': operation,
            'db.mongodb.collection': collection.collectionName
        };
        const spanContext = {
            op: 'db',
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: 'auto.db.mongo',
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $4a141dbb49c6f209$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === 'mapReduce') {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$4a141dbb49c6f209$export$968aa4360b02a334.__initStatic();


var $9oYhG = parcelRequire("9oYhG");
var $gB5MK = parcelRequire("gB5MK");
var $5Tp4j = parcelRequire("5Tp4j");


/** Tracing integration for node-mysql package */ class $54e6e393f3bd2b4b$export$a2cc26ff91a3f8ad {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mysql';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $54e6e393f3bd2b4b$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $gB5MK.loadModule)('mysql/lib/Connection.js');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Mysql Integration was unable to require `mysql` package.');
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Mysql Integration was unable to instrument `mysql` config.');
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                'server.address': mySqlConfig.host,
                'server.port': mySqlConfig.port,
                'db.user': mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setAttribute(key, data[key]);
            });
            span.end();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $9oYhG.fill)(pkg, 'createQuery', function(orig) {
            return function(options, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: typeof options === 'string' ? options : options.sql,
                            op: 'db',
                            origin: 'auto.db.mysql',
                            data: {
                                'db.system': 'mysql'
                            }
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                // streaming, no callback!
                const query = orig.call(this, options, values);
                query.on('end', ()=>{
                    finishSpan(span);
                });
                return query;
            };
        });
    }
}
$54e6e393f3bd2b4b$export$a2cc26ff91a3f8ad.__initStatic();


var $9oYhG = parcelRequire("9oYhG");
var $aYpzJ = parcelRequire("aYpzJ");
var $gB5MK = parcelRequire("gB5MK");
var $5Tp4j = parcelRequire("5Tp4j");


/** Tracing integration for node-postgres package */ class $116cf6913f03f491$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Postgres';
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $116cf6913f03f491$export$806ddb599177abc4.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $gB5MK.loadModule)('pg');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error('Postgres Integration was unable to require `pg` package.');
            return;
        }
        const Client = this._usePgNative ? (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
            pkg,
            'access',
            (_2)=>_2.native,
            'optionalAccess',
            (_3)=>_3.Client
        ]) : pkg.Client;
        if (!Client) {
            (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $9oYhG.fill)(Client.prototype, 'query', function(orig) {
            return function(config, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const data = {
                    'db.system': 'postgresql'
                };
                try {
                    if (this.database) data['db.name'] = this.database;
                    if (this.host) data['server.address'] = this.host;
                    if (this.port) data['server.port'] = this.port;
                    if (this.user) data['db.user'] = this.user;
                } catch (e) {
                // ignore
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: typeof config === 'string' ? config : config.text,
                            op: 'db',
                            origin: 'auto.db.postgres',
                            data: data
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.end,
                        'call',
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.end,
                        'call',
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $aYpzJ.isThenable)(rv)) return rv.then((res)=>{
                    (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_10)=>_10.end,
                        'call',
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, $984caf93a01ec55f$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_12)=>_12.end,
                    'call',
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
$116cf6913f03f491$export$806ddb599177abc4.__initStatic();


var $9FJRw = parcelRequire("9FJRw");
var $eas0Q = parcelRequire("eas0Q");
var $aWXXn = parcelRequire("aWXXn");

var $9oYhG = parcelRequire("9oYhG");
var $5Tp4j = parcelRequire("5Tp4j");


function $567886f22c87480a$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ class $567886f22c87480a$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Prisma';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $567886f22c87480a$export$e300e6f4779d55c2.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($567886f22c87480a$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9oYhG.addNonEnumerableProperty)(options.client, '_sentryInstrumented', true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider: activeProvider, clientVersion: clientVersion } = engineConfig;
                    if (activeProvider) clientData['db.system'] = activeProvider;
                    if (clientVersion) clientData['db.prisma.version'] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                // eslint-disable-next-line deprecation/deprecation
                if ((0, $c9782aebda9e1077$export$34db76d03eb96b7e)((0, $9FJRw.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, $aWXXn.startSpan)({
                    name: model ? `${model} ${action}` : action,
                    onlyIfParent: true,
                    op: 'db.prisma',
                    attributes: {
                        [(0, $eas0Q.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.db.prisma'
                    },
                    data: {
                        ...clientData,
                        'db.operation': action
                    }
                }, ()=>next(params));
            });
        } else (0, $d244f740f8e5a952$export$16a28057038b10ef) && (0, $5Tp4j.logger).warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:', options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
$567886f22c87480a$export$e300e6f4779d55c2.__initStatic();


var $rqtTb = parcelRequire("rqtTb");
var $iI0FQ = parcelRequire("iI0FQ");
var $aGB1Z = parcelRequire("aGB1Z");
var $UpCJO = parcelRequire("UpCJO");
var $iglHX = parcelRequire("iglHX");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
const $19b6934764737915$export$46d3bbd0375f5fa4 = (0, $b6ef7dc949d0f233$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $19b6934764737915$export$5a20b45239a3c0a6 = (0, $bFpVl.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $19b6934764737915$export$a7feb32fdd923295 = (0, $j527G.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $19b6934764737915$export$8e9a29865c0a1226 = (0, $j527G.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $19b6934764737915$export$ac65c70d78fcdb55 = (0, $iI0FQ.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $19b6934764737915$export$febc5573c75cefb0 = (0, $iglHX.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $19b6934764737915$export$5f1714a13ed34c01 = (0, $rqtTb.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $19b6934764737915$export$bbd2089f30bd3708 = (0, $b6ef7dc949d0f233$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $19b6934764737915$export$cc17fb3c0bc95cd7 = (0, $a51e06bcefc07b23$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $19b6934764737915$export$5008da00b1b6dee6 = (0, $bFyHv.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $19b6934764737915$export$ce084c78234bd35 = (0, $46d559bf03833ae8$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $19b6934764737915$export$394a210812ba3012 = (0, $UpCJO.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $19b6934764737915$export$b279e6bd7040371f = (0, $dveIv.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $19b6934764737915$export$864489cb3478db3e = (0, $a51e06bcefc07b23$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $19b6934764737915$export$479dbd817e392a4f = (0, $aGB1Z.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $19b6934764737915$export$beb8e6a823e89c5d = (0, $iI0FQ.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $19b6934764737915$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $19b6934764737915$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $12155c12ea8508e8$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $fca28e7cb34419cf$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $997b5709a9b4a4a7$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $4a141dbb49c6f209$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $54e6e393f3bd2b4b$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $116cf6913f03f491$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $567886f22c87480a$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $bFpVl.addExtensionMethods)();



var $gIfym = parcelRequire("gIfym");
var $c4a08725a78d51bf$exports = {};
'use strict';
function $c4a08725a78d51bf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4a08725a78d51bf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4a08725a78d51bf$var$checkDCE();

$c4a08725a78d51bf$exports = (parcelRequire("eN6q3"));


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gIfym = parcelRequire("gIfym");

/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $00f8c8d19c70d669$var$_extends() {
    return $00f8c8d19c70d669$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00f8c8d19c70d669$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $00f8c8d19c70d669$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($00f8c8d19c70d669$export$e19cd5f9376f8cee || ($00f8c8d19c70d669$export$e19cd5f9376f8cee = {}));
const $00f8c8d19c70d669$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $00f8c8d19c70d669$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $00f8c8d19c70d669$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $00f8c8d19c70d669$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $00f8c8d19c70d669$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $00f8c8d19c70d669$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $00f8c8d19c70d669$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $00f8c8d19c70d669$export$fe53371bee54353d(to);
    }
    return $00f8c8d19c70d669$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $00f8c8d19c70d669$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $00f8c8d19c70d669$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $00f8c8d19c70d669$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $00f8c8d19c70d669$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $00f8c8d19c70d669$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $00f8c8d19c70d669$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $00f8c8d19c70d669$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $00f8c8d19c70d669$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $00f8c8d19c70d669$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $00f8c8d19c70d669$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $00f8c8d19c70d669$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $00f8c8d19c70d669$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $00f8c8d19c70d669$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $00f8c8d19c70d669$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $00f8c8d19c70d669$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $00f8c8d19c70d669$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($00f8c8d19c70d669$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Push;
        let location = $00f8c8d19c70d669$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $00f8c8d19c70d669$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Replace;
        let location = $00f8c8d19c70d669$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $00f8c8d19c70d669$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $00f8c8d19c70d669$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $00f8c8d19c70d669$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($00f8c8d19c70d669$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($00f8c8d19c70d669$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $00f8c8d19c70d669$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($00f8c8d19c70d669$var$ResultType || ($00f8c8d19c70d669$var$ResultType = {}));
const $00f8c8d19c70d669$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $00f8c8d19c70d669$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $00f8c8d19c70d669$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $00f8c8d19c70d669$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $00f8c8d19c70d669$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($00f8c8d19c70d669$var$isIndexRoute(route)) {
            let indexRoute = $00f8c8d19c70d669$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $00f8c8d19c70d669$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $00f8c8d19c70d669$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $00f8c8d19c70d669$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $00f8c8d19c70d669$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $00f8c8d19c70d669$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $00f8c8d19c70d669$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $00f8c8d19c70d669$var$flattenRoutes(routes);
    $00f8c8d19c70d669$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $00f8c8d19c70d669$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $00f8c8d19c70d669$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $00f8c8d19c70d669$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $00f8c8d19c70d669$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $00f8c8d19c70d669$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $00f8c8d19c70d669$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $00f8c8d19c70d669$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $00f8c8d19c70d669$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $00f8c8d19c70d669$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $00f8c8d19c70d669$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $00f8c8d19c70d669$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $00f8c8d19c70d669$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $00f8c8d19c70d669$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $00f8c8d19c70d669$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $00f8c8d19c70d669$var$paramRe = /^:[\w-]+$/;
const $00f8c8d19c70d669$var$dynamicSegmentValue = 3;
const $00f8c8d19c70d669$var$indexRouteValue = 2;
const $00f8c8d19c70d669$var$emptySegmentValue = 1;
const $00f8c8d19c70d669$var$staticSegmentValue = 10;
const $00f8c8d19c70d669$var$splatPenalty = -2;
const $00f8c8d19c70d669$var$isSplat = (s)=>s === "*";
function $00f8c8d19c70d669$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($00f8c8d19c70d669$var$isSplat)) initialScore += $00f8c8d19c70d669$var$splatPenalty;
    if (index) initialScore += $00f8c8d19c70d669$var$indexRouteValue;
    return segments.filter((s)=>!$00f8c8d19c70d669$var$isSplat(s)).reduce((score, segment)=>score + ($00f8c8d19c70d669$var$paramRe.test(segment) ? $00f8c8d19c70d669$var$dynamicSegmentValue : segment === "" ? $00f8c8d19c70d669$var$emptySegmentValue : $00f8c8d19c70d669$var$staticSegmentValue), initialScore);
}
function $00f8c8d19c70d669$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $00f8c8d19c70d669$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $00f8c8d19c70d669$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $00f8c8d19c70d669$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $00f8c8d19c70d669$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $00f8c8d19c70d669$export$a5c6d149b50c1d86($00f8c8d19c70d669$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $00f8c8d19c70d669$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $00f8c8d19c70d669$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $00f8c8d19c70d669$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $00f8c8d19c70d669$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $00f8c8d19c70d669$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $00f8c8d19c70d669$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $00f8c8d19c70d669$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $00f8c8d19c70d669$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $00f8c8d19c70d669$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $00f8c8d19c70d669$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $00f8c8d19c70d669$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $00f8c8d19c70d669$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $00f8c8d19c70d669$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $00f8c8d19c70d669$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $00f8c8d19c70d669$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $00f8c8d19c70d669$var$normalizeSearch(search),
        hash: $00f8c8d19c70d669$var$normalizeHash(hash)
    };
}
function $00f8c8d19c70d669$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $00f8c8d19c70d669$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $00f8c8d19c70d669$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $00f8c8d19c70d669$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $00f8c8d19c70d669$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $00f8c8d19c70d669$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $00f8c8d19c70d669$export$8ccf933b0513f8d0(toArg);
    else {
        to = $00f8c8d19c70d669$var$_extends({}, toArg);
        $00f8c8d19c70d669$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $00f8c8d19c70d669$var$getInvalidPathError("?", "pathname", "search", to));
        $00f8c8d19c70d669$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $00f8c8d19c70d669$var$getInvalidPathError("#", "pathname", "hash", to));
        $00f8c8d19c70d669$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $00f8c8d19c70d669$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $00f8c8d19c70d669$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $00f8c8d19c70d669$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $00f8c8d19c70d669$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $00f8c8d19c70d669$export$86d9a7913e44197e = (paths)=>$00f8c8d19c70d669$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $00f8c8d19c70d669$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $00f8c8d19c70d669$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $00f8c8d19c70d669$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $00f8c8d19c70d669$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $00f8c8d19c70d669$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $00f8c8d19c70d669$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $00f8c8d19c70d669$export$4051a07651545597(data, init) {
    return new $00f8c8d19c70d669$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $00f8c8d19c70d669$export$42a99a7a4bc0e76a extends Error {
}
class $00f8c8d19c70d669$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $00f8c8d19c70d669$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $00f8c8d19c70d669$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $00f8c8d19c70d669$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $00f8c8d19c70d669$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $00f8c8d19c70d669$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $00f8c8d19c70d669$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $00f8c8d19c70d669$var$unwrapTrackedPromise(value) {
    if (!$00f8c8d19c70d669$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $00f8c8d19c70d669$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $00f8c8d19c70d669$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $00f8c8d19c70d669$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $00f8c8d19c70d669$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $00f8c8d19c70d669$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $00f8c8d19c70d669$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $00f8c8d19c70d669$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $00f8c8d19c70d669$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $00f8c8d19c70d669$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $00f8c8d19c70d669$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $00f8c8d19c70d669$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $00f8c8d19c70d669$var$validMutationMethods = new Set($00f8c8d19c70d669$var$validMutationMethodsArr);
const $00f8c8d19c70d669$var$validRequestMethodsArr = [
    "get",
    ...$00f8c8d19c70d669$var$validMutationMethodsArr
];
const $00f8c8d19c70d669$var$validRequestMethods = new Set($00f8c8d19c70d669$var$validRequestMethodsArr);
const $00f8c8d19c70d669$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $00f8c8d19c70d669$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $00f8c8d19c70d669$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $00f8c8d19c70d669$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $00f8c8d19c70d669$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $00f8c8d19c70d669$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $00f8c8d19c70d669$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $00f8c8d19c70d669$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $00f8c8d19c70d669$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $00f8c8d19c70d669$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $00f8c8d19c70d669$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $00f8c8d19c70d669$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $00f8c8d19c70d669$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $00f8c8d19c70d669$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $00f8c8d19c70d669$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $00f8c8d19c70d669$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $00f8c8d19c70d669$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$00f8c8d19c70d669$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$00f8c8d19c70d669$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $00f8c8d19c70d669$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $00f8c8d19c70d669$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $00f8c8d19c70d669$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $00f8c8d19c70d669$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$00f8c8d19c70d669$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $00f8c8d19c70d669$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $00f8c8d19c70d669$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $00f8c8d19c70d669$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $00f8c8d19c70d669$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $00f8c8d19c70d669$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $00f8c8d19c70d669$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $00f8c8d19c70d669$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($00f8c8d19c70d669$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $00f8c8d19c70d669$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $00f8c8d19c70d669$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $00f8c8d19c70d669$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $00f8c8d19c70d669$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $00f8c8d19c70d669$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $00f8c8d19c70d669$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $00f8c8d19c70d669$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $00f8c8d19c70d669$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $00f8c8d19c70d669$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $00f8c8d19c70d669$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $00f8c8d19c70d669$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $00f8c8d19c70d669$var$findNearestBoundary(matches).route.id,
            {
                type: $00f8c8d19c70d669$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $00f8c8d19c70d669$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($00f8c8d19c70d669$var$isErrorResult(result) && $00f8c8d19c70d669$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $00f8c8d19c70d669$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $00f8c8d19c70d669$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $00f8c8d19c70d669$var$_extends({
            matches: updatedMatches || matches
        }, $00f8c8d19c70d669$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $00f8c8d19c70d669$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $00f8c8d19c70d669$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $00f8c8d19c70d669$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $00f8c8d19c70d669$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $00f8c8d19c70d669$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $00f8c8d19c70d669$var$ResultType.error,
            error: $00f8c8d19c70d669$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($00f8c8d19c70d669$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $00f8c8d19c70d669$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($00f8c8d19c70d669$var$isDeferredResult(result)) throw $00f8c8d19c70d669$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($00f8c8d19c70d669$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $00f8c8d19c70d669$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $00f8c8d19c70d669$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $00f8c8d19c70d669$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $00f8c8d19c70d669$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($00f8c8d19c70d669$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $00f8c8d19c70d669$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $00f8c8d19c70d669$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $00f8c8d19c70d669$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $00f8c8d19c70d669$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $00f8c8d19c70d669$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $00f8c8d19c70d669$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $00f8c8d19c70d669$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $00f8c8d19c70d669$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $00f8c8d19c70d669$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $00f8c8d19c70d669$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $00f8c8d19c70d669$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $00f8c8d19c70d669$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $00f8c8d19c70d669$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $00f8c8d19c70d669$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $00f8c8d19c70d669$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $00f8c8d19c70d669$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $00f8c8d19c70d669$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $00f8c8d19c70d669$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $00f8c8d19c70d669$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $00f8c8d19c70d669$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $00f8c8d19c70d669$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($00f8c8d19c70d669$var$isRedirectResult(actionResult) || $00f8c8d19c70d669$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $00f8c8d19c70d669$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($00f8c8d19c70d669$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $00f8c8d19c70d669$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $00f8c8d19c70d669$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($00f8c8d19c70d669$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($00f8c8d19c70d669$var$isDeferredResult(actionResult)) throw $00f8c8d19c70d669$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $00f8c8d19c70d669$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $00f8c8d19c70d669$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $00f8c8d19c70d669$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $00f8c8d19c70d669$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $00f8c8d19c70d669$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $00f8c8d19c70d669$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $00f8c8d19c70d669$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $00f8c8d19c70d669$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $00f8c8d19c70d669$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $00f8c8d19c70d669$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $00f8c8d19c70d669$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $00f8c8d19c70d669$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $00f8c8d19c70d669$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $00f8c8d19c70d669$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $00f8c8d19c70d669$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $00f8c8d19c70d669$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($00f8c8d19c70d669$var$isDeferredResult(result)) result = await $00f8c8d19c70d669$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $00f8c8d19c70d669$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($00f8c8d19c70d669$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $00f8c8d19c70d669$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($00f8c8d19c70d669$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $00f8c8d19c70d669$export$3e9cee6b33872309(!$00f8c8d19c70d669$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $00f8c8d19c70d669$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $00f8c8d19c70d669$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $00f8c8d19c70d669$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $00f8c8d19c70d669$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($00f8c8d19c70d669$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $00f8c8d19c70d669$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $00f8c8d19c70d669$export$e19cd5f9376f8cee.Replace : $00f8c8d19c70d669$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $00f8c8d19c70d669$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($00f8c8d19c70d669$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $00f8c8d19c70d669$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $00f8c8d19c70d669$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $00f8c8d19c70d669$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $00f8c8d19c70d669$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $00f8c8d19c70d669$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($00f8c8d19c70d669$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $00f8c8d19c70d669$var$ResultType.redirect,
                response: $00f8c8d19c70d669$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $00f8c8d19c70d669$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $00f8c8d19c70d669$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $00f8c8d19c70d669$var$ResultType.error,
                    error: $00f8c8d19c70d669$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $00f8c8d19c70d669$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $00f8c8d19c70d669$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $00f8c8d19c70d669$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $00f8c8d19c70d669$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $00f8c8d19c70d669$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $00f8c8d19c70d669$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $00f8c8d19c70d669$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $00f8c8d19c70d669$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $00f8c8d19c70d669$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $00f8c8d19c70d669$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $00f8c8d19c70d669$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $00f8c8d19c70d669$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $00f8c8d19c70d669$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $00f8c8d19c70d669$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$00f8c8d19c70d669$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $00f8c8d19c70d669$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $00f8c8d19c70d669$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $00f8c8d19c70d669$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $00f8c8d19c70d669$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $00f8c8d19c70d669$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $00f8c8d19c70d669$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $00f8c8d19c70d669$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $00f8c8d19c70d669$export$4d0306f8f6a4585b = Symbol("deferred");
function $00f8c8d19c70d669$export$3336b097a6fbc59a(routes, opts) {
    $00f8c8d19c70d669$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $00f8c8d19c70d669$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $00f8c8d19c70d669$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $00f8c8d19c70d669$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $00f8c8d19c70d669$var$createLocation("", $00f8c8d19c70d669$export$fe53371bee54353d(url), null, "default");
        let matches = $00f8c8d19c70d669$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$00f8c8d19c70d669$var$isValidMethod(method) && method !== "HEAD") {
            let error = $00f8c8d19c70d669$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $00f8c8d19c70d669$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $00f8c8d19c70d669$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $00f8c8d19c70d669$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($00f8c8d19c70d669$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $00f8c8d19c70d669$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $00f8c8d19c70d669$var$createLocation("", $00f8c8d19c70d669$export$fe53371bee54353d(url), null, "default");
        let matches = $00f8c8d19c70d669$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$00f8c8d19c70d669$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $00f8c8d19c70d669$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $00f8c8d19c70d669$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $00f8c8d19c70d669$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $00f8c8d19c70d669$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $00f8c8d19c70d669$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($00f8c8d19c70d669$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$00f8c8d19c70d669$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $00f8c8d19c70d669$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($00f8c8d19c70d669$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $00f8c8d19c70d669$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $00f8c8d19c70d669$var$isResponse(result) ? result : $00f8c8d19c70d669$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($00f8c8d19c70d669$var$isDataStrategyResult(e) && $00f8c8d19c70d669$var$isResponse(e.result)) {
                if (e.type === $00f8c8d19c70d669$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($00f8c8d19c70d669$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $00f8c8d19c70d669$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $00f8c8d19c70d669$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $00f8c8d19c70d669$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($00f8c8d19c70d669$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($00f8c8d19c70d669$var$isDeferredResult(result)) {
            let error = $00f8c8d19c70d669$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $00f8c8d19c70d669$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($00f8c8d19c70d669$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($00f8c8d19c70d669$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $00f8c8d19c70d669$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $00f8c8d19c70d669$var$_extends({}, context, {
                statusCode: $00f8c8d19c70d669$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $00f8c8d19c70d669$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $00f8c8d19c70d669$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $00f8c8d19c70d669$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1]) ? $00f8c8d19c70d669$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $00f8c8d19c70d669$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $00f8c8d19c70d669$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $00f8c8d19c70d669$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $00f8c8d19c70d669$var$callDataStrategyImpl(dataStrategy || $00f8c8d19c70d669$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($00f8c8d19c70d669$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $00f8c8d19c70d669$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($00f8c8d19c70d669$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $00f8c8d19c70d669$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $00f8c8d19c70d669$export$fec11da027c70692(routes, context, error) {
    let newContext = $00f8c8d19c70d669$var$_extends({}, context, {
        statusCode: $00f8c8d19c70d669$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $00f8c8d19c70d669$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $00f8c8d19c70d669$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $00f8c8d19c70d669$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $00f8c8d19c70d669$export$cae722b0cc860f13(to ? to : ".", $00f8c8d19c70d669$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $00f8c8d19c70d669$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $00f8c8d19c70d669$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $00f8c8d19c70d669$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $00f8c8d19c70d669$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $00f8c8d19c70d669$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$00f8c8d19c70d669$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$00f8c8d19c70d669$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $00f8c8d19c70d669$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $00f8c8d19c70d669$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $00f8c8d19c70d669$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$00f8c8d19c70d669$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$00f8c8d19c70d669$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $00f8c8d19c70d669$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $00f8c8d19c70d669$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $00f8c8d19c70d669$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $00f8c8d19c70d669$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $00f8c8d19c70d669$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($00f8c8d19c70d669$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $00f8c8d19c70d669$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $00f8c8d19c70d669$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $00f8c8d19c70d669$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $00f8c8d19c70d669$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $00f8c8d19c70d669$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $00f8c8d19c70d669$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $00f8c8d19c70d669$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $00f8c8d19c70d669$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($00f8c8d19c70d669$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $00f8c8d19c70d669$var$shouldRevalidateLoader(match, $00f8c8d19c70d669$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $00f8c8d19c70d669$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $00f8c8d19c70d669$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $00f8c8d19c70d669$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $00f8c8d19c70d669$var$shouldRevalidateLoader(fetcherMatch, $00f8c8d19c70d669$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $00f8c8d19c70d669$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $00f8c8d19c70d669$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $00f8c8d19c70d669$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $00f8c8d19c70d669$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $00f8c8d19c70d669$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $00f8c8d19c70d669$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$00f8c8d19c70d669$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $00f8c8d19c70d669$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $00f8c8d19c70d669$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$00f8c8d19c70d669$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $00f8c8d19c70d669$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $00f8c8d19c70d669$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $00f8c8d19c70d669$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$00f8c8d19c70d669$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $00f8c8d19c70d669$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $00f8c8d19c70d669$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $00f8c8d19c70d669$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $00f8c8d19c70d669$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $00f8c8d19c70d669$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $00f8c8d19c70d669$var$ResultType.data,
                result: undefined
            });
        };
        return $00f8c8d19c70d669$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $00f8c8d19c70d669$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $00f8c8d19c70d669$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $00f8c8d19c70d669$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $00f8c8d19c70d669$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $00f8c8d19c70d669$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $00f8c8d19c70d669$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $00f8c8d19c70d669$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($00f8c8d19c70d669$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $00f8c8d19c70d669$var$ResultType.error,
                error: e
            };
        }
        if (type === $00f8c8d19c70d669$var$ResultType.error) return {
            type: $00f8c8d19c70d669$var$ResultType.error,
            error: new $00f8c8d19c70d669$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $00f8c8d19c70d669$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $00f8c8d19c70d669$var$ResultType.error) {
        if ($00f8c8d19c70d669$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $00f8c8d19c70d669$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $00f8c8d19c70d669$var$ResultType.error,
                error: new $00f8c8d19c70d669$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $00f8c8d19c70d669$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $00f8c8d19c70d669$var$ResultType.error,
            error: result,
            statusCode: $00f8c8d19c70d669$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($00f8c8d19c70d669$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $00f8c8d19c70d669$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($00f8c8d19c70d669$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $00f8c8d19c70d669$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $00f8c8d19c70d669$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $00f8c8d19c70d669$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $00f8c8d19c70d669$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$00f8c8d19c70d669$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $00f8c8d19c70d669$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $00f8c8d19c70d669$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($00f8c8d19c70d669$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $00f8c8d19c70d669$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $00f8c8d19c70d669$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $00f8c8d19c70d669$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($00f8c8d19c70d669$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $00f8c8d19c70d669$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $00f8c8d19c70d669$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $00f8c8d19c70d669$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $00f8c8d19c70d669$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $00f8c8d19c70d669$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $00f8c8d19c70d669$export$3e9cee6b33872309(!$00f8c8d19c70d669$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($00f8c8d19c70d669$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $00f8c8d19c70d669$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $00f8c8d19c70d669$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($00f8c8d19c70d669$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $00f8c8d19c70d669$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $00f8c8d19c70d669$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $00f8c8d19c70d669$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($00f8c8d19c70d669$var$isErrorResult(result)) {
            let boundaryMatch = $00f8c8d19c70d669$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $00f8c8d19c70d669$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($00f8c8d19c70d669$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $00f8c8d19c70d669$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($00f8c8d19c70d669$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $00f8c8d19c70d669$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $00f8c8d19c70d669$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $00f8c8d19c70d669$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $00f8c8d19c70d669$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $00f8c8d19c70d669$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $00f8c8d19c70d669$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $00f8c8d19c70d669$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $00f8c8d19c70d669$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $00f8c8d19c70d669$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $00f8c8d19c70d669$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $00f8c8d19c70d669$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($00f8c8d19c70d669$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $00f8c8d19c70d669$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(path) : path;
    return $00f8c8d19c70d669$export$fe53371bee54353d($00f8c8d19c70d669$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $00f8c8d19c70d669$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $00f8c8d19c70d669$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $00f8c8d19c70d669$var$ResultType.data || result.type === $00f8c8d19c70d669$var$ResultType.error);
}
function $00f8c8d19c70d669$var$isRedirectDataStrategyResultResult(result) {
    return $00f8c8d19c70d669$var$isResponse(result.result) && $00f8c8d19c70d669$var$redirectStatusCodes.has(result.result.status);
}
function $00f8c8d19c70d669$var$isDeferredResult(result) {
    return result.type === $00f8c8d19c70d669$var$ResultType.deferred;
}
function $00f8c8d19c70d669$var$isErrorResult(result) {
    return result.type === $00f8c8d19c70d669$var$ResultType.error;
}
function $00f8c8d19c70d669$var$isRedirectResult(result) {
    return (result && result.type) === $00f8c8d19c70d669$var$ResultType.redirect;
}
function $00f8c8d19c70d669$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $00f8c8d19c70d669$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $00f8c8d19c70d669$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $00f8c8d19c70d669$var$isRedirectResponse(result) {
    if (!$00f8c8d19c70d669$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $00f8c8d19c70d669$var$isValidMethod(method) {
    return $00f8c8d19c70d669$var$validRequestMethods.has(method.toLowerCase());
}
function $00f8c8d19c70d669$var$isMutationMethod(method) {
    return $00f8c8d19c70d669$var$validMutationMethods.has(method.toLowerCase());
}
async function $00f8c8d19c70d669$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$00f8c8d19c70d669$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($00f8c8d19c70d669$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $00f8c8d19c70d669$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $00f8c8d19c70d669$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($00f8c8d19c70d669$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $00f8c8d19c70d669$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $00f8c8d19c70d669$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $00f8c8d19c70d669$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $00f8c8d19c70d669$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $00f8c8d19c70d669$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $00f8c8d19c70d669$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $00f8c8d19c70d669$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $00f8c8d19c70d669$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $00f8c8d19c70d669$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $00f8c8d19c70d669$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $00f8c8d19c70d669$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $00f8c8d19c70d669$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $00f8c8d19c70d669$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $00f8c8d19c70d669$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $00f8c8d19c70d669$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $00f8c8d19c70d669$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $00f8c8d19c70d669$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $00f8c8d19c70d669$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($00f8c8d19c70d669$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $00f8c8d19c70d669$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($00f8c8d19c70d669$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $00f8c8d19c70d669$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gIfym = parcelRequire("gIfym");

function $bf4ac162b947611d$var$_extends() {
    return $bf4ac162b947611d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bf4ac162b947611d$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $bf4ac162b947611d$export$3add0d5dce533e2e = /*#__PURE__*/ $gIfym.createContext(null);
const $bf4ac162b947611d$export$145dfa71566a64dc = /*#__PURE__*/ $gIfym.createContext(null);
const $bf4ac162b947611d$var$AwaitContext = /*#__PURE__*/ $gIfym.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $bf4ac162b947611d$export$26749e8557646306 = /*#__PURE__*/ $gIfym.createContext(null);
const $bf4ac162b947611d$export$c7914228fb69b0f5 = /*#__PURE__*/ $gIfym.createContext(null);
const $bf4ac162b947611d$export$9072aa6dd1f93057 = /*#__PURE__*/ $gIfym.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $bf4ac162b947611d$var$RouteErrorContext = /*#__PURE__*/ $gIfym.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $bf4ac162b947611d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $gIfym.useContext($bf4ac162b947611d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $bf4ac162b947611d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $00f8c8d19c70d669$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $bf4ac162b947611d$export$9c954a9d03d32f4a() {
    return $gIfym.useContext($bf4ac162b947611d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $bf4ac162b947611d$export$45d76561a5302f2b() {
    !$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return $gIfym.useContext($bf4ac162b947611d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $bf4ac162b947611d$export$1b3f31771c5d07c() {
    return $gIfym.useContext($bf4ac162b947611d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $bf4ac162b947611d$export$6c330e8992e8a295(pattern) {
    !$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $bf4ac162b947611d$export$45d76561a5302f2b();
    return $gIfym.useMemo(()=>(0, $00f8c8d19c70d669$export$81336c211d5ff295)(pattern, (0, $00f8c8d19c70d669$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $bf4ac162b947611d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $bf4ac162b947611d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $gIfym.useContext($bf4ac162b947611d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $gIfym.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $bf4ac162b947611d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $bf4ac162b947611d$var$useNavigateStable() : $bf4ac162b947611d$var$useNavigateUnstable();
}
function $bf4ac162b947611d$var$useNavigateUnstable() {
    !$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let dataRouterContext = $gIfym.useContext($bf4ac162b947611d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $gIfym.useContext($bf4ac162b947611d$export$26749e8557646306);
    let { matches: matches } = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bf4ac162b947611d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $00f8c8d19c70d669$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $gIfym.useRef(false);
    $bf4ac162b947611d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $gIfym.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $00f8c8d19c70d669$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $00f8c8d19c70d669$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $bf4ac162b947611d$var$OutletContext = /*#__PURE__*/ $gIfym.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $bf4ac162b947611d$export$4138103a3ae699cc() {
    return $gIfym.useContext($bf4ac162b947611d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $bf4ac162b947611d$export$a3be3530d8e40d0b(context) {
    let outlet = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $bf4ac162b947611d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $bf4ac162b947611d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $gIfym.useContext($bf4ac162b947611d$export$26749e8557646306);
    let { matches: matches } = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bf4ac162b947611d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $00f8c8d19c70d669$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $gIfym.useMemo(()=>(0, $00f8c8d19c70d669$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $bf4ac162b947611d$export$5d3fca4a98652595(routes, locationArg) {
    return $bf4ac162b947611d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $bf4ac162b947611d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $gIfym.useContext($bf4ac162b947611d$export$26749e8557646306);
    let { matches: parentMatches } = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $bf4ac162b947611d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $00f8c8d19c70d669$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $00f8c8d19c70d669$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $bf4ac162b947611d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $00f8c8d19c70d669$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $00f8c8d19c70d669$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $bf4ac162b947611d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $00f8c8d19c70d669$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $bf4ac162b947611d$var$DefaultErrorComponent() {
    let error = $bf4ac162b947611d$export$ed527bf60f6e05f2();
    let message = (0, $00f8c8d19c70d669$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $gIfym.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $gIfym.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $bf4ac162b947611d$var$defaultErrorElement = /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$DefaultErrorComponent, null);
class $bf4ac162b947611d$var$RenderErrorBoundary extends $gIfym.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $bf4ac162b947611d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $gIfym.useContext($bf4ac162b947611d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $bf4ac162b947611d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $bf4ac162b947611d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $bf4ac162b947611d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $gIfym.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $bf4ac162b947611d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($bf4ac162b947611d$var$DataRouterHook || {});
var $bf4ac162b947611d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($bf4ac162b947611d$var$DataRouterStateHook || {});
function $bf4ac162b947611d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $bf4ac162b947611d$var$useDataRouterContext(hookName) {
    let ctx = $gIfym.useContext($bf4ac162b947611d$export$3add0d5dce533e2e);
    !ctx && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return ctx;
}
function $bf4ac162b947611d$var$useDataRouterState(hookName) {
    let state = $gIfym.useContext($bf4ac162b947611d$export$145dfa71566a64dc);
    !state && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return state;
}
function $bf4ac162b947611d$var$useRouteContext(hookName) {
    let route = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    !route && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $bf4ac162b947611d$var$useCurrentRouteId(hookName) {
    let route = $bf4ac162b947611d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $bf4ac162b947611d$export$5fc8298006ad9e58() {
    return $bf4ac162b947611d$var$useCurrentRouteId($bf4ac162b947611d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $bf4ac162b947611d$export$d0fd4b7106de2769() {
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $bf4ac162b947611d$export$600dc272ed516c15() {
    let dataRouterContext = $bf4ac162b947611d$var$useDataRouterContext($bf4ac162b947611d$var$DataRouterHook.UseRevalidator);
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseRevalidator);
    return $gIfym.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $bf4ac162b947611d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseMatches);
    return $gIfym.useMemo(()=>matches.map((m)=>(0, $00f8c8d19c70d669$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $bf4ac162b947611d$export$1448a5050d252c4d() {
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $bf4ac162b947611d$var$useCurrentRouteId($bf4ac162b947611d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $bf4ac162b947611d$export$fd5d37484eab868d(routeId) {
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $bf4ac162b947611d$export$fdc00f3f26066d5e() {
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseActionData);
    let routeId = $bf4ac162b947611d$var$useCurrentRouteId($bf4ac162b947611d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $bf4ac162b947611d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $gIfym.useContext($bf4ac162b947611d$var$RouteErrorContext);
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseRouteError);
    let routeId = $bf4ac162b947611d$var$useCurrentRouteId($bf4ac162b947611d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $bf4ac162b947611d$export$78a72ddb39bdd145() {
    let value = $gIfym.useContext($bf4ac162b947611d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $bf4ac162b947611d$export$17f53340677d5831() {
    let value = $gIfym.useContext($bf4ac162b947611d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $bf4ac162b947611d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $bf4ac162b947611d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $bf4ac162b947611d$var$useDataRouterContext($bf4ac162b947611d$var$DataRouterHook.UseBlocker);
    let state = $bf4ac162b947611d$var$useDataRouterState($bf4ac162b947611d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $gIfym.useState("");
    let blockerFunction = $gIfym.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $bf4ac162b947611d$var$_extends({}, currentLocation, {
                pathname: (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $bf4ac162b947611d$var$_extends({}, nextLocation, {
                pathname: (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $gIfym.useEffect(()=>{
        let key = String(++$bf4ac162b947611d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $gIfym.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $00f8c8d19c70d669$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $bf4ac162b947611d$var$useNavigateStable() {
    let { router: router } = $bf4ac162b947611d$var$useDataRouterContext($bf4ac162b947611d$var$DataRouterHook.UseNavigateStable);
    let id = $bf4ac162b947611d$var$useCurrentRouteId($bf4ac162b947611d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $gIfym.useRef(false);
    $bf4ac162b947611d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $gIfym.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $bf4ac162b947611d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $bf4ac162b947611d$var$alreadyWarned$1 = {};
function $bf4ac162b947611d$var$warningOnce(key, cond, message) {
    if (!cond && !$bf4ac162b947611d$var$alreadyWarned$1[key]) $bf4ac162b947611d$var$alreadyWarned$1[key] = true;
}
const $bf4ac162b947611d$var$alreadyWarned = {};
function $bf4ac162b947611d$var$warnOnce(key, message) {}
const $bf4ac162b947611d$var$logDeprecation = (flag, msg, link)=>$bf4ac162b947611d$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $bf4ac162b947611d$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $bf4ac162b947611d$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $bf4ac162b947611d$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $bf4ac162b947611d$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $bf4ac162b947611d$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $bf4ac162b947611d$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $bf4ac162b947611d$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $bf4ac162b947611d$var$START_TRANSITION = "startTransition";
const $bf4ac162b947611d$var$startTransitionImpl = $gIfym[$bf4ac162b947611d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $bf4ac162b947611d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $gIfym.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gIfym.useCallback((newState)=>{
        if (v7_startTransition && $bf4ac162b947611d$var$startTransitionImpl) $bf4ac162b947611d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $gIfym.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $gIfym.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $gIfym.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $gIfym.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $gIfym.useEffect(()=>$bf4ac162b947611d$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $bf4ac162b947611d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $bf4ac162b947611d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $bf4ac162b947611d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $gIfym.useRef();
    if (historyRef.current == null) historyRef.current = (0, $00f8c8d19c70d669$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gIfym.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gIfym.useCallback((newState)=>{
        v7_startTransition && $bf4ac162b947611d$var$startTransitionImpl ? $bf4ac162b947611d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gIfym.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gIfym.useEffect(()=>$bf4ac162b947611d$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $bf4ac162b947611d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $gIfym.useContext($bf4ac162b947611d$export$26749e8557646306);
    let { matches: matches } = $gIfym.useContext($bf4ac162b947611d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bf4ac162b947611d$export$45d76561a5302f2b();
    let navigate = $bf4ac162b947611d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $00f8c8d19c70d669$export$cae722b0cc860f13)(to, (0, $00f8c8d19c70d669$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $gIfym.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $bf4ac162b947611d$export$910ae8079b2c2852(props) {
    return $bf4ac162b947611d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $bf4ac162b947611d$export$e7b0ac011bb776c6(_props) {
    (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $bf4ac162b947611d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $00f8c8d19c70d669$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$bf4ac162b947611d$export$9c954a9d03d32f4a() && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $gIfym.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $bf4ac162b947611d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $00f8c8d19c70d669$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $gIfym.useMemo(()=>{
        let trailingPathname = (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $bf4ac162b947611d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $bf4ac162b947611d$export$5d3fca4a98652595($bf4ac162b947611d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $bf4ac162b947611d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$ResolveAwait, null, children));
}
var $bf4ac162b947611d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($bf4ac162b947611d$var$AwaitRenderStatus || {});
const $bf4ac162b947611d$var$neverSettledPromise = new Promise(()=>{});
class $bf4ac162b947611d$var$AwaitErrorBoundary extends $gIfym.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $bf4ac162b947611d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $bf4ac162b947611d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $bf4ac162b947611d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $bf4ac162b947611d$var$AwaitRenderStatus.error : "_data" in promise ? $bf4ac162b947611d$var$AwaitRenderStatus.success : $bf4ac162b947611d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $bf4ac162b947611d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $bf4ac162b947611d$var$AwaitRenderStatus.error && promise._error instanceof (0, $00f8c8d19c70d669$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $bf4ac162b947611d$var$neverSettledPromise;
        if (status === $bf4ac162b947611d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $bf4ac162b947611d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $bf4ac162b947611d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $gIfym.createElement($bf4ac162b947611d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $bf4ac162b947611d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $bf4ac162b947611d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $bf4ac162b947611d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $gIfym.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $gIfym.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $gIfym.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $bf4ac162b947611d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $bf4ac162b947611d$export$e7b0ac011bb776c6) && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $bf4ac162b947611d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $bf4ac162b947611d$export$daf73786167a7f72(matches) {
    return $bf4ac162b947611d$var$_renderMatches(matches);
}
function $bf4ac162b947611d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $gIfym.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $gIfym.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $gIfym.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $bf4ac162b947611d$export$f30f7e456d254e83(routes, opts) {
    return (0, $00f8c8d19c70d669$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $bf4ac162b947611d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $00f8c8d19c70d669$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $bf4ac162b947611d$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $8a32432afacbfa13$var$_extends() {
    return $8a32432afacbfa13$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8a32432afacbfa13$var$_extends.apply(null, arguments);
}
function $8a32432afacbfa13$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $8a32432afacbfa13$var$defaultMethod = "get";
const $8a32432afacbfa13$var$defaultEncType = "application/x-www-form-urlencoded";
function $8a32432afacbfa13$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $8a32432afacbfa13$var$isButtonElement(object) {
    return $8a32432afacbfa13$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $8a32432afacbfa13$var$isFormElement(object) {
    return $8a32432afacbfa13$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $8a32432afacbfa13$var$isInputElement(object) {
    return $8a32432afacbfa13$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $8a32432afacbfa13$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $8a32432afacbfa13$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$8a32432afacbfa13$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $8a32432afacbfa13$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $8a32432afacbfa13$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $8a32432afacbfa13$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $8a32432afacbfa13$var$_formDataSupportsSubmitter = null;
function $8a32432afacbfa13$var$isFormDataSubmitterSupported() {
    if ($8a32432afacbfa13$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $8a32432afacbfa13$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $8a32432afacbfa13$var$_formDataSupportsSubmitter = true;
    }
    return $8a32432afacbfa13$var$_formDataSupportsSubmitter;
}
const $8a32432afacbfa13$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $8a32432afacbfa13$var$getFormEncType(encType) {
    if (encType != null && !$8a32432afacbfa13$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $8a32432afacbfa13$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($8a32432afacbfa13$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $8a32432afacbfa13$var$defaultMethod;
        encType = $8a32432afacbfa13$var$getFormEncType(target.getAttribute("enctype")) || $8a32432afacbfa13$var$defaultEncType;
        formData = new FormData(target);
    } else if ($8a32432afacbfa13$var$isButtonElement(target) || $8a32432afacbfa13$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $8a32432afacbfa13$var$defaultMethod;
        encType = $8a32432afacbfa13$var$getFormEncType(target.getAttribute("formenctype")) || $8a32432afacbfa13$var$getFormEncType(form.getAttribute("enctype")) || $8a32432afacbfa13$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$8a32432afacbfa13$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($8a32432afacbfa13$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $8a32432afacbfa13$var$defaultMethod;
        action = null;
        encType = $8a32432afacbfa13$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $8a32432afacbfa13$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $8a32432afacbfa13$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $8a32432afacbfa13$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $8a32432afacbfa13$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $8a32432afacbfa13$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $8a32432afacbfa13$export$1f3f55432a00e06d(routes, opts) {
    return (0, $00f8c8d19c70d669$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8a32432afacbfa13$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $00f8c8d19c70d669$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8a32432afacbfa13$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bf4ac162b947611d$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8a32432afacbfa13$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $00f8c8d19c70d669$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8a32432afacbfa13$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $00f8c8d19c70d669$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8a32432afacbfa13$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bf4ac162b947611d$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8a32432afacbfa13$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $8a32432afacbfa13$var$_extends({}, state, {
        errors: $8a32432afacbfa13$var$deserializeErrors(state.errors)
    });
    return state;
}
function $8a32432afacbfa13$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $00f8c8d19c70d669$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $8a32432afacbfa13$export$7ad602f0e94e62d1 = /*#__PURE__*/ $gIfym.createContext({
    isTransitioning: false
});
const $8a32432afacbfa13$export$148fd98d095596d4 = /*#__PURE__*/ $gIfym.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $8a32432afacbfa13$var$START_TRANSITION = "startTransition";
const $8a32432afacbfa13$var$startTransitionImpl = $gIfym[$8a32432afacbfa13$var$START_TRANSITION];
const $8a32432afacbfa13$var$FLUSH_SYNC = "flushSync";
const $8a32432afacbfa13$var$flushSyncImpl = $c4a08725a78d51bf$exports[$8a32432afacbfa13$var$FLUSH_SYNC];
const $8a32432afacbfa13$var$USE_ID = "useId";
const $8a32432afacbfa13$var$useIdImpl = $gIfym[$8a32432afacbfa13$var$USE_ID];
function $8a32432afacbfa13$var$startTransitionSafe(cb) {
    if ($8a32432afacbfa13$var$startTransitionImpl) $8a32432afacbfa13$var$startTransitionImpl(cb);
    else cb();
}
function $8a32432afacbfa13$var$flushSyncSafe(cb) {
    if ($8a32432afacbfa13$var$flushSyncImpl) $8a32432afacbfa13$var$flushSyncImpl(cb);
    else cb();
}
class $8a32432afacbfa13$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8a32432afacbfa13$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $gIfym.useState(router.state);
    let [pendingState, setPendingState] = $gIfym.useState();
    let [vtContext, setVtContext] = $gIfym.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $gIfym.useState();
    let [transition, setTransition] = $gIfym.useState();
    let [interruption, setInterruption] = $gIfym.useState();
    let fetcherData = $gIfym.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $gIfym.useCallback((cb)=>{
        if (v7_startTransition) $8a32432afacbfa13$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $gIfym.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $8a32432afacbfa13$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $8a32432afacbfa13$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $8a32432afacbfa13$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $8a32432afacbfa13$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $8a32432afacbfa13$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $gIfym.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $gIfym.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $8a32432afacbfa13$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $gIfym.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $gIfym.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $gIfym.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $gIfym.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $gIfym.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $gIfym.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $gIfym.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $gIfym.useEffect(()=>(0, $bf4ac162b947611d$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement((0, $bf4ac162b947611d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $gIfym.createElement((0, $bf4ac162b947611d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $gIfym.createElement($8a32432afacbfa13$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $gIfym.createElement($8a32432afacbfa13$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $gIfym.createElement((0, $bf4ac162b947611d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $gIfym.createElement($8a32432afacbfa13$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $8a32432afacbfa13$var$MemoizedDataRoutes = /*#__PURE__*/ $gIfym.memo($8a32432afacbfa13$var$DataRoutes);
function $8a32432afacbfa13$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $bf4ac162b947611d$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $8a32432afacbfa13$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $gIfym.useRef();
    if (historyRef.current == null) historyRef.current = (0, $00f8c8d19c70d669$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gIfym.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gIfym.useCallback((newState)=>{
        v7_startTransition && $8a32432afacbfa13$var$startTransitionImpl ? $8a32432afacbfa13$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gIfym.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gIfym.useEffect(()=>(0, $bf4ac162b947611d$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $bf4ac162b947611d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $8a32432afacbfa13$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $gIfym.useRef();
    if (historyRef.current == null) historyRef.current = (0, $00f8c8d19c70d669$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gIfym.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gIfym.useCallback((newState)=>{
        v7_startTransition && $8a32432afacbfa13$var$startTransitionImpl ? $8a32432afacbfa13$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gIfym.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gIfym.useEffect(()=>(0, $bf4ac162b947611d$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $bf4ac162b947611d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $8a32432afacbfa13$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $gIfym.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gIfym.useCallback((newState)=>{
        v7_startTransition && $8a32432afacbfa13$var$startTransitionImpl ? $8a32432afacbfa13$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gIfym.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gIfym.useEffect(()=>(0, $bf4ac162b947611d$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $bf4ac162b947611d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $8a32432afacbfa13$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $8a32432afacbfa13$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $8a32432afacbfa13$export$a6c7ac8248d6e38a = /*#__PURE__*/ $gIfym.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $8a32432afacbfa13$var$_objectWithoutPropertiesLoose(_ref7, $8a32432afacbfa13$var$_excluded);
    let { basename: basename } = $gIfym.useContext((0, $bf4ac162b947611d$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $8a32432afacbfa13$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($8a32432afacbfa13$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $bf4ac162b947611d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $8a32432afacbfa13$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $gIfym.createElement("a", $8a32432afacbfa13$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $8a32432afacbfa13$export$b0d92dbee9b5b60d = /*#__PURE__*/ $gIfym.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $8a32432afacbfa13$var$_objectWithoutPropertiesLoose(_ref8, $8a32432afacbfa13$var$_excluded2);
    let path = (0, $bf4ac162b947611d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    let routerState = $gIfym.useContext((0, $bf4ac162b947611d$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $gIfym.useContext((0, $bf4ac162b947611d$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8a32432afacbfa13$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $gIfym.createElement($8a32432afacbfa13$export$a6c7ac8248d6e38a, $8a32432afacbfa13$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $8a32432afacbfa13$export$a7fed597f4b8afd8 = /*#__PURE__*/ $gIfym.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $8a32432afacbfa13$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $8a32432afacbfa13$var$_objectWithoutPropertiesLoose(_ref9, $8a32432afacbfa13$var$_excluded3);
    let submit = $8a32432afacbfa13$export$47c85c6e3a081d3();
    let formAction = $8a32432afacbfa13$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $gIfym.createElement("form", $8a32432afacbfa13$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $8a32432afacbfa13$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $8a32432afacbfa13$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $8a32432afacbfa13$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($8a32432afacbfa13$var$DataRouterHook || ($8a32432afacbfa13$var$DataRouterHook = {}));
var $8a32432afacbfa13$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($8a32432afacbfa13$var$DataRouterStateHook || ($8a32432afacbfa13$var$DataRouterStateHook = {}));
// Internal hooks
function $8a32432afacbfa13$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $8a32432afacbfa13$var$useDataRouterContext(hookName) {
    let ctx = $gIfym.useContext((0, $bf4ac162b947611d$export$3add0d5dce533e2e));
    !ctx && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8a32432afacbfa13$var$useDataRouterState(hookName) {
    let state = $gIfym.useContext((0, $bf4ac162b947611d$export$145dfa71566a64dc));
    !state && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $8a32432afacbfa13$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    let location = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    let path = (0, $bf4ac162b947611d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $gIfym.useCallback((event)=>{
        if ($8a32432afacbfa13$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $00f8c8d19c70d669$export$fe53371bee54353d)(location) === (0, $00f8c8d19c70d669$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $8a32432afacbfa13$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $gIfym.useRef($8a32432afacbfa13$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $gIfym.useRef(false);
    let location = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    let searchParams = $gIfym.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $8a32432afacbfa13$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    let setSearchParams = $gIfym.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $8a32432afacbfa13$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $8a32432afacbfa13$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $8a32432afacbfa13$var$fetcherId = 0;
let $8a32432afacbfa13$var$getUniqueFetcherId = ()=>"__" + String(++$8a32432afacbfa13$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $8a32432afacbfa13$export$47c85c6e3a081d3() {
    let { router: router } = $8a32432afacbfa13$var$useDataRouterContext($8a32432afacbfa13$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $gIfym.useContext((0, $bf4ac162b947611d$export$26749e8557646306));
    let currentRouteId = (0, $bf4ac162b947611d$export$5fc8298006ad9e58)();
    return $gIfym.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $8a32432afacbfa13$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $8a32432afacbfa13$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $8a32432afacbfa13$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $8a32432afacbfa13$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $gIfym.useContext((0, $bf4ac162b947611d$export$26749e8557646306));
    let routeContext = $gIfym.useContext((0, $bf4ac162b947611d$export$9072aa6dd1f93057));
    !routeContext && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $8a32432afacbfa13$var$_extends({}, (0, $bf4ac162b947611d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $00f8c8d19c70d669$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $00f8c8d19c70d669$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $8a32432afacbfa13$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $8a32432afacbfa13$var$useDataRouterContext($8a32432afacbfa13$var$DataRouterHook.UseFetcher);
    let state = $8a32432afacbfa13$var$useDataRouterState($8a32432afacbfa13$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $gIfym.useContext($8a32432afacbfa13$export$148fd98d095596d4);
    let route = $gIfym.useContext((0, $bf4ac162b947611d$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    !route && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $8a32432afacbfa13$var$useIdImpl ? $8a32432afacbfa13$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $gIfym.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($8a32432afacbfa13$var$getUniqueFetcherId());
    // Registration/cleanup
    $gIfym.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $gIfym.useCallback((href, opts)=>{
        !routeId && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $8a32432afacbfa13$export$47c85c6e3a081d3();
    let submit = $gIfym.useCallback((target, opts)=>{
        submitImpl(target, $8a32432afacbfa13$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $gIfym.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $gIfym.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $gIfym.createElement($8a32432afacbfa13$export$a7fed597f4b8afd8, $8a32432afacbfa13$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $00f8c8d19c70d669$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $gIfym.useMemo(()=>$8a32432afacbfa13$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $8a32432afacbfa13$export$fa996778a3a31087() {
    let state = $8a32432afacbfa13$var$useDataRouterState($8a32432afacbfa13$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $8a32432afacbfa13$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $8a32432afacbfa13$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $8a32432afacbfa13$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $8a32432afacbfa13$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $8a32432afacbfa13$var$useDataRouterContext($8a32432afacbfa13$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $8a32432afacbfa13$var$useDataRouterState($8a32432afacbfa13$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $gIfym.useContext((0, $bf4ac162b947611d$export$26749e8557646306));
    let location = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    let matches = (0, $bf4ac162b947611d$export$2378eb7f5ff86053)();
    let navigation = (0, $bf4ac162b947611d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $gIfym.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $8a32432afacbfa13$var$usePageHide($gIfym.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $8a32432afacbfa13$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $8a32432afacbfa13$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($8a32432afacbfa13$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gIfym.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $8a32432afacbfa13$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $8a32432afacbfa13$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gIfym.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($8a32432afacbfa13$var$_extends({}, location, {
                    pathname: (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($8a32432afacbfa13$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gIfym.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8a32432afacbfa13$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $gIfym.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8a32432afacbfa13$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $gIfym.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $8a32432afacbfa13$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $bf4ac162b947611d$export$b273b3273281a049)(when);
    $gIfym.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $gIfym.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $8a32432afacbfa13$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $gIfym.useContext($8a32432afacbfa13$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $00f8c8d19c70d669$export$3e9cee6b33872309)(false);
    let { basename: basename } = $8a32432afacbfa13$var$useDataRouterContext($8a32432afacbfa13$var$DataRouterHook.useViewTransitionState);
    let path = (0, $bf4ac162b947611d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $00f8c8d19c70d669$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $00f8c8d19c70d669$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $00f8c8d19c70d669$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $3f9f814746ab6e10$exports = {};
//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

(function(global, factory) {
    factory((parcelRequire("jBLdM")));
})($3f9f814746ab6e10$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split('_'),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tors_fre_l\xf6r".split('_'),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    return sv;
});



var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

parcelRequire("gIfym");

var $17323fc8ea3ee725$exports = {};
$17323fc8ea3ee725$exports = $parcel$resolve("dpH0O");


let $ffec81640b9b275e$var$logo = new URL($17323fc8ea3ee725$exports);
var $d5ccd1a014a4473f$exports = {};
$d5ccd1a014a4473f$exports = $parcel$resolve("ZqBv6");


let $ffec81640b9b275e$var$logoSign = new URL($d5ccd1a014a4473f$exports);
function $ffec81640b9b275e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "relative px-8 py-5",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $8a32432afacbfa13$export$a6c7ac8248d6e38a), {
            to: "/todo",
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "mr-4 flex",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        src: $ffec81640b9b275e$var$logo,
                        alt: "Fenix",
                        width: "42",
                        height: "42"
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        src: $ffec81640b9b275e$var$logoSign,
                        alt: "Fenix",
                        width: "95",
                        height: "24"
                    })
                })
            ]
        })
    });
}



function $006b2c47c574b37c$export$2e2bcd8739ae039({ children: children, title: title, noBg: noBg = false }) {
    let classes = noBg ? "" : "max-w-[28rem] bg-white rounded";
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "flex justify-center pt-[8%] relative",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: `w-[100%] p-8 mx-5 ${classes}`,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h1", {
                    className: `mb-8 text-center font-pprightgothic text-5xl sm:text-6xl ${noBg ? "text-white" : "text-dark-blue"} `,
                    children: title
                }),
                children
            ]
        })
    });
}


class $953340840ac7d8bf$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.errorInfo) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("main", {
            className: "relative flex-grow bg-dark-blue bg-auth bg-cover bg-no-repeat bg-center",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ffec81640b9b275e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $006b2c47c574b37c$export$2e2bcd8739ae039), {
                    title: "Something went wrong \uD83D\uDE2D",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "mb-2",
                                children: this.state.error && this.state.error.toString()
                            }),
                            false
                        ]
                    })
                })
            ]
        });
        return this.props.children;
    }
}
var $953340840ac7d8bf$export$2e2bcd8739ae039 = $953340840ac7d8bf$var$ErrorBoundary;




var $gIfym = parcelRequire("gIfym");



var $6VKBH = parcelRequire("6VKBH");

var $gIfym = parcelRequire("gIfym");
var $3ea29cd540ee2ef3$exports = {};
var $6fd9d96b7dc5f1ba$exports = {};
function $6fd9d96b7dc5f1ba$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$6fd9d96b7dc5f1ba$exports = $6fd9d96b7dc5f1ba$var$_arrayWithHoles, $6fd9d96b7dc5f1ba$exports.__esModule = true, $6fd9d96b7dc5f1ba$exports["default"] = $6fd9d96b7dc5f1ba$exports;


var $27f0ff893f6afde4$exports = {};
function $27f0ff893f6afde4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$27f0ff893f6afde4$exports = $27f0ff893f6afde4$var$_iterableToArrayLimit, $27f0ff893f6afde4$exports.__esModule = true, $27f0ff893f6afde4$exports["default"] = $27f0ff893f6afde4$exports;


var $b9376f7f2dc8a3f2$exports = {};
var $ecfe1bfe68770905$exports = {};
function $ecfe1bfe68770905$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$ecfe1bfe68770905$exports = $ecfe1bfe68770905$var$_arrayLikeToArray, $ecfe1bfe68770905$exports.__esModule = true, $ecfe1bfe68770905$exports["default"] = $ecfe1bfe68770905$exports;


function $b9376f7f2dc8a3f2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ecfe1bfe68770905$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ecfe1bfe68770905$exports(r, a) : void 0;
    }
}
$b9376f7f2dc8a3f2$exports = $b9376f7f2dc8a3f2$var$_unsupportedIterableToArray, $b9376f7f2dc8a3f2$exports.__esModule = true, $b9376f7f2dc8a3f2$exports["default"] = $b9376f7f2dc8a3f2$exports;


var $2f9e99dca3f3c98e$exports = {};
function $2f9e99dca3f3c98e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$2f9e99dca3f3c98e$exports = $2f9e99dca3f3c98e$var$_nonIterableRest, $2f9e99dca3f3c98e$exports.__esModule = true, $2f9e99dca3f3c98e$exports["default"] = $2f9e99dca3f3c98e$exports;


function $3ea29cd540ee2ef3$var$_slicedToArray(r, e) {
    return $6fd9d96b7dc5f1ba$exports(r) || $27f0ff893f6afde4$exports(r, e) || $b9376f7f2dc8a3f2$exports(r, e) || $2f9e99dca3f3c98e$exports();
}
$3ea29cd540ee2ef3$exports = $3ea29cd540ee2ef3$var$_slicedToArray, $3ea29cd540ee2ef3$exports.__esModule = true, $3ea29cd540ee2ef3$exports["default"] = $3ea29cd540ee2ef3$exports;


var $39363681bdb5f057$exports = {};
var $19f87469c0aa1cc1$exports = {};
var $c33c301477c193c0$exports = {};
function $c33c301477c193c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c33c301477c193c0$exports = $c33c301477c193c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c33c301477c193c0$exports.__esModule = true, $c33c301477c193c0$exports["default"] = $c33c301477c193c0$exports, $c33c301477c193c0$var$_typeof(o);
}
$c33c301477c193c0$exports = $c33c301477c193c0$var$_typeof, $c33c301477c193c0$exports.__esModule = true, $c33c301477c193c0$exports["default"] = $c33c301477c193c0$exports;


var $19f87469c0aa1cc1$var$_typeof = $c33c301477c193c0$exports.default;
var $d09cb406687da39d$exports = {};

var $d09cb406687da39d$var$_typeof = $c33c301477c193c0$exports.default;
function $d09cb406687da39d$var$toPrimitive(t, r) {
    if ("object" != $d09cb406687da39d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d09cb406687da39d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$d09cb406687da39d$exports = $d09cb406687da39d$var$toPrimitive, $d09cb406687da39d$exports.__esModule = true, $d09cb406687da39d$exports["default"] = $d09cb406687da39d$exports;


function $19f87469c0aa1cc1$var$toPropertyKey(t) {
    var i = $d09cb406687da39d$exports(t, "string");
    return "symbol" == $19f87469c0aa1cc1$var$_typeof(i) ? i : i + "";
}
$19f87469c0aa1cc1$exports = $19f87469c0aa1cc1$var$toPropertyKey, $19f87469c0aa1cc1$exports.__esModule = true, $19f87469c0aa1cc1$exports["default"] = $19f87469c0aa1cc1$exports;


function $39363681bdb5f057$var$_defineProperty(e, r, t) {
    return (r = $19f87469c0aa1cc1$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$39363681bdb5f057$exports = $39363681bdb5f057$var$_defineProperty, $39363681bdb5f057$exports.__esModule = true, $39363681bdb5f057$exports["default"] = $39363681bdb5f057$exports;



var $gIfym = parcelRequire("gIfym");
var $824faf247cd2386d$exports = {};
function $824faf247cd2386d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$824faf247cd2386d$exports = $824faf247cd2386d$var$_classCallCheck, $824faf247cd2386d$exports.__esModule = true, $824faf247cd2386d$exports["default"] = $824faf247cd2386d$exports;


var $5425dff1a7de1aa2$exports = {};

function $5425dff1a7de1aa2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $19f87469c0aa1cc1$exports(o.key), o);
    }
}
function $5425dff1a7de1aa2$var$_createClass(e, r, t) {
    return r && $5425dff1a7de1aa2$var$_defineProperties(e.prototype, r), t && $5425dff1a7de1aa2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$5425dff1a7de1aa2$exports = $5425dff1a7de1aa2$var$_createClass, $5425dff1a7de1aa2$exports.__esModule = true, $5425dff1a7de1aa2$exports["default"] = $5425dff1a7de1aa2$exports;




var $gIfym = parcelRequire("gIfym");
var $6d2d6414fe8a2ae8$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $6d2d6414fe8a2ae8$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $6d2d6414fe8a2ae8$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $6d2d6414fe8a2ae8$var$htmlEntities[m];
};
var $6d2d6414fe8a2ae8$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($6d2d6414fe8a2ae8$var$matchHtmlEntity, $6d2d6414fe8a2ae8$var$unescapeHtmlEntity);
};


function $388c5f3b9701ffb1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $388c5f3b9701ffb1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $388c5f3b9701ffb1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($39363681bdb5f057$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $388c5f3b9701ffb1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $388c5f3b9701ffb1$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $6d2d6414fe8a2ae8$export$e8bacd2802a88316)
};
var $388c5f3b9701ffb1$var$i18nInstance;
var $388c5f3b9701ffb1$export$5603ab5ced17ce64 = (0, $gIfym.createContext)();
function $388c5f3b9701ffb1$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $388c5f3b9701ffb1$var$defaultOptions = $388c5f3b9701ffb1$var$_objectSpread($388c5f3b9701ffb1$var$_objectSpread({}, $388c5f3b9701ffb1$var$defaultOptions), options);
}
function $388c5f3b9701ffb1$export$212bb2fc580a90a8() {
    return $388c5f3b9701ffb1$var$defaultOptions;
}
var $388c5f3b9701ffb1$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($824faf247cd2386d$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5425dff1a7de1aa2$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $388c5f3b9701ffb1$export$a039134f2fc7e0(instance) {
    $388c5f3b9701ffb1$var$i18nInstance = instance;
}
function $388c5f3b9701ffb1$export$64af334f494c2f47() {
    return $388c5f3b9701ffb1$var$i18nInstance;
}
var $388c5f3b9701ffb1$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $388c5f3b9701ffb1$export$2e2366488d12e20d(instance.options.react);
        $388c5f3b9701ffb1$export$a039134f2fc7e0(instance);
    }
};
function $388c5f3b9701ffb1$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $388c5f3b9701ffb1$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($388c5f3b9701ffb1$var$_objectSpread($388c5f3b9701ffb1$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $388c5f3b9701ffb1$export$704200e5d0b9e8f() {
    var i18n = $388c5f3b9701ffb1$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $e4dd253d4f96c29a$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $e4dd253d4f96c29a$var$alreadyWarned = {};
function $e4dd253d4f96c29a$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $e4dd253d4f96c29a$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $e4dd253d4f96c29a$var$alreadyWarned[args[0]] = new Date();
    $e4dd253d4f96c29a$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $e4dd253d4f96c29a$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $e4dd253d4f96c29a$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $e4dd253d4f96c29a$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $e4dd253d4f96c29a$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $e4dd253d4f96c29a$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $e4dd253d4f96c29a$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


function $eb3cabd3632e6a19$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb3cabd3632e6a19$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $eb3cabd3632e6a19$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($39363681bdb5f057$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $eb3cabd3632e6a19$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $eb3cabd3632e6a19$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $gIfym.useRef)();
    (0, $gIfym.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $eb3cabd3632e6a19$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $gIfym.useContext)((0, $388c5f3b9701ffb1$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $388c5f3b9701ffb1$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $388c5f3b9701ffb1$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $e4dd253d4f96c29a$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $e4dd253d4f96c29a$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $eb3cabd3632e6a19$var$_objectSpread($eb3cabd3632e6a19$var$_objectSpread($eb3cabd3632e6a19$var$_objectSpread({}, (0, $388c5f3b9701ffb1$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $e4dd253d4f96c29a$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $gIfym.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($3ea29cd540ee2ef3$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $eb3cabd3632e6a19$var$usePrevious(joinedNS);
    var isMounted = (0, $gIfym.useRef)(true);
    (0, $gIfym.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $e4dd253d4f96c29a$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $gIfym.useRef)(true);
    (0, $gIfym.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $e4dd253d4f96c29a$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}




parcelRequire("gIfym");

parcelRequire("gIfym");
function $5e5f6efd194dbddf$export$2e2bcd8739ae039({ theme: theme, size: size }) {
    let themeClasses = "text-gray-600 fill-white";
    let sizeClasses = "w-10 h-10";
    if (theme === "dark") themeClasses = "text-gray-300 fill-dark-blue";
    if (size === "tiny") sizeClasses = "w-4 h-4";
    if (size === "small") sizeClasses = "w-5 h-5";
    const cl = `${sizeClasses} animate-spin ${themeClasses}`; // animate-spin
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("svg", {
        role: "status",
        className: cl,
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill"
            })
        ]
    });
}


function $c65da64c1778b445$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "flex h-screen w-full justify-center items-center bg-dark-blue",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {})
    });
}




var $gIfym = parcelRequire("gIfym");

function $e845536d9724b5be$export$471f70c09cf8ab8c() {
    return window.innerWidth >= 1280;
}
function $e845536d9724b5be$export$8541741fca6b4b74() {
    return window.innerWidth < 1024;
}
function $e845536d9724b5be$export$9e15fb06e64c4810(length = 5) {
    return Math.random().toString(36).substr(2, length).split("").map((c)=>Math.random() < 0.5 ? c.toUpperCase() : c).join("");
}
function $e845536d9724b5be$export$709793eec59fe573(str) {
    const reg = RegExp(":|\\.|/|'|,", "g");
    return str.trim().split(" ").join("").toLowerCase().replaceAll(reg, "");
}
function $e845536d9724b5be$export$96e99d0e61df2702(phone) {
    const r = new RegExp("[\\s\\(\\)\\-]", "g");
    return phone.replaceAll(r, "");
}
function $e845536d9724b5be$export$fa8cb0654f2148f2(data) {
    return JSON.parse(JSON.stringify(data));
}
const $e845536d9724b5be$export$2f77551999344360 = (value, type = "text")=>{
    const personNumberRegex = "(^\\d{12}$)|(^\\d{8}\\-\\d{4}$)";
    // const emailRegex = "^[a-z0-9._\\-\\+]{1,64}@[a-z0-9.]{1,64}$";
    const orgNumberRegex = "^(?:(\\d{10}){1}|(\\d{6}\\-\\d{4}){1})$";
    const emailRegex = "^[a-zA-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-z0-9](?:[a-zA-z0-9-]*[a-z0-9])?\\.)+[a-zA-z0-9](?:[a-zA-z0-9-]*[a-zA-z0-9])?$";
    const phoneNumberRegex = "^\\+{0,1}\\d{8,12}$";
    const personNumberBirthdayRegex = "^(\\d{8}|\\d{12})$";
    switch(type){
        case "range":
            if (value === "") return "Det h\xe4r f\xe4ltet m\xe5ste du fylla i f\xf6r att kunna g\xe5 vidare";
            break;
        case "checkbox":
            if (!value || value.length === 0) return "Du m\xe5ste v\xe4lja ett alternativ f\xf6r att kunna g\xe5 vidare";
            break;
        case "radio":
            if (value === undefined || value === "") return "Du m\xe5ste v\xe4lja ett alternativ f\xf6r att kunna g\xe5 vidare";
            break;
        case "personnummer":
            if (value.match(personNumberRegex) === null) return "Fyll i med 12 siffror, \xc5\xc5\xc5\xc5MMDDXXXX";
            break;
        case "orgnummer":
            if (value.match(orgNumberRegex) === null) return "Fyll i med 10 siffror, \xc5\xc5MMDDXXXX";
            break;
        case "email":
            if (value.match(emailRegex) === null) return "Det verkar vara fel e-postadress. F\xf6rs\xf6k igen";
            break;
        case "postcode":
            if (value === "" || value.length !== 5) return "Fyll i med 5 siffror, XXXXX";
            break;
        case "phone":
            if (value.match(phoneNumberRegex) === null) return "\xc4r det r\xe4tt telefonnummer? F\xf6rs\xf6k igen";
            break;
        case "birthday-personnummer":
            if (value.match(personNumberBirthdayRegex) === null) return "Fyll i med personnummer med/utan 4 sista siffrorna";
            break;
        case "text":
        default:
            if (value === "") return "Det h\xe4r f\xe4ltet m\xe5ste du fylla i f\xf6r att kunna g\xe5 vidare";
            else if (value.length < 2) return "Du m\xe5ste fylla i minst tv\xe5 tecken i f\xe4ltet";
    }
    return true;
};



parcelRequire("gIfym");
const $6fd09f2a913ca93f$var$Notification = ({ message: message, type: type, onClose: onClose })=>{
    let textColorStyle = "text-red-700";
    let bgColorStyle = "bg-red-100";
    if (type === "success") {
        textColorStyle = "text-green-700";
        bgColorStyle = "bg-green-100";
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: `flex ${bgColorStyle} rounded-lg p-4 mb-4 text-sm ${textColorStyle} max-w-sm cursor-pointer shadow-default z-50`,
        role: "alert",
        onClick: ()=>onClose(),
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("svg", {
                className: "w-5 h-5 inline mr-3",
                fill: "currentColor",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                    clipRule: "evenodd"
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                children: message
            })
        ]
    });
};
var $6fd09f2a913ca93f$export$2e2bcd8739ae039 = $6fd09f2a913ca93f$var$Notification;


let $53da372dcfd86b3e$var$defaultDelay = 2000;
const $53da372dcfd86b3e$var$NotificationList = ({ notifications: notifications, onClose: onClose })=>{
    const elRef = (0, $gIfym.useRef)(null);
    if (!elRef.current) elRef.current = document.createElement("div");
    (0, $gIfym.useEffect)(()=>{
        const modalRoot = document.getElementById("notification");
        modalRoot.appendChild(elRef.current);
        return ()=>modalRoot.removeChild(elRef.current);
    }, []);
    (0, $gIfym.useEffect)(()=>{
        const timer = setTimeout(()=>{
            closeList();
        }, $53da372dcfd86b3e$var$defaultDelay);
        return ()=>clearTimeout(timer);
    });
    const closeList = ()=>{
        if (typeof onClose === "function") onClose();
    };
    return notifications.length > 0 ? /*#__PURE__*/ (0, $c4a08725a78d51bf$exports.createPortal)(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "absolute w-full h-full flex flex-col items-center",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "mt-5 z-[60]",
            children: notifications.map((item)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6fd09f2a913ca93f$export$2e2bcd8739ae039), {
                    ...item,
                    onClose: closeList
                }, (0, $e845536d9724b5be$export$9e15fb06e64c4810)()))
        })
    }), elRef.current) : null;
};
var $53da372dcfd86b3e$export$2e2bcd8739ae039 = $53da372dcfd86b3e$var$NotificationList;


const $b0aaffaa8d007c37$var$apiUrl = "https://api.fenixbegravning.se/api/v1/public";
async function $b0aaffaa8d007c37$var$readMessage(response, fallback) {
    try {
        const body = await response.json();
        return body?.message || fallback;
    } catch (e) {
        return fallback;
    }
}
async function $b0aaffaa8d007c37$export$6cdb07c4e80969e(email, password) {
    const response = await fetch(`${$b0aaffaa8d007c37$var$apiUrl}/customer/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
    if (!response.ok) throw new Error(await $b0aaffaa8d007c37$var$readMessage(response, "signin-failed"));
    return response.json();
}
async function $b0aaffaa8d007c37$export$a1f57b29902e609a(email) {
    const response = await fetch(`${$b0aaffaa8d007c37$var$apiUrl}/customer/password/forgot`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email
        })
    });
    const message = await $b0aaffaa8d007c37$var$readMessage(response, "general");
    if (!response.ok) throw new Error(message);
    return message;
}
async function $b0aaffaa8d007c37$export$dc726c8e334dd814(email, code, newPassword) {
    const response = await fetch(`${$b0aaffaa8d007c37$var$apiUrl}/customer/password/reset`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email,
            code: code,
            newPassword: newPassword
        })
    });
    const message = await $b0aaffaa8d007c37$var$readMessage(response, "general");
    if (!response.ok) throw new Error(message);
    return message;
}
async function $b0aaffaa8d007c37$export$296522b9b583854e(accessToken, refreshToken) {
    const response = await fetch(`${$b0aaffaa8d007c37$var$apiUrl}/bankid/refreshtoken`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            accessToken: accessToken,
            refreshToken: refreshToken
        })
    });
    if (!response.ok) throw new Error(await $b0aaffaa8d007c37$var$readMessage(response, "general"));
    return response.json();
}
function $b0aaffaa8d007c37$export$4b61618bdb99cb7e(token) {
    const payload = token.split(".")[1];
    const normalised = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(atob(normalised).split("").map((c)=>`%${c.charCodeAt(0).toString(16).padStart(2, "0")}`).join(""));
    return JSON.parse(json);
}


let $6c726320d527757b$var$apiUrl = "https://api.fenixbegravning.se/api/v1/public";
const $6c726320d527757b$var$tenantId = 1;
async function $6c726320d527757b$export$2324d9b69d65b3(accessToken) {
    try {
        const response = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/profile?tenantId=${$6c726320d527757b$var$tenantId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) console.log(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
            status: response.status
        });
        const data = await response.json();
        if (!data.object) console.log("No data in response");
        return data.object;
    } catch (error) {
        console.log(error);
    }
}
async function $6c726320d527757b$export$bdacb1e4b90bad89(user, controllerRef) {
    if (!user) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/order`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to fetch data");
}
async function $6c726320d527757b$export$a5be085772e686f9(user) {
    if (!user) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/order`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${user.jwtToken}`
        }
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to fetch data");
}
async function $6c726320d527757b$export$8c20ab16ac9cf14f(user, orderId, controllerRef) {
    if (!user || !orderId) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/order/${orderId}/message?seen=true`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to fetch data");
}
async function $6c726320d527757b$export$465cb47180de50f0(user, orderId, text) {
    if (!user || !orderId || !text) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/order/${orderId}/message`, {
        method: "POST",
        body: JSON.stringify({
            id: 0,
            messageText: text
        }),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwtToken}`
        }
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to send data");
}
async function $6c726320d527757b$export$42a6662fdfcb23c5(user, orderId, controllerRef) {
    if (!user || !orderId) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/todo?orderId=${orderId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to send data");
}
async function $6c726320d527757b$export$1e81486c55d394d7(user, todoId, todoStatus, controllerRef) {
    if (!user || !todoId) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/todo/${todoId}?todoStatus=${todoStatus}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to send data");
}
async function $6c726320d527757b$export$782f6f8dc0feb7b3(user, caseId, type, controllerRef) {
    if (!user || !caseId || !type) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/case/${caseId}/document/type/${type}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to send data");
}
async function $6c726320d527757b$export$6e17806a03288445(user, caseId, docId, controllerRef) {
    if (!user || !caseId || !docId) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/${caseId}/document/${docId}/base64`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to get data");
}
async function $6c726320d527757b$export$ea996601912957e2(user, orderId, controllerRef) {
    if (!user || !orderId) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/order/${orderId}/share`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to get data");
}
async function $6c726320d527757b$export$d11c1181088d2ccb(user, orderId, data, controllerRef) {
    if (!user || !orderId || !data) return false;
    const res = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/order/${orderId}/share`, {
        method: "POST",
        body: JSON.stringify({
            FirstName: data.firstName,
            LastName: data.lastName,
            Email: data.email
        }),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwtToken}`
        },
        signal: controllerRef?.current?.signal
    }).catch((error)=>{
        console.error("Error: ", error);
        throw Error(error);
    });
    if (res?.ok) return res.json();
    throw Error("Unable to send data");
}
async function $6c726320d527757b$export$9aa3ca101050be32(accessToken, status, details) {
    try {
        const dt = {
            status: status,
            source: "CustomerWebApp",
            eventDetails: details
        };
        const response = await fetch(`${$6c726320d527757b$var$apiUrl}/customer/event`, {
            method: "POST",
            body: JSON.stringify(dt),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) {
            console.log(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        return true;
    } catch (error) {
        console.log(error);
    }
}


var $9c890567856e8e32$exports = {};
var $40a79ecdf109d128$exports = {};

var $9xBij = parcelRequire("9xBij");
var $40a79ecdf109d128$var$slice = $9xBij.slice;
var $40a79ecdf109d128$var$pluck = $9xBij.pluck;
var $40a79ecdf109d128$var$each = $9xBij.each;
var $40a79ecdf109d128$var$bind = $9xBij.bind;
var $40a79ecdf109d128$var$create = $9xBij.create;
var $40a79ecdf109d128$var$isList = $9xBij.isList;
var $40a79ecdf109d128$var$isFunction = $9xBij.isFunction;
var $40a79ecdf109d128$var$isObject = $9xBij.isObject;
$40a79ecdf109d128$exports = {
    createStore: $40a79ecdf109d128$var$createStore
};
var $40a79ecdf109d128$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $40a79ecdf109d128$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $40a79ecdf109d128$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $40a79ecdf109d128$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $40a79ecdf109d128$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$40a79ecdf109d128$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$40a79ecdf109d128$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $40a79ecdf109d128$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $40a79ecdf109d128$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($40a79ecdf109d128$var$isList(plugin)) {
                $40a79ecdf109d128$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $40a79ecdf109d128$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$40a79ecdf109d128$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$40a79ecdf109d128$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $40a79ecdf109d128$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$40a79ecdf109d128$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $40a79ecdf109d128$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $40a79ecdf109d128$var$create(_privateStoreProps, $40a79ecdf109d128$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $40a79ecdf109d128$var$each(store, function(prop, propName) {
        if ($40a79ecdf109d128$var$isFunction(prop)) store.raw[propName] = $40a79ecdf109d128$var$bind(store, prop);
    });
    $40a79ecdf109d128$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $40a79ecdf109d128$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}


var $0150b41bdf23fbe2$exports = {};






$0150b41bdf23fbe2$exports = [
    // Listed in order of usage preference
    (parcelRequire("euka9")),
    (parcelRequire("lRbAa")),
    (parcelRequire("kZLhS")),
    (parcelRequire("e4Z05")),
    (parcelRequire("52S69")),
    (parcelRequire("evnLY"))
];



var $9c890567856e8e32$var$plugins = [
    (parcelRequire("6s9tW"))
];
$9c890567856e8e32$exports = $40a79ecdf109d128$exports.createStore($0150b41bdf23fbe2$exports, $9c890567856e8e32$var$plugins);


const $715c3e47e001e6ad$export$59799d613660a118 = "fnxTnt";
const $715c3e47e001e6ad$export$5b9892d2b7215bc8 = "fnxUser";
function $715c3e47e001e6ad$export$e4c9b9bae9539063(key, optionalDefaultValue) {
    return $9c890567856e8e32$exports.get(key, optionalDefaultValue);
}
function $715c3e47e001e6ad$export$b4b6c1ec764d6e5(key, data) {
    return $9c890567856e8e32$exports.set(key, data);
}
function $715c3e47e001e6ad$export$a3e6e3b94afefd97(key) {
    return $9c890567856e8e32$exports.remove(key);
}
function $715c3e47e001e6ad$export$7ca27827b1548a66(value) {
    return $715c3e47e001e6ad$export$b4b6c1ec764d6e5($715c3e47e001e6ad$export$59799d613660a118, value);
}
function $715c3e47e001e6ad$export$e24d85f794d5f8dd() {
    return $715c3e47e001e6ad$export$e4c9b9bae9539063($715c3e47e001e6ad$export$59799d613660a118);
}



const $bac5870904eda56a$var$allowedOrderTypes = [
    1,
    2,
    257,
    258
];
const $bac5870904eda56a$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext();
function $bac5870904eda56a$export$1d39dc5b47e56ff0() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext($bac5870904eda56a$export$a0fd8390cfe8ae69);
}
const $bac5870904eda56a$export$87091915187a1a85 = ({ children: children })=>{
    const [loading, setLoading] = (0, $gIfym.useState)(true);
    const [notifications, setNotifications] = (0, $gIfym.useState)([]);
    const [user, setUser] = (0, $gIfym.useState)();
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    (0, $gIfym.useEffect)(()=>{
        const localUser = (0, $715c3e47e001e6ad$export$e4c9b9bae9539063)((0, $715c3e47e001e6ad$export$5b9892d2b7215bc8), null);
        let data = null;
        if (localUser) {
            data = (0, $e845536d9724b5be$export$fa8cb0654f2148f2)(localUser);
            // force fetch data from api
            if (!data.bankid) data.accessTokenExpires = 0;
        }
        setUser(data);
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if (user === undefined) return false;
        if (user === null || user && Date.now() < user.accessTokenExpires) setLoading(false);
        async function validate() {
            return await validateAuth();
        }
        validate().then((res)=>{
            if (user && res === false) {
                addNotification(t("no-order-access"));
                signOut();
            }
        }).catch((e)=>{
            addNotification(t("no-order-access"));
            signOut();
        });
        if (user && user.accessLevel === 0) {
            addNotification(t("no-order-access"));
            signOut();
        }
    }, [
        user
    ]);
    const signIn = async (email, password)=>{
        try {
            const session = await (0, $b0aaffaa8d007c37$export$6cdb07c4e80969e)(email, password);
            const claims = (0, $b0aaffaa8d007c37$export$4b61618bdb99cb7e)(session.accessToken);
            const user = {
                name: claims.fenixUserName ?? "",
                email: claims.email ?? email,
                jwtToken: session.accessToken,
                refreshToken: session.refreshToken,
                accessToken: session.accessToken,
                accessTokenExpires: session.exp * 1000,
                customerIdaAccountId: parseInt(claims.customerIdaAccountId),
                customerUserName: claims.fenixUserName ?? ""
            };
            const res = await updateUser(user);
            if (res === false) throw Error(t("no-order-access"));
            return user;
        } catch (error) {
            $6VKBH.captureException(error);
            return {
                error: error.message
            };
        }
    };
    const signInBankId = async (authUser)=>{
        try {
            const user = {
                name: `${authUser.firstName} ${authUser.lastName}`,
                email: "",
                jwtToken: authUser.accessToken,
                refreshToken: authUser.refreshToken,
                accessToken: authUser.accessToken,
                accessTokenExpires: authUser.expDate,
                customerIdaAccountId: authUser.customerIdaAccountId,
                customerUserName: `${authUser.firstName} ${authUser.lastName}`,
                bankid: true
            };
            const res = await updateUser(user);
            if (res === false) {
                navigate("/signin");
                throw Error(t("no-order-access"));
            }
            return user;
        } catch (error) {
            $6VKBH.captureException(error);
            return {
                error: error.message
            };
        }
    };
    const signOut = ()=>{
        setUser(null);
        (0, $715c3e47e001e6ad$export$a3e6e3b94afefd97)((0, $715c3e47e001e6ad$export$5b9892d2b7215bc8));
        navigate("/");
    };
    const addNotification = (message, type)=>{
        setNotifications((items)=>items.concat({
                message: message,
                type: type
            }));
    };
    const updateUser = async (user)=>{
        const ordersData = await (0, $6c726320d527757b$export$a5be085772e686f9)(user).then((data)=>{
            if (data.object.length === 0) return false;
            const ord = data.object.filter((item)=>{
                return $bac5870904eda56a$var$allowedOrderTypes.includes(parseInt(item.orderType));
            });
            if (ord.length === 0) return false;
            const obj = ord[0];
            let memorial = null;
            if (obj.isMemorialPageExists) memorial = {
                firstName: obj.deceasedPersonFirstName,
                lastName: obj.deceasedPersonLastName,
                url: obj.memorialPageUrl
            };
            let assignedUser = null;
            if (obj.assignedUser) assignedUser = {
                name: obj.assignedUser.name,
                image: obj.assignedUser.profileImageThumbUrl,
                phone: obj.assignedUser.phoneNumber,
                // acuityId: 7092657,
                acuityId: obj.assignedUser.acuityUniqueId
            };
            return [
                obj.id,
                obj.caseId,
                memorial,
                obj.total,
                assignedUser,
                obj.accessLevel
            ];
        }).catch((error)=>{
            $6VKBH.captureException(error);
            addNotification(error.message);
        });
        if (!ordersData) return false;
        const [orderId, caseId, memorial, total, assignedUser, accessLevel] = ordersData;
        if (orderId) user.customerIdaOrderId = orderId;
        if (caseId) user.customerIdaCaseId = caseId;
        if (total) user.total = total;
        if (assignedUser) user.assignedUser = assignedUser;
        user.accessLevel = accessLevel;
        user.memorial = memorial;
        setUser(user);
        (0, $715c3e47e001e6ad$export$b4b6c1ec764d6e5)((0, $715c3e47e001e6ad$export$5b9892d2b7215bc8), user);
        return true;
    };
    const validateAuth = async ()=>{
        if (!user) return false;
        if (Date.now() < user.accessTokenExpires) return true;
        if (!user.refreshToken) return false;
        const session = await (0, $b0aaffaa8d007c37$export$296522b9b583854e)(user.accessToken, user.refreshToken);
        const res = await updateUser({
            ...user,
            jwtToken: session.accessToken,
            accessToken: session.accessToken,
            refreshToken: session.refreshToken,
            accessTokenExpires: session.exp * 1000
        });
        return res ?? false;
    };
    const canSubmit = ()=>{
        if (user.accessLevel === 2) return true;
        return false;
    };
    const value = {
        user: user,
        signIn: signIn,
        signInBankId: signInBankId,
        signOut: signOut,
        validateAuth: validateAuth,
        addNotification: addNotification,
        canSubmit: canSubmit
    };
    if (loading === true) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c65da64c1778b445$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)($bac5870904eda56a$export$a0fd8390cfe8ae69.Provider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $53da372dcfd86b3e$export$2e2bcd8739ae039), {
                notifications: notifications,
                onClose: ()=>setNotifications([])
            }),
            children
        ]
    });
};




var $gIfym = parcelRequire("gIfym");



function $9695464cd69251e9$export$8ef2ed426dede42d({ children: children }) {
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const loc = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    (0, $gIfym.useEffect)(()=>{
        auth.validateAuth();
    }, []);
    if (auth.user === null) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c65da64c1778b445$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$444b3ab0cb9aec40), {
                to: "/signin",
                state: {
                    from: loc
                },
                replace: true
            })
        ]
    });
    return children;
}





var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");



parcelRequire("gIfym");


let $9763e5519ca5fc60$var$logo = new URL($17323fc8ea3ee725$exports);
var $e6b15e6af7c99897$exports = {};
$e6b15e6af7c99897$exports = $parcel$resolve("2u7A5");


let $9763e5519ca5fc60$var$closeIcon = new URL($e6b15e6af7c99897$exports);
const $9763e5519ca5fc60$var$ModalFullScreen = ({ title: title, titleClass: titleClass, showLogo: showLogo, children: children, onClose: onClose })=>{
    let tClasses = "font-internormal text-white uppercase text-[12px]";
    if (titleClass) tClasses = titleClass;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "flex flex-col bg-dark-blue fixed w-full h-full z-50",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "flex items-center p-5",
                children: [
                    showLogo && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a32432afacbfa13$export$a6c7ac8248d6e38a), {
                            to: "/todo",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                src: $9763e5519ca5fc60$var$logo,
                                alt: "Fenix",
                                width: "42",
                                height: "42",
                                className: "h-fit max-w-none"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "flex flex-grow items-center",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: `w-full ${tClasses}`,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "items-center",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                            src: $9763e5519ca5fc60$var$closeIcon,
                            alt: "close",
                            width: "22",
                            height: "22",
                            className: "h-fit max-w-none cursor-pointer",
                            onClick: onClose
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "flex-grow p-5 overflow-auto",
                children: children
            })
        ]
    });
};
var $9763e5519ca5fc60$export$2e2bcd8739ae039 = $9763e5519ca5fc60$var$ModalFullScreen;



parcelRequire("gIfym");

var $b83fdea5bc39189f$exports = {};
$b83fdea5bc39189f$exports = $parcel$resolve("jgqIf");


let $4e8f7e2accfe221b$var$closeIcon = new URL($b83fdea5bc39189f$exports);
const $4e8f7e2accfe221b$var$ModalPopup = ({ title: title, children: children, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "absolute z-50 flex w-full h-full justify-center items-start",
        style: {
            backgroundColor: "rgba(0, 39, 51, .4)"
        },
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "flex justify-center pt-[5%] max-h-[90%] w-full",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "flex flex-col max-w-[90%] w-auto p-8 mx-5 bg-[#fafbfb] rounded relative drop-shadow-xl",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "self-end mb-1",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                            src: $4e8f7e2accfe221b$var$closeIcon,
                            alt: "close",
                            width: "20",
                            height: "20",
                            className: "h-fit max-w-none cursor-pointer",
                            onClick: onClose
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h1", {
                        className: "mb-6 text-center font-pprightgothic text-3xl sm:text-4xl md:text-5xl text-dark-blue px-8",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "overflow-auto",
                        children: children
                    })
                ]
            })
        })
    });
};
var $4e8f7e2accfe221b$export$2e2bcd8739ae039 = $4e8f7e2accfe221b$var$ModalPopup;


const $b136a8022cdd8440$var$Modal = (props)=>{
    const elRef = (0, $gIfym.useRef)(null);
    if (!elRef.current) elRef.current = document.createElement("div");
    (0, $gIfym.useEffect)(()=>{
        const modalRoot = document.getElementById("modal");
        modalRoot.appendChild(elRef.current);
        return ()=>modalRoot.removeChild(elRef.current);
    }, []);
    const ModalElement = (0, $e845536d9724b5be$export$471f70c09cf8ab8c)() ? (0, $4e8f7e2accfe221b$export$2e2bcd8739ae039) : (0, $9763e5519ca5fc60$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $c4a08725a78d51bf$exports.createPortal)(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(ModalElement, {
        ...props,
        children: props.children
    }), elRef.current);
};
var $b136a8022cdd8440$export$2e2bcd8739ae039 = $b136a8022cdd8440$var$Modal;




var $gIfym = parcelRequire("gIfym");





function $76e68f096da79c5e$export$2e2bcd8739ae039() {
    const [modalWidth, setModalWidth] = (0, $gIfym.useState)(0);
    const [modalHeight, setModalHeight] = (0, $gIfym.useState)(0);
    const [bookModal, setBookModal] = (0, $gIfym.useState)(false);
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    (0, $gIfym.useEffect)(()=>{
        const w = window.innerWidth;
        const h = window.innerHeight;
        const width = Math.round(parseInt(w, 10));
        let iframeWidth = width <= 768 ? width : 768;
        let k = width <= 768 ? 1 : 0.8;
        setModalWidth(iframeWidth);
        setModalHeight(Math.round(parseInt(h, 10) * k));
    }, []);
    function getAcuityUrl() {
        const names = user.customerUserName.split(" ").reduce((acc, cur)=>{
            return [
                ...acc,
                cur
            ];
        }, []);
        const firstName = names[0];
        const lastName = names[1] ?? firstName;
        const params = new URLSearchParams({
            owner: 18650906,
            // appointmentType: 35757172,
            "field:11996332": user.customerIdaCaseId,
            "field:11996333": user.jwtToken,
            "field:11996329": "Telefonm\xf6te",
            firstName: firstName,
            lastName: lastName,
            email: user.email
        });
        if (user.assignedUser.acuityId) params.set("calendarID", user.assignedUser.acuityId);
        return `https://app.acuityscheduling.com/schedule.php?${params.toString()}`;
    }
    function getPhoto() {
        if (user.assignedUser.image) return user.assignedUser.image;
        return 0, {};
    }
    const onModalShow = ()=>{
        if (auth.canSubmit() === false) {
            auth.addNotification(t("no-submit-access"));
            return false;
        }
        setBookModal(true);
    };
    const onModalClose = ()=>{
        setBookModal(false);
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: `flex flex-row rounded bg-white drop-shadow-xl ${auth.canSubmit() === false ? "opacity-40 pointer-events-none" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "rounded-tl-lg rounded-bl-lg w-[160px] h-[242px] overflow-hidden flex flex-grow justify-center",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                            className: "h-full h-full w-full object-cover",
                            src: getPhoto()
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "flex flex-col justify-between flex-grow text-center text-[#002733] p-4",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "font-interbold mt-5 mb-1 text-center leading-tight",
                                        children: user.assignedUser.name
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "text-sm mb-4",
                                        children: t("funeral-director")
                                    }),
                                    user.assignedUser.phone && user.assignedUser.phone !== "" ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "text-sm mb-4 font-interbold",
                                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                                            href: `tel:${(0, $e845536d9724b5be$export$96e99d0e61df2702)(user.assignedUser.phone)}`,
                                            children: user.assignedUser.phone
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                type: "button",
                                className: "block rounded-full text-dark-blue text-xs font-interbold py-2 px-1 mt-1 w-full uppercase bg-light-blue",
                                onClick: onModalShow,
                                disabled: auth.canSubmit() === false,
                                children: t("book-a-meeting")
                            })
                        ]
                    })
                ]
            }),
            bookModal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                title: t("bookmeeting-title-prefix", {
                    name: user.assignedUser.name
                }),
                onClose: onModalClose,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("iframe", {
                    src: getAcuityUrl(),
                    width: modalWidth,
                    height: modalHeight,
                    className: `mx-auto max-w-full max-h-full ${!(0, $e845536d9724b5be$export$471f70c09cf8ab8c)() ? "bg-white p-5" : ""}`
                })
            })
        ]
    });
}



parcelRequire("gIfym");



/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $8688143d7d85cf06$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $8688143d7d85cf06$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $8688143d7d85cf06$export$803cd8101b6c182b = /*#__PURE__*/ $8688143d7d85cf06$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $8688143d7d85cf06$export$27b07d8a310ed8b5[0], side + "-" + $8688143d7d85cf06$export$27b07d8a310ed8b5[1]), []);
const $8688143d7d85cf06$export$96ec731ed4dcb222 = Math.min;
const $8688143d7d85cf06$export$8960430cfd85939f = Math.max;
const $8688143d7d85cf06$export$2077e0241d6afd3c = Math.round;
const $8688143d7d85cf06$export$a3fe094919f356fd = Math.floor;
const $8688143d7d85cf06$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $8688143d7d85cf06$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $8688143d7d85cf06$export$7d15b64cf5a3a4c4(start, value, end) {
    return $8688143d7d85cf06$export$8960430cfd85939f(start, $8688143d7d85cf06$export$96ec731ed4dcb222(value, end));
}
function $8688143d7d85cf06$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $8688143d7d85cf06$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $8688143d7d85cf06$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $8688143d7d85cf06$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $8688143d7d85cf06$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $8688143d7d85cf06$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $8688143d7d85cf06$export$2b57e0052a6d6d4c(placement) {
    return $8688143d7d85cf06$export$8a000a963141ac32($8688143d7d85cf06$export$f28e8f882010718a(placement));
}
function $8688143d7d85cf06$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $8688143d7d85cf06$export$f0989780f32bfcda(placement);
    const alignmentAxis = $8688143d7d85cf06$export$2b57e0052a6d6d4c(placement);
    const length = $8688143d7d85cf06$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $8688143d7d85cf06$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $8688143d7d85cf06$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $8688143d7d85cf06$export$496432a3699e50b1(placement) {
    const oppositePlacement = $8688143d7d85cf06$export$9c5e28bad23365fa(placement);
    return [
        $8688143d7d85cf06$export$2b182c584985588b(placement),
        oppositePlacement,
        $8688143d7d85cf06$export$2b182c584985588b(oppositePlacement)
    ];
}
function $8688143d7d85cf06$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $8688143d7d85cf06$var$lrPlacement = [
    'left',
    'right'
];
const $8688143d7d85cf06$var$rlPlacement = [
    'right',
    'left'
];
const $8688143d7d85cf06$var$tbPlacement = [
    'top',
    'bottom'
];
const $8688143d7d85cf06$var$btPlacement = [
    'bottom',
    'top'
];
function $8688143d7d85cf06$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $8688143d7d85cf06$var$rlPlacement : $8688143d7d85cf06$var$lrPlacement;
            return isStart ? $8688143d7d85cf06$var$lrPlacement : $8688143d7d85cf06$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $8688143d7d85cf06$var$tbPlacement : $8688143d7d85cf06$var$btPlacement;
        default:
            return [];
    }
}
function $8688143d7d85cf06$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $8688143d7d85cf06$export$f0989780f32bfcda(placement);
    let list = $8688143d7d85cf06$var$getSideList($8688143d7d85cf06$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($8688143d7d85cf06$export$2b182c584985588b));
    }
    return list;
}
function $8688143d7d85cf06$export$9c5e28bad23365fa(placement) {
    const side = $8688143d7d85cf06$export$3c915306cb7fc97a(placement);
    return $8688143d7d85cf06$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $8688143d7d85cf06$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $8688143d7d85cf06$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $8688143d7d85cf06$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $8688143d7d85cf06$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $80585df3480ef0d4$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $8688143d7d85cf06$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $8688143d7d85cf06$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $8688143d7d85cf06$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $80585df3480ef0d4$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $8688143d7d85cf06$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $80585df3480ef0d4$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $80585df3480ef0d4$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $80585df3480ef0d4$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $80585df3480ef0d4$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $80585df3480ef0d4$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $80585df3480ef0d4$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $80585df3480ef0d4$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $8688143d7d85cf06$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $8688143d7d85cf06$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $8688143d7d85cf06$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $8688143d7d85cf06$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $80585df3480ef0d4$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $8688143d7d85cf06$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $80585df3480ef0d4$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $8688143d7d85cf06$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $8688143d7d85cf06$export$803cd8101b6c182b) ? $80585df3480ef0d4$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $8688143d7d85cf06$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $8688143d7d85cf06$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $8688143d7d85cf06$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $8688143d7d85cf06$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $80585df3480ef0d4$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $8688143d7d85cf06$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $8688143d7d85cf06$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $8688143d7d85cf06$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $8688143d7d85cf06$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $8688143d7d85cf06$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $8688143d7d85cf06$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $8688143d7d85cf06$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $8688143d7d85cf06$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $80585df3480ef0d4$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $80585df3480ef0d4$var$isAnySideFullyClipped(overflow) {
    return (0, $8688143d7d85cf06$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $80585df3480ef0d4$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $80585df3480ef0d4$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $80585df3480ef0d4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $80585df3480ef0d4$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $80585df3480ef0d4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $80585df3480ef0d4$var$getBoundingRect(rects) {
    const minX = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $8688143d7d85cf06$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $8688143d7d85cf06$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $80585df3480ef0d4$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $8688143d7d85cf06$export$ee05aea0aeecbad4)($80585df3480ef0d4$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $80585df3480ef0d4$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $80585df3480ef0d4$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)($80585df3480ef0d4$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $8688143d7d85cf06$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $8688143d7d85cf06$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $8688143d7d85cf06$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $80585df3480ef0d4$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $80585df3480ef0d4$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $8688143d7d85cf06$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $80585df3480ef0d4$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $80585df3480ef0d4$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $80585df3480ef0d4$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $80585df3480ef0d4$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $8688143d7d85cf06$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $8688143d7d85cf06$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $8688143d7d85cf06$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $80585df3480ef0d4$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $8688143d7d85cf06$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $8688143d7d85cf06$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $80585df3480ef0d4$var$originSides.has((0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $80585df3480ef0d4$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $8688143d7d85cf06$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $8688143d7d85cf06$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $8688143d7d85cf06$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $8688143d7d85cf06$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $8688143d7d85cf06$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $8688143d7d85cf06$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $f1bd9e3659684bee$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $f1bd9e3659684bee$export$651544f548703224(node) {
    if ($f1bd9e3659684bee$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $f1bd9e3659684bee$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $f1bd9e3659684bee$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($f1bd9e3659684bee$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $f1bd9e3659684bee$export$8ee0fc9ee280b4ee(value) {
    if (!$f1bd9e3659684bee$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $f1bd9e3659684bee$export$38b2d434cce3ea22(value).Node;
}
function $f1bd9e3659684bee$export$45a5e7f76e0caa8d(value) {
    if (!$f1bd9e3659684bee$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $f1bd9e3659684bee$export$38b2d434cce3ea22(value).Element;
}
function $f1bd9e3659684bee$export$1b3bfaa9684536aa(value) {
    if (!$f1bd9e3659684bee$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $f1bd9e3659684bee$export$38b2d434cce3ea22(value).HTMLElement;
}
function $f1bd9e3659684bee$export$af51f0f06c0f328a(value) {
    if (!$f1bd9e3659684bee$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $f1bd9e3659684bee$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $f1bd9e3659684bee$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $f1bd9e3659684bee$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $f1bd9e3659684bee$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($f1bd9e3659684bee$export$651544f548703224(element));
}
function $f1bd9e3659684bee$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $f1bd9e3659684bee$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $f1bd9e3659684bee$var$containRe = /paint|layout|strict|content/;
const $f1bd9e3659684bee$var$isNotNone = (value)=>!!value && value !== 'none';
let $f1bd9e3659684bee$var$isWebKitValue;
function $f1bd9e3659684bee$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $f1bd9e3659684bee$export$45a5e7f76e0caa8d(elementOrCss) ? $f1bd9e3659684bee$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $f1bd9e3659684bee$var$isNotNone(css.transform) || $f1bd9e3659684bee$var$isNotNone(css.translate) || $f1bd9e3659684bee$var$isNotNone(css.scale) || $f1bd9e3659684bee$var$isNotNone(css.rotate) || $f1bd9e3659684bee$var$isNotNone(css.perspective) || !$f1bd9e3659684bee$export$78551043582a6a98() && ($f1bd9e3659684bee$var$isNotNone(css.backdropFilter) || $f1bd9e3659684bee$var$isNotNone(css.filter)) || $f1bd9e3659684bee$var$willChangeRe.test(css.willChange || '') || $f1bd9e3659684bee$var$containRe.test(css.contain || '');
}
function $f1bd9e3659684bee$export$940d8225183e1404(element) {
    let currentNode = $f1bd9e3659684bee$export$4e12058fc4d51d56(element);
    while($f1bd9e3659684bee$export$1b3bfaa9684536aa(currentNode) && !$f1bd9e3659684bee$export$d1162fb0b6d4cd51(currentNode)){
        if ($f1bd9e3659684bee$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($f1bd9e3659684bee$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $f1bd9e3659684bee$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $f1bd9e3659684bee$export$78551043582a6a98() {
    if ($f1bd9e3659684bee$var$isWebKitValue == null) $f1bd9e3659684bee$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $f1bd9e3659684bee$var$isWebKitValue;
}
function $f1bd9e3659684bee$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($f1bd9e3659684bee$export$651544f548703224(node));
}
function $f1bd9e3659684bee$export$3735103072e4a80(element) {
    return $f1bd9e3659684bee$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $f1bd9e3659684bee$export$dc8fc79fa2800137(element) {
    if ($f1bd9e3659684bee$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $f1bd9e3659684bee$export$4e12058fc4d51d56(node) {
    if ($f1bd9e3659684bee$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $f1bd9e3659684bee$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $f1bd9e3659684bee$export$e495491855dc5418(node);
    return $f1bd9e3659684bee$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $f1bd9e3659684bee$export$7cd01a57c8ca906c(node) {
    const parentNode = $f1bd9e3659684bee$export$4e12058fc4d51d56(node);
    if ($f1bd9e3659684bee$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($f1bd9e3659684bee$export$1b3bfaa9684536aa(parentNode) && $f1bd9e3659684bee$export$989e911fa9af580a(parentNode)) return parentNode;
    return $f1bd9e3659684bee$export$7cd01a57c8ca906c(parentNode);
}
function $f1bd9e3659684bee$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $f1bd9e3659684bee$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $f1bd9e3659684bee$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $f1bd9e3659684bee$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $f1bd9e3659684bee$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $f1bd9e3659684bee$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $f1bd9e3659684bee$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $f1bd9e3659684bee$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $37bd3ebffd0f063b$var$getCssDimensions(element) {
    const css = (0, $f1bd9e3659684bee$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f1bd9e3659684bee$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $8688143d7d85cf06$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $8688143d7d85cf06$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $37bd3ebffd0f063b$var$unwrapElement(element) {
    return !(0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $37bd3ebffd0f063b$var$getScale(element) {
    const domElement = $37bd3ebffd0f063b$var$unwrapElement(element);
    if (!(0, $f1bd9e3659684bee$export$1b3bfaa9684536aa)(domElement)) return (0, $8688143d7d85cf06$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $37bd3ebffd0f063b$var$getCssDimensions(domElement);
    let x = ($ ? (0, $8688143d7d85cf06$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $8688143d7d85cf06$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $37bd3ebffd0f063b$var$noOffsets = /*#__PURE__*/ (0, $8688143d7d85cf06$export$a397704b5e280835)(0);
function $37bd3ebffd0f063b$var$getVisualOffsets(element) {
    const win = (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(element);
    if (!(0, $f1bd9e3659684bee$export$78551043582a6a98)() || !win.visualViewport) return $37bd3ebffd0f063b$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $37bd3ebffd0f063b$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(element);
}
function $37bd3ebffd0f063b$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $37bd3ebffd0f063b$var$unwrapElement(element);
    let scale = (0, $8688143d7d85cf06$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(offsetParent)) scale = $37bd3ebffd0f063b$var$getScale(offsetParent);
        } else scale = $37bd3ebffd0f063b$var$getScale(element);
    }
    const visualOffsets = $37bd3ebffd0f063b$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $37bd3ebffd0f063b$var$getVisualOffsets(domElement) : (0, $8688143d7d85cf06$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f1bd9e3659684bee$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $37bd3ebffd0f063b$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f1bd9e3659684bee$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $f1bd9e3659684bee$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $37bd3ebffd0f063b$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f1bd9e3659684bee$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $37bd3ebffd0f063b$var$getBoundingClientRect((0, $f1bd9e3659684bee$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $37bd3ebffd0f063b$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $37bd3ebffd0f063b$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $37bd3ebffd0f063b$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f1bd9e3659684bee$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $f1bd9e3659684bee$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $8688143d7d85cf06$export$a397704b5e280835)(1);
    const offsets = (0, $8688143d7d85cf06$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $f1bd9e3659684bee$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $f1bd9e3659684bee$export$651544f548703224)(offsetParent) !== 'body' || (0, $f1bd9e3659684bee$export$989e911fa9af580a)(documentElement)) scroll = (0, $f1bd9e3659684bee$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $37bd3ebffd0f063b$var$getBoundingClientRect(offsetParent);
            scale = $37bd3ebffd0f063b$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $37bd3ebffd0f063b$var$getHTMLOffset(documentElement, scroll) : (0, $8688143d7d85cf06$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $37bd3ebffd0f063b$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $37bd3ebffd0f063b$var$getDocumentRect(html) {
    const scroll = (0, $f1bd9e3659684bee$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $8688143d7d85cf06$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $8688143d7d85cf06$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $37bd3ebffd0f063b$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $f1bd9e3659684bee$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $8688143d7d85cf06$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $37bd3ebffd0f063b$var$SCROLLBAR_MAX = 25;
function $37bd3ebffd0f063b$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(element);
    const html = (0, $f1bd9e3659684bee$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $f1bd9e3659684bee$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $37bd3ebffd0f063b$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $37bd3ebffd0f063b$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $37bd3ebffd0f063b$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $37bd3ebffd0f063b$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $37bd3ebffd0f063b$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $37bd3ebffd0f063b$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $37bd3ebffd0f063b$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $37bd3ebffd0f063b$var$getDocumentRect((0, $f1bd9e3659684bee$export$e495491855dc5418)(element));
    else if ((0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $37bd3ebffd0f063b$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $37bd3ebffd0f063b$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $8688143d7d85cf06$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $37bd3ebffd0f063b$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f1bd9e3659684bee$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(el) && (0, $f1bd9e3659684bee$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $f1bd9e3659684bee$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f1bd9e3659684bee$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(currentNode) && !(0, $f1bd9e3659684bee$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $f1bd9e3659684bee$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $f1bd9e3659684bee$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $f1bd9e3659684bee$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $37bd3ebffd0f063b$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f1bd9e3659684bee$export$89e651af02346cd4)(element) ? [] : $37bd3ebffd0f063b$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $37bd3ebffd0f063b$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $37bd3ebffd0f063b$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $8688143d7d85cf06$export$8960430cfd85939f)(rect.top, top);
        right = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $8688143d7d85cf06$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $37bd3ebffd0f063b$var$getDimensions(element) {
    const { width: width, height: height } = $37bd3ebffd0f063b$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $37bd3ebffd0f063b$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f1bd9e3659684bee$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $f1bd9e3659684bee$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $37bd3ebffd0f063b$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $8688143d7d85cf06$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $f1bd9e3659684bee$export$651544f548703224)(offsetParent) !== 'body' || (0, $f1bd9e3659684bee$export$989e911fa9af580a)(documentElement)) scroll = (0, $f1bd9e3659684bee$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $37bd3ebffd0f063b$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $37bd3ebffd0f063b$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $37bd3ebffd0f063b$var$getHTMLOffset(documentElement, scroll) : (0, $8688143d7d85cf06$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $37bd3ebffd0f063b$var$isStaticPositioned(element) {
    return (0, $f1bd9e3659684bee$export$3735103072e4a80)(element).position === 'static';
}
function $37bd3ebffd0f063b$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f1bd9e3659684bee$export$1b3bfaa9684536aa)(element) || (0, $f1bd9e3659684bee$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f1bd9e3659684bee$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $37bd3ebffd0f063b$var$getOffsetParent(element, polyfill) {
    const win = (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(element);
    if ((0, $f1bd9e3659684bee$export$89e651af02346cd4)(element)) return win;
    if (!(0, $f1bd9e3659684bee$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $f1bd9e3659684bee$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $f1bd9e3659684bee$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $f1bd9e3659684bee$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$37bd3ebffd0f063b$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f1bd9e3659684bee$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $37bd3ebffd0f063b$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f1bd9e3659684bee$export$71535ffaa902797f)(offsetParent) && $37bd3ebffd0f063b$var$isStaticPositioned(offsetParent))offsetParent = $37bd3ebffd0f063b$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f1bd9e3659684bee$export$d1162fb0b6d4cd51)(offsetParent) && $37bd3ebffd0f063b$var$isStaticPositioned(offsetParent) && !(0, $f1bd9e3659684bee$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $f1bd9e3659684bee$export$940d8225183e1404)(element) || win;
}
const $37bd3ebffd0f063b$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $37bd3ebffd0f063b$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $37bd3ebffd0f063b$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $37bd3ebffd0f063b$var$isRTL(element) {
    return (0, $f1bd9e3659684bee$export$3735103072e4a80)(element).direction === 'rtl';
}
const $37bd3ebffd0f063b$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $37bd3ebffd0f063b$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f1bd9e3659684bee$export$e495491855dc5418,
    getClippingRect: $37bd3ebffd0f063b$var$getClippingRect,
    getOffsetParent: $37bd3ebffd0f063b$var$getOffsetParent,
    getElementRects: $37bd3ebffd0f063b$var$getElementRects,
    getClientRects: $37bd3ebffd0f063b$var$getClientRects,
    getDimensions: $37bd3ebffd0f063b$var$getDimensions,
    getScale: $37bd3ebffd0f063b$var$getScale,
    isElement: $f1bd9e3659684bee$export$45a5e7f76e0caa8d,
    isRTL: $37bd3ebffd0f063b$var$isRTL
};
function $37bd3ebffd0f063b$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $37bd3ebffd0f063b$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $f1bd9e3659684bee$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $8688143d7d85cf06$export$a3fe094919f356fd)(top);
        const insetRight = (0, $8688143d7d85cf06$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $8688143d7d85cf06$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $8688143d7d85cf06$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $8688143d7d85cf06$export$8960430cfd85939f)(0, (0, $8688143d7d85cf06$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$37bd3ebffd0f063b$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $f1bd9e3659684bee$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $37bd3ebffd0f063b$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $37bd3ebffd0f063b$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f1bd9e3659684bee$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $f1bd9e3659684bee$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $37bd3ebffd0f063b$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $37bd3ebffd0f063b$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $37bd3ebffd0f063b$var$getBoundingClientRect(reference);
        if (prevRefRect && !$37bd3ebffd0f063b$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $37bd3ebffd0f063b$export$37b6bde19b108ecc = (0, $80585df3480ef0d4$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $37bd3ebffd0f063b$export$cc800923e997bb8 = (0, $80585df3480ef0d4$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $37bd3ebffd0f063b$export$91fb6ecbd551914 = (0, $80585df3480ef0d4$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $37bd3ebffd0f063b$export$fba63a578e423eb = (0, $80585df3480ef0d4$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $37bd3ebffd0f063b$export$8a83211c878a3f1f = (0, $80585df3480ef0d4$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $37bd3ebffd0f063b$export$346677f925de839c = (0, $80585df3480ef0d4$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $37bd3ebffd0f063b$export$fe8985bb6374093c = (0, $80585df3480ef0d4$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $37bd3ebffd0f063b$export$f2120bbfa5450bd2 = (0, $80585df3480ef0d4$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $37bd3ebffd0f063b$export$18c8ad048e32c7d5 = (0, $80585df3480ef0d4$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $37bd3ebffd0f063b$export$7bf07e38f3dc4b69 = (0, $80585df3480ef0d4$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $37bd3ebffd0f063b$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$37bd3ebffd0f063b$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $80585df3480ef0d4$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $gIfym = parcelRequire("gIfym");

/**
 * A data provider that provides data to position an inner element of the
 * floating element (usually a triangle or caret) so that it is centered to the
 * reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $701476f51b3237ef$export$f2120bbfa5450bd2 = (options)=>{
    const { element: element, padding: padding } = options;
    function isRef(value) {
        return Object.prototype.hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (args) {
            if (isRef(element)) {
                if (element.current != null) return (0, $37bd3ebffd0f063b$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(args);
                return {};
            } else if (element) return (0, $37bd3ebffd0f063b$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(args);
            return {};
        }
    };
};
var $701476f51b3237ef$var$index = typeof document !== 'undefined' ? (0, $gIfym.useLayoutEffect) : (0, $gIfym.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $701476f51b3237ef$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$701476f51b3237ef$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$701476f51b3237ef$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $701476f51b3237ef$var$useLatestRef(value) {
    const ref = $gIfym.useRef(value);
    $701476f51b3237ef$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $701476f51b3237ef$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $gIfym.useState({
        x: null,
        y: null,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $gIfym.useState(middleware);
    if (!$701476f51b3237ef$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const referenceRef = $gIfym.useRef(null);
    const floatingRef = $gIfym.useRef(null);
    const dataRef = $gIfym.useRef(data);
    const whileElementsMountedRef = $701476f51b3237ef$var$useLatestRef(whileElementsMounted);
    const platformRef = $701476f51b3237ef$var$useLatestRef(platform);
    const [reference, _setReference] = $gIfym.useState(null);
    const [floating, _setFloating] = $gIfym.useState(null);
    const setReference = $gIfym.useCallback((node)=>{
        if (referenceRef.current !== node) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $gIfym.useCallback((node)=>{
        if (floatingRef.current !== node) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const update = $gIfym.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $37bd3ebffd0f063b$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$701476f51b3237ef$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $c4a08725a78d51bf$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $701476f51b3237ef$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $gIfym.useRef(false);
    $701476f51b3237ef$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $701476f51b3237ef$var$index(()=>{
        if (reference && floating) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(reference, floating, update);
            else update();
        }
    }, [
        reference,
        floating,
        update,
        whileElementsMountedRef
    ]);
    const refs = $gIfym.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $gIfym.useMemo(()=>({
            reference: reference,
            floating: floating
        }), [
        reference,
        floating
    ]);
    return $gIfym.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            reference: setReference,
            floating: setFloating
        }), [
        data,
        update,
        refs,
        elements,
        setReference,
        setFloating
    ]);
}



var $gIfym = parcelRequire("gIfym");

var $f36a135dbc76faa2$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $f36a135dbc76faa2$var$counterMap = new WeakMap();
var $f36a135dbc76faa2$var$uncontrolledNodes = new WeakMap();
var $f36a135dbc76faa2$var$markerMap = {};
var $f36a135dbc76faa2$var$lockCount = 0;
var $f36a135dbc76faa2$var$unwrapHost = function(node) {
    return node && (node.host || $f36a135dbc76faa2$var$unwrapHost(node.parentNode));
};
var $f36a135dbc76faa2$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $f36a135dbc76faa2$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $f36a135dbc76faa2$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $f36a135dbc76faa2$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$f36a135dbc76faa2$var$markerMap[markerName]) $f36a135dbc76faa2$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $f36a135dbc76faa2$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($f36a135dbc76faa2$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $f36a135dbc76faa2$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $f36a135dbc76faa2$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $f36a135dbc76faa2$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $f36a135dbc76faa2$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $f36a135dbc76faa2$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$f36a135dbc76faa2$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $f36a135dbc76faa2$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $f36a135dbc76faa2$var$lockCount--;
        if (!$f36a135dbc76faa2$var$lockCount) {
            // clear
            $f36a135dbc76faa2$var$counterMap = new WeakMap();
            $f36a135dbc76faa2$var$counterMap = new WeakMap();
            $f36a135dbc76faa2$var$uncontrolledNodes = new WeakMap();
            $f36a135dbc76faa2$var$markerMap = {};
        }
    };
};
var $f36a135dbc76faa2$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $f36a135dbc76faa2$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $f36a135dbc76faa2$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $f36a135dbc76faa2$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $f36a135dbc76faa2$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $f36a135dbc76faa2$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $f36a135dbc76faa2$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $f36a135dbc76faa2$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($f36a135dbc76faa2$export$cc95fea82d705fca() ? $f36a135dbc76faa2$export$59151cc8db999a24 : $f36a135dbc76faa2$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


var $cefae07eb29e7338$var$index = typeof document !== 'undefined' ? (0, $gIfym.useLayoutEffect) : (0, $gIfym.useEffect);
function $cefae07eb29e7338$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            map.set(event, (map.get(event) || []).filter((l)=>l !== listener));
        }
    };
}
let $cefae07eb29e7338$var$serverHandoffComplete = false;
let $cefae07eb29e7338$var$count = 0;
const $cefae07eb29e7338$var$genId = ()=>"floating-ui-" + $cefae07eb29e7338$var$count++;
function $cefae07eb29e7338$var$useFloatingId() {
    const [id, setId] = $gIfym.useState(()=>$cefae07eb29e7338$var$serverHandoffComplete ? $cefae07eb29e7338$var$genId() : undefined);
    $cefae07eb29e7338$var$index(()=>{
        if (id == null) setId($cefae07eb29e7338$var$genId());
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $gIfym.useEffect(()=>{
        if (!$cefae07eb29e7338$var$serverHandoffComplete) $cefae07eb29e7338$var$serverHandoffComplete = true;
    }, []);
    return id;
} // `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const $cefae07eb29e7338$var$useReactId = $gIfym[/*#__PURE__*/ 'useId'.toString()];
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */ const $cefae07eb29e7338$export$f680877a34711e37 = $cefae07eb29e7338$var$useReactId != null ? $cefae07eb29e7338$var$useReactId : $cefae07eb29e7338$var$useFloatingId;
const $cefae07eb29e7338$var$FloatingNodeContext = /*#__PURE__*/ $gIfym.createContext(null);
const $cefae07eb29e7338$var$FloatingTreeContext = /*#__PURE__*/ $gIfym.createContext(null);
const $cefae07eb29e7338$export$165209eae06d3488 = ()=>{
    var _React$useContext$id, _React$useContext;
    return (_React$useContext$id = (_React$useContext = $gIfym.useContext($cefae07eb29e7338$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) != null ? _React$useContext$id : null;
};
const $cefae07eb29e7338$export$db0c2a7c7a2a4f69 = ()=>$gIfym.useContext($cefae07eb29e7338$var$FloatingTreeContext);
/**
 * Registers a node into the floating tree, returning its id.
 */ const $cefae07eb29e7338$export$9b136e0e758a42f4 = ()=>{
    const id = $cefae07eb29e7338$export$f680877a34711e37();
    const tree = $cefae07eb29e7338$export$db0c2a7c7a2a4f69();
    const parentId = $cefae07eb29e7338$export$165209eae06d3488();
    $cefae07eb29e7338$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
};
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ const $cefae07eb29e7338$export$ca00a83b5b253862 = (_ref)=>{
    let { children: children, id: id } = _ref;
    const parentId = $cefae07eb29e7338$export$165209eae06d3488();
    return /*#__PURE__*/ $gIfym.createElement($cefae07eb29e7338$var$FloatingNodeContext.Provider, {
        value: $gIfym.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
};
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */ const $cefae07eb29e7338$export$587b60129641c4c8 = (_ref2)=>{
    let { children: children } = _ref2;
    const nodesRef = $gIfym.useRef([]);
    const addNode = $gIfym.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $gIfym.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $gIfym.useState(()=>$cefae07eb29e7338$var$createPubSub())[0];
    return /*#__PURE__*/ $gIfym.createElement($cefae07eb29e7338$var$FloatingTreeContext.Provider, {
        value: $gIfym.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            nodesRef,
            addNode,
            removeNode,
            events
        ])
    }, children);
};
function $cefae07eb29e7338$var$getDocument(floating) {
    var _floating$ownerDocume;
    return (_floating$ownerDocume = floating == null ? void 0 : floating.ownerDocument) != null ? _floating$ownerDocume : document;
}
function $cefae07eb29e7338$var$getWindow(value) {
    var _getDocument$defaultV;
    return (_getDocument$defaultV = $cefae07eb29e7338$var$getDocument(value).defaultView) != null ? _getDocument$defaultV : window;
}
function $cefae07eb29e7338$var$isElement(value) {
    return value ? value instanceof $cefae07eb29e7338$var$getWindow(value).Element : false;
}
function $cefae07eb29e7338$var$isHTMLElement(value) {
    return value ? value instanceof $cefae07eb29e7338$var$getWindow(value).HTMLElement : false;
}
// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const $cefae07eb29e7338$var$useInsertionEffect = $gIfym[/*#__PURE__*/ 'useInsertionEffect'.toString()];
function $cefae07eb29e7338$var$useEvent(callback) {
    const ref = $gIfym.useRef(()=>{});
    if ($cefae07eb29e7338$var$useInsertionEffect) // eslint-disable-next-line react-hooks/rules-of-hooks
    $cefae07eb29e7338$var$useInsertionEffect(()=>{
        ref.current = callback;
    });
    else ref.current = callback;
    return $gIfym.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $cefae07eb29e7338$export$4e02a5c1d08bac65(_temp) {
    let { open: open = false, onOpenChange: unstable_onOpenChange, whileElementsMounted: whileElementsMounted, placement: placement, middleware: middleware, strategy: strategy, nodeId: nodeId } = _temp === void 0 ? {} : _temp;
    const [domReference, setDomReference] = $gIfym.useState(null);
    const tree = $cefae07eb29e7338$export$db0c2a7c7a2a4f69();
    const domReferenceRef = $gIfym.useRef(null);
    const dataRef = $gIfym.useRef({});
    const events = $gIfym.useState(()=>$cefae07eb29e7338$var$createPubSub())[0];
    const position = (0, $701476f51b3237ef$export$4e02a5c1d08bac65)({
        placement: placement,
        middleware: middleware,
        strategy: strategy,
        whileElementsMounted: whileElementsMounted
    });
    const onOpenChange = $cefae07eb29e7338$var$useEvent(unstable_onOpenChange);
    const refs = $gIfym.useMemo(()=>({
            ...position.refs,
            domReference: domReferenceRef
        }), [
        position.refs
    ]);
    const context = $gIfym.useMemo(()=>({
            ...position,
            refs: refs,
            dataRef: dataRef,
            nodeId: nodeId,
            events: events,
            open: open,
            onOpenChange: onOpenChange,
            _: {
                domReference: domReference
            }
        }), [
        position,
        nodeId,
        events,
        open,
        onOpenChange,
        refs,
        domReference
    ]);
    $cefae07eb29e7338$var$index(()=>{
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    const { reference: reference } = position;
    const setReference = $gIfym.useCallback((node)=>{
        if ($cefae07eb29e7338$var$isElement(node) || node === null) {
            context.refs.domReference.current = node;
            setDomReference(node);
        }
        reference(node);
    }, [
        reference,
        context.refs
    ]);
    return $gIfym.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            reference: setReference
        }), [
        position,
        refs,
        context,
        setReference
    ]);
}
function $cefae07eb29e7338$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1
        },
        ...userProps,
        ...propsList.map((value)=>value ? value[elementKey] : null).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            (_map$get2 = map.get(key)) == null || _map$get2.forEach((fn)=>fn(...args));
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
const $cefae07eb29e7338$export$a519f7794e446ddd = function(propsList) {
    if (propsList === void 0) propsList = [];
    // The dependencies are a dynamic array, so we can't use the linter's
    // suggestion to add it to the deps array.
    const deps = propsList;
    const getReferenceProps = $gIfym.useCallback((userProps)=>$cefae07eb29e7338$var$mergeProps(userProps, propsList, 'reference'), deps);
    const getFloatingProps = $gIfym.useCallback((userProps)=>$cefae07eb29e7338$var$mergeProps(userProps, propsList, 'floating'), deps);
    const getItemProps = $gIfym.useCallback((userProps)=>$cefae07eb29e7338$var$mergeProps(userProps, propsList, 'item'), deps);
    return $gIfym.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
};
function $cefae07eb29e7338$var$getChildren(nodes, id) {
    var _nodes$filter;
    let allChildren = (_nodes$filter = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    })) != null ? _nodes$filter : [];
    let currentChildren = allChildren;
    while(currentChildren.length){
        var _nodes$filter2;
        currentChildren = (_nodes$filter2 = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        })) != null ? _nodes$filter2 : [];
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $cefae07eb29e7338$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $cefae07eb29e7338$export$7484214ab62358d2(_temp) {
    let { restMs: restMs = 0, buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = true, debug: debug = null } = _temp === void 0 ? {} : _temp;
    let timeoutId;
    let polygonIsDestroyed = false;
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, refs: refs, onClose: onClose, nodeId: nodeId, tree: tree, leave: leave = false } = _ref;
        return function onPointerMove(event) {
            var _refs$domReference$cu, _refs$floating$curren, _refs$floating$curren2;
            clearTimeout(timeoutId);
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            if (event.pointerType && event.pointerType !== 'mouse') return;
            const { clientX: clientX, clientY: clientY } = event;
            const target = 'composedPath' in event ? event.composedPath()[0] : event.target;
            const targetNode = target; // If the pointer is over the reference, there is no need to run the logic
            if (event.type === 'pointermove' && (_refs$domReference$cu = refs.domReference.current) != null && _refs$domReference$cu.contains(targetNode)) return;
             // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (event.type === 'mouseleave' && $cefae07eb29e7338$var$isElement(event.relatedTarget) && (_refs$floating$curren = refs.floating.current) != null && _refs$floating$curren.contains(event.relatedTarget)) return;
             // If any nested child is open, abort.
            if (tree && $cefae07eb29e7338$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
             // The cursor landed, so we destroy the polygon logic
            if ((_refs$floating$curren2 = refs.floating.current) != null && _refs$floating$curren2.contains(targetNode) && !leave) {
                polygonIsDestroyed = true;
                return;
            }
            if (!refs.domReference.current || !refs.floating.current || placement == null || x == null || y == null) return;
            const refRect = refs.domReference.current.getBoundingClientRect();
            const rect = refs.floating.current.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2; // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
             // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            switch(side){
                case 'top':
                    if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= refRect.top + 1) return;
                    break;
                case 'bottom':
                    if (clientX >= rect.left && clientX <= rect.right && clientY >= refRect.bottom - 1 && clientY <= rect.bottom) return;
                    break;
                case 'left':
                    if (clientX >= rect.left && clientX <= refRect.left + 1 && clientY >= rect.top && clientY <= rect.bottom) return;
                    break;
                case 'right':
                    if (clientX >= refRect.right - 1 && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) return;
                    break;
            }
            if (polygonIsDestroyed) return close();
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                const isFloatingWider = rect.width > refRect.width;
                const isFloatingTaller = rect.height > refRect.height;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            const poly = getPolygon([
                x,
                y
            ]);
            if (!$cefae07eb29e7338$var$isPointInPolygon([
                clientX,
                clientY
            ], poly)) close();
            else if (restMs) timeoutId = setTimeout(onClose, restMs);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}
const $cefae07eb29e7338$var$DEFAULT_ID = 'floating-ui-root';
const $cefae07eb29e7338$export$ac107512f3c5cca6 = function(_temp) {
    let { id: id = $cefae07eb29e7338$var$DEFAULT_ID, enabled: enabled = true } = _temp === void 0 ? {} : _temp;
    const [portalEl, setPortalEl] = $gIfym.useState(null);
    $cefae07eb29e7338$var$index(()=>{
        if (!enabled) return;
        const rootNode = document.getElementById(id);
        if (rootNode) setPortalEl(rootNode);
        else {
            const newPortalEl = document.createElement('div');
            newPortalEl.id = id;
            setPortalEl(newPortalEl);
            if (!document.body.contains(newPortalEl)) document.body.appendChild(newPortalEl);
        }
    }, [
        id,
        enabled
    ]);
    return portalEl;
};
/**
 * Portals your floating element outside of the main app node.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ const $cefae07eb29e7338$export$31fa5d718fa2ac09 = (_ref)=>{
    let { children: children, id: id = $cefae07eb29e7338$var$DEFAULT_ID, root: root = null } = _ref;
    const portalNode = $cefae07eb29e7338$export$ac107512f3c5cca6({
        id: id,
        enabled: !root
    });
    if (root) return /*#__PURE__*/ (0, $c4a08725a78d51bf$exports.createPortal)(children, root);
    if (portalNode) return /*#__PURE__*/ (0, $c4a08725a78d51bf$exports.createPortal)(children, portalNode);
    return null;
};
function $cefae07eb29e7338$var$_extends() {
    $cefae07eb29e7338$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cefae07eb29e7338$var$_extends.apply(this, arguments);
}
// Avoid Chrome DevTools blue warning
function $cefae07eb29e7338$var$getPlatform() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $cefae07eb29e7338$var$getUserAgent() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
const $cefae07eb29e7338$var$identifier = 'data-floating-ui-scroll-lock';
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $cefae07eb29e7338$export$a35954495955337b = /*#__PURE__*/ $gIfym.forwardRef(function FloatingOverlay(_ref, ref) {
    let { lockScroll: lockScroll = false, ...rest } = _ref;
    $cefae07eb29e7338$var$index(()=>{
        var _window$visualViewpor, _window$visualViewpor2, _window$visualViewpor3, _window$visualViewpor4;
        if (!lockScroll) return;
        const alreadyLocked = document.body.hasAttribute($cefae07eb29e7338$var$identifier);
        if (alreadyLocked) return;
        document.body.setAttribute($cefae07eb29e7338$var$identifier, ''); // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth; // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (!/iP(hone|ad|od)|iOS/.test($cefae07eb29e7338$var$getPlatform())) {
            Object.assign(document.body.style, {
                overflow: 'hidden',
                [paddingProp]: scrollbarWidth + "px"
            });
            return ()=>{
                document.body.removeAttribute($cefae07eb29e7338$var$identifier);
                Object.assign(document.body.style, {
                    overflow: '',
                    [paddingProp]: ''
                });
            };
        } // iOS 12 does not support `visuaViewport`.
        const offsetLeft = (_window$visualViewpor = (_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetLeft) != null ? _window$visualViewpor : 0;
        const offsetTop = (_window$visualViewpor3 = (_window$visualViewpor4 = window.visualViewport) == null ? void 0 : _window$visualViewpor4.offsetTop) != null ? _window$visualViewpor3 : 0;
        const scrollX = window.pageXOffset;
        const scrollY = window.pageYOffset;
        Object.assign(document.body.style, {
            position: 'fixed',
            overflow: 'hidden',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0',
            [paddingProp]: scrollbarWidth + "px"
        });
        return ()=>{
            Object.assign(document.body.style, {
                position: '',
                overflow: '',
                top: '',
                left: '',
                right: '',
                [paddingProp]: ''
            });
            document.body.removeAttribute($cefae07eb29e7338$var$identifier);
            window.scrollTo(scrollX, scrollY);
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $gIfym.createElement("div", $cefae07eb29e7338$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
/**
 * Find the real active element. Traverses into shadowRoots.
 */ function $cefae07eb29e7338$var$activeElement(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null){
        var _activeElement, _activeElement$shadow;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $cefae07eb29e7338$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $cefae07eb29e7338$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
     // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $cefae07eb29e7338$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $cefae07eb29e7338$var$isTypeableElement(element) {
    return $cefae07eb29e7338$var$isHTMLElement(element) && element.matches($cefae07eb29e7338$var$TYPEABLE_SELECTOR);
}
function $cefae07eb29e7338$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $cefae07eb29e7338$var$useLatestRef(value) {
    const ref = (0, $gIfym.useRef)(value);
    $cefae07eb29e7338$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
function $cefae07eb29e7338$var$focus(el, preventScroll) {
    if (preventScroll === void 0) preventScroll = false;
    // `mousedown` clicks occur before `focus`, so the button will steal the
    // focus unless we wait a frame.
    requestAnimationFrame(()=>{
        el == null || el.focus({
            preventScroll: preventScroll
        });
    });
}
const $cefae07eb29e7338$var$SELECTOR = "select:not([disabled]),a[href],button:not([disabled]),[tabindex],iframe,object,embed,area[href],audio[controls],video[controls]," + $cefae07eb29e7338$var$TYPEABLE_SELECTOR;
const $cefae07eb29e7338$var$FocusGuard = /*#__PURE__*/ $gIfym.forwardRef(function FocusGuard(props, ref) {
    return /*#__PURE__*/ $gIfym.createElement("span", $cefae07eb29e7338$var$_extends({}, props, {
        ref: ref,
        tabIndex: 0,
        style: {
            position: 'fixed',
            opacity: '0',
            pointerEvents: 'none',
            outline: '0'
        }
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $cefae07eb29e7338$export$8aeee49171ded61a(_ref) {
    let { context: { refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, dataRef: dataRef, events: events }, children: children, order: order = [
        'content'
    ], endGuard: endGuard = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, modal: modal = true } = _ref;
    const orderRef = $cefae07eb29e7338$var$useLatestRef(order);
    const tree = $cefae07eb29e7338$export$db0c2a7c7a2a4f69();
    const getTabbableElements = $gIfym.useCallback(()=>{
        return orderRef.current.map((type)=>{
            if (type === 'reference') return refs.domReference.current;
            if (refs.floating.current && type === 'floating') return refs.floating.current;
            if (type === 'content') {
                var _refs$floating$curren, _refs$floating$curren2;
                return Array.from((_refs$floating$curren = (_refs$floating$curren2 = refs.floating.current) == null ? void 0 : _refs$floating$curren2.querySelectorAll($cefae07eb29e7338$var$SELECTOR)) != null ? _refs$floating$curren : []);
            }
            return null;
        }).flat().filter((el)=>{
            if (el === refs.floating.current || el === refs.domReference.current) return true;
            if ($cefae07eb29e7338$var$isHTMLElement(el)) {
                var _el$getAttribute;
                const tabIndex = (_el$getAttribute = el.getAttribute('tabindex')) != null ? _el$getAttribute : '0';
                return tabIndex[0].trim() !== '-';
            }
        });
    }, [
        orderRef,
        refs
    ]);
    $gIfym.useEffect(()=>{
        if (!modal) return;
         // If the floating element has no focusable elements inside it, fallback
        // to focusing the floating element and preventing tab navigation
        const noTabbableContentElements = getTabbableElements().filter((el)=>el !== refs.floating.current && el !== refs.domReference.current).length === 0;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                if (noTabbableContentElements) $cefae07eb29e7338$var$stopEvent(event);
                const els = getTabbableElements();
                const target = $cefae07eb29e7338$var$getTarget(event);
                if (orderRef.current[0] === 'reference' && target === refs.domReference.current) {
                    $cefae07eb29e7338$var$stopEvent(event);
                    if (event.shiftKey) $cefae07eb29e7338$var$focus(els[els.length - 1]);
                    else $cefae07eb29e7338$var$focus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === refs.floating.current && event.shiftKey) {
                    $cefae07eb29e7338$var$stopEvent(event);
                    $cefae07eb29e7338$var$focus(els[0]);
                }
            }
        }
        const doc = $cefae07eb29e7338$var$getDocument(refs.floating.current);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        modal,
        getTabbableElements,
        orderRef,
        refs
    ]);
    $gIfym.useEffect(()=>{
        let isPointerDown = false;
        function onFocusOut(event) {
            var _refs$floating$curren3, _getAncestors;
            const relatedTarget = event.relatedTarget;
            const focusMovedOutsideFloating = !((_refs$floating$curren3 = refs.floating.current) != null && _refs$floating$curren3.contains(relatedTarget));
            const focusMovedOutsideReference = $cefae07eb29e7338$var$isElement(refs.domReference.current) && !refs.domReference.current.contains(relatedTarget);
            const isChildOpen = tree && $cefae07eb29e7338$var$getChildren(tree.nodesRef.current, nodeId).length > 0;
            const isParentRelated = tree && event.currentTarget === refs.domReference.current && ((_getAncestors = $cefae07eb29e7338$var$getAncestors(tree.nodesRef.current, nodeId)) == null ? void 0 : _getAncestors.some((node)=>{
                var _node$context, _node$context$refs$fl;
                return (_node$context = node.context) == null ? void 0 : (_node$context$refs$fl = _node$context.refs.floating.current) == null ? void 0 : _node$context$refs$fl.contains(relatedTarget);
            }));
            if (focusMovedOutsideFloating && focusMovedOutsideReference && !isChildOpen && !isParentRelated && !isPointerDown) onOpenChange(false);
        }
        function onPointerDown() {
            // In Safari, buttons *lose* focus when pressing them. This causes the
            // reference `focusout` to fire, which closes the floating element.
            isPointerDown = true;
            setTimeout(()=>{
                isPointerDown = false;
            });
        }
        const floating = refs.floating.current;
        const reference = refs.domReference.current;
        if (floating && $cefae07eb29e7338$var$isHTMLElement(reference)) {
            if (!modal) {
                floating.addEventListener('focusout', onFocusOut);
                reference.addEventListener('focusout', onFocusOut);
                reference.addEventListener('pointerdown', onPointerDown);
            }
            let cleanup;
            if (modal) {
                if (orderRef.current.includes('reference')) cleanup = (0, $f36a135dbc76faa2$export$6e33d16126ed003c)([
                    reference,
                    floating
                ]);
                else cleanup = (0, $f36a135dbc76faa2$export$6e33d16126ed003c)(floating);
            }
            return ()=>{
                if (!modal) {
                    floating.removeEventListener('focusout', onFocusOut);
                    reference.removeEventListener('focusout', onFocusOut);
                    reference.removeEventListener('pointerdown', onPointerDown);
                }
                cleanup == null || cleanup();
            };
        }
    }, [
        nodeId,
        tree,
        modal,
        onOpenChange,
        orderRef,
        dataRef,
        getTabbableElements,
        refs
    ]);
    $gIfym.useEffect(()=>{
        const floating = refs.floating.current;
        const doc = $cefae07eb29e7338$var$getDocument(floating);
        let returnFocusValue = returnFocus;
        let preventReturnFocusScroll = false;
        let previouslyFocusedElement = $cefae07eb29e7338$var$activeElement(doc);
        if (previouslyFocusedElement === doc.body && refs.domReference.current) previouslyFocusedElement = refs.domReference.current;
        if (typeof initialFocus === 'number') {
            var _getTabbableElements$;
            const el = (_getTabbableElements$ = getTabbableElements()[initialFocus]) != null ? _getTabbableElements$ : floating;
            $cefae07eb29e7338$var$focus(el, el === floating);
        } else if ($cefae07eb29e7338$var$isHTMLElement(initialFocus.current)) {
            var _initialFocus$current;
            const el = (_initialFocus$current = initialFocus.current) != null ? _initialFocus$current : floating;
            $cefae07eb29e7338$var$focus(el, el === floating);
        } // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onDismiss(allowReturnFocus) {
            if (allowReturnFocus === void 0) allowReturnFocus = false;
            if (typeof allowReturnFocus === 'object') {
                returnFocusValue = true;
                preventReturnFocusScroll = allowReturnFocus.preventScroll;
            } else returnFocusValue = allowReturnFocus;
        }
        events.on('dismiss', onDismiss);
        return ()=>{
            events.off('dismiss', onDismiss);
            if (returnFocusValue && $cefae07eb29e7338$var$isHTMLElement(previouslyFocusedElement)) $cefae07eb29e7338$var$focus(previouslyFocusedElement, preventReturnFocusScroll);
        };
    }, [
        getTabbableElements,
        initialFocus,
        returnFocus,
        refs,
        events
    ]);
    const isTypeableCombobox = ()=>{
        var _refs$domReference$cu;
        return ((_refs$domReference$cu = refs.domReference.current) == null ? void 0 : _refs$domReference$cu.getAttribute('role')) === 'combobox' && $cefae07eb29e7338$var$isTypeableElement(refs.domReference.current);
    };
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, modal && /*#__PURE__*/ $gIfym.createElement($cefae07eb29e7338$var$FocusGuard, {
        onFocus: (event)=>{
            if (isTypeableCombobox()) return;
            $cefae07eb29e7338$var$stopEvent(event);
            const els = getTabbableElements();
            if (order[0] === 'reference') $cefae07eb29e7338$var$focus(els[0]);
            else $cefae07eb29e7338$var$focus(els[els.length - 1]);
        }
    }), /*#__PURE__*/ $gIfym.cloneElement(children, order.includes('floating') ? {
        tabIndex: 0
    } : {}), modal && endGuard && /*#__PURE__*/ $gIfym.createElement($cefae07eb29e7338$var$FocusGuard, {
        onFocus: (event)=>{
            if (isTypeableCombobox()) return;
            $cefae07eb29e7338$var$stopEvent(event);
            $cefae07eb29e7338$var$focus(getTabbableElements()[0]);
        }
    }));
}
function $cefae07eb29e7338$var$usePrevious(value) {
    const ref = (0, $gIfym.useRef)();
    $cefae07eb29e7338$var$index(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
function $cefae07eb29e7338$var$getDelay(value, prop, pointerType) {
    if (pointerType && pointerType !== 'mouse') return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Adds hover event listeners that change the open state, like CSS :hover.
 * @see https://floating-ui.com/docs/useHover
 */ const $cefae07eb29e7338$export$ae780daf29e6d456 = function(context, _temp) {
    let { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = _temp === void 0 ? {} : _temp;
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, refs: refs, _: _ } = context;
    const tree = $cefae07eb29e7338$export$db0c2a7c7a2a4f69();
    const parentId = $cefae07eb29e7338$export$165209eae06d3488();
    const handleCloseRef = $cefae07eb29e7338$var$useLatestRef(handleClose);
    const delayRef = $cefae07eb29e7338$var$useLatestRef(delay);
    const previousOpen = $cefae07eb29e7338$var$usePrevious(open);
    const pointerTypeRef = $gIfym.useRef();
    const timeoutRef = $gIfym.useRef();
    const handlerRef = $gIfym.useRef();
    const restTimeoutRef = $gIfym.useRef();
    const blockMouseMoveRef = $gIfym.useRef(true);
    const performedPointerEventsMutationRef = $gIfym.useRef(false);
    const isHoverOpen = $gIfym.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    $gIfym.useEffect(()=>{
        if (!enabled) return;
        function onDismiss() {
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            blockMouseMoveRef.current = true;
        }
        events.on('dismiss', onDismiss);
        return ()=>{
            events.off('dismiss', onDismiss);
        };
    }, [
        enabled,
        events,
        refs
    ]);
    $gIfym.useEffect(()=>{
        if (!enabled || !handleCloseRef.current) return;
        function onLeave() {
            if (isHoverOpen()) onOpenChange(false);
        }
        const html = $cefae07eb29e7338$var$getDocument(refs.floating.current).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        refs,
        onOpenChange,
        enabled,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    const closeWithDelay = $gIfym.useCallback(function(runElseBranch) {
        if (runElseBranch === void 0) runElseBranch = true;
        const closeDelay = $cefae07eb29e7338$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>onOpenChange(false), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupPointerMoveHandler = $gIfym.useCallback(()=>{
        if (handlerRef.current) {
            $cefae07eb29e7338$var$getDocument(refs.floating.current).removeEventListener('pointermove', handlerRef.current);
            handlerRef.current = undefined;
        }
    }, [
        refs
    ]);
    const clearPointerEvents = $gIfym.useCallback(()=>{
        $cefae07eb29e7338$var$getDocument(refs.floating.current).body.style.pointerEvents = '';
        performedPointerEventsMutationRef.current = false;
    }, [
        refs
    ]); // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $gIfym.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                'click',
                'mousedown'
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && pointerTypeRef.current !== 'mouse' || restMs > 0 && $cefae07eb29e7338$var$getDelay(delayRef.current, 'open') === 0) return;
            dataRef.current.openEvent = event;
            const openDelay = $cefae07eb29e7338$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = setTimeout(()=>{
                onOpenChange(true);
            }, openDelay);
            else onOpenChange(true);
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            const doc = $cefae07eb29e7338$var$getDocument(refs.floating.current);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current) {
                clearTimeout(timeoutRef.current);
                handlerRef.current && doc.removeEventListener('pointermove', handlerRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...context,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupPointerMoveHandler();
                        closeWithDelay();
                    }
                });
                doc.addEventListener('pointermove', handlerRef.current);
                return;
            }
            closeWithDelay();
        } // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...context,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                leave: true,
                onClose () {
                    clearPointerEvents();
                    cleanupPointerMoveHandler();
                    closeWithDelay();
                }
            })(event);
        }
        const floating = refs.floating.current;
        const reference = refs.domReference.current;
        if ($cefae07eb29e7338$var$isElement(reference)) {
            open && reference.addEventListener('mouseleave', onScrollMouseLeave);
            floating == null || floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && reference.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onMouseEnter);
            reference.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                open && reference.removeEventListener('mouseleave', onScrollMouseLeave);
                floating == null || floating.removeEventListener('mouseleave', onScrollMouseLeave);
                move && reference.removeEventListener('mousemove', onMouseEnter);
                reference.removeEventListener('mouseenter', onMouseEnter);
                reference.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        // https://github.com/floating-ui/floating-ui/issues/1833
        _.domReference,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupPointerMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        tree,
        refs,
        delayRef,
        handleCloseRef,
        dataRef
    ]); // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $cefae07eb29e7338$var$index(()=>{
        if (!enabled) return;
        if (open && handleCloseRef.current && handleCloseRef.current.__options.blockPointerEvents && isHoverOpen()) {
            $cefae07eb29e7338$var$getDocument(refs.floating.current).body.style.pointerEvents = 'none';
            performedPointerEventsMutationRef.current = true;
            const reference = refs.domReference.current;
            const floating = refs.floating.current;
            if ($cefae07eb29e7338$var$isElement(reference) && floating) {
                var _tree$nodesRef$curren, _tree$nodesRef$curren2;
                const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.refs.floating.current;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                reference.style.pointerEvents = 'auto';
                floating.style.pointerEvents = 'auto';
                return ()=>{
                    reference.style.pointerEvents = '';
                    floating.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        refs,
        tree,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    $cefae07eb29e7338$var$index(()=>{
        if (previousOpen && !open) {
            pointerTypeRef.current = undefined;
            cleanupPointerMoveHandler();
            clearPointerEvents();
        }
    });
    $gIfym.useEffect(()=>{
        return ()=>{
            cleanupPointerMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            if (performedPointerEventsMutationRef.current) clearPointerEvents();
        };
    }, [
        enabled,
        cleanupPointerMoveHandler,
        clearPointerEvents
    ]);
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            reference: {
                onPointerDown: setPointerRef,
                onPointerEnter: setPointerRef,
                onMouseMove () {
                    if (open || restMs === 0) return;
                    clearTimeout(restTimeoutRef.current);
                    restTimeoutRef.current = setTimeout(()=>{
                        if (!blockMouseMoveRef.current) onOpenChange(true);
                    }, restMs);
                }
            },
            floating: {
                onMouseEnter () {
                    clearTimeout(timeoutRef.current);
                },
                onMouseLeave () {
                    closeWithDelay(false);
                }
            }
        };
    }, [
        enabled,
        restMs,
        open,
        onOpenChange,
        closeWithDelay
    ]);
};
const $cefae07eb29e7338$var$FloatingDelayGroupContext = /*#__PURE__*/ $gIfym.createContext({
    delay: 1000,
    initialDelay: 1000,
    currentId: null,
    setCurrentId: ()=>{},
    setState: ()=>{}
});
const $cefae07eb29e7338$export$e2411914b150383d = ()=>$gIfym.useContext($cefae07eb29e7338$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ const $cefae07eb29e7338$export$718279509ff1e241 = (_ref)=>{
    let { children: children, delay: delay } = _ref;
    const [state, setState] = $gIfym.useState({
        delay: delay,
        initialDelay: delay,
        currentId: null
    });
    const setCurrentId = $gIfym.useCallback((currentId)=>{
        setState((state)=>({
                ...state,
                currentId: currentId
            }));
    }, []);
    return /*#__PURE__*/ $gIfym.createElement($cefae07eb29e7338$var$FloatingDelayGroupContext.Provider, {
        value: $gIfym.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setState,
            setCurrentId
        ])
    }, children);
};
const $cefae07eb29e7338$export$560fc8be89c8b4a8 = (_ref2, _ref3)=>{
    let { open: open, onOpenChange: onOpenChange } = _ref2;
    let { id: id } = _ref3;
    const { currentId: currentId, initialDelay: initialDelay, setState: setState } = $cefae07eb29e7338$export$e2411914b150383d();
    $gIfym.useEffect(()=>{
        if (currentId) {
            setState((state)=>({
                    ...state,
                    delay: {
                        open: 1,
                        close: $cefae07eb29e7338$var$getDelay(initialDelay, 'close')
                    }
                }));
            if (currentId !== id) onOpenChange(false);
        }
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $gIfym.useEffect(()=>{
        if (!open && currentId === id) {
            onOpenChange(false);
            setState((state)=>({
                    ...state,
                    delay: initialDelay,
                    currentId: null
                }));
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay
    ]);
};
function $cefae07eb29e7338$var$getArgsWithCustomFloatingHeight(args, prop) {
    return {
        ...args,
        rects: {
            ...args.rects,
            floating: {
                ...args.rects.floating,
                height: args.elements.floating[prop]
            }
        }
    };
}
const $cefae07eb29e7338$export$4ae363f1d88fb658 = (options)=>({
        name: 'inner',
        options: options,
        async fn (middlewareArguments) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, ...detectOverflowOptions } = options;
            const { rects: rects, elements: { floating: floating } } = middlewareArguments;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...middlewareArguments,
                ...await (0, $37bd3ebffd0f063b$export$cc800923e997bb8)(-item.offsetTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(middlewareArguments)
            };
            const overflow = await (0, $37bd3ebffd0f063b$export$37b6bde19b108ecc)($cefae07eb29e7338$var$getArgsWithCustomFloatingHeight(nextArgs, 'scrollHeight'), detectOverflowOptions);
            const refOverflow = await (0, $37bd3ebffd0f063b$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, floating.scrollHeight - diffY - Math.max(0, overflow.bottom));
            floating.style.maxHeight = maxHeight + "px";
            floating.scrollTop = diffY; // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (floating.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) (0, $c4a08725a78d51bf$exports.flushSync)(()=>onFallbackChange(true));
                else (0, $c4a08725a78d51bf$exports.flushSync)(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $37bd3ebffd0f063b$export$37b6bde19b108ecc)($cefae07eb29e7338$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, 'offsetHeight'), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
const $cefae07eb29e7338$export$3d74b0dda7cc82ff = (_ref, _ref2)=>{
    let { open: open, refs: refs } = _ref;
    let { enabled: enabled = true, overflowRef: overflowRef, onChange: unstable_onChange } = _ref2;
    const onChange = $cefae07eb29e7338$var$useEvent(unstable_onChange);
    const controlledScrollingRef = $gIfym.useRef(false);
    const prevScrollTopRef = $gIfym.useRef(null);
    const initialOverflowRef = $gIfym.useRef(null);
    $gIfym.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                (0, $c4a08725a78d51bf$exports.flushSync)(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test($cefae07eb29e7338$var$getUserAgent())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = refs.floating.current;
        if (open && el) {
            el.addEventListener('wheel', onWheel); // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        refs,
        overflowRef,
        onChange
    ]);
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        return {
            floating: {
                onKeyDown () {
                    controlledScrollingRef.current = true;
                },
                onWheel () {
                    controlledScrollingRef.current = false;
                },
                onPointerMove () {
                    controlledScrollingRef.current = false;
                },
                onScroll () {
                    const el = refs.floating.current;
                    if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                    if (prevScrollTopRef.current !== null) {
                        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) (0, $c4a08725a78d51bf$exports.flushSync)(()=>onChange((d)=>d + scrollDiff));
                    } // [Firefox] Wait for the height change to have been applied.
                    requestAnimationFrame(()=>{
                        prevScrollTopRef.current = el.scrollTop;
                    });
                }
            }
        };
    }, [
        enabled,
        overflowRef,
        refs,
        onChange
    ]);
};
/**
 * Adds relevant screen reader props for a given element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ const $cefae07eb29e7338$export$f66572793fa256a1 = function(_ref, _temp) {
    let { open: open } = _ref;
    let { enabled: enabled = true, role: role = 'dialog' } = _temp === void 0 ? {} : _temp;
    const rootId = $cefae07eb29e7338$export$f680877a34711e37();
    const referenceId = $cefae07eb29e7338$export$f680877a34711e37();
    return $gIfym.useMemo(()=>{
        const floatingProps = {
            id: rootId,
            role: role
        };
        if (!enabled) return {};
        if (role === 'tooltip') return {
            reference: {
                'aria-describedby': open ? rootId : undefined
            },
            floating: floatingProps
        };
        return {
            reference: {
                'aria-expanded': open ? 'true' : 'false',
                'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
                'aria-controls': open ? rootId : undefined,
                ...role === 'listbox' && {
                    role: 'combobox'
                },
                ...role === 'menu' && {
                    id: referenceId
                }
            },
            floating: {
                ...floatingProps,
                ...role === 'menu' && {
                    'aria-labelledby': referenceId
                }
            }
        };
    }, [
        enabled,
        role,
        open,
        rootId,
        referenceId
    ]);
};
function $cefae07eb29e7338$var$isButtonTarget(event) {
    return $cefae07eb29e7338$var$isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function $cefae07eb29e7338$var$isSpaceIgnored(element) {
    return $cefae07eb29e7338$var$isTypeableElement(element);
}
/**
 * Adds click event listeners that change the open state.
 * @see https://floating-ui.com/docs/useClick
 */ const $cefae07eb29e7338$export$98524f11226063fc = function(_ref, _temp) {
    let { open: open, onOpenChange: onOpenChange, dataRef: dataRef, refs: refs } = _ref;
    let { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = _temp === void 0 ? {} : _temp;
    const pointerTypeRef = $gIfym.useRef();
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    pointerTypeRef.current = event.pointerType;
                },
                onMouseDown (event) {
                    // Ignore all buttons except for the "main" button.
                    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                    if (event.button !== 0) return;
                    if (pointerTypeRef.current === 'mouse' && ignoreMouse) return;
                    if (eventOption === 'click') return;
                    if (open) {
                        if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false);
                    } else onOpenChange(true);
                    dataRef.current.openEvent = event.nativeEvent;
                },
                onClick (event) {
                    if (eventOption === 'mousedown' && pointerTypeRef.current) {
                        pointerTypeRef.current = undefined;
                        return;
                    }
                    if (pointerTypeRef.current === 'mouse' && ignoreMouse) return;
                    if (open) {
                        if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false);
                    } else onOpenChange(true);
                    dataRef.current.openEvent = event.nativeEvent;
                },
                onKeyDown (event) {
                    pointerTypeRef.current = undefined;
                    if (!keyboardHandlers) return;
                    if ($cefae07eb29e7338$var$isButtonTarget(event)) return;
                    if (event.key === ' ' && !$cefae07eb29e7338$var$isSpaceIgnored(refs.domReference.current)) // Prvent scrolling
                    event.preventDefault();
                    if (event.key === 'Enter') {
                        if (open) {
                            if (toggle) onOpenChange(false);
                        } else onOpenChange(true);
                    }
                },
                onKeyUp (event) {
                    if (!keyboardHandlers) return;
                    if ($cefae07eb29e7338$var$isButtonTarget(event) || $cefae07eb29e7338$var$isSpaceIgnored(refs.domReference.current)) return;
                    if (event.key === ' ') {
                        if (open) {
                            if (toggle) onOpenChange(false);
                        } else onOpenChange(true);
                    }
                }
            }
        };
    }, [
        enabled,
        dataRef,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        refs,
        toggle,
        open,
        onOpenChange
    ]);
};
/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */ function $cefae07eb29e7338$var$isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
     // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
const $cefae07eb29e7338$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $cefae07eb29e7338$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
/**
 * Adds listeners that dismiss (close) the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ const $cefae07eb29e7338$export$fcdf1ba5fafc089b = function(_ref, _temp) {
    let { open: open, onOpenChange: onOpenChange, refs: refs, events: events, nodeId: nodeId } = _ref;
    let { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles = true } = _temp === void 0 ? {} : _temp;
    const tree = $cefae07eb29e7338$export$db0c2a7c7a2a4f69();
    const nested = $cefae07eb29e7338$export$165209eae06d3488() != null;
    const insideReactTreeRef = $gIfym.useRef(false);
    $gIfym.useEffect(()=>{
        if (!open || !enabled) return;
        function onKeyDown(event) {
            if (event.key === 'Escape') {
                if (!bubbles && tree && $cefae07eb29e7338$var$getChildren(tree.nodesRef.current, nodeId).length > 0) return;
                events.emit('dismiss', {
                    preventScroll: false
                });
                onOpenChange(false);
            }
        }
        function onOutsidePress(event) {
            // Given developers can stop the propagation of the synthetic event,
            // we can only be confident with a positive value.
            const insideReactTree = insideReactTreeRef.current;
            insideReactTreeRef.current = false;
            if (insideReactTree) return;
            const target = $cefae07eb29e7338$var$getTarget(event); // Check if the click occurred on the scrollbar
            if ($cefae07eb29e7338$var$isElement(target) && refs.floating.current) {
                var _refs$floating$curren;
                const win = (_refs$floating$curren = refs.floating.current.ownerDocument.defaultView) != null ? _refs$floating$curren : window;
                const canScrollX = target.scrollWidth > target.clientWidth;
                const canScrollY = target.scrollHeight > target.clientHeight;
                let xCond = canScrollY && event.offsetX > target.clientWidth; // In some browsers it is possible to change the <body> (or window)
                // scrollbar to the left side, but is very rare and is difficult to
                // check for. Plus, for modal dialogs with backdrops, it is more
                // important that the backdrop is checked but not so much the window.
                if (canScrollY) {
                    const isRTL = win.getComputedStyle(target).direction === 'rtl';
                    if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
                }
                if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
            }
            const targetIsInsideChildren = tree && $cefae07eb29e7338$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context;
                return $cefae07eb29e7338$var$isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.refs.floating.current);
            });
            if ($cefae07eb29e7338$var$isEventTargetWithin(event, refs.floating.current) || $cefae07eb29e7338$var$isEventTargetWithin(event, refs.domReference.current) || targetIsInsideChildren) return;
            if (!bubbles && tree && $cefae07eb29e7338$var$getChildren(tree.nodesRef.current, nodeId).length > 0) return;
            events.emit('dismiss', nested ? {
                preventScroll: true
            } : false);
            onOpenChange(false);
        }
        function onScroll() {
            onOpenChange(false);
        }
        const doc = $cefae07eb29e7338$var$getDocument(refs.floating.current);
        escapeKey && doc.addEventListener('keydown', onKeyDown);
        outsidePress && doc.addEventListener(outsidePressEvent, onOutsidePress);
        let ancestors = [];
        if (ancestorScroll) {
            if ($cefae07eb29e7338$var$isElement(refs.domReference.current)) ancestors = (0, $f1bd9e3659684bee$export$3b57c1601291186b)(refs.domReference.current);
            if ($cefae07eb29e7338$var$isElement(refs.floating.current)) ancestors = ancestors.concat((0, $f1bd9e3659684bee$export$3b57c1601291186b)(refs.floating.current));
            if (!$cefae07eb29e7338$var$isElement(refs.reference.current) && refs.reference.current && // @ts-expect-error is VirtualElement
            refs.reference.current.contextElement) ancestors = ancestors.concat((0, $f1bd9e3659684bee$export$3b57c1601291186b)(refs.reference.current.contextElement));
        } // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener('keydown', onKeyDown);
            outsidePress && doc.removeEventListener(outsidePressEvent, onOutsidePress);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
        };
    }, [
        escapeKey,
        outsidePress,
        outsidePressEvent,
        events,
        tree,
        nodeId,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        bubbles,
        refs,
        nested
    ]);
    $gIfym.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                [$cefae07eb29e7338$var$bubbleHandlerKeys[referencePressEvent]]: ()=>{
                    if (referencePress) {
                        events.emit('dismiss');
                        onOpenChange(false);
                    }
                }
            },
            floating: {
                [$cefae07eb29e7338$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                    insideReactTreeRef.current = true;
                }
            }
        };
    }, [
        enabled,
        events,
        referencePress,
        outsidePressEvent,
        referencePressEvent,
        onOpenChange
    ]);
};
/**
 * Adds focus event listeners that change the open state, like CSS :focus.
 * @see https://floating-ui.com/docs/useFocus
 */ const $cefae07eb29e7338$export$f8168d8dd8fd66e6 = function(_ref, _temp) {
    let { open: open, onOpenChange: onOpenChange, dataRef: dataRef, refs: refs, events: events } = _ref;
    let { enabled: enabled = true, keyboardOnly: keyboardOnly = true } = _temp === void 0 ? {} : _temp;
    const pointerTypeRef = $gIfym.useRef('');
    const blockFocusRef = $gIfym.useRef(false);
    const timeoutRef = $gIfym.useRef();
    $gIfym.useEffect(()=>{
        var _doc$defaultView;
        if (!enabled) return;
        const doc = $cefae07eb29e7338$var$getDocument(refs.floating.current);
        const win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
        function onBlur() {
            if (!open && $cefae07eb29e7338$var$isHTMLElement(refs.domReference.current)) refs.domReference.current.blur();
        }
        win.addEventListener('blur', onBlur);
        return ()=>{
            win.removeEventListener('blur', onBlur);
        };
    }, [
        refs,
        open,
        enabled
    ]);
    $gIfym.useEffect(()=>{
        if (!enabled) return;
        function onDismiss() {
            blockFocusRef.current = true;
        }
        events.on('dismiss', onDismiss);
        return ()=>{
            events.off('dismiss', onDismiss);
        };
    }, [
        events,
        enabled
    ]);
    $gIfym.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (_ref2) {
                    let { pointerType: pointerType } = _ref2;
                    pointerTypeRef.current = pointerType;
                    blockFocusRef.current = !!(pointerType && keyboardOnly);
                },
                onPointerLeave () {
                    blockFocusRef.current = false;
                },
                onFocus (event) {
                    var _dataRef$current$open, _refs$domReference$cu, _dataRef$current$open2;
                    if (blockFocusRef.current) return;
                     // Dismiss with click should ignore the subsequent `focus` trigger, but
                    // only if the click originated inside the reference element.
                    if (event.type === 'focus' && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === 'mousedown' && (_refs$domReference$cu = refs.domReference.current) != null && _refs$domReference$cu.contains((_dataRef$current$open2 = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open2.target)) return;
                    dataRef.current.openEvent = event.nativeEvent;
                    onOpenChange(true);
                },
                onBlur (event) {
                    const target = event.relatedTarget; // Wait for the window blur listener to fire.
                    timeoutRef.current = setTimeout(()=>{
                        var _refs$floating$curren, _refs$domReference$cu2;
                        // When focusing the reference element (e.g. regular click), then
                        // clicking into the floating element, prevent it from hiding.
                        // Note: it must be focusable, e.g. `tabindex="-1"`.
                        if ((_refs$floating$curren = refs.floating.current) != null && _refs$floating$curren.contains(target) || (_refs$domReference$cu2 = refs.domReference.current) != null && _refs$domReference$cu2.contains(target)) return;
                        blockFocusRef.current = false;
                        onOpenChange(false);
                    });
                }
            }
        };
    }, [
        enabled,
        keyboardOnly,
        refs,
        dataRef,
        onOpenChange
    ]);
};
const $cefae07eb29e7338$var$ARROW_UP = 'ArrowUp';
const $cefae07eb29e7338$var$ARROW_DOWN = 'ArrowDown';
const $cefae07eb29e7338$var$ARROW_LEFT = 'ArrowLeft';
const $cefae07eb29e7338$var$ARROW_RIGHT = 'ArrowRight';
function $cefae07eb29e7338$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $cefae07eb29e7338$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $cefae07eb29e7338$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do {
        var _list$index, _list$index2;
        index = index + (decrement ? -amount : amount);
    }while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute('disabled')) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute('aria-disabled')) === 'true'));
    return index;
}
function $cefae07eb29e7338$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $cefae07eb29e7338$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $cefae07eb29e7338$var$ARROW_UP || key === $cefae07eb29e7338$var$ARROW_DOWN;
    const horizontal = key === $cefae07eb29e7338$var$ARROW_LEFT || key === $cefae07eb29e7338$var$ARROW_RIGHT;
    return $cefae07eb29e7338$var$doSwitch(orientation, vertical, horizontal);
}
function $cefae07eb29e7338$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $cefae07eb29e7338$var$ARROW_DOWN;
    const horizontal = rtl ? key === $cefae07eb29e7338$var$ARROW_LEFT : key === $cefae07eb29e7338$var$ARROW_RIGHT;
    return $cefae07eb29e7338$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key == ' ' || key === '';
}
function $cefae07eb29e7338$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $cefae07eb29e7338$var$ARROW_LEFT : key === $cefae07eb29e7338$var$ARROW_RIGHT;
    const horizontal = key === $cefae07eb29e7338$var$ARROW_DOWN;
    return $cefae07eb29e7338$var$doSwitch(orientation, vertical, horizontal);
}
function $cefae07eb29e7338$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $cefae07eb29e7338$var$ARROW_RIGHT : key === $cefae07eb29e7338$var$ARROW_LEFT;
    const horizontal = key === $cefae07eb29e7338$var$ARROW_UP;
    return $cefae07eb29e7338$var$doSwitch(orientation, vertical, horizontal);
}
function $cefae07eb29e7338$var$getMinIndex(listRef, disabledIndices) {
    return $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $cefae07eb29e7338$var$getMaxIndex(listRef, disabledIndices) {
    return $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
/**
 * Adds focus-managed indexed navigation via arrow keys to a list of items
 * within the floating element.
 * @see https://floating-ui.com/docs/useListNavigation
 */ const $cefae07eb29e7338$export$b5d22cac4ad33f40 = function(_ref, _temp2) {
    let { open: open, onOpenChange: onOpenChange, refs: refs } = _ref;
    let { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1 } = _temp2 === void 0 ? {
        listRef: {
            current: []
        },
        activeIndex: null,
        onNavigate: ()=>{}
    } : _temp2;
    const parentId = $cefae07eb29e7338$export$165209eae06d3488();
    const tree = $cefae07eb29e7338$export$db0c2a7c7a2a4f69();
    const previousOpen = $cefae07eb29e7338$var$usePrevious(open);
    const onNavigate = $cefae07eb29e7338$var$useEvent(unstable_onNavigate);
    const previousOnNavigate = $cefae07eb29e7338$var$useEvent($cefae07eb29e7338$var$usePrevious(unstable_onNavigate));
    const focusItemOnOpenRef = $gIfym.useRef(focusItemOnOpen);
    const indexRef = $gIfym.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $gIfym.useRef(null);
    const disabledIndicesRef = $cefae07eb29e7338$var$useLatestRef(disabledIndices);
    const blockPointerLeaveRef = $gIfym.useRef(false);
    const frameRef = $gIfym.useRef(-1);
    const [activeId, setActiveId] = $gIfym.useState();
    const focusItem = $gIfym.useCallback((listRef, indexRef)=>{
        // `mousedown` clicks occur before `focus`, so the button will steal the
        // focus unless we wait a frame.
        frameRef.current = requestAnimationFrame(()=>{
            if (virtual) {
                var _listRef$current$inde;
                setActiveId((_listRef$current$inde = listRef.current[indexRef.current]) == null ? void 0 : _listRef$current$inde.id);
            } else {
                var _listRef$current$inde2;
                (_listRef$current$inde2 = listRef.current[indexRef.current]) == null || _listRef$current$inde2.focus({
                    preventScroll: true
                });
            }
        });
    }, [
        virtual
    ]); // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $cefae07eb29e7338$var$index(()=>{
        if (!enabled) return;
        if (!previousOpen && open && focusItemOnOpenRef.current && selectedIndex != null) onNavigate(selectedIndex);
         // Unset `activeIndex`. Since the user can specify `onNavigate`
        // conditionally (onNavigate: open ? setActiveIndex : setSelectedIndex)
        // we store and call the previous function
        if (previousOpen && !open) {
            cancelAnimationFrame(frameRef.current);
            indexRef.current = -1;
            previousOnNavigate(null);
        }
    }, [
        open,
        previousOpen,
        selectedIndex,
        listRef,
        focusItem,
        enabled,
        onNavigate,
        previousOnNavigate
    ]); // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $cefae07eb29e7338$var$index(()=>{
        if (!enabled) return;
        if (open) {
            if (activeIndex == null) {
                if (selectedIndex != null) return;
                 // Reset while the floating element was open (e.g. the list changed).
                if (previousOpen) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                } // Initial sync
                if (!previousOpen && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    indexRef.current = keyRef.current == null || $cefae07eb29e7338$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $cefae07eb29e7338$var$getMinIndex(listRef, disabledIndicesRef.current) : $cefae07eb29e7338$var$getMaxIndex(listRef, disabledIndicesRef.current);
                    onNavigate(indexRef.current);
                    focusItem(listRef, indexRef);
                }
            } else if (!$cefae07eb29e7338$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef);
            }
        }
    }, [
        open,
        previousOpen,
        activeIndex,
        selectedIndex,
        nested,
        listRef,
        onNavigate,
        focusItem,
        enabled,
        allowEscape,
        orientation,
        rtl,
        virtual,
        disabledIndicesRef
    ]); // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $cefae07eb29e7338$var$index(()=>{
        if (!enabled) return;
        if (!open && previousOpen) {
            var _tree$nodesRef$curren, _tree$nodesRef$curren2;
            const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.refs.floating.current;
            if (parentFloating && !parentFloating.contains($cefae07eb29e7338$var$activeElement($cefae07eb29e7338$var$getDocument(parentFloating)))) parentFloating.focus({
                preventScroll: true
            });
        }
    }, [
        enabled,
        open,
        previousOpen,
        tree,
        parentId
    ]);
    $cefae07eb29e7338$var$index(()=>{
        keyRef.current = null;
    });
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        const disabledIndices = disabledIndicesRef.current;
        function onKeyDown(event) {
            blockPointerLeaveRef.current = true;
            if (nested && $cefae07eb29e7338$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
                $cefae07eb29e7338$var$stopEvent(event);
                onOpenChange(false);
                if ($cefae07eb29e7338$var$isHTMLElement(refs.domReference.current)) refs.domReference.current.focus();
                return;
            }
            const currentIndex = indexRef.current;
            const minIndex = $cefae07eb29e7338$var$getMinIndex(listRef, disabledIndices);
            const maxIndex = $cefae07eb29e7338$var$getMaxIndex(listRef, disabledIndices);
            if (event.key === 'Home') {
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            } // Grid navigation
            if (cols > 1) {
                const prevIndex = indexRef.current;
                if (event.key === $cefae07eb29e7338$var$ARROW_UP) {
                    $cefae07eb29e7338$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = maxIndex;
                    else {
                        indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
                            const col = prevIndex % cols;
                            const maxCol = maxIndex % cols;
                            const offset = maxIndex - (maxCol - col);
                            if (maxCol === col) indexRef.current = maxIndex;
                            else indexRef.current = maxCol > col ? offset : offset - cols;
                        }
                    }
                    if ($cefae07eb29e7338$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                if (event.key === $cefae07eb29e7338$var$ARROW_DOWN) {
                    $cefae07eb29e7338$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = minIndex;
                    else {
                        indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                        if (loop && prevIndex + cols > maxIndex) indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex % cols - cols,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                    }
                    if ($cefae07eb29e7338$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                } // Remains on the same row/column
                if (orientation === 'both') {
                    const prevRow = Math.floor(prevIndex / cols);
                    if (event.key === $cefae07eb29e7338$var$ARROW_RIGHT) {
                        $cefae07eb29e7338$var$stopEvent(event);
                        if (prevIndex % cols !== cols - 1) {
                            indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices
                            });
                            if (loop && $cefae07eb29e7338$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex - prevIndex % cols - 1,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        if ($cefae07eb29e7338$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    if (event.key === $cefae07eb29e7338$var$ARROW_LEFT) {
                        $cefae07eb29e7338$var$stopEvent(event);
                        if (prevIndex % cols !== 0) {
                            indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices,
                                decrement: true
                            });
                            if (loop && $cefae07eb29e7338$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex + (cols - prevIndex % cols),
                                decrement: true,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex + (cols - prevIndex % cols),
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if ($cefae07eb29e7338$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    const lastRow = Math.floor(maxIndex / cols) === prevRow;
                    if ($cefae07eb29e7338$var$isIndexOutOfBounds(listRef, indexRef.current)) {
                        if (loop && lastRow) indexRef.current = event.key === $cefae07eb29e7338$var$ARROW_LEFT ? maxIndex : $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        else indexRef.current = prevIndex;
                    }
                    onNavigate(indexRef.current);
                    return;
                }
            }
            if ($cefae07eb29e7338$var$isMainOrientationKey(event.key, orientation)) {
                $cefae07eb29e7338$var$stopEvent(event); // Reset the index if no item is focused.
                if (open && !virtual && $cefae07eb29e7338$var$activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
                    indexRef.current = $cefae07eb29e7338$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                    onNavigate(indexRef.current);
                    return;
                }
                if ($cefae07eb29e7338$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                    if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else indexRef.current = Math.min(maxIndex, $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    }));
                } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.max(minIndex, $cefae07eb29e7338$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                }));
                if ($cefae07eb29e7338$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
                else onNavigate(indexRef.current);
            }
        }
        return {
            reference: {
                ...virtual && open && activeIndex != null && {
                    'aria-activedescendant': activeId
                },
                onKeyDown (event) {
                    blockPointerLeaveRef.current = true;
                    if (virtual && open) return onKeyDown(event);
                    const isNavigationKey = event.key.indexOf('Arrow') === 0 || event.key === 'Enter' || event.key === ' ' || event.key === '';
                    if (isNavigationKey) keyRef.current = event.key;
                    if (nested) {
                        if ($cefae07eb29e7338$var$isCrossOrientationOpenKey(event.key, orientation, rtl)) {
                            $cefae07eb29e7338$var$stopEvent(event);
                            if (open) {
                                indexRef.current = $cefae07eb29e7338$var$getMinIndex(listRef, disabledIndices);
                                onNavigate(indexRef.current);
                            } else onOpenChange(true);
                        }
                        return;
                    }
                    if ($cefae07eb29e7338$var$isMainOrientationKey(event.key, orientation)) {
                        if (selectedIndex != null) indexRef.current = selectedIndex;
                        $cefae07eb29e7338$var$stopEvent(event);
                        if (!open && openOnArrowKeyDown) onOpenChange(true);
                        else onKeyDown(event);
                        if (open) onNavigate(indexRef.current);
                    }
                }
            },
            floating: {
                'aria-orientation': orientation === 'both' ? undefined : orientation,
                ...virtual && activeIndex != null && {
                    'aria-activedescendant': activeId
                },
                onKeyDown: onKeyDown,
                onPointerMove () {
                    blockPointerLeaveRef.current = false;
                }
            },
            item: {
                onFocus (_ref2) {
                    let { currentTarget: currentTarget } = _ref2;
                    const index = listRef.current.indexOf(currentTarget);
                    if (index !== -1) onNavigate(index);
                },
                onClick: (_ref3)=>{
                    let { currentTarget: currentTarget } = _ref3;
                    return currentTarget.focus({
                        preventScroll: true
                    });
                },
                // Safari
                ...focusItemOnHover && {
                    onMouseMove (_ref4) {
                        let { currentTarget: currentTarget } = _ref4;
                        const target = currentTarget;
                        if (target) {
                            const index = listRef.current.indexOf(target);
                            if (index !== -1) onNavigate(index);
                        }
                    },
                    onPointerLeave () {
                        if (!blockPointerLeaveRef.current) {
                            indexRef.current = -1;
                            focusItem(listRef, indexRef);
                            onNavigate(null);
                            if (!virtual) requestAnimationFrame(()=>{
                                var _refs$floating$curren;
                                (_refs$floating$curren = refs.floating.current) == null || _refs$floating$curren.focus({
                                    preventScroll: true
                                });
                            });
                        }
                    }
                }
            }
        };
    }, [
        activeId,
        disabledIndicesRef,
        listRef,
        enabled,
        orientation,
        rtl,
        virtual,
        open,
        activeIndex,
        nested,
        selectedIndex,
        openOnArrowKeyDown,
        focusItemOnHover,
        allowEscape,
        cols,
        loop,
        refs,
        focusItem,
        onNavigate,
        onOpenChange
    ]);
};
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ const $cefae07eb29e7338$export$d8d674d50b73ba93 = function(_ref, _temp) {
    var _ref2;
    let { open: open, dataRef: dataRef } = _ref;
    let { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch = ()=>{}, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 1000, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = _temp === void 0 ? {
        listRef: {
            current: []
        },
        activeIndex: null
    } : _temp;
    const timeoutIdRef = $gIfym.useRef();
    const stringRef = $gIfym.useRef('');
    const prevIndexRef = $gIfym.useRef((_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1);
    const matchIndexRef = $gIfym.useRef(null);
    const onMatch = $cefae07eb29e7338$var$useEvent(unstable_onMatch);
    const findMatchRef = $cefae07eb29e7338$var$useLatestRef(findMatch);
    const ignoreKeysRef = $cefae07eb29e7338$var$useLatestRef(ignoreKeys);
    $cefae07eb29e7338$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $cefae07eb29e7338$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation
        if (open && stringRef.current === '') {
            var _ref3;
            prevIndexRef.current = (_ref3 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref3 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    return $gIfym.useMemo(()=>{
        if (!enabled) return {};
        function onKeyDown(event) {
            // Correctly scope nested non-portalled floating elements. Since the nested
            // floating element is inside of the another, we find the closest role
            // that indicates the floating element scope.
            const target = $cefae07eb29e7338$var$getTarget(event.nativeEvent);
            if ($cefae07eb29e7338$var$isElement(target) && ($cefae07eb29e7338$var$activeElement($cefae07eb29e7338$var$getDocument(target)) !== event.currentTarget ? target.closest('[role="dialog"],[role="menu"],[role="listbox"],[role="tree"],[role="grid"]') !== event.currentTarget : false)) return;
            if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
                dataRef.current.typing = true;
                if (event.key === ' ') $cefae07eb29e7338$var$stopEvent(event);
            }
            const listContent = listRef.current;
            if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key
            event.key.length !== 1 || // Modifier key
            event.ctrlKey || event.metaKey || event.altKey) return;
             // Bail out if the list contains a word like "llama" or "aaron". TODO:
            // allow it in this case, too.
            const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
                var _text$, _text$2;
                return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
            }); // Allows the user to cycle through items that start with the same letter
            // in rapid succession
            if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
                stringRef.current = '';
                prevIndexRef.current = matchIndexRef.current;
            }
            stringRef.current += event.key;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(()=>{
                stringRef.current = '';
                prevIndexRef.current = matchIndexRef.current;
                dataRef.current.typing = false;
            }, resetMs);
            const prevIndex = prevIndexRef.current;
            const orderedList = [
                ...listContent.slice((prevIndex != null ? prevIndex : 0) + 1),
                ...listContent.slice(0, (prevIndex != null ? prevIndex : 0) + 1)
            ];
            const str = findMatchRef.current ? findMatchRef.current(orderedList, stringRef.current) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(stringRef.current.toLocaleLowerCase())) === 0);
            const index = str ? listContent.indexOf(str) : -1;
            if (index !== -1) {
                onMatch(index);
                matchIndexRef.current = index;
            }
        }
        return {
            reference: {
                onKeyDown: onKeyDown
            },
            floating: {
                onKeyDown: onKeyDown
            }
        };
    }, [
        enabled,
        dataRef,
        listRef,
        resetMs,
        ignoreKeysRef,
        findMatchRef,
        onMatch
    ]);
};



var $gIfym = parcelRequire("gIfym");
function $c5405def59338d1b$export$c9058316764c140e(f) {
    return (r)=>{
        f.forEach((n)=>{
            typeof n == "function" ? n(r) : n != null && (n.current = r);
        });
    };
}


const $3dc450ea6ffcb133$var$Tooltip = ({ children: children, label: label, placement: placement = "top" })=>{
    const [open, setOpen] = (0, $gIfym.useState)(false);
    const { x: x, y: y, reference: reference, floating: floating, strategy: strategy, context: context } = (0, $cefae07eb29e7338$export$4e02a5c1d08bac65)({
        placement: placement,
        open: open,
        onOpenChange: setOpen,
        middleware: [
            (0, $37bd3ebffd0f063b$export$cc800923e997bb8)(10),
            (0, $37bd3ebffd0f063b$export$8a83211c878a3f1f)(),
            (0, $37bd3ebffd0f063b$export$fba63a578e423eb)({
                padding: 8
            })
        ],
        whileElementsMounted: (0, $37bd3ebffd0f063b$export$deee3a793edee05f)
    });
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $cefae07eb29e7338$export$a519f7794e446ddd)([
        (0, $cefae07eb29e7338$export$ae780daf29e6d456)(context),
        (0, $cefae07eb29e7338$export$f8168d8dd8fd66e6)(context),
        (0, $cefae07eb29e7338$export$f66572793fa256a1)(context, {
            role: "tooltip"
        }),
        (0, $cefae07eb29e7338$export$fcdf1ba5fafc089b)(context)
    ]);
    // Preserve the consumer's ref
    const ref = (0, $gIfym.useMemo)(()=>(0, $c5405def59338d1b$export$c9058316764c140e)([
            reference,
            children.ref
        ]), [
        reference,
        children
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gIfym.cloneElement)(children, getReferenceProps({
                ref: ref,
                ...children.props
            })),
            open && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                ref: floating,
                className: "bg-dark-blue text-white rounded-lg p-2 text-sm max-w-[200px] shadow-default z-50 text-center",
                style: {
                    position: strategy,
                    top: y ?? 0,
                    left: x ?? 0
                },
                ...getFloatingProps(),
                children: label
            })
        ]
    });
};
var $3dc450ea6ffcb133$export$2e2bcd8739ae039 = $3dc450ea6ffcb133$var$Tooltip;


function $8b39615f3260a6de$export$2e2bcd8739ae039({ children: children, placement: placement = "top", label: label }) {
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    if (auth.canSubmit() === false) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3dc450ea6ffcb133$export$2e2bcd8739ae039), {
        label: !label ? t("no-submit.default") : label,
        placement: placement,
        children: children
    });
    return children;
}


function $e5dfe94a87406a8d$export$2e2bcd8739ae039() {
    const [modal, setModal] = (0, $gIfym.useState)(false);
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const title = t("bookmeeting-title");
    const diplayModal = ()=>{
        setModal(true);
    };
    const hideModal = ()=>{
        setModal(false);
    };
    if (!(0, $e845536d9724b5be$export$471f70c09cf8ab8c)()) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8b39615f3260a6de$export$2e2bcd8739ae039), {
        label: t("no-submit.bookmeeting"),
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                    className: `rounded-full text-dark-blue text-sm font-interbold py-1 px-10 uppercase bg-white mx-9 ${auth.canSubmit() === false ? "opacity-40 pointer-events-none" : ""}`,
                    onClick: diplayModal,
                    disabled: auth.canSubmit() === false,
                    children: t("book-a-meeting")
                }),
                modal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                    title: title,
                    onClose: hideModal,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "flex justify-center p-10",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $76e68f096da79c5e$export$2e2bcd8739ae039), {}),
                            ";"
                        ]
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                className: "text-xs uppercase text-dark-blue font-interbold mb-4",
                children: title
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8b39615f3260a6de$export$2e2bcd8739ae039), {
                placement: "bottom",
                label: t("no-submit.bookmeeting"),
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "flex justify-center mb-8",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: `w-full relative ${auth.canSubmit() === false ? "opacity-40 pointer-events-none" : ""}`,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $76e68f096da79c5e$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
}



parcelRequire("gIfym");


parcelRequire("gIfym");


parcelRequire("gIfym");

function $5777853c1e9d77bc$export$2e2bcd8739ae039(props) {
    const { children: children, to: to, onClick: onClick, image: image, imageActive: imageActive, ...rest } = props;
    const resolved = (0, $bf4ac162b947611d$export$e75d2a2d1b3c245b)(to);
    const match = (0, $bf4ac162b947611d$export$6c330e8992e8a295)({
        path: resolved.pathname,
        end: true
    });
    let cl = "";
    let img = image;
    if (match && to) {
        cl = "bg-[#00171f]";
        img = imageActive ?? image;
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a32432afacbfa13$export$a6c7ac8248d6e38a), {
        to: to,
        onClick: onClick,
        className: `block text-white font-interbold hover:bg-[#00171f] py-4 px-5 mb-1 transition ${cl}`,
        ...rest,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "flex items-center justify-center lg:justify-start group-hover:justify-start",
            children: [
                image ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                    src: img,
                    width: "20",
                    height: "20",
                    className: "h-fit max-w-none lg:mr-2.5 group-hover:mr-2.5",
                    alt: ""
                }) : "",
                children
            ]
        })
    });
}


var $b836c7ee942dbd9e$exports = {};
$b836c7ee942dbd9e$exports = $parcel$resolve("bQG3t");


let $ae4044fdde164839$var$iconToDo = new URL($b836c7ee942dbd9e$exports);
var $eee88bcba0225d63$exports = {};
$eee88bcba0225d63$exports = $parcel$resolve("7dBsJ");


let $ae4044fdde164839$var$iconToDoActive = new URL($eee88bcba0225d63$exports);
var $a56fc4b937d8e0af$exports = {};
$a56fc4b937d8e0af$exports = $parcel$resolve("9Yhvd");


let $ae4044fdde164839$var$iconImages = new URL($a56fc4b937d8e0af$exports);
var $aff9dd8134290808$exports = {};
$aff9dd8134290808$exports = $parcel$resolve("i9pZP");


let $ae4044fdde164839$var$iconImagesActive = new URL($aff9dd8134290808$exports);
var $b96556ed380658e8$exports = {};
$b96556ed380658e8$exports = $parcel$resolve("gJHxr");


let $ae4044fdde164839$var$iconFiles = new URL($b96556ed380658e8$exports);
var $ce214e971bf11860$exports = {};
$ce214e971bf11860$exports = $parcel$resolve("cOMgj");


let $ae4044fdde164839$var$iconFilesActive = new URL($ce214e971bf11860$exports);
function $ae4044fdde164839$export$2e2bcd8739ae039({ itemClass: itemClass }) {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    let menuItemClass = "";
    if (itemClass) menuItemClass = itemClass;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5777853c1e9d77bc$export$2e2bcd8739ae039), {
                to: "/todo",
                image: $ae4044fdde164839$var$iconToDo,
                imageActive: $ae4044fdde164839$var$iconToDoActive,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: menuItemClass,
                    children: t("todo-menu-title")
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5777853c1e9d77bc$export$2e2bcd8739ae039), {
                to: "/files",
                image: $ae4044fdde164839$var$iconFiles,
                imageActive: $ae4044fdde164839$var$iconFilesActive,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: menuItemClass,
                    children: t("files-menu-title")
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5777853c1e9d77bc$export$2e2bcd8739ae039), {
                to: "/images",
                image: $ae4044fdde164839$var$iconImages,
                imageActive: $ae4044fdde164839$var$iconImagesActive,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: menuItemClass,
                    children: t("images-menu-title")
                })
            })
        ]
    });
}



parcelRequire("gIfym");



var $ad11f833b66de097$exports = {};
$ad11f833b66de097$exports = $parcel$resolve("65pvn");


let $5c0d471a44711bed$var$iconUser = new URL($ad11f833b66de097$exports);
function $5c0d471a44711bed$export$2e2bcd8739ae039({ itemClass: itemClass }) {
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    let menuItemClass = "";
    if (itemClass) menuItemClass = itemClass;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5777853c1e9d77bc$export$2e2bcd8739ae039), {
            to: "",
            onClick: (e)=>{
                e.preventDefault();
                auth.signOut();
            },
            image: $5c0d471a44711bed$var$iconUser,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                className: menuItemClass,
                children: t("sign-out")
            })
        })
    });
}



let $166fa83503a18738$var$logo = new URL($17323fc8ea3ee725$exports);
function $166fa83503a18738$export$2e2bcd8739ae039() {
    const menuItemClass = "truncate w-0 leading-tight transition-all overflow-hidden lg:w-[120px] group-hover:w-[120px]";
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "fixed group flex flex-col h-full bg-dark-blue lg:w-[180px]",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "flex pt-8 mb-5 mx-3 justify-center",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a32432afacbfa13$export$a6c7ac8248d6e38a), {
                    to: "/todo",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        src: $166fa83503a18738$var$logo,
                        alt: "Fenix",
                        width: "42",
                        height: "42",
                        className: "h-fit max-w-none"
                    })
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("nav", {
                className: "py-2.5 mb-5 flex-grow",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ae4044fdde164839$export$2e2bcd8739ae039), {
                        itemClass: menuItemClass
                    })
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5c0d471a44711bed$export$2e2bcd8739ae039), {
                itemClass: menuItemClass
            })
        ]
    });
}




var $gIfym = parcelRequire("gIfym");



var $6VKBH = parcelRequire("6VKBH");

var $gIfym = parcelRequire("gIfym");



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// 0, 2, 10, 30 second delays before reconnect attempts.
const $ec175b2dab2affa1$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [
    0,
    2000,
    10000,
    30000,
    null
];
class $ec175b2dab2affa1$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays,
            null
        ] : $ec175b2dab2affa1$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    nextRetryDelayInMilliseconds(retryContext) {
        return this._retryDelays[retryContext.previousRetryCount];
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Error thrown when an HTTP request fails. */ class $21942b33248eb90a$export$65bd6083489bd8bb extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */ constructor(errorMessage, statusCode){
        const trueProto = new.target.prototype;
        super(`${errorMessage}: Status code '${statusCode}'`);
        this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$66d311bf29d5c89c extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "A timeout occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$18b052ffd8c84d7 extends Error {
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "An abort occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$c7cbd7482d8bece8 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'UnsupportedTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$764b8cd64449c5b0 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'DisabledTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$264839a6ea29f91a extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'FailedToStartTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$b4f59905103de78d extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
     *
     * @param {string} message A descriptive error message.
     */ constructor(message){
        const trueProto = new.target.prototype;
        super(message);
        this.errorType = 'FailedToNegotiateWithServerError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $21942b33248eb90a$export$9341e26d19ed3783 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
     *
     * @param {string} message A descriptive error message.
     * @param {Error[]} innerErrors The collection of errors this error is aggregating.
     */ constructor(message, innerErrors){
        const trueProto = new.target.prototype;
        super(message);
        this.innerErrors = innerErrors;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Represents an HTTP response. */ class $9780b164edda7b27$export$1d94dfe0d9d1f1e7 {
    constructor(statusCode, statusText, content){
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
}
class $9780b164edda7b27$export$8c6ee871e681f0f4 {
    get(url, options) {
        return this.send({
            ...options,
            method: "GET",
            url: url
        });
    }
    post(url, options) {
        return this.send({
            ...options,
            method: "POST",
            url: url
        });
    }
    delete(url, options) {
        return this.send({
            ...options,
            method: "DELETE",
            url: url
        });
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */ // @ts-ignore
    getCookieString(url) {
        return "";
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */ var $85fb2f42146a105f$export$243e62d78d3b544d;
(function(LogLevel) {
    /** Log level for very low severity diagnostic messages. */ LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */ LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */ LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */ LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */ LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */ LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */ LogLevel[LogLevel["None"] = 6] = "None";
})($85fb2f42146a105f$export$243e62d78d3b544d || ($85fb2f42146a105f$export$243e62d78d3b544d = {}));


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** A logger that does nothing when log messages are sent to it. */ class $498197582861cc98$export$17ac58a1138ded46 {
    constructor(){}
    /** @inheritDoc */ // eslint-disable-next-line
    log(_logLevel, _message) {}
}
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */ $498197582861cc98$export$17ac58a1138ded46.instance = new $498197582861cc98$export$17ac58a1138ded46();



var $17tgv = parcelRequire("17tgv");
const $66662b1851d50501$export$a4ad2735b021c132 = "6.0.25";
class $66662b1851d50501$export$83f0753fc4347e43 {
    static isRequired(val, name) {
        if (val === null || val === undefined) throw new Error(`The '${name}' argument is required.`);
    }
    static isNotEmpty(val, name) {
        if (!val || val.match(/^\s*$/)) throw new Error(`The '${name}' argument should not be empty.`);
    }
    static isIn(val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) throw new Error(`Unknown ${name} value: ${val}.`);
    }
}
class $66662b1851d50501$export$2dffd0b5373a4389 {
    // react-native has a window but no document so we should check both
    static get isBrowser() {
        return typeof window === "object" && typeof window.document === "object";
    }
    // WebWorkers don't have a window object so the isBrowser check would fail
    static get isWebWorker() {
        return typeof self === "object" && "importScripts" in self;
    }
    // react-native has a window but no document
    static get isReactNative() {
        return typeof window === "object" && typeof window.document === "undefined";
    }
    // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
    static get isNode() {
        return !this.isBrowser && !this.isWebWorker && !this.isReactNative;
    }
}
function $66662b1851d50501$export$a688b91586df8fd9(data, includeContent) {
    let detail = "";
    if ($66662b1851d50501$export$9dd3754ae86f0017(data)) {
        detail = `Binary data of length ${data.byteLength}`;
        if (includeContent) detail += `. Content: '${$66662b1851d50501$export$3ddcef0d22959f49(data)}'`;
    } else if (typeof data === "string") {
        detail = `String data of length ${data.length}`;
        if (includeContent) detail += `. Content: '${data}'`;
    }
    return detail;
}
function $66662b1851d50501$export$3ddcef0d22959f49(data) {
    const view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    let str = "";
    view.forEach((num)=>{
        const pad = num < 16 ? "0" : "";
        str += `0x${pad}${num.toString(16)} `;
    });
    // Trim of trailing space.
    return str.substr(0, str.length - 1);
}
function $66662b1851d50501$export$9dd3754ae86f0017(val) {
    return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
    val.constructor && val.constructor.name === "ArrayBuffer");
}
async function $66662b1851d50501$export$465cb47180de50f0(logger, transportName, httpClient, url, accessTokenFactory, content, options) {
    let headers = {};
    if (accessTokenFactory) {
        const token = await accessTokenFactory();
        if (token) headers = {
            ["Authorization"]: `Bearer ${token}`
        };
    }
    const [name, value] = $66662b1851d50501$export$56c7340f89ca57c5();
    headers[name] = value;
    logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(${transportName} transport) sending data. ${$66662b1851d50501$export$a688b91586df8fd9(content, options.logMessageContent)}.`);
    const responseType = $66662b1851d50501$export$9dd3754ae86f0017(content) ? "arraybuffer" : "text";
    const response = await httpClient.post(url, {
        content: content,
        headers: {
            ...headers,
            ...options.headers
        },
        responseType: responseType,
        timeout: options.timeout,
        withCredentials: options.withCredentials
    });
    logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
function $66662b1851d50501$export$fe2e61603b61130d(logger) {
    if (logger === undefined) return new $66662b1851d50501$export$ba6a9c7ac8291f7f((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information);
    if (logger === null) return (0, $498197582861cc98$export$17ac58a1138ded46).instance;
    if (logger.log !== undefined) return logger;
    return new $66662b1851d50501$export$ba6a9c7ac8291f7f(logger);
}
class $66662b1851d50501$export$b7a41f2bfb5c60c3 {
    constructor(subject, observer){
        this._subject = subject;
        this._observer = observer;
    }
    dispose() {
        const index = this._subject.observers.indexOf(this._observer);
        if (index > -1) this._subject.observers.splice(index, 1);
        if (this._subject.observers.length === 0 && this._subject.cancelCallback) this._subject.cancelCallback().catch((_)=>{});
    }
}
class $66662b1851d50501$export$ba6a9c7ac8291f7f {
    constructor(minimumLogLevel){
        this._minLevel = minimumLogLevel;
        this.out = console;
    }
    log(logLevel, message) {
        if (logLevel >= this._minLevel) {
            const msg = `[${new Date().toISOString()}] ${(0, $85fb2f42146a105f$export$243e62d78d3b544d)[logLevel]}: ${message}`;
            switch(logLevel){
                case (0, $85fb2f42146a105f$export$243e62d78d3b544d).Critical:
                case (0, $85fb2f42146a105f$export$243e62d78d3b544d).Error:
                    this.out.error(msg);
                    break;
                case (0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning:
                    this.out.warn(msg);
                    break;
                case (0, $85fb2f42146a105f$export$243e62d78d3b544d).Information:
                    this.out.info(msg);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.out.log(msg);
                    break;
            }
        }
    }
}
function $66662b1851d50501$export$56c7340f89ca57c5() {
    let userAgentHeaderName = "X-SignalR-User-Agent";
    if ($66662b1851d50501$export$2dffd0b5373a4389.isNode) userAgentHeaderName = "User-Agent";
    return [
        userAgentHeaderName,
        $66662b1851d50501$export$1feb51270b0ce71b($66662b1851d50501$export$a4ad2735b021c132, $66662b1851d50501$var$getOsName(), $66662b1851d50501$var$getRuntime(), $66662b1851d50501$var$getRuntimeVersion())
    ];
}
function $66662b1851d50501$export$1feb51270b0ce71b(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    let userAgent = "Microsoft SignalR/";
    const majorAndMinor = version.split(".");
    userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
    userAgent += ` (${version}; `;
    if (os && os !== "") userAgent += `${os}; `;
    else userAgent += "Unknown OS; ";
    userAgent += `${runtime}`;
    if (runtimeVersion) userAgent += `; ${runtimeVersion}`;
    else userAgent += "; Unknown Runtime Version";
    userAgent += ")";
    return userAgent;
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $66662b1851d50501$var$getOsName() {
    if ($66662b1851d50501$export$2dffd0b5373a4389.isNode) switch($17tgv.platform){
        case "win32":
            return "Windows NT";
        case "darwin":
            return "macOS";
        case "linux":
            return "Linux";
        default:
            return $17tgv.platform;
    }
    else return "";
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $66662b1851d50501$var$getRuntimeVersion() {
    if ($66662b1851d50501$export$2dffd0b5373a4389.isNode) return $17tgv.versions.node;
    return undefined;
}
function $66662b1851d50501$var$getRuntime() {
    if ($66662b1851d50501$export$2dffd0b5373a4389.isNode) return "NodeJS";
    else return "Browser";
}
function $66662b1851d50501$export$375b49718dbd9ced(e) {
    if (e.stack) return e.stack;
    else if (e.message) return e.message;
    return `${e}`;
}
function $66662b1851d50501$export$ff5f2eeb11fc7e14() {
    // globalThis is semi-new and not available in Node until v12
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("could not find global");
}


class $b36d082656788c3b$export$1b51ed6f7c8f947b extends (0, $9780b164edda7b27$export$8c6ee871e681f0f4) {
    constructor(logger){
        super();
        this._logger = logger;
        if (typeof fetch === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            this._jar = new (requireFunc("tough-cookie")).CookieJar();
            this._fetchType = requireFunc("node-fetch");
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
        } else this._fetchType = fetch.bind((0, $66662b1851d50501$export$ff5f2eeb11fc7e14)());
        if (typeof AbortController === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            this._abortControllerType = requireFunc("abort-controller");
        } else this._abortControllerType = AbortController;
    }
    /** @inheritDoc */ async send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) throw new (0, $21942b33248eb90a$export$18b052ffd8c84d7)();
        if (!request.method) throw new Error("No method defined.");
        if (!request.url) throw new Error("No url defined.");
        const abortController = new this._abortControllerType();
        let error;
        // Hook our abortSignal into the abort controller
        if (request.abortSignal) request.abortSignal.onabort = ()=>{
            abortController.abort();
            error = new (0, $21942b33248eb90a$export$18b052ffd8c84d7)();
        };
        // If a timeout has been passed in, setup a timeout to call abort
        // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
        let timeoutId = null;
        if (request.timeout) {
            const msTimeout = request.timeout;
            timeoutId = setTimeout(()=>{
                abortController.abort();
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `Timeout from HTTP request.`);
                error = new (0, $21942b33248eb90a$export$66d311bf29d5c89c)();
            }, msTimeout);
        }
        let response;
        try {
            response = await this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: {
                    "Content-Type": "text/plain;charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest",
                    ...request.headers
                },
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal
            });
        } catch (e) {
            if (error) throw error;
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `Error from HTTP request. ${e}.`);
            throw e;
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (request.abortSignal) request.abortSignal.onabort = null;
        }
        if (!response.ok) {
            const errorMessage = await $b36d082656788c3b$var$deserializeContent(response, "text");
            throw new (0, $21942b33248eb90a$export$65bd6083489bd8bb)(errorMessage || response.statusText, response.status);
        }
        const content = $b36d082656788c3b$var$deserializeContent(response, request.responseType);
        const payload = await content;
        return new (0, $9780b164edda7b27$export$1d94dfe0d9d1f1e7)(response.status, response.statusText, payload);
    }
    getCookieString(url) {
        let cookies = "";
        if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isNode && this._jar) // @ts-ignore: unused variable
        this._jar.getCookies(url, (e, c)=>cookies = c.join("; "));
        return cookies;
    }
}
function $b36d082656788c3b$var$deserializeContent(response, responseType) {
    let content;
    switch(responseType){
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(`${responseType} is not supported.`);
        default:
            content = response.text();
            break;
    }
    return content;
}




// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.



class $bf0a9cf118e22483$export$33b9ed1bd07561aa extends (0, $9780b164edda7b27$export$8c6ee871e681f0f4) {
    constructor(logger){
        super();
        this._logger = logger;
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $21942b33248eb90a$export$18b052ffd8c84d7)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            // Explicitly setting the Content-Type header for React Native on Android platform.
            xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            const headers = request.headers;
            if (headers) Object.keys(headers).forEach((header)=>{
                xhr.setRequestHeader(header, headers[header]);
            });
            if (request.responseType) xhr.responseType = request.responseType;
            if (request.abortSignal) request.abortSignal.onabort = ()=>{
                xhr.abort();
                reject(new (0, $21942b33248eb90a$export$18b052ffd8c84d7)());
            };
            if (request.timeout) xhr.timeout = request.timeout;
            xhr.onload = ()=>{
                if (request.abortSignal) request.abortSignal.onabort = null;
                if (xhr.status >= 200 && xhr.status < 300) resolve(new (0, $9780b164edda7b27$export$1d94dfe0d9d1f1e7)(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                else reject(new (0, $21942b33248eb90a$export$65bd6083489bd8bb)(xhr.response || xhr.responseText || xhr.statusText, xhr.status));
            };
            xhr.onerror = ()=>{
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `Error from HTTP request. ${xhr.status}: ${xhr.statusText}.`);
                reject(new (0, $21942b33248eb90a$export$65bd6083489bd8bb)(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = ()=>{
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `Timeout from HTTP request.`);
                reject(new (0, $21942b33248eb90a$export$66d311bf29d5c89c)());
            };
            xhr.send(request.content || "");
        });
    }
}


class $382b20375fb1717a$export$4f11ab3560c519e5 extends (0, $9780b164edda7b27$export$8c6ee871e681f0f4) {
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */ constructor(logger){
        super();
        if (typeof fetch !== "undefined" || (0, $66662b1851d50501$export$2dffd0b5373a4389).isNode) this._httpClient = new (0, $b36d082656788c3b$export$1b51ed6f7c8f947b)(logger);
        else if (typeof XMLHttpRequest !== "undefined") this._httpClient = new (0, $bf0a9cf118e22483$export$33b9ed1bd07561aa)(logger);
        else throw new Error("No usable HttpClient found.");
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $21942b33248eb90a$export$18b052ffd8c84d7)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return this._httpClient.send(request);
    }
    getCookieString(url) {
        return this._httpClient.getCookieString(url);
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
class $810de70b061002ad$export$28d77f87efed1d88 {
}
$810de70b061002ad$export$28d77f87efed1d88.Authorization = "Authorization";
$810de70b061002ad$export$28d77f87efed1d88.Cookie = "Cookie";



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */ var $8f9633606a43bad2$export$789ba40ee1a75f0;
(function(HttpTransportType) {
    /** Specifies no transport preference. */ HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */ HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */ HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */ HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})($8f9633606a43bad2$export$789ba40ee1a75f0 || ($8f9633606a43bad2$export$789ba40ee1a75f0 = {}));
var $8f9633606a43bad2$export$f29afaa8e8d2989a;
(function(TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */ TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */ TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})($8f9633606a43bad2$export$f29afaa8e8d2989a || ($8f9633606a43bad2$export$f29afaa8e8d2989a = {}));


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */ class $013fcd2df7bc1241$export$48f7e099c149af88 {
    constructor(){
        this._isAborted = false;
        this.onabort = null;
    }
    abort() {
        if (!this._isAborted) {
            this._isAborted = true;
            if (this.onabort) this.onabort();
        }
    }
    get signal() {
        return this;
    }
    get aborted() {
        return this._isAborted;
    }
}







class $fdd040ad08aec854$export$fbd8c90d2cca1300 {
    constructor(httpClient, accessTokenFactory, logger, options){
        this._httpClient = httpClient;
        this._accessTokenFactory = accessTokenFactory;
        this._logger = logger;
        this._pollAbort = new (0, $013fcd2df7bc1241$export$48f7e099c149af88)();
        this._options = options;
        this._running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    // This is an internal type, not exported from 'index' so this is really just internal.
    get pollAborted() {
        return this._pollAbort.aborted;
    }
    async connect(url, transferFormat) {
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isIn(transferFormat, (0, $8f9633606a43bad2$export$f29afaa8e8d2989a), "transferFormat");
        this._url = url;
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Connecting.");
        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
        if (transferFormat === (0, $8f9633606a43bad2$export$f29afaa8e8d2989a).Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string") throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        const [name, value] = (0, $66662b1851d50501$export$56c7340f89ca57c5)();
        const headers = {
            [name]: value,
            ...this._options.headers
        };
        const pollOptions = {
            abortSignal: this._pollAbort.signal,
            headers: headers,
            timeout: 100000,
            withCredentials: this._options.withCredentials
        };
        if (transferFormat === (0, $8f9633606a43bad2$export$f29afaa8e8d2989a).Binary) pollOptions.responseType = "arraybuffer";
        const token = await this._getAccessToken();
        this._updateHeaderToken(pollOptions, token);
        // Make initial long polling request
        // Server uses first long polling request to finish initializing connection and it returns without data
        const pollUrl = `${url}&_=${Date.now()}`;
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
        const response = await this._httpClient.get(pollUrl, pollOptions);
        if (response.statusCode !== 200) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            // Mark running as false so that the poll immediately ends and runs the close logic
            this._closeError = new (0, $21942b33248eb90a$export$65bd6083489bd8bb)(response.statusText || "", response.statusCode);
            this._running = false;
        } else this._running = true;
        this._receiving = this._poll(this._url, pollOptions);
    }
    async _getAccessToken() {
        if (this._accessTokenFactory) return await this._accessTokenFactory();
        return null;
    }
    _updateHeaderToken(request, token) {
        if (!request.headers) request.headers = {};
        if (token) {
            request.headers[(0, $810de70b061002ad$export$28d77f87efed1d88).Authorization] = `Bearer ${token}`;
            return;
        }
        if (request.headers[(0, $810de70b061002ad$export$28d77f87efed1d88).Authorization]) delete request.headers[(0, $810de70b061002ad$export$28d77f87efed1d88).Authorization];
    }
    async _poll(url, pollOptions) {
        try {
            while(this._running){
                // We have to get the access token on each poll, in case it changes
                const token = await this._getAccessToken();
                this._updateHeaderToken(pollOptions, token);
                try {
                    const pollUrl = `${url}&_=${Date.now()}`;
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
                    const response = await this._httpClient.get(pollUrl, pollOptions);
                    if (response.statusCode === 204) {
                        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, "(LongPolling transport) Poll terminated by server.");
                        this._running = false;
                    } else if (response.statusCode !== 200) {
                        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
                        // Unexpected status code
                        this._closeError = new (0, $21942b33248eb90a$export$65bd6083489bd8bb)(response.statusText || "", response.statusCode);
                        this._running = false;
                    } else // Process the response
                    if (response.content) {
                        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(LongPolling transport) data received. ${(0, $66662b1851d50501$export$a688b91586df8fd9)(response.content, this._options.logMessageContent)}.`);
                        if (this.onreceive) this.onreceive(response.content);
                    } else // This is another way timeout manifest.
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Poll timed out, reissuing.");
                } catch (e) {
                    if (!this._running) // Log but disregard errors that occur after stopping
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
                    else if (e instanceof (0, $21942b33248eb90a$export$66d311bf29d5c89c)) // Ignore timeouts and reissue the poll.
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Poll timed out, reissuing.");
                    else {
                        // Close the connection with the error as the result.
                        this._closeError = e;
                        this._running = false;
                    }
                }
            }
        } finally{
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Polling complete.");
            // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
            if (!this.pollAborted) this._raiseOnClose();
        }
    }
    async send(data) {
        if (!this._running) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $66662b1851d50501$export$465cb47180de50f0)(this._logger, "LongPolling", this._httpClient, this._url, this._accessTokenFactory, data, this._options);
    }
    async stop() {
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Stopping polling.");
        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
        this._running = false;
        this._pollAbort.abort();
        try {
            await this._receiving;
            // Send DELETE to clean up long polling on the server
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
            const headers = {};
            const [name, value] = (0, $66662b1851d50501$export$56c7340f89ca57c5)();
            headers[name] = value;
            const deleteOptions = {
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            };
            const token = await this._getAccessToken();
            this._updateHeaderToken(deleteOptions, token);
            await this._httpClient.delete(this._url, deleteOptions);
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) DELETE request sent.");
        } finally{
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Stop finished.");
            // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent
            this._raiseOnClose();
        }
    }
    _raiseOnClose() {
        if (this.onclose) {
            let logMessage = "(LongPolling transport) Firing onclose event.";
            if (this._closeError) logMessage += " Error: " + this._closeError;
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, logMessage);
            this.onclose(this._closeError);
        }
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.



class $08a566f4dc72581e$export$f0d4dc62ec317948 {
    constructor(httpClient, accessTokenFactory, logger, options){
        this._httpClient = httpClient;
        this._accessTokenFactory = accessTokenFactory;
        this._logger = logger;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isIn(transferFormat, (0, $8f9633606a43bad2$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(SSE transport) Connecting.");
        // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send
        this._url = url;
        if (this._accessTokenFactory) {
            const token = await this._accessTokenFactory();
            if (token) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
        }
        return new Promise((resolve, reject)=>{
            let opened = false;
            if (transferFormat !== (0, $8f9633606a43bad2$export$f29afaa8e8d2989a).Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
            }
            let eventSource;
            if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isBrowser || (0, $66662b1851d50501$export$2dffd0b5373a4389).isWebWorker) eventSource = new this._options.EventSource(url, {
                withCredentials: this._options.withCredentials
            });
            else {
                // Non-browser passes cookies via the dictionary
                const cookies = this._httpClient.getCookieString(url);
                const headers = {};
                headers.Cookie = cookies;
                const [name, value] = (0, $66662b1851d50501$export$56c7340f89ca57c5)();
                headers[name] = value;
                eventSource = new this._options.EventSource(url, {
                    withCredentials: this._options.withCredentials,
                    headers: {
                        ...headers,
                        ...this._options.headers
                    }
                });
            }
            try {
                eventSource.onmessage = (e)=>{
                    if (this.onreceive) try {
                        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(SSE transport) data received. ${(0, $66662b1851d50501$export$a688b91586df8fd9)(e.data, this._options.logMessageContent)}.`);
                        this.onreceive(e.data);
                    } catch (error) {
                        this._close(error);
                        return;
                    }
                };
                // @ts-ignore: not using event on purpose
                eventSource.onerror = (e)=>{
                    // EventSource doesn't give any useful information about server side closes.
                    if (opened) this._close();
                    else reject(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
                };
                eventSource.onopen = ()=>{
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `SSE connected to ${this._url}`);
                    this._eventSource = eventSource;
                    opened = true;
                    resolve();
                };
            } catch (e) {
                reject(e);
                return;
            }
        });
    }
    async send(data) {
        if (!this._eventSource) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $66662b1851d50501$export$465cb47180de50f0)(this._logger, "SSE", this._httpClient, this._url, this._accessTokenFactory, data, this._options);
    }
    stop() {
        this._close();
        return Promise.resolve();
    }
    _close(e) {
        if (this._eventSource) {
            this._eventSource.close();
            this._eventSource = undefined;
            if (this.onclose) this.onclose(e);
        }
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.




class $916a3d5ca3891d7c$export$de21836fc42c6f9c {
    constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers){
        this._logger = logger;
        this._accessTokenFactory = accessTokenFactory;
        this._logMessageContent = logMessageContent;
        this._webSocketConstructor = webSocketConstructor;
        this._httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this._headers = headers;
    }
    async connect(url, transferFormat) {
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isIn(transferFormat, (0, $8f9633606a43bad2$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(WebSockets transport) Connecting.");
        if (this._accessTokenFactory) {
            const token = await this._accessTokenFactory();
            if (token) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
        }
        return new Promise((resolve, reject)=>{
            url = url.replace(/^http/, "ws");
            let webSocket;
            const cookies = this._httpClient.getCookieString(url);
            let opened = false;
            if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isNode) {
                const headers = {};
                const [name, value] = (0, $66662b1851d50501$export$56c7340f89ca57c5)();
                headers[name] = value;
                if (cookies) headers[(0, $810de70b061002ad$export$28d77f87efed1d88).Cookie] = `${cookies}`;
                // Only pass headers when in non-browser environments
                webSocket = new this._webSocketConstructor(url, undefined, {
                    headers: {
                        ...headers,
                        ...this._headers
                    }
                });
            }
            if (!webSocket) // Chrome is not happy with passing 'undefined' as protocol
            webSocket = new this._webSocketConstructor(url);
            if (transferFormat === (0, $8f9633606a43bad2$export$f29afaa8e8d2989a).Binary) webSocket.binaryType = "arraybuffer";
            webSocket.onopen = (_event)=>{
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `WebSocket connected to ${url}.`);
                this._webSocket = webSocket;
                opened = true;
                resolve();
            };
            webSocket.onerror = (event)=>{
                let error = null;
                // ErrorEvent is a browser only type we need to check if the type exists before using it
                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                else error = "There was an error with the transport";
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `(WebSockets transport) ${error}.`);
            };
            webSocket.onmessage = (message)=>{
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(WebSockets transport) data received. ${(0, $66662b1851d50501$export$a688b91586df8fd9)(message.data, this._logMessageContent)}.`);
                if (this.onreceive) try {
                    this.onreceive(message.data);
                } catch (error) {
                    this._close(error);
                    return;
                }
            };
            webSocket.onclose = (event)=>{
                // Don't call close handler if connection was never established
                // We'll reject the connect call instead
                if (opened) this._close(event);
                else {
                    let error = null;
                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                    else error = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.";
                    reject(new Error(error));
                }
            };
        });
    }
    send(data) {
        if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, `(WebSockets transport) sending data. ${(0, $66662b1851d50501$export$a688b91586df8fd9)(data, this._logMessageContent)}.`);
            this._webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    }
    stop() {
        if (this._webSocket) // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
        // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
        this._close(undefined);
        return Promise.resolve();
    }
    _close(event) {
        // webSocket will be null if the transport did not start successfully
        if (this._webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this._webSocket.onclose = ()=>{};
            this._webSocket.onmessage = ()=>{};
            this._webSocket.onerror = ()=>{};
            this._webSocket.close();
            this._webSocket = undefined;
        }
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
            else if (event instanceof Error) this.onclose(event);
            else this.onclose();
        }
    }
    _isCloseEvent(event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
}


const $aa7d054057283faf$var$MAX_REDIRECTS = 100;
class $aa7d054057283faf$export$13c1f9cf8a283575 {
    constructor(url, options = {}){
        this._stopPromiseResolver = ()=>{};
        this.features = {};
        this._negotiateVersion = 1;
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(url, "url");
        this._logger = (0, $66662b1851d50501$export$fe2e61603b61130d)(options.logger);
        this.baseUrl = this._resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        else throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        options.timeout = options.timeout === undefined ? 100000 : options.timeout;
        let webSocketModule = null;
        let eventSourceModule = null;
        if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isNode && true) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!(0, $66662b1851d50501$export$2dffd0b5373a4389).isNode && typeof WebSocket !== "undefined" && !options.WebSocket) options.WebSocket = WebSocket;
        else if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isNode && !options.WebSocket) {
            if (webSocketModule) options.WebSocket = webSocketModule;
        }
        if (!(0, $66662b1851d50501$export$2dffd0b5373a4389).isNode && typeof EventSource !== "undefined" && !options.EventSource) options.EventSource = EventSource;
        else if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") options.EventSource = eventSourceModule;
        }
        this._httpClient = options.httpClient || new (0, $382b20375fb1717a$export$4f11ab3560c519e5)(this._logger);
        this._connectionState = "Disconnected" /* Disconnected */ ;
        this._connectionStarted = false;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async start(transferFormat) {
        transferFormat = transferFormat || (0, $8f9633606a43bad2$export$f29afaa8e8d2989a).Binary;
        (0, $66662b1851d50501$export$83f0753fc4347e43).isIn(transferFormat, (0, $8f9633606a43bad2$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Starting connection with transfer format '${(0, $8f9633606a43bad2$export$f29afaa8e8d2989a)[transferFormat]}'.`);
        if (this._connectionState !== "Disconnected" /* Disconnected */ ) return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        this._connectionState = "Connecting" /* Connecting */ ;
        this._startInternalPromise = this._startInternal(transferFormat);
        await this._startInternalPromise;
        // The TypeScript compiler thinks that connectionState must be Connecting here. The TypeScript compiler is wrong.
        if (this._connectionState === "Disconnecting" /* Disconnecting */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "Failed to start the HttpConnection before stop() was called.";
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, message);
            // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
            await this._stopPromise;
            return Promise.reject(new Error(message));
        } else if (this._connectionState !== "Connected" /* Connected */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, message);
            return Promise.reject(new Error(message));
        }
        this._connectionStarted = true;
    }
    send(data) {
        if (this._connectionState !== "Connected" /* Connected */ ) return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        if (!this._sendQueue) this._sendQueue = new $aa7d054057283faf$export$ff09921d3884e946(this.transport);
        // Transport will not be null if state is connected
        return this._sendQueue.send(data);
    }
    async stop(error) {
        if (this._connectionState === "Disconnected" /* Disconnected */ ) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === "Disconnecting" /* Disconnecting */ ) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = "Disconnecting" /* Disconnecting */ ;
        this._stopPromise = new Promise((resolve)=>{
            // Don't complete stop() until stopConnection() completes.
            this._stopPromiseResolver = resolve;
        });
        // stopInternal should never throw so just observe it.
        await this._stopInternal(error);
        await this._stopPromise;
    }
    async _stopInternal(error) {
        // Set error as soon as possible otherwise there is a race between
        // the transport closing and providing an error and the error from a close message
        // We would prefer the close message error.
        this._stopError = error;
        try {
            await this._startInternalPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
        // The transport's onclose will trigger stopConnection which will run our onclose event.
        // The transport should always be set if currently connected. If it wasn't set, it's likely because
        // stop was called during start() and start() failed.
        if (this.transport) {
            try {
                await this.transport.stop();
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `HttpConnection.transport.stop() threw error '${e}'.`);
                this._stopConnection();
            }
            this.transport = undefined;
        } else this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
    }
    async _startInternal(transferFormat) {
        // Store the original base url and the access token factory since they may change
        // as part of negotiating
        let url = this.baseUrl;
        this._accessTokenFactory = this._options.accessTokenFactory;
        try {
            if (this._options.skipNegotiation) {
                if (this._options.transport === (0, $8f9633606a43bad2$export$789ba40ee1a75f0).WebSockets) {
                    // No need to add a connection ID in this case
                    this.transport = this._constructTransport((0, $8f9633606a43bad2$export$789ba40ee1a75f0).WebSockets);
                    // We should just call connect directly in this case.
                    // No fallback or negotiate in this case.
                    await this._startTransport(url, transferFormat);
                } else throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            } else {
                let negotiateResponse = null;
                let redirects = 0;
                do {
                    negotiateResponse = await this._getNegotiationResponse(url);
                    // the user tries to stop the connection when it is being started
                    if (this._connectionState === "Disconnecting" /* Disconnecting */  || this._connectionState === "Disconnected" /* Disconnected */ ) throw new Error("The connection was stopped during negotiation.");
                    if (negotiateResponse.error) throw new Error(negotiateResponse.error);
                    if (negotiateResponse.ProtocolVersion) throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    if (negotiateResponse.url) url = negotiateResponse.url;
                    if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        const accessToken = negotiateResponse.accessToken;
                        this._accessTokenFactory = ()=>accessToken;
                    }
                    redirects++;
                }while (negotiateResponse.url && redirects < $aa7d054057283faf$var$MAX_REDIRECTS);
                if (redirects === $aa7d054057283faf$var$MAX_REDIRECTS && negotiateResponse.url) throw new Error("Negotiate redirection limit exceeded.");
                await this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            }
            if (this.transport instanceof (0, $fdd040ad08aec854$export$fbd8c90d2cca1300)) this.features.inherentKeepAlive = true;
            if (this._connectionState === "Connecting" /* Connecting */ ) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* Connected */ ;
            }
        // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
        // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
        // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
        } catch (e) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, "Failed to start the connection: " + e);
            this._connectionState = "Disconnected" /* Disconnected */ ;
            this.transport = undefined;
            // if start fails, any active calls to stop assume that start will complete the stop promise
            this._stopPromiseResolver();
            return Promise.reject(e);
        }
    }
    async _getNegotiationResponse(url) {
        const headers = {};
        if (this._accessTokenFactory) {
            const token = await this._accessTokenFactory();
            if (token) headers[(0, $810de70b061002ad$export$28d77f87efed1d88).Authorization] = `Bearer ${token}`;
        }
        const [name, value] = (0, $66662b1851d50501$export$56c7340f89ca57c5)();
        headers[name] = value;
        const negotiateUrl = this._resolveNegotiateUrl(url);
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Sending negotiation request: ${negotiateUrl}.`);
        try {
            const response = await this._httpClient.post(negotiateUrl, {
                content: "",
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            });
            if (response.statusCode !== 200) return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
            const negotiateResponse = JSON.parse(response.content);
            if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) // Negotiate version 0 doesn't use connectionToken
            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
            negotiateResponse.connectionToken = negotiateResponse.connectionId;
            return negotiateResponse;
        } catch (e) {
            let errorMessage = "Failed to complete negotiation with the server: " + e;
            if (e instanceof (0, $21942b33248eb90a$export$65bd6083489bd8bb)) {
                if (e.statusCode === 404) errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
            }
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, errorMessage);
            return Promise.reject(new (0, $21942b33248eb90a$export$b4f59905103de78d)(errorMessage));
        }
    }
    _createConnectUrl(url, connectionToken) {
        if (!connectionToken) return url;
        return url + (url.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
    }
    async _createTransport(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        let connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
        if (this._isITransport(requestedTransport)) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Connection was provided an instance of ITransport, using that directly.");
            this.transport = requestedTransport;
            await this._startTransport(connectUrl, requestedTransferFormat);
            this.connectionId = negotiateResponse.connectionId;
            return;
        }
        const transportExceptions = [];
        const transports = negotiateResponse.availableTransports || [];
        let negotiate = negotiateResponse;
        for (const endpoint of transports){
            const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat);
            if (transportOrError instanceof Error) {
                // Store the error and continue, we don't want to cause a re-negotiate in these cases
                transportExceptions.push(`${endpoint.transport} failed:`);
                transportExceptions.push(transportOrError);
            } else if (this._isITransport(transportOrError)) {
                this.transport = transportOrError;
                if (!negotiate) {
                    try {
                        negotiate = await this._getNegotiationResponse(url);
                    } catch (ex) {
                        return Promise.reject(ex);
                    }
                    connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
                }
                try {
                    await this._startTransport(connectUrl, requestedTransferFormat);
                    this.connectionId = negotiate.connectionId;
                    return;
                } catch (ex) {
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
                    negotiate = undefined;
                    transportExceptions.push(new (0, $21942b33248eb90a$export$264839a6ea29f91a)(`${endpoint.transport} failed: ${ex}`, (0, $8f9633606a43bad2$export$789ba40ee1a75f0)[endpoint.transport]));
                    if (this._connectionState !== "Connecting" /* Connecting */ ) {
                        const message = "Failed to select transport before stop() was called.";
                        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, message);
                        return Promise.reject(new Error(message));
                    }
                }
            }
        }
        if (transportExceptions.length > 0) return Promise.reject(new (0, $21942b33248eb90a$export$9341e26d19ed3783)(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
        return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
    }
    _constructTransport(transport) {
        switch(transport){
            case (0, $8f9633606a43bad2$export$789ba40ee1a75f0).WebSockets:
                if (!this._options.WebSocket) throw new Error("'WebSocket' is not supported in your environment.");
                return new (0, $916a3d5ca3891d7c$export$de21836fc42c6f9c)(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
            case (0, $8f9633606a43bad2$export$789ba40ee1a75f0).ServerSentEvents:
                if (!this._options.EventSource) throw new Error("'EventSource' is not supported in your environment.");
                return new (0, $08a566f4dc72581e$export$f0d4dc62ec317948)(this._httpClient, this._accessTokenFactory, this._logger, this._options);
            case (0, $8f9633606a43bad2$export$789ba40ee1a75f0).LongPolling:
                return new (0, $fdd040ad08aec854$export$fbd8c90d2cca1300)(this._httpClient, this._accessTokenFactory, this._logger, this._options);
            default:
                throw new Error(`Unknown transport: ${transport}.`);
        }
    }
    _startTransport(url, transferFormat) {
        this.transport.onreceive = this.onreceive;
        this.transport.onclose = (e)=>this._stopConnection(e);
        return this.transport.connect(url, transferFormat);
    }
    _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat) {
        const transport = (0, $8f9633606a43bad2$export$789ba40ee1a75f0)[endpoint.transport];
        if (transport === null || transport === undefined) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
            return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
        } else if ($aa7d054057283faf$var$transportMatches(requestedTransport, transport)) {
            const transferFormats = endpoint.transferFormats.map((s)=>(0, $8f9633606a43bad2$export$f29afaa8e8d2989a)[s]);
            if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                if (transport === (0, $8f9633606a43bad2$export$789ba40ee1a75f0).WebSockets && !this._options.WebSocket || transport === (0, $8f9633606a43bad2$export$789ba40ee1a75f0).ServerSentEvents && !this._options.EventSource) {
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}' because it is not supported in your environment.'`);
                    return new (0, $21942b33248eb90a$export$c7cbd7482d8bece8)(`'${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}' is not supported in your environment.`, transport);
                } else {
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Selecting transport '${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}'.`);
                    try {
                        return this._constructTransport(transport);
                    } catch (ex) {
                        return ex;
                    }
                }
            } else {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}' because it does not support the requested transfer format '${(0, $8f9633606a43bad2$export$f29afaa8e8d2989a)[requestedTransferFormat]}'.`);
                return new Error(`'${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}' does not support ${(0, $8f9633606a43bad2$export$f29afaa8e8d2989a)[requestedTransferFormat]}.`);
            }
        } else {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}' because it was disabled by the client.`);
            return new (0, $21942b33248eb90a$export$764b8cd64449c5b0)(`'${(0, $8f9633606a43bad2$export$789ba40ee1a75f0)[transport]}' is disabled by the client.`, transport);
        }
    }
    _isITransport(transport) {
        return transport && typeof transport === "object" && "connect" in transport;
    }
    _stopConnection(error) {
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `HttpConnection.stopConnection(${error}) called while in state ${this._connectionState}.`);
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this._stopError || error;
        this._stopError = undefined;
        if (this._connectionState === "Disconnected" /* Disconnected */ ) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is already in the disconnected state.`);
            return;
        }
        if (this._connectionState === "Connecting" /* Connecting */ ) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is still in the connecting state.`);
            throw new Error(`HttpConnection.stopConnection(${error}) was called while the connection is still in the connecting state.`);
        }
        if (this._connectionState === "Disconnecting" /* Disconnecting */ ) // A call to stop() induced this call to stopConnection and needs to be completed.
        // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
        this._stopPromiseResolver();
        if (error) this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `Connection disconnected with error '${error}'.`);
        else this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, "Connection disconnected.");
        if (this._sendQueue) {
            this._sendQueue.stop().catch((e)=>{
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `TransportSendQueue.stop() threw error '${e}'.`);
            });
            this._sendQueue = undefined;
        }
        this.connectionId = undefined;
        this._connectionState = "Disconnected" /* Disconnected */ ;
        if (this._connectionStarted) {
            this._connectionStarted = false;
            try {
                if (this.onclose) this.onclose(error);
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `HttpConnection.onclose(${error}) threw error '${e}'.`);
            }
        }
    }
    _resolveUrl(url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) return url;
        if (!(0, $66662b1851d50501$export$2dffd0b5373a4389).isBrowser) throw new Error(`Cannot resolve '${url}'.`);
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        const aTag = window.document.createElement("a");
        aTag.href = url;
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `Normalizing '${url}' to '${aTag.href}'.`);
        return aTag.href;
    }
    _resolveNegotiateUrl(url) {
        const index = url.indexOf("?");
        let negotiateUrl = url.substring(0, index === -1 ? url.length : index);
        if (negotiateUrl[negotiateUrl.length - 1] !== "/") negotiateUrl += "/";
        negotiateUrl += "negotiate";
        negotiateUrl += index === -1 ? "" : url.substring(index);
        if (negotiateUrl.indexOf("negotiateVersion") === -1) {
            negotiateUrl += index === -1 ? "?" : "&";
            negotiateUrl += "negotiateVersion=" + this._negotiateVersion;
        }
        return negotiateUrl;
    }
}
function $aa7d054057283faf$var$transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
class $aa7d054057283faf$export$ff09921d3884e946 {
    constructor(_transport){
        this._transport = _transport;
        this._buffer = [];
        this._executing = true;
        this._sendBufferedData = new $aa7d054057283faf$var$PromiseSource();
        this._transportResult = new $aa7d054057283faf$var$PromiseSource();
        this._sendLoopPromise = this._sendLoop();
    }
    send(data) {
        this._bufferData(data);
        if (!this._transportResult) this._transportResult = new $aa7d054057283faf$var$PromiseSource();
        return this._transportResult.promise;
    }
    stop() {
        this._executing = false;
        this._sendBufferedData.resolve();
        return this._sendLoopPromise;
    }
    _bufferData(data) {
        if (this._buffer.length && typeof this._buffer[0] !== typeof data) throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof data}`);
        this._buffer.push(data);
        this._sendBufferedData.resolve();
    }
    async _sendLoop() {
        while(true){
            await this._sendBufferedData.promise;
            if (!this._executing) {
                if (this._transportResult) this._transportResult.reject("Connection stopped.");
                break;
            }
            this._sendBufferedData = new $aa7d054057283faf$var$PromiseSource();
            const transportResult = this._transportResult;
            this._transportResult = undefined;
            const data = typeof this._buffer[0] === "string" ? this._buffer.join("") : $aa7d054057283faf$export$ff09921d3884e946._concatBuffers(this._buffer);
            this._buffer.length = 0;
            try {
                await this._transport.send(data);
                transportResult.resolve();
            } catch (error) {
                transportResult.reject(error);
            }
        }
    }
    static _concatBuffers(arrayBuffers) {
        const totalLength = arrayBuffers.map((b)=>b.byteLength).reduce((a, b)=>a + b);
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const item of arrayBuffers){
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    }
}
class $aa7d054057283faf$var$PromiseSource {
    constructor(){
        this.promise = new Promise((resolve, reject)=>([this._resolver, this._rejecter] = [
                resolve,
                reject
            ]));
    }
    resolve() {
        this._resolver();
    }
    reject(reason) {
        this._rejecter(reason);
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Not exported from index
/** @private */ class $56f95e86a168c3ea$export$fc2e5d47850f626b {
    static write(output) {
        return `${output}${$56f95e86a168c3ea$export$fc2e5d47850f626b.RecordSeparator}`;
    }
    static parse(input) {
        if (input[input.length - 1] !== $56f95e86a168c3ea$export$fc2e5d47850f626b.RecordSeparator) throw new Error("Message is incomplete.");
        const messages = input.split($56f95e86a168c3ea$export$fc2e5d47850f626b.RecordSeparator);
        messages.pop();
        return messages;
    }
}
$56f95e86a168c3ea$export$fc2e5d47850f626b.RecordSeparatorCode = 0x1e;
$56f95e86a168c3ea$export$fc2e5d47850f626b.RecordSeparator = String.fromCharCode($56f95e86a168c3ea$export$fc2e5d47850f626b.RecordSeparatorCode);



class $a6d0d2d9b6d8815c$export$b23df48528d3f5f4 {
    // Handshake request is always JSON
    writeHandshakeRequest(handshakeRequest) {
        return (0, $56f95e86a168c3ea$export$fc2e5d47850f626b).write(JSON.stringify(handshakeRequest));
    }
    parseHandshakeResponse(data) {
        let messageData;
        let remainingData;
        if ((0, $66662b1851d50501$export$9dd3754ae86f0017)(data)) {
            // Format is binary but still need to read JSON text from handshake response
            const binaryData = new Uint8Array(data);
            const separatorIndex = binaryData.indexOf((0, $56f95e86a168c3ea$export$fc2e5d47850f626b).RecordSeparatorCode);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
            remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
        } else {
            const textData = data;
            const separatorIndex = textData.indexOf((0, $56f95e86a168c3ea$export$fc2e5d47850f626b).RecordSeparator);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = textData.length > responseLength ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        const messages = (0, $56f95e86a168c3ea$export$fc2e5d47850f626b).parse(messageData);
        const response = JSON.parse(messages[0]);
        if (response.type) throw new Error("Expected a handshake response from the server.");
        const responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [
            remainingData,
            responseMessage
        ];
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Defines the type of a Hub Message. */ var $2fb2f07f3d4dcbca$export$80edbf15fa61a4db;
(function(MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */ MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */ MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */ MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */ MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */ MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */ MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */ MessageType[MessageType["Close"] = 7] = "Close";
})($2fb2f07f3d4dcbca$export$80edbf15fa61a4db || ($2fb2f07f3d4dcbca$export$80edbf15fa61a4db = {}));



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

class $97cdf4597fb0e1c9$export$b6bbab5a9b109038 {
    constructor(){
        this.observers = [];
    }
    next(item) {
        for (const observer of this.observers)observer.next(item);
    }
    error(err) {
        for (const observer of this.observers)if (observer.error) observer.error(err);
    }
    complete() {
        for (const observer of this.observers)if (observer.complete) observer.complete();
    }
    subscribe(observer) {
        this.observers.push(observer);
        return new (0, $66662b1851d50501$export$b7a41f2bfb5c60c3)(this, observer);
    }
}



const $8892701a02b0e3c0$var$DEFAULT_TIMEOUT_IN_MS = 30000;
const $8892701a02b0e3c0$var$DEFAULT_PING_INTERVAL_IN_MS = 15000;
var $8892701a02b0e3c0$export$b8b4168ab851a6c3;
(function(HubConnectionState) {
    /** The hub connection is disconnected. */ HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */ HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */ HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */ HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */ HubConnectionState["Reconnecting"] = "Reconnecting";
})($8892701a02b0e3c0$export$b8b4168ab851a6c3 || ($8892701a02b0e3c0$export$b8b4168ab851a6c3 = {}));
class $8892701a02b0e3c0$export$e5dbe756ed73e8c8 {
    constructor(connection, logger, protocol, reconnectPolicy){
        this._nextKeepAlive = 0;
        this._freezeEventListener = ()=>{
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://docs.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        };
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(connection, "connection");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(logger, "logger");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = $8892701a02b0e3c0$var$DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = $8892701a02b0e3c0$var$DEFAULT_PING_INTERVAL_IN_MS;
        this._logger = logger;
        this._protocol = protocol;
        this.connection = connection;
        this._reconnectPolicy = reconnectPolicy;
        this._handshakeProtocol = new (0, $a6d0d2d9b6d8815c$export$b23df48528d3f5f4)();
        this.connection.onreceive = (data)=>this._processIncomingData(data);
        this.connection.onclose = (error)=>this._connectionClosed(error);
        this._callbacks = {};
        this._methods = {};
        this._closedCallbacks = [];
        this._reconnectingCallbacks = [];
        this._reconnectedCallbacks = [];
        this._invocationId = 0;
        this._receivedHandshakeResponse = false;
        this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnected;
        this._connectionStarted = false;
        this._cachedPingMessage = this._protocol.writeMessage({
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Ping
        });
    }
    /** @internal */ // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    static create(connection, logger, protocol, reconnectPolicy) {
        return new $8892701a02b0e3c0$export$e5dbe756ed73e8c8(connection, logger, protocol, reconnectPolicy);
    }
    /** Indicates the state of the {@link HubConnection} to the server. */ get state() {
        return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */ get connectionId() {
        return this.connection ? this.connection.connectionId || null : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */ get baseUrl() {
        return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */ set baseUrl(url) {
        if (this._connectionState !== $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnected && this._connectionState !== $8892701a02b0e3c0$export$b8b4168ab851a6c3.Reconnecting) throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        if (!url) throw new Error("The HubConnection url must be a valid url.");
        this.connection.baseUrl = url;
    }
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */ start() {
        this._startPromise = this._startWithStateTransitions();
        return this._startPromise;
    }
    async _startWithStateTransitions() {
        if (this._connectionState !== $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnected) return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Connecting;
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Starting HubConnection.");
        try {
            await this._startInternal();
            if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isBrowser) // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
            window.document.addEventListener("freeze", this._freezeEventListener);
            this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Connected;
            this._connectionStarted = true;
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "HubConnection connected successfully.");
        } catch (e) {
            this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnected;
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `HubConnection failed to start successfully because of error '${e}'.`);
            return Promise.reject(e);
        }
    }
    async _startInternal() {
        this._stopDuringStartError = undefined;
        this._receivedHandshakeResponse = false;
        // Set up the promise before any connection is (re)started otherwise it could race with received messages
        const handshakePromise = new Promise((resolve, reject)=>{
            this._handshakeResolver = resolve;
            this._handshakeRejecter = reject;
        });
        await this.connection.start(this._protocol.transferFormat);
        try {
            const handshakeRequest = {
                protocol: this._protocol.name,
                version: this._protocol.version
            };
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Sending handshake request.");
            await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `Using HubProtocol '${this._protocol.name}'.`);
            // defensively cleanup timeout in case we receive a message from the server before we finish start
            this._cleanupTimeout();
            this._resetTimeoutPeriod();
            this._resetKeepAliveInterval();
            await handshakePromise;
            // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
            // being rejected on close, because this continuation can run after both the handshake completed successfully
            // and the connection was closed.
            if (this._stopDuringStartError) // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
            // will cause the calling continuation to get scheduled to run later.
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw this._stopDuringStartError;
        } catch (e) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
            this._cleanupTimeout();
            this._cleanupPingTimer();
            // HttpConnection.stop() should not complete until after the onclose callback is invoked.
            // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
            await this.connection.stop(e);
            throw e;
        }
    }
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */ async stop() {
        // Capture the start promise before the connection might be restarted in an onclose callback.
        const startPromise = this._startPromise;
        this._stopPromise = this._stopInternal();
        await this._stopPromise;
        try {
            // Awaiting undefined continues immediately
            await startPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
    }
    _stopInternal(error) {
        if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnected) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Call to HubConnection.stop(${error}) ignored because it is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnecting) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnecting;
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Stopping HubConnection.");
        if (this._reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this._reconnectDelayHandle);
            this._reconnectDelayHandle = undefined;
            this._completeClose();
            return Promise.resolve();
        }
        this._cleanupTimeout();
        this._cleanupPingTimer();
        this._stopDuringStartError = error || new Error("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */ stream(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
        // eslint-disable-next-line prefer-const
        let promiseQueue;
        const subject = new (0, $97cdf4597fb0e1c9$export$b6bbab5a9b109038)();
        subject.cancelCallback = ()=>{
            const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
            delete this._callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(()=>{
                return this._sendWithProtocol(cancelInvocation);
            });
        };
        this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
            if (error) {
                subject.error(error);
                return;
            } else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion) {
                    if (invocationEvent.error) subject.error(new Error(invocationEvent.error));
                    else subject.complete();
                } else subject.next(invocationEvent.item);
            }
        };
        promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
            subject.error(e);
            delete this._callbacks[invocationDescriptor.invocationId];
        });
        this._launchStreams(streams, promiseQueue);
        return subject;
    }
    _sendMessage(message) {
        this._resetKeepAliveInterval();
        return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */ _sendWithProtocol(message) {
        return this._sendMessage(this._protocol.writeMessage(message));
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */ send(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
        this._launchStreams(streams, sendPromise);
        return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */ invoke(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
        const p = new Promise((resolve, reject)=>{
            // invocationId will always have a value for a non-blocking invocation
            this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
                if (error) {
                    reject(error);
                    return;
                } else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion) {
                        if (invocationEvent.error) reject(new Error(invocationEvent.error));
                        else resolve(invocationEvent.result);
                    } else reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
                }
            };
            const promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete this._callbacks[invocationDescriptor.invocationId];
            });
            this._launchStreams(streams, promiseQueue);
        });
        return p;
    }
    /** Registers a handler that will be invoked when the hub method with the specified method name is invoked.
     *
     * @param {string} methodName The name of the hub method to define.
     * @param {Function} newMethod The handler that will be raised when the hub method is invoked.
     */ on(methodName, newMethod) {
        if (!methodName || !newMethod) return;
        methodName = methodName.toLowerCase();
        if (!this._methods[methodName]) this._methods[methodName] = [];
        // Preventing adding the same handler multiple times.
        if (this._methods[methodName].indexOf(newMethod) !== -1) return;
        this._methods[methodName].push(newMethod);
    }
    off(methodName, method) {
        if (!methodName) return;
        methodName = methodName.toLowerCase();
        const handlers = this._methods[methodName];
        if (!handlers) return;
        if (method) {
            const removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) delete this._methods[methodName];
            }
        } else delete this._methods[methodName];
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */ onclose(callback) {
        if (callback) this._closedCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */ onreconnecting(callback) {
        if (callback) this._reconnectingCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */ onreconnected(callback) {
        if (callback) this._reconnectedCallbacks.push(callback);
    }
    _processIncomingData(data) {
        this._cleanupTimeout();
        if (!this._receivedHandshakeResponse) {
            data = this._processHandshakeResponse(data);
            this._receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            const messages = this._protocol.parseMessages(data, this._logger);
            for (const message of messages)switch(message.type){
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Invocation:
                    this._invokeClientMethod(message);
                    break;
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).StreamItem:
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion:
                    {
                        const callback = this._callbacks[message.invocationId];
                        if (callback) {
                            if (message.type === (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion) delete this._callbacks[message.invocationId];
                            try {
                                callback(message);
                            } catch (e) {
                                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `Stream callback threw error: ${(0, $66662b1851d50501$export$375b49718dbd9ced)(e)}`);
                            }
                        }
                        break;
                    }
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Ping:
                    break;
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Close:
                    {
                        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, "Close message received from server.");
                        const error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                        if (message.allowReconnect === true) // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                        // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        this.connection.stop(error);
                        else // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                        this._stopPromise = this._stopInternal(error);
                        break;
                    }
                default:
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `Invalid message type: ${message.type}.`);
                    break;
            }
        }
        this._resetTimeoutPeriod();
    }
    _processHandshakeResponse(data) {
        let responseMessage;
        let remainingData;
        try {
            [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data);
        } catch (e) {
            const message = "Error parsing handshake response: " + e;
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            const message = "Server returned handshake error: " + responseMessage.error;
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        } else this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Server handshake complete.");
        this._handshakeResolver();
        return remainingData;
    }
    _resetKeepAliveInterval() {
        if (this.connection.features.inherentKeepAlive) return;
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this._cleanupPingTimer();
    }
    _resetTimeoutPeriod() {
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this._timeoutHandle = setTimeout(()=>this.serverTimeout(), this.serverTimeoutInMilliseconds);
            // Set keepAlive timer if there isn't one
            if (this._pingServerHandle === undefined) {
                let nextPing = this._nextKeepAlive - new Date().getTime();
                if (nextPing < 0) nextPing = 0;
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this._pingServerHandle = setTimeout(async ()=>{
                    if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Connected) try {
                        await this._sendMessage(this._cachedPingMessage);
                    } catch  {
                        // We don't care about the error. It should be seen elsewhere in the client.
                        // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                        this._cleanupPingTimer();
                    }
                }, nextPing);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    serverTimeout() {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
    _invokeClientMethod(invocationMessage) {
        const methods = this._methods[invocationMessage.target.toLowerCase()];
        if (methods) {
            try {
                methods.forEach((m)=>m.apply(this, invocationMessage.arguments));
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `A callback for the method ${invocationMessage.target.toLowerCase()} threw error '${e}'.`);
            }
            if (invocationMessage.invocationId) {
                // This is not supported in v1. So we return an error to avoid blocking the server waiting for the response.
                const message = "Server requested a response, which is not supported in this version of the client.";
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, message);
                // We don't want to wait on the stop itself.
                this._stopPromise = this._stopInternal(new Error(message));
            }
        } else this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning, `No client method with the name '${invocationMessage.target}' found.`);
    }
    _connectionClosed(error) {
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `HubConnection.connectionClosed(${error}) called while in state ${this._connectionState}.`);
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this._stopDuringStartError = this._stopDuringStartError || error || new Error("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this._handshakeResolver) this._handshakeResolver();
        this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this._cleanupTimeout();
        this._cleanupPingTimer();
        if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnecting) this._completeClose(error);
        else if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Connected && this._reconnectPolicy) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._reconnect(error);
        else if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Connected) this._completeClose(error);
    // If none of the above if conditions were true were called the HubConnection must be in either:
    // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
    // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
    //    and potentially continue the reconnect() loop.
    // 3. The Disconnected state in which case we're already done.
    }
    _completeClose(error) {
        if (this._connectionStarted) {
            this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnected;
            this._connectionStarted = false;
            if ((0, $66662b1851d50501$export$2dffd0b5373a4389).isBrowser) window.document.removeEventListener("freeze", this._freezeEventListener);
            try {
                this._closedCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `An onclose callback called with error '${error}' threw error '${e}'.`);
            }
        }
    }
    async _reconnect(error) {
        const reconnectStartTime = Date.now();
        let previousReconnectAttempts = 0;
        let retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
        let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, 0, retryError);
        if (nextRetryDelay === null) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
            this._completeClose(error);
            return;
        }
        this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Reconnecting;
        if (error) this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `Connection reconnecting because of error '${error}'.`);
        else this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, "Connection reconnecting.");
        if (this._reconnectingCallbacks.length !== 0) {
            try {
                this._reconnectingCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `An onreconnecting callback called with error '${error}' threw error '${e}'.`);
            }
            // Exit early if an onreconnecting callback called connection.stop().
            if (this._connectionState !== $8892701a02b0e3c0$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                return;
            }
        }
        while(nextRetryDelay !== null){
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `Reconnect attempt number ${previousReconnectAttempts} will start in ${nextRetryDelay} ms.`);
            await new Promise((resolve)=>{
                this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
            });
            this._reconnectDelayHandle = undefined;
            if (this._connectionState !== $8892701a02b0e3c0$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                return;
            }
            try {
                await this._startInternal();
                this._connectionState = $8892701a02b0e3c0$export$b8b4168ab851a6c3.Connected;
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, "HubConnection reconnected successfully.");
                if (this._reconnectedCallbacks.length !== 0) try {
                    this._reconnectedCallbacks.forEach((c)=>c.apply(this, [
                            this.connection.connectionId
                        ]));
                } catch (e) {
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
                }
                return;
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `Reconnect attempt failed because of error '${e}'.`);
                if (this._connectionState !== $8892701a02b0e3c0$export$b8b4168ab851a6c3.Reconnecting) {
                    this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
                    // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                    if (this._connectionState === $8892701a02b0e3c0$export$b8b4168ab851a6c3.Disconnecting) this._completeClose();
                    return;
                }
                retryError = e instanceof Error ? e : new Error(e.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);
            }
        }
        this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
        this._completeClose();
    }
    _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this._reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason
            });
        } catch (e) {
            this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
            return null;
        }
    }
    _cancelCallbacksWithError(error) {
        const callbacks = this._callbacks;
        this._callbacks = {};
        Object.keys(callbacks).forEach((key)=>{
            const callback = callbacks[key];
            try {
                callback(null, error);
            } catch (e) {
                this._logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Error, `Stream 'error' callback called with '${error}' threw error: ${(0, $66662b1851d50501$export$375b49718dbd9ced)(e)}`);
            }
        });
    }
    _cleanupPingTimer() {
        if (this._pingServerHandle) {
            clearTimeout(this._pingServerHandle);
            this._pingServerHandle = undefined;
        }
    }
    _cleanupTimeout() {
        if (this._timeoutHandle) clearTimeout(this._timeoutHandle);
    }
    _createInvocation(methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) return {
                arguments: args,
                streamIds: streamIds,
                target: methodName,
                type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Invocation
            };
            else return {
                arguments: args,
                target: methodName,
                type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Invocation
            };
        } else {
            const invocationId = this._invocationId;
            this._invocationId++;
            if (streamIds.length !== 0) return {
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                target: methodName,
                type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Invocation
            };
            else return {
                arguments: args,
                invocationId: invocationId.toString(),
                target: methodName,
                type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Invocation
            };
        }
    }
    _launchStreams(streams, promiseQueue) {
        if (streams.length === 0) return;
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) promiseQueue = Promise.resolve();
        // We want to iterate over the keys, since the keys are the stream ids
        // eslint-disable-next-line guard-for-in
        for(const streamId in streams)streams[streamId].subscribe({
            complete: ()=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId)));
            },
            error: (err)=>{
                let message;
                if (err instanceof Error) message = err.message;
                else if (err && err.toString) message = err.toString();
                else message = "Unknown error";
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId, message)));
            },
            next: (item)=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createStreamItemMessage(streamId, item)));
            }
        });
    }
    _replaceStreamingParams(args) {
        const streams = [];
        const streamIds = [];
        for(let i = 0; i < args.length; i++){
            const argument = args[i];
            if (this._isObservable(argument)) {
                const streamId = this._invocationId;
                this._invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [
            streams,
            streamIds
        ];
    }
    _isObservable(arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
    _createStreamInvocation(methodName, args, streamIds) {
        const invocationId = this._invocationId;
        this._invocationId++;
        if (streamIds.length !== 0) return {
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            target: methodName,
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).StreamInvocation
        };
        else return {
            arguments: args,
            invocationId: invocationId.toString(),
            target: methodName,
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).StreamInvocation
        };
    }
    _createCancelInvocation(id) {
        return {
            invocationId: id,
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).CancelInvocation
        };
    }
    _createStreamItemMessage(id, item) {
        return {
            invocationId: id,
            item: item,
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).StreamItem
        };
    }
    _createCompletionMessage(id, error, result) {
        if (error) return {
            error: error,
            invocationId: id,
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion
        };
        return {
            invocationId: id,
            result: result,
            type: (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion
        };
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.





const $50a8cc3f8060098a$var$JSON_HUB_PROTOCOL_NAME = "json";
class $50a8cc3f8060098a$export$11f4f8ecec1ad0c8 {
    constructor(){
        /** @inheritDoc */ this.name = $50a8cc3f8060098a$var$JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */ this.version = 1;
        /** @inheritDoc */ this.transferFormat = (0, $8f9633606a43bad2$export$f29afaa8e8d2989a).Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */ parseMessages(input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        if (!input) return [];
        if (logger === null) logger = (0, $498197582861cc98$export$17ac58a1138ded46).instance;
        // Parse the messages
        const messages = (0, $56f95e86a168c3ea$export$fc2e5d47850f626b).parse(input);
        const hubMessages = [];
        for (const message of messages){
            const parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") throw new Error("Invalid payload.");
            switch(parsedMessage.type){
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Invocation:
                    this._isInvocationMessage(parsedMessage);
                    break;
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).StreamItem:
                    this._isStreamItemMessage(parsedMessage);
                    break;
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Completion:
                    this._isCompletionMessage(parsedMessage);
                    break;
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Ping:
                    break;
                case (0, $2fb2f07f3d4dcbca$export$80edbf15fa61a4db).Close:
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log((0, $85fb2f42146a105f$export$243e62d78d3b544d).Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */ writeMessage(message) {
        return (0, $56f95e86a168c3ea$export$fc2e5d47850f626b).write(JSON.stringify(message));
    }
    _isInvocationMessage(message) {
        this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
    }
    _isStreamItemMessage(message) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) throw new Error("Invalid payload for StreamItem message.");
    }
    _isCompletionMessage(message) {
        if (message.result && message.error) throw new Error("Invalid payload for Completion message.");
        if (!message.result && message.error) this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
    _assertNotEmptyString(value, errorMessage) {
        if (typeof value !== "string" || value === "") throw new Error(errorMessage);
    }
}




const $9fc508919e6538de$var$LogLevelNameMapping = {
    trace: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Trace,
    debug: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Debug,
    info: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Information,
    information: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Information,
    warn: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning,
    warning: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Warning,
    error: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Error,
    critical: (0, $85fb2f42146a105f$export$243e62d78d3b544d).Critical,
    none: (0, $85fb2f42146a105f$export$243e62d78d3b544d).None
};
function $9fc508919e6538de$var$parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    const mapping = $9fc508919e6538de$var$LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") return mapping;
    else throw new Error(`Unknown log level: ${name}`);
}
class $9fc508919e6538de$export$afccb10c24910b13 {
    configureLogging(logging) {
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(logging, "logging");
        if ($9fc508919e6538de$var$isLogger(logging)) this.logger = logging;
        else if (typeof logging === "string") {
            const logLevel = $9fc508919e6538de$var$parseLogLevel(logging);
            this.logger = new (0, $66662b1851d50501$export$ba6a9c7ac8291f7f)(logLevel);
        } else this.logger = new (0, $66662b1851d50501$export$ba6a9c7ac8291f7f)(logging);
        return this;
    }
    withUrl(url, transportTypeOrOptions) {
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $66662b1851d50501$export$83f0753fc4347e43).isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            ...transportTypeOrOptions
        };
        else this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            transport: transportTypeOrOptions
        };
        return this;
    }
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */ withHubProtocol(protocol) {
        (0, $66662b1851d50501$export$83f0753fc4347e43).isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    }
    withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) throw new Error("A reconnectPolicy has already been set.");
        if (!retryDelaysOrReconnectPolicy) this.reconnectPolicy = new (0, $ec175b2dab2affa1$export$97bc471d6a059e6e)();
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) this.reconnectPolicy = new (0, $ec175b2dab2affa1$export$97bc471d6a059e6e)(retryDelaysOrReconnectPolicy);
        else this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        return this;
    }
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */ build() {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        const httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
        httpConnectionOptions.logger = this.logger;
        // Now create the connection
        if (!this.url) throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        const connection = new (0, $aa7d054057283faf$export$13c1f9cf8a283575)(this.url, httpConnectionOptions);
        return (0, $8892701a02b0e3c0$export$e5dbe756ed73e8c8).create(connection, this.logger || (0, $498197582861cc98$export$17ac58a1138ded46).instance, this.protocol || new (0, $50a8cc3f8060098a$export$11f4f8ecec1ad0c8)(), this.reconnectPolicy);
    }
}
function $9fc508919e6538de$var$isLogger(logger) {
    return logger.log !== undefined;
}



var $gIfym = parcelRequire("gIfym");

const $6c05a81472ccb93d$export$b31f5acce7a54d48 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext();
const $6c05a81472ccb93d$var$wsUrl = "https://api.fenixbegravning.se/ws/v1";
function $6c05a81472ccb93d$export$bd1537e1f64b53aa() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext($6c05a81472ccb93d$export$b31f5acce7a54d48);
}
function $6c05a81472ccb93d$export$676472937f48f64({ children: children }) {
    const [connection, setConnection] = (0, $gIfym.useState)();
    const { user: user } = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    (0, $gIfym.useEffect)(()=>{
        if (user === undefined) return false;
        const conn = new $9fc508919e6538de$export$afccb10c24910b13().withUrl(`${$6c05a81472ccb93d$var$wsUrl}/notification/customer`).configureLogging($85fb2f42146a105f$export$243e62d78d3b544d.Error).build();
        if (user === null) {
            if (conn.connectionId !== null) {
                console.log("start ws disconnect");
                conn.stop().catch((error)=>{
                    console.log("Connection stop error = ", error);
                });
            }
            return;
        }
        if (user?.customerIdaAccountId && conn.connectionId === null) {
            conn.start().then(()=>{
                conn.invoke("RegisterUser", user.customerIdaAccountId).catch((error)=>{
                    console.log("Connection invoke 'RegisterUser' error = ", error);
                });
            }).catch((e)=>{
                console.log("Websocket connection failed", e);
            });
            setConnection(conn);
        }
        return ()=>{
            conn.stop();
        };
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($6c05a81472ccb93d$export$b31f5acce7a54d48.Provider, {
        value: connection,
        children: children
    });
}






var $b7c70b17b361e247$exports = {};
$b7c70b17b361e247$exports = $parcel$resolve("bKK12");


const $2cba180f1db851cc$var$iconNoMessages = new URL($b7c70b17b361e247$exports);
var $27327b95263ad420$exports = {};
$27327b95263ad420$exports = $parcel$resolve("bzfmz");


const $2cba180f1db851cc$var$iconNoMessagesWhite = new URL($27327b95263ad420$exports);
function $2cba180f1db851cc$export$2e2bcd8739ae039() {
    const [loadingSubmit, setLoadingSubmit] = (0, $gIfym.useState)(false);
    const [msg, setMsg] = (0, $gIfym.useState)("");
    const [msgInputHeight, setMsgInputHeight] = (0, $gIfym.useState)(1);
    const [messages, setMessages] = (0, $gIfym.useState)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const wsConnection = (0, $6c05a81472ccb93d$export$bd1537e1f64b53aa)();
    const user = auth.user;
    const controllerRef = (0, $gIfym.useRef)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    (0, $gIfym.useEffect)(()=>{
        if (!user || !wsConnection || !wsConnection.connectionId) return null;
        const controller = fetchMessages();
        const handler = ()=>setTimeout(()=>{
                fetchMessages();
            }, 1000);
        wsConnection.on("Customer_Message", handler);
        return ()=>{
            if (typeof controller === "object") controller.abort();
            wsConnection.off("Customer_Message", handler);
        };
    }, [
        user,
        wsConnection?.connectionId
    ]);
    function fetchMessages() {
        const orderId = user.customerIdaOrderId;
        if (orderId === undefined) return null;
        if (controllerRef.current) controllerRef.current.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        (0, $6c726320d527757b$export$8c20ab16ac9cf14f)(user, orderId, controllerRef).then((data)=>{
            if (data.success) return data.object;
            auth.addNotification(data.message);
        }).then((data)=>{
            if (data && data.length > 0) setMessages(data);
            else setMessages([]);
        }).catch((error)=>{
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
        controllerRef.current = null;
        return controller;
    }
    const handleMessageChange = (e)=>{
        const value = e.target.value;
        const countLines = [
            ...value.matchAll("\n")
        ].length;
        setMsg(value);
        setMsgInputHeight(countLines + 1);
    };
    const handleMessageSubmit = ()=>{
        if (auth.canSubmit() === false) {
            auth.addNotification(t("no-submit-access"));
            return false;
        }
        if (msg === "") return false;
        setLoadingSubmit(true);
        (0, $6c726320d527757b$export$465cb47180de50f0)(user, user.customerIdaOrderId, msg).then(()=>{
            fetchMessages();
            setLoadingSubmit(false);
            setMsg("");
            setMsgInputHeight(1);
        }).catch((error)=>{
            setLoadingSubmit(false);
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
    };
    const renderMessages = ()=>{
        let wrapperClass = "";
        let userIconClass = "bg-white text-dark-blue";
        let msgClass = "text-white px-4";
        let msgRowClass = "bg-[#072b36]";
        let submitWrapperClass = "bg-white rounded-[30]";
        let submitInputClass = "py-3 px-5 bg-transparent";
        let submitButtonClass = "items-center m-1 max-w-[100px]";
        let noMsgTextClass = "text-white";
        let noMsgImgClass = "";
        let noMsgImg = $2cba180f1db851cc$var$iconNoMessagesWhite;
        if ((0, $e845536d9724b5be$export$471f70c09cf8ab8c)()) {
            wrapperClass = "rounded-lg";
            userIconClass = "bg-dark-blue text-white";
            msgClass = "bg-white text-dark-blue px-5";
            msgRowClass = "bg-[#fafbfb]";
            submitWrapperClass = "m-3.5 mt-0 p-2";
            submitInputClass = "px-3 py-1 border-[#eaeaea] focus:border-[#eaeaea]";
            submitButtonClass = "max-w-[70px]";
            noMsgTextClass = "opacity-[0.5] text-dark-blue";
            noMsgImgClass = "opacity-[0.2]";
            noMsgImg = $2cba180f1db851cc$var$iconNoMessages;
        }
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: `flex flex-col-reverse overflow-y-auto ${wrapperClass}`,
                    style: {
                        flex: "1 1 0%"
                    },
                    children: [
                        messages === undefined && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: "flex flex-col items-center h-full justify-center",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                                theme: "dark",
                                size: "small"
                            })
                        }),
                        messages !== undefined && messages.length === 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: "flex flex-col items-center h-full grow justify-center",
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                    className: `mb-5 ${noMsgImgClass}`,
                                    src: noMsgImg
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                    className: `max-w-[200px] text-center font-interbold text-sm uppercase ${noMsgTextClass}`,
                                    children: t("messenger-no-messages")
                                })
                            ]
                        }),
                        messages !== undefined && messages.length > 0 && messages.map((el, ind)=>{
                            let ic = null;
                            let bg = "";
                            if (ind % 2) bg = msgRowClass;
                            let dir = "flex-row-reverse";
                            let mr = "ml-3";
                            if (el.senderType === 1) {
                                dir = "flex-row";
                                mr = "mr-3";
                            // ic = iconUser2;
                            }
                            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                    className: `flex items-center py-4 ${msgClass} ${dir} ${bg}`,
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                            className: `${mr} ${userIconClass} rounded-full font-pprightgothic w-[48] h-[48] flex shrink-0 justify-center items-center uppercase`,
                                            children: ic ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                                src: ic,
                                                width: 48,
                                                height: 48
                                            }) : el.senderName.split(" ").reduce((acc, cur)=>{
                                                acc += cur.slice(0, 1);
                                                return acc;
                                            }, "")
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                            style: {
                                                whiteSpace: "pre-wrap"
                                            },
                                            children: el.messageText
                                        })
                                    ]
                                })
                            }, ind);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8b39615f3260a6de$export$2e2bcd8739ae039), {
                    label: t("no-submit.messenger"),
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: `${submitWrapperClass} flex items-end shadow-default rounded-[16] ${auth.canSubmit() === false ? "opacity-40" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("textarea", {
                                className: `${submitInputClass} border-0 resize-none w-full focus:outline-none`,
                                name: "msg",
                                id: "msf",
                                rows: msgInputHeight,
                                placeholder: t("enter-text"),
                                onChange: handleMessageChange,
                                value: msg,
                                disabled: auth.canSubmit() === false
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                type: "button",
                                className: `${submitButtonClass} flex justify-center rounded-[16] text-white text-xs font-interbold py-3 xl:py-2 px-1 w-full uppercase bg-dark-blue`,
                                onClick: handleMessageSubmit,
                                disabled: auth.canSubmit() === false,
                                children: loadingSubmit ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                                    theme: "dark",
                                    size: "tiny"
                                }) : t("send")
                            })
                        ]
                    })
                })
            ]
        });
    };
    return renderMessages();
}


function $dd80a82b079ad376$export$2e2bcd8739ae039({ contRef: contRef, shareRef: shareRef, meetingRef: meetingRef }) {
    const [wrapperHeight, setWrapperHeight] = (0, $gIfym.useState)(0);
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const title = t("communication-title");
    (0, $gIfym.useEffect)(()=>{
        const timeout = setTimeout(calculateHeightForMessages, 50);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    (0, $gIfym.useEffect)(()=>{
        calculateHeightForMessages();
    }, [
        window.innerHeight
    ]);
    function calculateHeightForMessages() {
        let h = 0;
        if (contRef.current) {
            let containerStyle = window.getComputedStyle(contRef.current);
            h += parseInt(containerStyle.getPropertyValue("padding-top"));
            h += parseInt(containerStyle.getPropertyValue("padding-bottom"));
        }
        if (shareRef.current) h += parseInt(shareRef.current.clientHeight);
        if (meetingRef.current) h += parseInt(meetingRef.current.clientHeight);
        setWrapperHeight(h);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "flex flex-col mb-8",
        style: {
            height: `calc(100vh - 32px - ${wrapperHeight}px)`
        },
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                className: "text-xs uppercase text-dark-blue font-interbold mb-4",
                children: title
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "flex flex-col justify-between shadow-default bg-white rounded-lg",
                style: {
                    height: `calc(100vh - 64px - ${wrapperHeight}px)`
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2cba180f1db851cc$export$2e2bcd8739ae039), {})
            })
        ]
    });
}




var $gIfym = parcelRequire("gIfym");



var $034165480c6b31d0$exports = {};
$034165480c6b31d0$exports = $parcel$resolve("9Pwxj");


const $2a22fb1881ef27ab$var$iconMessages = new URL($034165480c6b31d0$exports);
function $2a22fb1881ef27ab$export$2e2bcd8739ae039() {
    const [modal, setModal] = (0, $gIfym.useState)(false);
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const title = t("communication-title");
    const displayModal = ()=>{
        setModal(true);
    };
    const hideModal = ()=>{
        setModal(false);
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                src: $2a22fb1881ef27ab$var$iconMessages,
                onClick: displayModal,
                className: "cursor-pointer"
            }),
            modal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                title: title,
                onClose: hideModal,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "flex flex-col justify-between",
                    style: {
                        height: "calc(100vh - 118px)"
                    },
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2cba180f1db851cc$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
}




var $6VKBH = parcelRequire("6VKBH");

var $gIfym = parcelRequire("gIfym");







var $ca596fd0efd6d85d$exports = {};
$ca596fd0efd6d85d$exports = $parcel$resolve("faMD4");


let $6b1c849f295157a5$var$icon = new URL($ca596fd0efd6d85d$exports);
function $6b1c849f295157a5$export$2e2bcd8739ae039() {
    const [inviteFirstName, setInviteFirstName] = (0, $gIfym.useState)("");
    const [inviteLastName, setInviteLastName] = (0, $gIfym.useState)("");
    const [inviteEmail, setInviteEmail] = (0, $gIfym.useState)("");
    const [submitting, setSubmitting] = (0, $gIfym.useState)(false);
    const [submitted, setSubmitted] = (0, $gIfym.useState)(false);
    const [inviteModal, setInviteModal] = (0, $gIfym.useState)(false);
    const [sharedMembers, setSharedMembers] = (0, $gIfym.useState)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const controllerRef = (0, $gIfym.useRef)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    (0, $gIfym.useEffect)(()=>{
        if (!user) return null;
        if (controllerRef.current) controllerRef.current.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        fetchSharedUsers(controllerRef);
        controllerRef.current = null;
        return ()=>controller.abort();
    }, []);
    function fetchSharedUsers(controllerRef) {
        const orderId = user.customerIdaOrderId;
        if (orderId === undefined) return null;
        (0, $6c726320d527757b$export$ea996601912957e2)(user, orderId, controllerRef).then((data)=>{
            if (data.success) return data.object;
            if (user.accessLevel !== 1) auth.addNotification(data.message);
        }).then((data)=>{
            if (data && data.length > 0) setSharedMembers(data);
            else setSharedMembers([]);
        }).catch((error)=>{
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
    }
    const onInviteShow = ()=>{
        if (auth.canSubmit() === false) {
            auth.addNotification(t("no-submit-access"));
            return false;
        }
        setInviteModal(true);
    };
    const onInviteClose = ()=>{
        setInviteModal(false);
        setSubmitted(false);
        clearForm();
    };
    const clearForm = ()=>{
        setInviteFirstName("");
        setInviteLastName("");
        setInviteEmail("");
    };
    const renderNames = ()=>{
        const you = t("you");
        let sufix = " ";
        const totalMembersLength = sharedMembers.length;
        if (totalMembersLength === 1) sufix += `${t("and")} ${sharedMembers[0].name}`;
        else if (totalMembersLength > 1) sufix += `${t("and")} ${totalMembersLength} ${t("more")}`;
        return you + sufix;
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        setSubmitting(true);
        if (!inviteFirstName || !inviteLastName || !inviteEmail) {
            auth.addNotification(t("messages.required-fields-empty"));
            setSubmitting(false);
            return;
        }
        const orderId = user.customerIdaOrderId;
        if (orderId === undefined) {
            setSubmitting(false);
            return;
        }
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        (0, $6c726320d527757b$export$d11c1181088d2ccb)(user, orderId, {
            email: inviteEmail.trim(),
            firstName: inviteFirstName.trim(),
            lastName: inviteLastName.trim()
        }, controllerRef).then((data)=>{
            setSubmitting(false);
            if (data.success === false) {
                auth.addNotification(data.message);
                return false;
            }
            setSubmitted(true);
            fetchSharedUsers();
            clearForm();
        }).catch((error)=>{
            setSubmitting(false);
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
    };
    const iconClasses = "bg-dark-blue rounded-full font-pprightgothic text-white w-[32] h-[32] flex justify-center items-center uppercase";
    let labelClass = "text-white";
    let formClass = "flex flex-col h-full justify-between";
    let inputClass = "";
    let sendButtonClass = "text-dark-blue bg-white";
    let successClass = "bg-dark-blue text-white";
    if ((0, $e845536d9724b5be$export$471f70c09cf8ab8c)()) {
        labelClass = "text-black";
        formClass = "";
        inputClass = "border-2 border-dark-blue";
        sendButtonClass = "bg-dark-blue text-white";
        successClass = "bg-[#fafbfb] text-black";
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8b39615f3260a6de$export$2e2bcd8739ae039), {
                children: (0, $e845536d9724b5be$export$471f70c09cf8ab8c)() ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                            className: "text-xs uppercase text-dark-blue font-interbold mb-4",
                            children: t("shared-with-title")
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: `flex flex-row w-full items-center justify-center ${auth.canSubmit() === false ? "opacity-40 pointer-events-none" : ""}`,
                            children: sharedMembers === undefined ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "flex flex-col items-center h-full justify-center",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                                    theme: "dark",
                                    size: "small"
                                })
                            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                        className: "flex shrink-0 mr-3",
                                        children: [
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                                className: `${iconClasses} z-10`,
                                                children: user.customerUserName.split(" ").reduce((acc, cur)=>{
                                                    acc += cur.slice(0, 1);
                                                    return acc;
                                                }, "")
                                            }),
                                            sharedMembers && sharedMembers.map((el, index)=>{
                                                const totalLength = sharedMembers.length;
                                                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                                    className: `${iconClasses} ml-[-13px]`,
                                                    style: {
                                                        zIndex: totalLength - index
                                                    },
                                                    children: el.name.split(" ").reduce((acc, cur)=>{
                                                        acc += cur.slice(0, 1);
                                                        return acc;
                                                    }, "")
                                                }, el.email);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "grow text-sm font-interbold text-dark-blue uppercase",
                                        children: renderNames()
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "shrink-0",
                                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                            type: "button",
                                            className: "flex justify-center rounded-full text-dark-blue text-sm font-interbold py-1 px-5 w-full uppercase bg-white border-2 border-dark-blue",
                                            onClick: onInviteShow,
                                            disabled: auth.canSubmit() === false,
                                            children: t("invite")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        src: $6b1c849f295157a5$var$icon,
                        onClick: onInviteShow,
                        className: `h-fit max-w-none ${auth.canSubmit() === false ? "opacity-40 pointer-events-none" : "cursor-pointer"}`,
                        width: 31,
                        height: 18
                    })
                })
            }),
            inviteModal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                title: !submitted ? t("invite") : t("shared-success-title"),
                onClose: onInviteClose,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: `relative max-w-xl xl:min-w-[320px] mx-auto ${formClass}`,
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                                            className: `block mb-2.5 font-interbold ${labelClass}`,
                                            children: [
                                                t("email"),
                                                " ",
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                                    className: "text-red-600",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                                            className: `rounded-full py-1.5 px-4 w-full placeholder:text-sm ${inputClass}`,
                                            type: "email",
                                            name: "email",
                                            id: "email",
                                            placeholder: t("shared-email-placeholder"),
                                            value: inviteEmail,
                                            required: true,
                                            onChange: (e)=>{
                                                setInviteEmail(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                                            className: `block mb-2.5 font-interbold ${labelClass}`,
                                            children: [
                                                t("first-name"),
                                                " ",
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                                    className: "text-red-600",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                                            className: `rounded-full py-1.5 px-4 w-full placeholder:text-sm ${inputClass}`,
                                            type: "text",
                                            name: "firstname",
                                            id: "firstname",
                                            placeholder: t("first-name-placeholder"),
                                            value: inviteFirstName,
                                            required: true,
                                            onChange: (e)=>{
                                                setInviteFirstName(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                                            className: `block mb-2.5 font-interbold ${labelClass}`,
                                            children: [
                                                t("last-name"),
                                                " ",
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                                    className: "text-red-600",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                                            className: `rounded-full py-1.5 px-4 w-full placeholder:text-sm ${inputClass}`,
                                            type: "text",
                                            name: "lastname",
                                            id: "lastname",
                                            placeholder: t("last-name-placeholder"),
                                            value: inviteLastName,
                                            required: true,
                                            onChange: (e)=>{
                                                setInviteLastName(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                    type: "submit",
                                    className: `block rounded-full font-interbold py-3 px-10 mt-10 mx-auto uppercase disabled:cursor-not-allowed disabled:bg-gray-500 ${sendButtonClass}`,
                                    disabled: submitting,
                                    children: t("send-invite")
                                })
                            ]
                        }),
                        submitted && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: `${successClass} absolute left-0 top-0 w-full h-full text-lg`,
                            children: t("shared-success-text")
                        })
                    ]
                })
            })
        ]
    });
}


function $1808761d820fe09a$export$2e2bcd8739ae039({ rightCol: rightCol = false }) {
    const contRef = (0, $gIfym.useRef)();
    const shareRef = (0, $gIfym.useRef)();
    const meetingRef = (0, $gIfym.useRef)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9695464cd69251e9$export$8ef2ed426dede42d), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "md:flex md:flex-row min-h-screen bg-[#fafbfb]",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "hidden sm:block relative bg-dark-blue lg:w-[180px] z-10",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $166fa83503a18738$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "grow shrink basis-0 bg-white sm:ml-[66px] lg:ml-0",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$910ae8079b2c2852), {})
                }),
                rightCol && (0, $e845536d9724b5be$export$471f70c09cf8ab8c)() && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "hidden shrink lg:block relative h-screen overflow-hidden bg-white ml-[16px]",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        ref: contRef,
                        className: "flex flex-col justify-between p-4 py-8 h-full w-[390px]",
                        children: [
                            user && user.assignedUser ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                ref: meetingRef,
                                className: "flex flex-col",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $e5dfe94a87406a8d$export$2e2bcd8739ae039), {})
                            }) : null,
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dd80a82b079ad376$export$2e2bcd8739ae039), {
                                contRef: contRef,
                                shareRef: shareRef,
                                meetingRef: meetingRef
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                ref: shareRef,
                                className: "flex flex-col min-h-[64px]",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6b1c849f295157a5$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                }),
                rightCol && !(0, $e845536d9724b5be$export$471f70c09cf8ab8c)() && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "fixed flex justify-center items-center xl:hidden bg-dark-blue w-full bottom-0 text-white py-2",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6b1c849f295157a5$export$2e2bcd8739ae039), {}),
                        user && user.assignedUser ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $e5dfe94a87406a8d$export$2e2bcd8739ae039), {}) : null,
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2a22fb1881ef27ab$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        })
    });
}



parcelRequire("gIfym");


function $30d74a2de4fcf97f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("main", {
        className: "relative flex-grow bg-dark-blue bg-auth bg-cover bg-no-repeat bg-center",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ffec81640b9b275e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$910ae8079b2c2852), {})
        ]
    });
}



parcelRequire("gIfym");



function $076ff821e12bc79d$export$2e2bcd8739ae039() {
    let location = (0, $bf4ac162b947611d$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("main", {
        className: "relative flex-grow bg-dark-blue bg-auth bg-cover bg-no-repeat bg-center",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ffec81640b9b275e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $006b2c47c574b37c$export$2e2bcd8739ae039), {
                title: "404",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "text-center",
                    children: [
                        "Page not found ",
                        location.pathname
                    ]
                })
            })
        ]
    });
}






var $gIfym = parcelRequire("gIfym");



const $fd62fb187c366684$var$apiUrl = "https://api.fenixbegravning.se/api/v1/public";
function $fd62fb187c366684$export$2e2bcd8739ae039() {
    const [actKey, setActKey] = (0, $gIfym.useState)("");
    const [email, setEmail] = (0, $gIfym.useState)("");
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const [searchParams, setSearchParams] = (0, $8a32432afacbfa13$export$f1a78c17382fe22a)();
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    document.title = t("activate-title");
    (0, $gIfym.useEffect)(()=>{
        const actKey = searchParams.get("activationKey");
        const email = searchParams.get("email");
        setActKey(actKey);
        setEmail(email);
        if (!actKey) return false;
        const fetchData = async ()=>{
            const url = `${$fd62fb187c366684$var$apiUrl}/customer/activate/${actKey}`;
            const res = await fetch(url, {
                method: "PUT"
            });
            return await res.json();
        };
        fetchData().then((json)=>{
            if (json.success === true) navigate(`/signin?as=1&email=${email}`);
        });
    }, [
        searchParams,
        navigate
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $006b2c47c574b37c$export$2e2bcd8739ae039), {
        title: t("activate-title"),
        children: !actKey ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
            className: "text-center",
            children: t("activate-desc")
        }) : ""
    });
}




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");





parcelRequire("gIfym");

function $ed35ce2e5b054174$export$2e2bcd8739ae039({ price: price }) {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const priceFormatter = new Intl.NumberFormat("sv-SE", {
        style: "currency",
        currency: "SEK",
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: 0
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "text-md",
        children: [
            t("cost"),
            ":",
            " ",
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                className: "font-interbold",
                children: priceFormatter.format(price)
            })
        ]
    });
}



parcelRequire("gIfym");

var $eabac6fbcfa7cf23$exports = {};
$eabac6fbcfa7cf23$exports = $parcel$resolve("e28S4");


const $d955ec2a98c8376c$var$flower = new URL($eabac6fbcfa7cf23$exports);
function $d955ec2a98c8376c$export$2e2bcd8739ae039({ url: url, firstName: firstName, lastName: lastName }) {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "flex flex-row lg:flex-col items-center rounded min-w-[160px] bg-dark-blue drop-shadow-xl break-words p-2 lg:p-0",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                className: "rounded-t-lg lg:mt-3 lg:mb-2 lg:mx-auto w-[40] h-[40] lg:w-[72px] lg:h-[72px]",
                src: $d955ec2a98c8376c$var$flower
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "flex flex-row lg:flex-col h-full w-full items-center justify-between text-center text-white pl-3 lg:px-3",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: "font-interbold text-center leading-tight inline-block lg:block pr-4 lg:p-0 lg:mb-4",
                            children: [
                                firstName,
                                "\xa0",
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("br", {
                                    className: "hidden lg:block"
                                }),
                                lastName
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                        href: url,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            type: "button",
                            className: "block rounded-full bg-white text-dark-blue text-xs font-interbold py-2 px-2 lg:mt-1 lg:mb-5 w-full uppercase",
                            children: t("visit-memorial-site")
                        })
                    })
                ]
            })
        ]
    });
}






let $d5abac16fc0baa87$var$logo = new URL($17323fc8ea3ee725$exports);
var $472a159f8aad6d7d$exports = {};
$472a159f8aad6d7d$exports = $parcel$resolve("goRe2");


let $d5abac16fc0baa87$var$menuIcon = new URL($472a159f8aad6d7d$exports);
function $d5abac16fc0baa87$export$2e2bcd8739ae039({ title: title, desc: desc, showMemorial: showMemorial }) {
    const [menu, setMenu] = (0, $gIfym.useState)(false);
    const [smallHeader, setSmallHeader] = (0, $gIfym.useState)(false);
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const price = auth.user.total;
    (0, $gIfym.useEffect)(()=>{
        setSmallHeader((0, $e845536d9724b5be$export$8541741fca6b4b74)());
    }, []);
    const descClass = smallHeader ? "overflow-hidden text-ellipsis whitespace-nowrap md:whitespace-normal" : "";
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "md:flex bg-dark-blue bg-auth bg-cover bg-no-repeat bg-center p-5 sm:p-10 drop-shadow-xl text-white relative z-[1]",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "grow",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "flex mb-6",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "mr-4 flex items-start shrink-0 sm:hidden",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a32432afacbfa13$export$a6c7ac8248d6e38a), {
                                    to: "/todo",
                                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                        src: $d5abac16fc0baa87$var$logo,
                                        alt: "Fenix",
                                        width: "42",
                                        height: "42"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h1", {
                                className: "text-center flex-1 font-pprightgothic text-3xl sm:text-4xl md:text-5xl xl:text-6xl sm:text-left sm:flex-initial pt-[2px] sm:pt-auto",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "ml-4 flex shrink-0 items-start sm:hidden",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                    src: $d5abac16fc0baa87$var$menuIcon,
                                    alt: "Fenix",
                                    width: "42",
                                    height: "42",
                                    className: "cursor-pointer",
                                    onClick: ()=>setMenu(!menu)
                                })
                            })
                        ]
                    }),
                    (showMemorial || price) && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "block lg:hidden mb-5",
                        children: [
                            auth.user.memorial !== null ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d955ec2a98c8376c$export$2e2bcd8739ae039), {
                                ...auth.user.memorial
                            }) : "",
                            price ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "mt-5",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ed35ce2e5b054174$export$2e2bcd8739ae039), {
                                    price: price
                                })
                            }) : ""
                        ]
                    }),
                    showMemorial && !auth.user.memorial && price && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "hidden lg:block mb-5",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ed35ce2e5b054174$export$2e2bcd8739ae039), {
                                price: price
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: `md:max-w-2xl ${descClass}`,
                        children: desc
                    }),
                    desc && desc.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "flex justify-end md:hidden",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            type: "button",
                            className: "text-sm font-interlight border-b-[1px]",
                            onClick: ()=>setSmallHeader(!smallHeader),
                            children: smallHeader ? t("show-more") : t("show-less")
                        })
                    })
                ]
            }),
            showMemorial && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "hidden ml-5 lg:block",
                children: [
                    auth.user.memorial !== null ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d955ec2a98c8376c$export$2e2bcd8739ae039), {
                        ...auth.user.memorial
                    }) : "",
                    auth.user.memorial && price ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "mt-5 text-center",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ed35ce2e5b054174$export$2e2bcd8739ae039), {
                            price: price
                        })
                    }) : ""
                ]
            }),
            menu && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                title: "Menu",
                titleClass: "font-pprightgothic text-4xl text-white text-center",
                showLogo: true,
                onClose: ()=>setMenu(!menu),
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "flex flex-col sm:w-[50%] mx-auto justify-between h-full",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ae4044fdde164839$export$2e2bcd8739ae039), {
                                itemClass: "w-auto ml-2.5"
                            })
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5c0d471a44711bed$export$2e2bcd8739ae039), {
                                itemClass: "w-auto ml-2.5"
                            })
                        })
                    ]
                })
            })
        ]
    });
}





var $gIfym = parcelRequire("gIfym");


function $df56f7e4a31c4023$export$2e2bcd8739ae039() {
    const [log, setLog] = (0, $gIfym.useState)([]);
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const wsConnection = (0, $6c05a81472ccb93d$export$bd1537e1f64b53aa)();
    const user = auth.user;
    (0, $gIfym.useEffect)(()=>{
        if (!user || wsConnection.connectionId === null) return;
        const handler = (message)=>updateLog(message);
        wsConnection.on("Customer_Todo", handler);
        wsConnection.on("Customer_Message", handler);
        wsConnection.on("Customer_Document", handler);
        wsConnection.on("Customer_Image", handler);
        wsConnection.on("Customer_Todo", handler);
        //clean up function
        return ()=>{
            wsConnection.off("Customer_Todo", handler);
            wsConnection.off("Customer_Message", handler);
            wsConnection.off("Customer_Document", handler);
            wsConnection.off("Customer_Image", handler);
            wsConnection.off("Customer_Todo", handler);
        };
    }, []);
    const updateLog = (item)=>{
        setLog((prev)=>[
                ...prev,
                item
            ]);
    };
    const items = log.map((item, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                children: JSON.stringify(item)
            })
        }, index));
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "p-10 pb-0",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                className: "text-md mb-3 font-bold",
                children: "Websocket"
            }),
            items
        ]
    });
}





function $5efddf245952e228$export$2e2bcd8739ae039() {
    const [ida, setIda] = (0, $gIfym.useState)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const controllerRef = (0, $gIfym.useRef)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    document.title = t("homepage-title");
    (0, $gIfym.useEffect)(()=>{
        if (!user) return null;
        if (controllerRef.current) controllerRef.current.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        (0, $6c726320d527757b$export$bdacb1e4b90bad89)(user, controllerRef).then((data)=>{
            setIda(data);
        }).catch((error)=>{
            auth.addNotification(error.message);
        });
        return ()=>controller.abort();
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9695464cd69251e9$export$8ef2ed426dede42d), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "bg-white min-h-screen",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                    title: `Welcome, ${user?.customerUserName}`
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $df56f7e4a31c4023$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "p-10",
                    children: [
                        !user ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            children: t("homepage-no-auth")
                        }) : "",
                        ida && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                                    className: "text-md mb-3 font-bold",
                                    children: t("description.ida")
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("pre", {
                                    className: "text-xs",
                                    style: {
                                        maxWidth: "fit-content",
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "anywhere"
                                    },
                                    children: JSON.stringify(ida, null, 2)
                                })
                            ]
                        }),
                        !ida ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                            theme: "dark",
                            size: "small"
                        }) : null,
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: "py-10",
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                                    className: "text-md mb-3 font-bold",
                                    children: "User object"
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("pre", {
                                    className: "text-xs",
                                    style: {
                                        maxWidth: "fit-content",
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "anywhere"
                                    },
                                    children: JSON.stringify(user, null, 2)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("gIfym");



var $6VKBH = parcelRequire("6VKBH");

var $gIfym = parcelRequire("gIfym");






var $6VKBH = parcelRequire("6VKBH");

var $gIfym = parcelRequire("gIfym");






var $gIfym = parcelRequire("gIfym");

var $7lXH1 = parcelRequire("7lXH1");
function $e97d362134fa57b8$export$2e2bcd8739ae039() {
    return $e97d362134fa57b8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e97d362134fa57b8$export$2e2bcd8739ae039.apply(null, arguments);
}


function $6080bdebdcd55ee7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $afffe439ef75a7d9$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6080bdebdcd55ee7$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $8ZNRc = parcelRequire("8ZNRc");

var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");
var $c65bfe520546a474$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c65bfe520546a474$var$ReactIs, $c65bfe520546a474$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c65bfe520546a474$exports = (parcelRequire("kh2Rv"))();


var $78c4fc952655f552$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $78c4fc952655f552$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
var $78c4fc952655f552$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
var $78c4fc952655f552$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
var $78c4fc952655f552$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
var $78c4fc952655f552$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
var $78c4fc952655f552$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
var $78c4fc952655f552$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
var $78c4fc952655f552$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
var $78c4fc952655f552$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
var $78c4fc952655f552$export$d93346aa7735a637 = [
    'onSelect'
];
var $78c4fc952655f552$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var $78c4fc952655f552$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
var $78c4fc952655f552$export$bac3087b5cb826f6 = [
    'onScroll'
];
var $78c4fc952655f552$export$28298837799e00e8 = [
    'onWheel'
];
var $78c4fc952655f552$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
var $78c4fc952655f552$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
var $78c4fc952655f552$export$477a88c5b93a108d = [
    'onToggle'
];
var $78c4fc952655f552$export$7212b61f9f58bd1 = [
    'onChange'
];
var $78c4fc952655f552$export$59ef7197c4d7b9dc = $78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray([], $78c4fc952655f552$export$84fe03429ed1b6d6, true), $78c4fc952655f552$export$dbc46161504615f7, true), $78c4fc952655f552$export$fb6351c2666f0875, true), $78c4fc952655f552$export$4e58c1a9761ed81a, true), $78c4fc952655f552$export$3bf7402f2a4eb3af, true), $78c4fc952655f552$export$409c4891d97f97cf, true), $78c4fc952655f552$export$6be5aa2386088264, true), $78c4fc952655f552$export$3a6e2b8954613992, true), $78c4fc952655f552$export$6c96379d5b8a2df7, true), $78c4fc952655f552$export$d93346aa7735a637, true), $78c4fc952655f552$export$fa367689c659e65c, true), $78c4fc952655f552$export$c731eab7619e00a0, true), $78c4fc952655f552$export$bac3087b5cb826f6, true), $78c4fc952655f552$export$28298837799e00e8, true), $78c4fc952655f552$export$6ff45424014e7407, true), $78c4fc952655f552$export$78878fc7bd50dc3e, true), $78c4fc952655f552$export$7212b61f9f58bd1, true), $78c4fc952655f552$export$477a88c5b93a108d, true);
function $78c4fc952655f552$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $78c4fc952655f552$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $a2d1e3f291c1aac8$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}


function $22b5539e131d8a59$export$2e2bcd8739ae039() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === 'string';
    }).join(' ');
}


var $51137fdf63eaf269$var$isProduction = true;
var $51137fdf63eaf269$var$prefix = 'Invariant failed';
function $51137fdf63eaf269$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($51137fdf63eaf269$var$isProduction) throw new Error($51137fdf63eaf269$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($51137fdf63eaf269$var$prefix, ": ").concat(provided) : $51137fdf63eaf269$var$prefix;
    throw new Error(value);
}


var $f4f9b01701245dfa$var$isProduction = true;
function $f4f9b01701245dfa$var$warning(condition, message) {
    if (!$f4f9b01701245dfa$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $f4f9b01701245dfa$export$2e2bcd8739ae039 = $f4f9b01701245dfa$var$warning;



var $7lXH1 = parcelRequire("7lXH1");

var $gIfym = parcelRequire("gIfym");
var $b7406b9166257ba4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $gIfym.createContext)(null);



var $gIfym = parcelRequire("gIfym");

function $876b96cc01b44bec$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, type = _ref.type;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "react-pdf__message react-pdf__message--".concat(type)
    }, children);
}
$876b96cc01b44bec$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
        'error',
        'loading',
        'no-data'
    ]).isRequired
};



var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $30dc112643bd7525$var$DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
var $30dc112643bd7525$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function LinkService() {
        (0, $vdtyq.default)(this, LinkService);
        this.externalLinkTarget = null;
        this.externalLinkRel = null;
    }
    (0, $lU1Um.default)(LinkService, [
        {
            key: "setDocument",
            value: function setDocument(pdfDocument) {
                this.pdfDocument = pdfDocument;
            }
        },
        {
            key: "setViewer",
            value: function setViewer(pdfViewer) {
                this.pdfViewer = pdfViewer;
            }
        },
        {
            key: "setExternalLinkRel",
            value: function setExternalLinkRel(externalLinkRel) {
                this.externalLinkRel = externalLinkRel;
            }
        },
        {
            key: "setExternalLinkTarget",
            value: function setExternalLinkTarget(externalLinkTarget) {
                this.externalLinkTarget = externalLinkTarget;
            }
        },
        {
            key: "setHistory",
            value: function setHistory() {}
        },
        {
            key: "pagesCount",
            get: function get() {
                return this.pdfDocument ? this.pdfDocument.numPages : 0;
            }
        },
        {
            key: "page",
            get: function get() {
                return this.pdfViewer.currentPageNumber;
            },
            set: function set(value) {
                this.pdfViewer.currentPageNumber = value;
            }
        },
        {
            key: "rotation",
            get: function get() {
                return 0;
            },
            set: function set(value) {}
        },
        {
            key: "goToDestination",
            value: function goToDestination(dest) {
                var _this = this;
                new Promise(function(resolve) {
                    if (typeof dest === 'string') _this.pdfDocument.getDestination(dest).then(resolve);
                    else if (Array.isArray(dest)) resolve(dest);
                    else dest.then(resolve);
                }).then(function(explicitDest) {
                    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(Array.isArray(explicitDest), "\"".concat(explicitDest, "\" is not a valid destination array."));
                    var destRef = explicitDest[0];
                    new Promise(function(resolve) {
                        if (destRef instanceof Object) _this.pdfDocument.getPageIndex(destRef).then(function(pageIndex) {
                            resolve(pageIndex);
                        })["catch"](function() {
                            (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false, "\"".concat(destRef, "\" is not a valid page reference."));
                        });
                        else if (typeof destRef === 'number') resolve(destRef);
                        else (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false, "\"".concat(destRef, "\" is not a valid destination reference."));
                    }).then(function(pageIndex) {
                        var pageNumber = pageIndex + 1;
                        (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= _this.pagesCount, "\"".concat(pageNumber, "\" is not a valid page number."));
                        _this.pdfViewer.scrollPageIntoView({
                            dest: dest,
                            pageIndex: pageIndex,
                            pageNumber: pageNumber
                        });
                    });
                });
            }
        },
        {
            key: "navigateTo",
            value: function navigateTo(dest) {
                this.goToDestination(dest);
            }
        },
        {
            key: "goToPage",
            value: function goToPage() {}
        },
        {
            key: "addLinkAttributes",
            value: function addLinkAttributes(link, url, newWindow) {
                link.href = url;
                link.rel = this.externalLinkRel || $30dc112643bd7525$var$DEFAULT_LINK_REL;
                link.target = newWindow ? '_blank' : this.externalLinkTarget || '';
            }
        },
        {
            key: "getDestinationHash",
            value: function getDestinationHash() {
                return '#';
            }
        },
        {
            key: "getAnchorUrl",
            value: function getAnchorUrl() {
                return '#';
            }
        },
        {
            key: "setHash",
            value: function setHash() {}
        },
        {
            key: "executeNamedAction",
            value: function executeNamedAction() {}
        },
        {
            key: "cachePageRef",
            value: function cachePageRef() {}
        },
        {
            key: "isPageVisible",
            value: function isPageVisible() {
                return true;
            }
        },
        {
            key: "isPageCached",
            value: function isPageCached() {
                return true;
            }
        }
    ]);
    return LinkService;
}();


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
var $c47f90cf820d9305$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $c47f90cf820d9305$export$2e2bcd8739ae039 = $c47f90cf820d9305$var$PasswordResponses;



var $c9QmJ = parcelRequire("c9QmJ");
function $96daae81604445fb$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



var $biFy3 = parcelRequire("biFy3");

var $6MgCo = parcelRequire("6MgCo");
function $2bbbd885e1fef371$export$2e2bcd8739ae039(r, e) {
    return (0, $c9QmJ.default)(r) || (0, $96daae81604445fb$export$2e2bcd8739ae039)(r, e) || (0, $biFy3.default)(r, e) || (0, $6MgCo.default)();
}




var $02e2df2893cf0bcc$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $02e2df2893cf0bcc$export$d528e4159a0e221e = $02e2df2893cf0bcc$export$4e09c449d6c407f7 && window.location.protocol === 'file:';
function $02e2df2893cf0bcc$export$4e62c701997796c1(variable) {
    return typeof variable !== 'undefined';
}
function $02e2df2893cf0bcc$export$ef8866826b0b1f6d(variable) {
    return $02e2df2893cf0bcc$export$4e62c701997796c1(variable) && variable !== null;
}
function $02e2df2893cf0bcc$export$844ec244b1367d54(variable) {
    return typeof variable === 'string';
}
function $02e2df2893cf0bcc$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $02e2df2893cf0bcc$export$5bcd6e94ed871c88(variable) {
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)($02e2df2893cf0bcc$export$4e09c449d6c407f7, 'isBlob can only be used in a browser environment');
    return variable instanceof Blob;
}
function $02e2df2893cf0bcc$export$be78b3111c50efdd(variable) {
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)($02e2df2893cf0bcc$export$4e09c449d6c407f7, 'isFile can only be used in a browser environment');
    return variable instanceof File;
}
function $02e2df2893cf0bcc$export$4d82193ef6a8d75c(str) {
    return $02e2df2893cf0bcc$export$844ec244b1367d54(str) && /^data:/.test(str);
}
function $02e2df2893cf0bcc$export$c1553384119518c3(dataURI) {
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)($02e2df2893cf0bcc$export$4d82193ef6a8d75c(dataURI), 'Invalid data URI.');
    var _dataURI$split = dataURI.split(','), _dataURI$split2 = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(_dataURI$split, 2), headersString = _dataURI$split2[0], dataString = _dataURI$split2[1];
    var headers = headersString.split(';');
    if (headers.indexOf('base64') !== -1) return atob(dataString);
    return unescape(dataString);
}
function $02e2df2893cf0bcc$export$d39ce20a37bba061() {
    return $02e2df2893cf0bcc$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
var $02e2df2893cf0bcc$var$allowFileAccessFromFilesTip = 'On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.';
function $02e2df2893cf0bcc$export$84884c3182d1bdda() {
    (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(!$02e2df2893cf0bcc$export$d528e4159a0e221e, "Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ".concat($02e2df2893cf0bcc$var$allowFileAccessFromFilesTip));
}
function $02e2df2893cf0bcc$export$e7ec4a9e2d586a77() {
    (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(!$02e2df2893cf0bcc$export$d528e4159a0e221e, "Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ".concat($02e2df2893cf0bcc$var$allowFileAccessFromFilesTip));
}
function $02e2df2893cf0bcc$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, 'width', {
        get: function get() {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'height', {
        get: function get() {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalWidth', {
        get: function get() {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalHeight', {
        get: function get() {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $02e2df2893cf0bcc$export$99075c4d008e6ab1(error) {
    return error.name === 'RenderingCancelledException';
}
function $02e2df2893cf0bcc$export$21fedb3a7a137f3d(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            return resolve(new Uint8Array(reader.result));
        };
        reader.onerror = function(event) {
            switch(event.target.error.code){
                case event.target.error.NOT_FOUND_ERR:
                    return reject(new Error('Error while reading a file: File not found.'));
                case event.target.error.NOT_READABLE_ERR:
                    return reject(new Error('Error while reading a file: File not readable.'));
                case event.target.error.SECURITY_ERR:
                    return reject(new Error('Error while reading a file: Security error.'));
                case event.target.error.ABORT_ERR:
                    return reject(new Error('Error while reading a file: Aborted.'));
                default:
                    return reject(new Error('Error while reading a file.'));
            }
        };
        reader.readAsArrayBuffer(file);
        return null;
    });
}



var $8ZNRc = parcelRequire("8ZNRc");

var $4rfJf = parcelRequire("4rfJf");
function $aada92ddabbc5f6f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $4rfJf.default)(r);
}



var $9Vqi3 = parcelRequire("9Vqi3");

var $biFy3 = parcelRequire("biFy3");
function $50e4ecdc3989e5dd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6e893b60175ac257$export$2e2bcd8739ae039(r) {
    return (0, $aada92ddabbc5f6f$export$2e2bcd8739ae039)(r) || (0, $9Vqi3.default)(r) || (0, $biFy3.default)(r) || (0, $50e4ecdc3989e5dd$export$2e2bcd8739ae039)();
}






var $46a785ad40348064$export$1e08905474334888 = function() {
    var result = {};
    [].concat((0, $6e893b60175ac257$export$2e2bcd8739ae039)((0, $78c4fc952655f552$export$3a6e2b8954613992)), (0, $6e893b60175ac257$export$2e2bcd8739ae039)((0, $78c4fc952655f552$export$fa367689c659e65c)), (0, $6e893b60175ac257$export$2e2bcd8739ae039)((0, $78c4fc952655f552$export$409c4891d97f97cf))).forEach(function(eventName) {
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func;
    });
    return result;
}();
var $46a785ad40348064$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
        ]),
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        range: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool
    })
];
if (typeof File !== 'undefined') $46a785ad40348064$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(File));
if (typeof Blob !== 'undefined') $46a785ad40348064$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Blob));
var $46a785ad40348064$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string)
]);
var $46a785ad40348064$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType($46a785ad40348064$var$fileTypes);
var $46a785ad40348064$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf((0, $30dc112643bd7525$export$2e2bcd8739ae039));
var $46a785ad40348064$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
    '_self',
    '_blank',
    '_parent',
    '_top'
]);
var $46a785ad40348064$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
    _transport: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        fontLoader: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired
    }).isRequired,
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        _objs: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired
    }).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired
});
var $46a785ad40348064$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    var pageIndex = props[propName], pageNumber = props.pageNumber, pdf = props.pdf;
    if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageIndex)) {
        if (typeof pageIndex !== 'number') return new Error("`".concat(propName, "` of type `").concat((0, $8ZNRc.default)(pageIndex), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageIndex < 0) return new Error("Expected `".concat(propName, "` to be greater or equal to 0."));
        var numPages = pdf.numPages;
        if (pageIndex + 1 > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages - 1, "."));
    } else if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageNumber)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
     // Everything is fine
    return null;
};
var $46a785ad40348064$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    var pageNumber = props[propName], pageIndex = props.pageIndex, pdf = props.pdf;
    if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageNumber)) {
        if (typeof pageNumber !== 'number') return new Error("`".concat(propName, "` of type `").concat((0, $8ZNRc.default)(pageNumber), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageNumber < 1) return new Error("Expected `".concat(propName, "` to be greater or equal to 1."));
        var numPages = pdf.numPages;
        if (pageNumber > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages, "."));
    } else if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageIndex)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
     // Everything is fine
    return null;
};
var $46a785ad40348064$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        getDestination: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
        getOutline: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
        getPage: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
        numPages: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool
]);
var $46a785ad40348064$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any
    })
]);
var $46a785ad40348064$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
    'canvas',
    'none',
    'svg'
]);
var $46a785ad40348064$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
    0,
    90,
    180,
    270
]);


var $97a1f05fb7e6099a$var$_excluded = [
    "url"
];
function $97a1f05fb7e6099a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $97a1f05fb7e6099a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $97a1f05fb7e6099a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $97a1f05fb7e6099a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $97a1f05fb7e6099a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $97a1f05fb7e6099a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $97a1f05fb7e6099a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $97a1f05fb7e6099a$var$PDFDataRangeTransport = $7lXH1.PDFDataRangeTransport;
var $97a1f05fb7e6099a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(Document, _PureComponent);
    var _super = $97a1f05fb7e6099a$var$_createSuper(Document);
    function Document() {
        var _this;
        (0, $vdtyq.default)(this, Document);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "state", {
            pdf: null
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "viewer", {
            scrollPageIntoView: function scrollPageIntoView(_ref) {
                var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
                // Handling jumping to internal links target
                var onItemClick = _this.props.onItemClick; // First, check if custom handling of onItemClick was provided
                if (onItemClick) {
                    onItemClick({
                        dest: dest,
                        pageIndex: pageIndex,
                        pageNumber: pageNumber
                    });
                    return;
                } // If not, try to look for target page within the <Document>.
                var page = _this.pages[pageIndex];
                if (page) {
                    // Scroll to the page automatically
                    page.scrollIntoView();
                    return;
                }
                (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
            }
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "linkService", new (0, $30dc112643bd7525$export$2e2bcd8739ae039)());
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "loadDocument", function() {
            // If another rendering is in progress, let's cancel it
            (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(_this.runningTask); // If another loading is in progress, let's destroy it
            if (_this.loadingTask) _this.loadingTask.destroy();
            var cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(_this.findDocumentSource());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(source) {
                _this.onSourceSuccess();
                if (!source) return;
                _this.setState(function(prevState) {
                    if (!prevState.pdf) return null;
                    return {
                        pdf: null
                    };
                });
                var _this$props = _this.props, options = _this$props.options, onLoadProgress = _this$props.onLoadProgress, onPassword = _this$props.onPassword;
                _this.loadingTask = $7lXH1.getDocument($97a1f05fb7e6099a$var$_objectSpread($97a1f05fb7e6099a$var$_objectSpread({}, source), options));
                _this.loadingTask.onPassword = onPassword;
                if (onLoadProgress) _this.loadingTask.onProgress = onLoadProgress;
                var cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(_this.loadingTask.promise);
                _this.runningTask = cancellable;
                cancellable.promise.then(function(pdf) {
                    _this.setState(function(prevState) {
                        if (prevState.pdf && prevState.pdf.fingerprint === pdf.fingerprint) return null;
                        return {
                            pdf: pdf
                        };
                    }, _this.onLoadSuccess);
                })["catch"](function(error) {
                    _this.onLoadError(error);
                });
            })["catch"](function(error) {
                _this.onSourceError(error);
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "setupLinkService", function() {
            var _this$props2 = _this.props, externalLinkRel = _this$props2.externalLinkRel, externalLinkTarget = _this$props2.externalLinkTarget;
            _this.linkService.setViewer(_this.viewer);
            _this.linkService.setExternalLinkRel(externalLinkRel);
            _this.linkService.setExternalLinkTarget(externalLinkTarget);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onSourceSuccess", function() {
            var onSourceSuccess = _this.props.onSourceSuccess;
            if (onSourceSuccess) onSourceSuccess();
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onSourceError", function(error) {
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onSourceError = _this.props.onSourceError;
            if (onSourceError) onSourceError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadSuccess", function() {
            var onLoadSuccess = _this.props.onLoadSuccess;
            var pdf = _this.state.pdf;
            if (onLoadSuccess) onLoadSuccess(pdf);
            _this.pages = new Array(pdf.numPages);
            _this.linkService.setDocument(pdf);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadError", function(error) {
            _this.setState({
                pdf: false
            });
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "findDocumentSource", function() {
            return new Promise(function(resolve) {
                var file = _this.props.file;
                if (!file) resolve(null);
                 // File is a string
                if (typeof file === 'string') {
                    if ((0, $02e2df2893cf0bcc$export$4d82193ef6a8d75c)(file)) {
                        var fileByteString = (0, $02e2df2893cf0bcc$export$c1553384119518c3)(file);
                        resolve({
                            data: fileByteString
                        });
                    }
                    (0, $02e2df2893cf0bcc$export$84884c3182d1bdda)();
                    resolve({
                        url: file
                    });
                } // File is PDFDataRangeTransport
                if (file instanceof $97a1f05fb7e6099a$var$PDFDataRangeTransport) resolve({
                    range: file
                });
                 // File is an ArrayBuffer
                if ((0, $02e2df2893cf0bcc$export$9dd3754ae86f0017)(file)) resolve({
                    data: file
                });
                /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $02e2df2893cf0bcc$export$4e09c449d6c407f7) // File is a Blob
                {
                    if ((0, $02e2df2893cf0bcc$export$5bcd6e94ed871c88)(file) || (0, $02e2df2893cf0bcc$export$be78b3111c50efdd)(file)) {
                        (0, $02e2df2893cf0bcc$export$21fedb3a7a137f3d)(file).then(function(data) {
                            resolve({
                                data: data
                            });
                        });
                        return;
                    }
                } // At this point, file must be an object
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)((0, $8ZNRc.default)(file) === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(file.url || file.data || file.range, 'Invalid parameter object: need either .data, .range or .url'); // File .url is a string
                if (typeof file.url === 'string') {
                    if ((0, $02e2df2893cf0bcc$export$4d82193ef6a8d75c)(file.url)) {
                        var url = file.url, otherParams = (0, $afffe439ef75a7d9$export$2e2bcd8739ae039)(file, $97a1f05fb7e6099a$var$_excluded);
                        var _fileByteString = (0, $02e2df2893cf0bcc$export$c1553384119518c3)(url);
                        resolve($97a1f05fb7e6099a$var$_objectSpread({
                            data: _fileByteString
                        }, otherParams));
                    }
                    (0, $02e2df2893cf0bcc$export$84884c3182d1bdda)();
                }
                resolve(file);
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "registerPage", function(pageIndex, ref) {
            _this.pages[pageIndex] = ref;
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "unregisterPage", function(pageIndex) {
            delete _this.pages[pageIndex];
        });
        return _this;
    }
    (0, $lU1Um.default)(Document, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.loadDocument();
                this.setupLinkService();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var file = this.props.file;
                if (file !== prevProps.file) this.loadDocument();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // If rendering is in progress, let's cancel it
                (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(this.runningTask); // If loading is in progress, let's destroy it
                if (this.loadingTask) this.loadingTask.destroy();
            }
        },
        {
            key: "childContext",
            get: function get() {
                var linkService = this.linkService, registerPage = this.registerPage, unregisterPage = this.unregisterPage;
                var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, renderMode = _this$props3.renderMode, rotate = _this$props3.rotate;
                var pdf = this.state.pdf;
                return {
                    imageResourcesPath: imageResourcesPath,
                    linkService: linkService,
                    pdf: pdf,
                    registerPage: registerPage,
                    renderMode: renderMode,
                    rotate: rotate,
                    unregisterPage: unregisterPage
                };
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $78c4fc952655f552$export$2e2bcd8739ae039)(this.props, function() {
                    return _this2.state.pdf;
                });
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b7406b9166257ba4$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, children);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var file = this.props.file;
                var pdf = this.state.pdf;
                if (!file) {
                    var noData = this.props.noData;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
                        type: "no-data"
                    }, typeof noData === 'function' ? noData() : noData);
                }
                if (pdf === null) {
                    var loading = this.props.loading;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
                        type: "loading"
                    }, typeof loading === 'function' ? loading() : loading);
                }
                if (pdf === false) {
                    var error = this.props.error;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
                        type: "error"
                    }, typeof error === 'function' ? error() : error);
                }
                return this.renderChildren();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, className = _this$props4.className, inputRef = _this$props4.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
                    className: (0, $22b5539e131d8a59$export$2e2bcd8739ae039)('react-pdf__Document', className),
                    ref: inputRef
                }, this.eventProps), this.renderContent());
            }
        }
    ]);
    return Document;
}((0, $gIfym.PureComponent));
$97a1f05fb7e6099a$export$2e2bcd8739ae039.defaultProps = {
    error: 'Failed to load PDF file.',
    loading: "Loading PDF\u2026",
    noData: 'No PDF file specified.',
    onPassword: function onPassword(callback, reason) {
        switch(reason){
            case (0, $c47f90cf820d9305$export$2e2bcd8739ae039).NEED_PASSWORD:
                // eslint-disable-next-line no-alert
                var password = prompt('Enter the password to open this PDF file.');
                callback(password);
                break;
            case (0, $c47f90cf820d9305$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
                // eslint-disable-next-line no-alert
                var _password = prompt('Invalid password. Please try again.');
                callback(_password);
                break;
            default:
        }
    }
};
var $97a1f05fb7e6099a$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
]);
$97a1f05fb7e6099a$export$2e2bcd8739ae039.propTypes = $97a1f05fb7e6099a$var$_objectSpread($97a1f05fb7e6099a$var$_objectSpread({}, (0, $46a785ad40348064$export$1e08905474334888)), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node,
    className: (0, $46a785ad40348064$export$d53f3db2f43345df),
    error: $97a1f05fb7e6099a$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    file: (0, $46a785ad40348064$export$be78b3111c50efdd),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    inputRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    loading: $97a1f05fb7e6099a$var$isFunctionOrNode,
    noData: $97a1f05fb7e6099a$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
});




var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");








var $gIfym = parcelRequire("gIfym");
var $6e6636de3107144a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $gIfym.createContext)(null);






var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");




var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");
var $abcf0adc980c246b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Ref(_ref) {
        var num = _ref.num, gen = _ref.gen;
        (0, $vdtyq.default)(this, Ref);
        this.num = num;
        this.gen = gen;
    }
    (0, $lU1Um.default)(Ref, [
        {
            key: "toString",
            value: function toString() {
                var str = "".concat(this.num, "R");
                if (this.gen !== 0) str += this.gen;
                return str;
            }
        }
    ]);
    return Ref;
}();




var $983df58318b09f08$var$_excluded = [
    "item"
];
function $983df58318b09f08$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $983df58318b09f08$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $983df58318b09f08$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $983df58318b09f08$export$9740e3c6481b5f0e = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(OutlineItemInternal, _PureComponent);
    var _super = $983df58318b09f08$var$_createSuper(OutlineItemInternal);
    function OutlineItemInternal() {
        var _this;
        (0, $vdtyq.default)(this, OutlineItemInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "getDestination", function() {
            return new Promise(function(resolve, reject) {
                var _this$props = _this.props, item = _this$props.item, pdf = _this$props.pdf;
                if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(_this.destination)) {
                    if (typeof item.dest === 'string') pdf.getDestination(item.dest).then(resolve)["catch"](reject);
                    else resolve(item.dest);
                }
                return _this.destination;
            }).then(function(destination) {
                _this.destination = destination;
                return destination;
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "getPageIndex", function() {
            return new Promise(function(resolve, reject) {
                var pdf = _this.props.pdf;
                if ((0, $02e2df2893cf0bcc$export$4e62c701997796c1)(_this.pageIndex)) resolve(_this.pageIndex);
                _this.getDestination().then(function(destination) {
                    if (!destination) return;
                    var _destination = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(destination, 1), ref = _destination[0];
                    pdf.getPageIndex(new (0, $abcf0adc980c246b$export$2e2bcd8739ae039)(ref)).then(resolve)["catch"](reject);
                });
            }).then(function(pageIndex) {
                _this.pageIndex = pageIndex;
                return _this.pageIndex;
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "getPageNumber", function() {
            return new Promise(function(resolve, reject) {
                if ((0, $02e2df2893cf0bcc$export$4e62c701997796c1)(_this.pageNumber)) resolve(_this.pageNumber);
                _this.getPageIndex().then(function(pageIndex) {
                    resolve(pageIndex + 1);
                })["catch"](reject);
            }).then(function(pageNumber) {
                _this.pageNumber = pageNumber;
                return pageNumber;
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onClick", function(event) {
            var onClick = _this.props.onClick;
            event.preventDefault();
            if (!onClick) return false;
            return Promise.all([
                _this.getDestination(),
                _this.getPageIndex(),
                _this.getPageNumber()
            ]).then(function(_ref) {
                var _ref2 = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(_ref, 3), dest = _ref2[0], pageIndex = _ref2[1], pageNumber = _ref2[2];
                onClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
        return _this;
    }
    (0, $lU1Um.default)(OutlineItemInternal, [
        {
            key: "renderSubitems",
            value: function renderSubitems() {
                var _this$props2 = this.props, item = _this$props2.item, otherProps = (0, $afffe439ef75a7d9$export$2e2bcd8739ae039)(_this$props2, $983df58318b09f08$var$_excluded);
                if (!item.items || !item.items.length) return null;
                var subitems = item.items;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("ul", null, subitems.map(function(subitem, subitemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(OutlineItemInternal, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
                        key: typeof subitem.destination === 'string' ? subitem.destination : subitemIndex,
                        item: subitem
                    }, otherProps));
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var item = this.props.item;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", {
                    href: "#",
                    onClick: this.onClick
                }, item.title), this.renderSubitems());
            }
        }
    ]);
    return OutlineItemInternal;
}((0, $gIfym.PureComponent));
var $983df58318b09f08$var$isDestination = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any)
]);
$983df58318b09f08$export$9740e3c6481b5f0e.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        dest: $983df58318b09f08$var$isDestination,
        items: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
            dest: $983df58318b09f08$var$isDestination,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
        })),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
    }).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    pdf: (0, $46a785ad40348064$export$d22001c6ab8dd37).isRequired
};
var $983df58318b09f08$var$OutlineItem = function OutlineItem(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b7406b9166257ba4$export$2e2bcd8739ae039).Consumer, null, function(documentContext) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $6e6636de3107144a$export$2e2bcd8739ae039).Consumer, null, function(outlineContext) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($983df58318b09f08$export$9740e3c6481b5f0e, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, documentContext, outlineContext, props));
        });
    });
};
var $983df58318b09f08$export$2e2bcd8739ae039 = $983df58318b09f08$var$OutlineItem;




function $6ec14c358cee67a4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ec14c358cee67a4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ec14c358cee67a4$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ec14c358cee67a4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ec14c358cee67a4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6ec14c358cee67a4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $6ec14c358cee67a4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6ec14c358cee67a4$export$5012f160061c9df4 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(OutlineInternal, _PureComponent);
    var _super = $6ec14c358cee67a4$var$_createSuper(OutlineInternal);
    function OutlineInternal() {
        var _this;
        (0, $vdtyq.default)(this, OutlineInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "state", {
            outline: null
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "loadOutline", function() {
            var pdf = _this.props.pdf;
            _this.setState(function(prevState) {
                if (!prevState.outline) return null;
                return {
                    outline: null
                };
            });
            var cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(pdf.getOutline());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(outline) {
                _this.setState({
                    outline: outline
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadSuccess", function() {
            var onLoadSuccess = _this.props.onLoadSuccess;
            var outline = _this.state.outline;
            if (onLoadSuccess) onLoadSuccess(outline);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadError", function(error) {
            _this.setState({
                outline: false
            });
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onItemClick", function(_ref) {
            var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
            var onItemClick = _this.props.onItemClick;
            if (onItemClick) onItemClick({
                dest: dest,
                pageIndex: pageIndex,
                pageNumber: pageNumber
            });
        });
        return _this;
    }
    (0, $lU1Um.default)(OutlineInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pdf = this.props.pdf;
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pdf, 'Attempted to load an outline, but no document was specified.');
                this.loadOutline();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var pdf = this.props.pdf;
                if (prevProps.pdf && pdf !== prevProps.pdf) this.loadOutline();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "childContext",
            get: function get() {
                return {
                    onClick: this.onItemClick
                };
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $78c4fc952655f552$export$2e2bcd8739ae039)(this.props, function() {
                    return _this2.state.outline;
                });
            }
        },
        {
            key: "renderOutline",
            value: function renderOutline() {
                var outline = this.state.outline;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("ul", null, outline.map(function(item, itemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $983df58318b09f08$export$2e2bcd8739ae039), {
                        key: typeof item.destination === 'string' ? item.destination : itemIndex,
                        item: item
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var pdf = this.props.pdf;
                var outline = this.state.outline;
                if (!pdf || !outline) return null;
                var _this$props = this.props, className = _this$props.className, inputRef = _this$props.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
                    className: (0, $22b5539e131d8a59$export$2e2bcd8739ae039)('react-pdf__Outline', className),
                    ref: inputRef
                }, this.eventProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $6e6636de3107144a$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, this.renderOutline()));
            }
        }
    ]);
    return OutlineInternal;
}((0, $gIfym.PureComponent));
$6ec14c358cee67a4$export$5012f160061c9df4.propTypes = $6ec14c358cee67a4$var$_objectSpread({
    className: (0, $46a785ad40348064$export$d53f3db2f43345df),
    inputRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    pdf: (0, $46a785ad40348064$export$d22001c6ab8dd37)
}, (0, $46a785ad40348064$export$1e08905474334888));
function $6ec14c358cee67a4$var$Outline(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b7406b9166257ba4$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6ec14c358cee67a4$export$5012f160061c9df4, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
            ref: ref
        }, context, props));
    });
}
var $6ec14c358cee67a4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef($6ec14c358cee67a4$var$Outline);




var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");




/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $2a61e75d1cb1bae8$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === 'function') inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}






var $gIfym = parcelRequire("gIfym");
var $299b34594af8ece3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $gIfym.createContext)(null);





var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");




var $7lXH1 = parcelRequire("7lXH1");



function $3000d697993296cc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3000d697993296cc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $3000d697993296cc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3000d697993296cc$var$ANNOTATION_MODE = $7lXH1.AnnotationMode;
var $3000d697993296cc$export$e3ecf0e48491aaf4 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(PageCanvasInternal, _PureComponent);
    var _super = $3000d697993296cc$var$_createSuper(PageCanvasInternal);
    function PageCanvasInternal() {
        var _this;
        (0, $vdtyq.default)(this, PageCanvasInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "canvasElement", /*#__PURE__*/ (0, $gIfym.createRef)());
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onRenderSuccess", function() {
            _this.renderer = null;
            var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale = _this$props.scale;
            if (onRenderSuccess) onRenderSuccess((0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, scale));
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onRenderError", function(error) {
            if ((0, $02e2df2893cf0bcc$export$99075c4d008e6ab1)(error)) return;
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onRenderError = _this.props.onRenderError;
            if (onRenderError) onRenderError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "drawPageOnCanvas", function() {
            var canvas = _this.canvasElement.current;
            if (!canvas) return null;
            var _assertThisInitialize = (0, $6o8oQ.default)(_this), renderViewport = _assertThisInitialize.renderViewport, viewport = _assertThisInitialize.viewport;
            var _this$props2 = _this.props, canvasBackground = _this$props2.canvasBackground, page = _this$props2.page, renderForms = _this$props2.renderForms;
            canvas.width = renderViewport.width;
            canvas.height = renderViewport.height;
            canvas.style.width = "".concat(Math.floor(viewport.width), "px");
            canvas.style.height = "".concat(Math.floor(viewport.height), "px");
            var renderContext = {
                annotationMode: renderForms ? $3000d697993296cc$var$ANNOTATION_MODE.ENABLE_FORMS : $3000d697993296cc$var$ANNOTATION_MODE.ENABLE,
                get canvasContext () {
                    return canvas.getContext('2d');
                },
                viewport: renderViewport
            };
            if (canvasBackground) renderContext.background = canvasBackground;
             // If another render is in progress, let's cancel it
            _this.cancelRenderingTask();
            _this.renderer = page.render(renderContext);
            return _this.renderer.promise.then(_this.onRenderSuccess)["catch"](_this.onRenderError);
        });
        return _this;
    }
    (0, $lU1Um.default)(PageCanvasInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.drawPageOnCanvas();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, canvasBackground = _this$props3.canvasBackground, page = _this$props3.page, renderForms = _this$props3.renderForms;
                if (canvasBackground !== prevProps.canvasBackground || renderForms !== prevProps.renderForms) {
                    // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
                    page.cleanup();
                    this.drawPageOnCanvas();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRenderingTask();
                var canvas = this.canvasElement.current;
                /**
       * Zeroing the width and height cause most browsers to release graphics
       * resources immediately, which can greatly reduce memory consumption.
       */ if (canvas) {
                    canvas.width = 0;
                    canvas.height = 0;
                }
            }
        },
        {
            key: "cancelRenderingTask",
            value: function cancelRenderingTask() {
                if (this.renderer) {
                    this.renderer.cancel();
                    this.renderer = null;
                }
            }
        },
        {
            key: "renderViewport",
            get: function get() {
                var _this$props4 = this.props, page = _this$props4.page, rotate = _this$props4.rotate, scale = _this$props4.scale;
                var pixelRatio = (0, $02e2df2893cf0bcc$export$d39ce20a37bba061)();
                return page.getViewport({
                    scale: scale * pixelRatio,
                    rotation: rotate
                });
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props5 = this.props, page = _this$props5.page, rotate = _this$props5.rotate, scale = _this$props5.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var canvasRef = this.props.canvasRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("canvas", {
                    className: "react-pdf__Page__canvas",
                    dir: "ltr",
                    ref: (0, $2a61e75d1cb1bae8$export$2e2bcd8739ae039)(canvasRef, this.canvasElement),
                    style: {
                        display: 'block',
                        userSelect: 'none'
                    }
                });
            }
        }
    ]);
    return PageCanvasInternal;
}((0, $gIfym.PureComponent));
$3000d697993296cc$export$e3ecf0e48491aaf4.propTypes = {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    canvasRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    page: (0, $46a785ad40348064$export$61d82a1ff85c609a).isRequired,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired
};
function $3000d697993296cc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($3000d697993296cc$export$e3ecf0e48491aaf4, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, context, props));
    });
}




var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");



var $7lXH1 = parcelRequire("7lXH1");



function $d7d9f5bed76bb2cd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d7d9f5bed76bb2cd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $d7d9f5bed76bb2cd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $d7d9f5bed76bb2cd$export$c43ce483afb9a093 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(PageSVGInternal, _PureComponent);
    var _super = $d7d9f5bed76bb2cd$var$_createSuper(PageSVGInternal);
    function PageSVGInternal() {
        var _this;
        (0, $vdtyq.default)(this, PageSVGInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "state", {
            svg: null
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onRenderSuccess", function() {
            _this.renderer = null;
            var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale = _this$props.scale;
            if (onRenderSuccess) onRenderSuccess((0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, scale));
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onRenderError", function(error) {
            if ((0, $02e2df2893cf0bcc$export$99075c4d008e6ab1)(error)) return;
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onRenderError = _this.props.onRenderError;
            if (onRenderError) onRenderError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "renderSVG", function() {
            var page = _this.props.page;
            _this.renderer = page.getOperatorList();
            return _this.renderer.then(function(operatorList) {
                var svgGfx = new $7lXH1.SVGGraphics(page.commonObjs, page.objs);
                _this.renderer = svgGfx.getSVG(operatorList, _this.viewport).then(function(svg) {
                    _this.setState({
                        svg: svg
                    }, _this.onRenderSuccess);
                })["catch"](_this.onRenderError);
            })["catch"](_this.onRenderError);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "drawPageOnContainer", function(element) {
            var svg = _this.state.svg;
            if (!element || !svg) return;
             // Append SVG element to the main container, if this hasn't been done already
            if (!element.firstElementChild) element.appendChild(svg);
            var _this$viewport = _this.viewport, width = _this$viewport.width, height = _this$viewport.height;
            svg.setAttribute('width', width);
            svg.setAttribute('height', height);
        });
        return _this;
    }
    (0, $lU1Um.default)(PageSVGInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderSVG();
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale = _this$props2.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$viewport2 = this.viewport, width = _this$viewport2.width, height = _this$viewport2.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
                    className: "react-pdf__Page__svg" // Note: This cannot be shortened, as we need this function to be called with each render.
                    ,
                    ref: function ref(_ref) {
                        return _this2.drawPageOnContainer(_ref);
                    },
                    style: {
                        display: 'block',
                        backgroundColor: 'white',
                        overflow: 'hidden',
                        width: width,
                        height: height,
                        userSelect: 'none'
                    }
                });
            }
        }
    ]);
    return PageSVGInternal;
}((0, $gIfym.PureComponent));
$d7d9f5bed76bb2cd$export$c43ce483afb9a093.propTypes = {
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    page: (0, $46a785ad40348064$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired
};
function $d7d9f5bed76bb2cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($d7d9f5bed76bb2cd$export$c43ce483afb9a093, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, context, props));
    });
}




var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");








var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");



function $2bfa09b54dd5f6a9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2bfa09b54dd5f6a9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $2bfa09b54dd5f6a9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2bfa09b54dd5f6a9$export$9a99b4bb3cdb3d5d = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(TextLayerItemInternal, _PureComponent);
    var _super = $2bfa09b54dd5f6a9$var$_createSuper(TextLayerItemInternal);
    function TextLayerItemInternal() {
        var _this;
        (0, $vdtyq.default)(this, TextLayerItemInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "itemElement", /*#__PURE__*/ (0, $gIfym.createRef)());
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "getElementWidth", function(element) {
            var _assertThisInitialize = (0, $6o8oQ.default)(_this), sideways = _assertThisInitialize.sideways;
            return element.getBoundingClientRect()[sideways ? 'height' : 'width'];
        });
        return _this;
    }
    (0, $lU1Um.default)(TextLayerItemInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.alignTextItem();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.alignTextItem();
            }
        },
        {
            key: "unrotatedViewport",
            get: function get() {
                var _this$props = this.props, page = _this$props.page, scale = _this$props.scale;
                return page.getViewport({
                    scale: scale
                });
            }
        },
        {
            key: "rotate",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
                return rotate - page.rotate;
            }
        },
        {
            key: "sideways",
            get: function get() {
                var rotate = this.rotate;
                return rotate % 180 !== 0;
            }
        },
        {
            key: "defaultSideways",
            get: function get() {
                var rotation = this.unrotatedViewport.rotation;
                return rotation % 180 !== 0;
            }
        },
        {
            key: "fontSize",
            get: function get() {
                var transform = this.props.transform;
                var defaultSideways = this.defaultSideways;
                var _transform = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(transform, 2), fontHeightPx = _transform[0], fontWidthPx = _transform[1];
                return defaultSideways ? fontWidthPx : fontHeightPx;
            }
        },
        {
            key: "top",
            get: function get() {
                var transform = this.props.transform;
                var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
                var _transform2 = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(transform, 6), /* fontHeightPx */ /* fontWidthPx */ offsetX = _transform2[2], offsetY = _transform2[3], x = _transform2[4], y = _transform2[5];
                var _viewport$viewBox = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(viewport.viewBox, 4), /* xMin */ yMin = _viewport$viewBox[1], yMax = _viewport$viewBox[3];
                return defaultSideways ? x + offsetX + yMin : yMax - (y + offsetY);
            }
        },
        {
            key: "left",
            get: function get() {
                var transform = this.props.transform;
                var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
                var _transform3 = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(transform, 6), /* fontHeightPx */ /* fontWidthPx */ /* offsetX */ /* offsetY */ x = _transform3[4], y = _transform3[5];
                var _viewport$viewBox2 = (0, $2bbbd885e1fef371$export$2e2bcd8739ae039)(viewport.viewBox, 1), xMin = _viewport$viewBox2[0];
                return defaultSideways ? y - xMin : x - xMin;
            }
        },
        {
            key: "getFontData",
            value: function getFontData(fontName) {
                var page = this.props.page;
                return new Promise(function(resolve) {
                    page.commonObjs.get(fontName, resolve);
                });
            }
        },
        {
            key: "alignTextItem",
            value: function alignTextItem() {
                var _this2 = this;
                var element = this.itemElement.current;
                if (!element) return;
                element.style.transform = '';
                var _this$props3 = this.props, fontName = _this$props3.fontName, scale = _this$props3.scale, width = _this$props3.width;
                element.style.fontFamily = "".concat(fontName, ", sans-serif");
                this.getFontData(fontName).then(function(fontData) {
                    var fallbackFontName = fontData ? fontData.fallbackName : 'sans-serif';
                    element.style.fontFamily = "".concat(fontName, ", ").concat(fallbackFontName);
                    var targetWidth = width * scale;
                    var actualWidth = _this2.getElementWidth(element);
                    var transform = "scaleX(".concat(targetWidth / actualWidth, ")");
                    var ascent = fontData ? fontData.ascent : 0;
                    if (ascent) transform += " translateY(".concat((1 - ascent) * 100, "%)");
                    element.style.transform = transform;
                    element.style.WebkitTransform = transform;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var fontSize = this.fontSize, top = this.top, left = this.left;
                var _this$props4 = this.props, customTextRenderer = _this$props4.customTextRenderer, scale = _this$props4.scale, text = _this$props4.str;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                    ref: this.itemElement,
                    style: {
                        height: '1em',
                        fontFamily: 'sans-serif',
                        fontSize: "".concat(fontSize * scale, "px"),
                        position: 'absolute',
                        top: "".concat(top * scale, "px"),
                        left: "".concat(left * scale, "px"),
                        transformOrigin: 'left bottom',
                        whiteSpace: 'pre',
                        pointerEvents: 'all'
                    }
                }, customTextRenderer ? customTextRenderer(this.props) : text);
            }
        }
    ]);
    return TextLayerItemInternal;
}((0, $gIfym.PureComponent));
$2bfa09b54dd5f6a9$export$9a99b4bb3cdb3d5d.propTypes = {
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    fontName: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired,
    itemIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired,
    page: (0, $46a785ad40348064$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    str: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired
};
function $2bfa09b54dd5f6a9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($2bfa09b54dd5f6a9$export$9a99b4bb3cdb3d5d, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, context, props));
    });
}




function $2a42932eb47a5fc8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2a42932eb47a5fc8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $2a42932eb47a5fc8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2a42932eb47a5fc8$export$2a4163b3d90be9ba = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(TextLayerInternal, _PureComponent);
    var _super = $2a42932eb47a5fc8$var$_createSuper(TextLayerInternal);
    function TextLayerInternal() {
        var _this;
        (0, $vdtyq.default)(this, TextLayerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "state", {
            textItems: null
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "loadTextItems", function() {
            var page = _this.props.page;
            var cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(page.getTextContent());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(_ref) {
                var textItems = _ref.items;
                _this.setState({
                    textItems: textItems
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadSuccess", function() {
            var onGetTextSuccess = _this.props.onGetTextSuccess;
            var textItems = _this.state.textItems;
            if (onGetTextSuccess) onGetTextSuccess(textItems);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadError", function(error) {
            _this.setState({
                textItems: false
            });
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onGetTextError = _this.props.onGetTextError;
            if (onGetTextError) onGetTextError(error);
        });
        return _this;
    }
    (0, $lU1Um.default)(TextLayerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var page = this.props.page;
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(page, 'Attempted to load page text content, but no page was specified.');
                this.loadTextItems();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var page = this.props.page;
                if (prevProps.page && page !== prevProps.page) this.loadTextItems();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "unrotatedViewport",
            get: function get() {
                var _this$props = this.props, page = _this$props.page, scale = _this$props.scale;
                return page.getViewport({
                    scale: scale
                });
            }
        },
        {
            key: "rotate",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
                return rotate - page.rotate;
            }
        },
        {
            key: "renderTextItems",
            value: function renderTextItems() {
                var textItems = this.state.textItems;
                if (!textItems) return null;
                return textItems.map(function(textItem, itemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2bfa09b54dd5f6a9$export$2e2bcd8739ae039 // eslint-disable-next-line react/no-array-index-key
                    ), (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
                        key: itemIndex,
                        itemIndex: itemIndex
                    }, textItem));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var viewport = this.unrotatedViewport, rotate = this.rotate;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
                    className: "react-pdf__Page__textContent",
                    style: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: "".concat(viewport.width, "px"),
                        height: "".concat(viewport.height, "px"),
                        color: 'transparent',
                        transform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
                        WebkitTransform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
                        pointerEvents: 'none'
                    }
                }, this.renderTextItems());
            }
        }
    ]);
    return TextLayerInternal;
}((0, $gIfym.PureComponent));
$2a42932eb47a5fc8$export$2a4163b3d90be9ba.propTypes = {
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    page: (0, $46a785ad40348064$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
};
function $2a42932eb47a5fc8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($2a42932eb47a5fc8$export$2a4163b3d90be9ba, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, context, props));
    });
}




var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");

var $7kInc = parcelRequire("7kInc");

var $kNXwL = parcelRequire("kNXwL");

var $lV8DW = parcelRequire("lV8DW");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");





var $7lXH1 = parcelRequire("7lXH1");




function $e4a09319bfcd7f5b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e4a09319bfcd7f5b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $e4a09319bfcd7f5b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e4a09319bfcd7f5b$export$46f5ffc431ae68b7 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(AnnotationLayerInternal, _PureComponent);
    var _super = $e4a09319bfcd7f5b$var$_createSuper(AnnotationLayerInternal);
    function AnnotationLayerInternal() {
        var _this;
        (0, $vdtyq.default)(this, AnnotationLayerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "state", {
            annotations: null
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "layerElement", /*#__PURE__*/ (0, $gIfym.createRef)());
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "loadAnnotations", function() {
            var page = _this.props.page;
            var cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(page.getAnnotations());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(annotations) {
                _this.setState({
                    annotations: annotations
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadSuccess", function() {
            var onGetAnnotationsSuccess = _this.props.onGetAnnotationsSuccess;
            var annotations = _this.state.annotations;
            if (onGetAnnotationsSuccess) onGetAnnotationsSuccess(annotations);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadError", function(error) {
            _this.setState({
                annotations: false
            });
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onGetAnnotationsError = _this.props.onGetAnnotationsError;
            if (onGetAnnotationsError) onGetAnnotationsError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onRenderSuccess", function() {
            var onRenderAnnotationLayerSuccess = _this.props.onRenderAnnotationLayerSuccess;
            if (onRenderAnnotationLayerSuccess) onRenderAnnotationLayerSuccess();
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onRenderError", function(error) {
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onRenderAnnotationLayerError = _this.props.onRenderAnnotationLayerError;
            if (onRenderAnnotationLayerError) onRenderAnnotationLayerError(error);
        });
        return _this;
    }
    (0, $lU1Um.default)(AnnotationLayerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var page = this.props.page;
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(page, 'Attempted to load page annotations, but no page was specified.');
                this.loadAnnotations();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, page = _this$props.page, renderForms = _this$props.renderForms;
                if (prevProps.page && page !== prevProps.page || renderForms !== prevProps.renderForms) this.loadAnnotations();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale = _this$props2.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "renderAnnotationLayer",
            value: function renderAnnotationLayer() {
                var annotations = this.state.annotations;
                if (!annotations) return;
                var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, linkService = _this$props3.linkService, page = _this$props3.page, renderForms = _this$props3.renderForms;
                var viewport = this.viewport.clone({
                    dontFlip: true
                });
                var parameters = {
                    annotations: annotations,
                    div: this.layerElement.current,
                    imageResourcesPath: imageResourcesPath,
                    linkService: linkService,
                    page: page,
                    renderForms: renderForms,
                    viewport: viewport
                };
                this.layerElement.current.innerHTML = '';
                try {
                    $7lXH1.AnnotationLayer.render(parameters);
                    this.onRenderSuccess();
                } catch (error) {
                    this.onRenderError(error);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
                    className: "react-pdf__Page__annotations annotationLayer",
                    ref: this.layerElement
                }, this.renderAnnotationLayer());
            }
        }
    ]);
    return AnnotationLayerInternal;
}((0, $gIfym.PureComponent));
$e4a09319bfcd7f5b$export$46f5ffc431ae68b7.propTypes = {
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    linkService: (0, $46a785ad40348064$export$836c1083c8eb7ae).isRequired,
    onGetAnnotationsError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onGetAnnotationsSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderAnnotationLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderAnnotationLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    page: (0, $46a785ad40348064$export$61d82a1ff85c609a),
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
};
var $e4a09319bfcd7f5b$var$AnnotationLayer = function AnnotationLayer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b7406b9166257ba4$export$2e2bcd8739ae039).Consumer, null, function(documentContext) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Consumer, null, function(pageContext) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e4a09319bfcd7f5b$export$46f5ffc431ae68b7, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, documentContext, pageContext, props));
        });
    });
};
var $e4a09319bfcd7f5b$export$2e2bcd8739ae039 = $e4a09319bfcd7f5b$var$AnnotationLayer;




function $f6292e99e22e05e6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f6292e99e22e05e6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f6292e99e22e05e6$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f6292e99e22e05e6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f6292e99e22e05e6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f6292e99e22e05e6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lV8DW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lV8DW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kNXwL.default)(this, result);
    };
}
function $f6292e99e22e05e6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f6292e99e22e05e6$var$defaultScale = 1;
var $f6292e99e22e05e6$export$1cc9850f801e298 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7kInc.default)(PageInternal, _PureComponent);
    var _super = $f6292e99e22e05e6$var$_createSuper(PageInternal);
    function PageInternal() {
        var _this;
        (0, $vdtyq.default)(this, PageInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "state", {
            page: null
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "pageElement", /*#__PURE__*/ (0, $gIfym.createRef)());
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadSuccess", function() {
            var _this$props = _this.props, onLoadSuccess = _this$props.onLoadSuccess, registerPage = _this$props.registerPage;
            var page = _this.state.page;
            if (onLoadSuccess) onLoadSuccess((0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, _this.scale));
            if (registerPage) registerPage(_this.pageIndex, _this.pageElement.current);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "onLoadError", function(error) {
            _this.setState({
                page: false
            });
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "loadPage", function() {
            var pdf = _this.props.pdf;
            var pageNumber = _this.getPageNumber();
            if (!pageNumber) return;
            _this.setState(function(prevState) {
                if (!prevState.page) return null;
                return {
                    page: null
                };
            });
            var cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
            _this.runningTask = cancellable;
            cancellable.promise.then(function(page) {
                _this.setState({
                    page: page
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        return _this;
    }
    (0, $lU1Um.default)(PageInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pdf = this.props.pdf;
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pdf, 'Attempted to load a page, but no document was specified.');
                this.loadPage();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var pdf = this.props.pdf;
                if (prevProps.pdf && pdf !== prevProps.pdf || this.getPageNumber() !== this.getPageNumber(prevProps)) {
                    var unregisterPage = this.props.unregisterPage;
                    if (unregisterPage) unregisterPage(this.getPageIndex(prevProps));
                    this.loadPage();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var unregisterPage = this.props.unregisterPage;
                if (unregisterPage) unregisterPage(this.pageIndex);
                (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "childContext",
            get: function get() {
                var page = this.state.page;
                if (!page) return {};
                var _this$props2 = this.props, canvasBackground = _this$props2.canvasBackground, customTextRenderer = _this$props2.customTextRenderer, onGetAnnotationsError = _this$props2.onGetAnnotationsError, onGetAnnotationsSuccess = _this$props2.onGetAnnotationsSuccess, onGetTextError = _this$props2.onGetTextError, onGetTextSuccess = _this$props2.onGetTextSuccess, onRenderAnnotationLayerError = _this$props2.onRenderAnnotationLayerError, onRenderAnnotationLayerSuccess = _this$props2.onRenderAnnotationLayerSuccess, onRenderError = _this$props2.onRenderError, onRenderSuccess = _this$props2.onRenderSuccess, renderForms = _this$props2.renderForms, renderInteractiveForms = _this$props2.renderInteractiveForms;
                return {
                    canvasBackground: canvasBackground,
                    customTextRenderer: customTextRenderer,
                    onGetAnnotationsError: onGetAnnotationsError,
                    onGetAnnotationsSuccess: onGetAnnotationsSuccess,
                    onGetTextError: onGetTextError,
                    onGetTextSuccess: onGetTextSuccess,
                    onRenderAnnotationLayerError: onRenderAnnotationLayerError,
                    onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccess,
                    onRenderError: onRenderError,
                    onRenderSuccess: onRenderSuccess,
                    page: page,
                    renderForms: renderForms !== null && renderForms !== void 0 ? renderForms : renderInteractiveForms,
                    // For backward compatibility
                    rotate: this.rotate,
                    scale: this.scale
                };
            }
        },
        {
            key: "getPageIndex",
            value: function getPageIndex() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                if ((0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(props.pageNumber)) return props.pageNumber - 1;
                if ((0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(props.pageIndex)) return props.pageIndex;
                return null;
            }
        },
        {
            key: "getPageNumber",
            value: function getPageNumber() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                if ((0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(props.pageNumber)) return props.pageNumber;
                if ((0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(props.pageIndex)) return props.pageIndex + 1;
                return null;
            }
        },
        {
            key: "pageIndex",
            get: function get() {
                return this.getPageIndex();
            }
        },
        {
            key: "pageNumber",
            get: function get() {
                return this.getPageNumber();
            }
        },
        {
            key: "rotate",
            get: function get() {
                var rotate = this.props.rotate;
                if ((0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(rotate)) return rotate;
                var page = this.state.page;
                if (!page) return null;
                return page.rotate;
            }
        },
        {
            key: "scale",
            get: function get() {
                var page = this.state.page;
                if (!page) return null;
                var _this$props3 = this.props, scale = _this$props3.scale, width = _this$props3.width, height = _this$props3.height;
                var rotate = this.rotate; // Be default, we'll render page at 100% * scale width.
                var pageScale = 1; // Passing scale explicitly null would cause the page not to render
                var scaleWithDefault = scale === null ? $f6292e99e22e05e6$var$defaultScale : scale; // If width/height is defined, calculate the scale of the page so it could be of desired width.
                if (width || height) {
                    var viewport = page.getViewport({
                        scale: 1,
                        rotation: rotate
                    });
                    pageScale = width ? width / viewport.width : height / viewport.height;
                }
                return scaleWithDefault * pageScale;
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $78c4fc952655f552$export$2e2bcd8739ae039)(this.props, function() {
                    var page = _this2.state.page;
                    if (!page) return page;
                    return (0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, _this2.scale);
                });
            }
        },
        {
            key: "pageKey",
            get: function get() {
                var page = this.state.page;
                return "".concat(page.pageIndex, "@").concat(this.scale, "/").concat(this.rotate);
            }
        },
        {
            key: "pageKeyNoScale",
            get: function get() {
                var page = this.state.page;
                return "".concat(page.pageIndex, "/").concat(this.rotate);
            }
        },
        {
            key: "renderMainLayer",
            value: function renderMainLayer() {
                var _this$props4 = this.props, canvasRef = _this$props4.canvasRef, renderMode = _this$props4.renderMode;
                switch(renderMode){
                    case 'none':
                        return null;
                    case 'svg':
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $d7d9f5bed76bb2cd$export$2e2bcd8739ae039), {
                            key: "".concat(this.pageKeyNoScale, "_svg")
                        });
                    case 'canvas':
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $3000d697993296cc$export$2e2bcd8739ae039), {
                            key: "".concat(this.pageKey, "_canvas"),
                            canvasRef: canvasRef
                        });
                }
            }
        },
        {
            key: "renderTextLayer",
            value: function renderTextLayer() {
                var renderTextLayer = this.props.renderTextLayer;
                if (!renderTextLayer) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2a42932eb47a5fc8$export$2e2bcd8739ae039), {
                    key: "".concat(this.pageKey, "_text")
                });
            }
        },
        {
            key: "renderAnnotationLayer",
            value: function renderAnnotationLayer() {
                var renderAnnotationLayer = this.props.renderAnnotationLayer;
                if (!renderAnnotationLayer) return null;
                /**
       * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
       * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $e4a09319bfcd7f5b$export$2e2bcd8739ae039), {
                    key: "".concat(this.pageKey, "_annotations")
                });
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, this.renderMainLayer(), this.renderTextLayer(), this.renderAnnotationLayer(), children);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var pageNumber = this.pageNumber;
                var pdf = this.props.pdf;
                var page = this.state.page;
                if (!pageNumber) {
                    var noData = this.props.noData;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
                        type: "no-data"
                    }, typeof noData === 'function' ? noData() : noData);
                }
                if (pdf === null || page === null) {
                    var loading = this.props.loading;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
                        type: "loading"
                    }, typeof loading === 'function' ? loading() : loading);
                }
                if (pdf === false || page === false) {
                    var error = this.props.error;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
                        type: "error"
                    }, typeof error === 'function' ? error() : error);
                }
                return this.renderChildren();
            }
        },
        {
            key: "render",
            value: function render() {
                var pageNumber = this.pageNumber;
                var _this$props5 = this.props, className = _this$props5.className, inputRef = _this$props5.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
                    className: (0, $22b5539e131d8a59$export$2e2bcd8739ae039)('react-pdf__Page', className),
                    "data-page-number": pageNumber,
                    ref: (0, $2a61e75d1cb1bae8$export$2e2bcd8739ae039)(inputRef, this.pageElement),
                    style: {
                        position: 'relative'
                    }
                }, this.eventProps), this.renderContent());
            }
        }
    ]);
    return PageInternal;
}((0, $gIfym.PureComponent));
$f6292e99e22e05e6$export$1cc9850f801e298.defaultProps = {
    error: 'Failed to load the page.',
    loading: "Loading page\u2026",
    noData: 'No page specified.',
    renderAnnotationLayer: true,
    renderForms: false,
    renderMode: 'canvas',
    renderTextLayer: true,
    scale: $f6292e99e22e05e6$var$defaultScale
};
var $f6292e99e22e05e6$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
]);
$f6292e99e22e05e6$export$1cc9850f801e298.propTypes = $f6292e99e22e05e6$var$_objectSpread($f6292e99e22e05e6$var$_objectSpread({}, (0, $46a785ad40348064$export$1e08905474334888)), {}, {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node,
    className: (0, $46a785ad40348064$export$d53f3db2f43345df),
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    error: $f6292e99e22e05e6$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    inputRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    loading: $f6292e99e22e05e6$var$isFunctionOrNode,
    noData: $f6292e99e22e05e6$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    pageIndex: (0, $46a785ad40348064$export$7b4c8bd6e6871332),
    pageNumber: (0, $46a785ad40348064$export$973e710208ddd50f),
    pdf: (0, $46a785ad40348064$export$d22001c6ab8dd37),
    registerPage: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    renderInteractiveForms: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    // For backward compatibility
    renderMode: (0, $46a785ad40348064$export$70f0c3edbd58f82c),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    unregisterPage: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
});
function $f6292e99e22e05e6$var$Page(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b7406b9166257ba4$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($f6292e99e22e05e6$export$1cc9850f801e298, (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({
            ref: ref
        }, context, props));
    });
}
var $f6292e99e22e05e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef($f6292e99e22e05e6$var$Page);



(0, $02e2df2893cf0bcc$export$e7ec4a9e2d586a77)();
var $b6fc83d0a4f8b4b0$exports = {};
var $69f6ccfe12857869$exports = {};
"use strict";
$69f6ccfe12857869$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $b6fc83d0a4f8b4b0$var$url = new URL($parcel$resolve("7pu9e"));
$b6fc83d0a4f8b4b0$exports = $69f6ccfe12857869$exports($b6fc83d0a4f8b4b0$var$url.toString(), $b6fc83d0a4f8b4b0$var$url.origin, true);


if (typeof window !== 'undefined' && 'Worker' in window) $7lXH1.GlobalWorkerOptions.workerPort = new Worker($b6fc83d0a4f8b4b0$exports);


function $bdb5348d9b0e077d$export$2e2bcd8739ae039({ file: file }) {
    const [numPages, setNumPages] = (0, $gIfym.useState)(null);
    function onDocumentLoadSuccess({ numPages: numPages }) {
        setNumPages(numPages);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: file && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $97a1f05fb7e6099a$export$2e2bcd8739ae039), {
            file: file,
            onLoadSuccess: onDocumentLoadSuccess,
            children: Array.from(new Array(numPages), (el, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $f6292e99e22e05e6$export$2e2bcd8739ae039), {
                    pageNumber: index + 1,
                    className: "mb-10 drop-shadow-xl bg-green-50"
                }, `page_${index + 1}`))
        })
    });
}


var $094312c91b95c95a$exports = {};
$094312c91b95c95a$exports = $parcel$resolve("lMPH0");


let $b8730a9792094041$var$downloadIcon = new URL($094312c91b95c95a$exports);
var $ef670f66a728d6b4$exports = {};
$ef670f66a728d6b4$exports = $parcel$resolve("atD8y");


let $b8730a9792094041$var$previewIcon = new URL($ef670f66a728d6b4$exports);
const $b8730a9792094041$var$imageTypes = [
    "image/png",
    "image/jpeg",
    "image/gif",
    "image/bmp"
];
const $b8730a9792094041$var$fileTypes = [
    "application/pdf"
];
function $b8730a9792094041$export$2e2bcd8739ae039({ id: id, documentTypeName: name, preview: preview, freeTextNote: freeTextNote, base64Content: base64Content }) {
    const [downloadLoading, setDownloadLoading] = (0, $gIfym.useState)(false);
    const [previewLoading, setPreviewLoading] = (0, $gIfym.useState)(false);
    const [previewModal, setPreviewModal] = (0, $gIfym.useState)(false);
    const [previewFile, setPreviewFile] = (0, $gIfym.useState)(null);
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    const onDownload = ()=>{
        setDownloadLoading(true);
        const caseId = user.customerIdaCaseId;
        (0, $6c726320d527757b$export$6e17806a03288445)(user, caseId, id).then((data)=>{
            const link = document.createElement("a");
            link.href = data.object.base64Content;
            link.download = data.object.fileName;
            link.click();
            setDownloadLoading(false);
        }).catch((error)=>{
            setDownloadLoading(false);
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
    };
    const onPreview = ()=>{
        setPreviewModal(true);
        setPreviewLoading(true);
        const caseId = user.customerIdaCaseId;
        (0, $6c726320d527757b$export$6e17806a03288445)(user, caseId, id).then((data)=>{
            setPreviewLoading(false);
            setPreviewFile({
                content: data.object.base64Content,
                type: data.object.contentType
            });
        }).catch((error)=>{
            setPreviewLoading(false);
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
    };
    const onPreviewClose = ()=>{
        setPreviewModal(!previewModal);
        setPreviewFile(null);
    };
    function renderFile() {
        if ($b8730a9792094041$var$imageTypes.includes(previewFile.type)) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
            src: previewFile.content,
            className: "max-w-full max-h-full mx-auto"
        });
        if ($b8730a9792094041$var$fileTypes.includes(previewFile.type)) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bdb5348d9b0e077d$export$2e2bcd8739ae039), {
                file: previewFile.content
            })
        });
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "flex flex-col relative rounded max-w-[160px] bg-white drop-shadow-xl",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "relative group",
                children: [
                    base64Content ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "flex flex-shrink-0 rounded-t-lg mb-4 w-[160px] h-[109px] bg-no-repeat bg-cover bg-center cursor-pointer",
                        style: {
                            backgroundImage: `url(${base64Content})`
                        }
                    }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        className: "rounded-t-lg mb-4 cursor-pointer",
                        src: preview
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "absolute hidden w-full h-full top-0 group-hover:block",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: "flex h-full justify-end items-start cursor-pointer pt-2 pr-2",
                            onClick: onPreview,
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                src: $b8730a9792094041$var$previewIcon
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "flex flex-col h-full justify-between text-center text-[#002733] px-3",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "font-interbold leading-5 mb-2",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "px-0.5 mb-2 text-sm",
                                children: freeTextNote
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "flex justify-end mb-3 min-h-[24px]",
                        children: downloadLoading ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                            theme: "dark",
                            size: "small"
                        }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            onClick: onDownload,
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                src: $b8730a9792094041$var$downloadIcon
                            })
                        })
                    })
                ]
            }),
            previewLoading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "absolute top-2 left-2",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                    size: "small"
                })
            }),
            !previewLoading && previewModal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                title: name,
                onClose: onPreviewClose,
                children: previewFile && renderFile()
            })
        ]
    });
}



var $bdaefd151280b3c2$exports = {};
$bdaefd151280b3c2$exports = $parcel$resolve("ipHR2");


let $2f74e7c48cd7c516$var$imgThumb = new URL($bdaefd151280b3c2$exports);
var $f0b006236d304116$exports = {};
$f0b006236d304116$exports = $parcel$resolve("20uZv");


let $2f74e7c48cd7c516$var$pdfThumb = new URL($f0b006236d304116$exports);
function $2f74e7c48cd7c516$export$2e2bcd8739ae039({ section: section, type: type }) {
    const [documents, setDocuments] = (0, $gIfym.useState)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const wsConnection = (0, $6c05a81472ccb93d$export$bd1537e1f64b53aa)();
    const user = auth.user;
    const controllerRef = (0, $gIfym.useRef)();
    (0, $gIfym.useEffect)(()=>{
        if (!user || !wsConnection || !wsConnection.connectionId) return null;
        const controller = fetchDocuments();
        let channel = "";
        switch(type){
            case 1:
                channel = "Customer_Document";
                break;
            default:
            case 2:
                channel = "Customer_Image";
                break;
        }
        const handler = ()=>setTimeout(()=>{
                fetchDocuments();
            }, 1000);
        wsConnection.on(channel, handler);
        return ()=>{
            if (typeof controller === "object") controller.abort();
            wsConnection.off(channel, handler);
        };
    }, [
        user,
        wsConnection?.connectionId
    ]);
    function fetchDocuments() {
        if (!user) return null;
        const caseId = user.customerIdaCaseId;
        if (caseId === undefined) return null;
        if (controllerRef.current) controllerRef.current.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        (0, $6c726320d527757b$export$782f6f8dc0feb7b3)(user, caseId, type, controllerRef).then((data)=>{
            if (data.success) return data.object;
            auth.addNotification(data.message);
            return false;
        }).then((data)=>{
            if (data instanceof Array && data.length > 0) {
                setDocuments(data);
                return true;
            }
            setDocuments([]);
        }).catch((error)=>{
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
        controllerRef.current = null;
        return controller;
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            documents === undefined && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "flex flex-col items-center h-full justify-center",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                    theme: "dark",
                    size: "small"
                })
            }),
            documents instanceof Array && documents.length === 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                className: "text-sm text-dark-blue",
                children: t("no-items")
            }) : null,
            documents && documents.length > 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "mb-10",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "flex flex-wrap gap-8 max-w-fit",
                    children: documents.map((doc)=>{
                        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b8730a9792094041$export$2e2bcd8739ae039), {
                            preview: type === 2 ? $2f74e7c48cd7c516$var$pdfThumb : $2f74e7c48cd7c516$var$imgThumb,
                            ...doc
                        }, doc.id);
                    })
                })
            }) : null
        ]
    });
}




function $02bcd05d145f160c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    document.title = t("files-title");
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $9695464cd69251e9$export$8ef2ed426dede42d), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                title: document.title,
                desc: t("files-description")
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "p-5 pt-8 sm:p-10",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2f74e7c48cd7c516$export$2e2bcd8739ae039), {
                    section: "All documents",
                    type: 1
                })
            })
        ]
    });
}




var $gIfym = parcelRequire("gIfym");






function $161658f7e776d6dc$export$2e2bcd8739ae039() {
    const [submitting, setSubmitting] = (0, $gIfym.useState)(false);
    const [password, setPassword] = (0, $gIfym.useState)("");
    const [passwordCheck, setPasswordCheck] = (0, $gIfym.useState)("");
    const [code, setCode] = (0, $gIfym.useState)("");
    const [email, setEmail] = (0, $gIfym.useState)("");
    const { t: t, i18n: i18n } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const [searchParams, setSearchParams] = (0, $8a32432afacbfa13$export$f1a78c17382fe22a)();
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    document.title = t("reset-password-confirm-title");
    (0, $gIfym.useEffect)(()=>{
        const email = searchParams.get("email");
        const code = searchParams.get("tempCode");
        setEmail(email);
        setCode(code);
    }, [
        searchParams
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        if (!code) {
            auth.addNotification(t("messages.code-error"));
            setSubmitting(false);
            return;
        }
        if (password !== passwordCheck) {
            auth.addNotification(t("messages.passwords-match-error"));
            setSubmitting(false);
            return;
        }
        await confirmChangePassword(email, code, password);
    };
    async function confirmChangePassword(email, code, password) {
        try {
            await (0, $b0aaffaa8d007c37$export$dc726c8e334dd814)(email, code, password);
            navigate("/signin?prs=1");
        } catch (error) {
            console.log("Error:", error);
            const p = (0, $e845536d9724b5be$export$709793eec59fe573)(error.message);
            auth.addNotification(t([
                `messages.${p}`,
                "messages.general"
            ]));
        }
        setSubmitting(false);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $006b2c47c574b37c$export$2e2bcd8739ae039), {
        title: t("reset-password-confirm-title"),
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("label", {
                            className: "block mb-2.5 font-interbold",
                            children: t("email")
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                            className: "border border-black focus:border-black bg-gray-100 text-gray-500 rounded-full py-1.5 px-4 w-full placeholder:text-sm cursor-not-allowed",
                            type: "text",
                            name: "email",
                            id: "email",
                            placeholder: t("email-placeholder"),
                            value: email,
                            readOnly: true,
                            disabled: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                            className: "block mb-2.5 font-interbold",
                            children: [
                                t("reset-password-confirm-code"),
                                " ",
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    className: "text-red-600",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                            className: "border border-black rounded-full py-1.5 px-4 w-full",
                            type: "text",
                            name: "code",
                            id: "code",
                            placeholder: t("reset-password-confirm-code-placeholder"),
                            value: code,
                            onChange: (e)=>{
                                setCode(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                            className: "block mb-2.5 font-interbold",
                            children: [
                                t("password"),
                                " ",
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    className: "text-red-600",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                            className: "border border-black rounded-full py-1.5 px-4 w-full",
                            type: "password",
                            name: "password",
                            id: "password",
                            placeholder: t("password-placeholder"),
                            value: password,
                            onChange: (e)=>{
                                setPassword(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                    className: "mb-5",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                            className: "block mb-2.5 font-interbold",
                            children: [
                                t("password-verify"),
                                " ",
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    className: "text-red-600",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                            className: "border border-black rounded-full py-1.5 px-4 w-full",
                            type: "password",
                            name: "password-check",
                            id: "password-check",
                            placeholder: t("password-verify-placeholder"),
                            value: passwordCheck,
                            onChange: (e)=>{
                                setPasswordCheck(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                    type: "submit",
                    className: "block bg-dark-blue rounded-full text-white font-interbold py-3 px-10 mt-10 mx-auto uppercase disabled:cursor-not-allowed disabled:bg-gray-500",
                    disabled: submitting,
                    children: t("reset-password-confirm-button")
                })
            ]
        })
    });
}




var $gIfym = parcelRequire("gIfym");




function $a4a0c03b4bf9f364$export$2e2bcd8739ae039() {
    const [submitting, setSubmitting] = (0, $gIfym.useState)(false);
    const [email, setEmail] = (0, $gIfym.useState)("");
    const [successMsg, setSuccessMsg] = (0, $gIfym.useState)(null);
    const { t: t, i18n: i18n } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    document.title = t("reset-password-title");
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        if (!email) {
            auth.addNotification(t("messages.required-fields-empty"));
            setSubmitting(false);
            return;
        }
        await forgotPassword(email);
    };
    async function forgotPassword(email) {
        try {
            await (0, $b0aaffaa8d007c37$export$a1f57b29902e609a)(email);
            setSuccessMsg(true);
        } catch (error) {
            console.log("Error:", error);
            auth.addNotification(t([
                `messages.${error.message}`,
                "messages.general"
            ]));
        }
        setSubmitting(false);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $006b2c47c574b37c$export$2e2bcd8739ae039), {
        title: successMsg ? t("reset-password-title-success") : t("reset-password-title"),
        children: successMsg ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
            className: "text-center",
            children: t("forgot-password-desc")
        }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    className: "mb-5",
                    children: t("reset-password-text")
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                            className: "mb-5",
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                                    className: "block mb-2.5 font-interbold",
                                    children: [
                                        t("email"),
                                        " ",
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                            className: "text-red-600",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                                    className: "border-2 border-dark-blue rounded-full py-1.5 px-4 w-full placeholder:text-sm",
                                    type: "email",
                                    name: "email",
                                    id: "email",
                                    placeholder: t("email-placeholder"),
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            type: "submit",
                            className: "block bg-dark-blue rounded-full text-white font-interbold py-3 px-10 mt-10 mx-auto uppercase disabled:cursor-not-allowed disabled:bg-gray-500",
                            disabled: submitting,
                            children: t("reset-password-button")
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("gIfym");




function $7224d96f6f75fda6$export$2e2bcd8739ae039() {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    document.title = t("images-title");
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $9695464cd69251e9$export$8ef2ed426dede42d), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                title: document.title,
                desc: t("images-description")
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "p-5 pt-8 sm:p-10",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2f74e7c48cd7c516$export$2e2bcd8739ae039), {
                    section: "All images",
                    type: 2
                })
            })
        ]
    });
}




var $gIfym = parcelRequire("gIfym");


function $56de3670e061aa8d$export$2e2bcd8739ae039() {
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    (0, $gIfym.useEffect)(()=>{
        navigate("/todo");
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c65da64c1778b445$export$2e2bcd8739ae039), {});
}



parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");






parcelRequire("gIfym");
var $5fb83d7f88692c56$exports = {};
$5fb83d7f88692c56$exports = $parcel$resolve("esd5a");


const $efbe182bfb8b17d2$var$arrowWhite = new URL($5fb83d7f88692c56$exports);
var $a3b62f66d10f4832$exports = {};
$a3b62f66d10f4832$exports = $parcel$resolve("1e1FO");


const $efbe182bfb8b17d2$var$arrowDark = new URL($a3b62f66d10f4832$exports);
function $efbe182bfb8b17d2$export$2e2bcd8739ae039({ onClick: onClick, title: title, theme: theme, id: id, type: type = "button", disabled: disabled, size: size, cssClasses: cssClasses = "", rightArrow: rightArrow = true, leftArrow: leftArrow = false, hideIcon: hideIcon = false, icon: icon, iconComp: iconComp, children: children }) {
    let themeClasses = "bg-dark-blue text-white border-dark-blue hover:opacity-80 w-full lg:w-auto";
    let sizeClasses = "text-[16px] py-[12px] lg:py-[20px] px-4 lg:px-9 lg:gap-4";
    let arrow = $efbe182bfb8b17d2$var$arrowWhite;
    let gap = "gap-3";
    let titleClasses = title.length > 25 && rightArrow ? "max-w-[58%] lg:max-w-none" : "";
    if (size === "small") {
        sizeClasses = "text-[10px] lg:text-[12px] border-[1px] py-2 px-3";
        gap = "gap-2";
    }
    if (theme === "yellow") {
        themeClasses = "bg-[#F7D152] border-[#F7D152] text-dark-blue hover:opacity-80";
        arrow = $efbe182bfb8b17d2$var$arrowDark;
    }
    if (theme === "white") {
        themeClasses = "bg-white border-dark-blue text-dark-blue hover:opacity-80";
        arrow = $efbe182bfb8b17d2$var$arrowDark;
        titleClasses = "";
        gap = "gap-2";
    }
    if (theme === "red") {
        themeClasses = "bg-[#EA3324] border-[#EA3324] text-white hover:opacity-80";
        arrow = $efbe182bfb8b17d2$var$arrowDark;
    }
    if (theme === "light-green") themeClasses = "bg-theme-func-light-green border-theme-func-light-green text-theme-primary1 hover:opacity-80";
    if (theme === "back-white") {
        themeClasses = "bg-theme-white border-transparent text-dark-blue underline hover:opacity-80";
        arrow = $efbe182bfb8b17d2$var$arrowDark;
    }
    if (disabled) themeClasses += " !opacity-50";
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
        id: id,
        type: type,
        onClick: onClick,
        className: `flex flex-row items-center justify-center border-[1px] font-intermedium uppercase transition ${sizeClasses} rounded-[5px] leading-tight tracking-widest lg:leading-none ${themeClasses} ${cssClasses} ${gap}`,
        disabled: disabled,
        children: [
            leftArrow && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                alt: "",
                src: arrow.href,
                width: 18,
                style: {
                    transform: "rotate(180deg)"
                }
            }),
            (icon || iconComp) && !hideIcon ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    iconComp && iconComp,
                    icon && !iconComp && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        className: "absolute left-[30px]",
                        alt: "",
                        src: icon.url?.href,
                        width: icon.width
                    }),
                    icon && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        style: {
                            marginLeft: `${icon.width + 20}px`
                        },
                        children: [
                            title,
                            children
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: titleClasses,
                        children: title
                    }),
                    children
                ]
            }),
            rightArrow && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                alt: "",
                src: arrow.href,
                width: 18
            })
        ]
    });
}



parcelRequire("gIfym");

//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
//---------------------------------------------------------------------
// qrcode
//---------------------------------------------------------------------
/**
 * qrcode
 * @param typeNumber 1 to 40
 * @param errorCorrectionLevel 'L','M','Q','H'
 */ const $20658c37a7628c6f$export$5f3279733515fed0 = function(typeNumber, errorCorrectionLevel) {
    const PAD0 = 0xEC;
    const PAD1 = 0x11;
    let _typeNumber = typeNumber;
    const _errorCorrectionLevel = $20658c37a7628c6f$var$QRErrorCorrectionLevel[errorCorrectionLevel];
    let _modules = null;
    let _moduleCount = 0;
    let _dataCache = null;
    const _dataList = [];
    const _this = {};
    const makeImpl = function(test, maskPattern) {
        _moduleCount = _typeNumber * 4 + 17;
        _modules = function(moduleCount) {
            const modules = new Array(moduleCount);
            for(let row = 0; row < moduleCount; row += 1){
                modules[row] = new Array(moduleCount);
                for(let col = 0; col < moduleCount; col += 1)modules[row][col] = null;
            }
            return modules;
        }(_moduleCount);
        setupPositionProbePattern(0, 0);
        setupPositionProbePattern(_moduleCount - 7, 0);
        setupPositionProbePattern(0, _moduleCount - 7);
        setupPositionAdjustPattern();
        setupTimingPattern();
        setupTypeInfo(test, maskPattern);
        if (_typeNumber >= 7) setupTypeNumber(test);
        if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
        mapData(_dataCache, maskPattern);
    };
    const setupPositionProbePattern = function(row, col) {
        for(let r = -1; r <= 7; r += 1){
            if (row + r <= -1 || _moduleCount <= row + r) continue;
            for(let c = -1; c <= 7; c += 1){
                if (col + c <= -1 || _moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const getBestMaskPattern = function() {
        let minLostPoint = 0;
        let pattern = 0;
        for(let i = 0; i < 8; i += 1){
            makeImpl(true, i);
            const lostPoint = $20658c37a7628c6f$var$QRUtil.getLostPoint(_this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    };
    const setupTimingPattern = function() {
        for(let r = 8; r < _moduleCount - 8; r += 1){
            if (_modules[r][6] != null) continue;
            _modules[r][6] = r % 2 == 0;
        }
        for(let c = 8; c < _moduleCount - 8; c += 1){
            if (_modules[6][c] != null) continue;
            _modules[6][c] = c % 2 == 0;
        }
    };
    const setupPositionAdjustPattern = function() {
        const pos = $20658c37a7628c6f$var$QRUtil.getPatternPosition(_typeNumber);
        for(let i = 0; i < pos.length; i += 1)for(let j = 0; j < pos.length; j += 1){
            const row = pos[i];
            const col = pos[j];
            if (_modules[row][col] != null) continue;
            for(let r = -2; r <= 2; r += 1){
                for(let c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const setupTypeNumber = function(test) {
        const bits = $20658c37a7628c6f$var$QRUtil.getBCHTypeNumber(_typeNumber);
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
        }
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    };
    const setupTypeInfo = function(test, maskPattern) {
        const data = _errorCorrectionLevel << 3 | maskPattern;
        const bits = $20658c37a7628c6f$var$QRUtil.getBCHTypeInfo(data);
        // vertical
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 6) _modules[i][8] = mod;
            else if (i < 8) _modules[i + 1][8] = mod;
            else _modules[_moduleCount - 15 + i][8] = mod;
        }
        // horizontal
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
            else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
            else _modules[8][15 - i - 1] = mod;
        }
        // fixed module
        _modules[_moduleCount - 8][8] = !test;
    };
    const mapData = function(data, maskPattern) {
        let inc = -1;
        let row = _moduleCount - 1;
        let bitIndex = 7;
        let byteIndex = 0;
        const maskFunc = $20658c37a7628c6f$var$QRUtil.getMaskFunction(maskPattern);
        for(let col = _moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col -= 1;
            while(true){
                for(let c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                    let dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    const mask = maskFunc(row, col - c);
                    if (mask) dark = !dark;
                    _modules[row][col - c] = dark;
                    bitIndex -= 1;
                    if (bitIndex == -1) {
                        byteIndex += 1;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || _moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    };
    const createBytes = function(buffer, rsBlocks) {
        let offset = 0;
        let maxDcCount = 0;
        let maxEcCount = 0;
        const dcdata = new Array(rsBlocks.length);
        const ecdata = new Array(rsBlocks.length);
        for(let r = 0; r < rsBlocks.length; r += 1){
            const dcCount = rsBlocks[r].dataCount;
            const ecCount = rsBlocks[r].totalCount - dcCount;
            maxDcCount = Math.max(maxDcCount, dcCount);
            maxEcCount = Math.max(maxEcCount, ecCount);
            dcdata[r] = new Array(dcCount);
            for(let i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
            offset += dcCount;
            const rsPoly = $20658c37a7628c6f$var$QRUtil.getErrorCorrectPolynomial(ecCount);
            const rawPoly = $20658c37a7628c6f$var$qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
            const modPoly = rawPoly.mod(rsPoly);
            ecdata[r] = new Array(rsPoly.getLength() - 1);
            for(let i = 0; i < ecdata[r].length; i += 1){
                const modIndex = i + modPoly.getLength() - ecdata[r].length;
                ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
            }
        }
        let totalCodeCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
        const data = new Array(totalCodeCount);
        let index = 0;
        for(let i = 0; i < maxDcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                data[index] = dcdata[r][i];
                index += 1;
            }
        }
        for(let i = 0; i < maxEcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                data[index] = ecdata[r][i];
                index += 1;
            }
        }
        return data;
    };
    const createData = function(typeNumber, errorCorrectionLevel, dataList) {
        const rsBlocks = $20658c37a7628c6f$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
        const buffer = $20658c37a7628c6f$var$qrBitBuffer();
        for(let i = 0; i < dataList.length; i += 1){
            const data = dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), $20658c37a7628c6f$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
            data.write(buffer);
        }
        // calc num max data.
        let totalDataCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
        if (buffer.getLengthInBits() > totalDataCount * 8) throw 'code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')';
        // end code
        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
        // padding
        while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
        // padding
        while(true){
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD0, 8);
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD1, 8);
        }
        return createBytes(buffer, rsBlocks);
    };
    _this.addData = function(data, mode) {
        mode = mode || 'Byte';
        let newData = null;
        switch(mode){
            case 'Numeric':
                newData = $20658c37a7628c6f$var$qrNumber(data);
                break;
            case 'Alphanumeric':
                newData = $20658c37a7628c6f$var$qrAlphaNum(data);
                break;
            case 'Byte':
                newData = $20658c37a7628c6f$var$qr8BitByte(data);
                break;
            case 'Kanji':
                newData = $20658c37a7628c6f$var$qrKanji(data);
                break;
            default:
                throw 'mode:' + mode;
        }
        _dataList.push(newData);
        _dataCache = null;
    };
    _this.isDark = function(row, col) {
        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + ',' + col;
        return _modules[row][col];
    };
    _this.getModuleCount = function() {
        return _moduleCount;
    };
    _this.make = function() {
        if (_typeNumber < 1) {
            let typeNumber = 1;
            for(; typeNumber < 40; typeNumber++){
                const rsBlocks = $20658c37a7628c6f$var$QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                const buffer = $20658c37a7628c6f$var$qrBitBuffer();
                for(let i = 0; i < _dataList.length; i++){
                    const data = _dataList[i];
                    buffer.put(data.getMode(), 4);
                    buffer.put(data.getLength(), $20658c37a7628c6f$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
                    data.write(buffer);
                }
                let totalDataCount = 0;
                for(let i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                if (buffer.getLengthInBits() <= totalDataCount * 8) break;
            }
            _typeNumber = typeNumber;
        }
        makeImpl(false, getBestMaskPattern());
    };
    _this.createTableTag = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        let qrHtml = '';
        qrHtml += '<table style="';
        qrHtml += ' border-width: 0px; border-style: none;';
        qrHtml += ' border-collapse: collapse;';
        qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
        qrHtml += '">';
        qrHtml += '<tbody>';
        for(let r = 0; r < _this.getModuleCount(); r += 1){
            qrHtml += '<tr>';
            for(let c = 0; c < _this.getModuleCount(); c += 1){
                qrHtml += '<td style="';
                qrHtml += ' border-width: 0px; border-style: none;';
                qrHtml += ' border-collapse: collapse;';
                qrHtml += ' padding: 0px; margin: 0px;';
                qrHtml += ' width: ' + cellSize + 'px;';
                qrHtml += ' height: ' + cellSize + 'px;';
                qrHtml += ' background-color: ';
                qrHtml += _this.isDark(r, c) ? '#000000' : '#ffffff';
                qrHtml += ';';
                qrHtml += '"/>';
            }
            qrHtml += '</tr>';
        }
        qrHtml += '</tbody>';
        qrHtml += '</table>';
        return qrHtml;
    };
    _this.createSvgTag = function(cellSize, margin, alt, title) {
        let opts = {};
        if (typeof arguments[0] == 'object') {
            // Called by options.
            opts = arguments[0];
            // overwrite cellSize and margin.
            cellSize = opts.cellSize;
            margin = opts.margin;
            alt = opts.alt;
            title = opts.title;
        }
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        // Compose alt property surrogate
        alt = typeof alt === 'string' ? {
            text: alt
        } : alt || {};
        alt.text = alt.text || null;
        alt.id = alt.text ? alt.id || 'qrcode-description' : null;
        // Compose title property surrogate
        title = typeof title === 'string' ? {
            text: title
        } : title || {};
        title.text = title.text || null;
        title.id = title.text ? title.id || 'qrcode-title' : null;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let c, mc, r, mr, qrSvg = '', rect;
        rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
        qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
        qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
        qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
        qrSvg += ' preserveAspectRatio="xMinYMin meet"';
        qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
            title.id,
            alt.id
        ].join(' ').trim()) + '"' : '';
        qrSvg += '>';
        qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + '</title>' : '';
        qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + '</description>' : '';
        qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
        qrSvg += '<path d="';
        for(r = 0; r < _this.getModuleCount(); r += 1){
            mr = r * cellSize + margin;
            for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                mc = c * cellSize + margin;
                qrSvg += 'M' + mc + ',' + mr + rect;
            }
        }
        qrSvg += '" stroke="transparent" fill="black"/>';
        qrSvg += '</svg>';
        return qrSvg;
    };
    _this.createDataURL = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        return $20658c37a7628c6f$var$createDataURL(size, size, function(x, y) {
            if (min <= x && x < max && min <= y && y < max) {
                const c = Math.floor((x - min) / cellSize);
                const r = Math.floor((y - min) / cellSize);
                return _this.isDark(r, c) ? 0 : 1;
            } else return 1;
        });
    };
    _this.createImgTag = function(cellSize, margin, alt) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let img = '';
        img += '<img';
        img += '\u0020src="';
        img += _this.createDataURL(cellSize, margin);
        img += '"';
        img += '\u0020width="';
        img += size;
        img += '"';
        img += '\u0020height="';
        img += size;
        img += '"';
        if (alt) {
            img += '\u0020alt="';
            img += escapeXml(alt);
            img += '"';
        }
        img += '/>';
        return img;
    };
    const escapeXml = function(s) {
        let escaped = '';
        for(let i = 0; i < s.length; i += 1){
            const c = s.charAt(i);
            switch(c){
                case '<':
                    escaped += '&lt;';
                    break;
                case '>':
                    escaped += '&gt;';
                    break;
                case '&':
                    escaped += '&amp;';
                    break;
                case '"':
                    escaped += '&quot;';
                    break;
                default:
                    escaped += c;
                    break;
            }
        }
        return escaped;
    };
    const _createHalfASCII = function(margin) {
        const cellSize = 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r1, r2, p;
        const blocks = {
            "\u2588\u2588": "\u2588",
            "\u2588 ": "\u2580",
            " \u2588": "\u2584",
            '  ': ' '
        };
        const blocksLastLineNoMargin = {
            "\u2588\u2588": "\u2580",
            "\u2588 ": "\u2580",
            " \u2588": ' ',
            '  ': ' '
        };
        let ascii = '';
        for(y = 0; y < size; y += 2){
            r1 = Math.floor((y - min) / cellSize);
            r2 = Math.floor((y + 1 - min) / cellSize);
            for(x = 0; x < size; x += 1){
                p = "\u2588";
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = ' ';
                if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += ' ';
                else p += "\u2588";
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
            }
            ascii += '\n';
        }
        if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
        return ascii.substring(0, ascii.length - 1);
    };
    _this.createASCII = function(cellSize, margin) {
        cellSize = cellSize || 1;
        if (cellSize < 2) return _createHalfASCII(margin);
        cellSize -= 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r, p;
        const white = Array(cellSize + 1).join("\u2588\u2588");
        const black = Array(cellSize + 1).join('  ');
        let ascii = '';
        let line = '';
        for(y = 0; y < size; y += 1){
            r = Math.floor((y - min) / cellSize);
            line = '';
            for(x = 0; x < size; x += 1){
                p = 1;
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                line += p ? white : black;
            }
            for(r = 0; r < cellSize; r += 1)ascii += line + '\n';
        }
        return ascii.substring(0, ascii.length - 1);
    };
    _this.renderTo2dContext = function(context, cellSize) {
        cellSize = cellSize || 2;
        const length = _this.getModuleCount();
        for(let row = 0; row < length; row++)for(let col = 0; col < length; col++){
            context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
            context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qrcode.stringToBytes
//---------------------------------------------------------------------
$20658c37a7628c6f$export$5f3279733515fed0.stringToBytes = function(s) {
    const bytes = [];
    for(let i = 0; i < s.length; i += 1){
        const c = s.charCodeAt(i);
        bytes.push(c & 0xff);
    }
    return bytes;
};
//---------------------------------------------------------------------
// qrcode.createStringToBytes
//---------------------------------------------------------------------
/**
 * @param unicodeData base64 string of byte array.
 * [16bit Unicode],[16bit Bytes], ...
 * @param numChars
 */ $20658c37a7628c6f$export$5f3279733515fed0.createStringToBytes = function(unicodeData, numChars) {
    // create conversion map.
    const unicodeMap = function() {
        const bin = $20658c37a7628c6f$var$base64DecodeInputStream(unicodeData);
        const read = function() {
            const b = bin.read();
            if (b == -1) throw 'eof';
            return b;
        };
        let count = 0;
        const unicodeMap = {};
        while(true){
            const b0 = bin.read();
            if (b0 == -1) break;
            const b1 = read();
            const b2 = read();
            const b3 = read();
            const k = String.fromCharCode(b0 << 8 | b1);
            const v = b2 << 8 | b3;
            unicodeMap[k] = v;
            count += 1;
        }
        if (count != numChars) throw count + ' != ' + numChars;
        return unicodeMap;
    }();
    const unknownChar = '?'.charCodeAt(0);
    return function(s) {
        const bytes = [];
        for(let i = 0; i < s.length; i += 1){
            const c = s.charCodeAt(i);
            if (c < 128) bytes.push(c);
            else {
                const b = unicodeMap[s.charAt(i)];
                if (typeof b == 'number') {
                    if ((b & 0xff) == b) // 1byte
                    bytes.push(b);
                    else {
                        // 2bytes
                        bytes.push(b >>> 8);
                        bytes.push(b & 0xff);
                    }
                } else bytes.push(unknownChar);
            }
        }
        return bytes;
    };
};
//---------------------------------------------------------------------
// QRMode
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
//---------------------------------------------------------------------
// QRErrorCorrectionLevel
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$QRErrorCorrectionLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
//---------------------------------------------------------------------
// QRMaskPattern
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
//---------------------------------------------------------------------
// QRUtil
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$QRUtil = function() {
    const PATTERN_POSITION_TABLE = [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ];
    const G15 = 1335;
    const G18 = 7973;
    const G15_MASK = 21522;
    const _this = {};
    const getBCHDigit = function(data) {
        let digit = 0;
        while(data != 0){
            digit += 1;
            data >>>= 1;
        }
        return digit;
    };
    _this.getBCHTypeInfo = function(data) {
        let d = data << 10;
        while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
        return (data << 10 | d) ^ G15_MASK;
    };
    _this.getBCHTypeNumber = function(data) {
        let d = data << 12;
        while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
        return data << 12 | d;
    };
    _this.getPatternPosition = function(typeNumber) {
        return PATTERN_POSITION_TABLE[typeNumber - 1];
    };
    _this.getMaskFunction = function(maskPattern) {
        switch(maskPattern){
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN000:
                return function(i, j) {
                    return (i + j) % 2 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN001:
                return function(i, j) {
                    return i % 2 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN010:
                return function(i, j) {
                    return j % 3 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN011:
                return function(i, j) {
                    return (i + j) % 3 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN100:
                return function(i, j) {
                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN101:
                return function(i, j) {
                    return i * j % 2 + i * j % 3 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN110:
                return function(i, j) {
                    return (i * j % 2 + i * j % 3) % 2 == 0;
                };
            case $20658c37a7628c6f$var$QRMaskPattern.PATTERN111:
                return function(i, j) {
                    return (i * j % 3 + (i + j) % 2) % 2 == 0;
                };
            default:
                throw 'bad maskPattern:' + maskPattern;
        }
    };
    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
        let a = $20658c37a7628c6f$var$qrPolynomial([
            1
        ], 0);
        for(let i = 0; i < errorCorrectLength; i += 1)a = a.multiply($20658c37a7628c6f$var$qrPolynomial([
            1,
            $20658c37a7628c6f$var$QRMath.gexp(i)
        ], 0));
        return a;
    };
    _this.getLengthInBits = function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $20658c37a7628c6f$var$QRMode.MODE_NUMBER:
                return 10;
            case $20658c37a7628c6f$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $20658c37a7628c6f$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $20658c37a7628c6f$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $20658c37a7628c6f$var$QRMode.MODE_NUMBER:
                return 12;
            case $20658c37a7628c6f$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $20658c37a7628c6f$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $20658c37a7628c6f$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $20658c37a7628c6f$var$QRMode.MODE_NUMBER:
                return 14;
            case $20658c37a7628c6f$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $20658c37a7628c6f$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $20658c37a7628c6f$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw 'mode:' + mode;
        }
        else throw 'type:' + type;
    };
    _this.getLostPoint = function(qrcode) {
        const moduleCount = qrcode.getModuleCount();
        let lostPoint = 0;
        // LEVEL1
        for(let row = 0; row < moduleCount; row += 1)for(let col = 0; col < moduleCount; col += 1){
            let sameCount = 0;
            const dark = qrcode.isDark(row, col);
            for(let r = -1; r <= 1; r += 1){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(let c = -1; c <= 1; c += 1){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(let row = 0; row < moduleCount - 1; row += 1)for(let col = 0; col < moduleCount - 1; col += 1){
            let count = 0;
            if (qrcode.isDark(row, col)) count += 1;
            if (qrcode.isDark(row + 1, col)) count += 1;
            if (qrcode.isDark(row, col + 1)) count += 1;
            if (qrcode.isDark(row + 1, col + 1)) count += 1;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(let row = 0; row < moduleCount; row += 1){
            for(let col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        let darkCount = 0;
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
        }
        const ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    };
    return _this;
}();
//---------------------------------------------------------------------
// QRMath
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$QRMath = function() {
    const EXP_TABLE = new Array(256);
    const LOG_TABLE = new Array(256);
    // initialize tables
    for(let i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
    for(let i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
    for(let i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
    const _this = {};
    _this.glog = function(n) {
        if (n < 1) throw 'glog(' + n + ')';
        return LOG_TABLE[n];
    };
    _this.gexp = function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return EXP_TABLE[n];
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrPolynomial
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$qrPolynomial = function(num, shift) {
    if (typeof num.length == 'undefined') throw num.length + '/' + shift;
    const _num = function() {
        let offset = 0;
        while(offset < num.length && num[offset] == 0)offset += 1;
        const _num = new Array(num.length - offset + shift);
        for(let i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
        return _num;
    }();
    const _this = {};
    _this.getAt = function(index) {
        return _num[index];
    };
    _this.getLength = function() {
        return _num.length;
    };
    _this.multiply = function(e) {
        const num = new Array(_this.getLength() + e.getLength() - 1);
        for(let i = 0; i < _this.getLength(); i += 1)for(let j = 0; j < e.getLength(); j += 1)num[i + j] ^= $20658c37a7628c6f$var$QRMath.gexp($20658c37a7628c6f$var$QRMath.glog(_this.getAt(i)) + $20658c37a7628c6f$var$QRMath.glog(e.getAt(j)));
        return $20658c37a7628c6f$var$qrPolynomial(num, 0);
    };
    _this.mod = function(e) {
        if (_this.getLength() - e.getLength() < 0) return _this;
        const ratio = $20658c37a7628c6f$var$QRMath.glog(_this.getAt(0)) - $20658c37a7628c6f$var$QRMath.glog(e.getAt(0));
        const num = new Array(_this.getLength());
        for(let i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
        for(let i = 0; i < e.getLength(); i += 1)num[i] ^= $20658c37a7628c6f$var$QRMath.gexp($20658c37a7628c6f$var$QRMath.glog(e.getAt(i)) + ratio);
        // recursive call
        return $20658c37a7628c6f$var$qrPolynomial(num, 0).mod(e);
    };
    return _this;
};
//---------------------------------------------------------------------
// QRRSBlock
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$QRRSBlock = function() {
    const RS_BLOCK_TABLE = [
        // L
        // M
        // Q
        // H
        // 1
        [
            1,
            26,
            19
        ],
        [
            1,
            26,
            16
        ],
        [
            1,
            26,
            13
        ],
        [
            1,
            26,
            9
        ],
        // 2
        [
            1,
            44,
            34
        ],
        [
            1,
            44,
            28
        ],
        [
            1,
            44,
            22
        ],
        [
            1,
            44,
            16
        ],
        // 3
        [
            1,
            70,
            55
        ],
        [
            1,
            70,
            44
        ],
        [
            2,
            35,
            17
        ],
        [
            2,
            35,
            13
        ],
        // 4
        [
            1,
            100,
            80
        ],
        [
            2,
            50,
            32
        ],
        [
            2,
            50,
            24
        ],
        [
            4,
            25,
            9
        ],
        // 5
        [
            1,
            134,
            108
        ],
        [
            2,
            67,
            43
        ],
        [
            2,
            33,
            15,
            2,
            34,
            16
        ],
        [
            2,
            33,
            11,
            2,
            34,
            12
        ],
        // 6
        [
            2,
            86,
            68
        ],
        [
            4,
            43,
            27
        ],
        [
            4,
            43,
            19
        ],
        [
            4,
            43,
            15
        ],
        // 7
        [
            2,
            98,
            78
        ],
        [
            4,
            49,
            31
        ],
        [
            2,
            32,
            14,
            4,
            33,
            15
        ],
        [
            4,
            39,
            13,
            1,
            40,
            14
        ],
        // 8
        [
            2,
            121,
            97
        ],
        [
            2,
            60,
            38,
            2,
            61,
            39
        ],
        [
            4,
            40,
            18,
            2,
            41,
            19
        ],
        [
            4,
            40,
            14,
            2,
            41,
            15
        ],
        // 9
        [
            2,
            146,
            116
        ],
        [
            3,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            36,
            16,
            4,
            37,
            17
        ],
        [
            4,
            36,
            12,
            4,
            37,
            13
        ],
        // 10
        [
            2,
            86,
            68,
            2,
            87,
            69
        ],
        [
            4,
            69,
            43,
            1,
            70,
            44
        ],
        [
            6,
            43,
            19,
            2,
            44,
            20
        ],
        [
            6,
            43,
            15,
            2,
            44,
            16
        ],
        // 11
        [
            4,
            101,
            81
        ],
        [
            1,
            80,
            50,
            4,
            81,
            51
        ],
        [
            4,
            50,
            22,
            4,
            51,
            23
        ],
        [
            3,
            36,
            12,
            8,
            37,
            13
        ],
        // 12
        [
            2,
            116,
            92,
            2,
            117,
            93
        ],
        [
            6,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            46,
            20,
            6,
            47,
            21
        ],
        [
            7,
            42,
            14,
            4,
            43,
            15
        ],
        // 13
        [
            4,
            133,
            107
        ],
        [
            8,
            59,
            37,
            1,
            60,
            38
        ],
        [
            8,
            44,
            20,
            4,
            45,
            21
        ],
        [
            12,
            33,
            11,
            4,
            34,
            12
        ],
        // 14
        [
            3,
            145,
            115,
            1,
            146,
            116
        ],
        [
            4,
            64,
            40,
            5,
            65,
            41
        ],
        [
            11,
            36,
            16,
            5,
            37,
            17
        ],
        [
            11,
            36,
            12,
            5,
            37,
            13
        ],
        // 15
        [
            5,
            109,
            87,
            1,
            110,
            88
        ],
        [
            5,
            65,
            41,
            5,
            66,
            42
        ],
        [
            5,
            54,
            24,
            7,
            55,
            25
        ],
        [
            11,
            36,
            12,
            7,
            37,
            13
        ],
        // 16
        [
            5,
            122,
            98,
            1,
            123,
            99
        ],
        [
            7,
            73,
            45,
            3,
            74,
            46
        ],
        [
            15,
            43,
            19,
            2,
            44,
            20
        ],
        [
            3,
            45,
            15,
            13,
            46,
            16
        ],
        // 17
        [
            1,
            135,
            107,
            5,
            136,
            108
        ],
        [
            10,
            74,
            46,
            1,
            75,
            47
        ],
        [
            1,
            50,
            22,
            15,
            51,
            23
        ],
        [
            2,
            42,
            14,
            17,
            43,
            15
        ],
        // 18
        [
            5,
            150,
            120,
            1,
            151,
            121
        ],
        [
            9,
            69,
            43,
            4,
            70,
            44
        ],
        [
            17,
            50,
            22,
            1,
            51,
            23
        ],
        [
            2,
            42,
            14,
            19,
            43,
            15
        ],
        // 19
        [
            3,
            141,
            113,
            4,
            142,
            114
        ],
        [
            3,
            70,
            44,
            11,
            71,
            45
        ],
        [
            17,
            47,
            21,
            4,
            48,
            22
        ],
        [
            9,
            39,
            13,
            16,
            40,
            14
        ],
        // 20
        [
            3,
            135,
            107,
            5,
            136,
            108
        ],
        [
            3,
            67,
            41,
            13,
            68,
            42
        ],
        [
            15,
            54,
            24,
            5,
            55,
            25
        ],
        [
            15,
            43,
            15,
            10,
            44,
            16
        ],
        // 21
        [
            4,
            144,
            116,
            4,
            145,
            117
        ],
        [
            17,
            68,
            42
        ],
        [
            17,
            50,
            22,
            6,
            51,
            23
        ],
        [
            19,
            46,
            16,
            6,
            47,
            17
        ],
        // 22
        [
            2,
            139,
            111,
            7,
            140,
            112
        ],
        [
            17,
            74,
            46
        ],
        [
            7,
            54,
            24,
            16,
            55,
            25
        ],
        [
            34,
            37,
            13
        ],
        // 23
        [
            4,
            151,
            121,
            5,
            152,
            122
        ],
        [
            4,
            75,
            47,
            14,
            76,
            48
        ],
        [
            11,
            54,
            24,
            14,
            55,
            25
        ],
        [
            16,
            45,
            15,
            14,
            46,
            16
        ],
        // 24
        [
            6,
            147,
            117,
            4,
            148,
            118
        ],
        [
            6,
            73,
            45,
            14,
            74,
            46
        ],
        [
            11,
            54,
            24,
            16,
            55,
            25
        ],
        [
            30,
            46,
            16,
            2,
            47,
            17
        ],
        // 25
        [
            8,
            132,
            106,
            4,
            133,
            107
        ],
        [
            8,
            75,
            47,
            13,
            76,
            48
        ],
        [
            7,
            54,
            24,
            22,
            55,
            25
        ],
        [
            22,
            45,
            15,
            13,
            46,
            16
        ],
        // 26
        [
            10,
            142,
            114,
            2,
            143,
            115
        ],
        [
            19,
            74,
            46,
            4,
            75,
            47
        ],
        [
            28,
            50,
            22,
            6,
            51,
            23
        ],
        [
            33,
            46,
            16,
            4,
            47,
            17
        ],
        // 27
        [
            8,
            152,
            122,
            4,
            153,
            123
        ],
        [
            22,
            73,
            45,
            3,
            74,
            46
        ],
        [
            8,
            53,
            23,
            26,
            54,
            24
        ],
        [
            12,
            45,
            15,
            28,
            46,
            16
        ],
        // 28
        [
            3,
            147,
            117,
            10,
            148,
            118
        ],
        [
            3,
            73,
            45,
            23,
            74,
            46
        ],
        [
            4,
            54,
            24,
            31,
            55,
            25
        ],
        [
            11,
            45,
            15,
            31,
            46,
            16
        ],
        // 29
        [
            7,
            146,
            116,
            7,
            147,
            117
        ],
        [
            21,
            73,
            45,
            7,
            74,
            46
        ],
        [
            1,
            53,
            23,
            37,
            54,
            24
        ],
        [
            19,
            45,
            15,
            26,
            46,
            16
        ],
        // 30
        [
            5,
            145,
            115,
            10,
            146,
            116
        ],
        [
            19,
            75,
            47,
            10,
            76,
            48
        ],
        [
            15,
            54,
            24,
            25,
            55,
            25
        ],
        [
            23,
            45,
            15,
            25,
            46,
            16
        ],
        // 31
        [
            13,
            145,
            115,
            3,
            146,
            116
        ],
        [
            2,
            74,
            46,
            29,
            75,
            47
        ],
        [
            42,
            54,
            24,
            1,
            55,
            25
        ],
        [
            23,
            45,
            15,
            28,
            46,
            16
        ],
        // 32
        [
            17,
            145,
            115
        ],
        [
            10,
            74,
            46,
            23,
            75,
            47
        ],
        [
            10,
            54,
            24,
            35,
            55,
            25
        ],
        [
            19,
            45,
            15,
            35,
            46,
            16
        ],
        // 33
        [
            17,
            145,
            115,
            1,
            146,
            116
        ],
        [
            14,
            74,
            46,
            21,
            75,
            47
        ],
        [
            29,
            54,
            24,
            19,
            55,
            25
        ],
        [
            11,
            45,
            15,
            46,
            46,
            16
        ],
        // 34
        [
            13,
            145,
            115,
            6,
            146,
            116
        ],
        [
            14,
            74,
            46,
            23,
            75,
            47
        ],
        [
            44,
            54,
            24,
            7,
            55,
            25
        ],
        [
            59,
            46,
            16,
            1,
            47,
            17
        ],
        // 35
        [
            12,
            151,
            121,
            7,
            152,
            122
        ],
        [
            12,
            75,
            47,
            26,
            76,
            48
        ],
        [
            39,
            54,
            24,
            14,
            55,
            25
        ],
        [
            22,
            45,
            15,
            41,
            46,
            16
        ],
        // 36
        [
            6,
            151,
            121,
            14,
            152,
            122
        ],
        [
            6,
            75,
            47,
            34,
            76,
            48
        ],
        [
            46,
            54,
            24,
            10,
            55,
            25
        ],
        [
            2,
            45,
            15,
            64,
            46,
            16
        ],
        // 37
        [
            17,
            152,
            122,
            4,
            153,
            123
        ],
        [
            29,
            74,
            46,
            14,
            75,
            47
        ],
        [
            49,
            54,
            24,
            10,
            55,
            25
        ],
        [
            24,
            45,
            15,
            46,
            46,
            16
        ],
        // 38
        [
            4,
            152,
            122,
            18,
            153,
            123
        ],
        [
            13,
            74,
            46,
            32,
            75,
            47
        ],
        [
            48,
            54,
            24,
            14,
            55,
            25
        ],
        [
            42,
            45,
            15,
            32,
            46,
            16
        ],
        // 39
        [
            20,
            147,
            117,
            4,
            148,
            118
        ],
        [
            40,
            75,
            47,
            7,
            76,
            48
        ],
        [
            43,
            54,
            24,
            22,
            55,
            25
        ],
        [
            10,
            45,
            15,
            67,
            46,
            16
        ],
        // 40
        [
            19,
            148,
            118,
            6,
            149,
            119
        ],
        [
            18,
            75,
            47,
            31,
            76,
            48
        ],
        [
            34,
            54,
            24,
            34,
            55,
            25
        ],
        [
            20,
            45,
            15,
            61,
            46,
            16
        ]
    ];
    const qrRSBlock = function(totalCount, dataCount) {
        const _this = {};
        _this.totalCount = totalCount;
        _this.dataCount = dataCount;
        return _this;
    };
    const _this = {};
    const getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
        switch(errorCorrectionLevel){
            case $20658c37a7628c6f$var$QRErrorCorrectionLevel.L:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
            case $20658c37a7628c6f$var$QRErrorCorrectionLevel.M:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
            case $20658c37a7628c6f$var$QRErrorCorrectionLevel.Q:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
            case $20658c37a7628c6f$var$QRErrorCorrectionLevel.H:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
            default:
                return undefined;
        }
    };
    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
        const rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
        if (typeof rsBlock == 'undefined') throw 'bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel;
        const length = rsBlock.length / 3;
        const list = [];
        for(let i = 0; i < length; i += 1){
            const count = rsBlock[i * 3 + 0];
            const totalCount = rsBlock[i * 3 + 1];
            const dataCount = rsBlock[i * 3 + 2];
            for(let j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
        }
        return list;
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrBitBuffer
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$qrBitBuffer = function() {
    const _buffer = [];
    let _length = 0;
    const _this = {};
    _this.getBuffer = function() {
        return _buffer;
    };
    _this.getAt = function(index) {
        const bufIndex = Math.floor(index / 8);
        return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    };
    _this.put = function(num, length) {
        for(let i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
    };
    _this.getLengthInBits = function() {
        return _length;
    };
    _this.putBit = function(bit) {
        const bufIndex = Math.floor(_length / 8);
        if (_buffer.length <= bufIndex) _buffer.push(0);
        if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
        _length += 1;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrNumber
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$qrNumber = function(data) {
    const _mode = $20658c37a7628c6f$var$QRMode.MODE_NUMBER;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const data = _data;
        let i = 0;
        while(i + 2 < data.length){
            buffer.put(strToNum(data.substring(i, i + 3)), 10);
            i += 3;
        }
        if (i < data.length) {
            if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
            else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
        }
    };
    const strToNum = function(s) {
        let num = 0;
        for(let i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
        return num;
    };
    const chatToNum = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        throw 'illegal char :' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrAlphaNum
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$qrAlphaNum = function(data) {
    const _mode = $20658c37a7628c6f$var$QRMode.MODE_ALPHA_NUM;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const s = _data;
        let i = 0;
        while(i + 1 < s.length){
            buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
            i += 2;
        }
        if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
    };
    const getCode = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        else if ('A' <= c && c <= 'Z') return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        else switch(c){
            case '\u0020':
                return 36;
            case '$':
                return 37;
            case '%':
                return 38;
            case '*':
                return 39;
            case '+':
                return 40;
            case '-':
                return 41;
            case '.':
                return 42;
            case '/':
                return 43;
            case ':':
                return 44;
            default:
                throw 'illegal char :' + c;
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qr8BitByte
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$qr8BitByte = function(data) {
    const _mode = $20658c37a7628c6f$var$QRMode.MODE_8BIT_BYTE;
    const _data = data;
    const _bytes = $20658c37a7628c6f$export$5f3279733515fed0.stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _bytes.length;
    };
    _this.write = function(buffer) {
        for(let i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
    };
    return _this;
};
//---------------------------------------------------------------------
// qrKanji
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$qrKanji = function(data) {
    const _mode = $20658c37a7628c6f$var$QRMode.MODE_KANJI;
    const _data = data;
    const stringToBytes = $20658c37a7628c6f$export$5f3279733515fed0.stringToBytes;
    !function(c, code) {
        // self test for sjis support.
        const test = stringToBytes(c);
        if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw 'sjis not supported.';
    }('\u53cb', 0x9746);
    const _bytes = stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return ~~(_bytes.length / 2);
    };
    _this.write = function(buffer) {
        const data = _bytes;
        let i = 0;
        while(i + 1 < data.length){
            let c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
            if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
            else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
            else throw 'illegal char at ' + (i + 1) + '/' + c;
            c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
            buffer.put(c, 13);
            i += 2;
        }
        if (i < data.length) throw 'illegal char at ' + (i + 1);
    };
    return _this;
};
//=====================================================================
// GIF Support etc.
//
//---------------------------------------------------------------------
// byteArrayOutputStream
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$byteArrayOutputStream = function() {
    const _bytes = [];
    const _this = {};
    _this.writeByte = function(b) {
        _bytes.push(b & 0xff);
    };
    _this.writeShort = function(i) {
        _this.writeByte(i);
        _this.writeByte(i >>> 8);
    };
    _this.writeBytes = function(b, off, len) {
        off = off || 0;
        len = len || b.length;
        for(let i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
    };
    _this.writeString = function(s) {
        for(let i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
    };
    _this.toByteArray = function() {
        return _bytes;
    };
    _this.toString = function() {
        let s = '';
        s += '[';
        for(let i = 0; i < _bytes.length; i += 1){
            if (i > 0) s += ',';
            s += _bytes[i];
        }
        s += ']';
        return s;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64EncodeOutputStream
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$base64EncodeOutputStream = function() {
    let _buffer = 0;
    let _buflen = 0;
    let _length = 0;
    let _base64 = '';
    const _this = {};
    const writeEncoded = function(b) {
        _base64 += String.fromCharCode(encode(b & 0x3f));
    };
    const encode = function(n) {
        if (n < 0) throw 'n:' + n;
        else if (n < 26) return 0x41 + n;
        else if (n < 52) return 0x61 + (n - 26);
        else if (n < 62) return 0x30 + (n - 52);
        else if (n == 62) return 0x2b;
        else if (n == 63) return 0x2f;
        else throw 'n:' + n;
    };
    _this.writeByte = function(n) {
        _buffer = _buffer << 8 | n & 0xff;
        _buflen += 8;
        _length += 1;
        while(_buflen >= 6){
            writeEncoded(_buffer >>> _buflen - 6);
            _buflen -= 6;
        }
    };
    _this.flush = function() {
        if (_buflen > 0) {
            writeEncoded(_buffer << 6 - _buflen);
            _buffer = 0;
            _buflen = 0;
        }
        if (_length % 3 != 0) {
            // padding
            const padlen = 3 - _length % 3;
            for(let i = 0; i < padlen; i += 1)_base64 += '=';
        }
    };
    _this.toString = function() {
        return _base64;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64DecodeInputStream
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$base64DecodeInputStream = function(str) {
    const _str = str;
    let _pos = 0;
    let _buffer = 0;
    let _buflen = 0;
    const _this = {};
    _this.read = function() {
        while(_buflen < 8){
            if (_pos >= _str.length) {
                if (_buflen == 0) return -1;
                throw 'unexpected end of file./' + _buflen;
            }
            const c = _str.charAt(_pos);
            _pos += 1;
            if (c == '=') {
                _buflen = 0;
                return -1;
            } else if (c.match(/^\s$/)) continue;
            _buffer = _buffer << 6 | decode(c.charCodeAt(0));
            _buflen += 6;
        }
        const n = _buffer >>> _buflen - 8 & 0xff;
        _buflen -= 8;
        return n;
    };
    const decode = function(c) {
        if (0x41 <= c && c <= 0x5a) return c - 0x41;
        else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
        else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
        else if (c == 0x2b) return 62;
        else if (c == 0x2f) return 63;
        else throw 'c:' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// gifImage (B/W)
//---------------------------------------------------------------------
const $20658c37a7628c6f$var$gifImage = function(width, height) {
    const _width = width;
    const _height = height;
    const _data = new Array(width * height);
    const _this = {};
    _this.setPixel = function(x, y, pixel) {
        _data[y * _width + x] = pixel;
    };
    _this.write = function(out) {
        //---------------------------------
        // GIF Signature
        out.writeString('GIF87a');
        //---------------------------------
        // Screen Descriptor
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0x80); // 2bit
        out.writeByte(0);
        out.writeByte(0);
        //---------------------------------
        // Global Color Map
        // black
        out.writeByte(0x00);
        out.writeByte(0x00);
        out.writeByte(0x00);
        // white
        out.writeByte(0xff);
        out.writeByte(0xff);
        out.writeByte(0xff);
        //---------------------------------
        // Image Descriptor
        out.writeString(',');
        out.writeShort(0);
        out.writeShort(0);
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0);
        //---------------------------------
        // Local Color Map
        //---------------------------------
        // Raster Data
        const lzwMinCodeSize = 2;
        const raster = getLZWRaster(lzwMinCodeSize);
        out.writeByte(lzwMinCodeSize);
        let offset = 0;
        while(raster.length - offset > 255){
            out.writeByte(255);
            out.writeBytes(raster, offset, 255);
            offset += 255;
        }
        out.writeByte(raster.length - offset);
        out.writeBytes(raster, offset, raster.length - offset);
        out.writeByte(0x00);
        //---------------------------------
        // GIF Terminator
        out.writeString(';');
    };
    const bitOutputStream = function(out) {
        const _out = out;
        let _bitLength = 0;
        let _bitBuffer = 0;
        const _this = {};
        _this.write = function(data, length) {
            if (data >>> length != 0) throw 'length over';
            while(_bitLength + length >= 8){
                _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                length -= 8 - _bitLength;
                data >>>= 8 - _bitLength;
                _bitBuffer = 0;
                _bitLength = 0;
            }
            _bitBuffer = data << _bitLength | _bitBuffer;
            _bitLength = _bitLength + length;
        };
        _this.flush = function() {
            if (_bitLength > 0) _out.writeByte(_bitBuffer);
        };
        return _this;
    };
    const getLZWRaster = function(lzwMinCodeSize) {
        const clearCode = 1 << lzwMinCodeSize;
        const endCode = (1 << lzwMinCodeSize) + 1;
        let bitLength = lzwMinCodeSize + 1;
        // Setup LZWTable
        const table = lzwTable();
        for(let i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
        table.add(String.fromCharCode(clearCode));
        table.add(String.fromCharCode(endCode));
        const byteOut = $20658c37a7628c6f$var$byteArrayOutputStream();
        const bitOut = bitOutputStream(byteOut);
        // clear code
        bitOut.write(clearCode, bitLength);
        let dataIndex = 0;
        let s = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;
        while(dataIndex < _data.length){
            const c = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            if (table.contains(s + c)) s = s + c;
            else {
                bitOut.write(table.indexOf(s), bitLength);
                if (table.size() < 0xfff) {
                    if (table.size() == 1 << bitLength) bitLength += 1;
                    table.add(s + c);
                }
                s = c;
            }
        }
        bitOut.write(table.indexOf(s), bitLength);
        // end code
        bitOut.write(endCode, bitLength);
        bitOut.flush();
        return byteOut.toByteArray();
    };
    const lzwTable = function() {
        const _map = {};
        let _size = 0;
        const _this = {};
        _this.add = function(key) {
            if (_this.contains(key)) throw 'dup key:' + key;
            _map[key] = _size;
            _size += 1;
        };
        _this.size = function() {
            return _size;
        };
        _this.indexOf = function(key) {
            return _map[key];
        };
        _this.contains = function(key) {
            return typeof _map[key] != 'undefined';
        };
        return _this;
    };
    return _this;
};
const $20658c37a7628c6f$var$createDataURL = function(width, height, getPixel) {
    const gif = $20658c37a7628c6f$var$gifImage(width, height);
    for(let y = 0; y < height; y += 1)for(let x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
    const b = $20658c37a7628c6f$var$byteArrayOutputStream();
    gif.write(b);
    const base64 = $20658c37a7628c6f$var$base64EncodeOutputStream();
    const bytes = b.toByteArray();
    for(let i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
    base64.flush();
    return 'data:image/gif;base64,' + base64;
};
var $20658c37a7628c6f$export$2e2bcd8739ae039 = $20658c37a7628c6f$export$5f3279733515fed0;
const $20658c37a7628c6f$export$c8dd6bc66a63753c = $20658c37a7628c6f$export$5f3279733515fed0.stringToBytes;



var $gIfym = parcelRequire("gIfym");
function $43a7ce719bde3bac$var$_extends() {
    return $43a7ce719bde3bac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $43a7ce719bde3bac$var$_extends.apply(null, arguments);
}
function $43a7ce719bde3bac$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $43a7ce719bde3bac$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $43a7ce719bde3bac$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $43a7ce719bde3bac$var$_excluded$1 = [
    "bgColor",
    "bgD",
    "fgD",
    "fgColor",
    "size",
    "title",
    "viewBoxSize",
    "xmlns"
];
var $43a7ce719bde3bac$var$propTypes$1 = {
    bgColor: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
    ]).isRequired,
    bgD: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired,
    fgColor: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
    ]).isRequired,
    fgD: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    viewBoxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired,
    xmlns: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
};
var $43a7ce719bde3bac$var$QRCodeSvg = /*#__PURE__*/ (0, $gIfym.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === void 0 ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = $43a7ce719bde3bac$var$_objectWithoutProperties(_ref, $43a7ce719bde3bac$var$_excluded$1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("svg", $43a7ce719bde3bac$var$_extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize),
        width: size,
        xmlns: xmlns
    }), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: bgD,
        fill: bgColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
$43a7ce719bde3bac$var$QRCodeSvg.displayName = "QRCodeSvg";
$43a7ce719bde3bac$var$QRCodeSvg.propTypes = $43a7ce719bde3bac$var$propTypes$1;
var $43a7ce719bde3bac$var$_excluded = [
    "bgColor",
    "fgColor",
    "level",
    "size",
    "value"
];
(0, $20658c37a7628c6f$export$2e2bcd8739ae039).stringToBytes = function(s) {
    return Array.from(new TextEncoder().encode(s));
};
var $43a7ce719bde3bac$var$propTypes = {
    bgColor: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
    ]),
    fgColor: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
    ]),
    level: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired
};
var $43a7ce719bde3bac$export$a77d98f00e648d58 = /*#__PURE__*/ (0, $gIfym.forwardRef)(function(_ref, ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === void 0 ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === void 0 ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 256 : _ref$size, value = _ref.value, props = $43a7ce719bde3bac$var$_objectWithoutProperties(_ref, $43a7ce719bde3bac$var$_excluded);
    var qr = (0, $20658c37a7628c6f$export$2e2bcd8739ae039)(0, level);
    qr.addData(value);
    qr.make();
    var moduleCount = qr.getModuleCount();
    var cells = Array.from({
        length: moduleCount
    }, function(_, rowIndex) {
        return Array.from({
            length: moduleCount
        }, function(_, colIndex) {
            return qr.isDark(rowIndex, colIndex);
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($43a7ce719bde3bac$var$QRCodeSvg, $43a7ce719bde3bac$var$_extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M ".concat(cellIndex, " ").concat(rowIndex, " l 1 0 0 1 -1 0 Z") : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M ".concat(cellIndex, " ").concat(rowIndex, " l 1 0 0 1 -1 0 Z") : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: moduleCount
    }));
});
$43a7ce719bde3bac$export$a77d98f00e648d58.displayName = "QRCode";
$43a7ce719bde3bac$export$a77d98f00e648d58.propTypes = $43a7ce719bde3bac$var$propTypes;


function $1efa8b22e1d1dc86$export$2e2bcd8739ae039({ value: value }) {
    if (!value) return null;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        style: {
            height: "auto",
            maxWidth: 250,
            width: "100%",
            marginTop: "30px"
        },
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $43a7ce719bde3bac$export$a77d98f00e648d58), {
            size: 256,
            style: {
                height: "auto",
                maxWidth: "100%",
                width: "100%"
            },
            value: value,
            viewBox: `0 0 256 256`
        })
    });
}


var $ba2a7c8dd4cbce01$exports = {};
$ba2a7c8dd4cbce01$exports = $parcel$resolve("1z9Zn");


const $b4c9d63dd2124d00$var$bankIdLogo = new URL($ba2a7c8dd4cbce01$exports);
const $b4c9d63dd2124d00$var$apiUrl = "https://api.fenixbegravning.se/api/v1/public";
function $b4c9d63dd2124d00$export$2e2bcd8739ae039({ backUrl: backUrl = "/signin" }) {
    const [status, setStatus] = (0, $gIfym.useState)("init");
    const [loading, setLoading] = (0, $gIfym.useState)(true);
    const [qrHash, setQrHash] = (0, $gIfym.useState)("");
    const [autoStartToken, setAutoStartToken] = (0, $gIfym.useState)();
    const qrInterval = (0, $gIfym.useRef)(null);
    const collectInterval = (0, $gIfym.useRef)(null);
    const [orderRef, setOrderRef] = (0, $gIfym.useState)("");
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    (0, $gIfym.useEffect)(()=>{
        startLogin();
        return ()=>{
            clearFetchQrHash();
            setStatus("init");
        };
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if (!orderRef) return;
        qrInterval.current = setInterval(()=>{
            fetchQrHash();
        }, 2000);
        collectInterval.current = setInterval(()=>{
            fetchCollect();
        }, 2000);
        return ()=>{
            if (qrInterval.current) clearInterval(qrInterval.current);
            if (collectInterval.current) clearInterval(collectInterval.current);
        };
    }, [
        orderRef
    ]);
    const startLogin = async ()=>{
        const paramString = "";
        setStatus("pending");
        const res = await fetch(`${$b4c9d63dd2124d00$var$apiUrl}/bankid/start${paramString}`, {
            method: "GET"
        }).catch((error)=>{
            console.error(error);
            clearFetchQrHash();
            setStatus("init");
            setLoading(false);
        });
        if (!res?.ok) return null;
        const data = await res.json();
        if (!data.orderRef) {
            startLogin();
            return;
        }
        setQrHash(data.qrHash);
        setOrderRef(data.orderRef);
        setAutoStartToken(data.autoStartToken);
        setLoading(false);
    };
    const fetchQrHash = async ()=>{
        const params = new URLSearchParams({
            orderRef: orderRef
        });
        const res = await fetch(`${$b4c9d63dd2124d00$var$apiUrl}/bankid/refreshQR?${params.toString()}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                Pragma: "no-cache"
            }
        }).catch((error)=>{
            console.error(error);
        });
        if (!res?.ok) return null;
        const data = await res.json();
        setQrHash(data.qrData);
    };
    const fetchCollect = async ()=>{
        const params = new URLSearchParams({
            orderRef: orderRef,
            source: "CustomerWebApp"
        });
        const res = await fetch(`${$b4c9d63dd2124d00$var$apiUrl}/bankid/collect?${params.toString()}`, {
            method: "GET"
        }).catch((error)=>{
            console.error(error);
        });
        if (!res?.ok) return null;
        const data = await res.json();
        const hintCode = data.hintCode;
        const collectStatus = data.status;
        const accessToken = data.accessToken;
        const refreshToken = data.refreshToken;
        const expiresIn = data.expiresIn;
        if (accessToken) {
            clearFetchQrHash();
            const profilePromise = (0, $6c726320d527757b$export$2324d9b69d65b3)(accessToken).then(async (data)=>{
                if (data) {
                    (0, $6c726320d527757b$export$9aa3ca101050be32)(accessToken, "LoggedIn", "");
                    const payload = {
                        profile: data,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        personNumber: data.personNumber,
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                        customerIdaAccountId: data.id,
                        expDate: Date.now() + parseInt(expiresIn) * 1000
                    };
                    const res = await auth.signInBankId(payload);
                    if (res?.error) {
                        console.log("Error:", JSON.stringify(res.error), JSON.stringify(res));
                        const p = (0, $e845536d9724b5be$export$709793eec59fe573)(res.error);
                        auth.addNotification(t([
                            `messages.${p}`,
                            "messages.general"
                        ]));
                    } else {
                        // const from = location.state?.from?.pathname || "/";
                        const from = "/todo";
                        navigate(from, {
                            replace: true
                        });
                    }
                }
            }).catch((e)=>console.log(e));
            Promise.allSettled([
                profilePromise
            ]).then(()=>{
                setStatus("complete");
            // navigate("/vault");
            });
            return;
        }
        switch(hintCode){
            case "userCancel":
                setStatus("canceled");
                clearFetchQrHash();
                break;
            case "userSign":
                setStatus("signing");
                if (qrInterval.current) clearInterval(qrInterval.current);
                setQrHash("");
                break;
            case "startFailed":
                setStatus("failure");
                clearFetchQrHash();
                break;
            case "outstandingTransaction":
            default:
                break;
        }
    };
    const clearFetchQrHash = ()=>{
        if (qrInterval.current) clearInterval(qrInterval.current);
        if (collectInterval.current) clearInterval(collectInterval.current);
        setQrHash("");
    };
    const renderCancelButton = ()=>{
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $efbe182bfb8b17d2$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setLoading(true);
                // clearFetchQrHash();
                // setStatus("init");
                window.location.href = backUrl;
            },
            title: "St\xe4ng",
            size: "small",
            cssClasses: "mt-4 mx-auto",
            rightArrow: false
        });
    };
    const renderStartButton = ()=>{
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $efbe182bfb8b17d2$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setLoading(true);
                startLogin();
            },
            title: "LOGGA IN MED MOBILT BANKID",
            cssClasses: "mx-auto mt-5 lg:mt-10",
            icon: {
                url: $b4c9d63dd2124d00$var$bankIdLogo,
                width: 30
            }
        });
    };
    const renderOpenAppButton = (autoStartToken)=>{
        if ((0, $e845536d9724b5be$export$471f70c09cf8ab8c)()) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
            className: "underline",
            href: `bankid:///?autostarttoken=${autoStartToken}&redirect=null`,
            children: "Anv\xe4nd BankID p\xe5 denna enhet"
        });
        else return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $efbe182bfb8b17d2$export$2e2bcd8739ae039), {
            onClick: ()=>{
                window.location.href = `https://app.bankid.com/?autostarttoken=${autoStartToken}&redirect=null`;
            },
            title: "\xd6ppna BankID-appen",
            cssClasses: "mx-auto mt-5 lg:mt-14",
            icon: {
                url: $b4c9d63dd2124d00$var$bankIdLogo,
                width: 30
            }
        });
    };
    const renderText = ()=>{
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "mx-auto mt-10 max-w-[400px] font-interlight text-[14px]",
            children: [
                "Genom att forts\xe4tta accepterar jag",
                " ",
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer",
                    className: "underline",
                    href: "https://fenixbegravning.se/pdf/Fenix-Allmanna-villkor.pdf",
                    children: "villkoren"
                }),
                " ",
                "f\xf6r Fenix Familys tj\xe4nst samt bekr\xe4ftar att jag har l\xe4st Familys",
                " ",
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer",
                    className: "underline",
                    href: "https://fenixbegravning.se/pdf/Fenix-Integritetspolicy.pdf",
                    children: "integritetspolicy"
                }),
                "."
            ]
        });
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "relative",
        children: [
            status === "pending" && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "mb-5 text-left lg:px-5",
                        children: (0, $e845536d9724b5be$export$471f70c09cf8ab8c)() && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("ul", {
                            className: "list-outside list-decimal pl-5",
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("li", {
                                    children: "\xd6ppna BankID-appen i mobilen."
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("li", {
                                    children: "Tryck p\xe5 QR-symbolen i BankID-appen."
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("li", {
                                    children: "Rikta kameran mot QR-koden i denna ruta."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "mx-auto h-auto w-full lg:max-w-[250px]",
                        children: [
                            (0, $e845536d9724b5be$export$471f70c09cf8ab8c)() && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1efa8b22e1d1dc86$export$2e2bcd8739ae039), {
                                value: qrHash
                            }),
                            false,
                            autoStartToken && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "mt-3",
                                children: renderOpenAppButton(autoStartToken)
                            })
                        ]
                    }),
                    (0, $e845536d9724b5be$export$471f70c09cf8ab8c)() && renderCancelButton(),
                    renderText()
                ]
            }),
            status === "signing" && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "mx-auto mb-5 max-w-[400px]",
                        children: "Skriv in din s\xe4kerhetskod i BankID- appen och v\xe4lj Identifiera eller Skriv under."
                    }),
                    renderCancelButton()
                ]
            }),
            status === "canceled" && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "mb-5",
                        children: [
                            "Identifieringen avbr\xf6ts. ",
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("br", {}),
                            " Prova igen!"
                        ]
                    }),
                    renderStartButton()
                ]
            }),
            status === "failure" && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "mx-auto mb-5 max-w-[400px]",
                        children: "Vi kunde inte hitta n\xe5got BankID eller s\xe5 misslyckades scanningen av QR-koden. Prova igen!"
                    }),
                    renderStartButton()
                ]
            })
        ]
    });
}






var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");
var $2693e1473ba30d4a$exports = {};
$2693e1473ba30d4a$exports = $parcel$resolve("9unJC");


let $dbafbcc8edec422b$var$icon = new URL($2693e1473ba30d4a$exports);
function $dbafbcc8edec422b$export$2e2bcd8739ae039({ name: name = "password", value: value, placeholder: placeholder, onChange: onChange }) {
    const [showPass, setShowPass] = (0, $gIfym.useState)(false);
    const togglePassword = ()=>{
        setShowPass(!showPass);
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                className: "border-2 border-dark-blue rounded-full py-1.5 px-4 w-full placeholder:text-sm",
                type: showPass ? "text" : "password",
                name: name,
                id: name,
                value: value,
                placeholder: placeholder,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                className: "absolute right-4 top-2",
                type: "button",
                onClick: togglePassword,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                    className: "opacity-100 hover:opacity-80 transition",
                    src: $dbafbcc8edec422b$var$icon.href,
                    width: "25",
                    height: "25",
                    alt: ""
                })
            })
        ]
    });
}




function $c308b75990c43c16$export$2e2bcd8739ae039() {
    const [email, setEmail] = (0, $gIfym.useState)("");
    const [password, setPassword] = (0, $gIfym.useState)("");
    const [submitting, setSubmitting] = (0, $gIfym.useState)(false);
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    const [searchParams, setSearchParams] = (0, $8a32432afacbfa13$export$f1a78c17382fe22a)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    (0, $gIfym.useEffect)(()=>{
        const prs = searchParams.get("prs");
        const as = searchParams.get("as");
        const em = searchParams.get("email");
        if (em) setEmail(em);
        if (prs) auth.addNotification(t("forgot-password-success"), "success");
        if (as) auth.addNotification(t("activate-success"), "success");
    }, []);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        if (!email || !password) {
            auth.addNotification(t("messages.required-fields-empty"));
            setSubmitting(false);
            return;
        }
        const res = await auth.signIn(email, password);
        if (res?.error) {
            console.log("Error:", JSON.stringify(res.error), JSON.stringify(res));
            const p = (0, $e845536d9724b5be$export$709793eec59fe573)(res.error);
            auth.addNotification(t([
                `messages.${p}`,
                "messages.general"
            ]));
        } else {
            // const from = location.state?.from?.pathname || "/";
            const from = "/todo";
            navigate(from, {
                replace: true
            });
        }
        setSubmitting(false);
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                        className: "block mb-2.5 font-interbold",
                        children: [
                            t("email"),
                            " ",
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                        className: "border-2 border-dark-blue rounded-full py-1.5 px-4 w-full placeholder:text-sm",
                        type: "email",
                        name: "email",
                        id: "email",
                        placeholder: t("email-placeholder"),
                        value: email,
                        onChange: (e)=>{
                            setEmail(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "flex justify-between items-center mb-2.5",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                                className: "font-interbold",
                                children: [
                                    t("password"),
                                    " ",
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a32432afacbfa13$export$a6c7ac8248d6e38a), {
                                to: "/forgot-password",
                                className: "text-sm",
                                children: t("forgot-password-title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dbafbcc8edec422b$export$2e2bcd8739ae039), {
                        name: "password",
                        value: password,
                        placeholder: t("password-placeholder"),
                        onChange: (e)=>{
                            setPassword(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                type: "submit",
                className: "block bg-dark-blue rounded-full text-white font-interbold py-3 px-10 mt-10 mx-auto uppercase disabled:cursor-not-allowed disabled:bg-gray-500",
                disabled: submitting,
                children: t("signin-button")
            })
        ]
    });
}




var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");
const $3ac7a23c8873628b$export$2ac23591c03bc180 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext();
function $3ac7a23c8873628b$export$d3bdeeabc5edeb91() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext($3ac7a23c8873628b$export$2ac23591c03bc180);
}
const $3ac7a23c8873628b$export$f9b90cd643f9c4c4 = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($3ac7a23c8873628b$export$2ac23591c03bc180.Provider, {
        value: value,
        children: children
    });
};



const $c6afc5506f6a36b6$var$apiUrl = "https://api.fenixbegravning.se/api/v1/public";
function $c6afc5506f6a36b6$export$2e2bcd8739ae039() {
    const [submitting, setSubmitting] = (0, $gIfym.useState)(false);
    const [password, setPassword] = (0, $gIfym.useState)("");
    const [passwordCheck, setPasswordCheck] = (0, $gIfym.useState)("");
    const [cid, setCid] = (0, $gIfym.useState)("");
    const [oid, setOid] = (0, $gIfym.useState)("");
    const [bcid, setBcid] = (0, $gIfym.useState)("");
    const [searchParams, setSearchParams] = (0, $8a32432afacbfa13$export$f1a78c17382fe22a)();
    const { t: t, i18n: i18n } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const navigate = (0, $bf4ac162b947611d$export$9770f232ac06a008)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const loc = (0, $3ac7a23c8873628b$export$d3bdeeabc5edeb91)();
    (0, $gIfym.useEffect)(()=>{
        const cid = searchParams.get("cid");
        const oid = searchParams.get("oid");
        const bcid = searchParams.get("bcid");
        setCid(cid);
        setOid(oid);
        setBcid(bcid);
        if (!cid || !oid || !bcid) {
            navigate("/");
            return;
        }
        const fetchData = async ()=>{
            const res = await fetch(`${$c6afc5506f6a36b6$var$apiUrl}/customer/check?memberId=${bcid}&tenantId=${loc.tenantId}`);
            return await res.json();
        };
        fetchData().then((json)=>{
            if (json.object === true) {
                navigate("/signin");
                return;
            }
        });
    }, [
        searchParams,
        navigate
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        if (!password || !passwordCheck) {
            auth.addNotification(t("messages.required-fields-empty"));
            setSubmitting(false);
            return;
        }
        if (password !== passwordCheck) {
            auth.addNotification(t("messages.passwords-match-error"));
            setSubmitting(false);
            return;
        }
        await idaSignUp();
    };
    async function idaSignUp() {
        try {
            const res = await fetch(`${$c6afc5506f6a36b6$var$apiUrl}/customer`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    cid: cid,
                    oid: oid,
                    bcid: bcid,
                    password: password,
                    tenantId: loc.tenantId
                })
            });
            const json = await res.json();
            if (json.success === false) {
                console.log(json.object);
                auth.addNotification(t("messages.passworddidnotconform"));
            }
            if (json.success === true) navigate("/activate");
        } catch (error) {
            console.log("Error:", error);
            auth.addNotification(error.message);
        }
        setSubmitting(false);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                        className: "block mb-2.5 font-interbold",
                        children: [
                            t("password-create"),
                            " ",
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dbafbcc8edec422b$export$2e2bcd8739ae039), {
                        name: "password",
                        placeholder: t("password-create-placeholder"),
                        value: password,
                        onChange: (e)=>{
                            setPassword(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("fieldset", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                        className: "block mb-2.5 font-interbold",
                        children: [
                            t("password-verify"),
                            " ",
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dbafbcc8edec422b$export$2e2bcd8739ae039), {
                        name: "password-check",
                        placeholder: t("password-verify-placeholder"),
                        value: passwordCheck,
                        onChange: (e)=>{
                            setPasswordCheck(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                type: "submit",
                className: "block bg-dark-blue rounded-full text-white font-interbold py-3 px-10 mt-10 mx-auto uppercase disabled:cursor-not-allowed disabled:bg-gray-500",
                disabled: submitting,
                children: t("signup-button")
            })
        ]
    });
}


var $430e926d41b55067$exports = {};
$430e926d41b55067$exports = $parcel$resolve("ki3b4");


const $116faaf87bce6ae7$var$bankIdLogo = new URL($430e926d41b55067$exports);
function $116faaf87bce6ae7$export$2e2bcd8739ae039({ title: title, backUrl: backUrl, loginMode: loginMode = "email-password" }) {
    const [display, setDisplay] = (0, $gIfym.useState)("default");
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    document.title = t("signin-title");
    (0, $gIfym.useEffect)(()=>{
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has("prs") || searchParams.has("as") || searchParams.has("email")) setDisplay("email-password");
    }, []);
    const renderBankIdButton = ()=>{
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $efbe182bfb8b17d2$export$2e2bcd8739ae039), {
            onClick: ()=>setDisplay("bankid"),
            title: "bankid",
            cssClasses: "",
            rightArrow: false,
            theme: "yellow",
            iconComp: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                className: "relative",
                alt: "",
                src: $116faaf87bce6ae7$var$bankIdLogo.href,
                width: 30
            }),
            icon: {
                width: -15
            }
        });
    };
    const renderSignInButton = ()=>{
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "text-white uppercase font-intermedium leading-tight tracking-widest lg:leading-none text-[12px] cursor-pointer",
            onClick: ()=>setDisplay(loginMode),
            children: "e-post och L\xf6senord"
        });
    };
    const renderContent = ()=>{
        switch(display){
            case "bankid":
                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b4c9d63dd2124d00$export$2e2bcd8739ae039), {
                    backUrl: backUrl
                });
            case "email-password":
                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c308b75990c43c16$export$2e2bcd8739ae039), {});
            case "password":
                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c6afc5506f6a36b6$export$2e2bcd8739ae039), {});
            default:
                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "mx-auto relative flex flex-col gap-5 items-center justify-center",
                    children: [
                        renderBankIdButton(),
                        renderSignInButton()
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $006b2c47c574b37c$export$2e2bcd8739ae039), {
        title: title,
        noBg: display === "default",
        children: renderContent()
    });
}


function $557d91122db3de78$export$2e2bcd8739ae039() {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const title = t("signin-title");
    document.title = title;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $116faaf87bce6ae7$export$2e2bcd8739ae039), {
        title: title
    });
}



parcelRequire("gIfym");


function $262ee0646164d9e8$export$2e2bcd8739ae039() {
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const title = t("signup-title");
    document.title = title;
    console.log("loc", location.pathname + location.search);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $116faaf87bce6ae7$export$2e2bcd8739ae039), {
        title: title,
        loginMode: "password",
        backUrl: location.pathname + location.search
    });
}




var $gIfym = parcelRequire("gIfym");




var $6VKBH = parcelRequire("6VKBH");

var $jBLdM = parcelRequire("jBLdM");

var $gIfym = parcelRequire("gIfym");









var $gIfym = parcelRequire("gIfym");


var $jBLdM = parcelRequire("jBLdM");

var $gIfym = parcelRequire("gIfym");



var $dtYFN = parcelRequire("dtYFN");
function $08bbac2f6708d378$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $dtYFN.default)(t, o);
}



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $dca0dd7d0fc909d9$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $5eb3f9a936237142$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dca0dd7d0fc909d9$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $883a28a3079d74fd$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $883a28a3079d74fd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $883a28a3079d74fd$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $883a28a3079d74fd$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");

var $7600586e28688e32$export$2e2bcd8739ae039 = {
    disabled: false
};




var $gIfym = parcelRequire("gIfym");
var $62aabe3b0546d049$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext(null);


var $0cf5d5f54f72096b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $19bb90b7fff15f94$export$bb38bb9a1161268 = 'unmounted';
var $19bb90b7fff15f94$export$84cbff306f539230 = 'exited';
var $19bb90b7fff15f94$export$df38205c966be359 = 'entering';
var $19bb90b7fff15f94$export$78e9e6e3e014d60a = 'entered';
var $19bb90b7fff15f94$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $19bb90b7fff15f94$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $08bbac2f6708d378$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $19bb90b7fff15f94$export$84cbff306f539230;
                _this.appearStatus = $19bb90b7fff15f94$export$df38205c966be359;
            } else initialStatus = $19bb90b7fff15f94$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $19bb90b7fff15f94$export$bb38bb9a1161268;
        else initialStatus = $19bb90b7fff15f94$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $19bb90b7fff15f94$export$bb38bb9a1161268) return {
            status: $19bb90b7fff15f94$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $19bb90b7fff15f94$export$df38205c966be359 && status !== $19bb90b7fff15f94$export$78e9e6e3e014d60a) nextStatus = $19bb90b7fff15f94$export$df38205c966be359;
            } else if (status === $19bb90b7fff15f94$export$df38205c966be359 || status === $19bb90b7fff15f94$export$78e9e6e3e014d60a) nextStatus = $19bb90b7fff15f94$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $19bb90b7fff15f94$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $0cf5d5f54f72096b$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $19bb90b7fff15f94$export$84cbff306f539230) this.setState({
            status: $19bb90b7fff15f94$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $7600586e28688e32$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $19bb90b7fff15f94$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $19bb90b7fff15f94$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $19bb90b7fff15f94$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $7600586e28688e32$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $19bb90b7fff15f94$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $19bb90b7fff15f94$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $19bb90b7fff15f94$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $19bb90b7fff15f94$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $6080bdebdcd55ee7$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $62aabe3b0546d049$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$19bb90b7fff15f94$var$Transition.contextType = (0, $62aabe3b0546d049$export$2e2bcd8739ae039);
$19bb90b7fff15f94$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $19bb90b7fff15f94$var$noop() {}
$19bb90b7fff15f94$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $19bb90b7fff15f94$var$noop,
    onEntering: $19bb90b7fff15f94$var$noop,
    onEntered: $19bb90b7fff15f94$var$noop,
    onExit: $19bb90b7fff15f94$var$noop,
    onExiting: $19bb90b7fff15f94$var$noop,
    onExited: $19bb90b7fff15f94$var$noop
};
$19bb90b7fff15f94$var$Transition.UNMOUNTED = $19bb90b7fff15f94$export$bb38bb9a1161268;
$19bb90b7fff15f94$var$Transition.EXITED = $19bb90b7fff15f94$export$84cbff306f539230;
$19bb90b7fff15f94$var$Transition.ENTERING = $19bb90b7fff15f94$export$df38205c966be359;
$19bb90b7fff15f94$var$Transition.ENTERED = $19bb90b7fff15f94$export$78e9e6e3e014d60a;
$19bb90b7fff15f94$var$Transition.EXITING = $19bb90b7fff15f94$export$4aacc83d4d59139f;
var $19bb90b7fff15f94$export$2e2bcd8739ae039 = $19bb90b7fff15f94$var$Transition;




var $8a71f0ffeeb4040b$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $5eb3f9a936237142$export$2e2bcd8739ae039)(node, c);
    });
};
var $8a71f0ffeeb4040b$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $883a28a3079d74fd$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $8a71f0ffeeb4040b$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $08bbac2f6708d378$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $0cf5d5f54f72096b$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $8a71f0ffeeb4040b$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $8a71f0ffeeb4040b$var$removeClass(node, baseClassName);
        if (activeClassName) $8a71f0ffeeb4040b$var$removeClass(node, activeClassName);
        if (doneClassName) $8a71f0ffeeb4040b$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $6080bdebdcd55ee7$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $19bb90b7fff15f94$export$2e2bcd8739ae039), (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$8a71f0ffeeb4040b$var$CSSTransition.defaultProps = {
    classNames: ''
};
$8a71f0ffeeb4040b$var$CSSTransition.propTypes = {};
var $8a71f0ffeeb4040b$export$2e2bcd8739ae039 = $8a71f0ffeeb4040b$var$CSSTransition;





var $jBLdM = parcelRequire("jBLdM");
parcelRequire("gIfym");

var $c76ee28d8b9ebe02$exports = {};
$c76ee28d8b9ebe02$exports = $parcel$resolve("dCEl3");


let $ddc16c0818f1471e$var$iconCircleDark = new URL($c76ee28d8b9ebe02$exports);
var $a59aef3c84f871ca$exports = {};
$a59aef3c84f871ca$exports = $parcel$resolve("dKZtz");


let $ddc16c0818f1471e$var$iconCircleWhite = new URL($a59aef3c84f871ca$exports);
var $a416640917bc77f7$exports = {};
$a416640917bc77f7$exports = $parcel$resolve("6dNgT");


let $ddc16c0818f1471e$var$iconCircleCheckedDark = new URL($a416640917bc77f7$exports);
var $1b43b0f3f43ff0e5$exports = {};
$1b43b0f3f43ff0e5$exports = $parcel$resolve("257jE");


let $ddc16c0818f1471e$var$iconCircleCheckedWhite = new URL($1b43b0f3f43ff0e5$exports);
var $54ddfa775c3bb504$exports = {};
$54ddfa775c3bb504$exports = $parcel$resolve("4CiMo");


let $ddc16c0818f1471e$var$iconCircleExclamation = new URL($54ddfa775c3bb504$exports);
const $ddc16c0818f1471e$var$now = (0, (/*@__PURE__*/$parcel$interopDefault($jBLdM)))();
function $ddc16c0818f1471e$export$2e2bcd8739ae039({ list: list, parentCompleted: parentCompleted, parentId: parentId, toggleCompleted: toggleCompleted }) {
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    function getCheckboxIcon(item) {
        const checked = item.completed;
        if (checked && !parentCompleted) return $ddc16c0818f1471e$var$iconCircleCheckedDark;
        else if (checked && parentCompleted) return $ddc16c0818f1471e$var$iconCircleCheckedWhite;
        else if (!parentCompleted && item.date && item.date.diff($ddc16c0818f1471e$var$now, "days") < 0) return $ddc16c0818f1471e$var$iconCircleExclamation;
        else if (!parentCompleted) return $ddc16c0818f1471e$var$iconCircleDark;
        else return $ddc16c0818f1471e$var$iconCircleWhite;
    }
    function isCompleted(item) {
        return !!item.completed;
    }
    let textColor = "text-dark-blue";
    if (parentCompleted) textColor = "text-white";
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "md:pl-9",
        children: list.map((item)=>{
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `relative mb-2`,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "flex flex-row justify-between items-center",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "flex flex-row flex-1",
                        onClick: ()=>toggleCompleted(parentId + "." + item.id, true),
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                className: "mr-3 w-[25px] h-[25px] hover:cursor-pointer",
                                src: getCheckboxIcon(item),
                                width: "25",
                                height: "25"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: `flex-grow hover:cursor-pointer ${isCompleted(item) ? "line-through" : ""}`,
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                    className: `${textColor}`,
                                    children: [
                                        item.title,
                                        item.date ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                            className: "text-[11px] pl-3 pt-1 text-gray-500 inline-block first-letter:uppercase",
                                            children: item.date.format("MMMM D, YYYY")
                                        }) : ""
                                    ]
                                })
                            })
                        ]
                    })
                })
            }, item.id);
        })
    });
}


var $191165038769615c$exports = {};
$191165038769615c$exports = $parcel$resolve("9f0xV");


let $01426a92acb1052f$var$arrowIconDark = new URL($191165038769615c$exports);
var $0f6d3e5b948a851a$exports = {};
$0f6d3e5b948a851a$exports = $parcel$resolve("8eVce");


let $01426a92acb1052f$var$arrowIcon = new URL($0f6d3e5b948a851a$exports);

let $01426a92acb1052f$var$iconUser = new URL($ad11f833b66de097$exports);
var $6ba92841ee8a7bbe$exports = {};
$6ba92841ee8a7bbe$exports = $parcel$resolve("7tEnp");


let $01426a92acb1052f$var$iconUserDark = new URL($6ba92841ee8a7bbe$exports);

let $01426a92acb1052f$var$iconCircle = new URL($c76ee28d8b9ebe02$exports);

let $01426a92acb1052f$var$iconCircleChecked = new URL($1b43b0f3f43ff0e5$exports);

let $01426a92acb1052f$var$iconCircleExclamation = new URL($54ddfa775c3bb504$exports);
const $01426a92acb1052f$var$now = (0, (/*@__PURE__*/$parcel$interopDefault($jBLdM)))();
function $01426a92acb1052f$export$2e2bcd8739ae039({ id: id, title: title, content: content, date: date, author: author, info: info, list: list, completed: completed, toggleCompleted: toggleCompleted }) {
    const [expand, setExpand] = (0, $gIfym.useState)(false);
    const [height, setHeight] = (0, $gIfym.useState)();
    const ref = (0, $gIfym.useRef)(null);
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    (0, $gIfym.useLayoutEffect)(()=>{
        setHeight(ref.current?.clientHeight);
    }, []);
    const defaultClasses = [
        "overflow-hidden",
        "transition-[max-height]"
    ];
    const transitionStyles = {
        entering: {
            maxHeight: `${height}px`
        },
        entered: {
            maxHeight: `${height}px`
        },
        exiting: {
            maxHeight: 0
        },
        exited: {
            maxHeight: 0
        }
    };
    function toggleExpand() {
        setExpand(!expand);
    }
    function getCheckboxIcon() {
        if (completed) return $01426a92acb1052f$var$iconCircleChecked;
        else if (date && date.diff($01426a92acb1052f$var$now, "days") < 0) return $01426a92acb1052f$var$iconCircleExclamation;
        else return $01426a92acb1052f$var$iconCircle;
    }
    function getAuthorIcon() {
        if (!author) return null;
        const icon = completed ? $01426a92acb1052f$var$iconUserDark : $01426a92acb1052f$var$iconUser;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: `mr-2 text-sm ${textColor}`,
                    children: "You"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                    className: `${iconBgColor} rounded-full p-1`,
                    src: icon,
                    width: "25",
                    height: "25"
                })
            ]
        });
    }
    function readMore() {
        if (!info) return null;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "flex items-center",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                href: "https://google.com/",
                target: "_blank",
                className: `mr-2 text-sm ${textColor} hover:underline`,
                rel: "noreferrer",
                children: "More info"
            })
        });
    }
    function getArrowIcon() {
        if (completed) return $01426a92acb1052f$var$arrowIcon;
        else return $01426a92acb1052f$var$arrowIconDark;
    }
    let bgColor = "bg-white";
    let iconBgColor = "bg-dark-blue";
    let textColor = "text-dark-blue";
    if (completed) {
        bgColor = "bg-dark-blue";
        iconBgColor = "bg-white";
        textColor = "text-white";
    }
    const hasNestedItems = list?.length > 0;
    const hasContent = content && content.length > 0;
    const shouldExpand = hasNestedItems || hasContent;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: `relative shadow-default ${bgColor} rounded-lg px-5 py-4 mb-5`,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "flex flex-row items-center flex-1",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                className: `mr-3 w-[25px] h-[25px] ${!hasNestedItems ? "hover:cursor-pointer" : ""}`,
                                onClick: ()=>!hasNestedItems ? toggleCompleted(id) : null,
                                src: getCheckboxIcon(),
                                width: "25",
                                height: "25"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: `flex-grow ${shouldExpand ? "hover:cursor-pointer" : ""}`,
                                onClick: ()=>toggleExpand(),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: `font-interbold ${textColor} leading-5 mb-1`,
                                        children: title
                                    }),
                                    date && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: `text-[10px] leading-none first-letter:uppercase ${textColor}`,
                                        children: date.format("MMMM D, YYYY")
                                    })
                                ]
                            }),
                            readMore(),
                            getAuthorIcon()
                        ]
                    }),
                    shouldExpand ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: `p-1 transition hover:cursor-pointer ${expand ? "rotate-0" : "rotate-180"}`,
                        onClick: ()=>toggleExpand(),
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                            src: getArrowIcon(),
                            width: "25",
                            height: "25"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a71f0ffeeb4040b$export$2e2bcd8739ae039), {
                in: expand,
                timeout: 150,
                nodeRef: ref,
                children: (state)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: defaultClasses.join(" "),
                        style: {
                            ...transitionStyles[state]
                        },
                        children: shouldExpand ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: `pt-5 pb-3 ${textColor}`,
                            ref: ref,
                            children: [
                                content && content,
                                hasNestedItems && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ddc16c0818f1471e$export$2e2bcd8739ae039), {
                                    parentCompleted: completed,
                                    parentId: id,
                                    list: list,
                                    toggleCompleted: toggleCompleted
                                })
                            ]
                        }) : null
                    })
            })
        ]
    });
}


var $1a72ba39a28c1a8b$exports = {};
$1a72ba39a28c1a8b$exports = $parcel$resolve("nAxKQ");


let $97a9d2d46fe3444f$var$doneIcon = new URL($1a72ba39a28c1a8b$exports);
const $97a9d2d46fe3444f$var$ToDoS = ({ title: title, isDone: isDone, items: items, toggleCompleted: toggleCompleted }, ref)=>{
    const itemsLength = items.length;
    let lineColor = "bg-light-pink";
    if (isDone) lineColor = "bg-dark-blue";
    const titleHtml = /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "relative text-xs uppercase text-dark-blue font-interbold mb-4 flex flex-row pl-[25] z-[2]",
        children: [
            isDone ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                src: $97a9d2d46fe3444f$var$doneIcon,
                width: 14,
                height: 14,
                className: "mr-4"
            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "h-[14] w-[14] bg-light-pink rounded-full mr-4"
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                children: title
            })
        ]
    });
    function sortItems(items) {
        return items.sort((a, b)=>{
            if (isDone) return a.apiOrder > b.apiOrder ? -1 : 1;
            else return a.apiOrder > b.apiOrder ? 1 : -1;
        });
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "relative pb-4 last:pb-0",
            children: [
                isDone && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "w-1 absolute bg-gradient-to-t from-light-pink to-dark-blue bottom-0 left-[30px] h-[30] z-[1]"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `w-1 h-full absolute ${lineColor} top-0 left-[30px]`
                }),
                !isDone && titleHtml,
                sortItems(items).map((item, index)=>{
                    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        children: [
                            isDone && itemsLength > 2 && index === itemsLength - 2 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                ref: ref
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $01426a92acb1052f$export$2e2bcd8739ae039), {
                                ...item,
                                toggleCompleted: toggleCompleted
                            }, item.id)
                        ]
                    }, item.id);
                }),
                isDone && titleHtml
            ]
        })
    });
};
const $97a9d2d46fe3444f$var$ToDoSection = /*#__PURE__*/ (0, $gIfym.forwardRef)($97a9d2d46fe3444f$var$ToDoS);
var $97a9d2d46fe3444f$export$2e2bcd8739ae039 = $97a9d2d46fe3444f$var$ToDoSection;


const $63f5ab00bb4ea66a$var$now = (0, (/*@__PURE__*/$parcel$interopDefault($jBLdM)))();
const $63f5ab00bb4ea66a$var$categories = {
    1: "F\xf6rberedelser personligt avsked",
    2: "F\xf6rberedelser ceremoni",
    3: "F\xf6rberedelser minnesstund",
    4: "Hantering av urna"
};
function $63f5ab00bb4ea66a$export$2e2bcd8739ae039({ wrapper: wrapper }) {
    const [rawData, setRawData] = (0, $gIfym.useState)();
    const [data, setData] = (0, $gIfym.useState)();
    const [showCanSubmitModal, setShowCanSubmitModal] = (0, $gIfym.useState)(false);
    const [initScroll, setInitScroll] = (0, $gIfym.useState)(0);
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    const wsConnection = (0, $6c05a81472ccb93d$export$bd1537e1f64b53aa)();
    const doneRef = (0, $gIfym.useRef)();
    const controllerRef = (0, $gIfym.useRef)();
    (0, $gIfym.useEffect)(()=>{
        if (user) fetchToDos(user);
    }, [
        user
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (!user || !wsConnection || !wsConnection.connectionId) return null;
        const handler = ()=>setTimeout(()=>{
                fetchToDos(user);
            }, 1000);
        wsConnection.on("Customer_Todo", handler);
        return ()=>{
            wsConnection.off("Customer_Todo", handler);
        };
    }, [
        user,
        wsConnection?.connectionId
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (rawData) processItems();
    }, [
        rawData
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (doneRef.current === undefined || initScroll === 1) return null;
        wrapper.current?.scrollTo({
            top: doneRef.current?.offsetTop + 25,
            left: 0,
            behavior: "smooth"
        });
        setInitScroll(1);
    }, [
        data
    ]);
    function getItemCompletionStatus(todoStatus) {
        if (todoStatus === 2) return 1;
        return 0;
    }
    function processItems() {
        const items = rawData;
        let dataItems = [];
        for (const [key, value] of Object.entries($63f5ab00bb4ea66a$var$categories))dataItems.push({
            id: parseInt(key),
            title: value,
            completed: 0,
            list: [],
            info: 0,
            author: 0
        });
        items.map((item)=>{
            const dt = item.deadline ? (0, (/*@__PURE__*/$parcel$interopDefault($jBLdM)))(item.deadline) : null;
            const obj = {
                id: item.id,
                title: item.hintText,
                completed: getItemCompletionStatus(item.todoStatus),
                order: item.rankUnderCategory,
                info: 0,
                author: 0,
                content: "",
                status: item.todoStatus,
                apiOrder: parseInt(item.rankOfCategory)
            };
            if (dt !== null) obj.date = dt;
            if ($63f5ab00bb4ea66a$var$categories[item.toDoCategory]) {
                const index = dataItems.findIndex((el)=>el.id === item.toDoCategory);
                dataItems[index].list.push(obj);
                dataItems[index].apiOrder = parseInt(item.rankOfCategory);
            } else dataItems.push(obj);
        });
        let dataItemsNew = dataItems.reduce((acc, item)=>{
            if (item.list && item.list.length === 0) return acc;
            if (item.list && item.list.length > 0) {
                item.date = item.list.reduce((a, i)=>{
                    if (a === null && i.date) return i.date;
                    return a && a.isAfter(i.date) ? i.date : a;
                }, null);
                item.list = item.list.sort((a, b)=>{
                    return a.order > b.order ? 1 : -1;
                });
                item.completed = calculateCategoryStatus(item);
            }
            acc.push(item);
            return acc;
        }, []);
        let dataItemsSorted = dataItemsNew.sort((a, b)=>{
            return a.apiOrder > b.apiOrder ? 1 : -1;
        });
        setData(dataItemsSorted);
    }
    function calculateCategoryStatus(item) {
        let listItemsCompleted = [];
        item.list.map((i)=>{
            if (i.completed === 1) listItemsCompleted.push(i.id);
        });
        return item.list.length === listItemsCompleted.length ? 1 : 0;
    }
    function fetchToDos(user) {
        if (!user) return null;
        const orderId = user.customerIdaOrderId;
        if (orderId === undefined) return null;
        if (controllerRef.current) controllerRef.current.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        (0, $6c726320d527757b$export$42a6662fdfcb23c5)(user, orderId, controllerRef).then((data)=>{
            if (data.success) return data.object;
            auth.addNotification(data.message);
        }).then((data)=>{
            if (!data) return false;
            if (data.length > 0) setRawData(data);
            else setRawData([]);
        }).catch((error)=>{
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
        controllerRef.current = null;
        return ()=>controller.abort();
    }
    function updateItem(user, todoId, todoStatus) {
        if (!todoId || !user) return null;
        if (controllerRef.current) controllerRef.current.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        (0, $6c726320d527757b$export$1e81486c55d394d7)(user, todoId, todoStatus, controllerRef).then((data)=>{
            if (!data.success) fetchToDos(user);
        }).catch((error)=>{
            $6VKBH.captureException(error);
            auth.addNotification(error.message);
        });
        controllerRef.current = null;
        return ()=>controller.abort();
    }
    function toggleCompleted(id, nested = false) {
        if (auth.canSubmit() === false) {
            setShowCanSubmitModal(true);
            // auth.addNotification(t("no-submit.default"));
            return false;
        }
        const newItems = [
            ...data
        ];
        let itemStatus;
        let itemId;
        const newItemStatus = (itemStatus)=>itemStatus === 2 ? 1 : 2;
        if (nested) {
            const [mId, nId] = id.split(".");
            itemId = nId;
            const index = newItems.findIndex((el)=>el.id == mId);
            const nestedIndex = newItems[index].list.findIndex((el)=>el.id == itemId);
            newItems[index].list[nestedIndex].completed = !newItems[index].list[nestedIndex].completed;
            itemStatus = newItems[index].list[nestedIndex].status;
            newItems[index].list[nestedIndex].status = newItemStatus(itemStatus);
            newItems[index].list[nestedIndex].completed = getItemCompletionStatus(newItems[index].list[nestedIndex].status);
            newItems[index].completed = calculateCategoryStatus(newItems[index]);
        } else {
            itemId = id;
            const index = newItems.findIndex((el)=>el.id === id);
            itemStatus = newItems[index].status;
            newItems[index].status = newItemStatus(itemStatus);
            newItems[index].completed = getItemCompletionStatus(newItems[index].status);
        }
        updateItem(user, itemId, newItemStatus(itemStatus));
        setData(newItems);
    }
    function splitItems() {
        let itemsCompleted = [];
        let itemsThisWeek = [];
        let itemsNextWeek = [];
        let itemsLater = [];
        if (data === undefined) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "flex flex-col items-center h-full justify-center",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5e5f6efd194dbddf$export$2e2bcd8739ae039), {
                theme: "dark",
                size: "small"
            })
        });
        if (data.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
            children: t("no-items")
        });
        data.map((item)=>{
            if (item.completed) {
                itemsCompleted.push(item);
                return;
            }
            const dt = (0, (/*@__PURE__*/$parcel$interopDefault($jBLdM)))(item.date, "YYYY-MM-DD");
            const diff = dt.diff($63f5ab00bb4ea66a$var$now, "days");
            if (diff <= 7) itemsThisWeek.push(item);
            else if (diff > 7 && diff <= 14) itemsNextWeek.push(item);
            else itemsLater.push(item);
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                itemsCompleted.length > 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $97a9d2d46fe3444f$export$2e2bcd8739ae039), {
                    title: t("todo-done"),
                    isDone: true,
                    items: itemsCompleted,
                    toggleCompleted: toggleCompleted,
                    ref: doneRef
                }) : "",
                itemsThisWeek.length > 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $97a9d2d46fe3444f$export$2e2bcd8739ae039), {
                    title: t("todo-this-week"),
                    items: itemsThisWeek,
                    toggleCompleted: toggleCompleted
                }) : "",
                itemsNextWeek.length > 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $97a9d2d46fe3444f$export$2e2bcd8739ae039), {
                    title: t("todo-next-week"),
                    items: itemsNextWeek,
                    toggleCompleted: toggleCompleted
                }) : "",
                itemsLater.length > 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $97a9d2d46fe3444f$export$2e2bcd8739ae039), {
                    title: t("todo-later"),
                    items: itemsLater,
                    toggleCompleted: toggleCompleted
                }) : ""
            ]
        });
    }
    function createMarkup() {
        return {
            __html: t("no-submit.todo")
        };
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            showCanSubmitModal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b136a8022cdd8440$export$2e2bcd8739ae039), {
                onClose: ()=>setShowCanSubmitModal(false),
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `max-w-xl xl:min-w-[320px] ${!(0, $e845536d9724b5be$export$471f70c09cf8ab8c)() ? "text-white" : ""}`,
                    dangerouslySetInnerHTML: createMarkup()
                })
            }),
            splitItems()
        ]
    });
}





function $888f4bc10b0e2275$export$2e2bcd8739ae039() {
    const [title, setTitle] = (0, $gIfym.useState)("");
    const [headerHeight, setHeaderHeight] = (0, $gIfym.useState)();
    const [wrapperStyle, setWrapperStyle] = (0, $gIfym.useState)();
    const auth = (0, $bac5870904eda56a$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $eb3cabd3632e6a19$export$9fc83ad70ead8663)();
    const headerRef = (0, $gIfym.useRef)(null);
    const wrapperRef = (0, $gIfym.useRef)(null);
    (0, $gIfym.useEffect)(()=>{
        let pageTitle = t("todo-title-no-name");
        if (auth.user.memorial && auth.user.memorial?.firstName !== "") pageTitle = t("todo-title", {
            name: auth.user.memorial.firstName
        });
        document.title = pageTitle;
        setTitle(pageTitle);
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if (document.readyState === "complete") {
            const headerInterval = setInterval(()=>{
                setHeaderHeight(headerRef.current?.clientHeight);
            }, 50);
            return ()=>clearInterval(headerInterval);
        }
    }, [
        document.readyState
    ]);
    (0, $gIfym.useEffect)(()=>{
        setWrapperStyle(st());
    }, [
        headerHeight
    ]);
    const st = ()=>{
        if (headerHeight === undefined || !(0, $e845536d9724b5be$export$471f70c09cf8ab8c)()) return null;
        return {
            minHeight: `calc(100vh - ${headerHeight}px)`,
            maxHeight: `calc(100vh - ${headerHeight}px)`
        };
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9695464cd69251e9$export$8ef2ed426dede42d), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "flex lg:block flex-col min-h-screen lg:min-h-fit min-w-full max-w-fit",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    ref: headerRef,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                        title: title,
                        desc: t("todo-description"),
                        showMemorial: true
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "p-5 pb-[50px] lg:pt-8 lg:pb-10 sm:p-10 overflow-y-auto max-h-screen grow",
                    style: wrapperStyle,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $63f5ab00bb4ea66a$export$2e2bcd8739ae039), {
                        wrapper: wrapperRef
                    })
                })
            ]
        })
    });
}


function $718440119370ca5a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $953340840ac7d8bf$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bac5870904eda56a$export$87091915187a1a85), {
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6c05a81472ccb93d$export$676472937f48f64), {
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $gIfym.Suspense), {
                    fallback: "loading",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $bf4ac162b947611d$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $30d74a2de4fcf97f$export$2e2bcd8739ae039), {}),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/signin",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $557d91122db3de78$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/signup",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $262ee0646164d9e8$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/activate",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $fd62fb187c366684$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/forgot-password",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a4a0c03b4bf9f364$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/forgot-password-confirm",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $161658f7e776d6dc$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1808761d820fe09a$export$2e2bcd8739ae039), {}),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/debug",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5efddf245952e228$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/images",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $7224d96f6f75fda6$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/files",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $02bcd05d145f160c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $56de3670e061aa8d$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1808761d820fe09a$export$2e2bcd8739ae039), {
                                    rightCol: true
                                }),
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                    path: "/todo",
                                    element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $888f4bc10b0e2275$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bf4ac162b947611d$export$e7b0ac011bb776c6), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $076ff821e12bc79d$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            })
        })
    });
}




var $i5SyM = parcelRequire("i5SyM");

var $vdtyq = parcelRequire("vdtyq");

var $lU1Um = parcelRequire("lU1Um");
var $c222087f6073185d$var$arr = [];
var $c222087f6073185d$var$each = $c222087f6073185d$var$arr.forEach;
var $c222087f6073185d$var$slice = $c222087f6073185d$var$arr.slice;
function $c222087f6073185d$var$defaults(obj) {
    $c222087f6073185d$var$each.call($c222087f6073185d$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $c222087f6073185d$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $c222087f6073185d$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$c222087f6073185d$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$c222087f6073185d$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $c222087f6073185d$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $c222087f6073185d$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $c222087f6073185d$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $c222087f6073185d$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $c222087f6073185d$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $c222087f6073185d$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $c222087f6073185d$var$hasLocalStorageSupport = null;
var $c222087f6073185d$var$localStorageAvailable = function localStorageAvailable() {
    if ($c222087f6073185d$var$hasLocalStorageSupport !== null) return $c222087f6073185d$var$hasLocalStorageSupport;
    try {
        $c222087f6073185d$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $c222087f6073185d$var$hasLocalStorageSupport = false;
    }
    return $c222087f6073185d$var$hasLocalStorageSupport;
};
var $c222087f6073185d$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $c222087f6073185d$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $c222087f6073185d$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $c222087f6073185d$var$hasSessionStorageSupport = null;
var $c222087f6073185d$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($c222087f6073185d$var$hasSessionStorageSupport !== null) return $c222087f6073185d$var$hasSessionStorageSupport;
    try {
        $c222087f6073185d$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $c222087f6073185d$var$hasSessionStorageSupport = false;
    }
    return $c222087f6073185d$var$hasSessionStorageSupport;
};
var $c222087f6073185d$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $c222087f6073185d$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $c222087f6073185d$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $c222087f6073185d$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $c222087f6073185d$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $c222087f6073185d$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $c222087f6073185d$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $c222087f6073185d$var$getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ] // cookieMinutes: 10,
    };
}
var $c222087f6073185d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $vdtyq.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    (0, $lU1Um.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $c222087f6073185d$var$defaults(options, this.options || {}, $c222087f6073185d$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($c222087f6073185d$var$cookie$1);
                this.addDetector($c222087f6073185d$var$querystring);
                this.addDetector($c222087f6073185d$var$localStorage);
                this.addDetector($c222087f6073185d$var$sessionStorage);
                this.addDetector($c222087f6073185d$var$navigator$1);
                this.addDetector($c222087f6073185d$var$htmlTag);
                this.addDetector($c222087f6073185d$var$path);
                this.addDetector($c222087f6073185d$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$c222087f6073185d$export$2e2bcd8739ae039.type = 'languageDetector';



var $af135e48d0ccea4c$exports = {};
$af135e48d0ccea4c$exports = JSON.parse('{"description":{"ida":"Data From Ida"},"messages":{"general":"Something went wrong.","required-fields-empty":"Required fields cannot be empty!","passwordcannotbeempty":"Required fields cannot be empty!","passwords-match-error":"The passwords do not match. Try again.","code-error":"Enter the code you received via email.","incorrectusernameorpassword":"Invalid username or password.","userdoesnotexist":"Invalid username or password.","passworddidnotconform":"Invalid password. The password must consist of at least 8 characters, of which at least one is a number and one special character. Use both upper and lower case letters.","1validationerrordetectedvalueatpasswordfailedtosatisfyconstraintmembermustsatisfyregularexpressionpattern^[\\\\s]+*[\\\\s]+$":"Invalid password. The password must consist of at least 8 characters, of which at least one is a number and one special character. Use both upper and lower case letters.","passworddoesnotconformtopolicypasswordnotlongenough":"Invalid password. The password must consist of at least 8 characters, of which at least one is a number and one special character. Use both upper and lower case letters.","passworddoesnotconformtopolicypasswordmusthaveuppercasecharacters":"Invalid password. The password must consist of at least 8 characters, of which at least one is a number and one special character. Use both upper and lower case letters.","LimitExceededException":"The attempt limit has been exceeded, try again after some time.","UserNotFoundException":"Invalid email address. It must be the same email address you entered for your account with us.","NotAuthorizedException":"Invalid email address. It must be the same email address you entered for your account with us.","duharintetillg\xe5ngtilln\xe5gonbest\xe4llning":"You do not have access to any orders."},"homepage-title":"Home","homepage-no-auth":"Sign In to view the content.","signin-title":"Sign In","signin-button":"Sign In","signup-title":"Create User","signup-button":"Create User","reset-password-title":"Reset Password","reset-password-button":"Reset Password","reset-password-text":"Fill in your email address and we will help you.","reset-password-title-success":"Reset Password","reset-password-confirm-title":"Confirm Changing Password","reset-password-confirm-code":"Code","reset-password-confirm-code-placeholder":"Enter the code from email","reset-password-confirm-button":"Confirm","activate-title":"Activate Account","activate-success":"Your account was successfully activated. You can sign in now!","activate-desc":"Check your email for the activation link.","email":"Email","email-placeholder":"Enter your email","shared-email-placeholder":"Enter email","name":"Name","first-name":"First name","first-name-placeholder":"Enter first name","last-name":"Last name","last-name-placeholder":"Enter last name","password":"Password","password-placeholder":"Enter password","password-create":"Create password","password-create-placeholder":"Enter password","password-verify":"Verify Password","password-verify-placeholder":"Enter password","submit":"Submit","no-items":"No items to display","sign-out":"Sign Out","book-a-meeting":"Book a meeting","forgot-password-title":"Forgot password?","forgot-password-desc":"Check your email for the password reset link.","forgot-password-success":"New password successfully set. You can sign in now!","profile-title":"Profile","todo-menu-title":"To Do","todo-title":"To Do","todo-title-no-name":"To Do","todo-description":"Some explanatory text describing the purpose and functionality of the To Do page.","todo-done":"Done","todo-this-week":"To do this week","todo-next-week":"To do next week","todo-later":"To do later","enter-text":"Enter text","bookmeeting-title":"Your team at fenix","bookmeeting-title-prefix":"Book a meeting with {{name}}","communication-title":"Communication","messenger-no-messages":"YOU HAVE NO COMMUNICATION YET","files-menu-title":"Files","files-title":"Files","files-description":"Some explanatory text describing the purpose and functionality of the Files page.","images-menu-title":"Images","images-title":"Images","images-description":"Some explanatory text describing the purpose and functionality of the Images page.","funeral-director":"Funeral Director","send":"Send","visit-memorial-site":"Visit site","shared-with-title":"Shared With","shared-success-title":"Shared With","shared-success-text":"Request successfully sent","invite":"Invite","send-invite":"Send Invite","show-more":"Show more","show-less":"Show less","and":"and","you":"you","more":"more","cost":"Cost","no-submit":{"default":"You can not submit or update information.","messenger":"You can not submit or update information.","bookmeeting":"You can not submit or update information.","todo":"You can not submit or update information."},"no-order-access":"You do not have access to any order."}');


var $34e622426bf2bdcc$exports = {};
$34e622426bf2bdcc$exports = JSON.parse('{"description":{"ida":"Data From Ida"},"messages":{"general":"N\xe5got gick fel.","required-fields-empty":"Du m\xe5ste fylla i det h\xe4r f\xe4ltet.","passwordcannotbeempty":"Du m\xe5ste fylla i det h\xe4r f\xe4ltet.","passwords-match-error":"L\xf6senorden matchar inte. F\xf6rs\xf6k igen.","code-error":"Ange koden som du f\xe5tt via mail.","incorrectusernameorpassword":"Ogiltigt anv\xe4ndarnamn eller l\xf6senord.","userdoesnotexist":"Ogiltigt anv\xe4ndarnamn eller l\xf6senord.","passworddidnotconform":"Ogiltigt l\xf6senord. L\xf6senordet m\xe5ste best\xe5 av minst 8 tecken, varav minst en siffra och ett specialtecken. Anv\xe4nd b\xe5de stora och sm\xe5 bokst\xe4ver.","1validationerrordetectedvalueatpasswordfailedtosatisfyconstraintmembermustsatisfyregularexpressionpattern^[\\\\s]+*[\\\\s]+$":"Ogiltigt l\xf6senord. L\xf6senordet m\xe5ste best\xe5 av minst 8 tecken, varav minst en siffra och ett specialtecken. Anv\xe4nd b\xe5de stora och sm\xe5 bokst\xe4ver.","passworddoesnotconformtopolicypasswordnotlongenough":"Ogiltigt l\xf6senord. L\xf6senordet m\xe5ste best\xe5 av minst 8 tecken, varav minst en siffra och ett specialtecken. Anv\xe4nd b\xe5de stora och sm\xe5 bokst\xe4ver.","passworddoesnotconformtopolicypasswordmusthaveuppercasecharacters":"Ogiltigt l\xf6senord. L\xf6senordet m\xe5ste best\xe5 av minst 8 tecken, varav minst en siffra och ett specialtecken. Anv\xe4nd b\xe5de stora och sm\xe5 bokst\xe4ver.","LimitExceededException":"F\xf6rs\xf6ksgr\xe4nsen har \xf6verskridits, f\xf6rs\xf6k efter en tid.","UserNotFoundException":"Ogiltigt e-postadress. Det m\xe5ste vara samma e-postadress som du angivit f\xf6r ditt konto hos oss.","NotAuthorizedException":"Ogiltigt e-postadress. Det m\xe5ste vara samma e-postadress som du angivit f\xf6r ditt konto hos oss.","duharintetillg\xe5ngtilln\xe5gonbest\xe4llning":"Du har inte tillg\xe5ng till n\xe5gon best\xe4llning."},"homepage-title":"Home","homepage-no-auth":"Sign In to view the content.","signin-title":"Logga in","signin-bankid-title":"Logga in med BankId","signin-button":"Logga in","signup-title":"Skapa anv\xe4ndare","signup-button":"Skapa anv\xe4ndare","reset-password-title":"Gl\xf6mt ditt l\xf6senord?","reset-password-button":"\xc5terst\xe4ll l\xf6senord","reset-password-text":"Fyll i din e-postadress s\xe5 hj\xe4lper vi dig.","reset-password-title-success":"\xc5terst\xe4ll l\xf6senord","reset-password-confirm-title":"Bekr\xe4fta \xe4ndring av l\xf6senord","reset-password-confirm-code":"S\xe4kerhetskod","reset-password-confirm-code-placeholder":"Ange koden som du f\xe5tt via mail","reset-password-confirm-button":"Bekr\xe4fta","activate-title":"Aktivera konto","activate-success":"Ditt l\xf6senord \xe4r nu \xe4ndrat. V\xe4lkommen att logga in igen.","activate-desc":"Du har nu f\xe5tt ett mejl av oss. F\xf6lj instruktionerna i mejlet f\xf6r att aktivera ditt personliga Fenix-konto.","email":"E-post","email-placeholder":"Fyll i din e-postadress h\xe4r","shared-email-placeholder":"Fyll i e-postadress h\xe4r","name":"Namn","first-name":"F\xf6rnamn","first-name-placeholder":"Skriv in f\xf6rnamn h\xe4r","last-name":"Efternamn","last-name-placeholder":"Skriv in efternamn h\xe4r","password":"L\xf6senord","password-placeholder":"Ange ditt l\xf6senord h\xe4r","password-create":"V\xe4lj ett l\xf6senord","password-create-placeholder":"Ange ditt l\xf6senord h\xe4r","password-verify":"Upprepa l\xf6senordet f\xf6r att bekr\xe4fta","password-verify-placeholder":"Ange ditt l\xf6senord h\xe4r","submit":"Submit","no-items":"Inga objekt att visa","sign-out":"Logga ut","book-a-meeting":"Boka m\xf6te","forgot-password-title":"Har du gl\xf6mt ditt l\xf6senord?","forgot-password-desc":"Kolla din mail. Du har f\xe5tt en l\xe4nk f\xf6r \xe5terst\xe4llning av l\xf6senord. ","forgot-password-success":"Ditt l\xf6senord \xe4r nu \xe4ndrat. V\xe4lkommen att logga in igen.","profile-title":"Profile","todo-menu-title":"Att g\xf6ra-lista","todo-title":"{{name}}s begravning. Steg f\xf6r steg.","todo-title-no-name":"Begravning. Steg f\xf6r steg.","todo-description":"Det \xe4r viktigt f\xf6r oss att du k\xe4nner dig trygg under hela processen. H\xe4r f\xe5r du en \xf6verblick \xf6ver planeringen \u2013 vad som \xe4r klart och vad som \xe4r kvar att g\xf6ra. Sj\xe4lvklart finns vi alltid n\xe4ra till hands om du har fr\xe5gor eller funderingar.","todo-done":"Klart","todo-this-week":"Att g\xf6ra den h\xe4r veckan","todo-next-week":"Att g\xf6ra n\xe4sta vecka","todo-later":"Att g\xf6ra senare ","enter-text":"Skriv h\xe4r","bookmeeting-title":"Din begravningsr\xe5dgivare p\xe5 Fenix","bookmeeting-title-prefix":"Boka m\xf6te med {{name}}","communication-title":"Konversation","messenger-no-messages":"Du har ingen kommunikation \xe4n","files-menu-title":"Dokument","files-title":"Alla viktiga papper p\xe5 ett st\xe4lle.","files-description":"F\xf6r att g\xf6ra det s\xe5 enkelt f\xf6r dig som m\xf6jligt, samlar vi alla dokument i samband med begravningen h\xe4r. Vi vet av erfarenhet att det kan vara sk\xf6nt att ha allt p\xe5 ett och samma st\xe4lle.","images-menu-title":"Foton","images-title":"Foton fr\xe5n ceremonin.","images-description":"H\xe4r hittar du alla bilder fr\xe5n fotografering av kondoleanser, blommor och minnesg\xe5vor i samband med begravningen. Foton \xe4r ett fint s\xe4tt att minnas och g\xf6r det ocks\xe5 l\xe4ttare f\xf6r dig att komma ih\xe5g om du vill skicka ett tackkort efter\xe5t.","funeral-director":"Begravningsr\xe5dgivare","send":"skicka","visit-memorial-site":"Bes\xf6k minnessida","shared-with-title":"Delad med","shared-success-title":"Din inbjudan \xe4r skickad","shared-success-text":"Som inbjuden anv\xe4ndare f\xe5r man ta del av att-g\xf6ra-listan och konversationen. Man f\xe5r \xe4ven tillg\xe5ng till alla dokument och bilder. D\xe4remot kan man inte sj\xe4lv fylla i n\xe5got eller g\xf6ra n\xe5gra \xe4ndringar.","invite":"Inbjudan","send-invite":"Skicka inbjudan","show-more":"Visa mer","show-less":"Visa mindre","and":"och","you":"dig","more":"till","cost":"Kostnad","no-submit":{"default":"Du kan inte skicka eller uppdatera information.","messenger":"Som inbjuden anv\xe4ndare kan du se allt som i konversationen, men du kan inte skriva n\xe5got sj\xe4lv.","bookmeeting":"Som inbjuden anv\xe4ndare kan du inte boka m\xf6ten.","todo":"Som inbjuden anv\xe4ndare kan du se allt som st\xe5r i att-g\xf6ra-listan, men du kan inte g\xf6ra n\xe5gra \xe4ndringar. <br /><br /> Har du fr\xe5gor eller funderingar \xe4r du alltid v\xe4lkommen att kontakta oss p\xe5 <a style=\'text-decoration:underline;\' href=\'mailto:kund@fenixfamily.se\'>kund@fenixfamily.se</a>. Du n\xe5r oss \xe4ven p\xe5 <a style=\'text-decoration:underline;\' href=\'tel:0101389446\'>010-138 94 46</a>."},"no-order-access":"Du har inte tillg\xe5ng till n\xe5gon best\xe4llning."}');



const $0a09926aebb273ef$var$defaultLang = "se";
const $0a09926aebb273ef$var$defaultTenant = "se";
const $0a09926aebb273ef$var$domainsSE = [
    "experience.fenixbegravning.se",
    "localhost"
];
const $0a09926aebb273ef$var$domainsUK = [
    ""
];
var $0a09926aebb273ef$export$2e2bcd8739ae039 = {
    name: "langDetector",
    lookup (options) {
        const domain = location.hostname;
        if ($0a09926aebb273ef$var$domainsSE.includes(domain)) {
            (0, $715c3e47e001e6ad$export$7ca27827b1548a66)("se");
            return "se";
        }
        if ($0a09926aebb273ef$var$domainsUK.includes(domain)) {
            (0, $715c3e47e001e6ad$export$7ca27827b1548a66)("en");
            return "en";
        }
        (0, $715c3e47e001e6ad$export$7ca27827b1548a66)($0a09926aebb273ef$var$defaultTenant);
        return $0a09926aebb273ef$var$defaultLang;
    }
};


const $c7d3364c52dd7a07$var$resources = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($af135e48d0ccea4c$exports)))
    },
    se: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($34e622426bf2bdcc$exports)))
    }
};
const $c7d3364c52dd7a07$var$languageDetector = new (0, $c222087f6073185d$export$2e2bcd8739ae039)();
$c7d3364c52dd7a07$var$languageDetector.addDetector((0, $0a09926aebb273ef$export$2e2bcd8739ae039));
(0, $i5SyM.default).use($c7d3364c52dd7a07$var$languageDetector).use((0, $388c5f3b9701ffb1$export$ae7e14d40d89f296)).init({
    resources: $c7d3364c52dd7a07$var$resources,
    detection: {
        order: [
            "langDetector"
        ],
        lookupCookie: "fnxLng",
        lookupLocalStorage: "fnxLng",
        lookupSessionStorage: "fnxLng",
        fallbackLng: "se"
    },
    debug: false,
    interpolation: {
        escapeValue: false
    }
});
var $c7d3364c52dd7a07$export$2e2bcd8739ae039 = (0, $i5SyM.default);



$496a7ca8d72a7cc9$export$2cd8252107eb640b({
    dsn: "https://229b303c9b5141238d363d34f5cc1106@o367701.ingest.sentry.io/4504446291869696",
    integrations: [
        new (0, $19b6934764737915$export$46d3bbd0375f5fa4)()
    ],
    tracesSampleRate: 1.0,
    environment: "production",
    release: "fenix-webapp@1.2.0"
});
console.log("https://229b303c9b5141238d363d34f5cc1106@o367701.ingest.sentry.io/4504446291869696");
(0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).render(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $gIfym.StrictMode), {
    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8a32432afacbfa13$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3ac7a23c8873628b$export$f9b90cd643f9c4c4), {
            value: {
                lang: (0, $c7d3364c52dd7a07$export$2e2bcd8739ae039).language,
                tenant: (0, $715c3e47e001e6ad$export$e24d85f794d5f8dd)(),
                tenantId: (0, $715c3e47e001e6ad$export$e24d85f794d5f8dd)() === "se" ? 1 : 2
            },
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $718440119370ca5a$export$2e2bcd8739ae039), {})
        })
    })
}), document.getElementById("root"));


//# sourceMappingURL=fenix-customer-app.c51a6447.js.map
